// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[0].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[4]!../node_modules/react-perfect-scrollbar/dist/css/styles.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[0].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[4]!../node_modules/nvd3/build/nv.d3.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23dee2e6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%2386b7fe%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23198754%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2833, 37, 41, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23212529%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27M2 5L8 11L14 5%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23052c65%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27M2 5L8 11L14 5%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%236ea8fe%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("./assets/scss/partials/font/fonts/pct.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("./assets/scss/partials/font/fonts/pct.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("./assets/scss/partials/font/fonts/pct.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("./assets/scss/partials/font/fonts/pct.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("./assets/scss/partials/font/fonts/feather.eot?t=1501841394106", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("./assets/scss/partials/font/fonts/feather.woff?t=1501841394106", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("./assets/scss/partials/font/fonts/feather.ttf?t=1501841394106", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("./assets/scss/partials/font/fonts/feather.svg?t=1501841394106", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("./assets/scss/partials/font/fonts/fa-brands-400.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("./assets/scss/partials/font/fonts/fa-brands-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("./assets/scss/partials/font/fonts/fa-brands-400.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("./assets/scss/partials/font/fonts/fa-brands-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("./assets/scss/partials/font/fonts/fa-brands-400.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("./assets/scss/partials/font/fonts/fa-regular-400.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("./assets/scss/partials/font/fonts/fa-regular-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("./assets/scss/partials/font/fonts/fa-regular-400.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("./assets/scss/partials/font/fonts/fa-regular-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("./assets/scss/partials/font/fonts/fa-regular-400.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("./assets/scss/partials/font/fonts/fa-solid-900.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("./assets/scss/partials/font/fonts/fa-solid-900.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("./assets/scss/partials/font/fonts/fa-solid-900.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("./assets/scss/partials/font/fonts/fa-solid-900.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("./assets/scss/partials/font/fonts/fa-solid-900.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("./assets/scss/partials/font/fonts/Flaticon.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("./assets/scss/partials/font/fonts/Flaticon.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("./assets/scss/partials/font/fonts/Flaticon.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("./assets/scss/partials/font/fonts/Flaticon.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("./assets/scss/partials/font/fonts/Flaticon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("./assets/scss/partials/font/fonts/cryptocoins.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("./assets/scss/partials/font/fonts/cryptocoins.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("./assets/scss/partials/font/fonts/cryptocoins.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___, { hash: "#pct" });
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___, { hash: "#feather" });
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___, { hash: "#fontawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___, { hash: "#fontawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___, { hash: "#fontawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___, { hash: "#Flaticon" });
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**======================================================================
=========================================================================
Template Name: Datta Able Admin Template
Author: Codedthemes
supports: https://codedthemes.support-hub.io/
File: style.css
=========================================================================
=========================================================================
  == Table of Contents==
	- Generic classes
		-	Margin, Padding, Font class, text align, position, floating, overflow, background class, text color, display class, boarder class
	- Theme Elements
		-	Accordion, Button, tabs, typography, buttons, box shadow, Lable & Badges, Alert, Pagination, Breadcumb, Cards, Collapse,
        -   Carousel, Grid, Progress, Model, tooltip, popover, Datepicker, Gridstack, lightbox, notification, Nestable, rating,
        -   Rangeslider, Slider, Syntax Highlighter, Tour, Treeview, Toolbar, Session Timeout, Session idle Timeout, offline, Animation
    - Forms
        -   Forms Elements, Advance Form Control, Validation, Masking, Wizard, Picker, Select
	- Pages
		-   Chat, authentication, Maintenance, Maps, Landingpage messages, task, Todo, Notes, Charts, Icons, Gallery, Editors,
        -   Invoice, Full Calender, File Upload,
=================================================================================
=================================================================================== */
/*!
 * Bootstrap  v5.3.3 (https://getbootstrap.com/)
 * Copyright 2011-2024 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #0d6efd;
  --bs-secondary: #6c757d;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #212529;
  --bs-primary-rgb: 13, 110, 253;
  --bs-secondary-rgb: 108, 117, 125;
  --bs-success-rgb: 25, 135, 84;
  --bs-info-rgb: 13, 202, 240;
  --bs-warning-rgb: 255, 193, 7;
  --bs-danger-rgb: 220, 53, 69;
  --bs-light-rgb: 248, 249, 250;
  --bs-dark-rgb: 33, 37, 41;
  --bs-primary-text-emphasis: #052c65;
  --bs-secondary-text-emphasis: #2b2f32;
  --bs-success-text-emphasis: #0a3622;
  --bs-info-text-emphasis: #055160;
  --bs-warning-text-emphasis: #664d03;
  --bs-danger-text-emphasis: #58151c;
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: #cfe2ff;
  --bs-secondary-bg-subtle: #e2e3e5;
  --bs-success-bg-subtle: #d1e7dd;
  --bs-info-bg-subtle: #cff4fc;
  --bs-warning-bg-subtle: #fff3cd;
  --bs-danger-bg-subtle: #f8d7da;
  --bs-light-bg-subtle: #fcfcfd;
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: #9ec5fe;
  --bs-secondary-border-subtle: #c4c8cb;
  --bs-success-border-subtle: #a3cfbb;
  --bs-info-border-subtle: #9eeaf9;
  --bs-warning-border-subtle: #ffe69c;
  --bs-danger-border-subtle: #f1aeb5;
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-color-rgb: 33, 37, 41;
  --bs-body-bg: #fff;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(33, 37, 41, 0.75);
  --bs-secondary-color-rgb: 33, 37, 41;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(33, 37, 41, 0.5);
  --bs-tertiary-color-rgb: 33, 37, 41;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #0d6efd;
  --bs-link-color-rgb: 13, 110, 253;
  --bs-link-decoration: underline;
  --bs-link-hover-color: #0a58ca;
  --bs-link-hover-color-rgb: 10, 88, 202;
  --bs-code-color: #d63384;
  --bs-highlight-color: #212529;
  --bs-highlight-bg: #fff3cd;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);
  --bs-form-valid-color: #198754;
  --bs-form-valid-border-color: #198754;
  --bs-form-invalid-color: #dc3545;
  --bs-form-invalid-border-color: #dc3545;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: #2b3035;
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: #6ea8fe;
  --bs-secondary-text-emphasis: #a7acb1;
  --bs-success-text-emphasis: #75b798;
  --bs-info-text-emphasis: #6edff6;
  --bs-warning-text-emphasis: #ffda6a;
  --bs-danger-text-emphasis: #ea868f;
  --bs-light-text-emphasis: #f8f9fa;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: #031633;
  --bs-secondary-bg-subtle: #161719;
  --bs-success-bg-subtle: #051b11;
  --bs-info-bg-subtle: #032830;
  --bs-warning-bg-subtle: #332701;
  --bs-danger-bg-subtle: #2c0b0e;
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: #1a1d20;
  --bs-primary-border-subtle: #084298;
  --bs-secondary-border-subtle: #41464b;
  --bs-success-border-subtle: #0f5132;
  --bs-info-border-subtle: #087990;
  --bs-warning-border-subtle: #997404;
  --bs-danger-border-subtle: #842029;
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: #6ea8fe;
  --bs-link-hover-color: #8bb9fe;
  --bs-link-color-rgb: 110, 168, 254;
  --bs-link-hover-color-rgb: 139, 185, 254;
  --bs-code-color: #e685b5;
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: #664d03;
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: #75b798;
  --bs-form-valid-border-color: #75b798;
  --bs-form-invalid-color: #ea868f;
  --bs-form-invalid-border-color: #ea868f;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}
body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: calc(1.375rem + 1.5vw);
}

@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.5rem;
  }
}
h2, .h2 {
  font-size: calc(1.325rem + 0.9vw);
}

@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 2rem;
  }
}
h3, .h3 {
  font-size: calc(1.3rem + 0.6vw);
}

@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.75rem;
  }
}
h4, .h4 {
  font-size: calc(1.275rem + 0.3vw);
}

@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.5rem;
  }
}
h5, .h5 {
  font-size: 1.25rem;
}

h6, .h6 {
  font-size: 1rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: underline;
}

a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}

pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}

a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.25rem;
}

kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-secondary-color);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}

select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}

@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}
.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}
.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}
.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}
.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}
.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}
.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}

.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}

.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}

.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}

.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-emphasis-color);
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-emphasis-color);
  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);
  --bs-table-active-color: var(--bs-emphasis-color);
  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);
  --bs-table-hover-color: var(--bs-emphasis-color);
  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}

.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}

.table > tbody {
  vertical-align: inherit;
}

.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: var(--bs-border-width) 0;
}

.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--bs-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}

.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #000;
  --bs-table-bg: #cfe2ff;
  --bs-table-border-color: #a6b5cc;
  --bs-table-striped-bg: #c5d7f2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #bacbe6;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #bfd1ec;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: #e2e3e5;
  --bs-table-border-color: #b5b6b7;
  --bs-table-striped-bg: #d7d8da;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #cbccce;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #d1d2d4;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #000;
  --bs-table-bg: #d1e7dd;
  --bs-table-border-color: #a7b9b1;
  --bs-table-striped-bg: #c7dbd2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #bcd0c7;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #c1d6cc;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #000;
  --bs-table-bg: #cff4fc;
  --bs-table-border-color: #a6c3ca;
  --bs-table-striped-bg: #c5e8ef;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #badce3;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #bfe2e9;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #000;
  --bs-table-bg: #fff3cd;
  --bs-table-border-color: #ccc2a4;
  --bs-table-striped-bg: #f2e7c3;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #e6dbb9;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #ece1be;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #000;
  --bs-table-bg: #f8d7da;
  --bs-table-border-color: #c6acae;
  --bs-table-striped-bg: #eccccf;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dfc2c4;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e5c7ca;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #000;
  --bs-table-bg: #f8f9fa;
  --bs-table-border-color: #c6c7c8;
  --bs-table-striped-bg: #ecedee;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dfe0e1;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e5e6e7;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #212529;
  --bs-table-border-color: #4d5154;
  --bs-table-striped-bg: #2c3034;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #373b3e;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #323539;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.375rem + var(--bs-border-width));
  padding-bottom: calc(0.375rem + var(--bs-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + var(--bs-border-width));
  padding-bottom: calc(0.5rem + var(--bs-border-width));
  font-size: 1.25rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + var(--bs-border-width));
  padding-bottom: calc(0.25rem + var(--bs-border-width));
  font-size: 0.875rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}

.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}

.form-control:focus {
  color: var(--bs-body-color);
  background-color: var(--bs-body-bg);
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}

.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}

.form-control::placeholder {
  color: var(--bs-secondary-color);
  opacity: 1;
}

.form-control:disabled {
  background-color: var(--bs-secondary-bg);
  opacity: 1;
}

.form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: var(--bs-body-color);
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--bs-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}

.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--bs-secondary-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--bs-border-width) 0;
}

.form-control-plaintext:focus {
  outline: 0;
}

.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + var(--bs-border-width) * 2);
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + var(--bs-border-width) * 2);
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.75rem + var(--bs-border-width) * 2);
}

textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + var(--bs-border-width) * 2);
}

textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + var(--bs-border-width) * 2);
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + var(--bs-border-width) * 2);
  padding: 0.375rem;
}

.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}

.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}

.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}

.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + var(--bs-border-width) * 2);
}

.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + var(--bs-border-width) * 2);
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}

.form-select:disabled {
  background-color: var(--bs-secondary-bg);
}

.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--bs-body-color);
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}

.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}

.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: var(--bs-body-bg);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--bs-border-width) solid var(--bs-border-color);
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}

.form-check-input[type=radio] {
  border-radius: 50%;
}

.form-check-input:active {
  filter: brightness(90%);
}

.form-check-input:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.form-check-input[type=checkbox]:indeterminate {
  background-color: #0d6efd;
  border-color: #0d6efd;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}

.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}

.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}

.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}

.form-range:focus {
  outline: 0;
}

.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.form-range::-moz-focus-outer {
  border: 0;
}

.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: #b6d4fe;
}

.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}

.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: #b6d4fe;
}

.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}

.form-range:disabled {
  pointer-events: none;
}

.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--bs-secondary-color);
}

.form-range:disabled::-moz-range-thumb {
  background-color: var(--bs-secondary-color);
}

.form-floating {
  position: relative;
}

.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + var(--bs-border-width) * 2);
  min-height: calc(3.5rem + var(--bs-border-width) * 2);
  line-height: 1.25;
}

.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--bs-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}

.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}

.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--bs-body-bg);
  border-radius: var(--bs-border-radius);
}

.form-floating > .form-control:-webkit-autofill ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.form-floating > .form-control-plaintext ~ label {
  border-width: var(--bs-border-width) 0;
}

.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #6c757d;
}

.form-floating > :disabled ~ label::after,
.form-floating > .form-control:disabled ~ label::after {
  background-color: var(--bs-secondary-bg);
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}

.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}

.input-group .btn {
  position: relative;
  z-index: 2;
}

.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-tertiary-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(var(--bs-border-width) * -1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: var(--bs-border-radius);
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--bs-form-valid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--bs-form-valid-border-color);
}

.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + 1.5em + 0.75rem);
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--bs-form-valid-border-color);
}

.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--bs-form-valid-color);
}

.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--bs-form-valid-color);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: var(--bs-border-radius);
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}

.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + 1.5em + 0.75rem);
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}

.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--bs-form-invalid-color);
}

.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--bs-form-invalid-color);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.375rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 1rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: var(--bs-border-radius);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}

.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}

.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}

.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}

.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}

.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}

.btn-check:checked:focus-visible + .btn {
  box-shadow: var(--bs-btn-focus-box-shadow);
}

.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0b5ed7;
  --bs-btn-hover-border-color: #0a58ca;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0a58ca;
  --bs-btn-active-border-color: #0a53be;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0d6efd;
  --bs-btn-disabled-border-color: #0d6efd;
}

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #5c636a;
  --bs-btn-hover-border-color: #565e64;
  --bs-btn-focus-shadow-rgb: 130, 138, 145;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #565e64;
  --bs-btn-active-border-color: #51585e;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #6c757d;
  --bs-btn-disabled-border-color: #6c757d;
}

.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #157347;
  --bs-btn-hover-border-color: #146c43;
  --bs-btn-focus-shadow-rgb: 60, 153, 110;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #146c43;
  --bs-btn-active-border-color: #13653f;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #198754;
  --bs-btn-disabled-border-color: #198754;
}

.btn-info {
  --bs-btn-color: #000;
  --bs-btn-bg: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #31d2f2;
  --bs-btn-hover-border-color: #25cff2;
  --bs-btn-focus-shadow-rgb: 11, 172, 204;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #3dd5f3;
  --bs-btn-active-border-color: #25cff2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #0dcaf0;
  --bs-btn-disabled-border-color: #0dcaf0;
}

.btn-warning {
  --bs-btn-color: #000;
  --bs-btn-bg: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffca2c;
  --bs-btn-hover-border-color: #ffc720;
  --bs-btn-focus-shadow-rgb: 217, 164, 6;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffcd39;
  --bs-btn-active-border-color: #ffc720;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #ffc107;
  --bs-btn-disabled-border-color: #ffc107;
}

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #bb2d3b;
  --bs-btn-hover-border-color: #b02a37;
  --bs-btn-focus-shadow-rgb: 225, 83, 97;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #b02a37;
  --bs-btn-active-border-color: #a52834;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #dc3545;
  --bs-btn-disabled-border-color: #dc3545;
}

.btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #d3d4d5;
  --bs-btn-hover-border-color: #c6c7c8;
  --bs-btn-focus-shadow-rgb: 211, 212, 213;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #c6c7c8;
  --bs-btn-active-border-color: #babbbc;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #f8f9fa;
  --bs-btn-disabled-border-color: #f8f9fa;
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #424649;
  --bs-btn-hover-border-color: #373b3e;
  --bs-btn-focus-shadow-rgb: 66, 70, 73;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #4d5154;
  --bs-btn-active-border-color: #373b3e;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #212529;
  --bs-btn-disabled-border-color: #212529;
}

.btn-outline-primary {
  --bs-btn-color: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0d6efd;
  --bs-btn-hover-border-color: #0d6efd;
  --bs-btn-focus-shadow-rgb: 13, 110, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0d6efd;
  --bs-btn-active-border-color: #0d6efd;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0d6efd;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0d6efd;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6c757d;
  --bs-btn-hover-border-color: #6c757d;
  --bs-btn-focus-shadow-rgb: 108, 117, 125;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #6c757d;
  --bs-btn-active-border-color: #6c757d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #6c757d;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #198754;
  --bs-btn-hover-border-color: #198754;
  --bs-btn-focus-shadow-rgb: 25, 135, 84;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #198754;
  --bs-btn-active-border-color: #198754;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #198754;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #198754;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #0dcaf0;
  --bs-btn-hover-border-color: #0dcaf0;
  --bs-btn-focus-shadow-rgb: 13, 202, 240;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #0dcaf0;
  --bs-btn-active-border-color: #0dcaf0;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0dcaf0;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0dcaf0;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffc107;
  --bs-btn-hover-border-color: #ffc107;
  --bs-btn-focus-shadow-rgb: 255, 193, 7;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffc107;
  --bs-btn-active-border-color: #ffc107;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffc107;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffc107;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #dc3545;
  --bs-btn-hover-border-color: #dc3545;
  --bs-btn-focus-shadow-rgb: 220, 53, 69;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #dc3545;
  --bs-btn-active-border-color: #dc3545;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #dc3545;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #dc3545;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f8f9fa;
  --bs-btn-hover-border-color: #f8f9fa;
  --bs-btn-focus-shadow-rgb: 248, 249, 250;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f8f9fa;
  --bs-btn-active-border-color: #f8f9fa;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f8f9fa;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f8f9fa;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #212529;
  --bs-btn-hover-border-color: #212529;
  --bs-btn-focus-shadow-rgb: 33, 37, 41;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #212529;
  --bs-btn-active-border-color: #212529;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #212529;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #212529;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  text-decoration: underline;
}

.btn-link:focus-visible {
  color: var(--bs-btn-color);
}

.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1.25rem;
  --bs-btn-border-radius: var(--bs-border-radius-lg);
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.875rem;
  --bs-btn-border-radius: var(--bs-border-radius-sm);
}

.fade {
  transition: opacity 0.15s linear;
}

@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}

@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}

@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}
.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}

.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 1rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: var(--bs-body-bg);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: var(--bs-border-radius);
  --bs-dropdown-border-width: var(--bs-border-width);
  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: var(--bs-box-shadow);
  --bs-dropdown-link-color: var(--bs-body-color);
  --bs-dropdown-link-hover-color: var(--bs-body-color);
  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.25rem;
  --bs-dropdown-header-color: #6c757d;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}

.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}

.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}

.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}

.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}

.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}

.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}

.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}

.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}

.dropstart .dropdown-toggle::after {
  display: none;
}

.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}

.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}

.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}

.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}

.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #dee2e6;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #dee2e6;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}

.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}

.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: var(--bs-border-radius);
}

.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(var(--bs-border-width) * -1);
}

.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}

.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}

.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}

.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(var(--bs-border-width) * -1);
}

.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}

.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}

.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}

.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}

.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: var(--bs-border-radius);
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #0d6efd;
}

.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}

.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}

.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}

.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}

.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y: 0.3125rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.25rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.25rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: var(--bs-border-radius);
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}

.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}

.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}

.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}

.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}

.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}

@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}

.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}

.navbar-expand .navbar-nav {
  flex-direction: row;
}

.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}

.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}

.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}

.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}

.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}

.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}

.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

.card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: var(--bs-border-width);
  --bs-card-border-color: var(--bs-border-color-translucent);
  --bs-card-border-radius: var(--bs-border-radius);
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--bs-body-bg);
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}

.card > hr {
  margin-right: 0;
  margin-left: 0;
}

.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}

.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}

.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}

.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}

.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}

@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}
.accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: var(--bs-primary-text-emphasis);
  --bs-accordion-active-bg: var(--bs-primary-bg-subtle);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}

@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}

.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}

.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}

@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}

.accordion-button:focus {
  z-index: 3;
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}

.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}

.accordion-item:first-of-type > .accordion-header .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}

.accordion-item:not(:first-of-type) {
  border-top: 0;
}

.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}

.accordion-item:last-of-type > .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush > .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}

.accordion-flush > .accordion-item:first-child {
  border-top: 0;
}

.accordion-flush > .accordion-item:last-child {
  border-bottom: 0;
}

.accordion-flush > .accordion-item > .accordion-header .accordion-button, .accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {
  border-radius: 0;
}

.accordion-flush > .accordion-item > .accordion-collapse {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-secondary-color);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}

.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/");
}

.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: var(--bs-link-color);
  --bs-pagination-bg: var(--bs-body-bg);
  --bs-pagination-border-width: var(--bs-border-width);
  --bs-pagination-border-color: var(--bs-border-color);
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: var(--bs-link-hover-color);
  --bs-pagination-hover-bg: var(--bs-tertiary-bg);
  --bs-pagination-hover-border-color: var(--bs-border-color);
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #0d6efd;
  --bs-pagination-active-border-color: #0d6efd;
  --bs-pagination-disabled-color: var(--bs-secondary-color);
  --bs-pagination-disabled-bg: var(--bs-secondary-bg);
  --bs-pagination-disabled-border-color: var(--bs-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}

.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}

.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}

.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: calc(var(--bs-border-width) * -1);
}

.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}

.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.25rem;
  --bs-pagination-border-radius: var(--bs-border-radius-lg);
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.875rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm);
}

.badge {
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 0.35em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 700;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: var(--bs-border-radius);
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: var(--bs-border-radius);
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3rem;
}

.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.75rem;
  --bs-progress-bg: var(--bs-secondary-bg);
  --bs-progress-border-radius: var(--bs-border-radius);
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #0d6efd;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}
.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}
.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: var(--bs-body-bg);
  --bs-list-group-border-color: var(--bs-border-color);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: var(--bs-secondary-color);
  --bs-list-group-disabled-bg: var(--bs-body-bg);
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #0d6efd;
  --bs-list-group-active-border-color: #0d6efd;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}

.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}

.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}

.list-group-item-action:active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}

.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}

.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}

.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}

.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}

.list-group-item + .list-group-item {
  border-top-width: 0;
}

.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}

.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}

.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}

.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}

.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}

.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}

.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}

.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--bs-btn-close-opacity);
}

.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}

.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}

.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
  user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  filter: var(--bs-btn-close-white-filter);
}

[data-bs-theme=dark] .btn-close {
  filter: var(--bs-btn-close-white-filter);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 1.5rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: var(--bs-border-radius);
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-secondary-color);
  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-header-border-color: var(--bs-border-color-translucent);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}

.toast.showing {
  opacity: 0;
}

.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}

.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}

.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: var(--bs-body-bg);
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: var(--bs-border-width);
  --bs-modal-border-radius: var(--bs-border-radius-lg);
  --bs-modal-box-shadow: var(--bs-box-shadow-sm);
  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}

.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}

@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}

.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}

.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}

.modal-backdrop.fade {
  opacity: 0;
}

.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}

.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}

.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: var(--bs-box-shadow);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}

.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}

.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}

.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.5rem;
  --bs-tooltip-padding-y: 0.25rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 0.875rem;
  --bs-tooltip-color: var(--bs-body-bg);
  --bs-tooltip-bg: var(--bs-emphasis-color);
  --bs-tooltip-border-radius: var(--bs-border-radius);
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}

.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}

.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}

.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}

.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}

.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}

.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}

.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.875rem;
  --bs-popover-bg: var(--bs-body-bg);
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: var(--bs-border-color-translucent);
  --bs-popover-border-radius: var(--bs-border-radius-lg);
  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));
  --bs-popover-box-shadow: var(--bs-box-shadow);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: var(--bs-secondary-bg);
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: var(--bs-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}

.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}

.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}

.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}

.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}

.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}

.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}

.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}

.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}

.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}

.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}

.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}

.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}

.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}

.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}

.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}

.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}
.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}

.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}

.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}
.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}

.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}

.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000;
}

.carousel-dark .carousel-caption {
  color: #000;
}

[data-bs-theme=dark] .carousel .carousel-control-prev-icon,
[data-bs-theme=dark] .carousel .carousel-control-next-icon, [data-bs-theme=dark].carousel .carousel-control-prev-icon,
[data-bs-theme=dark].carousel .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}

[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {
  background-color: #000;
}

[data-bs-theme=dark] .carousel .carousel-caption, [data-bs-theme=dark].carousel .carousel-caption {
  color: #000;
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}

@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}

.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}

.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}

.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}

.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}

.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}

.offcanvas-backdrop.fade {
  opacity: 0;
}

.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}

.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-offcanvas-padding-y)) calc(-0.5 * var(--bs-offcanvas-padding-x)) calc(-0.5 * var(--bs-offcanvas-padding-y)) auto;
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}

.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #000 !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary:hover, .link-primary:focus {
  color: RGBA(10, 88, 202, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(10, 88, 202, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary:hover, .link-secondary:focus {
  color: RGBA(86, 94, 100, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(86, 94, 100, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-success:hover, .link-success:focus {
  color: RGBA(20, 108, 67, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(20, 108, 67, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-info:hover, .link-info:focus {
  color: RGBA(61, 213, 243, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(61, 213, 243, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning:hover, .link-warning:focus {
  color: RGBA(255, 205, 57, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 205, 57, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger:hover, .link-danger:focus {
  color: RGBA(176, 42, 55, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(176, 42, 55, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-light:hover, .link-light:focus {
  color: RGBA(249, 250, 251, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(249, 250, 251, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark:hover, .link-dark:focus {
  color: RGBA(26, 30, 33, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(26, 30, 33, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}

.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}

@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}
.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}

.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}

.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2 {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-3 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-4 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-5 {
  font-size: 1.25rem !important;
}

.fs-6 {
  font-size: 1rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
  user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
  user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
  user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.5rem !important;
  }
  .fs-2 {
    font-size: 2rem !important;
  }
  .fs-3 {
    font-size: 1.75rem !important;
  }
  .fs-4 {
    font-size: 1.5rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}

/*
    description Of variables for build for theme layouts
        1) menu-caption-color
            List of color for sidebar menu caption

        2) brand-background
            List of color for logo background

        3) header-dark-background
            List of color for Dark Header

        4) header-light-background
            List of color for light Header

        5) menu-dark-background
            List of color for Dark sidebar menu

        6) menu-light-background
            List of color for light sidebar menu

        7) menu-active-color
            List of color for Active item highliter

        8) menu-icon-color
            List of color for sidebar menu items icon colors
*/
:root {
  --bs-body-color: #888;
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 1rem;
  --bs-breadcrumb-padding-y: 0.75rem;
}

/**  =====================
      Custom css start
==========================  **/
body {
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  color: #888;
  font-weight: 400;
  background: #f4f7fa;
  position: relative;
}

*:focus {
  outline: none;
}

a {
  text-decoration: none;
}
a:hover {
  outline: none;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  color: #111;
  font-weight: 400;
}

h1 {
  font-size: 48px;
}

h2 {
  font-size: 44px;
}

h3 {
  font-size: 26px;
}

h4 {
  font-size: 20px;
}

h5 {
  font-size: 18px;
}

h6 {
  font-size: 14px;
}

p {
  font-size: 14px;
}

strong {
  font-weight: 400;
}

label {
  margin-bottom: 0.5rem;
}

.img-radius {
  border-radius: 50%;
}

.page-header-title + .breadcrumb {
  background: transparent;
  padding: 0;
}
.page-header-title + .breadcrumb > .breadcrumb-item a {
  color: #888;
}
.page-header-title + .breadcrumb > .breadcrumb-item:last-child a {
  color: #111;
  font-weight: 600;
}

.theme-bg {
  background: linear-gradient(-135deg, #1de9b6 0%, #1dc4e9 100%);
}

.theme-bg2 {
  background: linear-gradient(-135deg, #899fd4 0%, #a389d4 100%);
}

/* ==========  card css start  =========== */
.anim-rotate {
  animation: anim-rotate 1s linear infinite;
}

@keyframes anim-rotate {
  100% {
    transform: rotate(360deg);
  }
}
.anim-close-card {
  animation: anim-close-card 1.4s linear;
}

@keyframes anim-close-card {
  100% {
    opacity: 0.3;
    transform: scale3d(0.3, 0.3, 0.3);
  }
}
p.text-muted {
  font-size: 13px;
}

.card {
  border-radius: 0;
  box-shadow: 0 1px 20px 0 rgba(69, 90, 100, 0.08);
  border: none;
  margin-bottom: 30px;
  transition: all 0.5s ease-in-out;
  --bs-card-title-color: #111;
}
.card .card-header {
  background-color: transparent;
  border-bottom: 1px solid #f1f1f1;
  padding: 20px 25px;
  position: relative;
}
.card .card-header h5 {
  margin-bottom: 0;
  color: #000;
  font-size: 17px;
  font-weight: 400;
  display: inline-block;
  margin-right: 10px;
  line-height: 1.1;
  position: relative;
}
.card .card-header h5:after {
  content: "";
  background-color: #04a9f5;
  position: absolute;
  left: -25px;
  top: 0;
  width: 4px;
  height: 20px;
}
.card .card-header.borderless {
  border-bottom: none;
}
.card .card-header.borderless h5:after {
  display: none;
}
.card .card-header .card-header-right {
  right: 10px;
  top: 10px;
  display: inline-block;
  float: right;
  padding: 0;
  position: absolute;
}
@media only screen and (max-width: 575px) {
  .card .card-header .card-header-right {
    display: none;
  }
}
.card .card-header .card-header-right .dropdown-menu {
  margin-top: 0;
}
.card .card-header .card-header-right .dropdown-menu li a {
  font-size: 14px;
  text-transform: capitalize;
}
.card .card-header .card-header-right .btn.dropdown-toggle {
  border: none;
  background: transparent;
  box-shadow: none;
  color: #888;
}
.card .card-header .card-header-right .btn.dropdown-toggle i {
  margin-right: 0;
}
.card .card-header .card-header-right .btn.dropdown-toggle:after {
  display: none;
}
.card .card-header .card-header-right .btn.dropdown-toggle:focus {
  box-shadow: none;
  outline: none;
}
.card .card-footer {
  border-top: 1px solid #f1f1f1;
  background: transparent;
  padding: 25px;
}
.card .card-block,
.card .card-body {
  padding: 30px 25px;
}
.card.card-load {
  position: relative;
  overflow: hidden;
}
.card.card-load .card-loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 999;
}
.card.card-load .card-loader i {
  margin: 0 auto;
  color: #04a9f5;
  font-size: 24px;
  align-items: center;
  display: flex;
}
.card.full-card {
  z-index: 99999;
  border-radius: 0;
}

/* ==========  scrollbar End  =========== */
.scroll-y {
  z-index: 1027;
}

/* ==========  scrollbar End  ===========
 ==========  card css End  ===========
 ================================    Dropdown Start  ===================== */
.dropdown-menu {
  padding: 20px 0;
  margin-top: 15px;
  box-shadow: 0 1px 10px 0 rgba(69, 90, 100, 0.2);
  border: none;
}
.dropdown-menu.show:before {
  content: "c";
  font-family: "pct";
  position: absolute;
  left: 115px;
  top: -5px;
  z-index: 1001;
  font-size: 40px;
  line-height: 0;
  color: #fff;
  text-shadow: 0 -2px 2px rgba(69, 90, 100, 0.12);
}
.dropdown-menu.show.dropdown-menu-right:before {
  left: auto;
  right: 5px;
}
.dropdown-menu[x-placement=top-start] {
  margin-bottom: 15px;
  margin-top: 0;
}
.dropdown-menu[x-placement=top-start].show:before {
  content: "d";
  bottom: -5px;
  top: auto;
  text-shadow: 0 2px 2px rgba(69, 90, 100, 0.12);
}
.dropdown-menu > li {
  padding-left: 15px;
  padding-right: 15px;
}
.dropdown-menu > li > a {
  padding: 5px;
  color: #888;
}
.dropdown-menu > li > a i {
  font-size: 15px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}
.dropdown-menu > li.active, .dropdown-menu > li:active, .dropdown-menu > li:focus, .dropdown-menu > li:hover {
  background: rgba(4, 169, 245, 0.1);
}
.dropdown-menu > li.active > a, .dropdown-menu > li:active > a, .dropdown-menu > li:focus > a, .dropdown-menu > li:hover > a {
  background: transparent;
}

/* ================================    Dropdown End  ===================== */
@media (min-width: 1600px) {
  .container {
    max-width: 1540px;
  }
}
@media (max-width: 992px) {
  .container {
    max-width: 100%;
  }
}
/* ========================================================
 ===============     document      ======================
 ========================================================

 Grid examples
*/
.bd-example-row {
  background: #f4f7fa;
  padding: 15px;
  margin-bottom: 15px;
}
.bd-example-row .row > [class^=col-],
.bd-example-row .row > .col {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  background-color: rgba(86, 61, 124, 0.15);
  border: 1px solid rgba(86, 61, 124, 0.2);
}
.bd-example-row .row + .row {
  margin-top: 1rem;
}
.bd-example-row .flex-items-bottom,
.bd-example-row .flex-items-middle,
.bd-example-row .flex-items-top {
  min-height: 6rem;
  background-color: rgba(255, 0, 0, 0.1);
}

.bd-example-row-flex-cols .row {
  min-height: 10rem;
  background-color: rgba(255, 0, 0, 0.1);
}

/* Docs examples */
.bd-example {
  position: relative;
  padding: 1rem;
  margin: 1rem;
  border: solid #ddd;
  border-width: 0.2rem 0 0;
}
@media only screen and (max-height: 575px) {
  .bd-example {
    padding: 1.5rem;
    margin-right: 0;
    margin-left: 0;
    border-width: 0.2rem;
  }
}

/* Example modals */
.modal {
  z-index: 1072;
}
.modal .popover,
.modal .tooltip {
  z-index: 1073;
}

.modal-backdrop {
  z-index: 1071;
}

.bd-example-modal {
  background-color: #fafafa;
}
.bd-example-modal .modal {
  position: relative;
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
  z-index: 1;
  display: block;
}
.bd-example-modal .modal-dialog {
  left: auto;
  margin-right: auto;
  margin-left: auto;
}

/* Example tabbable tabs */
.bd-example-tabs .nav-tabs {
  margin-bottom: 1rem;
}

/* Code snippets */
.highlight {
  padding: 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  background-color: #f3f2fb;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}
@media only screen and (max-height: 575px) {
  .highlight {
    padding: 1.5rem;
  }
}

.bd-content .highlight {
  margin-right: 15px;
  margin-left: 15px;
}
@media only screen and (max-height: 575px) {
  .bd-content .highlight {
    margin-right: 0;
    margin-left: 0;
  }
}

.highlight pre {
  padding: 0;
  margin-top: 0;
  margin-bottom: 0;
  background-color: transparent;
  border: 0;
}
.highlight pre code {
  font-size: inherit;
  color: #333;
}

/* =======================================================================
 ===============     Ui kit copy model style      ====================== */
/* Code examples */
.datta-example {
  position: relative;
}
.datta-example .datta-example-btns {
  position: absolute;
  right: 30px;
  top: -10px;
  opacity: 0;
  transform: rotateX(-90deg);
  transition: all 0.3s ease-in-out;
}
.datta-example .datta-example-btns .datta-example-btn {
  display: inline-block;
  line-height: 1;
  font-weight: 600;
  background: #04a9f5;
  color: #fff;
  padding: 0.1875rem 0.3125rem;
  border-radius: 2px;
  white-space: nowrap;
  font-size: 11px;
  margin: 0 4px;
}
.datta-example .datta-example-btns .datta-example-btn.copy::before {
  content: "COPY";
}
.datta-example .datta-example-btns .datta-example-btn.copied {
  background: #1de9b6 !important;
  color: #fff !important;
}
.datta-example .datta-example-btns .datta-example-btn.copied::before {
  content: "COPIED!";
}
.datta-example:hover .datta-example-btns {
  top: -21px;
  transform: rotateX(0deg);
  opacity: 1;
}

/* Modal */
.datta-example-modal {
  position: fixed;
  z-index: 1099;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #282c34;
  transform-origin: 50% 0;
  transform: scale(0);
  transition: all 0.3s ease-in-out;
}

.datta-example-modal-opened {
  overflow: hidden !important;
}
.datta-example-modal-opened .datta-example-modal {
  transform: scale(1);
}

.datta-example-modal-content {
  max-width: 100vw;
  margin: auto;
  padding: 50px;
  height: 100vh;
  overflow: auto;
}
.datta-example-modal-content > pre {
  overflow: hidden;
  width: -moz-fit-content;
  width: fit-content;
}
.datta-example-modal-content > pre > code {
  padding: 0;
  background: none;
  font-size: 16px;
}

.md-datta-example-modal-copy {
  display: block;
  position: fixed;
  top: 90px;
  right: 30px;
  margin-right: 8px;
  font-size: 1.5rem;
  border-radius: 50%;
  padding: 10px 15px;
  background: #04a9f5;
  color: #fff;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);
  z-index: 1;
  white-space: nowrap;
}
.md-datta-example-modal-copy:hover {
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);
  color: #fff;
}
.md-datta-example-modal-copy.copied::before {
  content: "Copied to Clipboard Successfully ! . . .";
  position: absolute;
  display: block;
  right: 100%;
  margin-right: 10px;
  font-size: 14px;
  background: #1de9b6;
  line-height: 24px;
  height: 24px;
  border-radius: 3px;
  padding: 0 6px;
  top: 50%;
  margin-top: -12px;
}

.datta-example-modal-close {
  display: block;
  position: fixed;
  top: 10px;
  right: 52px;
  color: #fff;
  opacity: 0.2;
  font-size: 3rem;
  font-weight: 100;
  transition: all 0.3s ease-in-out;
  z-index: 1;
}
.datta-example-modal-close:hover {
  color: #fff;
  opacity: 0.9;
}

/* Code */
.cui-bottom-spacer {
  height: 12rem;
}

/* editor style for model */
.hljs {
  padding: 0.5em;
  color: #abb2bf;
  background: #282c34;
}

.hljs-comment,
.hljs-quote {
  color: #5c6370;
  font-style: italic;
}

.hljs-doctag,
.hljs-formula,
.hljs-keyword {
  color: #c678dd;
}

.hljs-deletion,
.hljs-name,
.hljs-section,
.hljs-selector-tag,
.hljs-subst {
  color: #e06c75;
}

.hljs-literal {
  color: #56b6c2;
}

.hljs-addition,
.hljs-attribute,
.hljs-meta-string,
.hljs-regexp,
.hljs-string {
  color: #98c379;
}

.hljs-built_in,
.hljs-class .hljs-title {
  color: #e6c07b;
}

.hljs-attr,
.hljs-number,
.hljs-selector-attr,
.hljs-selector-class,
.hljs-selector-pseudo,
.hljs-template-variable,
.hljs-type,
.hljs-variable {
  color: #d19a66;
}

.hljs-bullet,
.hljs-link,
.hljs-meta,
.hljs-selector-id,
.hljs-symbol,
.hljs-title {
  color: #61aeee;
}

.hljs-emphasis {
  font-style: italic;
}

.hljs-strong {
  font-weight: bold;
}

.hljs-link {
  text-decoration: underline;
}

/* ================================    md animated mode start   ===================== */
.md-show.md-effect-12 ~ .md-overlay {
  background: linear-gradient(-135deg, #1de9b6 0%, #1dc4e9 100%);
}

/* ================================    md animated mode End   ===================== */
/* ================================    range slider Start  ===================== */
.tooltip.in {
  opacity: 0.9;
}
.tooltip .tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}
.tooltip.top {
  padding: 5px 0;
  margin-top: -3px;
}
.tooltip.top .tooltip-arrow {
  bottom: 0;
  left: 50%;
  margin-left: -5px;
  border-width: 5px 5px 0;
  border-top-color: #000;
}

/* ================================    range slider End  ===================== */
/* ================================    Bootstrap tags input Start  ===================== */
.bootstrap-tagsinput {
  padding: 10px 15px;
  box-shadow: none;
  border-radius: 2px;
  background: #f0f3f6;
}
.bootstrap-tagsinput .tag {
  padding: 5px 12px;
  border-radius: 2px;
  line-height: 37px;
  margin-top: 5px;
  margin-right: 5px;
}
.bootstrap-tagsinput .tag [data-role=remove] {
  margin-right: -5px;
}
.bootstrap-tagsinput .tag [data-role=remove]:after {
  content: "\\e8f6";
  padding: 0 2px;
  font-family: "feather" !important;
}

/* ================================    Bootstrap tags input End  ===================== */
/* ================================    Multi-Select Start  ===================== */
.ms-container {
  width: 100%;
}

/* ================================    Multi-Select End  ===================== */
/* ================================    Blockquote Start  ===================== */
.blockquote {
  border-left: 0.25rem solid #eaeaea;
  padding: 0.5rem 1rem;
}
.blockquote.text-right {
  border-left: none;
  border-right: 0.25rem solid #eaeaea;
}

/* ================================    Blockquote End  ===================== */
/* ================================    animation start  ===================== */
.card .animated {
  animation-duration: 1s;
  border: 5px solid #fff;
  margin-bottom: 30px;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);
}

/* ================================    animation End  ===================== */
/* ================================    browser  warning  Start  ===================== */
.ie-warning {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
  background: #000000;
  width: 100%;
  height: 100%;
  text-align: center;
  color: #fff;
  font-family: "Courier New", Courier, monospace;
  padding: 50px 0;
}
.ie-warning p {
  font-size: 17px;
}
.ie-warning h1 {
  color: #fff;
}
.ie-warning .iew-container {
  min-width: 1024px;
  width: 100%;
  height: 200px;
  background: #fff;
  margin: 50px 0;
}
.ie-warning .iew-download {
  list-style: none;
  padding: 30px 0;
  margin: 0 auto;
  width: 720px;
}
.ie-warning .iew-download > li {
  float: left;
  vertical-align: top;
}
.ie-warning .iew-download > li > a {
  display: block;
  color: #000;
  width: 140px;
  font-size: 15px;
  padding: 15px 0;
}
.ie-warning .iew-download > li > a > div {
  margin-top: 10px;
}
.ie-warning .iew-download > li > a:hover {
  background-color: #eee;
}

/* ================================    browser  warning  End  ===================== */
/* material icon for material datetime picker */
/* fallback */
@font-face {
  font-family: "Material Icons";
  font-style: normal;
  font-weight: 400;
  src: url("https://fonts.gstatic.com/s/materialicons/v41/flUhRq6tzZclQEJ-Vdg-IuiaDsNc.woff2") format("woff2");
}
.material-icons {
  font-family: "Material Icons";
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-feature-settings: "liga";
  -webkit-font-smoothing: antialiased;
}

/* material icon for material datetime picker */
.btn-link {
  text-decoration: none;
}

.react-datepicker-wrapper {
  display: block !important;
}

.table-dark {
  --bs-table-bg: #37474f;
}

.table-info,
.table-info > td,
.table-info > th {
  --bs-table-bg: #bee5eb;
  background-color: #bee5eb;
}

.table {
  --bs-table-striped-bg: rgba(4, 169, 245, 0.05);
}

.table-hover tbody tr:hover {
  color: #212529;
  background: rgba(4, 169, 245, 0.05);
}
.table-hover tbody tr:hover > * {
  --bs-table-color-state: #212529;
}

.table-hover > tbody > tr:hover > * {
  --bs-table-bg-state: rgba(4, 169, 245, 0.05);
}

.btn-check:checked + .btn:not([class*=btn-]),
:not(.btn-check) + .btn:active,
.btn:first-child:active,
.btn.active,
.btn.show {
  --bs-btn-active-bg: #04a9f5;
  --bs-btn-active-border-color: #04a9f5;
}

.invoice-table.table tr td {
  background: transparent;
}

.recent-users tr td:first-child {
  width: 60px;
  padding-left: 20px;
  padding-right: 0;
}
.recent-users tr td:last-child {
  text-align: center;
}

.blockquote-footer {
  margin-top: 0;
}

.adv-task-board header {
  display: flex;
  align-items: center;
}
.adv-task-board header span span {
  margin-right: 8px;
}

.swatches-picker,
.photoshop-picker,
.hue-picker,
.alpha-picker {
  width: 100% !important;
}

@media (max-width: 575px) {
  .grid figure.effect-moses figcaption {
    padding: 8px !important;
  }
  .grid figure.effect-moses figcaption h2 {
    font-size: 20px;
  }
}

.btn.text-secondary.btn-link:active, .btn.text-secondary.btn-link.active, .btn.text-secondary.btn-link.show {
  color: #fff !important;
}

.alert-inverse .btn-close {
  color: #fff !important;
  filter: invert(1) grayscale(100%) brightness(200%) !important;
}

/**  =====================
      Generic-class css start
========================== **/
/*====== Padding , Margin css starts ======*/
.p-0 {
  padding: 0px;
}
.p-t-0 {
  padding-top: 0px;
}
.p-b-0 {
  padding-bottom: 0px;
}
.p-l-0 {
  padding-left: 0px;
}
.p-r-0 {
  padding-right: 0px;
}

.m-0 {
  margin: 0px;
}
.m-t-0 {
  margin-top: 0px;
}
.m-b-0 {
  margin-bottom: 0px;
}
.m-l-0 {
  margin-left: 0px;
}
.m-r-0 {
  margin-right: 0px;
}

.p-5 {
  padding: 5px;
}
.p-t-5 {
  padding-top: 5px;
}
.p-b-5 {
  padding-bottom: 5px;
}
.p-l-5 {
  padding-left: 5px;
}
.p-r-5 {
  padding-right: 5px;
}

.m-5 {
  margin: 5px;
}
.m-t-5 {
  margin-top: 5px;
}
.m-b-5 {
  margin-bottom: 5px;
}
.m-l-5 {
  margin-left: 5px;
}
.m-r-5 {
  margin-right: 5px;
}

.p-10 {
  padding: 10px;
}
.p-t-10 {
  padding-top: 10px;
}
.p-b-10 {
  padding-bottom: 10px;
}
.p-l-10 {
  padding-left: 10px;
}
.p-r-10 {
  padding-right: 10px;
}

.m-10 {
  margin: 10px;
}
.m-t-10 {
  margin-top: 10px;
}
.m-b-10 {
  margin-bottom: 10px;
}
.m-l-10 {
  margin-left: 10px;
}
.m-r-10 {
  margin-right: 10px;
}

.p-15 {
  padding: 15px;
}
.p-t-15 {
  padding-top: 15px;
}
.p-b-15 {
  padding-bottom: 15px;
}
.p-l-15 {
  padding-left: 15px;
}
.p-r-15 {
  padding-right: 15px;
}

.m-15 {
  margin: 15px;
}
.m-t-15 {
  margin-top: 15px;
}
.m-b-15 {
  margin-bottom: 15px;
}
.m-l-15 {
  margin-left: 15px;
}
.m-r-15 {
  margin-right: 15px;
}

.p-20 {
  padding: 20px;
}
.p-t-20 {
  padding-top: 20px;
}
.p-b-20 {
  padding-bottom: 20px;
}
.p-l-20 {
  padding-left: 20px;
}
.p-r-20 {
  padding-right: 20px;
}

.m-20 {
  margin: 20px;
}
.m-t-20 {
  margin-top: 20px;
}
.m-b-20 {
  margin-bottom: 20px;
}
.m-l-20 {
  margin-left: 20px;
}
.m-r-20 {
  margin-right: 20px;
}

.p-25 {
  padding: 25px;
}
.p-t-25 {
  padding-top: 25px;
}
.p-b-25 {
  padding-bottom: 25px;
}
.p-l-25 {
  padding-left: 25px;
}
.p-r-25 {
  padding-right: 25px;
}

.m-25 {
  margin: 25px;
}
.m-t-25 {
  margin-top: 25px;
}
.m-b-25 {
  margin-bottom: 25px;
}
.m-l-25 {
  margin-left: 25px;
}
.m-r-25 {
  margin-right: 25px;
}

.p-30 {
  padding: 30px;
}
.p-t-30 {
  padding-top: 30px;
}
.p-b-30 {
  padding-bottom: 30px;
}
.p-l-30 {
  padding-left: 30px;
}
.p-r-30 {
  padding-right: 30px;
}

.m-30 {
  margin: 30px;
}
.m-t-30 {
  margin-top: 30px;
}
.m-b-30 {
  margin-bottom: 30px;
}
.m-l-30 {
  margin-left: 30px;
}
.m-r-30 {
  margin-right: 30px;
}

.p-35 {
  padding: 35px;
}
.p-t-35 {
  padding-top: 35px;
}
.p-b-35 {
  padding-bottom: 35px;
}
.p-l-35 {
  padding-left: 35px;
}
.p-r-35 {
  padding-right: 35px;
}

.m-35 {
  margin: 35px;
}
.m-t-35 {
  margin-top: 35px;
}
.m-b-35 {
  margin-bottom: 35px;
}
.m-l-35 {
  margin-left: 35px;
}
.m-r-35 {
  margin-right: 35px;
}

.p-40 {
  padding: 40px;
}
.p-t-40 {
  padding-top: 40px;
}
.p-b-40 {
  padding-bottom: 40px;
}
.p-l-40 {
  padding-left: 40px;
}
.p-r-40 {
  padding-right: 40px;
}

.m-40 {
  margin: 40px;
}
.m-t-40 {
  margin-top: 40px;
}
.m-b-40 {
  margin-bottom: 40px;
}
.m-l-40 {
  margin-left: 40px;
}
.m-r-40 {
  margin-right: 40px;
}

.p-45 {
  padding: 45px;
}
.p-t-45 {
  padding-top: 45px;
}
.p-b-45 {
  padding-bottom: 45px;
}
.p-l-45 {
  padding-left: 45px;
}
.p-r-45 {
  padding-right: 45px;
}

.m-45 {
  margin: 45px;
}
.m-t-45 {
  margin-top: 45px;
}
.m-b-45 {
  margin-bottom: 45px;
}
.m-l-45 {
  margin-left: 45px;
}
.m-r-45 {
  margin-right: 45px;
}

.p-50 {
  padding: 50px;
}
.p-t-50 {
  padding-top: 50px;
}
.p-b-50 {
  padding-bottom: 50px;
}
.p-l-50 {
  padding-left: 50px;
}
.p-r-50 {
  padding-right: 50px;
}

.m-50 {
  margin: 50px;
}
.m-t-50 {
  margin-top: 50px;
}
.m-b-50 {
  margin-bottom: 50px;
}
.m-l-50 {
  margin-left: 50px;
}
.m-r-50 {
  margin-right: 50px;
}

/*====== Padding , Margin css ends ======*/
/*====== text-color, background color css starts ======*/
.bg-c-blue {
  background: #04a9f5;
}

.text-c-blue {
  color: #04a9f5;
}

.bg-c-red {
  background: #f44236;
}

.text-c-red {
  color: #f44236;
}

.bg-c-green {
  background: #1de9b6;
}

.text-c-green {
  color: #1de9b6;
}

.bg-c-yellow {
  background: #f4c22b;
}

.text-c-yellow {
  color: #f4c22b;
}

.bg-c-purple {
  background: #a389d4;
}

.text-c-purple {
  color: #a389d4;
}

/*====== text-color css ends ======*/
/*====== Card top border css starts ======*/
.card-border-c-blue {
  border-top: 4px solid #04a9f5;
}

.card-border-c-red {
  border-top: 4px solid #f44236;
}

.card-border-c-green {
  border-top: 4px solid #1de9b6;
}

.card-border-c-yellow {
  border-top: 4px solid #f4c22b;
}

.card-border-c-purple {
  border-top: 4px solid #a389d4;
}

/*====== Card top border ends ======*/
/*====== Font-size css starts ======*/
.f-10 {
  font-size: 10px;
}

.f-12 {
  font-size: 12px;
}

.f-14 {
  font-size: 14px;
}

.f-16 {
  font-size: 16px;
}

.f-18 {
  font-size: 18px;
}

.f-20 {
  font-size: 20px;
}

.f-22 {
  font-size: 22px;
}

.f-24 {
  font-size: 24px;
}

.f-26 {
  font-size: 26px;
}

.f-28 {
  font-size: 28px;
}

.f-30 {
  font-size: 30px;
}

.f-32 {
  font-size: 32px;
}

.f-34 {
  font-size: 34px;
}

.f-36 {
  font-size: 36px;
}

.f-38 {
  font-size: 38px;
}

.f-40 {
  font-size: 40px;
}

.f-42 {
  font-size: 42px;
}

.f-44 {
  font-size: 44px;
}

.f-46 {
  font-size: 46px;
}

.f-48 {
  font-size: 48px;
}

.f-50 {
  font-size: 50px;
}

.f-52 {
  font-size: 52px;
}

.f-54 {
  font-size: 54px;
}

.f-56 {
  font-size: 56px;
}

.f-58 {
  font-size: 58px;
}

.f-60 {
  font-size: 60px;
}

.f-62 {
  font-size: 62px;
}

.f-64 {
  font-size: 64px;
}

.f-66 {
  font-size: 66px;
}

.f-68 {
  font-size: 68px;
}

.f-70 {
  font-size: 70px;
}

.f-72 {
  font-size: 72px;
}

.f-74 {
  font-size: 74px;
}

.f-76 {
  font-size: 76px;
}

.f-78 {
  font-size: 78px;
}

.f-80 {
  font-size: 80px;
}

/*====== Font-size css ends ======*/
/*====== Font-weight css starts ======*/
.f-w-100 {
  font-weight: 100;
}

.f-w-200 {
  font-weight: 200;
}

.f-w-300 {
  font-weight: 300;
}

.f-w-400 {
  font-weight: 400;
}

.f-w-500 {
  font-weight: 500;
}

.f-w-600 {
  font-weight: 600;
}

.f-w-700 {
  font-weight: 700;
}

.f-w-800 {
  font-weight: 800;
}

.f-w-900 {
  font-weight: 900;
}

/*====== Font-weight css ends ======*/
/*====== width, Height css starts ======*/
.wid-20 {
  width: 20px;
}

.hei-20 {
  height: 20px;
}

.wid-25 {
  width: 25px;
}

.hei-25 {
  height: 25px;
}

.wid-30 {
  width: 30px;
}

.hei-30 {
  height: 30px;
}

.wid-35 {
  width: 35px;
}

.hei-35 {
  height: 35px;
}

.wid-40 {
  width: 40px;
}

.hei-40 {
  height: 40px;
}

.wid-45 {
  width: 45px;
}

.hei-45 {
  height: 45px;
}

.wid-50 {
  width: 50px;
}

.hei-50 {
  height: 50px;
}

.wid-55 {
  width: 55px;
}

.hei-55 {
  height: 55px;
}

.wid-60 {
  width: 60px;
}

.hei-60 {
  height: 60px;
}

.wid-65 {
  width: 65px;
}

.hei-65 {
  height: 65px;
}

.wid-70 {
  width: 70px;
}

.hei-70 {
  height: 70px;
}

.wid-75 {
  width: 75px;
}

.hei-75 {
  height: 75px;
}

.wid-80 {
  width: 80px;
}

.hei-80 {
  height: 80px;
}

.wid-85 {
  width: 85px;
}

.hei-85 {
  height: 85px;
}

.wid-90 {
  width: 90px;
}

.hei-90 {
  height: 90px;
}

.wid-95 {
  width: 95px;
}

.hei-95 {
  height: 95px;
}

.wid-100 {
  width: 100px;
}

.hei-100 {
  height: 100px;
}

.wid-105 {
  width: 105px;
}

.hei-105 {
  height: 105px;
}

.wid-110 {
  width: 110px;
}

.hei-110 {
  height: 110px;
}

.wid-115 {
  width: 115px;
}

.hei-115 {
  height: 115px;
}

.wid-120 {
  width: 120px;
}

.hei-120 {
  height: 120px;
}

.wid-125 {
  width: 125px;
}

.hei-125 {
  height: 125px;
}

.wid-130 {
  width: 130px;
}

.hei-130 {
  height: 130px;
}

.wid-135 {
  width: 135px;
}

.hei-135 {
  height: 135px;
}

.wid-140 {
  width: 140px;
}

.hei-140 {
  height: 140px;
}

.wid-145 {
  width: 145px;
}

.hei-145 {
  height: 145px;
}

.wid-150 {
  width: 150px;
}

.hei-150 {
  height: 150px;
}

/*====== width, Height css ends ======*/
@font-face {
  font-family: "pct";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
[data-icon]:before {
  font-family: "pct" !important;
  content: attr(data-icon);
  font-style: normal !important;
  font-weight: normal !important;
  font-variant: normal !important;
  text-transform: none !important;
  speak: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

[class^=pct-]:before,
[class*=" pct-"]:before {
  font-family: "pct" !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-variant: normal !important;
  text-transform: none !important;
  speak: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.pct-arrow1:before {
  content: "a";
}

.pct-arrow2:before {
  content: "b";
}

.pct-arrow3:before {
  content: "c";
}

.pct-arrow4:before {
  content: "d";
}

.pct-chat1:before {
  content: "e";
}

.pct-chat2:before {
  content: "f";
}

.pct-chat3:before {
  content: "g";
}

.pct-chat4:before {
  content: "h";
}

.pct-loader1:before {
  content: "i";
}

.pct-arrow-sharp1:before {
  content: "j";
}

.pct-arrow-sharp2:before {
  content: "k";
}

.pct-arrow-sharp3:before {
  content: "l";
}

.pct-arrow-sharp4:before {
  content: "m";
}

@font-face {
  font-family: "feather";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  /* IE9*/
  src: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format("svg");
  /* iOS 4.1- */
}
.feather {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "feather" !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-alert-octagon:before {
  content: "\\e81b";
}

.icon-alert-circle:before {
  content: "\\e81c";
}

.icon-activity:before {
  content: "\\e81d";
}

.icon-alert-triangle:before {
  content: "\\e81e";
}

.icon-align-center:before {
  content: "\\e81f";
}

.icon-airplay:before {
  content: "\\e820";
}

.icon-align-justify:before {
  content: "\\e821";
}

.icon-align-left:before {
  content: "\\e822";
}

.icon-align-right:before {
  content: "\\e823";
}

.icon-arrow-down-left:before {
  content: "\\e824";
}

.icon-arrow-down-right:before {
  content: "\\e825";
}

.icon-anchor:before {
  content: "\\e826";
}

.icon-aperture:before {
  content: "\\e827";
}

.icon-arrow-left:before {
  content: "\\e828";
}

.icon-arrow-right:before {
  content: "\\e829";
}

.icon-arrow-down:before {
  content: "\\e82a";
}

.icon-arrow-up-left:before {
  content: "\\e82b";
}

.icon-arrow-up-right:before {
  content: "\\e82c";
}

.icon-arrow-up:before {
  content: "\\e82d";
}

.icon-award:before {
  content: "\\e82e";
}

.icon-bar-chart:before {
  content: "\\e82f";
}

.icon-at-sign:before {
  content: "\\e830";
}

.icon-bar-chart-2:before {
  content: "\\e831";
}

.icon-battery-charging:before {
  content: "\\e832";
}

.icon-bell-off:before {
  content: "\\e833";
}

.icon-battery:before {
  content: "\\e834";
}

.icon-bluetooth:before {
  content: "\\e835";
}

.icon-bell:before {
  content: "\\e836";
}

.icon-book:before {
  content: "\\e837";
}

.icon-briefcase:before {
  content: "\\e838";
}

.icon-camera-off:before {
  content: "\\e839";
}

.icon-calendar:before {
  content: "\\e83a";
}

.icon-bookmark:before {
  content: "\\e83b";
}

.icon-box:before {
  content: "\\e83c";
}

.icon-camera:before {
  content: "\\e83d";
}

.icon-check-circle:before {
  content: "\\e83e";
}

.icon-check:before {
  content: "\\e83f";
}

.icon-check-square:before {
  content: "\\e840";
}

.icon-cast:before {
  content: "\\e841";
}

.icon-chevron-down:before {
  content: "\\e842";
}

.icon-chevron-left:before {
  content: "\\e843";
}

.icon-chevron-right:before {
  content: "\\e844";
}

.icon-chevron-up:before {
  content: "\\e845";
}

.icon-chevrons-down:before {
  content: "\\e846";
}

.icon-chevrons-right:before {
  content: "\\e847";
}

.icon-chevrons-up:before {
  content: "\\e848";
}

.icon-chevrons-left:before {
  content: "\\e849";
}

.icon-circle:before {
  content: "\\e84a";
}

.icon-clipboard:before {
  content: "\\e84b";
}

.icon-chrome:before {
  content: "\\e84c";
}

.icon-clock:before {
  content: "\\e84d";
}

.icon-cloud-lightning:before {
  content: "\\e84e";
}

.icon-cloud-drizzle:before {
  content: "\\e84f";
}

.icon-cloud-rain:before {
  content: "\\e850";
}

.icon-cloud-off:before {
  content: "\\e851";
}

.icon-codepen:before {
  content: "\\e852";
}

.icon-cloud-snow:before {
  content: "\\e853";
}

.icon-compass:before {
  content: "\\e854";
}

.icon-copy:before {
  content: "\\e855";
}

.icon-corner-down-right:before {
  content: "\\e856";
}

.icon-corner-down-left:before {
  content: "\\e857";
}

.icon-corner-left-down:before {
  content: "\\e858";
}

.icon-corner-left-up:before {
  content: "\\e859";
}

.icon-corner-up-left:before {
  content: "\\e85a";
}

.icon-corner-up-right:before {
  content: "\\e85b";
}

.icon-corner-right-down:before {
  content: "\\e85c";
}

.icon-corner-right-up:before {
  content: "\\e85d";
}

.icon-cpu:before {
  content: "\\e85e";
}

.icon-credit-card:before {
  content: "\\e85f";
}

.icon-crosshair:before {
  content: "\\e860";
}

.icon-disc:before {
  content: "\\e861";
}

.icon-delete:before {
  content: "\\e862";
}

.icon-download-cloud:before {
  content: "\\e863";
}

.icon-download:before {
  content: "\\e864";
}

.icon-droplet:before {
  content: "\\e865";
}

.icon-edit-2:before {
  content: "\\e866";
}

.icon-edit:before {
  content: "\\e867";
}

.icon-edit-1:before {
  content: "\\e868";
}

.icon-external-link:before {
  content: "\\e869";
}

.icon-eye:before {
  content: "\\e86a";
}

.icon-feather:before {
  content: "\\e86b";
}

.icon-facebook:before {
  content: "\\e86c";
}

.icon-file-minus:before {
  content: "\\e86d";
}

.icon-eye-off:before {
  content: "\\e86e";
}

.icon-fast-forward:before {
  content: "\\e86f";
}

.icon-file-text:before {
  content: "\\e870";
}

.icon-film:before {
  content: "\\e871";
}

.icon-file:before {
  content: "\\e872";
}

.icon-file-plus:before {
  content: "\\e873";
}

.icon-folder:before {
  content: "\\e874";
}

.icon-filter:before {
  content: "\\e875";
}

.icon-flag:before {
  content: "\\e876";
}

.icon-globe:before {
  content: "\\e877";
}

.icon-grid:before {
  content: "\\e878";
}

.icon-heart:before {
  content: "\\e879";
}

.icon-home:before {
  content: "\\e87a";
}

.icon-github:before {
  content: "\\e87b";
}

.icon-image:before {
  content: "\\e87c";
}

.icon-inbox:before {
  content: "\\e87d";
}

.icon-layers:before {
  content: "\\e87e";
}

.icon-info:before {
  content: "\\e87f";
}

.icon-instagram:before {
  content: "\\e880";
}

.icon-layout:before {
  content: "\\e881";
}

.icon-link-2:before {
  content: "\\e882";
}

.icon-life-buoy:before {
  content: "\\e883";
}

.icon-link:before {
  content: "\\e884";
}

.icon-log-in:before {
  content: "\\e885";
}

.icon-list:before {
  content: "\\e886";
}

.icon-lock:before {
  content: "\\e887";
}

.icon-log-out:before {
  content: "\\e888";
}

.icon-loader:before {
  content: "\\e889";
}

.icon-mail:before {
  content: "\\e88a";
}

.icon-maximize-2:before {
  content: "\\e88b";
}

.icon-map:before {
  content: "\\e88c";
}

.icon-map-pin:before {
  content: "\\e88e";
}

.icon-menu:before {
  content: "\\e88f";
}

.icon-message-circle:before {
  content: "\\e890";
}

.icon-message-square:before {
  content: "\\e891";
}

.icon-minimize-2:before {
  content: "\\e892";
}

.icon-mic-off:before {
  content: "\\e893";
}

.icon-minus-circle:before {
  content: "\\e894";
}

.icon-mic:before {
  content: "\\e895";
}

.icon-minus-square:before {
  content: "\\e896";
}

.icon-minus:before {
  content: "\\e897";
}

.icon-moon:before {
  content: "\\e898";
}

.icon-monitor:before {
  content: "\\e899";
}

.icon-more-vertical:before {
  content: "\\e89a";
}

.icon-more-horizontal:before {
  content: "\\e89b";
}

.icon-move:before {
  content: "\\e89c";
}

.icon-music:before {
  content: "\\e89d";
}

.icon-navigation-2:before {
  content: "\\e89e";
}

.icon-navigation:before {
  content: "\\e89f";
}

.icon-octagon:before {
  content: "\\e8a0";
}

.icon-package:before {
  content: "\\e8a1";
}

.icon-pause-circle:before {
  content: "\\e8a2";
}

.icon-pause:before {
  content: "\\e8a3";
}

.icon-percent:before {
  content: "\\e8a4";
}

.icon-phone-call:before {
  content: "\\e8a5";
}

.icon-phone-forwarded:before {
  content: "\\e8a6";
}

.icon-phone-missed:before {
  content: "\\e8a7";
}

.icon-phone-off:before {
  content: "\\e8a8";
}

.icon-phone-incoming:before {
  content: "\\e8a9";
}

.icon-phone:before {
  content: "\\e8aa";
}

.icon-phone-outgoing:before {
  content: "\\e8ab";
}

.icon-pie-chart:before {
  content: "\\e8ac";
}

.icon-play-circle:before {
  content: "\\e8ad";
}

.icon-play:before {
  content: "\\e8ae";
}

.icon-plus-square:before {
  content: "\\e8af";
}

.icon-plus-circle:before {
  content: "\\e8b0";
}

.icon-plus:before {
  content: "\\e8b1";
}

.icon-pocket:before {
  content: "\\e8b2";
}

.icon-printer:before {
  content: "\\e8b3";
}

.icon-power:before {
  content: "\\e8b4";
}

.icon-radio:before {
  content: "\\e8b5";
}

.icon-repeat:before {
  content: "\\e8b6";
}

.icon-refresh-ccw:before {
  content: "\\e8b7";
}

.icon-rewind:before {
  content: "\\e8b8";
}

.icon-rotate-ccw:before {
  content: "\\e8b9";
}

.icon-refresh-cw:before {
  content: "\\e8ba";
}

.icon-rotate-cw:before {
  content: "\\e8bb";
}

.icon-save:before {
  content: "\\e8bc";
}

.icon-search:before {
  content: "\\e8bd";
}

.icon-server:before {
  content: "\\e8be";
}

.icon-scissors:before {
  content: "\\e8bf";
}

.icon-share-2:before {
  content: "\\e8c0";
}

.icon-share:before {
  content: "\\e8c1";
}

.icon-shield:before {
  content: "\\e8c2";
}

.icon-settings:before {
  content: "\\e8c3";
}

.icon-skip-back:before {
  content: "\\e8c4";
}

.icon-shuffle:before {
  content: "\\e8c5";
}

.icon-sidebar:before {
  content: "\\e8c6";
}

.icon-skip-forward:before {
  content: "\\e8c7";
}

.icon-slack:before {
  content: "\\e8c8";
}

.icon-slash:before {
  content: "\\e8c9";
}

.icon-smartphone:before {
  content: "\\e8ca";
}

.icon-square:before {
  content: "\\e8cb";
}

.icon-speaker:before {
  content: "\\e8cc";
}

.icon-star:before {
  content: "\\e8cd";
}

.icon-stop-circle:before {
  content: "\\e8ce";
}

.icon-sun:before {
  content: "\\e8cf";
}

.icon-sunrise:before {
  content: "\\e8d0";
}

.icon-tablet:before {
  content: "\\e8d1";
}

.icon-tag:before {
  content: "\\e8d2";
}

.icon-sunset:before {
  content: "\\e8d3";
}

.icon-target:before {
  content: "\\e8d4";
}

.icon-thermometer:before {
  content: "\\e8d5";
}

.icon-thumbs-up:before {
  content: "\\e8d6";
}

.icon-thumbs-down:before {
  content: "\\e8d7";
}

.icon-toggle-left:before {
  content: "\\e8d8";
}

.icon-toggle-right:before {
  content: "\\e8d9";
}

.icon-trash-2:before {
  content: "\\e8da";
}

.icon-trash:before {
  content: "\\e8db";
}

.icon-trending-up:before {
  content: "\\e8dc";
}

.icon-trending-down:before {
  content: "\\e8dd";
}

.icon-triangle:before {
  content: "\\e8de";
}

.icon-type:before {
  content: "\\e8df";
}

.icon-twitter:before {
  content: "\\e8e0";
}

.icon-upload:before {
  content: "\\e8e1";
}

.icon-umbrella:before {
  content: "\\e8e2";
}

.icon-upload-cloud:before {
  content: "\\e8e3";
}

.icon-unlock:before {
  content: "\\e8e4";
}

.icon-user-check:before {
  content: "\\e8e5";
}

.icon-user-minus:before {
  content: "\\e8e6";
}

.icon-user-plus:before {
  content: "\\e8e7";
}

.icon-user-x:before {
  content: "\\e8e8";
}

.icon-user:before {
  content: "\\e8e9";
}

.icon-users:before {
  content: "\\e8ea";
}

.icon-video-off:before {
  content: "\\e8eb";
}

.icon-video:before {
  content: "\\e8ec";
}

.icon-voicemail:before {
  content: "\\e8ed";
}

.icon-volume-x:before {
  content: "\\e8ee";
}

.icon-volume-2:before {
  content: "\\e8ef";
}

.icon-volume-1:before {
  content: "\\e8f0";
}

.icon-volume:before {
  content: "\\e8f1";
}

.icon-watch:before {
  content: "\\e8f2";
}

.icon-wifi:before {
  content: "\\e8f3";
}

.icon-x-square:before {
  content: "\\e8f4";
}

.icon-wind:before {
  content: "\\e8f5";
}

.icon-x:before {
  content: "\\e8f6";
}

.icon-x-circle:before {
  content: "\\e8f7";
}

.icon-zap:before {
  content: "\\e8f8";
}

.icon-zoom-in:before {
  content: "\\e8f9";
}

.icon-zoom-out:before {
  content: "\\e8fa";
}

.icon-command:before {
  content: "\\e8fb";
}

.icon-cloud:before {
  content: "\\e8fc";
}

.icon-hash:before {
  content: "\\e8fd";
}

.icon-headphones:before {
  content: "\\e8fe";
}

.icon-underline:before {
  content: "\\e8ff";
}

.icon-italic:before {
  content: "\\e900";
}

.icon-bold:before {
  content: "\\e901";
}

.icon-crop:before {
  content: "\\e902";
}

.icon-help-circle:before {
  content: "\\e903";
}

.icon-paperclip:before {
  content: "\\e904";
}

.icon-shopping-cart:before {
  content: "\\e905";
}

.icon-tv:before {
  content: "\\e906";
}

.icon-wifi-off:before {
  content: "\\e907";
}

.icon-minimize:before {
  content: "\\e88d";
}

.icon-maximize:before {
  content: "\\e908";
}

.icon-gitlab:before {
  content: "\\e909";
}

.icon-sliders:before {
  content: "\\e90a";
}

.icon-star-on:before {
  content: "\\e90b";
}

.icon-heart-on:before {
  content: "\\e90c";
}

.fa,
.fab,
.fal,
.far,
.fas {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
}

.fa-lg {
  font-size: 1.33333em;
  line-height: 0.75em;
  vertical-align: -0.0667em;
}

.fa-xs {
  font-size: 0.75em;
}

.fa-sm {
  font-size: 0.875em;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: 2.5em;
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: -2em;
  position: absolute;
  text-align: center;
  width: 2em;
  line-height: inherit;
}

.fa-border {
  border: 0.08em solid #eee;
  border-radius: 0.1em;
  padding: 0.2em 0.25em 0.15em;
}

.fa-pull-left {
  float: left;
}

.fa-pull-right {
  float: right;
}

.fa.fa-pull-left,
.fab.fa-pull-left,
.fal.fa-pull-left,
.far.fa-pull-left,
.fas.fa-pull-left {
  margin-right: 0.3em;
}

.fa.fa-pull-right,
.fab.fa-pull-right,
.fal.fa-pull-right,
.far.fa-pull-right,
.fas.fa-pull-right {
  margin-left: 0.3em;
}

.fa-spin {
  animation: fa-spin 2s infinite linear;
}

.fa-pulse {
  animation: fa-spin 1s infinite steps(8);
}

@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(1turn);
  }
}
.fa-rotate-90 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";
  transform: rotate(90deg);
}

.fa-rotate-180 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";
  transform: rotate(180deg);
}

.fa-rotate-270 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";
  transform: scaleX(-1);
}

.fa-flip-vertical {
  transform: scaleY(-1);
}

.fa-flip-horizontal.fa-flip-vertical,
.fa-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
}

.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1);
}

:root .fa-flip-horizontal,
:root .fa-flip-vertical,
:root .fa-rotate-90,
:root .fa-rotate-180,
:root .fa-rotate-270 {
  filter: none;
}

.fa-stack {
  display: inline-block;
  height: 2em;
  line-height: 2em;
  position: relative;
  vertical-align: middle;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  left: 0;
  position: absolute;
  text-align: center;
  width: 100%;
}

.fa-stack-1x {
  line-height: inherit;
}

.fa-stack-2x {
  font-size: 2em;
}

.fa-inverse {
  color: #fff;
}

.fa-500px:before {
  content: "\\f26e";
}

.fa-accessible-icon:before {
  content: "\\f368";
}

.fa-accusoft:before {
  content: "\\f369";
}

.fa-acquisitions-incorporated:before {
  content: "\\f6af";
}

.fa-ad:before {
  content: "\\f641";
}

.fa-address-book:before {
  content: "\\f2b9";
}

.fa-address-card:before {
  content: "\\f2bb";
}

.fa-adjust:before {
  content: "\\f042";
}

.fa-adn:before {
  content: "\\f170";
}

.fa-adobe:before {
  content: "\\f778";
}

.fa-adversal:before {
  content: "\\f36a";
}

.fa-affiliatetheme:before {
  content: "\\f36b";
}

.fa-air-freshener:before {
  content: "\\f5d0";
}

.fa-algolia:before {
  content: "\\f36c";
}

.fa-align-center:before {
  content: "\\f037";
}

.fa-align-justify:before {
  content: "\\f039";
}

.fa-align-left:before {
  content: "\\f036";
}

.fa-align-right:before {
  content: "\\f038";
}

.fa-alipay:before {
  content: "\\f642";
}

.fa-allergies:before {
  content: "\\f461";
}

.fa-amazon:before {
  content: "\\f270";
}

.fa-amazon-pay:before {
  content: "\\f42c";
}

.fa-ambulance:before {
  content: "\\f0f9";
}

.fa-american-sign-language-interpreting:before {
  content: "\\f2a3";
}

.fa-amilia:before {
  content: "\\f36d";
}

.fa-anchor:before {
  content: "\\f13d";
}

.fa-android:before {
  content: "\\f17b";
}

.fa-angellist:before {
  content: "\\f209";
}

.fa-angle-double-down:before {
  content: "\\f103";
}

.fa-angle-double-left:before {
  content: "\\f100";
}

.fa-angle-double-right:before {
  content: "\\f101";
}

.fa-angle-double-up:before {
  content: "\\f102";
}

.fa-angle-down:before {
  content: "\\f107";
}

.fa-angle-left:before {
  content: "\\f104";
}

.fa-angle-right:before {
  content: "\\f105";
}

.fa-angle-up:before {
  content: "\\f106";
}

.fa-angry:before {
  content: "\\f556";
}

.fa-angrycreative:before {
  content: "\\f36e";
}

.fa-angular:before {
  content: "\\f420";
}

.fa-ankh:before {
  content: "\\f644";
}

.fa-app-store:before {
  content: "\\f36f";
}

.fa-app-store-ios:before {
  content: "\\f370";
}

.fa-apper:before {
  content: "\\f371";
}

.fa-apple:before {
  content: "\\f179";
}

.fa-apple-alt:before {
  content: "\\f5d1";
}

.fa-apple-pay:before {
  content: "\\f415";
}

.fa-archive:before {
  content: "\\f187";
}

.fa-archway:before {
  content: "\\f557";
}

.fa-arrow-alt-circle-down:before {
  content: "\\f358";
}

.fa-arrow-alt-circle-left:before {
  content: "\\f359";
}

.fa-arrow-alt-circle-right:before {
  content: "\\f35a";
}

.fa-arrow-alt-circle-up:before {
  content: "\\f35b";
}

.fa-arrow-circle-down:before {
  content: "\\f0ab";
}

.fa-arrow-circle-left:before {
  content: "\\f0a8";
}

.fa-arrow-circle-right:before {
  content: "\\f0a9";
}

.fa-arrow-circle-up:before {
  content: "\\f0aa";
}

.fa-arrow-down:before {
  content: "\\f063";
}

.fa-arrow-left:before {
  content: "\\f060";
}

.fa-arrow-right:before {
  content: "\\f061";
}

.fa-arrow-up:before {
  content: "\\f062";
}

.fa-arrows-alt:before {
  content: "\\f0b2";
}

.fa-arrows-alt-h:before {
  content: "\\f337";
}

.fa-arrows-alt-v:before {
  content: "\\f338";
}

.fa-artstation:before {
  content: "\\f77a";
}

.fa-assistive-listening-systems:before {
  content: "\\f2a2";
}

.fa-asterisk:before {
  content: "\\f069";
}

.fa-asymmetrik:before {
  content: "\\f372";
}

.fa-at:before {
  content: "\\f1fa";
}

.fa-atlas:before {
  content: "\\f558";
}

.fa-atlassian:before {
  content: "\\f77b";
}

.fa-atom:before {
  content: "\\f5d2";
}

.fa-audible:before {
  content: "\\f373";
}

.fa-audio-description:before {
  content: "\\f29e";
}

.fa-autoprefixer:before {
  content: "\\f41c";
}

.fa-avianex:before {
  content: "\\f374";
}

.fa-aviato:before {
  content: "\\f421";
}

.fa-award:before {
  content: "\\f559";
}

.fa-aws:before {
  content: "\\f375";
}

.fa-baby:before {
  content: "\\f77c";
}

.fa-baby-carriage:before {
  content: "\\f77d";
}

.fa-backspace:before {
  content: "\\f55a";
}

.fa-backward:before {
  content: "\\f04a";
}

.fa-balance-scale:before {
  content: "\\f24e";
}

.fa-ban:before {
  content: "\\f05e";
}

.fa-band-aid:before {
  content: "\\f462";
}

.fa-bandcamp:before {
  content: "\\f2d5";
}

.fa-barcode:before {
  content: "\\f02a";
}

.fa-bars:before {
  content: "\\f0c9";
}

.fa-baseball-ball:before {
  content: "\\f433";
}

.fa-basketball-ball:before {
  content: "\\f434";
}

.fa-bath:before {
  content: "\\f2cd";
}

.fa-battery-empty:before {
  content: "\\f244";
}

.fa-battery-full:before {
  content: "\\f240";
}

.fa-battery-half:before {
  content: "\\f242";
}

.fa-battery-quarter:before {
  content: "\\f243";
}

.fa-battery-three-quarters:before {
  content: "\\f241";
}

.fa-bed:before {
  content: "\\f236";
}

.fa-beer:before {
  content: "\\f0fc";
}

.fa-behance:before {
  content: "\\f1b4";
}

.fa-behance-square:before {
  content: "\\f1b5";
}

.fa-bell:before {
  content: "\\f0f3";
}

.fa-bell-slash:before {
  content: "\\f1f6";
}

.fa-bezier-curve:before {
  content: "\\f55b";
}

.fa-bible:before {
  content: "\\f647";
}

.fa-bicycle:before {
  content: "\\f206";
}

.fa-bimobject:before {
  content: "\\f378";
}

.fa-binoculars:before {
  content: "\\f1e5";
}

.fa-biohazard:before {
  content: "\\f780";
}

.fa-birthday-cake:before {
  content: "\\f1fd";
}

.fa-bitbucket:before {
  content: "\\f171";
}

.fa-bitcoin:before {
  content: "\\f379";
}

.fa-bity:before {
  content: "\\f37a";
}

.fa-black-tie:before {
  content: "\\f27e";
}

.fa-blackberry:before {
  content: "\\f37b";
}

.fa-blender:before {
  content: "\\f517";
}

.fa-blender-phone:before {
  content: "\\f6b6";
}

.fa-blind:before {
  content: "\\f29d";
}

.fa-blog:before {
  content: "\\f781";
}

.fa-blogger:before {
  content: "\\f37c";
}

.fa-blogger-b:before {
  content: "\\f37d";
}

.fa-bluetooth:before {
  content: "\\f293";
}

.fa-bluetooth-b:before {
  content: "\\f294";
}

.fa-bold:before {
  content: "\\f032";
}

.fa-bolt:before {
  content: "\\f0e7";
}

.fa-bomb:before {
  content: "\\f1e2";
}

.fa-bone:before {
  content: "\\f5d7";
}

.fa-bong:before {
  content: "\\f55c";
}

.fa-book:before {
  content: "\\f02d";
}

.fa-book-dead:before {
  content: "\\f6b7";
}

.fa-book-open:before {
  content: "\\f518";
}

.fa-book-reader:before {
  content: "\\f5da";
}

.fa-bookmark:before {
  content: "\\f02e";
}

.fa-bowling-ball:before {
  content: "\\f436";
}

.fa-box:before {
  content: "\\f466";
}

.fa-box-open:before {
  content: "\\f49e";
}

.fa-boxes:before {
  content: "\\f468";
}

.fa-braille:before {
  content: "\\f2a1";
}

.fa-brain:before {
  content: "\\f5dc";
}

.fa-briefcase:before {
  content: "\\f0b1";
}

.fa-briefcase-medical:before {
  content: "\\f469";
}

.fa-broadcast-tower:before {
  content: "\\f519";
}

.fa-broom:before {
  content: "\\f51a";
}

.fa-brush:before {
  content: "\\f55d";
}

.fa-btc:before {
  content: "\\f15a";
}

.fa-bug:before {
  content: "\\f188";
}

.fa-building:before {
  content: "\\f1ad";
}

.fa-bullhorn:before {
  content: "\\f0a1";
}

.fa-bullseye:before {
  content: "\\f140";
}

.fa-burn:before {
  content: "\\f46a";
}

.fa-buromobelexperte:before {
  content: "\\f37f";
}

.fa-bus:before {
  content: "\\f207";
}

.fa-bus-alt:before {
  content: "\\f55e";
}

.fa-business-time:before {
  content: "\\f64a";
}

.fa-buysellads:before {
  content: "\\f20d";
}

.fa-calculator:before {
  content: "\\f1ec";
}

.fa-calendar:before {
  content: "\\f133";
}

.fa-calendar-alt:before {
  content: "\\f073";
}

.fa-calendar-check:before {
  content: "\\f274";
}

.fa-calendar-day:before {
  content: "\\f783";
}

.fa-calendar-minus:before {
  content: "\\f272";
}

.fa-calendar-plus:before {
  content: "\\f271";
}

.fa-calendar-times:before {
  content: "\\f273";
}

.fa-calendar-week:before {
  content: "\\f784";
}

.fa-camera:before {
  content: "\\f030";
}

.fa-camera-retro:before {
  content: "\\f083";
}

.fa-campground:before {
  content: "\\f6bb";
}

.fa-canadian-maple-leaf:before {
  content: "\\f785";
}

.fa-candy-cane:before {
  content: "\\f786";
}

.fa-cannabis:before {
  content: "\\f55f";
}

.fa-capsules:before {
  content: "\\f46b";
}

.fa-car:before {
  content: "\\f1b9";
}

.fa-car-alt:before {
  content: "\\f5de";
}

.fa-car-battery:before {
  content: "\\f5df";
}

.fa-car-crash:before {
  content: "\\f5e1";
}

.fa-car-side:before {
  content: "\\f5e4";
}

.fa-caret-down:before {
  content: "\\f0d7";
}

.fa-caret-left:before {
  content: "\\f0d9";
}

.fa-caret-right:before {
  content: "\\f0da";
}

.fa-caret-square-down:before {
  content: "\\f150";
}

.fa-caret-square-left:before {
  content: "\\f191";
}

.fa-caret-square-right:before {
  content: "\\f152";
}

.fa-caret-square-up:before {
  content: "\\f151";
}

.fa-caret-up:before {
  content: "\\f0d8";
}

.fa-carrot:before {
  content: "\\f787";
}

.fa-cart-arrow-down:before {
  content: "\\f218";
}

.fa-cart-plus:before {
  content: "\\f217";
}

.fa-cash-register:before {
  content: "\\f788";
}

.fa-cat:before {
  content: "\\f6be";
}

.fa-cc-amazon-pay:before {
  content: "\\f42d";
}

.fa-cc-amex:before {
  content: "\\f1f3";
}

.fa-cc-apple-pay:before {
  content: "\\f416";
}

.fa-cc-diners-club:before {
  content: "\\f24c";
}

.fa-cc-discover:before {
  content: "\\f1f2";
}

.fa-cc-jcb:before {
  content: "\\f24b";
}

.fa-cc-mastercard:before {
  content: "\\f1f1";
}

.fa-cc-paypal:before {
  content: "\\f1f4";
}

.fa-cc-stripe:before {
  content: "\\f1f5";
}

.fa-cc-visa:before {
  content: "\\f1f0";
}

.fa-centercode:before {
  content: "\\f380";
}

.fa-centos:before {
  content: "\\f789";
}

.fa-certificate:before {
  content: "\\f0a3";
}

.fa-chair:before {
  content: "\\f6c0";
}

.fa-chalkboard:before {
  content: "\\f51b";
}

.fa-chalkboard-teacher:before {
  content: "\\f51c";
}

.fa-charging-station:before {
  content: "\\f5e7";
}

.fa-chart-area:before {
  content: "\\f1fe";
}

.fa-chart-bar:before {
  content: "\\f080";
}

.fa-chart-line:before {
  content: "\\f201";
}

.fa-chart-pie:before {
  content: "\\f200";
}

.fa-check:before {
  content: "\\f00c";
}

.fa-check-circle:before {
  content: "\\f058";
}

.fa-check-double:before {
  content: "\\f560";
}

.fa-check-square:before {
  content: "\\f14a";
}

.fa-chess:before {
  content: "\\f439";
}

.fa-chess-bishop:before {
  content: "\\f43a";
}

.fa-chess-board:before {
  content: "\\f43c";
}

.fa-chess-king:before {
  content: "\\f43f";
}

.fa-chess-knight:before {
  content: "\\f441";
}

.fa-chess-pawn:before {
  content: "\\f443";
}

.fa-chess-queen:before {
  content: "\\f445";
}

.fa-chess-rook:before {
  content: "\\f447";
}

.fa-chevron-circle-down:before {
  content: "\\f13a";
}

.fa-chevron-circle-left:before {
  content: "\\f137";
}

.fa-chevron-circle-right:before {
  content: "\\f138";
}

.fa-chevron-circle-up:before {
  content: "\\f139";
}

.fa-chevron-down:before {
  content: "\\f078";
}

.fa-chevron-left:before {
  content: "\\f053";
}

.fa-chevron-right:before {
  content: "\\f054";
}

.fa-chevron-up:before {
  content: "\\f077";
}

.fa-child:before {
  content: "\\f1ae";
}

.fa-chrome:before {
  content: "\\f268";
}

.fa-church:before {
  content: "\\f51d";
}

.fa-circle:before {
  content: "\\f111";
}

.fa-circle-notch:before {
  content: "\\f1ce";
}

.fa-city:before {
  content: "\\f64f";
}

.fa-clipboard:before {
  content: "\\f328";
}

.fa-clipboard-check:before {
  content: "\\f46c";
}

.fa-clipboard-list:before {
  content: "\\f46d";
}

.fa-clock:before {
  content: "\\f017";
}

.fa-clone:before {
  content: "\\f24d";
}

.fa-closed-captioning:before {
  content: "\\f20a";
}

.fa-cloud:before {
  content: "\\f0c2";
}

.fa-cloud-download-alt:before {
  content: "\\f381";
}

.fa-cloud-meatball:before {
  content: "\\f73b";
}

.fa-cloud-moon:before {
  content: "\\f6c3";
}

.fa-cloud-moon-rain:before {
  content: "\\f73c";
}

.fa-cloud-rain:before {
  content: "\\f73d";
}

.fa-cloud-showers-heavy:before {
  content: "\\f740";
}

.fa-cloud-sun:before {
  content: "\\f6c4";
}

.fa-cloud-sun-rain:before {
  content: "\\f743";
}

.fa-cloud-upload-alt:before {
  content: "\\f382";
}

.fa-cloudscale:before {
  content: "\\f383";
}

.fa-cloudsmith:before {
  content: "\\f384";
}

.fa-cloudversify:before {
  content: "\\f385";
}

.fa-cocktail:before {
  content: "\\f561";
}

.fa-code:before {
  content: "\\f121";
}

.fa-code-branch:before {
  content: "\\f126";
}

.fa-codepen:before {
  content: "\\f1cb";
}

.fa-codiepie:before {
  content: "\\f284";
}

.fa-coffee:before {
  content: "\\f0f4";
}

.fa-cog:before {
  content: "\\f013";
}

.fa-cogs:before {
  content: "\\f085";
}

.fa-coins:before {
  content: "\\f51e";
}

.fa-columns:before {
  content: "\\f0db";
}

.fa-comment:before {
  content: "\\f075";
}

.fa-comment-alt:before {
  content: "\\f27a";
}

.fa-comment-dollar:before {
  content: "\\f651";
}

.fa-comment-dots:before {
  content: "\\f4ad";
}

.fa-comment-slash:before {
  content: "\\f4b3";
}

.fa-comments:before {
  content: "\\f086";
}

.fa-comments-dollar:before {
  content: "\\f653";
}

.fa-compact-disc:before {
  content: "\\f51f";
}

.fa-compass:before {
  content: "\\f14e";
}

.fa-compress:before {
  content: "\\f066";
}

.fa-compress-arrows-alt:before {
  content: "\\f78c";
}

.fa-concierge-bell:before {
  content: "\\f562";
}

.fa-confluence:before {
  content: "\\f78d";
}

.fa-connectdevelop:before {
  content: "\\f20e";
}

.fa-contao:before {
  content: "\\f26d";
}

.fa-cookie:before {
  content: "\\f563";
}

.fa-cookie-bite:before {
  content: "\\f564";
}

.fa-copy:before {
  content: "\\f0c5";
}

.fa-copyright:before {
  content: "\\f1f9";
}

.fa-couch:before {
  content: "\\f4b8";
}

.fa-cpanel:before {
  content: "\\f388";
}

.fa-creative-commons:before {
  content: "\\f25e";
}

.fa-creative-commons-by:before {
  content: "\\f4e7";
}

.fa-creative-commons-nc:before {
  content: "\\f4e8";
}

.fa-creative-commons-nc-eu:before {
  content: "\\f4e9";
}

.fa-creative-commons-nc-jp:before {
  content: "\\f4ea";
}

.fa-creative-commons-nd:before {
  content: "\\f4eb";
}

.fa-creative-commons-pd:before {
  content: "\\f4ec";
}

.fa-creative-commons-pd-alt:before {
  content: "\\f4ed";
}

.fa-creative-commons-remix:before {
  content: "\\f4ee";
}

.fa-creative-commons-sa:before {
  content: "\\f4ef";
}

.fa-creative-commons-sampling:before {
  content: "\\f4f0";
}

.fa-creative-commons-sampling-plus:before {
  content: "\\f4f1";
}

.fa-creative-commons-share:before {
  content: "\\f4f2";
}

.fa-creative-commons-zero:before {
  content: "\\f4f3";
}

.fa-credit-card:before {
  content: "\\f09d";
}

.fa-critical-role:before {
  content: "\\f6c9";
}

.fa-crop:before {
  content: "\\f125";
}

.fa-crop-alt:before {
  content: "\\f565";
}

.fa-cross:before {
  content: "\\f654";
}

.fa-crosshairs:before {
  content: "\\f05b";
}

.fa-crow:before {
  content: "\\f520";
}

.fa-crown:before {
  content: "\\f521";
}

.fa-css3:before {
  content: "\\f13c";
}

.fa-css3-alt:before {
  content: "\\f38b";
}

.fa-cube:before {
  content: "\\f1b2";
}

.fa-cubes:before {
  content: "\\f1b3";
}

.fa-cut:before {
  content: "\\f0c4";
}

.fa-cuttlefish:before {
  content: "\\f38c";
}

.fa-d-and-d:before {
  content: "\\f38d";
}

.fa-d-and-d-beyond:before {
  content: "\\f6ca";
}

.fa-dashcube:before {
  content: "\\f210";
}

.fa-database:before {
  content: "\\f1c0";
}

.fa-deaf:before {
  content: "\\f2a4";
}

.fa-delicious:before {
  content: "\\f1a5";
}

.fa-democrat:before {
  content: "\\f747";
}

.fa-deploydog:before {
  content: "\\f38e";
}

.fa-deskpro:before {
  content: "\\f38f";
}

.fa-desktop:before {
  content: "\\f108";
}

.fa-dev:before {
  content: "\\f6cc";
}

.fa-deviantart:before {
  content: "\\f1bd";
}

.fa-dharmachakra:before {
  content: "\\f655";
}

.fa-dhl:before {
  content: "\\f790";
}

.fa-diagnoses:before {
  content: "\\f470";
}

.fa-diaspora:before {
  content: "\\f791";
}

.fa-dice:before {
  content: "\\f522";
}

.fa-dice-d20:before {
  content: "\\f6cf";
}

.fa-dice-d6:before {
  content: "\\f6d1";
}

.fa-dice-five:before {
  content: "\\f523";
}

.fa-dice-four:before {
  content: "\\f524";
}

.fa-dice-one:before {
  content: "\\f525";
}

.fa-dice-six:before {
  content: "\\f526";
}

.fa-dice-three:before {
  content: "\\f527";
}

.fa-dice-two:before {
  content: "\\f528";
}

.fa-digg:before {
  content: "\\f1a6";
}

.fa-digital-ocean:before {
  content: "\\f391";
}

.fa-digital-tachograph:before {
  content: "\\f566";
}

.fa-directions:before {
  content: "\\f5eb";
}

.fa-discord:before {
  content: "\\f392";
}

.fa-discourse:before {
  content: "\\f393";
}

.fa-divide:before {
  content: "\\f529";
}

.fa-dizzy:before {
  content: "\\f567";
}

.fa-dna:before {
  content: "\\f471";
}

.fa-dochub:before {
  content: "\\f394";
}

.fa-docker:before {
  content: "\\f395";
}

.fa-dog:before {
  content: "\\f6d3";
}

.fa-dollar-sign:before {
  content: "\\f155";
}

.fa-dolly:before {
  content: "\\f472";
}

.fa-dolly-flatbed:before {
  content: "\\f474";
}

.fa-donate:before {
  content: "\\f4b9";
}

.fa-door-closed:before {
  content: "\\f52a";
}

.fa-door-open:before {
  content: "\\f52b";
}

.fa-dot-circle:before {
  content: "\\f192";
}

.fa-dove:before {
  content: "\\f4ba";
}

.fa-download:before {
  content: "\\f019";
}

.fa-draft2digital:before {
  content: "\\f396";
}

.fa-drafting-compass:before {
  content: "\\f568";
}

.fa-dragon:before {
  content: "\\f6d5";
}

.fa-draw-polygon:before {
  content: "\\f5ee";
}

.fa-dribbble:before {
  content: "\\f17d";
}

.fa-dribbble-square:before {
  content: "\\f397";
}

.fa-dropbox:before {
  content: "\\f16b";
}

.fa-drum:before {
  content: "\\f569";
}

.fa-drum-steelpan:before {
  content: "\\f56a";
}

.fa-drumstick-bite:before {
  content: "\\f6d7";
}

.fa-drupal:before {
  content: "\\f1a9";
}

.fa-dumbbell:before {
  content: "\\f44b";
}

.fa-dumpster:before {
  content: "\\f793";
}

.fa-dumpster-fire:before {
  content: "\\f794";
}

.fa-dungeon:before {
  content: "\\f6d9";
}

.fa-dyalog:before {
  content: "\\f399";
}

.fa-earlybirds:before {
  content: "\\f39a";
}

.fa-ebay:before {
  content: "\\f4f4";
}

.fa-edge:before {
  content: "\\f282";
}

.fa-edit:before {
  content: "\\f044";
}

.fa-eject:before {
  content: "\\f052";
}

.fa-elementor:before {
  content: "\\f430";
}

.fa-ellipsis-h:before {
  content: "\\f141";
}

.fa-ellipsis-v:before {
  content: "\\f142";
}

.fa-ello:before {
  content: "\\f5f1";
}

.fa-ember:before {
  content: "\\f423";
}

.fa-empire:before {
  content: "\\f1d1";
}

.fa-envelope:before {
  content: "\\f0e0";
}

.fa-envelope-open:before {
  content: "\\f2b6";
}

.fa-envelope-open-text:before {
  content: "\\f658";
}

.fa-envelope-square:before {
  content: "\\f199";
}

.fa-envira:before {
  content: "\\f299";
}

.fa-equals:before {
  content: "\\f52c";
}

.fa-eraser:before {
  content: "\\f12d";
}

.fa-erlang:before {
  content: "\\f39d";
}

.fa-ethereum:before {
  content: "\\f42e";
}

.fa-ethernet:before {
  content: "\\f796";
}

.fa-etsy:before {
  content: "\\f2d7";
}

.fa-euro-sign:before {
  content: "\\f153";
}

.fa-exchange-alt:before {
  content: "\\f362";
}

.fa-exclamation:before {
  content: "\\f12a";
}

.fa-exclamation-circle:before {
  content: "\\f06a";
}

.fa-exclamation-triangle:before {
  content: "\\f071";
}

.fa-expand:before {
  content: "\\f065";
}

.fa-expand-arrows-alt:before {
  content: "\\f31e";
}

.fa-expeditedssl:before {
  content: "\\f23e";
}

.fa-external-link-alt:before {
  content: "\\f35d";
}

.fa-external-link-square-alt:before {
  content: "\\f360";
}

.fa-eye:before {
  content: "\\f06e";
}

.fa-eye-dropper:before {
  content: "\\f1fb";
}

.fa-eye-slash:before {
  content: "\\f070";
}

.fa-facebook:before {
  content: "\\f09a";
}

.fa-facebook-f:before {
  content: "\\f39e";
}

.fa-facebook-messenger:before {
  content: "\\f39f";
}

.fa-facebook-square:before {
  content: "\\f082";
}

.fa-fantasy-flight-games:before {
  content: "\\f6dc";
}

.fa-fast-backward:before {
  content: "\\f049";
}

.fa-fast-forward:before {
  content: "\\f050";
}

.fa-fax:before {
  content: "\\f1ac";
}

.fa-feather:before {
  content: "\\f52d";
}

.fa-feather-alt:before {
  content: "\\f56b";
}

.fa-fedex:before {
  content: "\\f797";
}

.fa-fedora:before {
  content: "\\f798";
}

.fa-female:before {
  content: "\\f182";
}

.fa-fighter-jet:before {
  content: "\\f0fb";
}

.fa-figma:before {
  content: "\\f799";
}

.fa-file:before {
  content: "\\f15b";
}

.fa-file-alt:before {
  content: "\\f15c";
}

.fa-file-archive:before {
  content: "\\f1c6";
}

.fa-file-audio:before {
  content: "\\f1c7";
}

.fa-file-code:before {
  content: "\\f1c9";
}

.fa-file-contract:before {
  content: "\\f56c";
}

.fa-file-csv:before {
  content: "\\f6dd";
}

.fa-file-download:before {
  content: "\\f56d";
}

.fa-file-excel:before {
  content: "\\f1c3";
}

.fa-file-export:before {
  content: "\\f56e";
}

.fa-file-image:before {
  content: "\\f1c5";
}

.fa-file-import:before {
  content: "\\f56f";
}

.fa-file-invoice:before {
  content: "\\f570";
}

.fa-file-invoice-dollar:before {
  content: "\\f571";
}

.fa-file-medical:before {
  content: "\\f477";
}

.fa-file-medical-alt:before {
  content: "\\f478";
}

.fa-file-pdf:before {
  content: "\\f1c1";
}

.fa-file-powerpoint:before {
  content: "\\f1c4";
}

.fa-file-prescription:before {
  content: "\\f572";
}

.fa-file-signature:before {
  content: "\\f573";
}

.fa-file-upload:before {
  content: "\\f574";
}

.fa-file-video:before {
  content: "\\f1c8";
}

.fa-file-word:before {
  content: "\\f1c2";
}

.fa-fill:before {
  content: "\\f575";
}

.fa-fill-drip:before {
  content: "\\f576";
}

.fa-film:before {
  content: "\\f008";
}

.fa-filter:before {
  content: "\\f0b0";
}

.fa-fingerprint:before {
  content: "\\f577";
}

.fa-fire:before {
  content: "\\f06d";
}

.fa-fire-alt:before {
  content: "\\f7e4";
}

.fa-fire-extinguisher:before {
  content: "\\f134";
}

.fa-firefox:before {
  content: "\\f269";
}

.fa-first-aid:before {
  content: "\\f479";
}

.fa-first-order:before {
  content: "\\f2b0";
}

.fa-first-order-alt:before {
  content: "\\f50a";
}

.fa-firstdraft:before {
  content: "\\f3a1";
}

.fa-fish:before {
  content: "\\f578";
}

.fa-fist-raised:before {
  content: "\\f6de";
}

.fa-flag:before {
  content: "\\f024";
}

.fa-flag-checkered:before {
  content: "\\f11e";
}

.fa-flag-usa:before {
  content: "\\f74d";
}

.fa-flask:before {
  content: "\\f0c3";
}

.fa-flickr:before {
  content: "\\f16e";
}

.fa-flipboard:before {
  content: "\\f44d";
}

.fa-flushed:before {
  content: "\\f579";
}

.fa-fly:before {
  content: "\\f417";
}

.fa-folder:before {
  content: "\\f07b";
}

.fa-folder-minus:before {
  content: "\\f65d";
}

.fa-folder-open:before {
  content: "\\f07c";
}

.fa-folder-plus:before {
  content: "\\f65e";
}

.fa-font:before {
  content: "\\f031";
}

.fa-font-awesome:before {
  content: "\\f2b4";
}

.fa-font-awesome-alt:before {
  content: "\\f35c";
}

.fa-font-awesome-flag:before {
  content: "\\f425";
}

.fa-font-awesome-logo-full:before {
  content: "\\f4e6";
}

.fa-fonticons:before {
  content: "\\f280";
}

.fa-fonticons-fi:before {
  content: "\\f3a2";
}

.fa-football-ball:before {
  content: "\\f44e";
}

.fa-fort-awesome:before {
  content: "\\f286";
}

.fa-fort-awesome-alt:before {
  content: "\\f3a3";
}

.fa-forumbee:before {
  content: "\\f211";
}

.fa-forward:before {
  content: "\\f04e";
}

.fa-foursquare:before {
  content: "\\f180";
}

.fa-free-code-camp:before {
  content: "\\f2c5";
}

.fa-freebsd:before {
  content: "\\f3a4";
}

.fa-frog:before {
  content: "\\f52e";
}

.fa-frown:before {
  content: "\\f119";
}

.fa-frown-open:before {
  content: "\\f57a";
}

.fa-fulcrum:before {
  content: "\\f50b";
}

.fa-funnel-dollar:before {
  content: "\\f662";
}

.fa-futbol:before {
  content: "\\f1e3";
}

.fa-galactic-republic:before {
  content: "\\f50c";
}

.fa-galactic-senate:before {
  content: "\\f50d";
}

.fa-gamepad:before {
  content: "\\f11b";
}

.fa-gas-pump:before {
  content: "\\f52f";
}

.fa-gavel:before {
  content: "\\f0e3";
}

.fa-gem:before {
  content: "\\f3a5";
}

.fa-genderless:before {
  content: "\\f22d";
}

.fa-get-pocket:before {
  content: "\\f265";
}

.fa-gg:before {
  content: "\\f260";
}

.fa-gg-circle:before {
  content: "\\f261";
}

.fa-ghost:before {
  content: "\\f6e2";
}

.fa-gift:before {
  content: "\\f06b";
}

.fa-gifts:before {
  content: "\\f79c";
}

.fa-git:before {
  content: "\\f1d3";
}

.fa-git-square:before {
  content: "\\f1d2";
}

.fa-github:before {
  content: "\\f09b";
}

.fa-github-alt:before {
  content: "\\f113";
}

.fa-github-square:before {
  content: "\\f092";
}

.fa-gitkraken:before {
  content: "\\f3a6";
}

.fa-gitlab:before {
  content: "\\f296";
}

.fa-gitter:before {
  content: "\\f426";
}

.fa-glass-cheers:before {
  content: "\\f79f";
}

.fa-glass-martini:before {
  content: "\\f000";
}

.fa-glass-martini-alt:before {
  content: "\\f57b";
}

.fa-glass-whiskey:before {
  content: "\\f7a0";
}

.fa-glasses:before {
  content: "\\f530";
}

.fa-glide:before {
  content: "\\f2a5";
}

.fa-glide-g:before {
  content: "\\f2a6";
}

.fa-globe:before {
  content: "\\f0ac";
}

.fa-globe-africa:before {
  content: "\\f57c";
}

.fa-globe-americas:before {
  content: "\\f57d";
}

.fa-globe-asia:before {
  content: "\\f57e";
}

.fa-globe-europe:before {
  content: "\\f7a2";
}

.fa-gofore:before {
  content: "\\f3a7";
}

.fa-golf-ball:before {
  content: "\\f450";
}

.fa-goodreads:before {
  content: "\\f3a8";
}

.fa-goodreads-g:before {
  content: "\\f3a9";
}

.fa-google:before {
  content: "\\f1a0";
}

.fa-google-drive:before {
  content: "\\f3aa";
}

.fa-google-play:before {
  content: "\\f3ab";
}

.fa-google-plus:before {
  content: "\\f2b3";
}

.fa-google-plus-g:before {
  content: "\\f0d5";
}

.fa-google-plus-square:before {
  content: "\\f0d4";
}

.fa-google-wallet:before {
  content: "\\f1ee";
}

.fa-gopuram:before {
  content: "\\f664";
}

.fa-graduation-cap:before {
  content: "\\f19d";
}

.fa-gratipay:before {
  content: "\\f184";
}

.fa-grav:before {
  content: "\\f2d6";
}

.fa-greater-than:before {
  content: "\\f531";
}

.fa-greater-than-equal:before {
  content: "\\f532";
}

.fa-grimace:before {
  content: "\\f57f";
}

.fa-grin:before {
  content: "\\f580";
}

.fa-grin-alt:before {
  content: "\\f581";
}

.fa-grin-beam:before {
  content: "\\f582";
}

.fa-grin-beam-sweat:before {
  content: "\\f583";
}

.fa-grin-hearts:before {
  content: "\\f584";
}

.fa-grin-squint:before {
  content: "\\f585";
}

.fa-grin-squint-tears:before {
  content: "\\f586";
}

.fa-grin-stars:before {
  content: "\\f587";
}

.fa-grin-tears:before {
  content: "\\f588";
}

.fa-grin-tongue:before {
  content: "\\f589";
}

.fa-grin-tongue-squint:before {
  content: "\\f58a";
}

.fa-grin-tongue-wink:before {
  content: "\\f58b";
}

.fa-grin-wink:before {
  content: "\\f58c";
}

.fa-grip-horizontal:before {
  content: "\\f58d";
}

.fa-grip-lines:before {
  content: "\\f7a4";
}

.fa-grip-lines-vertical:before {
  content: "\\f7a5";
}

.fa-grip-vertical:before {
  content: "\\f58e";
}

.fa-gripfire:before {
  content: "\\f3ac";
}

.fa-grunt:before {
  content: "\\f3ad";
}

.fa-guitar:before {
  content: "\\f7a6";
}

.fa-gulp:before {
  content: "\\f3ae";
}

.fa-h-square:before {
  content: "\\f0fd";
}

.fa-hacker-news:before {
  content: "\\f1d4";
}

.fa-hacker-news-square:before {
  content: "\\f3af";
}

.fa-hackerrank:before {
  content: "\\f5f7";
}

.fa-hammer:before {
  content: "\\f6e3";
}

.fa-hamsa:before {
  content: "\\f665";
}

.fa-hand-holding:before {
  content: "\\f4bd";
}

.fa-hand-holding-heart:before {
  content: "\\f4be";
}

.fa-hand-holding-usd:before {
  content: "\\f4c0";
}

.fa-hand-lizard:before {
  content: "\\f258";
}

.fa-hand-paper:before {
  content: "\\f256";
}

.fa-hand-peace:before {
  content: "\\f25b";
}

.fa-hand-point-down:before {
  content: "\\f0a7";
}

.fa-hand-point-left:before {
  content: "\\f0a5";
}

.fa-hand-point-right:before {
  content: "\\f0a4";
}

.fa-hand-point-up:before {
  content: "\\f0a6";
}

.fa-hand-pointer:before {
  content: "\\f25a";
}

.fa-hand-rock:before {
  content: "\\f255";
}

.fa-hand-scissors:before {
  content: "\\f257";
}

.fa-hand-spock:before {
  content: "\\f259";
}

.fa-hands:before {
  content: "\\f4c2";
}

.fa-hands-helping:before {
  content: "\\f4c4";
}

.fa-handshake:before {
  content: "\\f2b5";
}

.fa-hanukiah:before {
  content: "\\f6e6";
}

.fa-hashtag:before {
  content: "\\f292";
}

.fa-hat-wizard:before {
  content: "\\f6e8";
}

.fa-haykal:before {
  content: "\\f666";
}

.fa-hdd:before {
  content: "\\f0a0";
}

.fa-heading:before {
  content: "\\f1dc";
}

.fa-headphones:before {
  content: "\\f025";
}

.fa-headphones-alt:before {
  content: "\\f58f";
}

.fa-headset:before {
  content: "\\f590";
}

.fa-heart:before {
  content: "\\f004";
}

.fa-heart-broken:before {
  content: "\\f7a9";
}

.fa-heartbeat:before {
  content: "\\f21e";
}

.fa-helicopter:before {
  content: "\\f533";
}

.fa-highlighter:before {
  content: "\\f591";
}

.fa-hiking:before {
  content: "\\f6ec";
}

.fa-hippo:before {
  content: "\\f6ed";
}

.fa-hips:before {
  content: "\\f452";
}

.fa-hire-a-helper:before {
  content: "\\f3b0";
}

.fa-history:before {
  content: "\\f1da";
}

.fa-hockey-puck:before {
  content: "\\f453";
}

.fa-holly-berry:before {
  content: "\\f7aa";
}

.fa-home:before {
  content: "\\f015";
}

.fa-hooli:before {
  content: "\\f427";
}

.fa-hornbill:before {
  content: "\\f592";
}

.fa-horse:before {
  content: "\\f6f0";
}

.fa-horse-head:before {
  content: "\\f7ab";
}

.fa-hospital:before {
  content: "\\f0f8";
}

.fa-hospital-alt:before {
  content: "\\f47d";
}

.fa-hospital-symbol:before {
  content: "\\f47e";
}

.fa-hot-tub:before {
  content: "\\f593";
}

.fa-hotel:before {
  content: "\\f594";
}

.fa-hotjar:before {
  content: "\\f3b1";
}

.fa-hourglass:before {
  content: "\\f254";
}

.fa-hourglass-end:before {
  content: "\\f253";
}

.fa-hourglass-half:before {
  content: "\\f252";
}

.fa-hourglass-start:before {
  content: "\\f251";
}

.fa-house-damage:before {
  content: "\\f6f1";
}

.fa-houzz:before {
  content: "\\f27c";
}

.fa-hryvnia:before {
  content: "\\f6f2";
}

.fa-html5:before {
  content: "\\f13b";
}

.fa-hubspot:before {
  content: "\\f3b2";
}

.fa-i-cursor:before {
  content: "\\f246";
}

.fa-icicles:before {
  content: "\\f7ad";
}

.fa-id-badge:before {
  content: "\\f2c1";
}

.fa-id-card:before {
  content: "\\f2c2";
}

.fa-id-card-alt:before {
  content: "\\f47f";
}

.fa-igloo:before {
  content: "\\f7ae";
}

.fa-image:before {
  content: "\\f03e";
}

.fa-images:before {
  content: "\\f302";
}

.fa-imdb:before {
  content: "\\f2d8";
}

.fa-inbox:before {
  content: "\\f01c";
}

.fa-indent:before {
  content: "\\f03c";
}

.fa-industry:before {
  content: "\\f275";
}

.fa-infinity:before {
  content: "\\f534";
}

.fa-info:before {
  content: "\\f129";
}

.fa-info-circle:before {
  content: "\\f05a";
}

.fa-instagram:before {
  content: "\\f16d";
}

.fa-intercom:before {
  content: "\\f7af";
}

.fa-internet-explorer:before {
  content: "\\f26b";
}

.fa-invision:before {
  content: "\\f7b0";
}

.fa-ioxhost:before {
  content: "\\f208";
}

.fa-italic:before {
  content: "\\f033";
}

.fa-itunes:before {
  content: "\\f3b4";
}

.fa-itunes-note:before {
  content: "\\f3b5";
}

.fa-java:before {
  content: "\\f4e4";
}

.fa-jedi:before {
  content: "\\f669";
}

.fa-jedi-order:before {
  content: "\\f50e";
}

.fa-jenkins:before {
  content: "\\f3b6";
}

.fa-jira:before {
  content: "\\f7b1";
}

.fa-joget:before {
  content: "\\f3b7";
}

.fa-joint:before {
  content: "\\f595";
}

.fa-joomla:before {
  content: "\\f1aa";
}

.fa-journal-whills:before {
  content: "\\f66a";
}

.fa-js:before {
  content: "\\f3b8";
}

.fa-js-square:before {
  content: "\\f3b9";
}

.fa-jsfiddle:before {
  content: "\\f1cc";
}

.fa-kaaba:before {
  content: "\\f66b";
}

.fa-kaggle:before {
  content: "\\f5fa";
}

.fa-key:before {
  content: "\\f084";
}

.fa-keybase:before {
  content: "\\f4f5";
}

.fa-keyboard:before {
  content: "\\f11c";
}

.fa-keycdn:before {
  content: "\\f3ba";
}

.fa-khanda:before {
  content: "\\f66d";
}

.fa-kickstarter:before {
  content: "\\f3bb";
}

.fa-kickstarter-k:before {
  content: "\\f3bc";
}

.fa-kiss:before {
  content: "\\f596";
}

.fa-kiss-beam:before {
  content: "\\f597";
}

.fa-kiss-wink-heart:before {
  content: "\\f598";
}

.fa-kiwi-bird:before {
  content: "\\f535";
}

.fa-korvue:before {
  content: "\\f42f";
}

.fa-landmark:before {
  content: "\\f66f";
}

.fa-language:before {
  content: "\\f1ab";
}

.fa-laptop:before {
  content: "\\f109";
}

.fa-laptop-code:before {
  content: "\\f5fc";
}

.fa-laravel:before {
  content: "\\f3bd";
}

.fa-lastfm:before {
  content: "\\f202";
}

.fa-lastfm-square:before {
  content: "\\f203";
}

.fa-laugh:before {
  content: "\\f599";
}

.fa-laugh-beam:before {
  content: "\\f59a";
}

.fa-laugh-squint:before {
  content: "\\f59b";
}

.fa-laugh-wink:before {
  content: "\\f59c";
}

.fa-layer-group:before {
  content: "\\f5fd";
}

.fa-leaf:before {
  content: "\\f06c";
}

.fa-leanpub:before {
  content: "\\f212";
}

.fa-lemon:before {
  content: "\\f094";
}

.fa-less:before {
  content: "\\f41d";
}

.fa-less-than:before {
  content: "\\f536";
}

.fa-less-than-equal:before {
  content: "\\f537";
}

.fa-level-down-alt:before {
  content: "\\f3be";
}

.fa-level-up-alt:before {
  content: "\\f3bf";
}

.fa-life-ring:before {
  content: "\\f1cd";
}

.fa-lightbulb:before {
  content: "\\f0eb";
}

.fa-line:before {
  content: "\\f3c0";
}

.fa-link:before {
  content: "\\f0c1";
}

.fa-linkedin:before {
  content: "\\f08c";
}

.fa-linkedin-in:before {
  content: "\\f0e1";
}

.fa-linode:before {
  content: "\\f2b8";
}

.fa-linux:before {
  content: "\\f17c";
}

.fa-lira-sign:before {
  content: "\\f195";
}

.fa-list:before {
  content: "\\f03a";
}

.fa-list-alt:before {
  content: "\\f022";
}

.fa-list-ol:before {
  content: "\\f0cb";
}

.fa-list-ul:before {
  content: "\\f0ca";
}

.fa-location-arrow:before {
  content: "\\f124";
}

.fa-lock:before {
  content: "\\f023";
}

.fa-lock-open:before {
  content: "\\f3c1";
}

.fa-long-arrow-alt-down:before {
  content: "\\f309";
}

.fa-long-arrow-alt-left:before {
  content: "\\f30a";
}

.fa-long-arrow-alt-right:before {
  content: "\\f30b";
}

.fa-long-arrow-alt-up:before {
  content: "\\f30c";
}

.fa-low-vision:before {
  content: "\\f2a8";
}

.fa-luggage-cart:before {
  content: "\\f59d";
}

.fa-lyft:before {
  content: "\\f3c3";
}

.fa-magento:before {
  content: "\\f3c4";
}

.fa-magic:before {
  content: "\\f0d0";
}

.fa-magnet:before {
  content: "\\f076";
}

.fa-mail-bulk:before {
  content: "\\f674";
}

.fa-mailchimp:before {
  content: "\\f59e";
}

.fa-male:before {
  content: "\\f183";
}

.fa-mandalorian:before {
  content: "\\f50f";
}

.fa-map:before {
  content: "\\f279";
}

.fa-map-marked:before {
  content: "\\f59f";
}

.fa-map-marked-alt:before {
  content: "\\f5a0";
}

.fa-map-marker:before {
  content: "\\f041";
}

.fa-map-marker-alt:before {
  content: "\\f3c5";
}

.fa-map-pin:before {
  content: "\\f276";
}

.fa-map-signs:before {
  content: "\\f277";
}

.fa-markdown:before {
  content: "\\f60f";
}

.fa-marker:before {
  content: "\\f5a1";
}

.fa-mars:before {
  content: "\\f222";
}

.fa-mars-double:before {
  content: "\\f227";
}

.fa-mars-stroke:before {
  content: "\\f229";
}

.fa-mars-stroke-h:before {
  content: "\\f22b";
}

.fa-mars-stroke-v:before {
  content: "\\f22a";
}

.fa-mask:before {
  content: "\\f6fa";
}

.fa-mastodon:before {
  content: "\\f4f6";
}

.fa-maxcdn:before {
  content: "\\f136";
}

.fa-medal:before {
  content: "\\f5a2";
}

.fa-medapps:before {
  content: "\\f3c6";
}

.fa-medium:before {
  content: "\\f23a";
}

.fa-medium-m:before {
  content: "\\f3c7";
}

.fa-medkit:before {
  content: "\\f0fa";
}

.fa-medrt:before {
  content: "\\f3c8";
}

.fa-meetup:before {
  content: "\\f2e0";
}

.fa-megaport:before {
  content: "\\f5a3";
}

.fa-meh:before {
  content: "\\f11a";
}

.fa-meh-blank:before {
  content: "\\f5a4";
}

.fa-meh-rolling-eyes:before {
  content: "\\f5a5";
}

.fa-memory:before {
  content: "\\f538";
}

.fa-mendeley:before {
  content: "\\f7b3";
}

.fa-menorah:before {
  content: "\\f676";
}

.fa-mercury:before {
  content: "\\f223";
}

.fa-meteor:before {
  content: "\\f753";
}

.fa-microchip:before {
  content: "\\f2db";
}

.fa-microphone:before {
  content: "\\f130";
}

.fa-microphone-alt:before {
  content: "\\f3c9";
}

.fa-microphone-alt-slash:before {
  content: "\\f539";
}

.fa-microphone-slash:before {
  content: "\\f131";
}

.fa-microscope:before {
  content: "\\f610";
}

.fa-microsoft:before {
  content: "\\f3ca";
}

.fa-minus:before {
  content: "\\f068";
}

.fa-minus-circle:before {
  content: "\\f056";
}

.fa-minus-square:before {
  content: "\\f146";
}

.fa-mitten:before {
  content: "\\f7b5";
}

.fa-mix:before {
  content: "\\f3cb";
}

.fa-mixcloud:before {
  content: "\\f289";
}

.fa-mizuni:before {
  content: "\\f3cc";
}

.fa-mobile:before {
  content: "\\f10b";
}

.fa-mobile-alt:before {
  content: "\\f3cd";
}

.fa-modx:before {
  content: "\\f285";
}

.fa-monero:before {
  content: "\\f3d0";
}

.fa-money-bill:before {
  content: "\\f0d6";
}

.fa-money-bill-alt:before {
  content: "\\f3d1";
}

.fa-money-bill-wave:before {
  content: "\\f53a";
}

.fa-money-bill-wave-alt:before {
  content: "\\f53b";
}

.fa-money-check:before {
  content: "\\f53c";
}

.fa-money-check-alt:before {
  content: "\\f53d";
}

.fa-monument:before {
  content: "\\f5a6";
}

.fa-moon:before {
  content: "\\f186";
}

.fa-mortar-pestle:before {
  content: "\\f5a7";
}

.fa-mosque:before {
  content: "\\f678";
}

.fa-motorcycle:before {
  content: "\\f21c";
}

.fa-mountain:before {
  content: "\\f6fc";
}

.fa-mouse-pointer:before {
  content: "\\f245";
}

.fa-mug-hot:before {
  content: "\\f7b6";
}

.fa-music:before {
  content: "\\f001";
}

.fa-napster:before {
  content: "\\f3d2";
}

.fa-neos:before {
  content: "\\f612";
}

.fa-network-wired:before {
  content: "\\f6ff";
}

.fa-neuter:before {
  content: "\\f22c";
}

.fa-newspaper:before {
  content: "\\f1ea";
}

.fa-nimblr:before {
  content: "\\f5a8";
}

.fa-nintendo-switch:before {
  content: "\\f418";
}

.fa-node:before {
  content: "\\f419";
}

.fa-node-js:before {
  content: "\\f3d3";
}

.fa-not-equal:before {
  content: "\\f53e";
}

.fa-notes-medical:before {
  content: "\\f481";
}

.fa-npm:before {
  content: "\\f3d4";
}

.fa-ns8:before {
  content: "\\f3d5";
}

.fa-nutritionix:before {
  content: "\\f3d6";
}

.fa-object-group:before {
  content: "\\f247";
}

.fa-object-ungroup:before {
  content: "\\f248";
}

.fa-odnoklassniki:before {
  content: "\\f263";
}

.fa-odnoklassniki-square:before {
  content: "\\f264";
}

.fa-oil-can:before {
  content: "\\f613";
}

.fa-old-republic:before {
  content: "\\f510";
}

.fa-om:before {
  content: "\\f679";
}

.fa-opencart:before {
  content: "\\f23d";
}

.fa-openid:before {
  content: "\\f19b";
}

.fa-opera:before {
  content: "\\f26a";
}

.fa-optin-monster:before {
  content: "\\f23c";
}

.fa-osi:before {
  content: "\\f41a";
}

.fa-otter:before {
  content: "\\f700";
}

.fa-outdent:before {
  content: "\\f03b";
}

.fa-page4:before {
  content: "\\f3d7";
}

.fa-pagelines:before {
  content: "\\f18c";
}

.fa-paint-brush:before {
  content: "\\f1fc";
}

.fa-paint-roller:before {
  content: "\\f5aa";
}

.fa-palette:before {
  content: "\\f53f";
}

.fa-palfed:before {
  content: "\\f3d8";
}

.fa-pallet:before {
  content: "\\f482";
}

.fa-paper-plane:before {
  content: "\\f1d8";
}

.fa-paperclip:before {
  content: "\\f0c6";
}

.fa-parachute-box:before {
  content: "\\f4cd";
}

.fa-paragraph:before {
  content: "\\f1dd";
}

.fa-parking:before {
  content: "\\f540";
}

.fa-passport:before {
  content: "\\f5ab";
}

.fa-pastafarianism:before {
  content: "\\f67b";
}

.fa-paste:before {
  content: "\\f0ea";
}

.fa-patreon:before {
  content: "\\f3d9";
}

.fa-pause:before {
  content: "\\f04c";
}

.fa-pause-circle:before {
  content: "\\f28b";
}

.fa-paw:before {
  content: "\\f1b0";
}

.fa-paypal:before {
  content: "\\f1ed";
}

.fa-peace:before {
  content: "\\f67c";
}

.fa-pen:before {
  content: "\\f304";
}

.fa-pen-alt:before {
  content: "\\f305";
}

.fa-pen-fancy:before {
  content: "\\f5ac";
}

.fa-pen-nib:before {
  content: "\\f5ad";
}

.fa-pen-square:before {
  content: "\\f14b";
}

.fa-pencil-alt:before {
  content: "\\f303";
}

.fa-pencil-ruler:before {
  content: "\\f5ae";
}

.fa-penny-arcade:before {
  content: "\\f704";
}

.fa-people-carry:before {
  content: "\\f4ce";
}

.fa-percent:before {
  content: "\\f295";
}

.fa-percentage:before {
  content: "\\f541";
}

.fa-periscope:before {
  content: "\\f3da";
}

.fa-person-booth:before {
  content: "\\f756";
}

.fa-phabricator:before {
  content: "\\f3db";
}

.fa-phoenix-framework:before {
  content: "\\f3dc";
}

.fa-phoenix-squadron:before {
  content: "\\f511";
}

.fa-phone:before {
  content: "\\f095";
}

.fa-phone-slash:before {
  content: "\\f3dd";
}

.fa-phone-square:before {
  content: "\\f098";
}

.fa-phone-volume:before {
  content: "\\f2a0";
}

.fa-php:before {
  content: "\\f457";
}

.fa-pied-piper:before {
  content: "\\f2ae";
}

.fa-pied-piper-alt:before {
  content: "\\f1a8";
}

.fa-pied-piper-hat:before {
  content: "\\f4e5";
}

.fa-pied-piper-pp:before {
  content: "\\f1a7";
}

.fa-piggy-bank:before {
  content: "\\f4d3";
}

.fa-pills:before {
  content: "\\f484";
}

.fa-pinterest:before {
  content: "\\f0d2";
}

.fa-pinterest-p:before {
  content: "\\f231";
}

.fa-pinterest-square:before {
  content: "\\f0d3";
}

.fa-place-of-worship:before {
  content: "\\f67f";
}

.fa-plane:before {
  content: "\\f072";
}

.fa-plane-arrival:before {
  content: "\\f5af";
}

.fa-plane-departure:before {
  content: "\\f5b0";
}

.fa-play:before {
  content: "\\f04b";
}

.fa-play-circle:before {
  content: "\\f144";
}

.fa-playstation:before {
  content: "\\f3df";
}

.fa-plug:before {
  content: "\\f1e6";
}

.fa-plus:before {
  content: "\\f067";
}

.fa-plus-circle:before {
  content: "\\f055";
}

.fa-plus-square:before {
  content: "\\f0fe";
}

.fa-podcast:before {
  content: "\\f2ce";
}

.fa-poll:before {
  content: "\\f681";
}

.fa-poll-h:before {
  content: "\\f682";
}

.fa-poo:before {
  content: "\\f2fe";
}

.fa-poo-storm:before {
  content: "\\f75a";
}

.fa-poop:before {
  content: "\\f619";
}

.fa-portrait:before {
  content: "\\f3e0";
}

.fa-pound-sign:before {
  content: "\\f154";
}

.fa-power-off:before {
  content: "\\f011";
}

.fa-pray:before {
  content: "\\f683";
}

.fa-praying-hands:before {
  content: "\\f684";
}

.fa-prescription:before {
  content: "\\f5b1";
}

.fa-prescription-bottle:before {
  content: "\\f485";
}

.fa-prescription-bottle-alt:before {
  content: "\\f486";
}

.fa-print:before {
  content: "\\f02f";
}

.fa-procedures:before {
  content: "\\f487";
}

.fa-product-hunt:before {
  content: "\\f288";
}

.fa-project-diagram:before {
  content: "\\f542";
}

.fa-pushed:before {
  content: "\\f3e1";
}

.fa-puzzle-piece:before {
  content: "\\f12e";
}

.fa-python:before {
  content: "\\f3e2";
}

.fa-qq:before {
  content: "\\f1d6";
}

.fa-qrcode:before {
  content: "\\f029";
}

.fa-question:before {
  content: "\\f128";
}

.fa-question-circle:before {
  content: "\\f059";
}

.fa-quidditch:before {
  content: "\\f458";
}

.fa-quinscape:before {
  content: "\\f459";
}

.fa-quora:before {
  content: "\\f2c4";
}

.fa-quote-left:before {
  content: "\\f10d";
}

.fa-quote-right:before {
  content: "\\f10e";
}

.fa-quran:before {
  content: "\\f687";
}

.fa-r-project:before {
  content: "\\f4f7";
}

.fa-radiation:before {
  content: "\\f7b9";
}

.fa-radiation-alt:before {
  content: "\\f7ba";
}

.fa-rainbow:before {
  content: "\\f75b";
}

.fa-random:before {
  content: "\\f074";
}

.fa-raspberry-pi:before {
  content: "\\f7bb";
}

.fa-ravelry:before {
  content: "\\f2d9";
}

.fa-react:before {
  content: "\\f41b";
}

.fa-reacteurope:before {
  content: "\\f75d";
}

.fa-readme:before {
  content: "\\f4d5";
}

.fa-rebel:before {
  content: "\\f1d0";
}

.fa-receipt:before {
  content: "\\f543";
}

.fa-recycle:before {
  content: "\\f1b8";
}

.fa-red-river:before {
  content: "\\f3e3";
}

.fa-reddit:before {
  content: "\\f1a1";
}

.fa-reddit-alien:before {
  content: "\\f281";
}

.fa-reddit-square:before {
  content: "\\f1a2";
}

.fa-redhat:before {
  content: "\\f7bc";
}

.fa-redo:before {
  content: "\\f01e";
}

.fa-redo-alt:before {
  content: "\\f2f9";
}

.fa-registered:before {
  content: "\\f25d";
}

.fa-renren:before {
  content: "\\f18b";
}

.fa-reply:before {
  content: "\\f3e5";
}

.fa-reply-all:before {
  content: "\\f122";
}

.fa-replyd:before {
  content: "\\f3e6";
}

.fa-republican:before {
  content: "\\f75e";
}

.fa-researchgate:before {
  content: "\\f4f8";
}

.fa-resolving:before {
  content: "\\f3e7";
}

.fa-restroom:before {
  content: "\\f7bd";
}

.fa-retweet:before {
  content: "\\f079";
}

.fa-rev:before {
  content: "\\f5b2";
}

.fa-ribbon:before {
  content: "\\f4d6";
}

.fa-ring:before {
  content: "\\f70b";
}

.fa-road:before {
  content: "\\f018";
}

.fa-robot:before {
  content: "\\f544";
}

.fa-rocket:before {
  content: "\\f135";
}

.fa-rocketchat:before {
  content: "\\f3e8";
}

.fa-rockrms:before {
  content: "\\f3e9";
}

.fa-route:before {
  content: "\\f4d7";
}

.fa-rss:before {
  content: "\\f09e";
}

.fa-rss-square:before {
  content: "\\f143";
}

.fa-ruble-sign:before {
  content: "\\f158";
}

.fa-ruler:before {
  content: "\\f545";
}

.fa-ruler-combined:before {
  content: "\\f546";
}

.fa-ruler-horizontal:before {
  content: "\\f547";
}

.fa-ruler-vertical:before {
  content: "\\f548";
}

.fa-running:before {
  content: "\\f70c";
}

.fa-rupee-sign:before {
  content: "\\f156";
}

.fa-sad-cry:before {
  content: "\\f5b3";
}

.fa-sad-tear:before {
  content: "\\f5b4";
}

.fa-safari:before {
  content: "\\f267";
}

.fa-sass:before {
  content: "\\f41e";
}

.fa-satellite:before {
  content: "\\f7bf";
}

.fa-satellite-dish:before {
  content: "\\f7c0";
}

.fa-save:before {
  content: "\\f0c7";
}

.fa-schlix:before {
  content: "\\f3ea";
}

.fa-school:before {
  content: "\\f549";
}

.fa-screwdriver:before {
  content: "\\f54a";
}

.fa-scribd:before {
  content: "\\f28a";
}

.fa-scroll:before {
  content: "\\f70e";
}

.fa-sd-card:before {
  content: "\\f7c2";
}

.fa-search:before {
  content: "\\f002";
}

.fa-search-dollar:before {
  content: "\\f688";
}

.fa-search-location:before {
  content: "\\f689";
}

.fa-search-minus:before {
  content: "\\f010";
}

.fa-search-plus:before {
  content: "\\f00e";
}

.fa-searchengin:before {
  content: "\\f3eb";
}

.fa-seedling:before {
  content: "\\f4d8";
}

.fa-sellcast:before {
  content: "\\f2da";
}

.fa-sellsy:before {
  content: "\\f213";
}

.fa-server:before {
  content: "\\f233";
}

.fa-servicestack:before {
  content: "\\f3ec";
}

.fa-shapes:before {
  content: "\\f61f";
}

.fa-share:before {
  content: "\\f064";
}

.fa-share-alt:before {
  content: "\\f1e0";
}

.fa-share-alt-square:before {
  content: "\\f1e1";
}

.fa-share-square:before {
  content: "\\f14d";
}

.fa-shekel-sign:before {
  content: "\\f20b";
}

.fa-shield-alt:before {
  content: "\\f3ed";
}

.fa-ship:before {
  content: "\\f21a";
}

.fa-shipping-fast:before {
  content: "\\f48b";
}

.fa-shirtsinbulk:before {
  content: "\\f214";
}

.fa-shoe-prints:before {
  content: "\\f54b";
}

.fa-shopping-bag:before {
  content: "\\f290";
}

.fa-shopping-basket:before {
  content: "\\f291";
}

.fa-shopping-cart:before {
  content: "\\f07a";
}

.fa-shopware:before {
  content: "\\f5b5";
}

.fa-shower:before {
  content: "\\f2cc";
}

.fa-shuttle-van:before {
  content: "\\f5b6";
}

.fa-sign:before {
  content: "\\f4d9";
}

.fa-sign-in-alt:before {
  content: "\\f2f6";
}

.fa-sign-language:before {
  content: "\\f2a7";
}

.fa-sign-out-alt:before {
  content: "\\f2f5";
}

.fa-signal:before {
  content: "\\f012";
}

.fa-signature:before {
  content: "\\f5b7";
}

.fa-sim-card:before {
  content: "\\f7c4";
}

.fa-simplybuilt:before {
  content: "\\f215";
}

.fa-sistrix:before {
  content: "\\f3ee";
}

.fa-sitemap:before {
  content: "\\f0e8";
}

.fa-sith:before {
  content: "\\f512";
}

.fa-skating:before {
  content: "\\f7c5";
}

.fa-sketch:before {
  content: "\\f7c6";
}

.fa-skiing:before {
  content: "\\f7c9";
}

.fa-skiing-nordic:before {
  content: "\\f7ca";
}

.fa-skull:before {
  content: "\\f54c";
}

.fa-skull-crossbones:before {
  content: "\\f714";
}

.fa-skyatlas:before {
  content: "\\f216";
}

.fa-skype:before {
  content: "\\f17e";
}

.fa-slack:before {
  content: "\\f198";
}

.fa-slack-hash:before {
  content: "\\f3ef";
}

.fa-slash:before {
  content: "\\f715";
}

.fa-sleigh:before {
  content: "\\f7cc";
}

.fa-sliders-h:before {
  content: "\\f1de";
}

.fa-slideshare:before {
  content: "\\f1e7";
}

.fa-smile:before {
  content: "\\f118";
}

.fa-smile-beam:before {
  content: "\\f5b8";
}

.fa-smile-wink:before {
  content: "\\f4da";
}

.fa-smog:before {
  content: "\\f75f";
}

.fa-smoking:before {
  content: "\\f48d";
}

.fa-smoking-ban:before {
  content: "\\f54d";
}

.fa-sms:before {
  content: "\\f7cd";
}

.fa-snapchat:before {
  content: "\\f2ab";
}

.fa-snapchat-ghost:before {
  content: "\\f2ac";
}

.fa-snapchat-square:before {
  content: "\\f2ad";
}

.fa-snowboarding:before {
  content: "\\f7ce";
}

.fa-snowflake:before {
  content: "\\f2dc";
}

.fa-snowman:before {
  content: "\\f7d0";
}

.fa-snowplow:before {
  content: "\\f7d2";
}

.fa-socks:before {
  content: "\\f696";
}

.fa-solar-panel:before {
  content: "\\f5ba";
}

.fa-sort:before {
  content: "\\f0dc";
}

.fa-sort-alpha-down:before {
  content: "\\f15d";
}

.fa-sort-alpha-up:before {
  content: "\\f15e";
}

.fa-sort-amount-down:before {
  content: "\\f160";
}

.fa-sort-amount-up:before {
  content: "\\f161";
}

.fa-sort-down:before {
  content: "\\f0dd";
}

.fa-sort-numeric-down:before {
  content: "\\f162";
}

.fa-sort-numeric-up:before {
  content: "\\f163";
}

.fa-sort-up:before {
  content: "\\f0de";
}

.fa-soundcloud:before {
  content: "\\f1be";
}

.fa-sourcetree:before {
  content: "\\f7d3";
}

.fa-spa:before {
  content: "\\f5bb";
}

.fa-space-shuttle:before {
  content: "\\f197";
}

.fa-speakap:before {
  content: "\\f3f3";
}

.fa-spider:before {
  content: "\\f717";
}

.fa-spinner:before {
  content: "\\f110";
}

.fa-splotch:before {
  content: "\\f5bc";
}

.fa-spotify:before {
  content: "\\f1bc";
}

.fa-spray-can:before {
  content: "\\f5bd";
}

.fa-square:before {
  content: "\\f0c8";
}

.fa-square-full:before {
  content: "\\f45c";
}

.fa-square-root-alt:before {
  content: "\\f698";
}

.fa-squarespace:before {
  content: "\\f5be";
}

.fa-stack-exchange:before {
  content: "\\f18d";
}

.fa-stack-overflow:before {
  content: "\\f16c";
}

.fa-stamp:before {
  content: "\\f5bf";
}

.fa-star:before {
  content: "\\f005";
}

.fa-star-and-crescent:before {
  content: "\\f699";
}

.fa-star-half:before {
  content: "\\f089";
}

.fa-star-half-alt:before {
  content: "\\f5c0";
}

.fa-star-of-david:before {
  content: "\\f69a";
}

.fa-star-of-life:before {
  content: "\\f621";
}

.fa-staylinked:before {
  content: "\\f3f5";
}

.fa-steam:before {
  content: "\\f1b6";
}

.fa-steam-square:before {
  content: "\\f1b7";
}

.fa-steam-symbol:before {
  content: "\\f3f6";
}

.fa-step-backward:before {
  content: "\\f048";
}

.fa-step-forward:before {
  content: "\\f051";
}

.fa-stethoscope:before {
  content: "\\f0f1";
}

.fa-sticker-mule:before {
  content: "\\f3f7";
}

.fa-sticky-note:before {
  content: "\\f249";
}

.fa-stop:before {
  content: "\\f04d";
}

.fa-stop-circle:before {
  content: "\\f28d";
}

.fa-stopwatch:before {
  content: "\\f2f2";
}

.fa-store:before {
  content: "\\f54e";
}

.fa-store-alt:before {
  content: "\\f54f";
}

.fa-strava:before {
  content: "\\f428";
}

.fa-stream:before {
  content: "\\f550";
}

.fa-street-view:before {
  content: "\\f21d";
}

.fa-strikethrough:before {
  content: "\\f0cc";
}

.fa-stripe:before {
  content: "\\f429";
}

.fa-stripe-s:before {
  content: "\\f42a";
}

.fa-stroopwafel:before {
  content: "\\f551";
}

.fa-studiovinari:before {
  content: "\\f3f8";
}

.fa-stumbleupon:before {
  content: "\\f1a4";
}

.fa-stumbleupon-circle:before {
  content: "\\f1a3";
}

.fa-subscript:before {
  content: "\\f12c";
}

.fa-subway:before {
  content: "\\f239";
}

.fa-suitcase:before {
  content: "\\f0f2";
}

.fa-suitcase-rolling:before {
  content: "\\f5c1";
}

.fa-sun:before {
  content: "\\f185";
}

.fa-superpowers:before {
  content: "\\f2dd";
}

.fa-superscript:before {
  content: "\\f12b";
}

.fa-supple:before {
  content: "\\f3f9";
}

.fa-surprise:before {
  content: "\\f5c2";
}

.fa-suse:before {
  content: "\\f7d6";
}

.fa-swatchbook:before {
  content: "\\f5c3";
}

.fa-swimmer:before {
  content: "\\f5c4";
}

.fa-swimming-pool:before {
  content: "\\f5c5";
}

.fa-synagogue:before {
  content: "\\f69b";
}

.fa-sync:before {
  content: "\\f021";
}

.fa-sync-alt:before {
  content: "\\f2f1";
}

.fa-syringe:before {
  content: "\\f48e";
}

.fa-table:before {
  content: "\\f0ce";
}

.fa-table-tennis:before {
  content: "\\f45d";
}

.fa-tablet:before {
  content: "\\f10a";
}

.fa-tablet-alt:before {
  content: "\\f3fa";
}

.fa-tablets:before {
  content: "\\f490";
}

.fa-tachometer-alt:before {
  content: "\\f3fd";
}

.fa-tag:before {
  content: "\\f02b";
}

.fa-tags:before {
  content: "\\f02c";
}

.fa-tape:before {
  content: "\\f4db";
}

.fa-tasks:before {
  content: "\\f0ae";
}

.fa-taxi:before {
  content: "\\f1ba";
}

.fa-teamspeak:before {
  content: "\\f4f9";
}

.fa-teeth:before {
  content: "\\f62e";
}

.fa-teeth-open:before {
  content: "\\f62f";
}

.fa-telegram:before {
  content: "\\f2c6";
}

.fa-telegram-plane:before {
  content: "\\f3fe";
}

.fa-temperature-high:before {
  content: "\\f769";
}

.fa-temperature-low:before {
  content: "\\f76b";
}

.fa-tencent-weibo:before {
  content: "\\f1d5";
}

.fa-tenge:before {
  content: "\\f7d7";
}

.fa-terminal:before {
  content: "\\f120";
}

.fa-text-height:before {
  content: "\\f034";
}

.fa-text-width:before {
  content: "\\f035";
}

.fa-th:before {
  content: "\\f00a";
}

.fa-th-large:before {
  content: "\\f009";
}

.fa-th-list:before {
  content: "\\f00b";
}

.fa-the-red-yeti:before {
  content: "\\f69d";
}

.fa-theater-masks:before {
  content: "\\f630";
}

.fa-themeco:before {
  content: "\\f5c6";
}

.fa-themeisle:before {
  content: "\\f2b2";
}

.fa-thermometer:before {
  content: "\\f491";
}

.fa-thermometer-empty:before {
  content: "\\f2cb";
}

.fa-thermometer-full:before {
  content: "\\f2c7";
}

.fa-thermometer-half:before {
  content: "\\f2c9";
}

.fa-thermometer-quarter:before {
  content: "\\f2ca";
}

.fa-thermometer-three-quarters:before {
  content: "\\f2c8";
}

.fa-think-peaks:before {
  content: "\\f731";
}

.fa-thumbs-down:before {
  content: "\\f165";
}

.fa-thumbs-up:before {
  content: "\\f164";
}

.fa-thumbtack:before {
  content: "\\f08d";
}

.fa-ticket-alt:before {
  content: "\\f3ff";
}

.fa-times:before {
  content: "\\f00d";
}

.fa-times-circle:before {
  content: "\\f057";
}

.fa-tint:before {
  content: "\\f043";
}

.fa-tint-slash:before {
  content: "\\f5c7";
}

.fa-tired:before {
  content: "\\f5c8";
}

.fa-toggle-off:before {
  content: "\\f204";
}

.fa-toggle-on:before {
  content: "\\f205";
}

.fa-toilet:before {
  content: "\\f7d8";
}

.fa-toilet-paper:before {
  content: "\\f71e";
}

.fa-toolbox:before {
  content: "\\f552";
}

.fa-tools:before {
  content: "\\f7d9";
}

.fa-tooth:before {
  content: "\\f5c9";
}

.fa-torah:before {
  content: "\\f6a0";
}

.fa-torii-gate:before {
  content: "\\f6a1";
}

.fa-tractor:before {
  content: "\\f722";
}

.fa-trade-federation:before {
  content: "\\f513";
}

.fa-trademark:before {
  content: "\\f25c";
}

.fa-traffic-light:before {
  content: "\\f637";
}

.fa-train:before {
  content: "\\f238";
}

.fa-tram:before {
  content: "\\f7da";
}

.fa-transgender:before {
  content: "\\f224";
}

.fa-transgender-alt:before {
  content: "\\f225";
}

.fa-trash:before {
  content: "\\f1f8";
}

.fa-trash-alt:before {
  content: "\\f2ed";
}

.fa-tree:before {
  content: "\\f1bb";
}

.fa-trello:before {
  content: "\\f181";
}

.fa-tripadvisor:before {
  content: "\\f262";
}

.fa-trophy:before {
  content: "\\f091";
}

.fa-truck:before {
  content: "\\f0d1";
}

.fa-truck-loading:before {
  content: "\\f4de";
}

.fa-truck-monster:before {
  content: "\\f63b";
}

.fa-truck-moving:before {
  content: "\\f4df";
}

.fa-truck-pickup:before {
  content: "\\f63c";
}

.fa-tshirt:before {
  content: "\\f553";
}

.fa-tty:before {
  content: "\\f1e4";
}

.fa-tumblr:before {
  content: "\\f173";
}

.fa-tumblr-square:before {
  content: "\\f174";
}

.fa-tv:before {
  content: "\\f26c";
}

.fa-twitch:before {
  content: "\\f1e8";
}

.fa-twitter:before {
  content: "\\f099";
}

.fa-twitter-square:before {
  content: "\\f081";
}

.fa-typo3:before {
  content: "\\f42b";
}

.fa-uber:before {
  content: "\\f402";
}

.fa-ubuntu:before {
  content: "\\f7df";
}

.fa-uikit:before {
  content: "\\f403";
}

.fa-umbrella:before {
  content: "\\f0e9";
}

.fa-umbrella-beach:before {
  content: "\\f5ca";
}

.fa-underline:before {
  content: "\\f0cd";
}

.fa-undo:before {
  content: "\\f0e2";
}

.fa-undo-alt:before {
  content: "\\f2ea";
}

.fa-uniregistry:before {
  content: "\\f404";
}

.fa-universal-access:before {
  content: "\\f29a";
}

.fa-university:before {
  content: "\\f19c";
}

.fa-unlink:before {
  content: "\\f127";
}

.fa-unlock:before {
  content: "\\f09c";
}

.fa-unlock-alt:before {
  content: "\\f13e";
}

.fa-untappd:before {
  content: "\\f405";
}

.fa-upload:before {
  content: "\\f093";
}

.fa-ups:before {
  content: "\\f7e0";
}

.fa-usb:before {
  content: "\\f287";
}

.fa-user:before {
  content: "\\f007";
}

.fa-user-alt:before {
  content: "\\f406";
}

.fa-user-alt-slash:before {
  content: "\\f4fa";
}

.fa-user-astronaut:before {
  content: "\\f4fb";
}

.fa-user-check:before {
  content: "\\f4fc";
}

.fa-user-circle:before {
  content: "\\f2bd";
}

.fa-user-clock:before {
  content: "\\f4fd";
}

.fa-user-cog:before {
  content: "\\f4fe";
}

.fa-user-edit:before {
  content: "\\f4ff";
}

.fa-user-friends:before {
  content: "\\f500";
}

.fa-user-graduate:before {
  content: "\\f501";
}

.fa-user-injured:before {
  content: "\\f728";
}

.fa-user-lock:before {
  content: "\\f502";
}

.fa-user-md:before {
  content: "\\f0f0";
}

.fa-user-minus:before {
  content: "\\f503";
}

.fa-user-ninja:before {
  content: "\\f504";
}

.fa-user-plus:before {
  content: "\\f234";
}

.fa-user-secret:before {
  content: "\\f21b";
}

.fa-user-shield:before {
  content: "\\f505";
}

.fa-user-slash:before {
  content: "\\f506";
}

.fa-user-tag:before {
  content: "\\f507";
}

.fa-user-tie:before {
  content: "\\f508";
}

.fa-user-times:before {
  content: "\\f235";
}

.fa-users:before {
  content: "\\f0c0";
}

.fa-users-cog:before {
  content: "\\f509";
}

.fa-usps:before {
  content: "\\f7e1";
}

.fa-ussunnah:before {
  content: "\\f407";
}

.fa-utensil-spoon:before {
  content: "\\f2e5";
}

.fa-utensils:before {
  content: "\\f2e7";
}

.fa-vaadin:before {
  content: "\\f408";
}

.fa-vector-square:before {
  content: "\\f5cb";
}

.fa-venus:before {
  content: "\\f221";
}

.fa-venus-double:before {
  content: "\\f226";
}

.fa-venus-mars:before {
  content: "\\f228";
}

.fa-viacoin:before {
  content: "\\f237";
}

.fa-viadeo:before {
  content: "\\f2a9";
}

.fa-viadeo-square:before {
  content: "\\f2aa";
}

.fa-vial:before {
  content: "\\f492";
}

.fa-vials:before {
  content: "\\f493";
}

.fa-viber:before {
  content: "\\f409";
}

.fa-video:before {
  content: "\\f03d";
}

.fa-video-slash:before {
  content: "\\f4e2";
}

.fa-vihara:before {
  content: "\\f6a7";
}

.fa-vimeo:before {
  content: "\\f40a";
}

.fa-vimeo-square:before {
  content: "\\f194";
}

.fa-vimeo-v:before {
  content: "\\f27d";
}

.fa-vine:before {
  content: "\\f1ca";
}

.fa-vk:before {
  content: "\\f189";
}

.fa-vnv:before {
  content: "\\f40b";
}

.fa-volleyball-ball:before {
  content: "\\f45f";
}

.fa-volume-down:before {
  content: "\\f027";
}

.fa-volume-mute:before {
  content: "\\f6a9";
}

.fa-volume-off:before {
  content: "\\f026";
}

.fa-volume-up:before {
  content: "\\f028";
}

.fa-vote-yea:before {
  content: "\\f772";
}

.fa-vr-cardboard:before {
  content: "\\f729";
}

.fa-vuejs:before {
  content: "\\f41f";
}

.fa-walking:before {
  content: "\\f554";
}

.fa-wallet:before {
  content: "\\f555";
}

.fa-warehouse:before {
  content: "\\f494";
}

.fa-water:before {
  content: "\\f773";
}

.fa-weebly:before {
  content: "\\f5cc";
}

.fa-weibo:before {
  content: "\\f18a";
}

.fa-weight:before {
  content: "\\f496";
}

.fa-weight-hanging:before {
  content: "\\f5cd";
}

.fa-weixin:before {
  content: "\\f1d7";
}

.fa-whatsapp:before {
  content: "\\f232";
}

.fa-whatsapp-square:before {
  content: "\\f40c";
}

.fa-wheelchair:before {
  content: "\\f193";
}

.fa-whmcs:before {
  content: "\\f40d";
}

.fa-wifi:before {
  content: "\\f1eb";
}

.fa-wikipedia-w:before {
  content: "\\f266";
}

.fa-wind:before {
  content: "\\f72e";
}

.fa-window-close:before {
  content: "\\f410";
}

.fa-window-maximize:before {
  content: "\\f2d0";
}

.fa-window-minimize:before {
  content: "\\f2d1";
}

.fa-window-restore:before {
  content: "\\f2d2";
}

.fa-windows:before {
  content: "\\f17a";
}

.fa-wine-bottle:before {
  content: "\\f72f";
}

.fa-wine-glass:before {
  content: "\\f4e3";
}

.fa-wine-glass-alt:before {
  content: "\\f5ce";
}

.fa-wix:before {
  content: "\\f5cf";
}

.fa-wizards-of-the-coast:before {
  content: "\\f730";
}

.fa-wolf-pack-battalion:before {
  content: "\\f514";
}

.fa-won-sign:before {
  content: "\\f159";
}

.fa-wordpress:before {
  content: "\\f19a";
}

.fa-wordpress-simple:before {
  content: "\\f411";
}

.fa-wpbeginner:before {
  content: "\\f297";
}

.fa-wpexplorer:before {
  content: "\\f2de";
}

.fa-wpforms:before {
  content: "\\f298";
}

.fa-wpressr:before {
  content: "\\f3e4";
}

.fa-wrench:before {
  content: "\\f0ad";
}

.fa-x-ray:before {
  content: "\\f497";
}

.fa-xbox:before {
  content: "\\f412";
}

.fa-xing:before {
  content: "\\f168";
}

.fa-xing-square:before {
  content: "\\f169";
}

.fa-y-combinator:before {
  content: "\\f23b";
}

.fa-yahoo:before {
  content: "\\f19e";
}

.fa-yandex:before {
  content: "\\f413";
}

.fa-yandex-international:before {
  content: "\\f414";
}

.fa-yarn:before {
  content: "\\f7e3";
}

.fa-yelp:before {
  content: "\\f1e9";
}

.fa-yen-sign:before {
  content: "\\f157";
}

.fa-yin-yang:before {
  content: "\\f6ad";
}

.fa-yoast:before {
  content: "\\f2b1";
}

.fa-youtube:before {
  content: "\\f167";
}

.fa-youtube-square:before {
  content: "\\f431";
}

.fa-zhihu:before {
  content: "\\f63f";
}

.sr-only {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
  clip: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  position: static;
  width: auto;
}

@font-face {
  font-family: "Font Awesome 5 Brands";
  font-style: normal;
  font-weight: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format("svg");
}
.fab {
  font-family: "Font Awesome 5 Brands";
}

@font-face {
  font-family: "Font Awesome 5 Free";
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_36___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_37___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_38___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_39___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_40___}) format("svg");
}
.far {
  font-weight: 400;
}

@font-face {
  font-family: "Font Awesome 5 Free";
  font-style: normal;
  font-weight: 900;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_42___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_43___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_44___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_45___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_46___}) format("svg");
}
.fa,
.far,
.fas {
  font-family: "Font Awesome 5 Free";
}

.fa,
.fas {
  font-weight: 900;
}

/*
    Flaticon icon font: Flaticon
    Creation date: 11/04/2019 05:01
    */
@font-face {
  font-family: "Flaticon";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_48___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_49___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_50___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_51___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_52___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
@media screen and (-webkit-min-device-pixel-ratio: 0) {
  @font-face {
    font-family: "Flaticon";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_52___}) format("svg");
  }
}
.fi:before {
  display: inline-block;
  font-family: "Flaticon";
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  line-height: 1;
  text-decoration: inherit;
  text-rendering: optimizeLegibility;
  text-transform: none;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-smoothing: antialiased;
}

.flaticon-shield:before {
  content: "\\f100";
}

.flaticon-layout:before {
  content: "\\f101";
}

.flaticon-layers:before {
  content: "\\f102";
}

.flaticon-cube:before {
  content: "\\f103";
}

.flaticon-compass:before {
  content: "\\f104";
}

.flaticon-thunderbolt:before {
  content: "\\f105";
}

.flaticon-gift:before {
  content: "\\f106";
}

.flaticon-shapes-and-symbols:before {
  content: "\\f107";
}

.flaticon-feather:before {
  content: "\\f108";
}

.flaticon-menu:before {
  content: "\\f109";
}

.flaticon-abc:before {
  content: "\\f10a";
}

.flaticon-alarm:before {
  content: "\\f10b";
}

.flaticon-locker:before {
  content: "\\f10c";
}

.flaticon-menu-1:before {
  content: "\\f10d";
}

.flaticon-crop:before {
  content: "\\f10e";
}

.flaticon-mail:before {
  content: "\\f10f";
}

.flaticon-diamond:before {
  content: "\\f110";
}

.flaticon-edit:before {
  content: "\\f111";
}

.flaticon-gear:before {
  content: "\\f112";
}

.flaticon-video:before {
  content: "\\f113";
}

.flaticon-clipboard:before {
  content: "\\f114";
}

.flaticon-search:before {
  content: "\\f115";
}

.flaticon-data-storage:before {
  content: "\\f116";
}

.flaticon-table:before {
  content: "\\f117";
}

.flaticon-pie-chart:before {
  content: "\\f118";
}

.flaticon-map:before {
  content: "\\f119";
}

.flaticon-calendar:before {
  content: "\\f11a";
}

.flaticon-mixer:before {
  content: "\\f11b";
}

.flaticon-chat:before {
  content: "\\f11c";
}

.flaticon-lock:before {
  content: "\\f11d";
}

.flaticon-photo:before {
  content: "\\f11e";
}

.flaticon-start-up:before {
  content: "\\f11f";
}

.flaticon-test:before {
  content: "\\f120";
}

.flaticon-study:before {
  content: "\\f121";
}

.flaticon-information:before {
  content: "\\f122";
}

.flaticon-support:before {
  content: "\\f123";
}

.flaticon-help:before {
  content: "\\f124";
}

.flaticon-business-and-finance:before {
  content: "\\f125";
}

.flaticon-cloud:before {
  content: "\\f126";
}

.flaticon-grid:before {
  content: "\\f127";
}

.flaticon-text:before {
  content: "\\f128";
}

.flaticon-draft:before {
  content: "\\f129";
}

.flaticon-writing:before {
  content: "\\f12a";
}

.flaticon-flag:before {
  content: "\\f12b";
}

.flaticon-waiting:before {
  content: "\\f12c";
}

.flaticon-questions:before {
  content: "\\f12d";
}

@font-face {
  font-family: "cryptocoins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_53___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_54___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_55___}) format("truetype");
}
/* .cc:before { */
.cc::before {
  font-family: "cryptocoins";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  /* speak: none; only necessary if not using the private unicode range (firstGlyph option) */
  text-decoration: none;
  text-transform: none;
}

.cc.ADA-alt::before {
  content: "\\e001";
}

.cc.ADA::before {
  content: "\\e002";
}

.cc.ADC-alt::before {
  content: "\\e003";
}

.cc.ADC::before {
  content: "\\e004";
}

.cc.AEON-alt::before {
  content: "\\e005";
}

.cc.AEON::before {
  content: "\\e006";
}

.cc.AMP-alt::before {
  content: "\\e007";
}

.cc.AMP::before {
  content: "\\e008";
}

.cc.ANC-alt::before {
  content: "\\e009";
}

.cc.ANC::before {
  content: "\\e00a";
}

.cc.ARCH-alt::before {
  content: "\\e00b";
}

.cc.ARCH::before {
  content: "\\e00c";
}

.cc.ARDR-alt::before {
  content: "\\e00d";
}

.cc.ARDR::before {
  content: "\\e00e";
}

.cc.ARK-alt::before {
  content: "\\e00f";
}

.cc.ARK::before {
  content: "\\e010";
}

.cc.AST::before {
  content: "\\e011";
}

.cc.AUR-alt::before {
  content: "\\e012";
}

.cc.AUR::before {
  content: "\\e013";
}

.cc.BANX-alt::before {
  content: "\\e014";
}

.cc.BANX::before {
  content: "\\e015";
}

.cc.BAT-alt::before {
  content: "\\e016";
}

.cc.BAT::before {
  content: "\\e017";
}

.cc.BAY-alt::before {
  content: "\\e018";
}

.cc.BAY::before {
  content: "\\e019";
}

.cc.BC-alt::before {
  content: "\\e01a";
}

.cc.BLK-alt::before {
  content: "\\e01a";
}

.cc.BC::before {
  content: "\\e01b";
}

.cc.BLK::before {
  content: "\\e01b";
}

.cc.BCH-alt::before {
  content: "\\e01c";
}

.cc.BCC-alt::before {
  content: "\\e01c";
}

.cc.BCH::before {
  content: "\\e01d";
}

.cc.BCC::before {
  content: "\\e01d";
}

.cc.BCN-alt::before {
  content: "\\e01e";
}

.cc.BCN::before {
  content: "\\e01f";
}

.cc.BCY::before {
  content: "\\e020";
}

.cc.BELA::before {
  content: "\\e021";
}

.cc.BFT-alt::before {
  content: "\\e022";
}

.cc.BFT::before {
  content: "\\e023";
}

.cc.BLZ::before {
  content: "\\e024";
}

.cc.BNB::before {
  content: "\\e025";
}

.cc.BRK-alt::before {
  content: "\\e026";
}

.cc.BRK::before {
  content: "\\e027";
}

.cc.BRX-alt::before {
  content: "\\e028";
}

.cc.BRX::before {
  content: "\\e029";
}

.cc.BSD-alt::before {
  content: "\\e02a";
}

.cc.BSD::before {
  content: "\\e02b";
}

.cc.BTA::before {
  content: "\\e02c";
}

.cc.BTC-alt::before {
  content: "\\e02d";
}

.cc.BTC::before {
  content: "\\e02e";
}

.cc.BTCD-alt::before {
  content: "\\e02f";
}

.cc.BTCD::before {
  content: "\\e030";
}

.cc.BTCP-alt::before {
  content: "\\e031";
}

.cc.BTCP::before {
  content: "\\e032";
}

.cc.BTG::before {
  content: "\\e033";
}

.cc.BTM-alt::before {
  content: "\\e034";
}

.cc.BTM::before {
  content: "\\e035";
}

.cc.BTS-alt::before {
  content: "\\e036";
}

.cc.BTS::before {
  content: "\\e037";
}

.cc.BURST::before {
  content: "\\e038";
}

.cc.CLAM-alt::before {
  content: "\\e039";
}

.cc.CLAM::before {
  content: "\\e03a";
}

.cc.CLOAK-alt::before {
  content: "\\e03b";
}

.cc.CLOAK::before {
  content: "\\e03c";
}

.cc.CVC-alt::before {
  content: "\\e03d";
}

.cc.CVC::before {
  content: "\\e03e";
}

.cc.DAO-alt::before {
  content: "\\e03f";
}

.cc.DAO::before {
  content: "\\e040";
}

.cc.DASH-alt::before {
  content: "\\e041";
}

.cc.DASH::before {
  content: "\\e042";
}

.cc.DCR-alt::before {
  content: "\\e043";
}

.cc.DCR::before {
  content: "\\e044";
}

.cc.DCT-alt::before {
  content: "\\e045";
}

.cc.DCT::before {
  content: "\\e046";
}

.cc.DGB-alt::before {
  content: "\\e047";
}

.cc.DGB::before {
  content: "\\e048";
}

.cc.DGD::before {
  content: "\\e049";
}

.cc.DGX::before {
  content: "\\e04a";
}

.cc.DMD-alt::before {
  content: "\\e04b";
}

.cc.DMD::before {
  content: "\\e04c";
}

.cc.DOGE-alt::before {
  content: "\\e04d";
}

.cc.DOGE::before {
  content: "\\e04e";
}

.cc.EMC-alt::before {
  content: "\\e04f";
}

.cc.EMC::before {
  content: "\\e050";
}

.cc.EMC2-alt::before {
  content: "\\e051";
}

.cc.EMC2::before {
  content: "\\e052";
}

.cc.EOS-alt::before {
  content: "\\e053";
}

.cc.EOS::before {
  content: "\\e054";
}

.cc.ERC-alt::before {
  content: "\\e055";
}

.cc.ERC::before {
  content: "\\e056";
}

.cc.ETC-alt::before {
  content: "\\e057";
}

.cc.ETC::before {
  content: "\\e058";
}

.cc.ETH-alt::before {
  content: "\\e059";
}

.cc.ETH::before {
  content: "\\e05a";
}

.cc.EXP-alt::before {
  content: "\\e05b";
}

.cc.EXP::before {
  content: "\\e05c";
}

.cc.FC2-alt::before {
  content: "\\e05d";
}

.cc.FC2::before {
  content: "\\e05e";
}

.cc.FCT-alt::before {
  content: "\\e05f";
}

.cc.FCT::before {
  content: "\\e060";
}

.cc.FLDC-alt::before {
  content: "\\e061";
}

.cc.FLDC::before {
  content: "\\e062";
}

.cc.FLO-alt::before {
  content: "\\e063";
}

.cc.FLO::before {
  content: "\\e064";
}

.cc.FRK-alt::before {
  content: "\\e065";
}

.cc.FRK::before {
  content: "\\e066";
}

.cc.FTC-alt::before {
  content: "\\e067";
}

.cc.FTC::before {
  content: "\\e068";
}

.cc.FUN::before {
  content: "\\e069";
}

.cc.GAME-alt::before {
  content: "\\e06a";
}

.cc.GAME::before {
  content: "\\e06b";
}

.cc.GBYTE-alt::before {
  content: "\\e06c";
}

.cc.GBYTE::before {
  content: "\\e06d";
}

.cc.GDC-alt::before {
  content: "\\e06e";
}

.cc.GDC::before {
  content: "\\e06f";
}

.cc.GEMZ-alt::before {
  content: "\\e070";
}

.cc.GEMZ::before {
  content: "\\e071";
}

.cc.GLD-alt::before {
  content: "\\e072";
}

.cc.GLD::before {
  content: "\\e073";
}

.cc.GNO-alt::before {
  content: "\\e074";
}

.cc.GNO::before {
  content: "\\e075";
}

.cc.GNT-alt::before {
  content: "\\e076";
}

.cc.GNT::before {
  content: "\\e077";
}

.cc.GOLOS-alt::before {
  content: "\\e078";
}

.cc.GOLOS::before {
  content: "\\e079";
}

.cc.GRC-alt::before {
  content: "\\e07a";
}

.cc.GRC::before {
  content: "\\e07b";
}

.cc.GRS::before {
  content: "\\e07c";
}

.cc.HEAT-alt::before {
  content: "\\e07d";
}

.cc.HEAT::before {
  content: "\\e07e";
}

.cc.HSR::before {
  content: "\\e07f";
}

.cc.HUC-alt::before {
  content: "\\e080";
}

.cc.HUC::before {
  content: "\\e081";
}

.cc.ICN-alt::before {
  content: "\\e082";
}

.cc.ICN::before {
  content: "\\e083";
}

.cc.ICX::before {
  content: "\\e084";
}

.cc.IFC-alt::before {
  content: "\\e085";
}

.cc.IFC::before {
  content: "\\e086";
}

.cc.INCNT-alt::before {
  content: "\\e087";
}

.cc.INCNT::before {
  content: "\\e088";
}

.cc.IOC-alt::before {
  content: "\\e089";
}

.cc.IOC::before {
  content: "\\e08a";
}

.cc.IOTA-alt::before {
  content: "\\e08b";
}

.cc.IOTA::before {
  content: "\\e08c";
}

.cc.JBS-alt::before {
  content: "\\e08d";
}

.cc.JBS::before {
  content: "\\e08e";
}

.cc.KMD-alt::before {
  content: "\\e08f";
}

.cc.KMD::before {
  content: "\\e090";
}

.cc.KOBO::before {
  content: "\\e091";
}

.cc.KORE-alt::before {
  content: "\\e092";
}

.cc.KORE::before {
  content: "\\e093";
}

.cc.LBC-alt::before {
  content: "\\e094";
}

.cc.LBC::before {
  content: "\\e095";
}

.cc.LDOGE-alt::before {
  content: "\\e096";
}

.cc.LDOGE::before {
  content: "\\e097";
}

.cc.LSK-alt::before {
  content: "\\e098";
}

.cc.LSK::before {
  content: "\\e099";
}

.cc.LTC-alt::before {
  content: "\\e09a";
}

.cc.LTC::before {
  content: "\\e09b";
}

.cc.MAID-alt::before {
  content: "\\e09c";
}

.cc.MAID::before {
  content: "\\e09d";
}

.cc.MARKS-alt::before {
  content: "\\e09e";
}

.cc.MARKS::before {
  content: "\\e09f";
}

.cc.Bitmark::before {
  content: "\\e09f";
}

.cc.MCO-alt::before {
  content: "\\e0a0";
}

.cc.MCO::before {
  content: "\\e0a1";
}

.cc.MINT-alt::before {
  content: "\\e0a2";
}

.cc.MINT::before {
  content: "\\e0a3";
}

.cc.MONA-alt::before {
  content: "\\e0a4";
}

.cc.MONA::before {
  content: "\\e0a5";
}

.cc.MRC::before {
  content: "\\e0a6";
}

.cc.MSC-alt::before {
  content: "\\e0a7";
}

.cc.MSC::before {
  content: "\\e0a8";
}

.cc.MTL-alt::before {
  content: "\\e0a9";
}

.cc.MTL::before {
  content: "\\e0aa";
}

.cc.MTR-alt::before {
  content: "\\e0ab";
}

.cc.MTR::before {
  content: "\\e0ac";
}

.cc.MUE-alt::before {
  content: "\\e0ad";
}

.cc.MUE::before {
  content: "\\e0ae";
}

.cc.MYST-alt::before {
  content: "\\e0af";
}

.cc.MYST::before {
  content: "\\e0b0";
}

.cc.NAV-alt::before {
  content: "\\e0b1";
}

.cc.NAV::before {
  content: "\\e0b2";
}

.cc.NBT::before {
  content: "\\e0b3";
}

.cc.USNBT::before {
  content: "\\e0b3";
}

.cc.NEO-alt::before {
  content: "\\e0b4";
}

.cc.NEO::before {
  content: "\\e0b5";
}

.cc.GAS::before {
  content: "\\e0b5";
}

.cc.NEOS-alt::before {
  content: "\\e0b6";
}

.cc.NEOS::before {
  content: "\\e0b7";
}

.cc.NEU-alt::before {
  content: "\\e0b8";
}

.cc.NEU::before {
  content: "\\e0b9";
}

.cc.NLG-alt::before {
  content: "\\e0ba";
}

.cc.NLG::before {
  content: "\\e0bb";
}

.cc.NMC-alt::before {
  content: "\\e0bc";
}

.cc.NMC::before {
  content: "\\e0bd";
}

.cc.NMR::before {
  content: "\\e0be";
}

.cc.NOTE-alt::before {
  content: "\\e0bf";
}

.cc.NOTE::before {
  content: "\\e0c0";
}

.cc.NVC-alt::before {
  content: "\\e0c1";
}

.cc.NVC::before {
  content: "\\e0c2";
}

.cc.NXT-alt::before {
  content: "\\e0c3";
}

.cc.NXT::before {
  content: "\\e0c4";
}

.cc.OK-alt::before {
  content: "\\e0c5";
}

.cc.OK::before {
  content: "\\e0c6";
}

.cc.OMG-alt::before {
  content: "\\e0c7";
}

.cc.OMG::before {
  content: "\\e0c8";
}

.cc.OMNI-alt::before {
  content: "\\e0c9";
}

.cc.OMNI::before {
  content: "\\e0ca";
}

.cc.OPAL-alt::before {
  content: "\\e0cb";
}

.cc.OPAL::before {
  content: "\\e0cc";
}

.cc.PART-alt::before {
  content: "\\e0cd";
}

.cc.PART::before {
  content: "\\e0ce";
}

.cc.PASC::before {
  content: "\\e0cf";
}

.cc.PIGGY-alt::before {
  content: "\\e0d0";
}

.cc.PIGGY::before {
  content: "\\e0d1";
}

.cc.PINK-alt::before {
  content: "\\e0d2";
}

.cc.PINK::before {
  content: "\\e0d3";
}

.cc.PIVX-alt::before {
  content: "\\e0d4";
}

.cc.PIVX::before {
  content: "\\e0d5";
}

.cc.POT-alt::before {
  content: "\\e0d6";
}

.cc.POT::before {
  content: "\\e0d7";
}

.cc.PPC-alt::before {
  content: "\\e0d8";
}

.cc.PPC::before {
  content: "\\e0d9";
}

.cc.PPT::before {
  content: "\\e0da";
}

.cc.QRK-alt::before {
  content: "\\e0db";
}

.cc.QRK::before {
  content: "\\e0dc";
}

.cc.QTUM-alt::before {
  content: "\\e0dd";
}

.cc.QTUM::before {
  content: "\\e0de";
}

.cc.RADS-alt::before {
  content: "\\e0df";
}

.cc.RADS::before {
  content: "\\e0e0";
}

.cc.RBIES-alt::before {
  content: "\\e0e1";
}

.cc.RBIES::before {
  content: "\\e0e2";
}

.cc.RBT-alt::before {
  content: "\\e0e3";
}

.cc.RBT::before {
  content: "\\e0e4";
}

.cc.RBY-alt::before {
  content: "\\e0e5";
}

.cc.RBY::before {
  content: "\\e0e6";
}

.cc.RDD-alt::before {
  content: "\\e0e7";
}

.cc.RDD::before {
  content: "\\e0e8";
}

.cc.REP-alt::before {
  content: "\\e0e9";
}

.cc.REP::before {
  content: "\\e0ea";
}

.cc.RHOC::before {
  content: "\\e0eb";
}

.cc.RIC-alt::before {
  content: "\\e0ec";
}

.cc.RIC::before {
  content: "\\e0ed";
}

.cc.RISE-alt::before {
  content: "\\e0ee";
}

.cc.RISE::before {
  content: "\\e0ef";
}

.cc.SALT-alt::before {
  content: "\\e0f0";
}

.cc.SALT::before {
  content: "\\e0f1";
}

.cc.SAR-alt::before {
  content: "\\e0f2";
}

.cc.SAR::before {
  content: "\\e0f3";
}

.cc.SCOT-alt::before {
  content: "\\e0f4";
}

.cc.SCOT::before {
  content: "\\e0f5";
}

.cc.SDC-alt::before {
  content: "\\e0f6";
}

.cc.SDC::before {
  content: "\\e0f7";
}

.cc.SIA-alt::before {
  content: "\\e0f8";
}

.cc.SIA::before {
  content: "\\e0f9";
}

.cc.SC::before {
  content: "\\e0f9";
}

.cc.SJCX-alt::before {
  content: "\\e0fa";
}

.cc.SJCX::before {
  content: "\\e0fb";
}

.cc.STORJ::before {
  content: "\\e0fb";
}

.cc.SLG-alt::before {
  content: "\\e0fc";
}

.cc.SLG::before {
  content: "\\e0fd";
}

.cc.SLS-alt::before {
  content: "\\e0fe";
}

.cc.SLS::before {
  content: "\\e0ff";
}

.cc.SNRG-alt::before {
  content: "\\e100";
}

.cc.SNRG::before {
  content: "\\e101";
}

.cc.SNT::before {
  content: "\\e102";
}

.cc.START-alt::before {
  content: "\\e103";
}

.cc.START::before {
  content: "\\e104";
}

.cc.STEEM-alt::before {
  content: "\\e105";
}

.cc.STEEM::before {
  content: "\\e106";
}

.cc.SBD::before {
  content: "\\e106";
}

.cc.STRAT-alt::before {
  content: "\\e107";
}

.cc.STRAT::before {
  content: "\\e108";
}

.cc.SWIFT-alt::before {
  content: "\\e109";
}

.cc.SWIFT::before {
  content: "\\e10a";
}

.cc.SYNC-alt::before {
  content: "\\e10b";
}

.cc.SYNC::before {
  content: "\\e10c";
}

.cc.SYS-alt::before {
  content: "\\e10d";
}

.cc.SYS::before {
  content: "\\e10e";
}

.cc.TRIG-alt::before {
  content: "\\e10f";
}

.cc.TRIG::before {
  content: "\\e110";
}

.cc.TRX::before {
  content: "\\e111";
}

.cc.TX-alt::before {
  content: "\\e112";
}

.cc.TX::before {
  content: "\\e113";
}

.cc.UBQ-alt::before {
  content: "\\e114";
}

.cc.UBQ::before {
  content: "\\e115";
}

.cc.UNITY-alt::before {
  content: "\\e116";
}

.cc.UNITY::before {
  content: "\\e117";
}

.cc.USDT-alt::before {
  content: "\\e118";
}

.cc.USDT::before {
  content: "\\e119";
}

.cc.VERI::before {
  content: "\\e11a";
}

.cc.VET::before {
  content: "\\e11b";
}

.cc.VIA-alt::before {
  content: "\\e11c";
}

.cc.VIA::before {
  content: "\\e11d";
}

.cc.VIOR-alt::before {
  content: "\\e11e";
}

.cc.VIOR::before {
  content: "\\e11f";
}

.cc.VNL-alt::before {
  content: "\\e120";
}

.cc.VNL::before {
  content: "\\e121";
}

.cc.VPN-alt::before {
  content: "\\e122";
}

.cc.VPN::before {
  content: "\\e123";
}

.cc.VRC-alt::before {
  content: "\\e124";
}

.cc.VRC::before {
  content: "\\e125";
}

.cc.VTC-alt::before {
  content: "\\e126";
}

.cc.VTC::before {
  content: "\\e127";
}

.cc.WAVES-alt::before {
  content: "\\e128";
}

.cc.WAVES::before {
  content: "\\e129";
}

.cc.XAI-alt::before {
  content: "\\e12a";
}

.cc.XAI::before {
  content: "\\e12b";
}

.cc.XBC::before {
  content: "\\e12c";
}

.cc.XBS-alt::before {
  content: "\\e12d";
}

.cc.XBS::before {
  content: "\\e12e";
}

.cc.XCP-alt::before {
  content: "\\e12f";
}

.cc.XCP::before {
  content: "\\e130";
}

.cc.XEM-alt::before {
  content: "\\e131";
}

.cc.XEM::before {
  content: "\\e132";
}

.cc.XLM-alt::before {
  content: "\\e133";
}

.cc.XLM::before {
  content: "\\e134";
}

.cc.XMR::before {
  content: "\\e135";
}

.cc.XMY::before {
  content: "\\e136";
}

.cc.XPM-alt::before {
  content: "\\e137";
}

.cc.XPM::before {
  content: "\\e138";
}

.cc.XRB::before {
  content: "\\e139";
}

.cc.XRP-alt::before {
  content: "\\e13a";
}

.cc.XRP::before {
  content: "\\e13b";
}

.cc.XTZ-alt::before {
  content: "\\e13c";
}

.cc.XTZ::before {
  content: "\\e13d";
}

.cc.XVC-alt::before {
  content: "\\e13e";
}

.cc.XVC::before {
  content: "\\e13f";
}

.cc.XVG-alt::before {
  content: "\\e140";
}

.cc.XVG::before {
  content: "\\e141";
}

.cc.XZC-alt::before {
  content: "\\e142";
}

.cc.XZC::before {
  content: "\\e143";
}

.cc.YBC-alt::before {
  content: "\\e144";
}

.cc.YBC::before {
  content: "\\e145";
}

.cc.ZEC-alt::before {
  content: "\\e146";
}

.cc.ZEC::before {
  content: "\\e147";
}

.cc.ZEIT-alt::before {
  content: "\\e148";
}

.cc.ZEIT::before {
  content: "\\e149";
}

.cc.ZRX-alt::before {
  content: "\\e14a";
}

.cc.ZRX::before {
  content: "\\e14b";
}

.ADA {
  color: #3cc8c8;
}

.ADC {
  color: #3cb0e5;
}

.AEON {
  color: #164450;
}

.AMP {
  color: #048dd2;
}

.ANC {
  color: #000;
}

.ARCH {
  color: #002652;
}

.ARDR {
  color: #1162a1;
}

.ARK {
  color: #f70000;
}

.AST {
  color: #18f18f;
}

.AUR {
  color: #136c5e;
}

.BANX {
  color: #225ba6;
}

.BAT {
  color: #9e1f63;
}

.BAY {
  color: #584ba1;
}

.BC {
  color: #202121;
}

.BCN {
  color: #964f51;
}

.BCY {
  color: #123a5a;
}

.BELA {
  color: #009ef9;
}

.BFT {
  color: #4fc3f7;
}

.BLZ {
  color: #6be6be;
}

.BRK {
  color: #194fa0;
}

.BRX {
  color: #a8c300;
}

.BSD {
  color: #1186e7;
}

.BTA {
  color: #210094;
}

.BTC,
.BCH {
  color: #f7931a;
}

.BTG {
  color: #eba809;
}

.BTCD {
  color: #2a72dc;
}

.BTCP {
  color: #272d63;
}

.BTM {
  color: #9fa8b4;
}

.BTS {
  color: #03a9e0;
}

.BURST {
  color: #2d2d2d;
}

.CLAM {
  color: #d6ab31;
}

.CLOAK {
  color: #df3f1e;
}

.CVC {
  color: #3ab03e;
}

.DAO {
  color: #ff3b3b;
}

.DASH {
  color: #1c75bc;
}

.DCR {
  color: #3b7cfb;
}

.DCT {
  color: #008770;
}

.DGB {
  color: #0066cc;
}

.DGD,
.DGX {
  color: #d8a24a;
}

.DMD {
  color: #5497b2;
}

.DOGE {
  color: #ba9f33;
}

.EMC {
  color: #674c8c;
}

.EMC2 {
  color: #00ccff;
}

.EOS {
  color: #19191a;
}

.ERC {
  color: #101e84;
}

.ETC {
  color: #669073;
}

.ETH {
  color: #282828;
}

.EXP {
  color: #ffaa5c;
}

.FC2 {
  color: #040405;
}

.FCT {
  color: #2175bb;
}

.FLDC {
  color: #c40e09;
}

.FLO {
  color: #1358c8;
}

.FRK {
  color: #0633cd;
}

.FTC {
  color: #679ef1;
}

.FUN {
  color: #ef3a5c;
}

.GAME {
  color: #ed1b24;
}

.GBYTE {
  color: #2c3e50;
}

.GDC {
  color: #e9a226;
}

.GEMZ {
  color: #e86060;
}

.GLD {
  color: #e8be24;
}

.GNO {
  color: #00a6c4;
}

.GNT {
  color: #00d6e3;
}

.GOLOS {
  color: #2670b7;
}

.GRC {
  color: #88a13c;
}

.GRS {
  color: #648fa0;
}

.HEAT {
  color: #ff5606;
}

.HUC {
  color: #ffc018;
}

.ICN {
  color: #4c6f8c;
}

.ICX {
  color: #22c8cc;
}

.IFC {
  color: #ed272d;
}

.INCNT {
  color: #f2932f;
}

.IOC {
  color: #2fa3de;
}

.IOTA {
  color: #ffffff;
}

.JBS {
  color: #1a8bcd;
}

.KMD {
  color: #326464;
}

.KOBO {
  color: #80c342;
}

.KORE {
  color: #df4124;
}

.LBC {
  color: #015c47;
}

.LDOGE {
  color: #ffcc00;
}

.LSK {
  color: #0d4ea0;
}

.LTC {
  color: #838383;
}

.MAID {
  color: #5492d6;
}

.MARKS {
  color: #504c4c;
}

.MCO {
  color: #0d3459;
}

.MINT {
  color: #006835;
}

.MONA {
  color: #a99364;
}

.MRC {
  color: #4279bd;
}

.MSC {
  color: #1d4983;
}

.MTL {
  color: #242424;
}

.MTR {
  color: #b92429;
}

.MUE {
  color: #f5a10e;
}

.NAV {
  color: #7d59b5;
}

.MYST {
  color: #f5a10e;
}

.NBT {
  color: #ffc93d;
}

.NEO {
  color: #58bf00;
}

.NEOS {
  color: #1d1d1b;
}

.NEU {
  color: #2983c0;
}

.NLG {
  color: #003e7e;
}

.NMC {
  color: #6787b7;
}

.NMR {
  color: #8de8de;
}

.NOTE {
  color: #42daff;
}

.NVC {
  color: #ecab41;
}

.NXT {
  color: #008fbb;
}

.OK {
  color: #0165a4;
}

.OMG {
  color: #1a53f0;
}

.OMNI {
  color: #18347e;
}

.OPAL {
  color: #7193aa;
}

.PART {
  color: #05d5a3;
}

.PASC {
  color: #f7931e;
}

.PIGGY {
  color: #f27a7a;
}

.PINK {
  color: #ed31ca;
}

.PIVX {
  color: #3b2f4d;
}

.POT {
  color: #105b2f;
}

.PPC {
  color: #3fa30c;
}

.PPT {
  color: #5a9ef6;
}

.QRK {
  color: #22aabf;
}

.QTUM {
  color: #359bce;
}

.RADS {
  color: #924cea;
}

.RBIES {
  color: #c62436;
}

.RBT {
  color: #0d4982;
}

.RBY {
  color: #d31f26;
}

.RDD {
  color: #ed1c24;
}

.REP {
  color: #40a2cb;
}

.RIC {
  color: #60e4dd;
}

.RHOC {
  color: #c26c26;
}

.RISE {
  color: #43cea2;
}

.SALT {
  color: #373c43;
}

.SAR {
  color: #1b72b8;
}

.SCOT {
  color: #3498db;
}

.SDC {
  color: #981d2d;
}

.SIA {
  color: #00cba0;
}

.SJCX {
  color: #003366;
}

.SLG {
  color: #5a6875;
}

.SLS {
  color: #1eb549;
}

.SNRG {
  color: #160363;
}

.START {
  color: #01aef0;
}

.STEEM {
  color: #1a5099;
}

.STRAT {
  color: #2398dd;
}

.SWIFT {
  color: #428bca;
}

.SYNC {
  color: #008dd2;
}

.SYS {
  color: #0098da;
}

.TRIG {
  color: #1fbff4;
}

.TRX {
  color: #c62734;
}

.TX {
  color: #1f8bcc;
}

.UBQ {
  color: #00ec8d;
}

.UNITY {
  color: #ed8527;
}

.USDT {
  color: #2ca07a;
}

.VEN {
  color: #15bdff;
}

.VIA {
  color: #565656;
}

.VIOR {
  color: #1f52a4;
}

.VNL {
  color: #404249;
}

.VPN {
  color: #589700;
}

.VRC {
  color: #418bca;
}

.VTC {
  color: #1b5c2e;
}

.WAVES {
  color: #24aad6;
}

.XAI {
  color: #2ef99f;
}

.XBC {
  color: #f7931a;
}

.XBS {
  color: #d3261d;
}

.XCP {
  color: #ec1550;
}

.XEM {
  color: #41bf76;
}

.XLM {
  color: #08b5e5;
}

.XMR {
  color: #ff6600;
}

.XMY {
  color: #bc3182;
}

.XPM {
  color: #e5b625;
}

.XRP {
  color: #346aa9;
}

.XTZ {
  color: #a6df00;
}

.XVC {
  color: #b50126;
}

.XVG {
  color: #42afb2;
}

.XZC {
  color: #23b852;
}

.YBC {
  color: #d6c154;
}

.ZEC {
  color: #e5a93d;
}

.ZEIT {
  color: #acacac;
}

.ZRX {
  color: #302c2c;
}

/* new logo start */
.b-brand {
  display: flex;
  align-items: center;
}
.b-brand .b-bg {
  background: linear-gradient(-135deg, #1de9b6 0%, #1dc4e9 100%);
  border-radius: 10px;
  width: 35px;
  height: 35px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.b-brand .b-bg i {
  color: #fff;
}
.b-brand .b-title {
  margin-left: 10px;
  font-weight: 100;
  color: #fff;
  font-size: 18px;
}

.navbar-collapsed .b-brand .b-title {
  transform: rotateY(-90deg);
  transform-origin: 0 0;
  opacity: 0;
  transition: all 0.3s ease-in-out;
}
.navbar-collapsed .mobile-menu {
  transform: rotateY(-90deg);
  transform-origin: 0 0;
  opacity: 0;
  transition: all 0.3s ease-in-out;
}
.navbar-collapsed:hover .b-brand .b-title {
  transform: rotateY(0deg);
  opacity: 1;
}
.navbar-collapsed:hover .mobile-menu {
  transition-delay: 0.3s;
  transform: rotateY(0deg);
  opacity: 1;
}

/* header css start */
.pcoded-header {
  z-index: 1028;
  position: relative;
  display: flex;
  min-height: 70px;
  padding: 0;
  position: relative;
  top: 0;
  background: transparent;
  color: #3f4d67;
  width: calc(100% - 264px);
  margin-left: 264px;
  transition: all 0.3s ease-in-out;
}
.pcoded-header .m-header {
  display: none;
}
.pcoded-header .m-header .logo-dark,
.pcoded-header .m-header .logo-thumb {
  display: none;
}
.pcoded-header .input-group {
  background: transparent;
}
.pcoded-header .input-group .input-group-text {
  margin-right: 0;
}
.pcoded-header .input-group {
  background: transparent;
}
.pcoded-header .input-group .input-group-text,
.pcoded-header a,
.pcoded-header .btn, .pcoded-header.dropdown-toggle {
  color: #3f4d67;
}
.pcoded-header .input-group .input-group-text:hover,
.pcoded-header a:hover,
.pcoded-header .btn:hover, .pcoded-header.dropdown-toggle:hover {
  color: #04a9f5;
}
.pcoded-header .navbar-nav {
  padding-left: 0;
  list-style: none;
  margin-bottom: 0;
  display: inline-block;
}
.pcoded-header .navbar-nav > li {
  line-height: 70px;
  display: inline-block;
  padding: 0 12px;
}
.pcoded-header .navbar-nav > li .nav-link {
  padding: 0;
}
.pcoded-header .navbar-nav > li:first-child {
  padding-left: 25px;
}
.pcoded-header .navbar-nav > li:last-child {
  padding-right: 40px;
}
.pcoded-header .mr-auto .dropdown-menu {
  margin-left: -20px;
}
.pcoded-header .ml-auto {
  float: right;
}
.pcoded-header .main-search .input-group {
  border-radius: 20px;
  padding: 0;
  display: flex;
  align-items: center;
}
.pcoded-header .main-search .input-group .form-control,
.pcoded-header .main-search .input-group .input-group-text {
  background: transparent;
  border: none;
  border-radius: 0;
  padding: 0;
}
.pcoded-header .main-search .input-group .search-close {
  display: none;
}
.pcoded-header .main-search .input-group .search-btn {
  border-radius: 50%;
  padding: 0;
  background: transparent;
  border-color: transparent;
  box-shadow: none;
}
.pcoded-header .main-search .input-group .form-control {
  transition: all 0.3s ease-in-out;
  width: 0;
  font-size: 14px;
}
.pcoded-header .main-search .input-group .form-control:active, .pcoded-header .main-search .input-group .form-control:focus, .pcoded-header .main-search .input-group .form-control:hover,
.pcoded-header .main-search .input-group .search-btn:active,
.pcoded-header .main-search .input-group .search-btn:focus,
.pcoded-header .main-search .input-group .search-btn:hover {
  outline: none;
  box-shadow: none;
}
.pcoded-header .main-search.open .input-group {
  background: #fff;
  border: 1px solid #f1f1f1;
  box-shadow: 0 6px 12px -5px rgba(65, 76, 78, 0.08);
  padding: 5px 5px 5px 20px;
}
.pcoded-header .main-search.open .input-group .search-close {
  display: flex;
}
.pcoded-header .main-search.open .input-group .search-btn {
  padding: 5px;
  margin-left: 5px;
  background: #04a9f5;
  border-color: #04a9f5;
}
.pcoded-header .main-search.open .input-group .search-btn .input-group-text {
  color: #fff;
}
.pcoded-header .main-search.open .input-group .form-control {
  transition: all 0.3s ease-in-out;
  width: 0;
}
.pcoded-header .main-search.open .input-group .form-control:active, .pcoded-header .main-search.open .input-group .form-control:focus, .pcoded-header .main-search.open .input-group .form-control:hover,
.pcoded-header .main-search.open .input-group .search-btn:active,
.pcoded-header .main-search.open .input-group .search-btn:focus,
.pcoded-header .main-search.open .input-group .search-btn:hover {
  outline: none;
  box-shadow: none;
}
.pcoded-header .dropdown .dropdown-toggle {
  line-height: 70px;
  display: inline-block;
  padding-right: 15px;
}
.pcoded-header .dropdown .dropdown-toggle.show, .pcoded-header .dropdown .dropdown-toggle:active {
  background: transparent;
}
.pcoded-header .dropdown .dropdown-toggle:after {
  content: "\\e842";
  font-family: "feather";
  font-size: 15px;
  border: none;
  position: absolute;
  top: 0;
  right: 0;
}
.pcoded-header .dropdown .dropdown-menu {
  position: absolute;
  border: none;
  margin-top: -6px;
  min-width: 290px;
}
.pcoded-header .dropdown .dropdown-menu.show:before {
  display: none;
}
.pcoded-header .dropdown .dropdown-menu li {
  line-height: 1.2;
}
.pcoded-header .dropdown .dropdown-menu li a {
  padding: 10px;
  font-size: 14px;
}
.pcoded-header .dropdown .dropdown-menu li.active a, .pcoded-header .dropdown .dropdown-menu li:active a, .pcoded-header .dropdown .dropdown-menu li:focus a, .pcoded-header .dropdown .dropdown-menu li:hover a {
  color: #888;
}
.pcoded-header .dropdown.show:before {
  content: "c";
  font-family: "pct";
  position: absolute;
  left: -9px;
  top: 62px;
  z-index: 1001;
  font-size: 40px;
  line-height: 0;
  color: #fff;
  text-shadow: 0 -2px 2px rgba(65, 76, 78, 0.12);
}
.pcoded-header .dropdown .notification {
  width: 350px;
  padding: 0;
  line-height: 1.4;
  overflow: hidden;
}
.pcoded-header .dropdown .notification .noti-head {
  border-bottom: 1px solid #f1f1f1;
  padding: 15px 20px;
}
.pcoded-header .dropdown .notification .noti-head a {
  text-decoration: underline;
  font-size: 13px;
}
.pcoded-header .dropdown .notification .noti-body {
  padding: 0;
}
.pcoded-header .dropdown .notification .noti-body img {
  width: 40px;
  margin-right: 20px;
}
.pcoded-header .dropdown .notification .noti-body li {
  padding: 15px 20px;
  transition: all 0.3s ease-in-out;
}
.pcoded-header .dropdown .notification .noti-body li.n-title {
  padding-bottom: 0;
}
.pcoded-header .dropdown .notification .noti-body li.n-title p {
  margin-bottom: 5px;
}
.pcoded-header .dropdown .notification .noti-body li.notification:hover {
  background: rgba(4, 169, 245, 0.1);
}
.pcoded-header .dropdown .notification .noti-body li p {
  margin-bottom: 5px;
  font-size: 13px;
}
.pcoded-header .dropdown .notification .noti-body li p strong {
  color: #222;
}
.pcoded-header .dropdown .notification .noti-body li .n-time {
  font-size: 80%;
  float: right;
}
.pcoded-header .dropdown .notification .noti-footer {
  border-top: 1px solid #f1f1f1;
  padding: 15px 20px;
  text-align: center;
}
.pcoded-header .dropdown .notification .noti-footer a {
  text-decoration: underline;
  font-size: 13px;
}
.pcoded-header .dropdown .notification ul {
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.pcoded-header .dropdown .notification ul li {
  padding: 20px 15px;
}
.pcoded-header .dropdown .profile-notification {
  padding: 0;
  line-height: 1.4;
  overflow: hidden;
}
.pcoded-header .dropdown .profile-notification .pro-head {
  color: #fff;
  border-radius: 0.25rem 0.25rem 0 0;
  padding: 15px;
  position: relative;
  background: #04a9f5;
}
.pcoded-header .dropdown .profile-notification .pro-head img {
  width: 40px;
  margin-right: 10px;
}
.pcoded-header .dropdown .profile-notification .pro-head .dud-logout {
  color: #fff;
  padding-right: 0;
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pcoded-header .dropdown .profile-notification .pro-body {
  padding: 20px 0;
  margin-bottom: 0;
  list-style: none;
}
.pcoded-header .dropdown .profile-notification .pro-body li a {
  color: #888;
  font-size: 14px;
  padding: 10px 20px;
}
.pcoded-header .dropdown .profile-notification .pro-body li a i {
  margin-right: 10px;
}
.pcoded-header .dropdown .profile-notification .pro-body li.active, .pcoded-header .dropdown .profile-notification .pro-body li:active, .pcoded-header .dropdown .profile-notification .pro-body li:focus, .pcoded-header .dropdown .profile-notification .pro-body li:hover {
  background: rgba(4, 169, 245, 0.1);
}
.pcoded-header .dropdown .profile-notification .pro-body li.active > a, .pcoded-header .dropdown .profile-notification .pro-body li:active > a, .pcoded-header .dropdown .profile-notification .pro-body li:focus > a, .pcoded-header .dropdown .profile-notification .pro-body li:hover > a {
  background: transparent;
}
.pcoded-header .dropdown.drp-user.show:before {
  color: #04a9f5;
}

/* header css end */
/* menu[ vertical ] css start */
.mobile-menu {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 37px;
  height: 70px;
  position: absolute;
  right: 0;
  top: 0;
  padding: 0 10px;
}
.mobile-menu span {
  position: relative;
  display: block;
  width: 100%;
  height: 2.8px;
  background-color: #fff;
  transition: all 0.3s ease-in-out;
  backface-visibility: hidden;
  border-radius: 2px;
}
.mobile-menu span:after, .mobile-menu span:before {
  content: "";
  position: absolute;
  left: 0;
  height: 2.8px;
  background-color: #fff;
  transition: all 0.3s;
  backface-visibility: hidden;
  border-radius: 2px;
}
.mobile-menu span:after {
  top: 5px;
  width: 70%;
}
.mobile-menu span:before {
  top: -5px;
  width: 40%;
}
.mobile-menu.on span {
  background-color: transparent;
}
.mobile-menu.on span:after, .mobile-menu.on span:before {
  height: 2px;
  width: 100%;
}
.mobile-menu.on span:before {
  transform: rotate(45deg) translate(4px, 4px);
}
.mobile-menu.on span:after {
  transform: rotate(-45deg) translate(3px, -3px);
}

.navbar-brand {
  background: #3f4d67;
  font-size: 1.25rem;
}

.pcoded-header:before,
.pcoded-main-container:before {
  content: "";
  transition: all 0.3s ease-in-out;
}
@media screen and (max-width: 991px) {
  .pcoded-header .pcoded-content .pcoded-inner-content,
  .pcoded-main-container .pcoded-content .pcoded-inner-content {
    margin-top: 70px;
  }
}

.pcoded-navbar {
  display: block;
  z-index: 1029;
  position: fixed;
  transition: all 0.3s ease-in-out;
  box-shadow: 1px 0 20px 0 rgb(63, 77, 103);
  width: 264px;
  height: 100vh;
  top: 0;
  background: #3f4d67;
  color: #a9b7d0;
}
.pcoded-navbar ul {
  padding-left: 0;
  list-style: none;
  margin-bottom: 0;
}
.pcoded-navbar .datta-scroll.navbar-content {
  height: calc(100vh - 70px);
}
.pcoded-navbar .header-logo {
  position: relative;
  align-items: center;
  display: inline-flex;
  float: left;
  height: 70px;
  text-align: center;
  width: 264px;
  margin-right: 0;
  padding: 10px 20px;
  transition: all 0.3s ease-in-out;
}
.pcoded-navbar .header-logo .logo-dark {
  display: none;
}
.pcoded-navbar .header-logo .logo-thumb {
  transform: rotateY(-90deg);
  opacity: 0;
  position: absolute;
  transition: unset;
}
.pcoded-navbar .header-logo + .datta-scroll {
  float: left;
  display: inline-block;
}
.pcoded-navbar .mobile-menu {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 37px;
  height: 70px;
  position: absolute;
  right: 10px;
  top: 0;
  padding: 0 10px;
  transition: all 0.3s ease-in-out;
}
.pcoded-navbar .mobile-menu span {
  position: relative;
  display: block;
  width: 100%;
  height: 2.8px;
  background-color: #a9b7d0;
  transition: all 0.3s ease-in-out;
  backface-visibility: hidden;
  border-radius: 2px;
}
.pcoded-navbar .mobile-menu span:after, .pcoded-navbar .mobile-menu span:before {
  content: "";
  position: absolute;
  left: 0;
  height: 2.8px;
  background-color: #a9b7d0;
  transition: all 0.3s;
  backface-visibility: hidden;
  border-radius: 2px;
}
.pcoded-navbar .mobile-menu span:after {
  top: 5px;
  width: 70%;
}
.pcoded-navbar .mobile-menu span:before {
  top: -5px;
  width: 40%;
}
.pcoded-navbar .mobile-menu.on span {
  background-color: transparent;
}
.pcoded-navbar .mobile-menu.on span:after, .pcoded-navbar .mobile-menu.on span:before {
  height: 2px;
  width: 100%;
}
.pcoded-navbar .mobile-menu.on span:before {
  transform: rotate(45deg) translate(4px, 4px);
}
.pcoded-navbar .mobile-menu.on span:after {
  transform: rotate(-45deg) translate(3px, -3px);
}
.pcoded-navbar .pcoded-badge {
  color: #fff;
  font-size: 75%;
  position: absolute;
  right: 30px;
  top: 8px;
  padding: 2px 7px;
  border-radius: 2px;
}
.pcoded-navbar .pcoded-inner-navbar {
  flex-direction: column;
}
.pcoded-navbar .pcoded-inner-navbar > li > a .pcoded-badge {
  top: 12px;
}
.pcoded-navbar .pcoded-inner-navbar li {
  position: relative;
}
.pcoded-navbar .pcoded-inner-navbar li > a {
  text-align: left;
  padding: 7px 15px;
  margin: 5px 0 0;
  display: block;
  border-radius: 0;
  position: relative;
}
.pcoded-navbar .pcoded-inner-navbar li > a .pcoded-mtext {
  position: relative;
}
.pcoded-navbar .pcoded-inner-navbar li > a > .pcoded-micon {
  font-size: 1rem;
  padding: 4px 7px;
  margin-right: 7px;
  border-radius: 4px;
  width: 30px;
  display: inline-flex;
  align-items: center;
  height: 30px;
  text-align: center;
}
.pcoded-navbar .pcoded-inner-navbar li > a > .pcoded-micon + .pcoded-mtext {
  position: absolute;
  top: 11px;
}
.pcoded-navbar .pcoded-inner-navbar li.pcoded-hasmenu > a:after {
  content: "\\e844";
  font-family: "feather";
  font-size: 15px;
  border: none;
  position: absolute;
  top: 11px;
  right: 20px;
  transition: 0.3s ease-in-out;
}
.pcoded-navbar .pcoded-inner-navbar li.pcoded-hasmenu .pcoded-hasmenu > a:after {
  top: 6px;
}
.pcoded-navbar .pcoded-inner-navbar li.pcoded-hasmenu.pcoded-trigger > a:after {
  transform: rotate(90deg);
}
.pcoded-navbar .pcoded-inner-navbar li.pcoded-hasmenu .pcoded-submenu {
  display: none;
}
.pcoded-navbar .pcoded-inner-navbar li.pcoded-hasmenu.pcoded-trigger > .pcoded-submenu {
  display: block;
}
.pcoded-navbar .pcoded-inner-navbar li.pcoded-hasmenu.pcoded-trigger > a {
  position: relative;
}
.pcoded-navbar .pcoded-inner-navbar li.pcoded-hasmenu .pcoded-submenu li > a {
  text-align: left;
  padding: 7px 7px 7px 60px;
  margin: 0;
  display: block;
}
.pcoded-navbar .pcoded-inner-navbar li.pcoded-hasmenu .pcoded-submenu li > a:before {
  content: "";
  border-radius: 50%;
  position: absolute;
  top: 16px;
  left: 35px;
  width: 5px;
  height: 5px;
}
.pcoded-navbar .pcoded-inner-navbar li.pcoded-hasmenu .pcoded-submenu li .pcoded-submenu > li > a {
  padding: 7px 7px 7px 80px;
}
.pcoded-navbar .pcoded-inner-navbar li.pcoded-hasmenu .pcoded-submenu li .pcoded-submenu > li > a:before {
  left: 55px;
}
.pcoded-navbar .pcoded-inner-navbar li.pcoded-menu-caption {
  font-size: 10px;
  font-weight: 600;
  padding: 25px 20px 5px;
  text-transform: uppercase;
  position: relative;
}
.pcoded-navbar .pcoded-inner-navbar li.disabled > a {
  cursor: default;
  opacity: 0.5;
}
.pcoded-navbar .pcoded-submenu {
  background: #39465e;
  padding: 15px 0;
}
.pcoded-navbar a {
  color: #a9b7d0;
}
.pcoded-navbar .navbar-content,
.pcoded-navbar .navbar-wrapper {
  width: 100%;
  height: 100%;
}
.pcoded-navbar.navbar-collapsed {
  width: 80px;
  height: 100%;
  transition: all 0.3s ease-in-out;
}
.pcoded-navbar.navbar-collapsed .header-logo {
  width: 80px;
}
.pcoded-navbar.navbar-collapsed .header-logo img {
  transform: rotateY(-90deg);
  transform-origin: 0 0;
  opacity: 0;
  transition: unset;
}
.pcoded-navbar.navbar-collapsed .header-logo .logo-thumb {
  transform: rotateY(0deg);
  transform-origin: 0 0;
  opacity: 1;
  left: calc(80px / 2 - 20px);
}
.pcoded-navbar.navbar-collapsed .header-logo .mobile-menu {
  transform: rotateY(-90deg);
  transform-origin: 0 0;
  opacity: 0;
}
.pcoded-navbar.navbar-collapsed .navbar-content.ps {
  overflow: visible;
}
.pcoded-navbar.navbar-collapsed .pcoded-menu-caption {
  position: relative;
  width: 100%;
  height: auto;
  white-space: nowrap;
  overflow: hidden;
}
.pcoded-navbar.navbar-collapsed .pcoded-menu-caption > label {
  transform: rotateY(-90deg);
  transform-origin: 0 0;
  opacity: 0;
  transition: all 0.3s ease-in-out;
}
.pcoded-navbar.navbar-collapsed .pcoded-menu-caption:after {
  content: "";
  position: absolute;
  top: 25px;
  left: 15px;
  width: calc(100% - 30px);
  height: 1px;
  background: rgba(0, 0, 0, 0.1);
}
.pcoded-navbar.navbar-collapsed .pcoded-inner-navbar > li > a {
  z-index: 1026;
  padding: 7px 25px;
}
.pcoded-navbar.navbar-collapsed .pcoded-inner-navbar > li > a > .pcoded-mtext {
  transform: rotateY(-90deg);
  transform-origin: 0 0;
  opacity: 0;
  transition: all 0.3s ease-in-out;
}
.pcoded-navbar.navbar-collapsed .pcoded-inner-navbar > li.pcoded-hasmenu > a:after {
  right: 12px;
}
.pcoded-navbar.navbar-collapsed .pcoded-inner-navbar > li.pcoded-trigger .pcoded-submenu:after {
  content: "";
  position: absolute;
  top: 49px;
  left: calc(80px / 2 - 3px);
  width: 1px;
  height: calc(100% - 49px);
  background: rgba(169, 183, 208, 0.2);
}
.pcoded-navbar.navbar-collapsed .pcoded-inner-navbar > li.pcoded-trigger .pcoded-submenu li a {
  color: transparent;
  white-space: nowrap;
}
.pcoded-navbar.navbar-collapsed .pcoded-inner-navbar > li.pcoded-trigger .pcoded-submenu .pcoded-submenu li a:before {
  opacity: 0;
}
.pcoded-navbar.navbar-collapsed ~ .pcoded-header {
  width: calc(100% - 80px);
}
.pcoded-navbar.navbar-collapsed ~ .pcoded-header,
.pcoded-navbar.navbar-collapsed ~ .pcoded-main-container {
  margin-left: 80px;
}
.pcoded-navbar.navbar-collapsed .pcoded-badge {
  transform: rotateX(-90deg);
  transform-origin: 50% 50%;
  opacity: 0;
  transition: all 0.15s ease-in-out;
}
.pcoded-navbar.navbar-collapsed:hover {
  width: 264px !important;
}
.pcoded-navbar.navbar-collapsed:hover .pcoded-badge {
  transition-delay: 0.3s;
  transform: rotateX(0deg);
  opacity: 1;
}
.pcoded-navbar.navbar-collapsed:hover .header-logo {
  width: 264px;
}
.pcoded-navbar.navbar-collapsed:hover .header-logo img {
  transform: rotateY(0deg);
  opacity: 1;
}
.pcoded-navbar.navbar-collapsed:hover .header-logo .logo-thumb {
  transform: rotateY(-90deg);
  opacity: 0;
}
.pcoded-navbar.navbar-collapsed:hover .header-logo .mobile-menu {
  display: flex;
  right: 10px;
}
.pcoded-navbar.navbar-collapsed:hover .pcoded-menu-caption > label {
  transform: rotateY(0deg);
  opacity: 1;
}
.pcoded-navbar.navbar-collapsed:hover .pcoded-menu-caption:after {
  background: transparent;
}
.pcoded-navbar.navbar-collapsed:hover .mobile-menu {
  transform: rotateY(0deg);
  opacity: 1;
}
.pcoded-navbar.navbar-collapsed:hover .pcoded-inner-navbar > li > a > .pcoded-mtext {
  transform: rotateY(0deg);
  opacity: 1;
}
.pcoded-navbar.navbar-collapsed:hover .pcoded-inner-navbar > li > a > .pcoded-mtext:after {
  opacity: 1;
  visibility: visible;
}
.pcoded-navbar.navbar-collapsed:hover .pcoded-inner-navbar > li.pcoded-hasmenu > a:after {
  transform: rotateX(0deg);
}
.pcoded-navbar.navbar-collapsed:hover .pcoded-inner-navbar > li.pcoded-hasmenu.pcoded-trigger > a:after {
  transform: rotateX(0deg) rotate(90deg);
}
.pcoded-navbar.navbar-collapsed:hover .pcoded-inner-navbar > li.pcoded-trigger .pcoded-submenu:after {
  display: none;
}
.pcoded-navbar.navbar-collapsed:hover .pcoded-inner-navbar > li.pcoded-trigger .pcoded-submenu li a {
  color: inherit;
}
.pcoded-navbar.navbar-collapsed:hover .pcoded-inner-navbar > li.pcoded-trigger .pcoded-submenu .pcoded-submenu li a:before {
  opacity: 1;
}
.pcoded-navbar .pcoded-menu-caption {
  color: #e8edf7;
}
.pcoded-navbar .pcoded-inner-navbar li > a.active, .pcoded-navbar .pcoded-inner-navbar li > a:focus, .pcoded-navbar .pcoded-inner-navbar li > a:hover {
  color: #1dc4e9;
}
.pcoded-navbar .pcoded-inner-navbar li > a .pcoded-submenu > li.active > a:before, .pcoded-navbar .pcoded-inner-navbar li > a .pcoded-submenu > li:focus > a:before, .pcoded-navbar .pcoded-inner-navbar li > a .pcoded-submenu > li:hover > a:before {
  background: #1dc4e9;
}
.pcoded-navbar .pcoded-inner-navbar > li.active:after, .pcoded-navbar .pcoded-inner-navbar > li.pcoded-trigger:after {
  content: "";
  background-color: #1dc4e9;
  z-index: 1027;
  position: absolute;
  left: 0;
  top: 5px;
  width: 3px;
  height: calc(100% - 5px);
}
.pcoded-navbar .pcoded-inner-navbar > li.active > a, .pcoded-navbar .pcoded-inner-navbar > li.pcoded-trigger > a {
  background: #333f54;
  color: #fff;
}
.pcoded-navbar .pcoded-inner-navbar > .pcoded-menu-caption.active:after, .pcoded-navbar .pcoded-inner-navbar > .pcoded-menu-caption.pcoded-trigger:after {
  display: none;
}

.pcoded-navbar.mob-open ~ .pcoded-header,
.pcoded-navbar.mob-open ~ .pcoded-main-container, .pcoded-navbar.navbar-collapsed:hover ~ .pcoded-header,
.pcoded-navbar.navbar-collapsed:hover ~ .pcoded-main-container {
  margin-left: 80px;
}
.pcoded-navbar.mob-open ~ .pcoded-header:before,
.pcoded-navbar.mob-open ~ .pcoded-main-container:before, .pcoded-navbar.navbar-collapsed:hover ~ .pcoded-header:before,
.pcoded-navbar.navbar-collapsed:hover ~ .pcoded-main-container:before {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 1;
}

/* menu [ vertical ] css end */
/* main content start */
.pcoded-content {
  position: relative;
  display: block;
  padding: 30px;
}

.pcoded-main-container {
  position: relative;
  margin: 0 auto;
  display: block;
  clear: both;
  float: unset;
  right: 0;
  margin-left: 264px;
  min-height: 100vh;
  transition: all 0.3s ease-in-out;
}

/* main content end*/
/* ==========================    Rsponsive Menu  start   ====================== */
.mob-toggler {
  display: none;
}

@media only screen and (max-width: 991px) {
  .pcoded-header {
    background: #3f4d67;
    color: #fff;
  }
  .pcoded-header .input-group-text,
  .pcoded-header a,
  .pcoded-header dropdown-toggle {
    color: #3f4d67;
  }
  .pcoded-header .input-group-text:hover,
  .pcoded-header a:hover,
  .pcoded-header dropdown-toggle:hover {
    color: #04a9f5;
  }
  .pcoded-header > .collapse.show {
    display: flex;
    background: #fff;
    box-shadow: 0 1px 20px 0 rgba(69, 90, 100, 0.08);
  }
  .pcoded-header .mob-toggler {
    display: flex;
    color: #fff;
    position: absolute;
    right: 60px;
  }
  .pcoded-header .dropdown-menu,
  .pcoded-header .dropdown-menu a,
  .pcoded-header .search-close .input-group-text {
    color: #3f4d67;
  }
  .pcoded-header .m-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 70px;
  }
  .pcoded-header .m-header .b-brand {
    margin-left: 20px;
  }
  .pcoded-header .m-header .mobile-menu {
    right: 20px;
  }
  .pcoded-header .full-screen {
    display: none;
  }
  .pcoded-header .navbar-nav > li:last-child {
    padding-right: 60px;
  }
  .pcoded-navbar {
    margin-left: -264px;
    position: fixed;
    height: 100%;
    box-shadow: none;
  }
  .pcoded-navbar .datta-scroll.navbar-content {
    height: 100%;
  }
  .pcoded-navbar ~ .pcoded-header,
  .pcoded-navbar ~ .pcoded-main-container {
    margin-left: 0;
  }
  .pcoded-navbar ~ .pcoded-header {
    width: 100%;
  }
  .pcoded-navbar .navbar-brand {
    display: none;
  }
  .pcoded-navbar.mob-open {
    margin-left: 0;
  }
  .pcoded-navbar.mob-open ~ .pcoded-header,
  .pcoded-navbar.mob-open ~ .pcoded-main-container {
    margin-left: 0;
  }
}
@media only screen and (max-width: 575px) {
  .pcoded-header .navbar-nav > li:first-child {
    padding-left: 0;
  }
  .pcoded-header .navbar-nav > li:last-child {
    padding-right: 20px;
  }
  .pcoded-header .navbar-nav.mr-auto li {
    display: none;
  }
  .pcoded-header .navbar-nav.mr-auto li.nav-item:not(.dropdown) {
    display: block;
    padding-right: 0;
  }
  .pcoded-header .dropdown.show {
    position: static;
  }
  .pcoded-header .dropdown.show a:after {
    display: none;
  }
  .pcoded-header .dropdown.show:before {
    display: none;
  }
  .pcoded-header .dropdown .notification {
    width: 100%;
  }
  .pcoded-header .dropdown .dropdown-menu {
    width: 95%;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
  }
  .header-chat.open,
  .header-user-list.open {
    width: 280px;
  }
  .pcoded-content {
    padding: 30px 15px;
  }
  .card {
    margin-bottom: 15px;
  }
}
@media only screen and (max-width: 1200px) and (min-width: 768px) {
  .pcoded-navbar .header-logo {
    transition: none;
  }
  .pcoded-navbar.navbar-collapsed {
    transition: none;
  }
  .pcoded-navbar.navbar-collapsed .header-logo img {
    transition: none;
  }
  .pcoded-navbar.navbar-collapsed .pcoded-menu-caption > label {
    transition: none;
  }
  .pcoded-navbar.navbar-collapsed .pcoded-inner-navbar > li > a > .pcoded-mtext {
    transition: none;
  }
  .pcoded-navbar.navbar-collapsed .pcoded-inner-navbar > li.pcoded-hasmenu > a:after {
    transition: none;
    transition-delay: unset;
  }
  .pcoded-navbar.navbar-collapsed .pcoded-badge {
    transition: none;
  }
  .pcoded-navbar.navbar-collapsed:hover .pcoded-badge {
    transition-delay: unset;
  }
}
.pro-card {
  background: #5c6a83;
  border: #465673;
  border-radius: 8px;
}

/* ==========================    Responsive Menu  end   ====================== */
/* ===================================================================================
 ==========================    Different Layout Styles Start     ====================
 ===================================================================================
 ====== [ light menu style start ] ======== */
.pcoded-navbar.menu-light {
  background-color: #fff;
  color: #3f4d67;
  box-shadow: 7px 0 15px 0 rgba(69, 90, 100, 0.09);
}
.pcoded-navbar.menu-light .header-logo {
  background-color: #3f4d67;
}
.pcoded-navbar.menu-light .header-logo .logo-dark {
  display: none;
}
.pcoded-navbar.menu-light .header-logo .logo-main {
  display: block;
}
.pcoded-navbar.menu-light .mobile-menu span {
  background-color: #a9b7d0;
}
.pcoded-navbar.menu-light .mobile-menu span:after, .pcoded-navbar.menu-light .mobile-menu span:before {
  background-color: #a9b7d0;
}
.pcoded-navbar.menu-light .mobile-menu.on span {
  background-color: transparent;
}
.pcoded-navbar.menu-light .pcoded-submenu {
  background: #fbfbfb;
}
.pcoded-navbar.menu-light a {
  color: #3f4d67;
}
.pcoded-navbar.menu-light.navbar-collapsed .pcoded-menu-caption:after {
  background: rgba(0, 0, 0, 0.1);
}
.pcoded-navbar.menu-light.navbar-collapsed:hover .pcoded-menu-caption:after {
  background: transparent;
}
.pcoded-navbar.menu-light .pcoded-menu-caption {
  color: #3f4d67;
}
.pcoded-navbar.menu-light .pcoded-inner-navbar > li.active > a, .pcoded-navbar.menu-light .pcoded-inner-navbar > li.pcoded-trigger > a {
  background: #f1f1f1;
  color: #111;
}

/* ====== [ light menu style end ] ======== */
/* ====== [ menu static start ] ======== */
.pcoded-navbar.menupos-static {
  position: absolute;
  height: 100%;
  min-height: 100%;
}
.pcoded-navbar.menupos-static .datta-scroll.navbar-content {
  height: calc(100% - 70px);
  min-height: 100vh;
}

/* ====== [ menu static end ] ======== */
/* ==========================    Different Layout Styles end     ====================== */
/* temp SCSS for document */
.nav-link.active.h-blue {
  background: #04a9f5 !important;
}

.nav-link.active.h-red {
  background: #ff5252 !important;
}

.nav-link.active.h-purple {
  background: #9575cd !important;
}

.nav-link.active.h-lightblue {
  background: #23b7e5 !important;
}

.nav-link.active.h-dark {
  background: #323437 !important;
}

@media all and (-ms-high-contrast: none) {
  .pcoded-header .dropdown.show::before {
    line-height: 0.1;
  }
  .pcoded-header .navbar-nav > li {
    display: inline-flex;
  }
  .pcoded-header .navbar-nav > li.dropdown {
    display: inline-block;
  }
  .dropdown-menu.show::before {
    top: -2px;
  }
  .pcoded-navbar.navbar-collapsed .pcoded-inner-navbar > li.pcoded-trigger .pcoded-submenu::after {
    left: 40px;
  }
}
.navbar-content {
  position: relative;
}

.ps .ps__rail-x.ps--clicking,
.ps .ps__rail-x:focus,
.ps .ps__rail-x:hover,
.ps .ps__rail-y.ps--clicking,
.ps .ps__rail-y:focus,
.ps .ps__rail-y:hover {
  background: transparent;
}

.ps__thumb-y {
  background: #2a3446;
}

.ps__rail-y.ps--clicking .ps__thumb-y,
.ps__rail-y:focus > .ps__thumb-y,
.ps__rail-y:hover > .ps__thumb-y {
  background: #222a38;
}

/* nav-outside */
.nav-outside {
  position: absolute;
  width: 100%;
  height: 100%;
}

.carousel {
  z-index: -1;
}

.landing-nav {
  z-index: 1201;
}

.user-list .table td {
  vertical-align: middle;
}
.user-list .table thead th {
  border: 0;
}

.Recent-Users .table tr:first-child td {
  border-top: 0;
}
.Recent-Users .table td {
  vertical-align: middle;
}
.Recent-Users .table .label {
  border-radius: 15px;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.2);
}

.card-social:hover i {
  font-size: 40px;
  transition: all 0.3s ease-in-out;
}
.card-social .progress {
  height: 6px;
}
.card-social .card-active > div + div {
  border-left: 1px solid #eaeaea;
}

.card .card-block code,
.card .card-body code {
  background-color: #eee;
  margin: 5px;
  display: inline-block;
  border-radius: 3px;
  padding: 0 3px;
}

@media screen and (max-width: 767px) {
  div.dataTables_wrapper div.dataTables_filter label {
    float: none !important;
    text-align: center;
  }
}
/**  =====================
      Form Componant css start
==========================  **/
.custom-select,
.form-control {
  background: #f4f7fa;
  padding: 10px 20px;
  font-size: 14px;
  height: auto;
}
.custom-select.form-control-lg,
.form-control.form-control-lg {
  font-size: 1.25rem;
}
.custom-select.form-control-sm,
.form-control.form-control-sm {
  height: calc(1.8125rem + 2px);
  font-size: 0.875rem;
}
.custom-select.form-control-range,
.form-control.form-control-range {
  box-shadow: none;
}
.custom-select:focus,
.form-control:focus {
  background: #f4f7fa;
}
.custom-select::-moz-placeholder,
.form-control::-moz-placeholder {
  color: #aaaeb3;
  opacity: 1;
}
.custom-select:-ms-input-placeholder,
.form-control:-ms-input-placeholder {
  color: #aaaeb3;
}
.custom-select::-webkit-input-placeholder,
.form-control::-webkit-input-placeholder {
  color: #aaaeb3;
}

/* input group start */
.input-group {
  background: #f4f7fa;
}
.input-group .input-group-text {
  padding-left: 15px;
  padding-right: 15px;
  background: transparent;
}
.input-group .input-group-text i {
  font-size: 20px;
}
.input-group .custom-file-label {
  margin-bottom: 0;
}
.input-group .btn {
  margin-bottom: 0;
  margin-right: 0;
}

.cust-file-button .custom-file-label {
  height: calc(2.25rem + 8px);
  line-height: 2.5;
}
.cust-file-button .custom-file-label::after {
  padding: 0.775rem 0.75rem;
  height: 2.65rem;
}

.custom-select {
  height: calc(2.25rem + 9px);
}

/* input group End */
/**====== Form Componant css end ======**/
select.form-control:not([size]):not([multiple]) {
  height: calc(2.55rem + 2px);
}

.input-group-lg > .input-group-append > select.btn:not([size]):not([multiple]),
.input-group-lg > .input-group-append > select.input-group-text:not([size]):not([multiple]),
.input-group-lg > .input-group-prepend > select.btn:not([size]):not([multiple]),
.input-group-lg > .input-group-prepend > select.input-group-text:not([size]):not([multiple]),
.input-group-lg > select.form-control:not([size]):not([multiple]),
select.form-control-lg:not([size]):not([multiple]) {
  height: calc(3.375rem + 2px);
}

.minicolors .form-control {
  padding: 6px 12px 5px 44px;
}

/* form-select */
.select2-container {
  width: 100% !important;
}

.tt-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 160px;
  padding: 5px 0;
  margin: 2px 0 0;
  list-style: none;
  font-size: 14px;
  background-color: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 4px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  background-clip: padding-box;
  cursor: pointer;
}

.bootstrap-tagsinput {
  width: 100%;
}

.custom-file-label {
  height: auto;
}
.custom-file-label:after {
  height: auto;
  padding: 0.55rem 0.75rem;
}

.form-control.is-invalid,
.was-validated .form-control:invalid,
.was-validated .form-control:valid,
.form-control.is-valid {
  background-position: calc(100% - 10px) calc(0.375em + 0.4875rem);
}

.was-validated .form-control:invalid ~ .invalid-feedback {
  background: #fff;
  margin-top: 0;
  padding-top: 0.25em;
}

/**  =====================
      Radio & Checked css start
==========================  **/
.checkbox {
  padding: 10px 0;
  min-height: auto;
  position: relative;
  margin-right: 5px;
}
.checkbox input[type=checkbox] {
  margin: 0;
  display: none;
  width: 22px;
}
.checkbox input[type=checkbox] + .form-check-label,
.checkbox input[type=checkbox] + .cr {
  padding-left: 0;
}
.checkbox input[type=checkbox] + .form-check-label:before,
.checkbox input[type=checkbox] + .cr:before {
  content: "\\e83f";
  width: 22px;
  height: 22px;
  display: inline-block;
  margin-right: 10px;
  border: 2px solid #e9eaec;
  border-radius: 3px;
  font-size: 15px;
  font-family: "feather";
  font-weight: 400;
  line-height: 19px;
  vertical-align: bottom;
  text-align: center;
  background: #ffffff;
  color: transparent;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.checkbox input[type=checkbox]:checked + .form-check-label:before, .checkbox input[type=checkbox]:checked + .cr:before {
  background: #1dd5d2;
  border-color: #1dd5d2;
  color: #ffffff;
}
.checkbox input[type=checkbox].disabled + .form-check-label, .checkbox input[type=checkbox]:disabled + .form-check-label, .checkbox input[type=checkbox].disabled + .cr, .checkbox input[type=checkbox]:disabled + .cr {
  opacity: 0.5;
}
.checkbox input[type=checkbox].disabled + .form-check-label:before, .checkbox input[type=checkbox]:disabled + .form-check-label:before, .checkbox input[type=checkbox].disabled + .cr:before, .checkbox input[type=checkbox]:disabled + .cr:before {
  cursor: not-allowed;
}
.checkbox.checkbox-fill input[type=checkbox] + .form-check-label:after,
.checkbox.checkbox-fill input[type=checkbox] + .cr:after {
  content: "";
  width: 22.5px;
  height: 22.5px;
  display: inline-block;
  margin-right: 10px;
  border: 2px solid #e9eaec;
  border-radius: 2px;
  vertical-align: bottom;
  text-align: center;
  background: transparent;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  position: absolute;
  top: 8.5px;
  left: 3px;
}
.checkbox.checkbox-fill input[type=checkbox] + .form-check-label:before,
.checkbox.checkbox-fill input[type=checkbox] + .cr:before {
  opacity: 0;
  content: "\\e840";
  font-size: 27px;
  background: transparent;
}
.checkbox.checkbox-fill input[type=checkbox]:checked + .form-check-label:after,
.checkbox.checkbox-fill input[type=checkbox]:checked + .cr:after {
  opacity: 0;
}
.checkbox.checkbox-fill input[type=checkbox]:checked + .form-check-label:before,
.checkbox.checkbox-fill input[type=checkbox]:checked + .cr:before {
  opacity: 1;
  background: transparent;
  color: #1dd5d2;
  border-color: transparent;
}
.checkbox.checkbox-primary input[type=checkbox]:checked + .form-check-label:before, .checkbox.checkbox-primary input[type=checkbox]:checked + .cr:before {
  background: #04a9f5;
  border-color: #04a9f5;
  color: #ffffff;
}
.checkbox.checkbox-fill.checkbox-primary input[type=checkbox]:checked + .form-check-label:before, .checkbox.checkbox-fill.checkbox-primary input[type=checkbox]:checked + .cr:before {
  background: transparent;
  color: #04a9f5;
  border-color: transparent;
}
.checkbox.checkbox-danger input[type=checkbox]:checked + .form-check-label:before, .checkbox.checkbox-danger input[type=checkbox]:checked + .cr:before {
  background: #f44236;
  border-color: #f44236;
  color: #ffffff;
}
.checkbox.checkbox-fill.checkbox-danger input[type=checkbox]:checked + .form-check-label:before, .checkbox.checkbox-fill.checkbox-danger input[type=checkbox]:checked + .cr:before {
  background: transparent;
  color: #f44236;
  border-color: transparent;
}
.checkbox.checkbox-success input[type=checkbox]:checked + .form-check-label:before, .checkbox.checkbox-success input[type=checkbox]:checked + .cr:before {
  background: #1de9b6;
  border-color: #1de9b6;
  color: #ffffff;
}
.checkbox.checkbox-fill.checkbox-success input[type=checkbox]:checked + .form-check-label:before, .checkbox.checkbox-fill.checkbox-success input[type=checkbox]:checked + .cr:before {
  background: transparent;
  color: #1de9b6;
  border-color: transparent;
}
.checkbox.checkbox-warning input[type=checkbox]:checked + .form-check-label:before, .checkbox.checkbox-warning input[type=checkbox]:checked + .cr:before {
  background: #f4c22b;
  border-color: #f4c22b;
  color: #ffffff;
}
.checkbox.checkbox-fill.checkbox-warning input[type=checkbox]:checked + .form-check-label:before, .checkbox.checkbox-fill.checkbox-warning input[type=checkbox]:checked + .cr:before {
  background: transparent;
  color: #f4c22b;
  border-color: transparent;
}
.checkbox.checkbox-info input[type=checkbox]:checked + .form-check-label:before, .checkbox.checkbox-info input[type=checkbox]:checked + .cr:before {
  background: #17a2b8;
  border-color: #17a2b8;
  color: #ffffff;
}
.checkbox.checkbox-fill.checkbox-info input[type=checkbox]:checked + .form-check-label:before, .checkbox.checkbox-fill.checkbox-info input[type=checkbox]:checked + .cr:before {
  background: transparent;
  color: #17a2b8;
  border-color: transparent;
}
.checkbox .form-check-label,
.checkbox .cr {
  cursor: pointer;
}

.radio {
  padding: 10px 0;
  min-height: auto;
  position: relative;
  margin-right: 5px;
}
.radio input[type=radio] {
  margin: 0;
  display: none;
  width: 22px;
}
.radio input[type=radio] + .form-check-label,
.radio input[type=radio] + .cr {
  padding-left: 0;
}
.radio input[type=radio] + .form-check-label:after, .radio input[type=radio] + .form-check-label:before,
.radio input[type=radio] + .cr:after,
.radio input[type=radio] + .cr:before {
  content: "";
  display: inline-block;
  margin-right: 10px;
  border-radius: 50%;
  vertical-align: bottom;
  background: #fff;
  color: transparent;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.radio input[type=radio] + .form-check-label:before,
.radio input[type=radio] + .cr:before {
  width: 22px;
  height: 22px;
  border: 2px solid #e9eaec;
}
.radio input[type=radio] + .form-check-label:after,
.radio input[type=radio] + .cr:after {
  width: 12px;
  height: 12px;
  position: absolute;
  top: 13px;
  left: 5px;
}
.radio input[type=radio]:checked + .form-check-label:before,
.radio input[type=radio]:checked + .cr:before {
  border-color: #1dd5d2;
}
.radio input[type=radio]:checked + .form-check-label:after,
.radio input[type=radio]:checked + .cr:after {
  background: linear-gradient(-135deg, #1de9b6 0%, #1dc4e9 100%);
}
.radio input[type=radio]:disabled + .form-check-label,
.radio input[type=radio]:disabled + .cr {
  opacity: 0.5;
  cursor: not-allowed;
}
.radio input[type=radio]:disabled + .form-check-label:after, .radio input[type=radio]:disabled + .form-check-label:before,
.radio input[type=radio]:disabled + .cr:after,
.radio input[type=radio]:disabled + .cr:before {
  cursor: not-allowed;
}
.radio.radio-fill input[type=radio] + .form-check-label:after,
.radio.radio-fill input[type=radio] + .cr:after {
  width: 18px;
  height: 18px;
  top: 10px;
  left: 2px;
}
.radio.radio-primary input[type=radio]:checked + .form-check-label:before, .radio.radio-primary input[type=radio]:checked + .cr:before {
  border-color: #04a9f5;
}
.radio.radio-primary input[type=radio]:checked + .form-check-label:after, .radio.radio-primary input[type=radio]:checked + .cr:after {
  background: #04a9f5;
}
.radio.radio-danger input[type=radio]:checked + .form-check-label:before, .radio.radio-danger input[type=radio]:checked + .cr:before {
  border-color: #f44236;
}
.radio.radio-danger input[type=radio]:checked + .form-check-label:after, .radio.radio-danger input[type=radio]:checked + .cr:after {
  background: #f44236;
}
.radio.radio-success input[type=radio]:checked + .form-check-label:before, .radio.radio-success input[type=radio]:checked + .cr:before {
  border-color: #1de9b6;
}
.radio.radio-success input[type=radio]:checked + .form-check-label:after, .radio.radio-success input[type=radio]:checked + .cr:after {
  background: #1de9b6;
}
.radio.radio-warning input[type=radio]:checked + .form-check-label:before, .radio.radio-warning input[type=radio]:checked + .cr:before {
  border-color: #f4c22b;
}
.radio.radio-warning input[type=radio]:checked + .form-check-label:after, .radio.radio-warning input[type=radio]:checked + .cr:after {
  background: #f4c22b;
}
.radio.radio-info input[type=radio]:checked + .form-check-label:before, .radio.radio-info input[type=radio]:checked + .cr:before {
  border-color: #17a2b8;
}
.radio.radio-info input[type=radio]:checked + .form-check-label:after, .radio.radio-info input[type=radio]:checked + .cr:after {
  background: #17a2b8;
}
.radio .form-check-label,
.radio .cr {
  cursor: pointer;
}

@-moz-document url-prefix() {
  .radio input[type=radio] + .form-check-label::after,
  .radio input[type=radio] + .cr::after {
    top: 14px;
  }
}
.custom-controls-stacked .radio input[type=radio] + .form-check-label:after,
.custom-controls-stacked .radio input[type=radio] + .cr:after {
  top: 15px;
}

/**====== Radio & Checked css end ======**/
.radio .form-check,
.checkbox .form-check {
  padding-left: 0;
  margin-bottom: 6px;
}
.radio .form-check input[type=radio] + .form-check-label:after,
.checkbox .form-check input[type=radio] + .form-check-label:after {
  top: 5px;
}

/**  =====================
      Label & Badges css start
==========================  **/
.label {
  padding: 4px 10px;
  min-height: auto;
  position: relative;
  margin-right: 5px;
  margin-bottom: 5px;
}
.label.label-primary {
  background: #04a9f5;
  color: #ffffff;
}
.label.label-danger {
  background: #f44236;
  color: #ffffff;
}
.label.label-success {
  background: #1de9b6;
  color: #ffffff;
}
.label.label-warning {
  background: #f4c22b;
  color: #ffffff;
}
.label.label-info {
  background: #17a2b8;
  color: #ffffff;
}

/**====== Label & Badges css end ======**/
/**  =====================
      Data Tables css start
==========================  **/
.table {
  color: #888;
}
.table td,
.table th {
  border-top: 1px solid #eaeaea;
  white-space: nowrap;
  padding: 1.05rem 0.75rem;
}
.table thead th {
  border-bottom: 1px solid #eaeaea;
}
.table tbody + tbody {
  border-top: 2px solid #eaeaea;
}
.table.table-sm th,
.table.table-sm td {
  padding: 0.35rem;
}

/* Border versions */
.table-bordered {
  border: 1px solid #eaeaea;
}
.table-bordered td,
.table-bordered th {
  border: 1px solid #eaeaea;
}

/* Zebra-striping */
.table-striped tbody tr:nth-of-type(2n + 1) {
  background-color: rgba(4, 169, 245, 0.05);
}

/* Hover effect */
.table-hover tbody tr:hover {
  background-color: rgba(4, 169, 245, 0.05);
}

/* Table backgrounds */
.table .thead-dark th {
  color: #fff;
  background-color: #37474f;
  border-color: #222c31;
}

.table-dark {
  color: #fff;
  background-color: #37474f;
}
.table-dark td,
.table-dark th,
.table-dark thead th {
  border-color: #222c31;
}
.table-dark.table-striped tbody tr:nth-of-type(odd) {
  background-color: #334249;
}
.table-dark.table-hover tbody tr:hover {
  background-color: #2d3940;
}

/* fixed header position */
@media screen and (max-width: 992px) {
  .fixedHeader-locked {
    display: none !important;
  }
}
/**  =====================
      Foo-table css start
==========================  **/
.footable .pagination > .active > a,
.footable .pagination > .active > span {
  background-color: #04a9f5;
  border-color: #04a9f5;
}
.footable .pagination > .active > a:focus, .footable .pagination > .active > a:hover,
.footable .pagination > .active > span:focus,
.footable .pagination > .active > span:hover {
  background-color: #04a9f5;
  border-color: #04a9f5;
}
.footable .pagination > li > a,
.footable .pagination > li > span {
  color: #222;
}

.footable-details.table,
.footable.table {
  margin-bottom: 0;
}

table.footable > tfoot > tr.footable-paging > td > span.label {
  margin-bottom: 0;
}
table.footable-paging-center > tfoot > tr.footable-paging > td {
  padding-bottom: 0;
}

.table-columned > tbody > tr > td {
  border: 0;
  border-left: 1px solid #eaeaea;
}
.table-columned > tbody > tr > th {
  border: 0;
}

/**====== Foo-table css end ======**/
/**====== Data Tables css end ======**/
/**  =====================
      Authentication css start
==========================  **/
.auth-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  min-width: 100%;
  min-height: 100vh;
}
.auth-wrapper a,
.auth-wrapper p > a {
  color: #111;
  font-weight: 600;
}
.auth-wrapper .btn-auth-gen .btn-icon {
  width: 140px;
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 45px;
}
.auth-wrapper .btn-auth-gen .btn-icon small {
  font-size: 15px;
}
.auth-wrapper .input-group {
  background: transparent;
}
.auth-wrapper .card {
  margin-bottom: 0;
}
.auth-wrapper > div {
  z-index: 5;
}
.auth-wrapper .auth-content {
  position: relative;
  width: 390px;
  padding: 15px;
  z-index: 5;
}
.auth-wrapper .auth-content.multyform, .auth-wrapper .auth-content.subscribe {
  width: 750px;
}
@media only screen and (max-width: 768px) {
  .auth-wrapper {
    max-width: 360px;
  }
}
@media only screen and (max-width: 575px) {
  .auth-wrapper .card .card-body {
    padding: 30px 15px;
  }
}
.auth-wrapper .auth-icon {
  font-size: 30px;
}
.auth-wrapper .auth-icon:before {
  background: linear-gradient(-135deg, #1de9b6 0%, #1dc4e9 100%);
  background-clip: inherit;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.auth-wrapper.offline {
  background-image: none;
}
.auth-wrapper.offline:before {
  display: none;
}
.auth-wrapper .auth-bg .r {
  position: absolute;
  width: 300px;
  height: 300px;
  border-radius: 50%;
}
.auth-wrapper .auth-bg .r:first-child {
  top: -100px;
  right: -100px;
  background: linear-gradient(-135deg, #1de9b6 0%, #1dc4e9 100%);
}
.auth-wrapper .auth-bg .r:last-child {
  left: -100px;
  bottom: -100px;
  background: linear-gradient(-135deg, #899fd4 0%, #a389d4 100%);
}
.auth-wrapper .auth-bg .r.s {
  width: 20px;
  height: 20px;
}
.auth-wrapper .auth-bg .r.s:nth-child(2) {
  top: 150px;
  right: -150px;
  background: #04a9f5;
}
.auth-wrapper .auth-bg .r.s:nth-child(3) {
  left: -150px;
  bottom: 150px;
  background: #1de9b6;
}
.auth-wrapper .auth-bg .r:nth-child(odd) {
  animation: floating 7s infinite;
}
.auth-wrapper .auth-bg .r:nth-child(even) {
  animation: floating 9s infinite;
}

/* image variant start */
.aut-bg-img {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.aut-bg-img-side p {
  line-height: 2;
}

.aut-bg-img .custom-select,
.aut-bg-img .form-control,
.aut-bg-img-side .custom-select,
.aut-bg-img-side .form-control {
  background: transparent;
}

.auth-tabs .tab-content {
  overflow: hidden;
  position: relative;
}
.auth-tabs .tab-content .tab-pane > * {
  position: relative;
  z-index: 5;
}
.auth-tabs .tab-content .auth-icon {
  position: absolute;
  bottom: 0;
  right: 0;
  font-size: 180px;
  transform: rotate(-30deg);
  z-index: 1;
  opacity: 0.2;
}

/* image varient start */
@keyframes floating {
  from {
    transform: rotate(0deg) translate(-10px) rotate(0deg);
  }
  to {
    transform: rotate(360deg) translate(-10px) rotate(-360deg);
  }
}
/**====== Authentication css end ======**/
/* Button variants
 Easily pump out default styles, as well as :hover, :focus, :active,
 and disabled options for all buttons */
/**  =====================
      Button css start
==========================  **/
.btn-theme,
a.btn-theme {
  background: linear-gradient(-135deg, #1de9b6 0%, #1dc4e9 100%);
  color: #fff;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);
  border-color: #1de1c2;
  border-radius: 0.25rem;
  padding: 11px 25px;
}
.btn-theme:active, .btn-theme:focus, .btn-theme:not(:disabled):not(.disabled):active,
a.btn-theme:active,
a.btn-theme:focus,
a.btn-theme:not(:disabled):not(.disabled):active {
  background-image: linear-gradient(-135deg, #1de9b6 0%, #1dc4e9 100%);
  color: #fff;
  box-shadow: none;
}
.btn-theme.active,
a.btn-theme.active {
  background-image: #fff !important;
  color: #d6d6d6;
  border: 1px solid #eaeaea;
  box-shadow: none;
}

.btn-outline-theme {
  background-image: #fff !important;
  color: #d6d6d6;
  border: 1px solid #eaeaea;
  box-shadow: none;
}
.btn-outline-theme:active, .btn-outline-theme:focus, .btn-outline-theme:not(:disabled):not(.disabled):active {
  background-image: #fff;
  color: #d6d6d6;
  border: 1px solid #eaeaea;
}
.btn-outline-theme.active {
  background: linear-gradient(-135deg, #1de9b6 0%, #1dc4e9 100%) !important;
  color: #fff;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);
  border: 1px solid transparent;
}

.btn-theme2 {
  background: linear-gradient(-135deg, #899fd4 0%, #a389d4 100%);
  color: #fff;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);
  border: 1px solid transparent;
  border-radius: 10px;
  padding: 14px 25px;
}
.btn-theme2:active, .btn-theme2:focus, .btn-theme2:not(:disabled):not(.disabled):active {
  background-image: linear-gradient(-135deg, #899fd4 0%, #a389d4 100%);
  color: #fff;
  box-shadow: none;
}
.btn-theme2.active {
  background-image: #fff !important;
  color: #d6d6d6;
  border: 1px solid #eaeaea;
  box-shadow: none;
}

.btn-outline-theme2 {
  background-image: #fff !important;
  color: #d6d6d6;
  border: 1px solid #eaeaea;
  box-shadow: none;
}
.btn-outline-theme2:active, .btn-outline-theme2:focus, .btn-outline-theme2:not(:disabled):not(.disabled):active {
  background-image: #fff;
  color: #d6d6d6;
  border: 1px solid #eaeaea;
}
.btn-outline-theme2.active {
  background: linear-gradient(-135deg, #899fd4 0%, #a389d4 100%) !important;
  color: #fff;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);
  border: 1px solid transparent;
}

.btn {
  padding: 10px 20px;
  border-radius: 0.25rem;
  font-size: 14px;
  margin-bottom: 5px;
  margin-right: 10px;
  transition: all 0.3s ease-in-out;
}
.btn > i {
  margin-right: 12px;
}
.btn.btn-icon, .btn.drp-icon {
  width: 45px;
  height: 45px;
  padding: 10px 12px;
}
.btn.btn-icon > i, .btn.drp-icon > i {
  margin-right: 0;
}
.btn.drp-icon.dropdown-toggle:after {
  display: none;
}
.btn.drp-icon + .dropdown-menu {
  margin-left: -10px;
}
.btn:active, .btn:focus {
  box-shadow: none;
}
.btn-square {
  border-radius: 0;
}
.btn.disabled {
  cursor: not-allowed;
  opacity: 0.55;
}
.btn-rounded {
  border-radius: 30px;
}

.btn-group .btn {
  margin-bottom: 0;
  margin-right: 0;
}

.btn-group-sm > .btn,
.btn-sm {
  padding: 6px 14px;
  font-size: 13px;
}

.btn-group-lg > .btn,
.btn-lg {
  padding: 13px 23px;
  font-size: 16px;
}

.shadow-1 {
  box-shadow: 0 7px 12px 0 rgba(62, 57, 107, 0.16);
}

.shadow-2 {
  box-shadow: 0 10px 18px 0 rgba(62, 57, 107, 0.2);
}

.shadow-3 {
  box-shadow: 0 14px 24px 0 rgba(62, 57, 107, 0.26);
}

.shadow-4 {
  box-shadow: 0 16px 28px 0 rgba(62, 57, 107, 0.3);
}

.shadow-5 {
  box-shadow: 0 20px 24px 0 rgba(62, 57, 107, 0.36);
}

/* Alternate buttons */
.btn-primary {
  color: #fff;
  background-color: #04a9f5;
  border-color: #04a9f5;
}
.btn-primary:hover {
  color: #fff;
  background-color: #038fcf;
  border-color: #0386c3;
}
.btn-primary.disabled, .btn-primary:disabled {
  color: #fff;
  background-color: #04a9f5;
  border-color: #04a9f5;
}
.btn-primary:not(:disabled):not(.disabled).active, .btn-primary:not(:disabled):not(.disabled):active, .show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #0386c3;
  border-color: #037eb6;
}
.btn-secondary {
  color: #fff;
  background-color: #748892;
  border-color: #748892;
}
.btn-secondary:hover {
  color: #fff;
  background-color: #62747d;
  border-color: #5d6e76;
}
.btn-secondary.disabled, .btn-secondary:disabled {
  color: #fff;
  background-color: #748892;
  border-color: #748892;
}
.btn-secondary:not(:disabled):not(.disabled).active, .btn-secondary:not(:disabled):not(.disabled):active, .show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #5d6e76;
  border-color: #57676f;
}
.btn-success {
  color: #fff;
  background-color: #1de9b6;
  border-color: #1de9b6;
}
.btn-success:hover {
  color: #fff;
  background-color: #14cc9e;
  border-color: #13c095;
}
.btn-success.disabled, .btn-success:disabled {
  color: #fff;
  background-color: #1de9b6;
  border-color: #1de9b6;
}
.btn-success:not(:disabled):not(.disabled).active, .btn-success:not(:disabled):not(.disabled):active, .show > .btn-success.dropdown-toggle {
  color: #fff;
  background-color: #13c095;
  border-color: #12b58c;
}
.btn-info {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}
.btn-info:hover {
  color: #fff;
  background-color: #138496;
  border-color: #117a8b;
}
.btn-info.disabled, .btn-info:disabled {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}
.btn-info:not(:disabled):not(.disabled).active, .btn-info:not(:disabled):not(.disabled):active, .show > .btn-info.dropdown-toggle {
  color: #fff;
  background-color: #117a8b;
  border-color: #10707f;
}
.btn-warning {
  color: #fff;
  background-color: #f4c22b;
  border-color: #f4c22b;
}
.btn-warning:hover {
  color: #fff;
  background-color: #ecb50c;
  border-color: #e0ab0c;
}
.btn-warning.disabled, .btn-warning:disabled {
  color: #fff;
  background-color: #f4c22b;
  border-color: #f4c22b;
}
.btn-warning:not(:disabled):not(.disabled).active, .btn-warning:not(:disabled):not(.disabled):active, .show > .btn-warning.dropdown-toggle {
  color: #fff;
  background-color: #e0ab0c;
  border-color: #d4a20b;
}
.btn-danger {
  color: #fff;
  background-color: #f44236;
  border-color: #f44236;
}
.btn-danger:hover {
  color: #fff;
  background-color: #f22012;
  border-color: #ea1b0d;
}
.btn-danger.disabled, .btn-danger:disabled {
  color: #fff;
  background-color: #f44236;
  border-color: #f44236;
}
.btn-danger:not(:disabled):not(.disabled).active, .btn-danger:not(:disabled):not(.disabled):active, .show > .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: #ea1b0d;
  border-color: #de190c;
}
.btn-light {
  color: #37474f;
  background-color: #f2f2f2;
  border-color: #f2f2f2;
}
.btn-light:hover {
  color: #37474f;
  background-color: #dfdfdf;
  border-color: #d9d9d9;
}
.btn-light.disabled, .btn-light:disabled {
  color: #37474f;
  background-color: #f2f2f2;
  border-color: #f2f2f2;
}
.btn-light:not(:disabled):not(.disabled).active, .btn-light:not(:disabled):not(.disabled):active, .show > .btn-light.dropdown-toggle {
  color: #37474f;
  background-color: #d9d9d9;
  border-color: #d2d2d2;
}
.btn-dark {
  color: #fff;
  background-color: #37474f;
  border-color: #37474f;
}
.btn-dark:hover {
  color: #fff;
  background-color: #273338;
  border-color: #222c31;
}
.btn-dark.disabled, .btn-dark:disabled {
  color: #fff;
  background-color: #37474f;
  border-color: #37474f;
}
.btn-dark:not(:disabled):not(.disabled).active, .btn-dark:not(:disabled):not(.disabled):active, .show > .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: #222c31;
  border-color: #1d2529;
}
/* outline buttons */
.btn-outline-primary {
  color: #04a9f5;
  background-color: transparent;
  background-image: none;
  border-color: #04a9f5;
}
.btn-outline-primary:hover {
  color: #fff;
  background-color: #04a9f5;
  border-color: #04a9f5;
}
.btn-outline-primary.disabled, .btn-outline-primary:disabled {
  color: #04a9f5;
  background-color: transparent;
}
.btn-outline-primary:not(:disabled):not(.disabled).active, .btn-outline-primary:not(:disabled):not(.disabled):active, .show > .btn-outline-primary.dropdown-toggle {
  color: #fff;
  background-color: #04a9f5;
  border-color: #04a9f5;
}
.btn-outline-secondary {
  color: #748892;
  background-color: transparent;
  background-image: none;
  border-color: #748892;
}
.btn-outline-secondary:hover {
  color: #fff;
  background-color: #748892;
  border-color: #748892;
}
.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
  color: #748892;
  background-color: transparent;
}
.btn-outline-secondary:not(:disabled):not(.disabled).active, .btn-outline-secondary:not(:disabled):not(.disabled):active, .show > .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #748892;
  border-color: #748892;
}
.btn-outline-success {
  color: #1de9b6;
  background-color: transparent;
  background-image: none;
  border-color: #1de9b6;
}
.btn-outline-success:hover {
  color: #fff;
  background-color: #1de9b6;
  border-color: #1de9b6;
}
.btn-outline-success.disabled, .btn-outline-success:disabled {
  color: #1de9b6;
  background-color: transparent;
}
.btn-outline-success:not(:disabled):not(.disabled).active, .btn-outline-success:not(:disabled):not(.disabled):active, .show > .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #1de9b6;
  border-color: #1de9b6;
}
.btn-outline-info {
  color: #17a2b8;
  background-color: transparent;
  background-image: none;
  border-color: #17a2b8;
}
.btn-outline-info:hover {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}
.btn-outline-info.disabled, .btn-outline-info:disabled {
  color: #17a2b8;
  background-color: transparent;
}
.btn-outline-info:not(:disabled):not(.disabled).active, .btn-outline-info:not(:disabled):not(.disabled):active, .show > .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}
.btn-outline-warning {
  color: #f4c22b;
  background-color: transparent;
  background-image: none;
  border-color: #f4c22b;
}
.btn-outline-warning:hover {
  color: #fff;
  background-color: #f4c22b;
  border-color: #f4c22b;
}
.btn-outline-warning.disabled, .btn-outline-warning:disabled {
  color: #f4c22b;
  background-color: transparent;
}
.btn-outline-warning:not(:disabled):not(.disabled).active, .btn-outline-warning:not(:disabled):not(.disabled):active, .show > .btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #f4c22b;
  border-color: #f4c22b;
}
.btn-outline-danger {
  color: #f44236;
  background-color: transparent;
  background-image: none;
  border-color: #f44236;
}
.btn-outline-danger:hover {
  color: #fff;
  background-color: #f44236;
  border-color: #f44236;
}
.btn-outline-danger.disabled, .btn-outline-danger:disabled {
  color: #f44236;
  background-color: transparent;
}
.btn-outline-danger:not(:disabled):not(.disabled).active, .btn-outline-danger:not(:disabled):not(.disabled):active, .show > .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44236;
  border-color: #f44236;
}
.btn-outline-light {
  color: #f2f2f2;
  background-color: transparent;
  background-image: none;
  border-color: #f2f2f2;
}
.btn-outline-light:hover {
  color: #37474f;
  background-color: #f2f2f2;
  border-color: #f2f2f2;
}
.btn-outline-light.disabled, .btn-outline-light:disabled {
  color: #f2f2f2;
  background-color: transparent;
}
.btn-outline-light:not(:disabled):not(.disabled).active, .btn-outline-light:not(:disabled):not(.disabled):active, .show > .btn-outline-light.dropdown-toggle {
  color: #37474f;
  background-color: #f2f2f2;
  border-color: #f2f2f2;
}
.btn-outline-dark {
  color: #37474f;
  background-color: transparent;
  background-image: none;
  border-color: #37474f;
}
.btn-outline-dark:hover {
  color: #fff;
  background-color: #37474f;
  border-color: #37474f;
}
.btn-outline-dark.disabled, .btn-outline-dark:disabled {
  color: #37474f;
  background-color: transparent;
}
.btn-outline-dark:not(:disabled):not(.disabled).active, .btn-outline-dark:not(:disabled):not(.disabled):active, .show > .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #37474f;
  border-color: #37474f;
}
/* glow buttons */
.btn-glow-primary {
  box-shadow: 0 1px 6px 2px rgba(4, 169, 245, 0.56), 0 6px 11px 2px rgba(4, 169, 245, 0.2);
}
.btn-glow-primary:hover {
  box-shadow: 0 1px 4px 2px rgba(4, 169, 245, 0.56), 0 4px 9px 2px rgba(4, 169, 245, 0.1);
}
.btn-glow-primary:not(:disabled):not(.disabled).active, .btn-glow-primary:not(:disabled):not(.disabled):active:focus, .show > .btn-glow-primary.dropdown-toggle, .btn-glow-primary.active, .btn-glow-primary:focus {
  box-shadow: none;
}

.btn-glow-secondary {
  box-shadow: 0 1px 6px 2px rgba(116, 136, 146, 0.56), 0 6px 11px 2px rgba(116, 136, 146, 0.2);
}
.btn-glow-secondary:hover {
  box-shadow: 0 1px 4px 2px rgba(116, 136, 146, 0.56), 0 4px 9px 2px rgba(116, 136, 146, 0.1);
}
.btn-glow-secondary:not(:disabled):not(.disabled).active, .btn-glow-secondary:not(:disabled):not(.disabled):active:focus, .show > .btn-glow-secondary.dropdown-toggle, .btn-glow-secondary.active, .btn-glow-secondary:focus {
  box-shadow: none;
}

.btn-glow-success {
  box-shadow: 0 1px 6px 2px rgba(29, 233, 182, 0.56), 0 6px 11px 2px rgba(29, 233, 182, 0.2);
}
.btn-glow-success:hover {
  box-shadow: 0 1px 4px 2px rgba(29, 233, 182, 0.56), 0 4px 9px 2px rgba(29, 233, 182, 0.1);
}
.btn-glow-success:not(:disabled):not(.disabled).active, .btn-glow-success:not(:disabled):not(.disabled):active:focus, .show > .btn-glow-success.dropdown-toggle, .btn-glow-success.active, .btn-glow-success:focus {
  box-shadow: none;
}

.btn-glow-info {
  box-shadow: 0 1px 6px 2px rgba(23, 162, 184, 0.56), 0 6px 11px 2px rgba(23, 162, 184, 0.2);
}
.btn-glow-info:hover {
  box-shadow: 0 1px 4px 2px rgba(23, 162, 184, 0.56), 0 4px 9px 2px rgba(23, 162, 184, 0.1);
}
.btn-glow-info:not(:disabled):not(.disabled).active, .btn-glow-info:not(:disabled):not(.disabled):active:focus, .show > .btn-glow-info.dropdown-toggle, .btn-glow-info.active, .btn-glow-info:focus {
  box-shadow: none;
}

.btn-glow-warning {
  box-shadow: 0 1px 6px 2px rgba(244, 194, 43, 0.56), 0 6px 11px 2px rgba(244, 194, 43, 0.2);
}
.btn-glow-warning:hover {
  box-shadow: 0 1px 4px 2px rgba(244, 194, 43, 0.56), 0 4px 9px 2px rgba(244, 194, 43, 0.1);
}
.btn-glow-warning:not(:disabled):not(.disabled).active, .btn-glow-warning:not(:disabled):not(.disabled):active:focus, .show > .btn-glow-warning.dropdown-toggle, .btn-glow-warning.active, .btn-glow-warning:focus {
  box-shadow: none;
}

.btn-glow-danger {
  box-shadow: 0 1px 6px 2px rgba(244, 66, 54, 0.56), 0 6px 11px 2px rgba(244, 66, 54, 0.2);
}
.btn-glow-danger:hover {
  box-shadow: 0 1px 4px 2px rgba(244, 66, 54, 0.56), 0 4px 9px 2px rgba(244, 66, 54, 0.1);
}
.btn-glow-danger:not(:disabled):not(.disabled).active, .btn-glow-danger:not(:disabled):not(.disabled):active:focus, .show > .btn-glow-danger.dropdown-toggle, .btn-glow-danger.active, .btn-glow-danger:focus {
  box-shadow: none;
}

.btn-glow-light {
  box-shadow: 0 1px 6px 2px rgba(242, 242, 242, 0.56), 0 6px 11px 2px rgba(242, 242, 242, 0.2);
}
.btn-glow-light:hover {
  box-shadow: 0 1px 4px 2px rgba(242, 242, 242, 0.56), 0 4px 9px 2px rgba(242, 242, 242, 0.1);
}
.btn-glow-light:not(:disabled):not(.disabled).active, .btn-glow-light:not(:disabled):not(.disabled):active:focus, .show > .btn-glow-light.dropdown-toggle, .btn-glow-light.active, .btn-glow-light:focus {
  box-shadow: none;
}

.btn-glow-dark {
  box-shadow: 0 1px 6px 2px rgba(55, 71, 79, 0.56), 0 6px 11px 2px rgba(55, 71, 79, 0.2);
}
.btn-glow-dark:hover {
  box-shadow: 0 1px 4px 2px rgba(55, 71, 79, 0.56), 0 4px 9px 2px rgba(55, 71, 79, 0.1);
}
.btn-glow-dark:not(:disabled):not(.disabled).active, .btn-glow-dark:not(:disabled):not(.disabled):active:focus, .show > .btn-glow-dark.dropdown-toggle, .btn-glow-dark.active, .btn-glow-dark:focus {
  box-shadow: none;
}

/**====== Button css end ======**/
.drp-icon .btn {
  width: 45px;
  height: 45px;
  padding: 10px 12px;
}
.drp-icon .btn > i {
  margin-right: 0;
}
.drp-icon .btn.dropdown-toggle:after {
  display: none;
}
.drp-icon + .dropdown-menu {
  margin-left: -10px;
}
.drp-icon.btn-rounded .btn.dropdown-toggle {
  border-radius: 30px;
}

.btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}

/**  =====================
      Breadcrumbs & Pagination css start
==========================  **/
/* Breadcrumbs */
.breadcrumb {
  background-color: #f4f7fa;
  border-radius: 0;
}

.breadcrumb-item + .breadcrumb-item {
  color: #04a9f5;
}
.breadcrumb-item.active {
  color: #111;
}

/* pagination */
.page-item.active .page-link {
  color: #fff;
  background-color: #04a9f5;
  border-color: #04a9f5;
}

/**====== Breadcrumbs & Pagination css end ======**/
/**  =====================
      Progress css start
==========================  **/
@keyframes progress-bar-stripes {
  from {
    background-position: 16px 0;
  }
  to {
    background-position: 0 0;
  }
}
.progress {
  height: 12px;
  font-size: 10px;
  background-color: #f4f7fa;
  border-radius: 0;
  overflow: visible;
}
.progress .progress-bar {
  background-color: #04a9f5;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.3);
}
.progress .progress-bar.progress-c-blue, .progress .progress-bar.bg-c-blue {
  background: #04a9f5;
}
.progress .progress-bar.progress-c-red, .progress .progress-bar.bg-c-red {
  background: #f44236;
}
.progress .progress-bar.progress-c-green, .progress .progress-bar.bg-c-green {
  background: #1de9b6;
}
.progress .progress-bar.progress-c-yellow, .progress .progress-bar.bg-c-yellow {
  background: #f4c22b;
}
.progress .progress-bar.progress-c-purple, .progress .progress-bar.bg-c-purple {
  background: #a389d4;
}
.progress .progress-bar.progress-c-theme {
  background: linear-gradient(-135deg, #1de9b6 0%, #1dc4e9 100%);
}
.progress .progress-bar.progress-c-theme2 {
  background: linear-gradient(-135deg, #899fd4 0%, #a389d4 100%);
}
.progress .progress-bar.bg-primary {
  background-color: #04a9f5 !important;
}
.progress .progress-bar.bg-secondary {
  background-color: #748892 !important;
}
.progress .progress-bar.bg-success {
  background-color: #1de9b6 !important;
}
.progress .progress-bar.bg-info {
  background-color: #17a2b8 !important;
}
.progress .progress-bar.bg-warning {
  background-color: #f4c22b !important;
}
.progress .progress-bar.bg-danger {
  background-color: #f44236 !important;
}
.progress .progress-bar.bg-light {
  background-color: #f2f2f2 !important;
}
.progress .progress-bar.bg-dark {
  background-color: #37474f !important;
}

/**====== Progress css end ======**/
.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 10px 24px;
}
.nav-link:hover {
  text-decoration: none;
}
.nav-link.disabled {
  opacity: 0.7;
}

/* ======================== Tabs =============================== */
.nav-tabs {
  border-bottom: none;
}
.nav-tabs .nav-link {
  border: none;
  color: #888;
}
.nav-tabs .nav-link:hover {
  color: #04a9f5;
}
.nav-tabs .nav-link.disabled {
  opacity: 0.7;
}
.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  border: none;
  color: #111;
  box-shadow: 0 -5px 10px 0 rgba(0, 0, 0, 0.05);
}

/* =======================   Pills ================== */
.nav-pills {
  padding: 15px;
  background-color: #fff;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.05);
}
.nav-pills .nav-link {
  border-radius: 5px;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background: #04a9f5;
  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.2);
}

/* ==================== Justified variants ===================*/
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

/* Tabbable tabs */
/* Hide tabbable panes to start, show them when \`.active\` */
.tab-content {
  padding: 35px 30px;
  background: #fff;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.05);
}
.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

/**  =====================
      Chatting css start
==========================  **/
.header-chat,
.header-user-list {
  height: 100%;
  width: 350px;
  position: fixed;
  top: 0;
  right: -350px;
  border-radius: 0;
  z-index: 1030;
  background-color: #fff;
  transition: all 0.3s ease-in-out;
}
.header-chat .main-friend-cont,
.header-user-list .main-friend-cont {
  height: calc(100vh - 166px);
}
.header-chat .main-friend-cont .main-friend-list,
.header-user-list .main-friend-cont .main-friend-list {
  height: calc(100vh - 85px);
}
.header-chat .h-list-header,
.header-user-list .h-list-header {
  padding: 15px;
  border-bottom: 1px solid #f1f1f1;
}
.header-chat .h-list-body,
.header-user-list .h-list-body {
  padding: 20px 0;
}
.header-chat.open,
.header-user-list.open {
  box-shadow: 0 1px 10px 0 rgba(69, 90, 100, 0.2);
  right: 0;
}

.header-user-list.open .h-close-text {
  position: absolute;
  top: 111px;
  left: -99px;
}
.header-user-list.open .h-close-text i {
  position: absolute;
  top: 23px;
  left: 73px;
  font-size: 25px;
  z-index: 1003;
  color: #1de9b6;
}
.header-user-list.open .h-close-text:after {
  content: "a";
  font-family: "pct";
  z-index: 1001;
  font-size: 150px;
  line-height: 0;
  color: #fff;
  position: absolute;
  top: 35px;
  left: 6px;
  text-shadow: -4px 0 7px rgba(69, 90, 100, 0.12);
}
.header-user-list.open.msg-open:after {
  color: rgba(4, 169, 245, 0.1);
}

.h-list-header .form-control:active, .h-list-header .form-control:focus, .h-list-header .form-control:hover {
  box-shadow: none;
  outline: none;
}

.h-list-body {
  position: relative;
}
.h-list-body .userlist-box {
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 15px 20px;
  position: relative;
}
.h-list-body .userlist-box:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 20px;
  width: calc(100% - 40px);
  height: 1px;
  background: #f3f4f9;
}
.h-list-body .userlist-box.active {
  background: #e0f5fe;
}
.h-list-body .userlist-box .media-left {
  padding-right: 10px;
}
.h-list-body .userlist-box .media-object {
  width: 50px;
  display: inline-block;
}
.h-list-body .userlist-box .chat-header {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 0;
}
.h-list-body .userlist-box .chat-header small {
  margin-top: 5px;
  font-size: 90%;
}
.h-list-body .userlist-box .live-status {
  height: 25px;
  width: 25px;
  position: absolute;
  top: 28px;
  right: 20px;
  border-radius: 100%;
  color: #fff;
  padding: 2px 0;
  text-align: center;
  background: linear-gradient(-135deg, #1de9b6 0%, #1dc4e9 100%);
}

.header-chat .h-list-header {
  text-align: center;
  position: relative;
}
.header-chat .h-list-header h6 {
  margin: 5px 0;
}
.header-chat .h-list-header .h-back-user-list {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;
  width: 40px;
  justify-content: center;
  font-size: 20px;
}
.header-chat .main-chat-cont {
  height: calc(100vh - 166px);
}
.header-chat .h-list-body {
  height: 100%;
  background: #e0f5fe;
}
.header-chat .h-list-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  right: 0;
  padding: 20px 15px;
  z-index: 10;
  background: #e0f5fe;
}
.header-chat .h-list-footer .input-group {
  background: #fff;
  border: none;
  display: inline-flex;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
  padding: 7px;
  border-radius: 20px 0 10px 20px;
  width: calc(100% - 40px);
}
.header-chat .h-list-footer .input-group .form-control,
.header-chat .h-list-footer .input-group .input-group-text {
  background: transparent;
  border: none;
  border-radius: 0;
  padding: 0;
}
.header-chat .h-list-footer .input-group .btn-send:active, .header-chat .h-list-footer .input-group .btn-send:focus, .header-chat .h-list-footer .input-group .btn-send:hover,
.header-chat .h-list-footer .input-group .form-control:active,
.header-chat .h-list-footer .input-group .form-control:focus,
.header-chat .h-list-footer .input-group .form-control:hover {
  outline: none;
  box-shadow: none;
}
.header-chat .h-list-footer .input-group .btn-attach {
  border-radius: 50% !important;
  padding: 5px;
  margin-right: 5px;
}
.header-chat .h-list-footer .input-group .btn-attach > i {
  margin-right: 0;
}
.header-chat .h-list-footer .input-group .btn-send {
  border-radius: 50% !important;
  padding: 10px;
  margin-left: 5px !important;
  position: absolute;
  right: -45px;
  top: 2px;
  z-index: 99;
}
.header-chat .h-list-footer .input-group .btn-send i {
  margin-right: 0;
}
.header-chat .h-list-footer .input-group .btn-send .input-group-text {
  color: #fff;
}
.header-chat .h-list-footer .input-group .form-control {
  transition: all 0.3s ease-in-out;
  width: 0;
}
.header-chat .h-list-footer .input-group:after {
  content: "g";
  font-family: "pct";
  z-index: 1001;
  font-size: 35px;
  line-height: 0;
  color: #fff;
  position: absolute;
  top: 18px;
  right: -23px;
  text-shadow: 4px 10px 20px rgba(0, 0, 0, 0.1);
}

.h-list-body .chat-messages {
  padding-bottom: 20px !important;
  padding-left: 15px !important;
  padding-right: 15px !important;
}
.h-list-body .chat-messages .photo-table {
  padding-right: 15px;
}
.h-list-body .chat-messages .photo-table img {
  display: inline-block;
  width: 50px;
  margin-bottom: 5px;
}
.h-list-body .chat-messages .chat-menu-content > div,
.h-list-body .chat-messages .chat-menu-reply > div {
  position: relative;
  overflow: visible;
  display: inline-block;
}
.h-list-body .chat-messages .chat-menu-content > div .chat-cont,
.h-list-body .chat-messages .chat-menu-reply > div .chat-cont {
  padding: 15px 20px;
}
.h-list-body .chat-messages .chat-menu-content .chat-time,
.h-list-body .chat-messages .chat-menu-reply .chat-time {
  margin: 9px 8px 0 10px;
}
.h-list-body .chat-messages .chat-menu-reply {
  text-align: right;
}
.h-list-body .chat-messages .chat-menu-reply > div p {
  background: #fff;
  border-radius: 4px;
  margin-bottom: 4px;
  margin-right: 25px;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
}
.h-list-body .chat-messages .chat-menu-reply > div p:first-child {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.h-list-body .chat-messages .chat-menu-reply > div p:last-child {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 0;
}
.h-list-body .chat-messages .chat-menu-reply > div:before {
  content: "f";
  font-family: "pct";
  z-index: 5;
  font-size: 30px;
  line-height: 0;
  color: #fff;
  position: absolute;
  bottom: 19px;
  right: 5px;
  text-shadow: 7px 10px 20px rgba(0, 0, 0, 0.1);
}
.h-list-body .chat-messages .chat-menu-content > div p {
  background: linear-gradient(-135deg, #1de9b6 0%, #1dc4e9 100%);
  color: #fff;
  border-radius: 4px;
  margin-bottom: 4px;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
}
.h-list-body .chat-messages .chat-menu-content > div p:first-child {
  border-top-left-radius: 0;
  border-top-right-radius: 10px;
}
.h-list-body .chat-messages .chat-menu-content > div p:last-child {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.h-list-body .chat-messages .chat-menu-content > div:before {
  content: "h";
  font-family: "pct";
  z-index: 1001;
  font-size: 30px;
  line-height: 0;
  color: #1ec9de;
  position: absolute;
  top: 15px;
  left: -20px;
  text-shadow: -4px 4px 10px rgba(0, 0, 0, 0.15);
}

/* massage page start */
.main-friend-chat {
  padding-bottom: 15px;
}

/* massage page end */
/**====== Chat css end ======**/
@media only screen and (max-width: 991px) {
  .pcoded-header {
    color: #3f4d67;
  }
}
/**  =====================
      Chart css start
==========================  **/
.nvtooltip {
  position: fixed !important;
}

/**====== Chart css end ======**/
.datta-scroll .ps__rail-y:hover > .ps__thumb-y, .datta-scroll .ps__rail-y:focus > .ps__thumb-y, .datta-scroll .ps__rail-y.ps--clicking .ps__thumb-y,
.scroll-widget .ps__rail-y:hover > .ps__thumb-y,
.scroll-widget .ps__rail-y:focus > .ps__thumb-y,
.scroll-widget .ps__rail-y.ps--clicking .ps__thumb-y,
.main-chat-cont .ps__rail-y:hover > .ps__thumb-y,
.main-chat-cont .ps__rail-y:focus > .ps__thumb-y,
.main-chat-cont .ps__rail-y.ps--clicking .ps__thumb-y,
.config-scroll .ps__rail-y:hover > .ps__thumb-y,
.config-scroll .ps__rail-y:focus > .ps__thumb-y,
.config-scroll .ps__rail-y.ps--clicking .ps__thumb-y,
.main-friend-list .ps__rail-y:hover > .ps__thumb-y,
.main-friend-list .ps__rail-y:focus > .ps__thumb-y,
.main-friend-list .ps__rail-y.ps--clicking .ps__thumb-y {
  background-color: #a7a7a7;
  width: 5px;
}
.datta-scroll .ps__thumb-y,
.scroll-widget .ps__thumb-y,
.main-chat-cont .ps__thumb-y,
.config-scroll .ps__thumb-y,
.main-friend-list .ps__thumb-y {
  background-color: #aaa;
  border-radius: 6px;
  width: 5px;
  right: 0;
}

perfect-scrollbar.datta-scroll > .ps.ps--active-y > .ps__rail-y,
perfect-scrollbar.scroll-widget > .ps.ps--active-y > .ps__rail-y,
perfect-scrollbar.main-chat-cont > .ps.ps--active-y > .ps__rail-y,
perfect-scrollbar.config-scroll > .ps.ps--active-y > .ps__rail-y,
perfect-scrollbar.main-friend-list > .ps.ps--active-y > .ps__rail-y {
  width: 5px;
}
perfect-scrollbar.datta-scroll > .ps.ps--active-y > .ps__rail-y:hover, perfect-scrollbar.datta-scroll > .ps.ps--active-y > .ps__rail-y.ps--clicking,
perfect-scrollbar.scroll-widget > .ps.ps--active-y > .ps__rail-y:hover,
perfect-scrollbar.scroll-widget > .ps.ps--active-y > .ps__rail-y.ps--clicking,
perfect-scrollbar.main-chat-cont > .ps.ps--active-y > .ps__rail-y:hover,
perfect-scrollbar.main-chat-cont > .ps.ps--active-y > .ps__rail-y.ps--clicking,
perfect-scrollbar.config-scroll > .ps.ps--active-y > .ps__rail-y:hover,
perfect-scrollbar.config-scroll > .ps.ps--active-y > .ps__rail-y.ps--clicking,
perfect-scrollbar.main-friend-list > .ps.ps--active-y > .ps__rail-y:hover,
perfect-scrollbar.main-friend-list > .ps.ps--active-y > .ps__rail-y.ps--clicking {
  width: 5px;
}
perfect-scrollbar.datta-scroll > .ps.ps--scrolling-y > .ps__rail-y, perfect-scrollbar.datta-scroll > .ps.ps--scrolling-x > .ps__rail-x,
perfect-scrollbar.scroll-widget > .ps.ps--scrolling-y > .ps__rail-y,
perfect-scrollbar.scroll-widget > .ps.ps--scrolling-x > .ps__rail-x,
perfect-scrollbar.main-chat-cont > .ps.ps--scrolling-y > .ps__rail-y,
perfect-scrollbar.main-chat-cont > .ps.ps--scrolling-x > .ps__rail-x,
perfect-scrollbar.config-scroll > .ps.ps--scrolling-y > .ps__rail-y,
perfect-scrollbar.config-scroll > .ps.ps--scrolling-x > .ps__rail-x,
perfect-scrollbar.main-friend-list > .ps.ps--scrolling-y > .ps__rail-y,
perfect-scrollbar.main-friend-list > .ps.ps--scrolling-x > .ps__rail-x {
  opacity: 0.4;
  background-color: transparent;
}
perfect-scrollbar.datta-scroll > .ps.ps--active-y > .ps__rail-y:hover, perfect-scrollbar.datta-scroll > .ps.ps--active-y > .ps__rail-y.ps--clicking,
perfect-scrollbar.scroll-widget > .ps.ps--active-y > .ps__rail-y:hover,
perfect-scrollbar.scroll-widget > .ps.ps--active-y > .ps__rail-y.ps--clicking,
perfect-scrollbar.main-chat-cont > .ps.ps--active-y > .ps__rail-y:hover,
perfect-scrollbar.main-chat-cont > .ps.ps--active-y > .ps__rail-y.ps--clicking,
perfect-scrollbar.config-scroll > .ps.ps--active-y > .ps__rail-y:hover,
perfect-scrollbar.config-scroll > .ps.ps--active-y > .ps__rail-y.ps--clicking,
perfect-scrollbar.main-friend-list > .ps.ps--active-y > .ps__rail-y:hover,
perfect-scrollbar.main-friend-list > .ps.ps--active-y > .ps__rail-y.ps--clicking {
  width: 5px;
}

.table > :not(caption) > * > * {
  border-bottom-width: 0px;
}

.map {
  position: relative !important;
}

.pcoded-header .dropdown {
  height: 70px;
}
.pcoded-header .dropdown .dropdown-toggle {
  margin: -2px 0 0 4px;
}
.pcoded-header .btn {
  padding: 0;
  margin-bottom: 0;
  margin-right: 0;
  border: none;
}
.pcoded-header .btn:after {
  right: -12px !important;
}
.pcoded-header .btn:focus, .pcoded-header .btn:active, .pcoded-header .btn:hover {
  text-decoration: none;
}
.pcoded-header .main-search .input-group-text {
  line-height: 1.5;
}
.pcoded-header .btn > i {
  margin-right: -12px;
}

.pcoded-header .main-search .input-group-text {
  line-height: 1;
}

.text-muted {
  color: #6c757d !important;
}

.card-event .label {
  border-radius: 15px;
  margin: 0;
  padding: 5px 16px;
}
.card-event i {
  position: absolute;
  bottom: 36px;
  right: 27px;
}

.carousel {
  z-index: 1 !important;
}

.rodal .rodal-dialog {
  max-width: 100%;
}

.page-link {
  font-size: 0.9rem !important;
}

.nav-outside.mob-backdrop.mob-fixed .pcoded-navbar {
  z-index: 1032;
}
.nav-outside.mob-backdrop ~ .pcoded-outside:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1031;
  background: rgba(0, 0, 0, 0.25);
}

.pcoded-header .dropdown .notification .noti-body li {
  width: 100%;
}

.header-chat .h-list-footer .input-group .btn-attach {
  padding: 0;
  width: 35px;
  height: 35px;
}
.header-chat .h-list-footer .input-group .btn-send {
  top: 7px;
}

.main-search {
  padding: 16px 12px;
}

@media only screen and (max-width: 991px) {
  .nav-outside ~ .pcoded-header,
  .nav-outside ~ .pcoded-main-container {
    margin-left: 0;
  }
  .nav-outside.mob-fixed ~ .pcoded-main-container {
    padding-top: 142px;
  }
  .pcoded-header .navbar-nav > li:last-child {
    padding-right: 35px;
  }
}
.box {
  display: inline-block;
  padding: 10px;
  box-sizing: border-box;
}

.img-preview {
  overflow: hidden;
}

.img-preview-section-container {
  display: none;
}

.carousel-inner {
  overflow: visible;
  z-index: 1050;
}

@media only screen and (max-width: 991px) {
  .pcoded-header,
  .pcoded-main-container {
    margin-left: 0;
    width: 100%;
  }
}
.card-header .card-header-right .dropdown-menu.show {
  transform: none !important;
  right: 0 !important;
  top: 100% !important;
  left: auto !important;
}

header.navbar.pcoded-header.navbar-expand-lg.header-default.headerpos-fixed {
  background: #f4f7fa;
}

header.navbar.pcoded-header.navbar-expand-lg.header-default.headerpos-fixed .b-brand .b-title {
  color: #3f4d67;
}

header.navbar.pcoded-header.navbar-expand-lg.header-default.headerpos-fixed .mobile-menu span,
header.navbar.pcoded-header.navbar-expand-lg.header-default.headerpos-fixed .mobile-menu span:after,
header.navbar.pcoded-header.navbar-expand-lg.header-default.headerpos-fixed .mobile-menu span:before {
  background-color: #3f4d67;
}

header.navbar.pcoded-header.navbar-expand-lg.header-default .mobile-menu.on span {
  background-color: transparent;
}

@media only screen and (max-width: 991px) {
  .pcoded-navbar {
    z-index: 1072;
  }
  header.navbar.pcoded-header.navbar-expand-lg.header-default.headerpos-fixed {
    background: #3f4d67;
  }
  header.navbar.pcoded-header.navbar-expand-lg.header-default.headerpos-fixed .b-brand .b-title {
    color: #fff;
  }
  header.navbar.pcoded-header.navbar-expand-lg.header-default.headerpos-fixed .mobile-menu span,
  header.navbar.pcoded-header.navbar-expand-lg.header-default.headerpos-fixed .mobile-menu span:after,
  header.navbar.pcoded-header.navbar-expand-lg.header-default.headerpos-fixed .mobile-menu span:before {
    background-color: #fff;
  }
  header.navbar.pcoded-header.navbar-expand-lg.header-default .mobile-menu.on span {
    background-color: transparent;
  }
}
.user-activity .tab-content {
  padding-top: 5px;
}

.rodal .rodal-dialog {
  height: auto !important;
  bottom: auto;
  top: 25%;
  padding: 0;
}
.rodal .rodal-dialog .card {
  box-shadow: none;
  margin-bottom: 0px;
}
.rodal .rodal-close:hover:before,
.rodal .rodal-close:hover:after {
  background: #f44236;
}

.carousel-inner {
  overflow: visible;
  z-index: 1050;
}

.form-control[type=file] {
  height: auto;
  padding-left: 0.45rem;
}

.table .badge {
  margin-right: 0.25rem;
}

.rdrInputRanges {
  display: none;
}

@media (max-width: 768px) {
  .mb-3.row > .col,
  .mb-3.row .col.d-flex {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .mb-3.row > .col:nth-child(2),
  .mb-3.row .col.d-flex:nth-child(2) {
    flex-direction: column;
    text-align: left;
  }
  .mb-3.row > .col:nth-child(2) > span,
  .mb-3.row .col.d-flex:nth-child(2) > span {
    justify-content: flex-start !important;
  }
  .mb-3.row > .col:nth-child(2) > span .form-control,
  .mb-3.row .col.d-flex:nth-child(2) > span .form-control {
    max-width: 150px;
  }
  .mb-3.row > .col:nth-child(2) .btn,
  .mb-3.row .col.d-flex:nth-child(2) .btn {
    margin-top: 8px;
    max-width: -moz-fit-content;
    max-width: fit-content;
    margin-left: 0 !important;
  }
}

.row.justify-content-between > .col > .d-flex.align-items-center strong {
  margin: 0 5px;
}

@media (max-width: 575px) {
  .row.justify-content-between > *[class*=col-],
  .row.justify-content-between > .col {
    flex: 100% 1;
  }
  .row.justify-content-between > *[class*=col-] .pagination,
  .row.justify-content-between > .col .pagination {
    justify-content: flex-start !important;
  }
  .row.justify-content-between > *[class*=col-]:first-child,
  .row.justify-content-between > .col:first-child {
    margin-bottom: 8px;
  }
  .row.justify-content-between > *[class*=col-] > .d-flex.align-items-center input,
  .row.justify-content-between > .col > .d-flex.align-items-center input {
    width: 40px !important;
    padding-left: 10px;
    padding-right: 10px;
  }
}
td img.wid-40 {
  max-width: 40px;
}

@media (max-width: 1024px) {
  .new-cust-card .d-inline-block {
    width: calc(100% - 55px);
  }
  .new-cust-card .align-middle .status {
    position: relative;
    top: 0;
    left: 0;
  }
}

.table th,
.table td {
  vertical-align: middle;
}

.cover-img-block {
  overflow: hidden;
  z-index: 1;
}

.user-about-block {
  position: relative;
  z-index: 5;
}

@media only screen and (max-width: 1200px) {
  .user-card .user-about-block {
    margin-top: -10px;
  }
}
.alert .float-right {
  margin-left: 8px;
  float: none !important;
}

@media (max-width: 768px) {
  .modal-open .modal {
    padding-left: 0 !important;
  }
}
.carousel.slide {
  overflow: hidden;
}

.table.table-bordered.table-hover th select.form-control {
  min-width: 140px;
}

@media only screen and (max-width: 575px) {
  .photoshop-picker {
    display: none;
  }
}

.css-1v494f5-Wrapper {
  z-index: 20 !important;
}`, "",{"version":3,"sources":["webpack://./src/index.scss","webpack://./src/assets/scss/style.scss","webpack://./node_modules/bootstrap/dist/css/bootstrap.css","webpack://./src/assets/scss/partials/_variables.scss","webpack://./src/assets/scss/partials/_general.scss","webpack://./src/assets/scss/partials/_generic.scss","webpack://./src/assets/scss/partials/font/_next-icon.scss","webpack://./src/assets/scss/partials/font/_feather.scss","webpack://./src/assets/scss/partials/font/_fontawesome.scss","webpack://./src/assets/scss/partials/font/_flaticon.scss","webpack://./src/assets/scss/partials/font/_cryptofont.scss","webpack://./src/assets/scss/partials/menu/_menu-lite.scss","webpack://./src/assets/scss/partials/widget/_widget.scss","webpack://./src/assets/scss/partials/theme-elements/_form.scss","webpack://./src/assets/scss/partials/theme-elements/_radiobox-checkbox.scss","webpack://./src/assets/scss/partials/theme-elements/_labels-badges.scss","webpack://./src/assets/scss/partials/theme-elements/_data-tables.scss","webpack://./src/assets/scss/partials/theme-elements/_authentication.scss","webpack://./src/assets/scss/partials/mixins/_buttons.scss","webpack://./src/assets/scss/partials/theme-elements/_button.scss","webpack://./src/assets/scss/partials/theme-elements/_breadcrumb-pagination.scss","webpack://./src/assets/scss/partials/theme-elements/_progress.scss","webpack://./src/assets/scss/partials/theme-elements/_nav.scss","webpack://./src/assets/scss/partials/other/_chat.scss","webpack://./src/assets/scss/partials/other/_chart.scss","webpack://./src/assets/scss/partials/third-party/_ngx-perfect-scrollbar.scss","webpack://./src/assets/scss/partials/third-party/_datatables.scss","webpack://./src/assets/scss/partials/third-party/_google-map.scss","webpack://./src/assets/scss/partials/third-party/react-bootstrap/_header.scss","webpack://./src/assets/scss/partials/third-party/_third-party.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;;;;;;;;;;;;;;;;;;;qFAAA;ACCA;;;;EAAA;AAKA;;EAEE,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,2BAAA;EACA,6BAAA;EACA,4BAAA;EACA,6BAAA;EACA,yBAAA;EACA,mCAAA;EACA,qCAAA;EACA,mCAAA;EACA,gCAAA;EACA,mCAAA;EACA,kCAAA;EACA,iCAAA;EACA,gCAAA;EACA,+BAAA;EACA,iCAAA;EACA,+BAAA;EACA,4BAAA;EACA,+BAAA;EACA,8BAAA;EACA,6BAAA;EACA,4BAAA;EACA,mCAAA;EACA,qCAAA;EACA,mCAAA;EACA,gCAAA;EACA,mCAAA;EACA,kCAAA;EACA,iCAAA;EACA,gCAAA;EACA,6BAAA;EACA,uBAAA;EACA,qNAAA;EACA,yGAAA;EACA,yFAAA;EACA,gDAAA;EACA,yBAAA;EACA,0BAAA;EACA,0BAAA;EACA,wBAAA;EACA,+BAAA;EACA,kBAAA;EACA,+BAAA;EACA,yBAAA;EACA,gCAAA;EACA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EACA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EACA,2BAAA;EACA,wBAAA;EACA,iCAAA;EACA,+BAAA;EACA,8BAAA;EACA,sCAAA;EACA,wBAAA;EACA,6BAAA;EACA,0BAAA;EACA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EACA,4BAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EACA,kDAAA;EACA,2DAAA;EACA,oDAAA;EACA,2DAAA;EACA,8BAAA;EACA,6BAAA;EACA,+CAAA;EACA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AFyBF;;AEtBA;EACE,kBAAA;EACA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EACA,yBAAA;EACA,sCAAA;EACA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EACA,6CAAA;EACA,sCAAA;EACA,yBAAA;EACA,gCAAA;EACA,mCAAA;EACA,qCAAA;EACA,mCAAA;EACA,gCAAA;EACA,mCAAA;EACA,kCAAA;EACA,iCAAA;EACA,gCAAA;EACA,+BAAA;EACA,iCAAA;EACA,+BAAA;EACA,4BAAA;EACA,+BAAA;EACA,8BAAA;EACA,6BAAA;EACA,4BAAA;EACA,mCAAA;EACA,qCAAA;EACA,mCAAA;EACA,gCAAA;EACA,mCAAA;EACA,kCAAA;EACA,iCAAA;EACA,gCAAA;EACA,2BAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,wCAAA;EACA,wBAAA;EACA,6BAAA;EACA,0BAAA;EACA,0BAAA;EACA,wDAAA;EACA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AFyBF;;AEtBA;;;EAGE,sBAAA;AFyBF;;AEtBA;EACE;IACE,uBAAA;EFyBF;AACF;AEtBA;EACE,SAAA;EACA,uCAAA;EACA,mCAAA;EACA,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;AFwBF;;AErBA;EACE,cAAA;EACA,cAAA;EACA,SAAA;EACA,wCAAA;EACA,aAAA;AFwBF;;AErBA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,8BAAA;AFwBF;;AErBA;EACE,iCAAA;AFwBF;;AEtBA;EACE;IACE,iBAAA;EFyBF;AACF;AEtBA;EACE,iCAAA;AFwBF;;AEtBA;EACE;IACE,eAAA;EFyBF;AACF;AEtBA;EACE,+BAAA;AFwBF;;AEtBA;EACE;IACE,kBAAA;EFyBF;AACF;AEtBA;EACE,iCAAA;AFwBF;;AEtBA;EACE;IACE,iBAAA;EFyBF;AACF;AEtBA;EACE,kBAAA;AFwBF;;AErBA;EACE,eAAA;AFwBF;;AErBA;EACE,aAAA;EACA,mBAAA;AFwBF;;AErBA;EACE,yCAAA;EACA,iCAAA;EACA,YAAA;EAEA,8BAAA;AFwBF;;AErBA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AFwBF;;AErBA;;EAEE,kBAAA;AFwBF;;AErBA;;;EAGE,aAAA;EACA,mBAAA;AFwBF;;AErBA;;;;EAIE,gBAAA;AFwBF;;AErBA;EACE,gBAAA;AFwBF;;AErBA;EACE,qBAAA;EACA,cAAA;AFwBF;;AErBA;EACE,gBAAA;AFwBF;;AErBA;;EAEE,mBAAA;AFwBF;;AErBA;EACE,kBAAA;AFwBF;;AErBA;EACE,iBAAA;EACA,gCAAA;EACA,wCAAA;AFwBF;;AErBA;;EAEE,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,wBAAA;AFwBF;;AErBA;EACE,eAAA;AFwBF;;AErBA;EACE,WAAA;AFwBF;;AErBA;EACE,gEAAA;EACA,0BAAA;AFwBF;;AEtBA;EACE,mDAAA;AFyBF;;AEtBA;EACE,cAAA;EACA,qBAAA;AFyBF;;AEtBA;;;;EAIE,qCAAA;EACA,cAAA;AFyBF;;AEtBA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AFyBF;;AEvBA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;AF0BF;;AEvBA;EACE,kBAAA;EACA,2BAAA;EACA,qBAAA;AF0BF;;AExBA;EACE,cAAA;AF2BF;;AExBA;EACE,2BAAA;EACA,kBAAA;EACA,wBAAA;EACA,sCAAA;EACA,sBAAA;AF2BF;;AEzBA;EACE,UAAA;EACA,cAAA;AF4BF;;AEzBA;EACE,gBAAA;AF4BF;;AEzBA;;EAEE,sBAAA;AF4BF;;AEzBA;EACE,oBAAA;EACA,yBAAA;AF4BF;;AEzBA;EACE,mBAAA;EACA,sBAAA;EACA,gCAAA;EACA,gBAAA;AF4BF;;AEzBA;EACE,mBAAA;EACA,gCAAA;AF4BF;;AEzBA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AF4BF;;AEzBA;EACE,qBAAA;AF4BF;;AEzBA;EACE,gBAAA;AF4BF;;AEzBA;EACE,UAAA;AF4BF;;AEzBA;;;;;EAKE,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;AF4BF;;AEzBA;;EAEE,oBAAA;AF4BF;;AEzBA;EACE,eAAA;AF4BF;;AEzBA;EACE,iBAAA;AF4BF;;AE1BA;EACE,UAAA;AF6BF;;AE1BA;EACE,wBAAA;AF6BF;;AE1BA;;;;EAIE,0BAAA;AF6BF;;AE3BA;;;;EAIE,eAAA;AF8BF;;AE3BA;EACE,UAAA;EACA,kBAAA;AF8BF;;AE3BA;EACE,gBAAA;AF8BF;;AE3BA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AF8BF;;AE3BA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBAAA;EACA,iCAAA;EACA,oBAAA;AF8BF;;AE5BA;EACE;IACE,iBAAA;EF+BF;AACF;AE7BA;EACE,WAAA;AF+BF;;AE5BA;;;;;;;EAOE,UAAA;AF+BF;;AE5BA;EACE,YAAA;AF+BF;;AE5BA;EACE,6BAAA;EACA,oBAAA;AF+BF;;AE5BA;;;;;;;CAAA;AAQA;EACE,wBAAA;AF+BF;;AE5BA;EACE,UAAA;AF+BF;;AEvBA;EACE,aAAA;EACA,0BAAA;AF+BF;;AE5BA;EACE,qBAAA;AF+BF;;AE5BA;EACE,SAAA;AF+BF;;AE5BA;EACE,kBAAA;EACA,eAAA;AF+BF;;AE5BA;EACE,wBAAA;AF+BF;;AE5BA;EACE,wBAAA;AF+BF;;AE5BA;EACE,kBAAA;EACA,gBAAA;AF+BF;;AE5BA;EACE,iCAAA;EACA,gBAAA;EACA,gBAAA;AF+BF;;AE7BA;EACE;IACE,eAAA;EFgCF;AACF;AE7BA;EACE,iCAAA;EACA,gBAAA;EACA,gBAAA;AF+BF;;AE7BA;EACE;IACE,iBAAA;EFgCF;AACF;AE7BA;EACE,iCAAA;EACA,gBAAA;EACA,gBAAA;AF+BF;;AE7BA;EACE;IACE,eAAA;EFgCF;AACF;AE7BA;EACE,iCAAA;EACA,gBAAA;EACA,gBAAA;AF+BF;;AE7BA;EACE;IACE,iBAAA;EFgCF;AACF;AE7BA;EACE,iCAAA;EACA,gBAAA;EACA,gBAAA;AF+BF;;AE7BA;EACE;IACE,eAAA;EFgCF;AACF;AE7BA;EACE,iCAAA;EACA,gBAAA;EACA,gBAAA;AF+BF;;AE7BA;EACE;IACE,iBAAA;EFgCF;AACF;AE7BA;EACE,eAAA;EACA,gBAAA;AF+BF;;AE5BA;EACE,eAAA;EACA,gBAAA;AF+BF;;AE5BA;EACE,qBAAA;AF+BF;;AE7BA;EACE,oBAAA;AFgCF;;AE7BA;EACE,kBAAA;EACA,yBAAA;AFgCF;;AE7BA;EACE,mBAAA;EACA,kBAAA;AFgCF;;AE9BA;EACE,gBAAA;AFiCF;;AE9BA;EACE,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AFiCF;;AE/BA;EACE,aAAA;AFkCF;;AE/BA;EACE,eAAA;EACA,YAAA;AFkCF;;AE/BA;EACE,gBAAA;EACA,mCAAA;EACA,2DAAA;EACA,sCAAA;EACA,eAAA;EACA,YAAA;AFkCF;;AE/BA;EACE,qBAAA;AFkCF;;AE/BA;EACE,qBAAA;EACA,cAAA;AFkCF;;AE/BA;EACE,kBAAA;EACA,gCAAA;AFkCF;;AE/BA;;;;;;;EAOE,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;AFkCF;;AE/BA;EACE;IACE,gBAAA;EFkCF;AACF;AEhCA;EACE;IACE,gBAAA;EFkCF;AACF;AEhCA;EACE;IACE,gBAAA;EFkCF;AACF;AEhCA;EACE;IACE,iBAAA;EFkCF;AACF;AEhCA;EACE;IACE,iBAAA;EFkCF;AACF;AEhCA;EACE,qBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;EACA,2BAAA;AFkCF;;AE/BA;EACE,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,yCAAA;EACA,6CAAA;EACA,4CAAA;AFkCF;;AEhCA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AFmCF;;AEhCA;EACE,SAAA;AFmCF;;AEhCA;EACE,cAAA;EACA,WAAA;AFmCF;;AEhCA;EACE,cAAA;EACA,WAAA;AFmCF;;AEhCA;EACE,cAAA;EACA,UAAA;AFmCF;;AEhCA;EACE,cAAA;EACA,mBAAA;AFmCF;;AEhCA;EACE,cAAA;EACA,UAAA;AFmCF;;AEhCA;EACE,cAAA;EACA,UAAA;AFmCF;;AEhCA;EACE,cAAA;EACA,mBAAA;AFmCF;;AEhCA;EACE,cAAA;EACA,WAAA;AFmCF;;AEhCA;EACE,cAAA;EACA,kBAAA;AFmCF;;AEhCA;EACE,cAAA;EACA,mBAAA;AFmCF;;AEhCA;EACE,cAAA;EACA,UAAA;AFmCF;;AEhCA;EACE,cAAA;EACA,mBAAA;AFmCF;;AEhCA;EACE,cAAA;EACA,mBAAA;AFmCF;;AEhCA;EACE,cAAA;EACA,UAAA;AFmCF;;AEhCA;EACE,cAAA;EACA,mBAAA;AFmCF;;AEhCA;EACE,cAAA;EACA,mBAAA;AFmCF;;AEhCA;EACE,cAAA;EACA,UAAA;AFmCF;;AEhCA;EACE,cAAA;EACA,mBAAA;AFmCF;;AEhCA;EACE,cAAA;EACA,mBAAA;AFmCF;;AEhCA;EACE,cAAA;EACA,WAAA;AFmCF;;AEhCA;EACE,wBAAA;AFmCF;;AEhCA;EACE,yBAAA;AFmCF;;AEhCA;EACE,gBAAA;AFmCF;;AEhCA;EACE,yBAAA;AFmCF;;AEhCA;EACE,yBAAA;AFmCF;;AEhCA;EACE,gBAAA;AFmCF;;AEhCA;EACE,yBAAA;AFmCF;;AEhCA;EACE,yBAAA;AFmCF;;AEhCA;EACE,gBAAA;AFmCF;;AEhCA;EACE,yBAAA;AFmCF;;AEhCA;EACE,yBAAA;AFmCF;;AEhCA;;EAEE,gBAAA;AFmCF;;AEhCA;;EAEE,gBAAA;AFmCF;;AEhCA;;EAEE,sBAAA;AFmCF;;AEhCA;;EAEE,sBAAA;AFmCF;;AEhCA;;EAEE,qBAAA;AFmCF;;AEhCA;;EAEE,qBAAA;AFmCF;;AEhCA;;EAEE,mBAAA;AFmCF;;AEhCA;;EAEE,mBAAA;AFmCF;;AEhCA;;EAEE,qBAAA;AFmCF;;AEhCA;;EAEE,qBAAA;AFmCF;;AEhCA;;EAEE,mBAAA;AFmCF;;AEhCA;;EAEE,mBAAA;AFmCF;;AEhCA;EACE;IACE,SAAA;EFmCF;EEjCA;IACE,cAAA;IACA,WAAA;EFmCF;EEjCA;IACE,cAAA;IACA,WAAA;EFmCF;EEjCA;IACE,cAAA;IACA,UAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,UAAA;EFmCF;EEjCA;IACE,cAAA;IACA,UAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,WAAA;EFmCF;EEjCA;IACE,cAAA;IACA,kBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,UAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,UAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,UAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,WAAA;EFmCF;EEjCA;IACE,cAAA;EFmCF;EEjCA;IACE,wBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;IACE,gBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;IACE,gBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;IACE,gBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;;IAEE,gBAAA;EFmCF;EEjCA;;IAEE,gBAAA;EFmCF;EEjCA;;IAEE,sBAAA;EFmCF;EEjCA;;IAEE,sBAAA;EFmCF;EEjCA;;IAEE,qBAAA;EFmCF;EEjCA;;IAEE,qBAAA;EFmCF;EEjCA;;IAEE,mBAAA;EFmCF;EEjCA;;IAEE,mBAAA;EFmCF;EEjCA;;IAEE,qBAAA;EFmCF;EEjCA;;IAEE,qBAAA;EFmCF;EEjCA;;IAEE,mBAAA;EFmCF;EEjCA;;IAEE,mBAAA;EFmCF;AACF;AEjCA;EACE;IACE,SAAA;EFmCF;EEjCA;IACE,cAAA;IACA,WAAA;EFmCF;EEjCA;IACE,cAAA;IACA,WAAA;EFmCF;EEjCA;IACE,cAAA;IACA,UAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,UAAA;EFmCF;EEjCA;IACE,cAAA;IACA,UAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,WAAA;EFmCF;EEjCA;IACE,cAAA;IACA,kBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,UAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,UAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,UAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,WAAA;EFmCF;EEjCA;IACE,cAAA;EFmCF;EEjCA;IACE,wBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;IACE,gBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;IACE,gBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;IACE,gBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;;IAEE,gBAAA;EFmCF;EEjCA;;IAEE,gBAAA;EFmCF;EEjCA;;IAEE,sBAAA;EFmCF;EEjCA;;IAEE,sBAAA;EFmCF;EEjCA;;IAEE,qBAAA;EFmCF;EEjCA;;IAEE,qBAAA;EFmCF;EEjCA;;IAEE,mBAAA;EFmCF;EEjCA;;IAEE,mBAAA;EFmCF;EEjCA;;IAEE,qBAAA;EFmCF;EEjCA;;IAEE,qBAAA;EFmCF;EEjCA;;IAEE,mBAAA;EFmCF;EEjCA;;IAEE,mBAAA;EFmCF;AACF;AEjCA;EACE;IACE,SAAA;EFmCF;EEjCA;IACE,cAAA;IACA,WAAA;EFmCF;EEjCA;IACE,cAAA;IACA,WAAA;EFmCF;EEjCA;IACE,cAAA;IACA,UAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,UAAA;EFmCF;EEjCA;IACE,cAAA;IACA,UAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,WAAA;EFmCF;EEjCA;IACE,cAAA;IACA,kBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,UAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,UAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,UAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,WAAA;EFmCF;EEjCA;IACE,cAAA;EFmCF;EEjCA;IACE,wBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;IACE,gBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;IACE,gBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;IACE,gBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;;IAEE,gBAAA;EFmCF;EEjCA;;IAEE,gBAAA;EFmCF;EEjCA;;IAEE,sBAAA;EFmCF;EEjCA;;IAEE,sBAAA;EFmCF;EEjCA;;IAEE,qBAAA;EFmCF;EEjCA;;IAEE,qBAAA;EFmCF;EEjCA;;IAEE,mBAAA;EFmCF;EEjCA;;IAEE,mBAAA;EFmCF;EEjCA;;IAEE,qBAAA;EFmCF;EEjCA;;IAEE,qBAAA;EFmCF;EEjCA;;IAEE,mBAAA;EFmCF;EEjCA;;IAEE,mBAAA;EFmCF;AACF;AEjCA;EACE;IACE,SAAA;EFmCF;EEjCA;IACE,cAAA;IACA,WAAA;EFmCF;EEjCA;IACE,cAAA;IACA,WAAA;EFmCF;EEjCA;IACE,cAAA;IACA,UAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,UAAA;EFmCF;EEjCA;IACE,cAAA;IACA,UAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,WAAA;EFmCF;EEjCA;IACE,cAAA;IACA,kBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,UAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,UAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,UAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,WAAA;EFmCF;EEjCA;IACE,cAAA;EFmCF;EEjCA;IACE,wBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;IACE,gBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;IACE,gBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;IACE,gBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;;IAEE,gBAAA;EFmCF;EEjCA;;IAEE,gBAAA;EFmCF;EEjCA;;IAEE,sBAAA;EFmCF;EEjCA;;IAEE,sBAAA;EFmCF;EEjCA;;IAEE,qBAAA;EFmCF;EEjCA;;IAEE,qBAAA;EFmCF;EEjCA;;IAEE,mBAAA;EFmCF;EEjCA;;IAEE,mBAAA;EFmCF;EEjCA;;IAEE,qBAAA;EFmCF;EEjCA;;IAEE,qBAAA;EFmCF;EEjCA;;IAEE,mBAAA;EFmCF;EEjCA;;IAEE,mBAAA;EFmCF;AACF;AEjCA;EACE;IACE,SAAA;EFmCF;EEjCA;IACE,cAAA;IACA,WAAA;EFmCF;EEjCA;IACE,cAAA;IACA,WAAA;EFmCF;EEjCA;IACE,cAAA;IACA,UAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,UAAA;EFmCF;EEjCA;IACE,cAAA;IACA,UAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,WAAA;EFmCF;EEjCA;IACE,cAAA;IACA,kBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,UAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,UAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,UAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,mBAAA;EFmCF;EEjCA;IACE,cAAA;IACA,WAAA;EFmCF;EEjCA;IACE,cAAA;EFmCF;EEjCA;IACE,wBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;IACE,gBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;IACE,gBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;IACE,gBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;IACE,yBAAA;EFmCF;EEjCA;;IAEE,gBAAA;EFmCF;EEjCA;;IAEE,gBAAA;EFmCF;EEjCA;;IAEE,sBAAA;EFmCF;EEjCA;;IAEE,sBAAA;EFmCF;EEjCA;;IAEE,qBAAA;EFmCF;EEjCA;;IAEE,qBAAA;EFmCF;EEjCA;;IAEE,mBAAA;EFmCF;EEjCA;;IAEE,mBAAA;EFmCF;EEjCA;;IAEE,qBAAA;EFmCF;EEjCA;;IAEE,qBAAA;EFmCF;EEjCA;;IAEE,mBAAA;EFmCF;EEjCA;;IAEE,mBAAA;EFmCF;AACF;AEjCA;EACE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EACA,0CAAA;EACA,gCAAA;EACA,+CAAA;EACA,iCAAA;EACA,kDAAA;EACA,+DAAA;EACA,iDAAA;EACA,6DAAA;EACA,gDAAA;EACA,8DAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,0CAAA;AFmCF;;AEjCA;EACE,sBAAA;EACA,qFAAA;EACA,oCAAA;EACA,2CAAA;EACA,2GAAA;AFoCF;;AElCA;EACE,uBAAA;AFqCF;;AEnCA;EACE,sBAAA;AFsCF;;AEnCA;EACE,+DAAA;AFsCF;;AEnCA;EACE,iBAAA;AFsCF;;AEnCA;EACE,wBAAA;AFsCF;;AEnCA;EACE,sCAAA;AFsCF;;AEpCA;EACE,sCAAA;AFuCF;;AEpCA;EACE,sBAAA;AFuCF;;AErCA;EACE,mBAAA;AFwCF;;AErCA;EACE,oDAAA;EACA,8CAAA;AFwCF;;AErCA;EACE,oDAAA;EACA,8CAAA;AFwCF;;AErCA;EACE,oDAAA;EACA,8CAAA;AFwCF;;AErCA;EACE,mDAAA;EACA,6CAAA;AFwCF;;AErCA;EACE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,0CAAA;AFwCF;;AErCA;EACE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,0CAAA;AFwCF;;AErCA;EACE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,0CAAA;AFwCF;;AErCA;EACE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,0CAAA;AFwCF;;AErCA;EACE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,0CAAA;AFwCF;;AErCA;EACE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,0CAAA;AFwCF;;AErCA;EACE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,0CAAA;AFwCF;;AErCA;EACE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,0CAAA;AFwCF;;AErCA;EACE,gBAAA;EACA,iCAAA;AFwCF;;AErCA;EACE;IACE,gBAAA;IACA,iCAAA;EFwCF;AACF;AEtCA;EACE;IACE,gBAAA;IACA,iCAAA;EFwCF;AACF;AEtCA;EACE;IACE,gBAAA;IACA,iCAAA;EFwCF;AACF;AEtCA;EACE;IACE,gBAAA;IACA,iCAAA;EFwCF;AACF;AEtCA;EACE;IACE,gBAAA;IACA,iCAAA;EFwCF;AACF;AEtCA;EACE,qBAAA;AFwCF;;AErCA;EACE,oDAAA;EACA,uDAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AFwCF;;AErCA;EACE,kDAAA;EACA,qDAAA;EACA,kBAAA;AFwCF;;AErCA;EACE,mDAAA;EACA,sDAAA;EACA,mBAAA;AFwCF;;AErCA;EACE,mBAAA;EACA,kBAAA;EACA,gCAAA;AFwCF;;AErCA;EACE,cAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;EAGA,gBAAA;EACA,mCAAA;EACA,4BAAA;EACA,2DAAA;EACA,sCAAA;EACA,wEAAA;AFwCF;;AEtCA;EACE;IACE,gBAAA;EFyCF;AACF;AEvCA;EACE,gBAAA;AFyCF;;AEvCA;EACE,eAAA;AF0CF;;AExCA;EACE,2BAAA;EACA,mCAAA;EACA,qBAAA;EACA,UAAA;EACA,kDAAA;AF2CF;;AEzCA;EACE,eAAA;EACA,aAAA;EACA,SAAA;AF4CF;;AE1CA;EACE,cAAA;EACA,UAAA;AF6CF;;AEvCA;EACE,gCAAA;EACA,UAAA;AF+CF;;AE7CA;EACE,wCAAA;EACA,UAAA;AFgDF;;AE9BA;EACE,yBAAA;EACA,0BAAA;EAEA,0BAAA;EACA,2BAAA;EACA,uCAAA;EACA,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,+CAAA;EACA,gBAAA;EACA,qIAAA;AFkDF;;AEhDA;EAKE;IACE,gBAAA;EFmDF;AACF;;AE9CA;EACE,wCAAA;AFoDF;;AEjDA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;EACA,6BAAA;EACA,yBAAA;EACA,sCAAA;AFoDF;;AElDA;EACE,UAAA;AFqDF;;AEnDA;EACE,gBAAA;EACA,eAAA;AFsDF;;AEnDA;EACE,6DAAA;EACA,uBAAA;EACA,mBAAA;EACA,yCAAA;AFsDF;;AE9CA;EACE,uBAAA;EACA,wBAAA;EAEA,yBAAA;AFwDF;;AErDA;EACE,2DAAA;EACA,oBAAA;EACA,kBAAA;EACA,yCAAA;AFwDF;;AEhDA;EACE,oBAAA;EACA,qBAAA;EAEA,uBAAA;AF0DF;;AEvDA;EACE,8DAAA;AF0DF;;AExDA;EACE,6DAAA;AF2DF;;AEzDA;EACE,2DAAA;AF4DF;;AEzDA;EACE,WAAA;EACA,0DAAA;EACA,iBAAA;AF4DF;;AE1DA;EACE,eAAA;AF6DF;;AE3DA;EACE,oBAAA;EACA,sCAAA;AF8DF;;AE5DA;EACE,oBAAA;EACA,sCAAA;AF+DF;;AE7DA;EACE,yDAAA;AFgEF;;AE9DA;EACE,uDAAA;AFiEF;;AE9DA;EACE,gEAAA;EACA,cAAA;EACA,WAAA;EACA,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;EAGA,gBAAA;EACA,mCAAA;EACA,mFAAA;EACA,4BAAA;EACA,yCAAA;EACA,0BAAA;EACA,2DAAA;EACA,sCAAA;EACA,wEAAA;AFiEF;;AE/DA;EACE;IACE,gBAAA;EFkEF;AACF;AEhEA;EACE,qBAAA;EACA,UAAA;EACA,kDAAA;AFkEF;;AEhEA;EACE,sBAAA;EACA,sBAAA;AFmEF;;AEjEA;EACE,wCAAA;AFoEF;;AElEA;EACE,kBAAA;EACA,uCAAA;AFqEF;;AElEA;EACE,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;EACA,yCAAA;AFqEF;;AElEA;EACE,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yCAAA;AFqEF;;AElEA;EACE,gEAAA;AFqEF;;AElEA;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;AFqEF;;AEnEA;EACE,WAAA;EACA,mBAAA;AFsEF;;AEnEA;EACE,oBAAA;EACA,eAAA;EACA,iBAAA;AFsEF;;AEpEA;EACE,YAAA;EACA,oBAAA;EACA,cAAA;AFuEF;;AEpEA;EACE,qCAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EAGA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,2DAAA;EACA,iCAAA;EAEA,yBAAA;AFuEF;;AErEA;EACE,qBAAA;AFwEF;;AEtEA;EACE,kBAAA;AFyEF;;AEvEA;EACE,uBAAA;AF0EF;;AExEA;EACE,qBAAA;EACA,UAAA;EACA,kDAAA;AF2EF;;AEzEA;EACE,yBAAA;EACA,qBAAA;AF4EF;;AE1EA;EACE,iEAAA;AF6EF;;AE3EA;EACE,iEAAA;AF8EF;;AE5EA;EACE,yBAAA;EACA,qBAAA;EACA,iEAAA;AF+EF;;AE7EA;EACE,oBAAA;EACA,YAAA;EACA,YAAA;AFgFF;;AE9EA;EACE,eAAA;EACA,YAAA;AFiFF;;AE9EA;EACE,mBAAA;AFiFF;;AE/EA;EACE,4DAAA;EACA,UAAA;EACA,mBAAA;EACA,0CAAA;EACA,gCAAA;EACA,kBAAA;EACA,iDAAA;AFkFF;;AEhFA;EACE;IACE,gBAAA;EFmFF;AACF;AEjFA;EACE,4DAAA;AFmFF;;AEjFA;EACE,iCAAA;EACA,4DAAA;AFoFF;;AElFA;EACE,oBAAA;EACA,eAAA;AFqFF;;AEnFA;EACE,oBAAA;EACA,cAAA;AFsFF;;AEnFA;EACE,qBAAA;EACA,kBAAA;AFsFF;;AEnFA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;AFsFF;;AEpFA;EACE,oBAAA;EACA,YAAA;EACA,aAAA;AFuFF;;AEpFA;EACE,4DAAA;AFuFF;;AEpFA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EAGA,gBAAA;EACA,6BAAA;AFuFF;;AErFA;EACE,UAAA;AFwFF;;AEtFA;EACE,kEAAA;AFyFF;;AEvFA;EACE,kEAAA;AF0FF;;AExFA;EACE,SAAA;AF2FF;;AEzFA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EAEA,gBAAA;EACA,yBAAA;EACA,SAAA;EACA,mBAAA;EAEA,oHAAA;EAAA,4GAAA;AF4FF;;AE1FA;EACE;IAEE,wBAAA;IAAA,gBAAA;EF6FF;AACF;AE3FA;EACE,yBAAA;AF6FF;;AE3FA;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EACA,yBAAA;EACA,mBAAA;AF8FF;;AE5FA;EACE,WAAA;EACA,YAAA;EAEA,gBAAA;EACA,yBAAA;EACA,SAAA;EACA,mBAAA;EAEA,iHAAA;EAAA,4GAAA;AF+FF;;AE7FA;EACE;IAEE,qBAAA;IAAA,gBAAA;EFgGF;AACF;AE9FA;EACE,yBAAA;AFgGF;;AE9FA;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EACA,yBAAA;EACA,mBAAA;AFiGF;;AE/FA;EACE,oBAAA;AFkGF;;AEhGA;EACE,2CAAA;AFmGF;;AEjGA;EACE,2CAAA;AFoGF;;AEjGA;EACE,kBAAA;AFoGF;;AElGA;;;EAGE,iDAAA;EACA,qDAAA;EACA,iBAAA;AFqGF;;AEnGA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gDAAA;EACA,qBAAA;EACA,gEAAA;AFsGF;;AEpGA;EACE;IACE,gBAAA;EFuGF;AACF;AErGA;;EAEE,qBAAA;AFuGF;;AElGA;;EAEE,kBAAA;AFyGF;;AEnGA;;;EAGE,qBAAA;EACA,wBAAA;AF2GF;;AEzGA;;EAEE,qBAAA;EACA,wBAAA;AF4GF;;AE1GA;EACE,qBAAA;EACA,wBAAA;AF6GF;;AEvGA;;;;EAIE,2CAAA;EACA,8DAAA;AF+GF;;AEpGA;;;;EAIE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,mCAAA;EACA,sCAAA;AFiHF;;AE/GA;EACE,2CAAA;EACA,8DAAA;AFkHF;;AEhHA;EACE,sCAAA;AFmHF;;AEjHA;;EAEE,cAAA;AFoHF;;AElHA;;EAEE,wCAAA;AFqHF;;AElHA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;AFqHF;;AEnHA;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;AFsHF;;AEpHA;;;EAGE,UAAA;AFuHF;;AErHA;EACE,kBAAA;EACA,UAAA;AFwHF;;AEtHA;EACE,UAAA;AFyHF;;AEtHA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;EACA,kBAAA;EACA,mBAAA;EACA,uCAAA;EACA,2DAAA;EACA,sCAAA;AFyHF;;AEtHA;;;;EAIE,oBAAA;EACA,kBAAA;EACA,yCAAA;AFyHF;;AEtHA;;;;EAIE,uBAAA;EACA,mBAAA;EACA,yCAAA;AFyHF;;AEtHA;;EAEE,mBAAA;AFyHF;;AEtHA;;;;EAIE,0BAAA;EACA,6BAAA;AFyHF;;AEvHA;;;;EAIE,0BAAA;EACA,6BAAA;AF0HF;;AExHA;EACE,8CAAA;EACA,yBAAA;EACA,4BAAA;AF2HF;;AEzHA;;EAEE,yBAAA;EACA,4BAAA;AF4HF;;AEzHA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,iCAAA;AF4HF;;AEzHA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,mCAAA;EACA,sCAAA;AF4HF;;AEzHA;;;;EAIE,cAAA;AF4HF;;AEzHA;EACE,+CAAA;EACA,oCAAA;EACA,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;AF4HF;;AE1HA;EACE,+CAAA;EACA,2DAAA;AF6HF;;AE1HA;EACE,oCAAA;EACA,kFAAA;AF6HF;;AE1HA;EACE,+CAAA;AF6HF;;AE3HA;EACE,iEAAA;EACA,uBAAA;EACA,+DAAA;EACA,2EAAA;AF8HF;;AE5HA;EACE,+CAAA;EACA,2DAAA;AF+HF;;AE5HA;EACE,mCAAA;AF+HF;;AE5HA;EACE,+CAAA;AF+HF;;AE7HA;EACE,4CAAA;AFgIF;;AE9HA;EACE,2DAAA;AFiIF;;AE/HA;EACE,iCAAA;AFkIF;;AE/HA;EACE,kBAAA;AFkIF;;AE/HA;;;;;EAKE,UAAA;AFkIF;;AE/HA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,mCAAA;AFkIF;;AE/HA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,kCAAA;EACA,sCAAA;AFkIF;;AE/HA;;;;EAIE,cAAA;AFkIF;;AE/HA;EACE,iDAAA;EACA,oCAAA;EACA,0DAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;AFkIF;;AEhIA;EACE,iDAAA;EACA,0DAAA;AFmIF;;AEhIA;EACE,oCAAA;EACA,kFAAA;AFmIF;;AEhIA;EACE,iDAAA;AFmIF;;AEjIA;EACE,kEAAA;EACA,uBAAA;EACA,+DAAA;EACA,2EAAA;AFoIF;;AElIA;EACE,iDAAA;EACA,0DAAA;AFqIF;;AElIA;EACE,mCAAA;AFqIF;;AElIA;EACE,iDAAA;AFqIF;;AEnIA;EACE,8CAAA;AFsIF;;AEpIA;EACE,0DAAA;AFuIF;;AErIA;EACE,mCAAA;AFwIF;;AErIA;EACE,kBAAA;AFwIF;;AErIA;;;;;EAKE,UAAA;AFwIF;;AErIA;EACE,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,wBAAA;EACA,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,6CAAA;EACA,kCAAA;EACA,+CAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,iFAAA;EACA,qBAAA;EACA,wDAAA;EACA,sCAAA;EACA,kCAAA;EACA,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;EAEA,iBAAA;EACA,mEAAA;EACA,0CAAA;EACA,kCAAA;EACA,qIAAA;AFwIF;;AEtIA;EACE;IACE,gBAAA;EFyIF;AACF;AEvIA;EACE,gCAAA;EACA,wCAAA;EACA,8CAAA;AFyIF;;AEvIA;EACE,0BAAA;EACA,kCAAA;EACA,wCAAA;AF0IF;;AExIA;EACE,gCAAA;EACA,wCAAA;EACA,8CAAA;EACA,UAAA;EACA,0CAAA;AF2IF;;AEzIA;EACE,8CAAA;EACA,UAAA;EACA,0CAAA;AF4IF;;AE1IA;EACE,iCAAA;EACA,yCAAA;EACA,+CAAA;AF6IF;;AE3IA;EACE,0CAAA;AF8IF;;AE5IA;EACE,0CAAA;AF+IF;;AE7IA;EACE,mCAAA;EACA,oBAAA;EACA,2CAAA;EACA,iDAAA;EACA,uCAAA;AFgJF;;AE7IA;EACE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AFgJF;;AE7IA;EACE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AFgJF;;AE7IA;EACE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AFgJF;;AE7IA;EACE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AFgJF;;AE7IA;EACE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AFgJF;;AE7IA;EACE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AFgJF;;AE7IA;EACE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AFgJF;;AE7IA;EACE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AFgJF;;AE7IA;EACE,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AFgJF;;AE7IA;EACE,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AFgJF;;AE7IA;EACE,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AFgJF;;AE7IA;EACE,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AFgJF;;AE7IA;EACE,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AFgJF;;AE7IA;EACE,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AFgJF;;AE7IA;EACE,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AFgJF;;AE7IA;EACE,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AFgJF;;AE7IA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,uCAAA;EACA,0BAAA;AFgJF;;AE9IA;EACE,0BAAA;AFiJF;;AE/IA;EACE,gCAAA;AFkJF;;AE/IA;EACE,0BAAA;EACA,wBAAA;EACA,2BAAA;EACA,kDAAA;AFkJF;;AE/IA;EACE,2BAAA;EACA,0BAAA;EACA,4BAAA;EACA,kDAAA;AFkJF;;AE/IA;EACE,gCAAA;AFkJF;;AEhJA;EACE;IACE,gBAAA;EFmJF;AACF;AEjJA;EACE,UAAA;AFmJF;;AEhJA;EACE,aAAA;AFmJF;;AEhJA;EACE,SAAA;EACA,gBAAA;EACA,6BAAA;AFmJF;;AEjJA;EACE;IACE,gBAAA;EFoJF;AACF;AElJA;EACE,QAAA;EACA,YAAA;EACA,4BAAA;AFoJF;;AElJA;EACE;IACE,gBAAA;EFqJF;AACF;AElJA;;;;;;EAME,kBAAA;AFoJF;;AEjJA;EACE,mBAAA;AFoJF;;AElJA;EACE,qBAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;EACA,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AFqJF;;AEnJA;EACE,cAAA;AFsJF;;AEnJA;EACE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;EACA,6BAAA;EACA,yCAAA;EACA,mCAAA;EACA,8DAAA;EACA,oDAAA;EACA,kDAAA;EACA,yFAAA;EACA,4DAAA;EACA,sCAAA;EACA,8CAAA;EACA,8CAAA;EACA,oDAAA;EACA,kDAAA;EACA,qCAAA;EACA,qCAAA;EACA,2DAAA;EACA,kCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,sCAAA;EACA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;EACA,uCAAA;EACA,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;EACA,+CAAA;AFsJF;;AEpJA;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AFuJF;;AEpJA;EACE,oBAAA;AFuJF;;AErJA;EACE,WAAA;EACA,OAAA;AFwJF;;AErJA;EACE,kBAAA;AFwJF;;AEtJA;EACE,QAAA;EACA,UAAA;AFyJF;;AEtJA;EACE;IACE,oBAAA;EFyJF;EEvJA;IACE,WAAA;IACA,OAAA;EFyJF;EEvJA;IACE,kBAAA;EFyJF;EEvJA;IACE,QAAA;IACA,UAAA;EFyJF;AACF;AEvJA;EACE;IACE,oBAAA;EFyJF;EEvJA;IACE,WAAA;IACA,OAAA;EFyJF;EEvJA;IACE,kBAAA;EFyJF;EEvJA;IACE,QAAA;IACA,UAAA;EFyJF;AACF;AEvJA;EACE;IACE,oBAAA;EFyJF;EEvJA;IACE,WAAA;IACA,OAAA;EFyJF;EEvJA;IACE,kBAAA;EFyJF;EEvJA;IACE,QAAA;IACA,UAAA;EFyJF;AACF;AEvJA;EACE;IACE,oBAAA;EFyJF;EEvJA;IACE,WAAA;IACA,OAAA;EFyJF;EEvJA;IACE,kBAAA;EFyJF;EEvJA;IACE,QAAA;IACA,UAAA;EFyJF;AACF;AEvJA;EACE;IACE,oBAAA;EFyJF;EEvJA;IACE,WAAA;IACA,OAAA;EFyJF;EEvJA;IACE,kBAAA;EFyJF;EEvJA;IACE,QAAA;IACA,UAAA;EFyJF;AACF;AEvJA;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AFyJF;;AEvJA;EACE,qBAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;AF0JF;;AExJA;EACE,cAAA;AF2JF;;AExJA;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AF2JF;;AEzJA;EACE,qBAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;EACA,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;AF4JF;;AE1JA;EACE,cAAA;AF6JF;;AE3JA;EACE,iBAAA;AF8JF;;AE3JA;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AF8JF;;AE5JA;EACE,qBAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;AF+JF;;AE7JA;EACE,aAAA;AFgKF;;AE9JA;EACE,qBAAA;EACA,qBAAA;EACA,uBAAA;EACA,WAAA;EACA,mCAAA;EACA,yBAAA;EACA,sCAAA;AFiKF;;AE/JA;EACE,cAAA;AFkKF;;AEhKA;EACE,iBAAA;AFmKF;;AEhKA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AFmKF;;AEhKA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gBAAA;EACA,oCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;EACA,uDAAA;AFmKF;;AEjKA;EACE,0CAAA;EACA,kDAAA;AFoKF;;AElKA;EACE,2CAAA;EACA,qBAAA;EACA,mDAAA;AFqKF;;AEnKA;EACE,6CAAA;EACA,oBAAA;EACA,6BAAA;AFsKF;;AEnKA;EACE,cAAA;AFsKF;;AEnKA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;EACA,mBAAA;EACA,sCAAA;EACA,mBAAA;AFsKF;;AEnKA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AFsKF;;AEnKA;EACE,4BAAA;EACA,yBAAA;EACA,8DAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,4DAAA;EACA,sDAAA;EACA,qCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;AFsKF;;AEnKA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AFsKF;;AEpKA;;EAEE,kBAAA;EACA,cAAA;AFuKF;;AErKA;;;;;;;;;;;;EAYE,UAAA;AFwKF;;AErKA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AFwKF;;AEtKA;EACE,WAAA;AFyKF;;AEtKA;EACE,sCAAA;AFyKF;;AEvKA;;EAEE,8CAAA;AF0KF;;AExKA;;;EAGE,0BAAA;EACA,6BAAA;AF2KF;;AEzKA;;;EAGE,yBAAA;EACA,4BAAA;AF4KF;;AEzKA;EACE,wBAAA;EACA,uBAAA;AF4KF;;AE1KA;EACE,cAAA;AF6KF;;AE3KA;EACE,eAAA;AF8KF;;AE3KA;EACE,uBAAA;EACA,sBAAA;AF8KF;;AE3KA;EACE,sBAAA;EACA,qBAAA;AF8KF;;AE3KA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AF8KF;;AE5KA;;EAEE,WAAA;AF+KF;;AE7KA;;EAEE,6CAAA;AFgLF;;AE9KA;;EAEE,6BAAA;EACA,4BAAA;AFiLF;;AE/KA;;EAEE,yBAAA;EACA,0BAAA;AFkLF;;AE/KA;EACE,6BAAA;EACA,+BAAA;EACA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,uDAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AFkLF;;AE/KA;EACE,cAAA;EACA,kEAAA;EACA,uCAAA;EACA,2CAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EACA,uGAAA;AFkLF;;AEhLA;EACE;IACE,gBAAA;EFmLF;AACF;AEjLA;EACE,qCAAA;AFmLF;;AEjLA;EACE,UAAA;EACA,kDAAA;AFoLF;;AElLA;EACE,wCAAA;EACA,oBAAA;EACA,eAAA;AFqLF;;AElLA;EACE,kDAAA;EACA,kDAAA;EACA,oDAAA;EACA,2GAAA;EACA,yDAAA;EACA,+CAAA;EACA,uGAAA;EACA,oFAAA;AFqLF;;AEnLA;EACE,yDAAA;EACA,yDAAA;EACA,wDAAA;EACA,yDAAA;AFsLF;;AEpLA;EACE,kBAAA;EACA,wDAAA;AFuLF;;AErLA;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;AFwLF;;AEtLA;EACE,sDAAA;EACA,yBAAA;EACA,0BAAA;AFyLF;;AEtLA;EACE,qDAAA;EACA,sCAAA;EACA,sCAAA;AFyLF;;AEvLA;EACE,gDAAA;AF0LF;;AExLA;;EAEE,4CAAA;EACA,oDAAA;AF2LF;;AExLA;EACE,4BAAA;EACA,yCAAA;EACA,8DAAA;EACA,gCAAA;AF2LF;;AEzLA;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;AF4LF;;AE1LA;EACE,iCAAA;AF6LF;;AE3LA;;EAEE,gBAAA;EACA,gDAAA;EACA,iCAAA;AF8LF;;AE3LA;;EAEE,cAAA;EACA,kBAAA;AF8LF;;AE3LA;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AF8LF;;AE3LA;;EAEE,WAAA;AF8LF;;AE3LA;EACE,aAAA;AF8LF;;AE5LA;EACE,cAAA;AF+LF;;AE5LA;EACE,wBAAA;EACA,6BAAA;EACA,2DAAA;EACA,gEAAA;EACA,mEAAA;EACA,+DAAA;EACA,sCAAA;EACA,kCAAA;EACA,oCAAA;EACA,8DAAA;EACA,oEAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,qEAAA;EACA,0EAAA;EACA,0DAAA;EACA,wCAAA;EACA,4DAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;AF+LF;;AE7LA;;;;;;;EAOE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AFgMF;;AE9LA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;EACA,2CAAA;EACA,mCAAA;EACA,qBAAA;EACA,mBAAA;AFiMF;;AE/LA;EACE,yCAAA;AFkMF;;AE/LA;EACE,0BAAA;EACA,+BAAA;EACA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AFkMF;;AEhMA;EACE,oCAAA;AFmMF;;AEjMA;EACE,gBAAA;AFoMF;;AEjMA;EACE,mBAAA;EACA,sBAAA;EACA,6BAAA;AFoMF;;AElMA;;;EAGE,oCAAA;AFqMF;;AElMA;EACE,gBAAA;EACA,YAAA;EACA,mBAAA;AFqMF;;AElMA;EACE,8EAAA;EACA,6CAAA;EACA,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;EACA,qDAAA;EACA,+CAAA;AFqMF;;AEnMA;EACE;IACE,gBAAA;EFsMF;AACF;AEpMA;EACE,qBAAA;AFsMF;;AEpMA;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;AFuMF;;AEpMA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AFuMF;;AEpMA;EACE,yCAAA;EACA,gBAAA;AFuMF;;AEpMA;EACE;IACE,iBAAA;IACA,2BAAA;EFuMF;EErMA;IACE,mBAAA;EFuMF;EErMA;IACE,kBAAA;EFuMF;EErMA;IACE,kDAAA;IACA,iDAAA;EFuMF;EErMA;IACE,iBAAA;EFuMF;EErMA;IACE,wBAAA;IACA,gBAAA;EFuMF;EErMA;IACE,aAAA;EFuMF;EErMA;IACE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IACA,gBAAA;EFuMF;EErMA;IACE,aAAA;EFuMF;EErMA;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EFuMF;AACF;AErMA;EACE;IACE,iBAAA;IACA,2BAAA;EFuMF;EErMA;IACE,mBAAA;EFuMF;EErMA;IACE,kBAAA;EFuMF;EErMA;IACE,kDAAA;IACA,iDAAA;EFuMF;EErMA;IACE,iBAAA;EFuMF;EErMA;IACE,wBAAA;IACA,gBAAA;EFuMF;EErMA;IACE,aAAA;EFuMF;EErMA;IACE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IACA,gBAAA;EFuMF;EErMA;IACE,aAAA;EFuMF;EErMA;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EFuMF;AACF;AErMA;EACE;IACE,iBAAA;IACA,2BAAA;EFuMF;EErMA;IACE,mBAAA;EFuMF;EErMA;IACE,kBAAA;EFuMF;EErMA;IACE,kDAAA;IACA,iDAAA;EFuMF;EErMA;IACE,iBAAA;EFuMF;EErMA;IACE,wBAAA;IACA,gBAAA;EFuMF;EErMA;IACE,aAAA;EFuMF;EErMA;IACE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IACA,gBAAA;EFuMF;EErMA;IACE,aAAA;EFuMF;EErMA;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EFuMF;AACF;AErMA;EACE;IACE,iBAAA;IACA,2BAAA;EFuMF;EErMA;IACE,mBAAA;EFuMF;EErMA;IACE,kBAAA;EFuMF;EErMA;IACE,kDAAA;IACA,iDAAA;EFuMF;EErMA;IACE,iBAAA;EFuMF;EErMA;IACE,wBAAA;IACA,gBAAA;EFuMF;EErMA;IACE,aAAA;EFuMF;EErMA;IACE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IACA,gBAAA;EFuMF;EErMA;IACE,aAAA;EFuMF;EErMA;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EFuMF;AACF;AErMA;EACE;IACE,iBAAA;IACA,2BAAA;EFuMF;EErMA;IACE,mBAAA;EFuMF;EErMA;IACE,kBAAA;EFuMF;EErMA;IACE,kDAAA;IACA,iDAAA;EFuMF;EErMA;IACE,iBAAA;EFuMF;EErMA;IACE,wBAAA;IACA,gBAAA;EFuMF;EErMA;IACE,aAAA;EFuMF;EErMA;IACE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IACA,gBAAA;EFuMF;EErMA;IACE,aAAA;EFuMF;EErMA;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EFuMF;AACF;AErMA;EACE,iBAAA;EACA,2BAAA;AFuMF;;AErMA;EACE,mBAAA;AFwMF;;AEtMA;EACE,kBAAA;AFyMF;;AEvMA;EACE,kDAAA;EACA,iDAAA;AF0MF;;AExMA;EACE,iBAAA;AF2MF;;AEzMA;EACE,wBAAA;EACA,gBAAA;AF4MF;;AE1MA;EACE,aAAA;AF6MF;;AE3MA;EACE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;EACA,gBAAA;AF8MF;;AE5MA;EACE,aAAA;AF+MF;;AE7MA;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AFgNF;;AE7MA;;EAEE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,qEAAA;AFgNF;;AE7MA;EACE,qEAAA;AFgNF;;AE7MA;EACE,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,8CAAA;EACA,0DAAA;EACA,gDAAA;EACA,sBAAA;EACA,uFAAA;EACA,+BAAA;EACA,6BAAA;EACA,sDAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,mCAAA;EACA,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;EACA,2CAAA;AFgNF;;AE9MA;EACE,eAAA;EACA,cAAA;AFiNF;;AE/MA;EACE,mBAAA;EACA,sBAAA;AFkNF;;AEhNA;EACE,mBAAA;EACA,0DAAA;EACA,2DAAA;AFmNF;;AEjNA;EACE,sBAAA;EACA,8DAAA;EACA,6DAAA;AFoNF;;AElNA;;EAEE,aAAA;AFqNF;;AElNA;EACE,cAAA;EACA,wDAAA;EACA,2BAAA;AFqNF;;AElNA;EACE,4CAAA;EACA,iCAAA;AFqNF;;AElNA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;AFqNF;;AElNA;EACE,gBAAA;AFqNF;;AElNA;EACE,oCAAA;AFqNF;;AElNA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;AFqNF;;AEnNA;EACE,wFAAA;AFsNF;;AEnNA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;AFsNF;;AEpNA;EACE,wFAAA;AFuNF;;AEpNA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;AFuNF;;AErNA;EACE,mCAAA;EACA,sCAAA;AFwNF;;AErNA;EACE,uDAAA;EACA,sDAAA;AFwNF;;AErNA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;EACA,iDAAA;AFwNF;;AErNA;;;EAGE,WAAA;AFwNF;;AErNA;;EAEE,0DAAA;EACA,2DAAA;AFwNF;;AErNA;;EAEE,8DAAA;EACA,6DAAA;AFwNF;;AErNA;EACE,0CAAA;AFwNF;;AEtNA;EACE;IACE,aAAA;IACA,mBAAA;EFyNF;EEvNA;IACE,SAAA;IACA,gBAAA;EFyNF;EEvNA;IACE,cAAA;IACA,cAAA;EFyNF;EEvNA;IACE,0BAAA;IACA,6BAAA;EFyNF;EEvNA;;IAEE,0BAAA;EFyNF;EEvNA;;IAEE,6BAAA;EFyNF;EEvNA;IACE,yBAAA;IACA,4BAAA;EFyNF;EEvNA;;IAEE,yBAAA;EFyNF;EEvNA;;IAEE,4BAAA;EFyNF;AACF;AEtNA;EACE,0CAAA;EACA,oCAAA;EACA,8KAAA;EACA,mDAAA;EACA,mDAAA;EACA,qDAAA;EACA,4FAAA;EACA,qCAAA;EACA,kCAAA;EACA,8CAAA;EACA,6CAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,2EAAA;EACA,sCAAA;EACA,mCAAA;EACA,4DAAA;EACA,qDAAA;AFwNF;;AErNA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EACA,gBAAA;EACA,qBAAA;EACA,0CAAA;AFwNF;;AEtNA;EACE;IACE,gBAAA;EFyNF;AACF;AEvNA;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;AFyNF;;AEvNA;EACE,qDAAA;EACA,iDAAA;AF0NF;;AExNA;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EACA,mDAAA;AF2NF;;AEzNA;EACE;IACE,gBAAA;EF4NF;AACF;AE1NA;EACE,UAAA;AF4NF;;AE1NA;EACE,UAAA;EACA,UAAA;EACA,oDAAA;AF6NF;;AE1NA;EACE,gBAAA;AF6NF;;AE1NA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;AF6NF;;AE3NA;EACE,yDAAA;EACA,0DAAA;AF8NF;;AE5NA;EACE,+DAAA;EACA,gEAAA;AF+NF;;AE7NA;EACE,aAAA;AFgOF;;AE9NA;EACE,6DAAA;EACA,4DAAA;AFiOF;;AE/NA;EACE,mEAAA;EACA,kEAAA;AFkOF;;AEhOA;EACE,6DAAA;EACA,4DAAA;AFmOF;;AEhOA;EACE,8EAAA;AFmOF;;AEhOA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AFmOF;;AEjOA;EACE,aAAA;AFoOF;;AElOA;EACE,gBAAA;AFqOF;;AEnOA;EACE,gBAAA;AFsOF;;AEpOA;EACE,gBAAA;AFuOF;;AEpOA;EACE,iEAAA;EACA,wEAAA;AFuOF;;AEpOA;EACE,4BAAA;EACA,4BAAA;EACA,mCAAA;EACA,oBAAA;EACA,+BAAA;EACA,wDAAA;EACA,sCAAA;EACA,4DAAA;EACA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;EACA,yCAAA;EACA,gBAAA;EACA,yCAAA;EACA,iDAAA;AFuOF;;AEpOA;EACE,iDAAA;AFuOF;;AErOA;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,0CAAA;AFwOF;;AEtOA;EACE,6CAAA;AFyOF;;AEtOA;EACE,kCAAA;EACA,mCAAA;EACA,+BAAA;EACA,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,uDAAA;EACA,+CAAA;EACA,0DAAA;EACA,uDAAA;EACA,gDAAA;EACA,wEAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,yDAAA;EACA,mDAAA;EACA,6DAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AFyOF;;AEtOA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EACA,yCAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;EACA,qIAAA;AFyOF;;AEvOA;EACE;IACE,gBAAA;EF0OF;AACF;AExOA;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,qDAAA;AF0OF;;AExOA;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UAAA;EACA,iDAAA;AF2OF;;AEzOA;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;AF4OF;;AE1OA;EACE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;AF6OF;;AE1OA;EACE,8CAAA;AF6OF;;AE3OA;EACE,0DAAA;EACA,6DAAA;AF8OF;;AE5OA;EACE,2DAAA;EACA,8DAAA;AF+OF;;AE5OA;EACE,iCAAA;EACA,kCAAA;EACA,kCAAA;EACA,yDAAA;AF+OF;;AE5OA;EACE,iCAAA;EACA,kCAAA;EACA,mCAAA;EACA,yDAAA;AF+OF;;AE5OA;EACE,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,2BAAA;EACA,sBAAA;EACA,iDAAA;EACA,qBAAA;EACA,4DAAA;EACA,oCAAA;EACA,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,4CAAA;AF+OF;;AE7OA;EACE,aAAA;AFgPF;;AE7OA;EACE,kBAAA;EACA,SAAA;AFgPF;;AE7OA;EACE,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,iDAAA;EACA,8BAAA;EACA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;EACA,4CAAA;AFgPF;;AE7OA;EACE,cAAA;AFgPF;;AE7OA;EACE,gBAAA;EACA,iCAAA;AFgPF;;AE7OA;EACE,mBAAA;AFgPF;;AE9OA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;AFiPF;;AE9OA;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;AFiPF;;AE9OA;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;AFiPF;;AE9OA;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;AFiPF;;AE9OA;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;AFiPF;;AE9OA;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;AFiPF;;AE9OA;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;AFiPF;;AE9OA;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;AFiPF;;AE9OA;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;AFiPF;;AE9OA;EACE;IACE,2BAAA;EFiPF;AACF;AE/OA;;EAEE,0BAAA;EACA,gCAAA;EACA,wCAAA;EACA,oDAAA;EACA,oDAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EACA,aAAA;EACA,iCAAA;EACA,gBAAA;EACA,uCAAA;EACA,uCAAA;EACA,+CAAA;AFiPF;;AE9OA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EACA,6CAAA;AFiPF;;AE/OA;EACE;IACE,gBAAA;EFkPF;AACF;AE/OA;EACE,qMAAA;EACA,oEAAA;AFiPF;;AE9OA;EACE,iBAAA;AFiPF;;AE9OA;EACE,WAAA;AFiPF;;AE9OA;EACE,kDAAA;AFiPF;;AE/OA;EACE;IACE,eAAA;EFkPF;AACF;AE/OA;EACE,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,oCAAA;EACA,sCAAA;EACA,uDAAA;EACA,4DAAA;EACA,sDAAA;EACA,yDAAA;EACA,wDAAA;EACA,yDAAA;EACA,8CAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iDAAA;AFiPF;;AE9OA;EACE,qBAAA;EACA,sBAAA;AFiPF;;AE/OA;EACE,oCAAA;EACA,0BAAA;AFkPF;;AE/OA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;AFkPF;;AEhPA;EACE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;AFmPF;;AEjPA;EACE,+CAAA;EACA,uDAAA;AFoPF;;AEjPA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;AFoPF;;AElPA;EACE,+BAAA;EACA,gCAAA;AFqPF;;AEnPA;EACE,mCAAA;EACA,kCAAA;AFsPF;;AEpPA;EACE,0CAAA;EACA,oBAAA;EACA,kDAAA;AFuPF;;AErPA;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;AFwPF;;AEtPA;EACE,mBAAA;AFyPF;;AEvPA;EACE,wDAAA;EACA,mDAAA;AF0PF;;AEvPA;EACE,mBAAA;AF0PF;;AExPA;EACE,6DAAA;EACA,0BAAA;AF2PF;;AEzPA;EACE,2DAAA;EACA,4BAAA;AF4PF;;AE1PA;EACE,aAAA;AF6PF;;AE3PA;EACE,mDAAA;EACA,oBAAA;AF8PF;;AE5PA;EACE,yDAAA;EACA,oDAAA;AF+PF;;AE5PA;EACE;IACE,mBAAA;EF+PF;EE7PA;IACE,6DAAA;IACA,0BAAA;EF+PF;EE7PA;IACE,2DAAA;IACA,4BAAA;EF+PF;EE7PA;IACE,aAAA;EF+PF;EE7PA;IACE,mDAAA;IACA,oBAAA;EF+PF;EE7PA;IACE,yDAAA;IACA,oDAAA;EF+PF;AACF;AE7PA;EACE;IACE,mBAAA;EF+PF;EE7PA;IACE,6DAAA;IACA,0BAAA;EF+PF;EE7PA;IACE,2DAAA;IACA,4BAAA;EF+PF;EE7PA;IACE,aAAA;EF+PF;EE7PA;IACE,mDAAA;IACA,oBAAA;EF+PF;EE7PA;IACE,yDAAA;IACA,oDAAA;EF+PF;AACF;AE7PA;EACE;IACE,mBAAA;EF+PF;EE7PA;IACE,6DAAA;IACA,0BAAA;EF+PF;EE7PA;IACE,2DAAA;IACA,4BAAA;EF+PF;EE7PA;IACE,aAAA;EF+PF;EE7PA;IACE,mDAAA;IACA,oBAAA;EF+PF;EE7PA;IACE,yDAAA;IACA,oDAAA;EF+PF;AACF;AE7PA;EACE;IACE,mBAAA;EF+PF;EE7PA;IACE,6DAAA;IACA,0BAAA;EF+PF;EE7PA;IACE,2DAAA;IACA,4BAAA;EF+PF;EE7PA;IACE,aAAA;EF+PF;EE7PA;IACE,mDAAA;IACA,oBAAA;EF+PF;EE7PA;IACE,yDAAA;IACA,oDAAA;EF+PF;AACF;AE7PA;EACE;IACE,mBAAA;EF+PF;EE7PA;IACE,6DAAA;IACA,0BAAA;EF+PF;EE7PA;IACE,2DAAA;IACA,4BAAA;EF+PF;EE7PA;IACE,aAAA;EF+PF;EE7PA;IACE,mDAAA;IACA,oBAAA;EF+PF;EE7PA;IACE,yDAAA;IACA,oDAAA;EF+PF;AACF;AE7PA;EACE,gBAAA;AF+PF;;AE7PA;EACE,mDAAA;AFgQF;;AE9PA;EACE,sBAAA;AFiQF;;AE9PA;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AFiQF;;AE9PA;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;AFiQF;;AE9PA;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AFiQF;;AE9PA;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;AFiQF;;AE9PA;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AFiQF;;AE9PA;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;AFiQF;;AE9PA;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;AFiQF;;AE9PA;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;AFiQF;;AE9PA;EACE,0BAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,mEAAA;EACA,+BAAA;EACA,qCAAA;EACA,uEAAA;EACA,uBAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,SAAA;EACA,uBAAA;EACA,oCAAA;AFiQF;;AE/PA;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;AFkQF;;AEhQA;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;AFmQF;;AEjQA;EACE,oBAAA;EACA,yBAAA;EAEA,iBAAA;EACA,6CAAA;AFoQF;;AEjQA;EACE,wCAAA;AFoQF;;AEjQA;EACE,wCAAA;AFoQF;;AEjQA;EACE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,kBAAA;EACA,gDAAA;EACA,+CAAA;EACA,2DAAA;EACA,iDAAA;EACA,2CAAA;EACA,kDAAA;EACA,uDAAA;EACA,kEAAA;EACA,gCAAA;EACA,eAAA;EACA,oCAAA;EACA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;EACA,4CAAA;AFoQF;;AElQA;EACE,UAAA;AFqQF;;AEnQA;EACE,aAAA;AFsQF;;AEnQA;EACE,uBAAA;EACA,kBAAA;EACA,+BAAA;EAGA,kBAAA;EACA,eAAA;EACA,oBAAA;AFsQF;;AEpQA;EACE,sCAAA;AFuQF;;AEpQA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;EACA,0FAAA;EACA,2FAAA;AFuQF;;AErQA;EACE,oDAAA;EACA,sCAAA;AFwQF;;AErQA;EACE,kCAAA;EACA,qBAAA;AFwQF;;AErQA;EACE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gCAAA;EACA,2DAAA;EACA,+CAAA;EACA,oDAAA;EACA,8CAAA;EACA,2FAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,sDAAA;EACA,sDAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,sDAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;AFwQF;;AErQA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EACA,oBAAA;AFwQF;;AEtQA;EACE,mCAAA;EACA,8BAAA;AFyQF;;AEvQA;EACE;IACE,gBAAA;EF0QF;AACF;AExQA;EACE,eAAA;AF0QF;;AExQA;EACE,sBAAA;AF2QF;;AExQA;EACE,+CAAA;AF2QF;;AEzQA;EACE,gBAAA;EACA,gBAAA;AF4QF;;AE1QA;EACE,gBAAA;AF6QF;;AE1QA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AF6QF;;AE1QA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,4CAAA;EACA,UAAA;AF6QF;;AE1QA;EACE,0BAAA;EACA,sBAAA;EACA,0BAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCAAA;EACA,YAAA;EACA,aAAA;EACA,uCAAA;AF6QF;;AE3QA;EACE,UAAA;AF8QF;;AE5QA;EACE,mCAAA;AF+QF;;AE5QA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uCAAA;EACA,4FAAA;EACA,2DAAA;EACA,4DAAA;AF+QF;;AE7QA;EACE,kGAAA;EACA,sJAAA;AFgRF;;AE7QA;EACE,gBAAA;EACA,8CAAA;AFgRF;;AE7QA;EACE,kBAAA;EACA,cAAA;EACA,gCAAA;AFgRF;;AE7QA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;EACA,+DAAA;EACA,8DAAA;AFgRF;;AE9QA;EACE,8CAAA;AFiRF;;AE9QA;EACE;IACE,0BAAA;IACA,2CAAA;EFiRF;EE/QA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;EFiRF;EE/QA;IACE,uBAAA;EFiRF;AACF;AE/QA;EACE;;IAEE,uBAAA;EFiRF;AACF;AE/QA;EACE;IACE,wBAAA;EFiRF;AACF;AE/QA;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AFiRF;;AE/QA;EACE,YAAA;EACA,SAAA;EACA,gBAAA;AFkRF;;AEhRA;;EAEE,gBAAA;AFmRF;;AEjRA;EACE,gBAAA;AFoRF;;AEjRA;EACE;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EFoRF;EElRA;IACE,YAAA;IACA,SAAA;IACA,gBAAA;EFoRF;EElRA;;IAEE,gBAAA;EFoRF;EElRA;IACE,gBAAA;EFoRF;AACF;AElRA;EACE;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EFoRF;EElRA;IACE,YAAA;IACA,SAAA;IACA,gBAAA;EFoRF;EElRA;;IAEE,gBAAA;EFoRF;EElRA;IACE,gBAAA;EFoRF;AACF;AElRA;EACE;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EFoRF;EElRA;IACE,YAAA;IACA,SAAA;IACA,gBAAA;EFoRF;EElRA;;IAEE,gBAAA;EFoRF;EElRA;IACE,gBAAA;EFoRF;AACF;AElRA;EACE;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EFoRF;EElRA;IACE,YAAA;IACA,SAAA;IACA,gBAAA;EFoRF;EElRA;;IAEE,gBAAA;EFoRF;EElRA;IACE,gBAAA;EFoRF;AACF;AElRA;EACE;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EFoRF;EElRA;IACE,YAAA;IACA,SAAA;IACA,gBAAA;EFoRF;EElRA;;IAEE,gBAAA;EFoRF;EElRA;IACE,gBAAA;EFoRF;AACF;AElRA;EACE,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,qBAAA;EACA,gCAAA;EACA,qCAAA;EACA,yCAAA;EACA,mDAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EACA,iCAAA;EACA,cAAA;EACA,gCAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,sCAAA;EACA,qBAAA;EACA,UAAA;AFoRF;;AElRA;EACE,kCAAA;AFqRF;;AEnRA;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AFsRF;;AEpRA;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AFuRF;;AEpRA;EACE,iDAAA;AFuRF;;AErRA;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;AFwRF;;AErRA,qBAAA;AACA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;AFwRF;;AEtRA;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;AFyRF;;AEtRA,mBAAA;AACA;EACE,8CAAA;AFyRF;;AEvRA;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;AF0RF;;AEvRA,qBAAA;AACA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;AF0RF;;AExRA;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;AF2RF;;AExRA,mBAAA;AACA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;EACA,8CAAA;AF2RF;;AExRA;EACE,yBAAA;EACA,6BAAA;EACA,gCAAA;EACA,kCAAA;EACA,iDAAA;EACA,6DAAA;EACA,sDAAA;EACA,2FAAA;EACA,6CAAA;EACA,mCAAA;EACA,qCAAA;EACA,mCAAA;EACA,kCAAA;EACA,8CAAA;EACA,iCAAA;EACA,iCAAA;EACA,6CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EACA,iCAAA;EACA,cAAA;EACA,sCAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,sCAAA;EACA,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;EACA,8CAAA;AF2RF;;AEzRA;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AF4RF;;AE1RA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AF6RF;;AE1RA;EACE,oFAAA;AF6RF;;AE3RA;EACE,wFAAA;AF8RF;;AE5RA;EACE,SAAA;EACA,gDAAA;AF+RF;;AE7RA;EACE,sCAAA;EACA,sCAAA;AFgSF;;AE7RA,qBAAA;AACA;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;AFgSF;;AE9RA;EACE,kIAAA;AFiSF;;AE/RA;EACE,OAAA;EACA,kDAAA;AFkSF;;AEhSA;EACE,oCAAA;EACA,wCAAA;AFmSF;;AEhSA,mBAAA;AACA;EACE,iFAAA;AFmSF;;AEjSA;EACE,wFAAA;AFoSF;;AElSA;EACE,MAAA;EACA,mDAAA;AFqSF;;AEnSA;EACE,mCAAA;EACA,yCAAA;AFsSF;;AEpSA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;AFuSF;;AEpSA,qBAAA;AACA;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;AFuSF;;AErSA;EACE,kIAAA;AFwSF;;AEtSA;EACE,QAAA;EACA,iDAAA;AFySF;;AEvSA;EACE,qCAAA;EACA,uCAAA;AF0SF;;AEvSA,mBAAA;AACA;EACE,8EAAA;EACA,gBAAA;EACA,6CAAA;EACA,qCAAA;EACA,6CAAA;EACA,kFAAA;EACA,6DAAA;EACA,8DAAA;AF0SF;;AExSA;EACE,aAAA;AF2SF;;AExSA;EACE,0EAAA;EACA,mCAAA;AF2SF;;AExSA;EACE,kBAAA;AF2SF;;AExSA;EACE,mBAAA;AF2SF;;AExSA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AF2SF;;AEzSA;EACE,cAAA;EACA,WAAA;EACA,WAAA;AF4SF;;AEzSA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EAEA,2BAAA;EACA,sCAAA;AF4SF;;AE1SA;EACE;IACE,gBAAA;EF6SF;AACF;AE1SA;;;EAGE,cAAA;AF4SF;;AEzSA;;EAEE,2BAAA;AF4SF;;AEzSA;;EAEE,4BAAA;AF4SF;;AEzSA;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AF4SF;;AE1SA;;;EAGE,UAAA;EACA,UAAA;AF6SF;;AE3SA;;EAEE,UAAA;EACA,UAAA;EACA,2BAAA;AF8SF;;AE5SA;EACE;;IAEE,gBAAA;EF+SF;AACF;AE5SA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YAAA;EACA,8BAAA;AF8SF;;AE5SA;EACE;;IAEE,gBAAA;EF+SF;AACF;AE7SA;;;EAGE,WAAA;EACA,qBAAA;EACA,UAAA;EACA,YAAA;AF+SF;;AE5SA;EACE,OAAA;AF+SF;;AE5SA;EACE,QAAA;AF+SF;;AE5SA;;EAEE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,wBAAA;EACA,0BAAA;AF+SF;;AE5SA;EACE,0DAAA;AF+SF;;AE5SA;EACE,0DAAA;AF+SF;;AE5SA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AF+SF;;AE7SA;EACE,uBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,4BAAA;EACA,SAAA;EACA,kCAAA;EACA,qCAAA;EACA,YAAA;EACA,6BAAA;AFgTF;;AE9SA;EACE;IACE,gBAAA;EFiTF;AACF;AE/SA;EACE,UAAA;AFiTF;;AE9SA;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;AFiTF;;AE9SA;;EAEE,gCAAA;AFiTF;;AE/SA;EACE,sBAAA;AFkTF;;AEhTA;EACE,WAAA;AFmTF;;AEhTA;;;EAGE,gCAAA;AFmTF;;AEjTA;EACE,sBAAA;AFoTF;;AElTA;EACE,WAAA;AFqTF;;AElTA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EACA,kBAAA;EACA,6FAAA;AFqTF;;AElTA;EACE;IACE,yBAAA;EFqTF;AACF;AEnTA;EACE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EACA,yDAAA;EACA,+BAAA;AFqTF;;AElTA;EACE,wBAAA;EACA,yBAAA;EACA,gCAAA;AFqTF;;AElTA;EACE;IACE,mBAAA;EFqTF;EEnTA;IACE,UAAA;IACA,eAAA;EFqTF;AACF;AEnTA;EACE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EACA,8BAAA;EACA,UAAA;AFqTF;;AElTA;EACE,wBAAA;EACA,yBAAA;AFqTF;;AElTA;EACE;;IAEE,kCAAA;EFqTF;AACF;AEnTA;EACE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,oCAAA;EACA,mDAAA;EACA,+DAAA;EACA,kDAAA;EACA,qDAAA;EACA,qCAAA;AFqTF;;AElTA;EACE;IACE,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IACA,0CAAA;EFqTF;AACF;AEnTA;EACE;IACE,gBAAA;EFqTF;AACF;AEnTA;EACE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EFqTF;EEnTA;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EFqTF;EEnTA;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EFqTF;EEnTA;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EFqTF;EEnTA;IACE,eAAA;EFqTF;EEnTA;IACE,mBAAA;EFqTF;AACF;AEnTA;EACE;IACE,2BAAA;IACA,8BAAA;IACA,wCAAA;EFqTF;EEnTA;IACE,aAAA;EFqTF;EEnTA;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IACA,wCAAA;EFqTF;AACF;AElTA;EACE;IACE,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IACA,0CAAA;EFoTF;AACF;AElTA;EACE;IACE,gBAAA;EFoTF;AACF;AElTA;EACE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EFoTF;EElTA;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EFoTF;EElTA;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EFoTF;EElTA;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EFoTF;EElTA;IACE,eAAA;EFoTF;EElTA;IACE,mBAAA;EFoTF;AACF;AElTA;EACE;IACE,2BAAA;IACA,8BAAA;IACA,wCAAA;EFoTF;EElTA;IACE,aAAA;EFoTF;EElTA;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IACA,wCAAA;EFoTF;AACF;AEjTA;EACE;IACE,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IACA,0CAAA;EFmTF;AACF;AEjTA;EACE;IACE,gBAAA;EFmTF;AACF;AEjTA;EACE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EFmTF;EEjTA;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EFmTF;EEjTA;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EFmTF;EEjTA;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EFmTF;EEjTA;IACE,eAAA;EFmTF;EEjTA;IACE,mBAAA;EFmTF;AACF;AEjTA;EACE;IACE,2BAAA;IACA,8BAAA;IACA,wCAAA;EFmTF;EEjTA;IACE,aAAA;EFmTF;EEjTA;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IACA,wCAAA;EFmTF;AACF;AEhTA;EACE;IACE,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IACA,0CAAA;EFkTF;AACF;AEhTA;EACE;IACE,gBAAA;EFkTF;AACF;AEhTA;EACE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EFkTF;EEhTA;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EFkTF;EEhTA;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EFkTF;EEhTA;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EFkTF;EEhTA;IACE,eAAA;EFkTF;EEhTA;IACE,mBAAA;EFkTF;AACF;AEhTA;EACE;IACE,2BAAA;IACA,8BAAA;IACA,wCAAA;EFkTF;EEhTA;IACE,aAAA;EFkTF;EEhTA;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IACA,wCAAA;EFkTF;AACF;AE/SA;EACE;IACE,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IACA,0CAAA;EFiTF;AACF;AE/SA;EACE;IACE,gBAAA;EFiTF;AACF;AE/SA;EACE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EFiTF;EE/SA;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EFiTF;EE/SA;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EFiTF;EE/SA;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EFiTF;EE/SA;IACE,eAAA;EFiTF;EE/SA;IACE,mBAAA;EFiTF;AACF;AE/SA;EACE;IACE,2BAAA;IACA,8BAAA;IACA,wCAAA;EFiTF;EE/SA;IACE,aAAA;EFiTF;EE/SA;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IACA,wCAAA;EFiTF;AACF;AE9SA;EACE,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EACA,0CAAA;AFgTF;;AE9SA;EACE;IACE,gBAAA;EFiTF;AACF;AE/SA;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;AFiTF;;AE/SA;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;AFkTF;;AEhTA;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;AFmTF;;AEjTA;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;AFoTF;;AElTA;EACE,eAAA;AFqTF;;AEnTA;EACE,mBAAA;AFsTF;;AEnTA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AFsTF;;AEpTA;EACE,UAAA;AFuTF;;AErTA;EACE,YAAA;AFwTF;;AErTA;EACE,aAAA;EACA,mBAAA;EACA,oEAAA;AFwTF;;AEtTA;EACE,4FAAA;EACA,6IAAA;AFyTF;;AEtTA;EACE,gBAAA;EACA,kDAAA;AFyTF;;AEtTA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;AFyTF;;AEtTA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YAAA;AFyTF;;AEvTA;EACE,qBAAA;EACA,WAAA;AF0TF;;AEvTA;EACE,iBAAA;AF0TF;;AEvTA;EACE,iBAAA;AF0TF;;AEvTA;EACE,iBAAA;AF0TF;;AEvTA;EACE,mDAAA;AF0TF;;AEvTA;EACE;IACE,YAAA;EF0TF;AACF;AExTA;EAEE,+EAAA;EAEA,oBAAA;EACA,8CAAA;AF0TF;;AEvTA;EACE;IAEE,uBAAA;EF0TF;AACF;AExTA;EACE,cAAA;EACA,WAAA;EACA,WAAA;AF0TF;;AEvTA;EACE,sBAAA;EACA,iFAAA;AF0TF;;AEvTA;EACE,sBAAA;EACA,mFAAA;AF0TF;;AEvTA;EACE,sBAAA;EACA,iFAAA;AF0TF;;AEvTA;EACE,sBAAA;EACA,8EAAA;AF0TF;;AEvTA;EACE,sBAAA;EACA,iFAAA;AF0TF;;AEvTA;EACE,sBAAA;EACA,gFAAA;AF0TF;;AEvTA;EACE,sBAAA;EACA,+EAAA;AF0TF;;AEvTA;EACE,sBAAA;EACA,8EAAA;AF0TF;;AEvTA;EACE,wEAAA;EAEA,kGAAA;AF0TF;;AExTA;EACE,8DAAA;EAEA,wFAAA;AF2TF;;AExTA;EACE,0EAAA;EAEA,oGAAA;AF2TF;;AEzTA;EACE,8DAAA;EAEA,wFAAA;AF4TF;;AEzTA;EACE,wEAAA;EAEA,kGAAA;AF4TF;;AE1TA;EACE,8DAAA;EAEA,wFAAA;AF6TF;;AE1TA;EACE,qEAAA;EAEA,+FAAA;AF6TF;;AE3TA;EACE,+DAAA;EAEA,yFAAA;AF8TF;;AE3TA;EACE,wEAAA;EAEA,kGAAA;AF8TF;;AE5TA;EACE,+DAAA;EAEA,yFAAA;AF+TF;;AE5TA;EACE,uEAAA;EAEA,iGAAA;AF+TF;;AE7TA;EACE,8DAAA;EAEA,wFAAA;AFgUF;;AE7TA;EACE,sEAAA;EAEA,gGAAA;AFgUF;;AE9TA;EACE,gEAAA;EAEA,0FAAA;AFiUF;;AE9TA;EACE,qEAAA;EAEA,+FAAA;AFiUF;;AE/TA;EACE,6DAAA;EAEA,uFAAA;AFkUF;;AE/TA;EACE,+EAAA;EAEA,yGAAA;AFkUF;;AEhUA;EACE,kFAAA;EAEA,4GAAA;AFmUF;;AEhUA;EACE,UAAA;EACA,kJAAA;AFmUF;;AEhUA;EACE,oBAAA;EACA,aAAA;EACA,mBAAA;EAEA,kFAAA;EACA,6BAAA;EAEA,2BAAA;AFmUF;;AEjUA;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,sCAAA;AFoUF;;AElUA;EACE;IACE,gBAAA;EFqUF;AACF;AElUA;EACE,mEAAA;AFoUF;;AEjUA;EACE,kBAAA;EACA,WAAA;AFoUF;;AElUA;EACE,cAAA;EACA,mCAAA;EACA,WAAA;AFqUF;;AEnUA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AFsUF;;AEnUA;EACE,uBAAA;AFsUF;;AEnUA;EACE,sBAAA;AFsUF;;AEnUA;EACE,yBAAA;AFsUF;;AEnUA;EACE,iCAAA;AFsUF;;AEnUA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,aAAA;AFsUF;;AEnUA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;AFsUF;;AEnUA;EAEE,gBAAA;EACA,MAAA;EACA,aAAA;AFsUF;;AEnUA;EAEE,gBAAA;EACA,SAAA;EACA,aAAA;AFsUF;;AEnUA;EACE;IAEE,gBAAA;IACA,MAAA;IACA,aAAA;EFsUF;EEpUA;IAEE,gBAAA;IACA,SAAA;IACA,aAAA;EFsUF;AACF;AEpUA;EACE;IAEE,gBAAA;IACA,MAAA;IACA,aAAA;EFsUF;EEpUA;IAEE,gBAAA;IACA,SAAA;IACA,aAAA;EFsUF;AACF;AEpUA;EACE;IAEE,gBAAA;IACA,MAAA;IACA,aAAA;EFsUF;EEpUA;IAEE,gBAAA;IACA,SAAA;IACA,aAAA;EFsUF;AACF;AEpUA;EACE;IAEE,gBAAA;IACA,MAAA;IACA,aAAA;EFsUF;EEpUA;IAEE,gBAAA;IACA,SAAA;IACA,aAAA;EFsUF;AACF;AEpUA;EACE;IAEE,gBAAA;IACA,MAAA;IACA,aAAA;EFsUF;EEpUA;IAEE,gBAAA;IACA,SAAA;IACA,aAAA;EFsUF;AACF;AEpUA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AFsUF;;AEnUA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AFsUF;;AEnUA;;EAEE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AFsUF;;AEpUA;;EAEE,6BAAA;AFuUF;;AEpUA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;AFuUF;;AEpUA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AFuUF;;AEpUA;EACE,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;EACA,8BAAA;EACA,aAAA;AFuUF;;AEpUA;EACE,mCAAA;AFuUF;;AEpUA;EACE,8BAAA;AFuUF;;AEpUA;EACE,iCAAA;AFuUF;;AEpUA;EACE,iCAAA;AFuUF;;AEpUA;EACE,sCAAA;AFuUF;;AEpUA;EACE,mCAAA;AFuUF;;AEpUA;EACE,sBAAA;AFuUF;;AEpUA;EACE,uBAAA;AFuUF;;AEpUA;EACE,sBAAA;AFuUF;;AEpUA;EAEE,8BAAA;AFuUF;;AEpUA;EAEE,4BAAA;AFuUF;;AEpUA;EAEE,2BAAA;AFuUF;;AEpUA;EAEE,iCAAA;AFuUF;;AEpUA;EAEE,2BAAA;AFuUF;;AEpUA;EACE,qBAAA;AFuUF;;AEpUA;EACE,wBAAA;AFuUF;;AEpUA;EACE,uBAAA;AFuUF;;AEpUA;EACE,wBAAA;AFuUF;;AEpUA;EACE,qBAAA;AFuUF;;AEpUA;EACE,yBAAA;AFuUF;;AEpUA;EACE,2BAAA;AFuUF;;AEpUA;EACE,4BAAA;AFuUF;;AEpUA;EACE,2BAAA;AFuUF;;AEpUA;EACE,2BAAA;AFuUF;;AEpUA;EACE,6BAAA;AFuUF;;AEpUA;EACE,8BAAA;AFuUF;;AEpUA;EACE,6BAAA;AFuUF;;AEpUA;EACE,2BAAA;AFuUF;;AEpUA;EACE,6BAAA;AFuUF;;AEpUA;EACE,8BAAA;AFuUF;;AEpUA;EACE,6BAAA;AFuUF;;AEpUA;EACE,0BAAA;AFuUF;;AEpUA;EACE,gCAAA;AFuUF;;AEpUA;EACE,yBAAA;AFuUF;;AEpUA;EACE,wBAAA;AFuUF;;AEpUA;EACE,+BAAA;AFuUF;;AEpUA;EACE,yBAAA;AFuUF;;AEpUA;EACE,6BAAA;AFuUF;;AEpUA;EACE,8BAAA;AFuUF;;AEpUA;EACE,wBAAA;AFuUF;;AEpUA;EACE,+BAAA;AFuUF;;AEpUA;EACE,wBAAA;AFuUF;;AEpUA;EACE,2CAAA;AFuUF;;AEpUA;EACE,8CAAA;AFuUF;;AEpUA;EACE,8CAAA;AFuUF;;AEpUA;EACE,2BAAA;AFuUF;;AEpUA;EACE,gFAAA;AFuUF;;AEpUA;EACE,kFAAA;AFuUF;;AEpUA;EACE,gFAAA;AFuUF;;AEpUA;EACE,6EAAA;AFuUF;;AEpUA;EACE,gFAAA;AFuUF;;AEpUA;EACE,+EAAA;AFuUF;;AEpUA;EACE,8EAAA;AFuUF;;AEpUA;EACE,6EAAA;AFuUF;;AEpUA;EACE,2BAAA;AFuUF;;AEpUA;EACE,6BAAA;AFuUF;;AEpUA;EACE,6BAAA;AFuUF;;AEpUA;EACE,0BAAA;AFuUF;;AEpUA;EAEE,2BAAA;AFuUF;;AEpUA;EACE,iBAAA;AFuUF;;AEpUA;EACE,mBAAA;AFuUF;;AEpUA;EACE,oBAAA;AFuUF;;AEpUA;EACE,oBAAA;AFuUF;;AEpUA;EACE,sBAAA;AFuUF;;AEpUA;EACE,uBAAA;AFuUF;;AEpUA;EACE,kBAAA;AFuUF;;AEpUA;EACE,oBAAA;AFuUF;;AEpUA;EACE,qBAAA;AFuUF;;AEpUA;EACE,mBAAA;AFuUF;;AEpUA;EACE,qBAAA;AFuUF;;AEpUA;EACE,sBAAA;AFuUF;;AEpUA;EACE,2CAAA;AFuUF;;AEpUA;EACE,sCAAA;AFuUF;;AEpUA;EACE,sCAAA;AFuUF;;AEpUA;EACE,uFAAA;AFuUF;;AEpUA;EACE,oBAAA;AFuUF;;AEpUA;EACE,2FAAA;AFuUF;;AEpUA;EACE,wBAAA;AFuUF;;AEpUA;EACE,6FAAA;AFuUF;;AEpUA;EACE,0BAAA;AFuUF;;AEpUA;EACE,8FAAA;AFuUF;;AEpUA;EACE,2BAAA;AFuUF;;AEpUA;EACE,4FAAA;AFuUF;;AEpUA;EACE,yBAAA;AFuUF;;AEpUA;EACE,sBAAA;EACA,8EAAA;AFuUF;;AEpUA;EACE,sBAAA;EACA,gFAAA;AFuUF;;AEpUA;EACE,sBAAA;EACA,8EAAA;AFuUF;;AEpUA;EACE,sBAAA;EACA,2EAAA;AFuUF;;AEpUA;EACE,sBAAA;EACA,8EAAA;AFuUF;;AEpUA;EACE,sBAAA;EACA,6EAAA;AFuUF;;AEpUA;EACE,sBAAA;EACA,4EAAA;AFuUF;;AEpUA;EACE,sBAAA;EACA,2EAAA;AFuUF;;AEpUA;EACE,sBAAA;EACA,4EAAA;AFuUF;;AEpUA;EACE,sBAAA;EACA,4EAAA;AFuUF;;AEpUA;EACE,wDAAA;AFuUF;;AEpUA;EACE,0DAAA;AFuUF;;AEpUA;EACE,wDAAA;AFuUF;;AEpUA;EACE,qDAAA;AFuUF;;AEpUA;EACE,wDAAA;AFuUF;;AEpUA;EACE,uDAAA;AFuUF;;AEpUA;EACE,sDAAA;AFuUF;;AEpUA;EACE,qDAAA;AFuUF;;AEpUA;EACE,4BAAA;AFuUF;;AEpUA;EACE,4BAAA;AFuUF;;AEpUA;EACE,4BAAA;AFuUF;;AEpUA;EACE,4BAAA;AFuUF;;AEpUA;EACE,4BAAA;AFuUF;;AEpUA;EACE,wBAAA;AFuUF;;AEpUA;EACE,yBAAA;AFuUF;;AEpUA;EACE,wBAAA;AFuUF;;AEpUA;EACE,yBAAA;AFuUF;;AEpUA;EACE,sBAAA;AFuUF;;AEpUA;EACE,qBAAA;AFuUF;;AEpUA;EACE,qBAAA;AFuUF;;AEpUA;EACE,qBAAA;AFuUF;;AEpUA;EACE,sBAAA;AFuUF;;AEpUA;EACE,sBAAA;AFuUF;;AEpUA;EACE,0BAAA;AFuUF;;AEpUA;EACE,uBAAA;AFuUF;;AEpUA;EACE,2BAAA;AFuUF;;AEpUA;EACE,sBAAA;AFuUF;;AEpUA;EACE,sBAAA;AFuUF;;AEpUA;EACE,sBAAA;AFuUF;;AEpUA;EACE,uBAAA;AFuUF;;AEpUA;EACE,uBAAA;AFuUF;;AEpUA;EACE,2BAAA;AFuUF;;AEpUA;EACE,wBAAA;AFuUF;;AEpUA;EACE,4BAAA;AFuUF;;AEpUA;EACE,yBAAA;AFuUF;;AEpUA;EACE,8BAAA;AFuUF;;AEpUA;EACE,iCAAA;AFuUF;;AEpUA;EACE,sCAAA;AFuUF;;AEpUA;EACE,yCAAA;AFuUF;;AEpUA;EACE,uBAAA;AFuUF;;AEpUA;EACE,uBAAA;AFuUF;;AEpUA;EACE,yBAAA;AFuUF;;AEpUA;EACE,yBAAA;AFuUF;;AEpUA;EACE,0BAAA;AFuUF;;AEpUA;EACE,4BAAA;AFuUF;;AEpUA;EACE,kCAAA;AFuUF;;AEpUA;EACE,sCAAA;AFuUF;;AEpUA;EACE,oCAAA;AFuUF;;AEpUA;EACE,kCAAA;AFuUF;;AEpUA;EACE,yCAAA;AFuUF;;AEpUA;EACE,wCAAA;AFuUF;;AEpUA;EACE,wCAAA;AFuUF;;AEpUA;EACE,kCAAA;AFuUF;;AEpUA;EACE,gCAAA;AFuUF;;AEpUA;EACE,8BAAA;AFuUF;;AEpUA;EACE,gCAAA;AFuUF;;AEpUA;EACE,+BAAA;AFuUF;;AEpUA;EACE,oCAAA;AFuUF;;AEpUA;EACE,kCAAA;AFuUF;;AEpUA;EACE,gCAAA;AFuUF;;AEpUA;EACE,uCAAA;AFuUF;;AEpUA;EACE,sCAAA;AFuUF;;AEpUA;EACE,iCAAA;AFuUF;;AEpUA;EACE,2BAAA;AFuUF;;AEpUA;EACE,iCAAA;AFuUF;;AEpUA;EACE,+BAAA;AFuUF;;AEpUA;EACE,6BAAA;AFuUF;;AEpUA;EACE,+BAAA;AFuUF;;AEpUA;EACE,8BAAA;AFuUF;;AEpUA;EACE,oBAAA;AFuUF;;AEpUA;EACE,mBAAA;AFuUF;;AEpUA;EACE,mBAAA;AFuUF;;AEpUA;EACE,mBAAA;AFuUF;;AEpUA;EACE,mBAAA;AFuUF;;AEpUA;EACE,mBAAA;AFuUF;;AEpUA;EACE,mBAAA;AFuUF;;AEpUA;EACE,mBAAA;AFuUF;;AEpUA;EACE,oBAAA;AFuUF;;AEpUA;EACE,0BAAA;AFuUF;;AEpUA;EACE,yBAAA;AFuUF;;AEpUA;EACE,uBAAA;AFuUF;;AEpUA;EACE,yBAAA;AFuUF;;AEpUA;EACE,uBAAA;AFuUF;;AEpUA;EACE,uBAAA;AFuUF;;AEpUA;EACE,0BAAA;EACA,yBAAA;AFuUF;;AEpUA;EACE,gCAAA;EACA,+BAAA;AFuUF;;AEpUA;EACE,+BAAA;EACA,8BAAA;AFuUF;;AEpUA;EACE,6BAAA;EACA,4BAAA;AFuUF;;AEpUA;EACE,+BAAA;EACA,8BAAA;AFuUF;;AEpUA;EACE,6BAAA;EACA,4BAAA;AFuUF;;AEpUA;EACE,6BAAA;EACA,4BAAA;AFuUF;;AEpUA;EACE,wBAAA;EACA,2BAAA;AFuUF;;AEpUA;EACE,8BAAA;EACA,iCAAA;AFuUF;;AEpUA;EACE,6BAAA;EACA,gCAAA;AFuUF;;AEpUA;EACE,2BAAA;EACA,8BAAA;AFuUF;;AEpUA;EACE,6BAAA;EACA,gCAAA;AFuUF;;AEpUA;EACE,2BAAA;EACA,8BAAA;AFuUF;;AEpUA;EACE,2BAAA;EACA,8BAAA;AFuUF;;AEpUA;EACE,wBAAA;AFuUF;;AEpUA;EACE,8BAAA;AFuUF;;AEpUA;EACE,6BAAA;AFuUF;;AEpUA;EACE,2BAAA;AFuUF;;AEpUA;EACE,6BAAA;AFuUF;;AEpUA;EACE,2BAAA;AFuUF;;AEpUA;EACE,2BAAA;AFuUF;;AEpUA;EACE,0BAAA;AFuUF;;AEpUA;EACE,gCAAA;AFuUF;;AEpUA;EACE,+BAAA;AFuUF;;AEpUA;EACE,6BAAA;AFuUF;;AEpUA;EACE,+BAAA;AFuUF;;AEpUA;EACE,6BAAA;AFuUF;;AEpUA;EACE,6BAAA;AFuUF;;AEpUA;EACE,2BAAA;AFuUF;;AEpUA;EACE,iCAAA;AFuUF;;AEpUA;EACE,gCAAA;AFuUF;;AEpUA;EACE,8BAAA;AFuUF;;AEpUA;EACE,gCAAA;AFuUF;;AEpUA;EACE,8BAAA;AFuUF;;AEpUA;EACE,8BAAA;AFuUF;;AEpUA;EACE,yBAAA;AFuUF;;AEpUA;EACE,+BAAA;AFuUF;;AEpUA;EACE,8BAAA;AFuUF;;AEpUA;EACE,4BAAA;AFuUF;;AEpUA;EACE,8BAAA;AFuUF;;AEpUA;EACE,4BAAA;AFuUF;;AEpUA;EACE,4BAAA;AFuUF;;AEpUA;EACE,qBAAA;AFuUF;;AEpUA;EACE,2BAAA;AFuUF;;AEpUA;EACE,0BAAA;AFuUF;;AEpUA;EACE,wBAAA;AFuUF;;AEpUA;EACE,0BAAA;AFuUF;;AEpUA;EACE,wBAAA;AFuUF;;AEpUA;EACE,2BAAA;EACA,0BAAA;AFuUF;;AEpUA;EACE,iCAAA;EACA,gCAAA;AFuUF;;AEpUA;EACE,gCAAA;EACA,+BAAA;AFuUF;;AEpUA;EACE,8BAAA;EACA,6BAAA;AFuUF;;AEpUA;EACE,gCAAA;EACA,+BAAA;AFuUF;;AEpUA;EACE,8BAAA;EACA,6BAAA;AFuUF;;AEpUA;EACE,yBAAA;EACA,4BAAA;AFuUF;;AEpUA;EACE,+BAAA;EACA,kCAAA;AFuUF;;AEpUA;EACE,8BAAA;EACA,iCAAA;AFuUF;;AEpUA;EACE,4BAAA;EACA,+BAAA;AFuUF;;AEpUA;EACE,8BAAA;EACA,iCAAA;AFuUF;;AEpUA;EACE,4BAAA;EACA,+BAAA;AFuUF;;AEpUA;EACE,yBAAA;AFuUF;;AEpUA;EACE,+BAAA;AFuUF;;AEpUA;EACE,8BAAA;AFuUF;;AEpUA;EACE,4BAAA;AFuUF;;AEpUA;EACE,8BAAA;AFuUF;;AEpUA;EACE,4BAAA;AFuUF;;AEpUA;EACE,2BAAA;AFuUF;;AEpUA;EACE,iCAAA;AFuUF;;AEpUA;EACE,gCAAA;AFuUF;;AEpUA;EACE,8BAAA;AFuUF;;AEpUA;EACE,gCAAA;AFuUF;;AEpUA;EACE,8BAAA;AFuUF;;AEpUA;EACE,4BAAA;AFuUF;;AEpUA;EACE,kCAAA;AFuUF;;AEpUA;EACE,iCAAA;AFuUF;;AEpUA;EACE,+BAAA;AFuUF;;AEpUA;EACE,iCAAA;AFuUF;;AEpUA;EACE,+BAAA;AFuUF;;AEpUA;EACE,0BAAA;AFuUF;;AEpUA;EACE,gCAAA;AFuUF;;AEpUA;EACE,+BAAA;AFuUF;;AEpUA;EACE,6BAAA;AFuUF;;AEpUA;EACE,+BAAA;AFuUF;;AEpUA;EACE,6BAAA;AFuUF;;AEpUA;EACE,iBAAA;AFuUF;;AEpUA;EACE,uBAAA;AFuUF;;AEpUA;EACE,sBAAA;AFuUF;;AEpUA;EACE,oBAAA;AFuUF;;AEpUA;EACE,sBAAA;AFuUF;;AEpUA;EACE,oBAAA;AFuUF;;AEpUA;EACE,qBAAA;AFuUF;;AEpUA;EACE,2BAAA;AFuUF;;AEpUA;EACE,0BAAA;AFuUF;;AEpUA;EACE,wBAAA;AFuUF;;AEpUA;EACE,0BAAA;AFuUF;;AEpUA;EACE,wBAAA;AFuUF;;AEpUA;EAEE,wBAAA;AFuUF;;AEpUA;EAEE,8BAAA;AFuUF;;AEpUA;EAEE,6BAAA;AFuUF;;AEpUA;EAEE,2BAAA;AFuUF;;AEpUA;EAEE,6BAAA;AFuUF;;AEpUA;EAEE,2BAAA;AFuUF;;AEpUA;EACE,gDAAA;AFuUF;;AEpUA;EACE,4CAAA;AFuUF;;AEpUA;EACE,4CAAA;AFuUF;;AEpUA;EACE,0CAAA;AFuUF;;AEpUA;EACE,4CAAA;AFuUF;;AEpUA;EACE,6BAAA;AFuUF;;AEpUA;EACE,0BAAA;AFuUF;;AEpUA;EACE,6BAAA;AFuUF;;AEpUA;EACE,6BAAA;AFuUF;;AEpUA;EACE,+BAAA;AFuUF;;AEpUA;EACE,2BAAA;AFuUF;;AEpUA;EACE,2BAAA;AFuUF;;AEpUA;EACE,2BAAA;AFuUF;;AEpUA;EACE,2BAAA;AFuUF;;AEpUA;EACE,2BAAA;AFuUF;;AEpUA;EACE,8BAAA;AFuUF;;AEpUA;EACE,yBAAA;AFuUF;;AEpUA;EACE,4BAAA;AFuUF;;AEpUA;EACE,2BAAA;AFuUF;;AEpUA;EACE,yBAAA;AFuUF;;AEpUA;EACE,2BAAA;AFuUF;;AEpUA;EACE,4BAAA;AFuUF;;AEpUA;EACE,6BAAA;AFuUF;;AEpUA;EACE,gCAAA;AFuUF;;AEpUA;EACE,qCAAA;AFuUF;;AEpUA;EACE,wCAAA;AFuUF;;AEpUA;EACE,oCAAA;AFuUF;;AEpUA;EACE,oCAAA;AFuUF;;AEpUA;EACE,qCAAA;AFuUF;;AEpUA;EACE,8BAAA;AFuUF;;AEpUA;EACE,8BAAA;AFuUF;;AEpUA,qBAAA;AACA;EACE,gCAAA;EACA,iCAAA;AFuUF;;AEpUA,mBAAA;AACA;EACE,oBAAA;EACA,qEAAA;AFuUF;;AEpUA;EACE,oBAAA;EACA,uEAAA;AFuUF;;AEpUA;EACE,oBAAA;EACA,qEAAA;AFuUF;;AEpUA;EACE,oBAAA;EACA,kEAAA;AFuUF;;AEpUA;EACE,oBAAA;EACA,qEAAA;AFuUF;;AEpUA;EACE,oBAAA;EACA,oEAAA;AFuUF;;AEpUA;EACE,oBAAA;EACA,mEAAA;AFuUF;;AEpUA;EACE,oBAAA;EACA,kEAAA;AFuUF;;AEpUA;EACE,oBAAA;EACA,mEAAA;AFuUF;;AEpUA;EACE,oBAAA;EACA,mEAAA;AFuUF;;AEpUA;EACE,oBAAA;EACA,wEAAA;AFuUF;;AEpUA;EACE,oBAAA;EACA,2CAAA;AFuUF;;AEpUA;EACE,oBAAA;EACA,oCAAA;AFuUF;;AEpUA;EACE,oBAAA;EACA,0CAAA;AFuUF;;AEpUA;EACE,oBAAA;EACA,2CAAA;AFuUF;;AEpUA;EACE,oBAAA;EACA,0CAAA;AFuUF;;AEpUA;EACE,oBAAA;EACA,0CAAA;AFuUF;;AEpUA;EACE,oBAAA;EACA,yBAAA;AFuUF;;AEpUA;EACE,uBAAA;AFuUF;;AEpUA;EACE,sBAAA;AFuUF;;AEpUA;EACE,uBAAA;AFuUF;;AEpUA;EACE,oBAAA;AFuUF;;AEpUA;EACE,iDAAA;AFuUF;;AEpUA;EACE,mDAAA;AFuUF;;AEpUA;EACE,iDAAA;AFuUF;;AEpUA;EACE,8CAAA;AFuUF;;AEpUA;EACE,iDAAA;AFuUF;;AEpUA;EACE,gDAAA;AFuUF;;AEpUA;EACE,+CAAA;AFuUF;;AEpUA;EACE,8CAAA;AFuUF;;AEpUA;EACE,sBAAA;AFuUF;;AEpUA;EACE,sBAAA;AFuUF;;AEpUA;EACE,uBAAA;AFuUF;;AEpUA;EACE,uBAAA;AFuUF;;AEpUA;EACE,sBAAA;AFuUF;;AEpUA;EACE,sBAAA;AFuUF;;AEpUA;EACE,uBAAA;AFuUF;;AEpUA;EACE,uBAAA;AFuUF;;AEpUA;EACE,oBAAA;AFuUF;;AEpUA;EACE,oBAAA;AFuUF;;AEpUA;EACE,yCAAA;AFuUF;;AEpUA;EACE,yCAAA;AFuUF;;AEpUA;EACE,wCAAA;AFuUF;;AEpUA;EACE,wCAAA;AFuUF;;AEpUA;EACE,yCAAA;AFuUF;;AEpUA;EACE,yCAAA;AFuUF;;AEpUA;EACE,8BAAA;EAEA,+FAAA;AFuUF;;AEpUA;EACE,8BAAA;EAEA,iGAAA;AFuUF;;AEpUA;EACE,8BAAA;EAEA,+FAAA;AFuUF;;AEpUA;EACE,8BAAA;EAEA,4FAAA;AFuUF;;AEpUA;EACE,8BAAA;EAEA,+FAAA;AFuUF;;AEpUA;EACE,8BAAA;EAEA,8FAAA;AFuUF;;AEpUA;EACE,8BAAA;EAEA,6FAAA;AFuUF;;AEpUA;EACE,8BAAA;EAEA,4FAAA;AFuUF;;AEpUA;EACE,8BAAA;EAEA,qGAAA;AFuUF;;AEpUA;EACE,8BAAA;AFuUF;;AEpUA;EACE,8BAAA;AFuUF;;AEpUA;EACE,gCAAA;AFuUF;;AEpUA;EACE,gCAAA;AFuUF;;AEpUA;EACE,iCAAA;AFuUF;;AEpUA;EACE,iCAAA;AFuUF;;AEpUA;EACE,gCAAA;AFuUF;;AEpUA;EACE,gCAAA;AFuUF;;AEpUA;EACE,iCAAA;AFuUF;;AEpUA;EACE,iCAAA;AFuUF;;AEpUA;EACE,8BAAA;AFuUF;;AEpUA;EACE,8BAAA;AFuUF;;AEpUA;EACE,kBAAA;EACA,8EAAA;AFuUF;;AEpUA;EACE,kBAAA;EACA,gFAAA;AFuUF;;AEpUA;EACE,kBAAA;EACA,8EAAA;AFuUF;;AEpUA;EACE,kBAAA;EACA,2EAAA;AFuUF;;AEpUA;EACE,kBAAA;EACA,8EAAA;AFuUF;;AEpUA;EACE,kBAAA;EACA,6EAAA;AFuUF;;AEpUA;EACE,kBAAA;EACA,4EAAA;AFuUF;;AEpUA;EACE,kBAAA;EACA,2EAAA;AFuUF;;AEpUA;EACE,kBAAA;EACA,4EAAA;AFuUF;;AEpUA;EACE,kBAAA;EACA,4EAAA;AFuUF;;AEpUA;EACE,kBAAA;EACA,8EAAA;AFuUF;;AEpUA;EACE,kBAAA;EACA,wCAAA;AFuUF;;AEpUA;EACE,kBAAA;EACA,mFAAA;AFuUF;;AEpUA;EACE,kBAAA;EACA,kFAAA;AFuUF;;AEpUA;EACE,oBAAA;AFuUF;;AEpUA;EACE,qBAAA;AFuUF;;AEpUA;EACE,oBAAA;AFuUF;;AEpUA;EACE,qBAAA;AFuUF;;AEpUA;EACE,kBAAA;AFuUF;;AEpUA;EACE,wDAAA;AFuUF;;AEpUA;EACE,0DAAA;AFuUF;;AEpUA;EACE,wDAAA;AFuUF;;AEpUA;EACE,qDAAA;AFuUF;;AEpUA;EACE,wDAAA;AFuUF;;AEpUA;EACE,uDAAA;AFuUF;;AEpUA;EACE,sDAAA;AFuUF;;AEpUA;EACE,qDAAA;AFuUF;;AEpUA;EACE,+CAAA;AFuUF;;AEpUA;EACE,mCAAA;EAEA,2BAAA;AFuUF;;AEpUA;EACE,oCAAA;EAEA,4BAAA;AFuUF;;AEpUA;EACE,oCAAA;EAEA,4BAAA;AFuUF;;AEpUA;EACE,+BAAA;AFuUF;;AEpUA;EACE,+BAAA;AFuUF;;AEpUA;EACE,iDAAA;AFuUF;;AEpUA;EACE,2BAAA;AFuUF;;AEpUA;EACE,oDAAA;AFuUF;;AEpUA;EACE,iDAAA;AFuUF;;AEpUA;EACE,oDAAA;AFuUF;;AEpUA;EACE,oDAAA;AFuUF;;AEpUA;EACE,qDAAA;AFuUF;;AEpUA;EACE,6BAAA;AFuUF;;AEpUA;EACE,sDAAA;AFuUF;;AEpUA;EACE,0DAAA;EACA,2DAAA;AFuUF;;AEpUA;EACE,oCAAA;EACA,qCAAA;AFuUF;;AEpUA;EACE,6DAAA;EACA,8DAAA;AFuUF;;AEpUA;EACE,0DAAA;EACA,2DAAA;AFuUF;;AEpUA;EACE,6DAAA;EACA,8DAAA;AFuUF;;AEpUA;EACE,6DAAA;EACA,8DAAA;AFuUF;;AEpUA;EACE,8DAAA;EACA,+DAAA;AFuUF;;AEpUA;EACE,sCAAA;EACA,uCAAA;AFuUF;;AEpUA;EACE,+DAAA;EACA,gEAAA;AFuUF;;AEpUA;EACE,2DAAA;EACA,8DAAA;AFuUF;;AEpUA;EACE,qCAAA;EACA,wCAAA;AFuUF;;AEpUA;EACE,8DAAA;EACA,iEAAA;AFuUF;;AEpUA;EACE,2DAAA;EACA,8DAAA;AFuUF;;AEpUA;EACE,8DAAA;EACA,iEAAA;AFuUF;;AEpUA;EACE,8DAAA;EACA,iEAAA;AFuUF;;AEpUA;EACE,+DAAA;EACA,kEAAA;AFuUF;;AEpUA;EACE,uCAAA;EACA,0CAAA;AFuUF;;AEpUA;EACE,gEAAA;EACA,mEAAA;AFuUF;;AEpUA;EACE,8DAAA;EACA,6DAAA;AFuUF;;AEpUA;EACE,wCAAA;EACA,uCAAA;AFuUF;;AEpUA;EACE,iEAAA;EACA,gEAAA;AFuUF;;AEpUA;EACE,8DAAA;EACA,6DAAA;AFuUF;;AEpUA;EACE,iEAAA;EACA,gEAAA;AFuUF;;AEpUA;EACE,iEAAA;EACA,gEAAA;AFuUF;;AEpUA;EACE,kEAAA;EACA,iEAAA;AFuUF;;AEpUA;EACE,0CAAA;EACA,yCAAA;AFuUF;;AEpUA;EACE,mEAAA;EACA,kEAAA;AFuUF;;AEpUA;EACE,6DAAA;EACA,0DAAA;AFuUF;;AEpUA;EACE,uCAAA;EACA,oCAAA;AFuUF;;AEpUA;EACE,gEAAA;EACA,6DAAA;AFuUF;;AEpUA;EACE,6DAAA;EACA,0DAAA;AFuUF;;AEpUA;EACE,gEAAA;EACA,6DAAA;AFuUF;;AEpUA;EACE,gEAAA;EACA,6DAAA;AFuUF;;AEpUA;EACE,iEAAA;EACA,8DAAA;AFuUF;;AEpUA;EACE,yCAAA;EACA,sCAAA;AFuUF;;AEpUA;EACE,kEAAA;EACA,+DAAA;AFuUF;;AEpUA;EACE,8BAAA;AFuUF;;AEpUA;EACE,6BAAA;AFuUF;;AEpUA;EACE,sBAAA;AFuUF;;AEpUA;EACE,qBAAA;AFuUF;;AEpUA;EACE,qBAAA;AFuUF;;AEpUA;EACE,qBAAA;AFuUF;;AEpUA;EACE,qBAAA;AFuUF;;AEpUA;EACE;IACE,sBAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,sBAAA;EFuUF;EErUA;IAEE,8BAAA;EFuUF;EErUA;IAEE,4BAAA;EFuUF;EErUA;IAEE,2BAAA;EFuUF;EErUA;IAEE,iCAAA;EFuUF;EErUA;IAEE,2BAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,sCAAA;EFuUF;EErUA;IACE,yCAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,kCAAA;EFuUF;EErUA;IACE,sCAAA;EFuUF;EErUA;IACE,oCAAA;EFuUF;EErUA;IACE,kCAAA;EFuUF;EErUA;IACE,yCAAA;EFuUF;EErUA;IACE,wCAAA;EFuUF;EErUA;IACE,wCAAA;EFuUF;EErUA;IACE,kCAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,oCAAA;EFuUF;EErUA;IACE,kCAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,uCAAA;EFuUF;EErUA;IACE,sCAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,oBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,oBAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,0BAAA;IACA,yBAAA;EFuUF;EErUA;IACE,gCAAA;IACA,+BAAA;EFuUF;EErUA;IACE,+BAAA;IACA,8BAAA;EFuUF;EErUA;IACE,6BAAA;IACA,4BAAA;EFuUF;EErUA;IACE,+BAAA;IACA,8BAAA;EFuUF;EErUA;IACE,6BAAA;IACA,4BAAA;EFuUF;EErUA;IACE,6BAAA;IACA,4BAAA;EFuUF;EErUA;IACE,wBAAA;IACA,2BAAA;EFuUF;EErUA;IACE,8BAAA;IACA,iCAAA;EFuUF;EErUA;IACE,6BAAA;IACA,gCAAA;EFuUF;EErUA;IACE,2BAAA;IACA,8BAAA;EFuUF;EErUA;IACE,6BAAA;IACA,gCAAA;EFuUF;EErUA;IACE,2BAAA;IACA,8BAAA;EFuUF;EErUA;IACE,2BAAA;IACA,8BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,qBAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,2BAAA;IACA,0BAAA;EFuUF;EErUA;IACE,iCAAA;IACA,gCAAA;EFuUF;EErUA;IACE,gCAAA;IACA,+BAAA;EFuUF;EErUA;IACE,8BAAA;IACA,6BAAA;EFuUF;EErUA;IACE,gCAAA;IACA,+BAAA;EFuUF;EErUA;IACE,8BAAA;IACA,6BAAA;EFuUF;EErUA;IACE,yBAAA;IACA,4BAAA;EFuUF;EErUA;IACE,+BAAA;IACA,kCAAA;EFuUF;EErUA;IACE,8BAAA;IACA,iCAAA;EFuUF;EErUA;IACE,4BAAA;IACA,+BAAA;EFuUF;EErUA;IACE,8BAAA;IACA,iCAAA;EFuUF;EErUA;IACE,4BAAA;IACA,+BAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,kCAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,iBAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,sBAAA;EFuUF;EErUA;IACE,oBAAA;EFuUF;EErUA;IACE,sBAAA;EFuUF;EErUA;IACE,oBAAA;EFuUF;EErUA;IACE,qBAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IAEE,wBAAA;EFuUF;EErUA;IAEE,8BAAA;EFuUF;EErUA;IAEE,6BAAA;EFuUF;EErUA;IAEE,2BAAA;EFuUF;EErUA;IAEE,6BAAA;EFuUF;EErUA;IAEE,2BAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;AACF;AErUA;EACE;IACE,sBAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,sBAAA;EFuUF;EErUA;IAEE,8BAAA;EFuUF;EErUA;IAEE,4BAAA;EFuUF;EErUA;IAEE,2BAAA;EFuUF;EErUA;IAEE,iCAAA;EFuUF;EErUA;IAEE,2BAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,sCAAA;EFuUF;EErUA;IACE,yCAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,kCAAA;EFuUF;EErUA;IACE,sCAAA;EFuUF;EErUA;IACE,oCAAA;EFuUF;EErUA;IACE,kCAAA;EFuUF;EErUA;IACE,yCAAA;EFuUF;EErUA;IACE,wCAAA;EFuUF;EErUA;IACE,wCAAA;EFuUF;EErUA;IACE,kCAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,oCAAA;EFuUF;EErUA;IACE,kCAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,uCAAA;EFuUF;EErUA;IACE,sCAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,oBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,oBAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,0BAAA;IACA,yBAAA;EFuUF;EErUA;IACE,gCAAA;IACA,+BAAA;EFuUF;EErUA;IACE,+BAAA;IACA,8BAAA;EFuUF;EErUA;IACE,6BAAA;IACA,4BAAA;EFuUF;EErUA;IACE,+BAAA;IACA,8BAAA;EFuUF;EErUA;IACE,6BAAA;IACA,4BAAA;EFuUF;EErUA;IACE,6BAAA;IACA,4BAAA;EFuUF;EErUA;IACE,wBAAA;IACA,2BAAA;EFuUF;EErUA;IACE,8BAAA;IACA,iCAAA;EFuUF;EErUA;IACE,6BAAA;IACA,gCAAA;EFuUF;EErUA;IACE,2BAAA;IACA,8BAAA;EFuUF;EErUA;IACE,6BAAA;IACA,gCAAA;EFuUF;EErUA;IACE,2BAAA;IACA,8BAAA;EFuUF;EErUA;IACE,2BAAA;IACA,8BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,qBAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,2BAAA;IACA,0BAAA;EFuUF;EErUA;IACE,iCAAA;IACA,gCAAA;EFuUF;EErUA;IACE,gCAAA;IACA,+BAAA;EFuUF;EErUA;IACE,8BAAA;IACA,6BAAA;EFuUF;EErUA;IACE,gCAAA;IACA,+BAAA;EFuUF;EErUA;IACE,8BAAA;IACA,6BAAA;EFuUF;EErUA;IACE,yBAAA;IACA,4BAAA;EFuUF;EErUA;IACE,+BAAA;IACA,kCAAA;EFuUF;EErUA;IACE,8BAAA;IACA,iCAAA;EFuUF;EErUA;IACE,4BAAA;IACA,+BAAA;EFuUF;EErUA;IACE,8BAAA;IACA,iCAAA;EFuUF;EErUA;IACE,4BAAA;IACA,+BAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,kCAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,iBAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,sBAAA;EFuUF;EErUA;IACE,oBAAA;EFuUF;EErUA;IACE,sBAAA;EFuUF;EErUA;IACE,oBAAA;EFuUF;EErUA;IACE,qBAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IAEE,wBAAA;EFuUF;EErUA;IAEE,8BAAA;EFuUF;EErUA;IAEE,6BAAA;EFuUF;EErUA;IAEE,2BAAA;EFuUF;EErUA;IAEE,6BAAA;EFuUF;EErUA;IAEE,2BAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;AACF;AErUA;EACE;IACE,sBAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,sBAAA;EFuUF;EErUA;IAEE,8BAAA;EFuUF;EErUA;IAEE,4BAAA;EFuUF;EErUA;IAEE,2BAAA;EFuUF;EErUA;IAEE,iCAAA;EFuUF;EErUA;IAEE,2BAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,sCAAA;EFuUF;EErUA;IACE,yCAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,kCAAA;EFuUF;EErUA;IACE,sCAAA;EFuUF;EErUA;IACE,oCAAA;EFuUF;EErUA;IACE,kCAAA;EFuUF;EErUA;IACE,yCAAA;EFuUF;EErUA;IACE,wCAAA;EFuUF;EErUA;IACE,wCAAA;EFuUF;EErUA;IACE,kCAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,oCAAA;EFuUF;EErUA;IACE,kCAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,uCAAA;EFuUF;EErUA;IACE,sCAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,oBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,oBAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,0BAAA;IACA,yBAAA;EFuUF;EErUA;IACE,gCAAA;IACA,+BAAA;EFuUF;EErUA;IACE,+BAAA;IACA,8BAAA;EFuUF;EErUA;IACE,6BAAA;IACA,4BAAA;EFuUF;EErUA;IACE,+BAAA;IACA,8BAAA;EFuUF;EErUA;IACE,6BAAA;IACA,4BAAA;EFuUF;EErUA;IACE,6BAAA;IACA,4BAAA;EFuUF;EErUA;IACE,wBAAA;IACA,2BAAA;EFuUF;EErUA;IACE,8BAAA;IACA,iCAAA;EFuUF;EErUA;IACE,6BAAA;IACA,gCAAA;EFuUF;EErUA;IACE,2BAAA;IACA,8BAAA;EFuUF;EErUA;IACE,6BAAA;IACA,gCAAA;EFuUF;EErUA;IACE,2BAAA;IACA,8BAAA;EFuUF;EErUA;IACE,2BAAA;IACA,8BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,qBAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,2BAAA;IACA,0BAAA;EFuUF;EErUA;IACE,iCAAA;IACA,gCAAA;EFuUF;EErUA;IACE,gCAAA;IACA,+BAAA;EFuUF;EErUA;IACE,8BAAA;IACA,6BAAA;EFuUF;EErUA;IACE,gCAAA;IACA,+BAAA;EFuUF;EErUA;IACE,8BAAA;IACA,6BAAA;EFuUF;EErUA;IACE,yBAAA;IACA,4BAAA;EFuUF;EErUA;IACE,+BAAA;IACA,kCAAA;EFuUF;EErUA;IACE,8BAAA;IACA,iCAAA;EFuUF;EErUA;IACE,4BAAA;IACA,+BAAA;EFuUF;EErUA;IACE,8BAAA;IACA,iCAAA;EFuUF;EErUA;IACE,4BAAA;IACA,+BAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,kCAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,iBAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,sBAAA;EFuUF;EErUA;IACE,oBAAA;EFuUF;EErUA;IACE,sBAAA;EFuUF;EErUA;IACE,oBAAA;EFuUF;EErUA;IACE,qBAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IAEE,wBAAA;EFuUF;EErUA;IAEE,8BAAA;EFuUF;EErUA;IAEE,6BAAA;EFuUF;EErUA;IAEE,2BAAA;EFuUF;EErUA;IAEE,6BAAA;EFuUF;EErUA;IAEE,2BAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;AACF;AErUA;EACE;IACE,sBAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,sBAAA;EFuUF;EErUA;IAEE,8BAAA;EFuUF;EErUA;IAEE,4BAAA;EFuUF;EErUA;IAEE,2BAAA;EFuUF;EErUA;IAEE,iCAAA;EFuUF;EErUA;IAEE,2BAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,sCAAA;EFuUF;EErUA;IACE,yCAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,kCAAA;EFuUF;EErUA;IACE,sCAAA;EFuUF;EErUA;IACE,oCAAA;EFuUF;EErUA;IACE,kCAAA;EFuUF;EErUA;IACE,yCAAA;EFuUF;EErUA;IACE,wCAAA;EFuUF;EErUA;IACE,wCAAA;EFuUF;EErUA;IACE,kCAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,oCAAA;EFuUF;EErUA;IACE,kCAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,uCAAA;EFuUF;EErUA;IACE,sCAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,oBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,oBAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,0BAAA;IACA,yBAAA;EFuUF;EErUA;IACE,gCAAA;IACA,+BAAA;EFuUF;EErUA;IACE,+BAAA;IACA,8BAAA;EFuUF;EErUA;IACE,6BAAA;IACA,4BAAA;EFuUF;EErUA;IACE,+BAAA;IACA,8BAAA;EFuUF;EErUA;IACE,6BAAA;IACA,4BAAA;EFuUF;EErUA;IACE,6BAAA;IACA,4BAAA;EFuUF;EErUA;IACE,wBAAA;IACA,2BAAA;EFuUF;EErUA;IACE,8BAAA;IACA,iCAAA;EFuUF;EErUA;IACE,6BAAA;IACA,gCAAA;EFuUF;EErUA;IACE,2BAAA;IACA,8BAAA;EFuUF;EErUA;IACE,6BAAA;IACA,gCAAA;EFuUF;EErUA;IACE,2BAAA;IACA,8BAAA;EFuUF;EErUA;IACE,2BAAA;IACA,8BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,qBAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,2BAAA;IACA,0BAAA;EFuUF;EErUA;IACE,iCAAA;IACA,gCAAA;EFuUF;EErUA;IACE,gCAAA;IACA,+BAAA;EFuUF;EErUA;IACE,8BAAA;IACA,6BAAA;EFuUF;EErUA;IACE,gCAAA;IACA,+BAAA;EFuUF;EErUA;IACE,8BAAA;IACA,6BAAA;EFuUF;EErUA;IACE,yBAAA;IACA,4BAAA;EFuUF;EErUA;IACE,+BAAA;IACA,kCAAA;EFuUF;EErUA;IACE,8BAAA;IACA,iCAAA;EFuUF;EErUA;IACE,4BAAA;IACA,+BAAA;EFuUF;EErUA;IACE,8BAAA;IACA,iCAAA;EFuUF;EErUA;IACE,4BAAA;IACA,+BAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,kCAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,iBAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,sBAAA;EFuUF;EErUA;IACE,oBAAA;EFuUF;EErUA;IACE,sBAAA;EFuUF;EErUA;IACE,oBAAA;EFuUF;EErUA;IACE,qBAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IAEE,wBAAA;EFuUF;EErUA;IAEE,8BAAA;EFuUF;EErUA;IAEE,6BAAA;EFuUF;EErUA;IAEE,2BAAA;EFuUF;EErUA;IAEE,6BAAA;EFuUF;EErUA;IAEE,2BAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;AACF;AErUA;EACE;IACE,sBAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,sBAAA;EFuUF;EErUA;IAEE,8BAAA;EFuUF;EErUA;IAEE,4BAAA;EFuUF;EErUA;IAEE,2BAAA;EFuUF;EErUA;IAEE,iCAAA;EFuUF;EErUA;IAEE,2BAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,sCAAA;EFuUF;EErUA;IACE,yCAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,kCAAA;EFuUF;EErUA;IACE,sCAAA;EFuUF;EErUA;IACE,oCAAA;EFuUF;EErUA;IACE,kCAAA;EFuUF;EErUA;IACE,yCAAA;EFuUF;EErUA;IACE,wCAAA;EFuUF;EErUA;IACE,wCAAA;EFuUF;EErUA;IACE,kCAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,oCAAA;EFuUF;EErUA;IACE,kCAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,uCAAA;EFuUF;EErUA;IACE,sCAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,oBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,mBAAA;EFuUF;EErUA;IACE,oBAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,0BAAA;IACA,yBAAA;EFuUF;EErUA;IACE,gCAAA;IACA,+BAAA;EFuUF;EErUA;IACE,+BAAA;IACA,8BAAA;EFuUF;EErUA;IACE,6BAAA;IACA,4BAAA;EFuUF;EErUA;IACE,+BAAA;IACA,8BAAA;EFuUF;EErUA;IACE,6BAAA;IACA,4BAAA;EFuUF;EErUA;IACE,6BAAA;IACA,4BAAA;EFuUF;EErUA;IACE,wBAAA;IACA,2BAAA;EFuUF;EErUA;IACE,8BAAA;IACA,iCAAA;EFuUF;EErUA;IACE,6BAAA;IACA,gCAAA;EFuUF;EErUA;IACE,2BAAA;IACA,8BAAA;EFuUF;EErUA;IACE,6BAAA;IACA,gCAAA;EFuUF;EErUA;IACE,2BAAA;IACA,8BAAA;EFuUF;EErUA;IACE,2BAAA;IACA,8BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,qBAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,2BAAA;IACA,0BAAA;EFuUF;EErUA;IACE,iCAAA;IACA,gCAAA;EFuUF;EErUA;IACE,gCAAA;IACA,+BAAA;EFuUF;EErUA;IACE,8BAAA;IACA,6BAAA;EFuUF;EErUA;IACE,gCAAA;IACA,+BAAA;EFuUF;EErUA;IACE,8BAAA;IACA,6BAAA;EFuUF;EErUA;IACE,yBAAA;IACA,4BAAA;EFuUF;EErUA;IACE,+BAAA;IACA,kCAAA;EFuUF;EErUA;IACE,8BAAA;IACA,iCAAA;EFuUF;EErUA;IACE,4BAAA;IACA,+BAAA;EFuUF;EErUA;IACE,8BAAA;IACA,iCAAA;EFuUF;EErUA;IACE,4BAAA;IACA,+BAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,kCAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,iCAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,iBAAA;EFuUF;EErUA;IACE,uBAAA;EFuUF;EErUA;IACE,sBAAA;EFuUF;EErUA;IACE,oBAAA;EFuUF;EErUA;IACE,sBAAA;EFuUF;EErUA;IACE,oBAAA;EFuUF;EErUA;IACE,qBAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IAEE,wBAAA;EFuUF;EErUA;IAEE,8BAAA;EFuUF;EErUA;IAEE,6BAAA;EFuUF;EErUA;IAEE,2BAAA;EFuUF;EErUA;IAEE,6BAAA;EFuUF;EErUA;IAEE,2BAAA;EFuUF;EErUA;IACE,2BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;AACF;AErUA;EACE;IACE,4BAAA;EFuUF;EErUA;IACE,0BAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,4BAAA;EFuUF;AACF;AErUA;EACE;IACE,0BAAA;EFuUF;EErUA;IACE,gCAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,yBAAA;EFuUF;EErUA;IACE,6BAAA;EFuUF;EErUA;IACE,8BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;EErUA;IACE,+BAAA;EFuUF;EErUA;IACE,wBAAA;EFuUF;AACF;;AGzlYA;;;;;;;;;;;;;;;;;;;;;;;;;CAAA;AAwHA;EACE,qBAAA;AH8/XF;;AG3/XA;EACE,+BAAA;EACA,kCAAA;AH8/XF;;AI/nYA;;8BAAA;AAGA;EACE,oCDmFkB;EClFlB,eDmFgB;EClFhB,WDoFiB;ECnFjB,gBAAA;EACA,mBDiFiB;EChFjB,kBAAA;AJkoYF;;AI9nYE;EACE,aAAA;AJioYJ;;AI7nYA;EAKE,qBAAA;AJ4nYF;AIhoYE;EACE,aAAA;AJkoYJ;;AI5nYA;;;;;;EAME,WD2DoB;EC1DpB,gBAAA;AJ+nYF;;AI5nYA;EACE,eAAA;AJ+nYF;;AI5nYA;EACE,eAAA;AJ+nYF;;AI5nYA;EACE,eAAA;AJ+nYF;;AI5nYA;EACE,eAAA;AJ+nYF;;AI5nYA;EACE,eAAA;AJ+nYF;;AI5nYA;EACE,eAAA;AJ+nYF;;AI5nYA;EACE,eAAA;AJ+nYF;;AI5nYA;EACE,gBAAA;AJ+nYF;;AI5nYA;EACE,qBAAA;AJ+nYF;;AI5nYA;EACE,kBAAA;AJ+nYF;;AI5nYA;EACE,uBAAA;EACA,UAAA;AJ+nYF;AI5nYI;EACE,WAAA;AJ8nYN;AI3nYI;EACE,WAAA;EACA,gBAAA;AJ6nYN;;AIxnYA;EACE,8DD1DY;AHqrYd;;AIxnYA;EACE,8DD7Da;AHwrYf;;AIxnYA,4CAAA;AAEA;EACE,yCAAA;AJ0nYF;;AIvnYA;EACE;IACE,yBAAA;EJ0nYF;AACF;AIvnYA;EACE,sCAAA;AJynYF;;AItnYA;EACE;IACE,YAAA;IACA,iCAAA;EJynYF;AACF;AItnYA;EACE,eAAA;AJwnYF;;AIrnYA;EACE,gBAAA;EACA,gDAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;EACA,2BAAA;AJwnYF;AIvnYE;EACE,6BAAA;EACA,gCAAA;EACA,kBAAA;EACA,kBAAA;AJynYJ;AIvnYI;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AJynYN;AIvnYM;EACE,WAAA;EACA,yBDnHQ;ECoHR,kBAAA;EACA,WAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;AJynYR;AIrnYI;EACE,mBAAA;AJunYN;AIrnYM;EACE,aAAA;AJunYR;AInnYI;EACE,WAAA;EACA,SAAA;EACA,qBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;AJqnYN;AInnYM;EARF;IASI,aAAA;EJsnYN;AACF;AIpnYM;EACE,aAAA;AJsnYR;AInnYU;EACE,eAAA;EACA,0BAAA;AJqnYZ;AIhnYM;EACE,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;AJknYR;AIhnYQ;EACE,eAAA;AJknYV;AI/mYQ;EACE,aAAA;AJinYV;AI9mYQ;EACE,gBAAA;EACA,aAAA;AJgnYV;AI1mYE;EACE,6BAAA;EACA,uBAAA;EACA,aAAA;AJ4mYJ;AIzmYE;;EAEE,kBAAA;AJ2mYJ;AIxmYE;EACE,kBAAA;EACA,gBAAA;AJ0mYJ;AIxmYI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,YAAA;AJ0mYN;AIxmYM;EACE,cAAA;EACA,cD7MQ;EC8MR,eAAA;EACA,mBAAA;EACA,aAAA;AJ0mYR;AIrmYE;EACE,cAAA;EACA,gBAAA;AJumYJ;;AInmYA,2CAAA;AAEA;EACE,aAAA;AJqmYF;;AIlmYA;;4EAAA;AAIA;EACE,eAAA;EACA,gBAAA;EACA,+CAAA;EACA,YAAA;AJomYF;AIjmYI;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;EACA,+CAAA;AJmmYN;AI/lYM;EACE,UAAA;EACA,UAAA;AJimYR;AI5lYE;EACE,mBAAA;EACA,aAAA;AJ8lYJ;AI3lYM;EACE,YAAA;EACA,YAAA;EACA,SAAA;EACA,8CAAA;AJ6lYR;AIxlYE;EACE,kBAAA;EACA,mBAAA;AJ0lYJ;AIxlYI;EACE,YAAA;EACA,WDhOa;AH0zYnB;AIxlYM;EACE,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AJ0lYR;AItlYI;EAIE,kCAAA;AJqlYN;AInlYM;EACE,uBAAA;AJqlYR;;AI/kYA,4EAAA;AACA;EACE;IACE,iBAAA;EJklYF;AACF;AI/kYA;EACE;IACE,eAAA;EJilYF;AACF;AI9kYA;;;;;CAAA;AAOA;EACE,mBD9QiB;EC+QjB,aAAA;EACA,mBAAA;AJ+kYF;AI5kYI;;EAEE,oBAAA;EACA,uBAAA;EACA,yCAAA;EACA,wCAAA;AJ8kYN;AI1kYE;EACE,gBAAA;AJ4kYJ;AIzkYE;;;EAGE,gBAAA;EACA,sCAAA;AJ2kYJ;;AIvkYA;EACE,iBAAA;EACA,sCAAA;AJ0kYF;;AIvkYA,kBAAA;AAEA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;AJykYF;AIvkYE;EAPF;IAQI,eAAA;IACA,eAAA;IACA,cAAA;IACA,oBAAA;EJ0kYF;AACF;;AIvkYA,mBAAA;AAEA;EACE,aAAA;AJykYF;AIvkYE;;EAEE,aAAA;AJykYJ;;AIrkYA;EACE,aAAA;AJwkYF;;AIrkYA;EACE,yBAAA;AJwkYF;AItkYE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;AJwkYJ;AIrkYE;EACE,UAAA;EACA,kBAAA;EACA,iBAAA;AJukYJ;;AInkYA,0BAAA;AAEA;EACE,mBAAA;AJqkYF;;AIlkYA,kBAAA;AAEA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,4CAAA;AJokYF;AIlkYE;EAPF;IAQI,eAAA;EJqkYF;AACF;;AIlkYA;EACE,kBAAA;EACA,iBAAA;AJqkYF;AInkYE;EAJF;IAKI,eAAA;IACA,cAAA;EJskYF;AACF;;AIlkYE;EACE,UAAA;EACA,aAAA;EACA,gBAAA;EACA,6BAAA;EACA,SAAA;AJqkYJ;AIlkYE;EACE,kBAAA;EACA,WAAA;AJokYJ;;AIhkYA;0EAAA;AAGA,kBAAA;AACA;EACE,kBAAA;AJkkYF;AIhkYE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;EACA,0BAAA;EACA,gCAAA;AJkkYJ;AIhkYI;EACE,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBDrdU;ECsdV,WAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;AJkkYN;AIhkYM;EACE,eAAA;AJkkYR;AI/jYM;EACE,8BAAA;EACA,sBAAA;AJikYR;AI/jYQ;EACE,kBAAA;AJikYV;AI3jYE;EACE,UAAA;EACA,wBAAA;EACA,UAAA;AJ6jYJ;;AIzjYA,UAAA;AAEA;EACE,eAAA;EACA,aAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gCAAA;AJ2jYF;;AIxjYA;EACE,2BAAA;AJ2jYF;AIzjYE;EACE,mBAAA;AJ2jYJ;;AIvjYA;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,cAAA;AJ0jYF;AIxjYE;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;AJ0jYJ;AIxjYI;EACE,UAAA;EACA,gBAAA;EACA,eAAA;AJ0jYN;;AIrjYA;EACE,cAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBDviBc;ECwiBd,WAAA;EACA,4CAAA;EACA,UAAA;EACA,mBAAA;AJwjYF;AItjYE;EACE,4CAAA;EACA,WAAA;AJwjYJ;AIrjYE;EACE,mDAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,mBDtjBY;ECujBZ,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,QAAA;EACA,iBAAA;AJujYJ;;AInjYA;EACE,cAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,UAAA;AJsjYF;AIpjYE;EACE,WAAA;EACA,YAAA;AJsjYJ;;AIljYA,SAAA;AACA;EACE,aAAA;AJqjYF;;AIljYA,2BAAA;AACA;EACE,cAAA;EACA,cAAA;EACA,mBAAA;AJqjYF;;AIljYA;;EAEE,cAAA;EACA,kBAAA;AJqjYF;;AIljYA;;;EAGE,cAAA;AJqjYF;;AIljYA;;;;;EAKE,cAAA;AJqjYF;;AIljYA;EACE,cAAA;AJqjYF;;AIljYA;;;;;EAKE,cAAA;AJqjYF;;AIljYA;;EAEE,cAAA;AJqjYF;;AIljYA;;;;;;;;EAQE,cAAA;AJqjYF;;AIljYA;;;;;;EAME,cAAA;AJqjYF;;AIljYA;EACE,kBAAA;AJqjYF;;AIljYA;EACE,iBAAA;AJqjYF;;AIljYA;EACE,0BAAA;AJqjYF;;AIljYA,uFAAA;AAEA;EACE,8DD3qBY;AH+tZd;;AIjjYA,qFAAA;AACA,kFAAA;AAGE;EACE,YAAA;AJkjYJ;AI/iYE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;AJijYJ;AI9iYE;EACE,cAAA;EACA,gBAAA;AJgjYJ;AI9iYI;EACE,SAAA;EACA,SAAA;EACA,iBAAA;EACA,uBAAA;EACA,sBAAA;AJgjYN;;AI5iYA,gFAAA;AAEA,0FAAA;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBDnpBQ;AHgsZV;AI3iYE;EACE,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AJ6iYJ;AI3iYI;EACE,kBAAA;AJ6iYN;AI3iYM;EACE,gBAAA;EACA,cAAA;EACA,iCAAA;AJ6iYR;;AIviYA,wFAAA;AACA,kFAAA;AAEA;EACE,WAAA;AJyiYF;;AItiYA,gFAAA;AACA,gFAAA;AAEA;EACE,kCAAA;EACA,oBAAA;AJwiYF;AItiYE;EACE,iBAAA;EACA,mCAAA;AJwiYJ;;AIpiYA,8EAAA;AACA,+EAAA;AAEA;EACE,sBAAA;EACA,sBAAA;EACA,mBAAA;EACA,4CAAA;AJsiYF;;AIniYA,6EAAA;AACA,uFAAA;AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,8CAAA;EACA,eAAA;AJqiYF;AIniYE;EACE,eAAA;AJqiYJ;AIliYE;EACE,WAAA;AJoiYJ;AIjiYE;EACE,iBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;AJmiYJ;AIhiYE;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AJkiYJ;AIhiYI;EACE,WAAA;EACA,mBAAA;AJkiYN;AIhiYM;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AJkiYR;AIhiYQ;EACE,gBAAA;AJkiYV;AI/hYQ;EACE,sBAAA;AJiiYV;;AI1hYA,qFAAA;AACA,+CAAA;AACA,aAAA;AACA;EACE,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,4GAAA;AJ6hYF;AI1hYA;EACE,6BAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,qCAAA;EACA,mCAAA;AJ4hYF;;AIzhYA,+CAAA;AACA;EACE,qBAAA;AJ4hYF;;AIzhYA;EACE,yBAAA;AJ4hYF;;AIzhYA;EACE,sBAAA;AJ4hYF;;AIzhYA;;;EAGE,sBAAA;EACA,yBAAA;AJ4hYF;;AIzhYA;EACE,8CAAA;AJ4hYF;;AIzhYA;EACE,cAAA;EACA,mCAAA;AJ4hYF;AI1hYE;EACE,+BAAA;AJ4hYJ;;AIxhYA;EACE,4CAAA;AJ2hYF;;AIxhYA;;;;;EAKE,2BAAA;EACA,qCAAA;AJ2hYF;;AIxhYA;EACE,uBAAA;AJ2hYF;;AIrhYM;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;AJwhYR;AIrhYM;EACE,kBAAA;AJuhYR;;AIjhYA;EACE,aAAA;AJohYF;;AIhhYE;EACE,aAAA;EACA,mBAAA;AJmhYJ;AIhhYM;EACE,iBAAA;AJkhYR;;AI5gYA;;;;EAIE,sBAAA;AJ+gYF;;AI3gYE;EADF;IAEI,uBAAA;EJ+gYF;EI7gYE;IACE,eAAA;EJ+gYJ;AACF;;AI1gYE;EAGE,sBAAA;AJ2gYJ;;AItgYE;EACE,sBAAA;EACA,6DAAA;AJygYJ;;AKx/ZA;;6BAAA;AAGA,4CAAA;AAII;EACE,YAAA;ALw/ZN;AKr/ZI;EACE,gBAAA;ALu/ZN;AKp/ZI;EACE,mBAAA;ALs/ZN;AKn/ZI;EACE,iBAAA;ALq/ZN;AKl/ZI;EACE,kBAAA;ALo/ZN;;AKh/ZI;EACE,WAAA;ALm/ZN;AKh/ZI;EACE,eAAA;ALk/ZN;AK/+ZI;EACE,kBAAA;ALi/ZN;AK9+ZI;EACE,gBAAA;ALg/ZN;AK7+ZI;EACE,iBAAA;AL++ZN;;AKrhaI;EACE,YAAA;ALwhaN;AKrhaI;EACE,gBAAA;ALuhaN;AKphaI;EACE,mBAAA;ALshaN;AKnhaI;EACE,iBAAA;ALqhaN;AKlhaI;EACE,kBAAA;ALohaN;;AKhhaI;EACE,WAAA;ALmhaN;AKhhaI;EACE,eAAA;ALkhaN;AK/gaI;EACE,kBAAA;ALihaN;AK9gaI;EACE,gBAAA;ALghaN;AK7gaI;EACE,iBAAA;AL+gaN;;AKrjaI;EACE,aAAA;ALwjaN;AKrjaI;EACE,iBAAA;ALujaN;AKpjaI;EACE,oBAAA;ALsjaN;AKnjaI;EACE,kBAAA;ALqjaN;AKljaI;EACE,mBAAA;ALojaN;;AKhjaI;EACE,YAAA;ALmjaN;AKhjaI;EACE,gBAAA;ALkjaN;AK/iaI;EACE,mBAAA;ALijaN;AK9iaI;EACE,iBAAA;ALgjaN;AK7iaI;EACE,kBAAA;AL+iaN;;AKrlaI;EACE,aAAA;ALwlaN;AKrlaI;EACE,iBAAA;ALulaN;AKplaI;EACE,oBAAA;ALslaN;AKnlaI;EACE,kBAAA;ALqlaN;AKllaI;EACE,mBAAA;ALolaN;;AKhlaI;EACE,YAAA;ALmlaN;AKhlaI;EACE,gBAAA;ALklaN;AK/kaI;EACE,mBAAA;ALilaN;AK9kaI;EACE,iBAAA;ALglaN;AK7kaI;EACE,kBAAA;AL+kaN;;AKrnaI;EACE,aAAA;ALwnaN;AKrnaI;EACE,iBAAA;ALunaN;AKpnaI;EACE,oBAAA;ALsnaN;AKnnaI;EACE,kBAAA;ALqnaN;AKlnaI;EACE,mBAAA;ALonaN;;AKhnaI;EACE,YAAA;ALmnaN;AKhnaI;EACE,gBAAA;ALknaN;AK/maI;EACE,mBAAA;ALinaN;AK9maI;EACE,iBAAA;ALgnaN;AK7maI;EACE,kBAAA;AL+maN;;AKrpaI;EACE,aAAA;ALwpaN;AKrpaI;EACE,iBAAA;ALupaN;AKppaI;EACE,oBAAA;ALspaN;AKnpaI;EACE,kBAAA;ALqpaN;AKlpaI;EACE,mBAAA;ALopaN;;AKhpaI;EACE,YAAA;ALmpaN;AKhpaI;EACE,gBAAA;ALkpaN;AK/oaI;EACE,mBAAA;ALipaN;AK9oaI;EACE,iBAAA;ALgpaN;AK7oaI;EACE,kBAAA;AL+oaN;;AKrraI;EACE,aAAA;ALwraN;AKrraI;EACE,iBAAA;ALuraN;AKpraI;EACE,oBAAA;ALsraN;AKnraI;EACE,kBAAA;ALqraN;AKlraI;EACE,mBAAA;ALoraN;;AKhraI;EACE,YAAA;ALmraN;AKhraI;EACE,gBAAA;ALkraN;AK/qaI;EACE,mBAAA;ALiraN;AK9qaI;EACE,iBAAA;ALgraN;AK7qaI;EACE,kBAAA;AL+qaN;;AKrtaI;EACE,aAAA;ALwtaN;AKrtaI;EACE,iBAAA;ALutaN;AKptaI;EACE,oBAAA;ALstaN;AKntaI;EACE,kBAAA;ALqtaN;AKltaI;EACE,mBAAA;ALotaN;;AKhtaI;EACE,YAAA;ALmtaN;AKhtaI;EACE,gBAAA;ALktaN;AK/saI;EACE,mBAAA;ALitaN;AK9saI;EACE,iBAAA;ALgtaN;AK7saI;EACE,kBAAA;AL+saN;;AKrvaI;EACE,aAAA;ALwvaN;AKrvaI;EACE,iBAAA;ALuvaN;AKpvaI;EACE,oBAAA;ALsvaN;AKnvaI;EACE,kBAAA;ALqvaN;AKlvaI;EACE,mBAAA;ALovaN;;AKhvaI;EACE,YAAA;ALmvaN;AKhvaI;EACE,gBAAA;ALkvaN;AK/uaI;EACE,mBAAA;ALivaN;AK9uaI;EACE,iBAAA;ALgvaN;AK7uaI;EACE,kBAAA;AL+uaN;;AKrxaI;EACE,aAAA;ALwxaN;AKrxaI;EACE,iBAAA;ALuxaN;AKpxaI;EACE,oBAAA;ALsxaN;AKnxaI;EACE,kBAAA;ALqxaN;AKlxaI;EACE,mBAAA;ALoxaN;;AKhxaI;EACE,YAAA;ALmxaN;AKhxaI;EACE,gBAAA;ALkxaN;AK/waI;EACE,mBAAA;ALixaN;AK9waI;EACE,iBAAA;ALgxaN;AK7waI;EACE,kBAAA;AL+waN;;AKrzaI;EACE,aAAA;ALwzaN;AKrzaI;EACE,iBAAA;ALuzaN;AKpzaI;EACE,oBAAA;ALszaN;AKnzaI;EACE,kBAAA;ALqzaN;AKlzaI;EACE,mBAAA;ALozaN;;AKhzaI;EACE,YAAA;ALmzaN;AKhzaI;EACE,gBAAA;ALkzaN;AK/yaI;EACE,mBAAA;ALizaN;AK9yaI;EACE,iBAAA;ALgzaN;AK7yaI;EACE,kBAAA;AL+yaN;;AK1yaA,0CAAA;AAEA,wDAAA;AAGE;EACE,mBAAA;AL0yaJ;;AKxyaE;EACE,cAAA;AL2yaJ;;AK/yaE;EACE,mBAAA;ALkzaJ;;AKhzaE;EACE,cAAA;ALmzaJ;;AKvzaE;EACE,mBAAA;AL0zaJ;;AKxzaE;EACE,cAAA;AL2zaJ;;AK/zaE;EACE,mBAAA;ALk0aJ;;AKh0aE;EACE,cAAA;ALm0aJ;;AKv0aE;EACE,mBAAA;AL00aJ;;AKx0aE;EACE,cAAA;AL20aJ;;AKx0aA,oCAAA;AACA,2CAAA;AAGE;EACE,6BAAA;ALy0aJ;;AK10aE;EACE,6BAAA;AL60aJ;;AK90aE;EACE,6BAAA;ALi1aJ;;AKl1aE;EACE,6BAAA;ALq1aJ;;AKt1aE;EACE,6BAAA;ALy1aJ;;AKt1aA,qCAAA;AACA,qCAAA;AAGE;EACE,eAAA;ALu1aJ;;AKx1aE;EACE,eAAA;AL21aJ;;AK51aE;EACE,eAAA;AL+1aJ;;AKh2aE;EACE,eAAA;ALm2aJ;;AKp2aE;EACE,eAAA;ALu2aJ;;AKx2aE;EACE,eAAA;AL22aJ;;AK52aE;EACE,eAAA;AL+2aJ;;AKh3aE;EACE,eAAA;ALm3aJ;;AKp3aE;EACE,eAAA;ALu3aJ;;AKx3aE;EACE,eAAA;AL23aJ;;AK53aE;EACE,eAAA;AL+3aJ;;AKh4aE;EACE,eAAA;ALm4aJ;;AKp4aE;EACE,eAAA;ALu4aJ;;AKx4aE;EACE,eAAA;AL24aJ;;AK54aE;EACE,eAAA;AL+4aJ;;AKh5aE;EACE,eAAA;ALm5aJ;;AKp5aE;EACE,eAAA;ALu5aJ;;AKx5aE;EACE,eAAA;AL25aJ;;AK55aE;EACE,eAAA;AL+5aJ;;AKh6aE;EACE,eAAA;ALm6aJ;;AKp6aE;EACE,eAAA;ALu6aJ;;AKx6aE;EACE,eAAA;AL26aJ;;AK56aE;EACE,eAAA;AL+6aJ;;AKh7aE;EACE,eAAA;ALm7aJ;;AKp7aE;EACE,eAAA;ALu7aJ;;AKx7aE;EACE,eAAA;AL27aJ;;AK57aE;EACE,eAAA;AL+7aJ;;AKh8aE;EACE,eAAA;ALm8aJ;;AKp8aE;EACE,eAAA;ALu8aJ;;AKx8aE;EACE,eAAA;AL28aJ;;AK58aE;EACE,eAAA;AL+8aJ;;AKh9aE;EACE,eAAA;ALm9aJ;;AKp9aE;EACE,eAAA;ALu9aJ;;AKx9aE;EACE,eAAA;AL29aJ;;AK59aE;EACE,eAAA;AL+9aJ;;AKh+aE;EACE,eAAA;ALm+aJ;;AK/9aA,mCAAA;AACA,uCAAA;AAGE;EACE,gBAAA;ALg+aJ;;AKj+aE;EACE,gBAAA;ALo+aJ;;AKr+aE;EACE,gBAAA;ALw+aJ;;AKz+aE;EACE,gBAAA;AL4+aJ;;AK7+aE;EACE,gBAAA;ALg/aJ;;AKj/aE;EACE,gBAAA;ALo/aJ;;AKr/aE;EACE,gBAAA;ALw/aJ;;AKz/aE;EACE,gBAAA;AL4/aJ;;AK7/aE;EACE,gBAAA;ALggbJ;;AK5/aA,qCAAA;AACA,yCAAA;AAGE;EACE,WAAA;AL6/aJ;;AK3/aE;EACE,YAAA;AL8/aJ;;AKlgbE;EACE,WAAA;ALqgbJ;;AKngbE;EACE,YAAA;ALsgbJ;;AK1gbE;EACE,WAAA;AL6gbJ;;AK3gbE;EACE,YAAA;AL8gbJ;;AKlhbE;EACE,WAAA;ALqhbJ;;AKnhbE;EACE,YAAA;ALshbJ;;AK1hbE;EACE,WAAA;AL6hbJ;;AK3hbE;EACE,YAAA;AL8hbJ;;AKlibE;EACE,WAAA;ALqibJ;;AKnibE;EACE,YAAA;ALsibJ;;AK1ibE;EACE,WAAA;AL6ibJ;;AK3ibE;EACE,YAAA;AL8ibJ;;AKljbE;EACE,WAAA;ALqjbJ;;AKnjbE;EACE,YAAA;ALsjbJ;;AK1jbE;EACE,WAAA;AL6jbJ;;AK3jbE;EACE,YAAA;AL8jbJ;;AKlkbE;EACE,WAAA;ALqkbJ;;AKnkbE;EACE,YAAA;ALskbJ;;AK1kbE;EACE,WAAA;AL6kbJ;;AK3kbE;EACE,YAAA;AL8kbJ;;AKllbE;EACE,WAAA;ALqlbJ;;AKnlbE;EACE,YAAA;ALslbJ;;AK1lbE;EACE,WAAA;AL6lbJ;;AK3lbE;EACE,YAAA;AL8lbJ;;AKlmbE;EACE,WAAA;ALqmbJ;;AKnmbE;EACE,YAAA;ALsmbJ;;AK1mbE;EACE,WAAA;AL6mbJ;;AK3mbE;EACE,YAAA;AL8mbJ;;AKlnbE;EACE,WAAA;ALqnbJ;;AKnnbE;EACE,YAAA;ALsnbJ;;AK1nbE;EACE,YAAA;AL6nbJ;;AK3nbE;EACE,aAAA;AL8nbJ;;AKlobE;EACE,YAAA;ALqobJ;;AKnobE;EACE,aAAA;ALsobJ;;AK1obE;EACE,YAAA;AL6obJ;;AK3obE;EACE,aAAA;AL8obJ;;AKlpbE;EACE,YAAA;ALqpbJ;;AKnpbE;EACE,aAAA;ALspbJ;;AK1pbE;EACE,YAAA;AL6pbJ;;AK3pbE;EACE,aAAA;AL8pbJ;;AKlqbE;EACE,YAAA;ALqqbJ;;AKnqbE;EACE,aAAA;ALsqbJ;;AK1qbE;EACE,YAAA;AL6qbJ;;AK3qbE;EACE,aAAA;AL8qbJ;;AKlrbE;EACE,YAAA;ALqrbJ;;AKnrbE;EACE,aAAA;ALsrbJ;;AK1rbE;EACE,YAAA;AL6rbJ;;AK3rbE;EACE,aAAA;AL8rbJ;;AKlsbE;EACE,YAAA;ALqsbJ;;AKnsbE;EACE,aAAA;ALssbJ;;AK1sbE;EACE,YAAA;AL6sbJ;;AK3sbE;EACE,aAAA;AL8sbJ;;AK1sbA,uCAAA;AClGA;EACE,kBAAA;EACA,6CAAA;EACA,uPAAA;EAEA,mBAAA;EACA,kBAAA;AN+ybF;AM5ybA;EACE,6BAAA;EACA,wBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,+BAAA;EACA,WAAA;EACA,cAAA;EACA,mCAAA;EACA,kCAAA;AN8ybF;;AM3ybA;;EAEE,6BAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,+BAAA;EACA,WAAA;EACA,cAAA;EACA,mCAAA;EACA,kCAAA;AN8ybF;;AM3ybA;EACE,YAAA;AN8ybF;;AM3ybA;EACE,YAAA;AN8ybF;;AM3ybA;EACE,YAAA;AN8ybF;;AM3ybA;EACE,YAAA;AN8ybF;;AM3ybA;EACE,YAAA;AN8ybF;;AM3ybA;EACE,YAAA;AN8ybF;;AM3ybA;EACE,YAAA;AN8ybF;;AM3ybA;EACE,YAAA;AN8ybF;;AM3ybA;EACE,YAAA;AN8ybF;;AM3ybA;EACE,YAAA;AN8ybF;;AM3ybA;EACE,YAAA;AN8ybF;;AM3ybA;EACE,YAAA;AN8ybF;;AM3ybA;EACE,YAAA;AN8ybF;;AOp4bA;EACE,sBAAA;EACA,6CAAA;EACA,OAAA;EACA,uPAAA;EAGA,aAAA;APq4bF;AOl4bA;EACE,+EAAA;EACA,iCAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,sCAAA;EACA,mCAAA;EACA,kCAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AOj4bA;EACE,gBAAA;APo4bF;;AQj2dA;;;;;EAKE,kCAAA;EACA,mCAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;ARo2dF;;AQj2dA;EACE,oBAAA;EACA,mBAAA;EACA,yBAAA;ARo2dF;;AQj2dA;EACE,iBAAA;ARo2dF;;AQj2dA;EACE,kBAAA;ARo2dF;;AQj2dA;EACE,cAAA;ARo2dF;;AQj2dA;EACE,cAAA;ARo2dF;;AQj2dA;EACE,cAAA;ARo2dF;;AQj2dA;EACE,cAAA;ARo2dF;;AQj2dA;EACE,cAAA;ARo2dF;;AQj2dA;EACE,cAAA;ARo2dF;;AQj2dA;EACE,cAAA;ARo2dF;;AQj2dA;EACE,cAAA;ARo2dF;;AQj2dA;EACE,cAAA;ARo2dF;;AQj2dA;EACE,eAAA;ARo2dF;;AQj2dA;EACE,kBAAA;EACA,aAAA;ARo2dF;;AQj2dA;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;ARo2dF;AQn2dE;EACE,kBAAA;ARq2dJ;;AQj2dA;EACE,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;ARo2dF;;AQj2dA;EACE,yBAAA;EACA,oBAAA;EACA,4BAAA;ARo2dF;;AQj2dA;EACE,WAAA;ARo2dF;;AQj2dA;EACE,YAAA;ARo2dF;;AQj2dA;;;;;EAKE,mBAAA;ARo2dF;;AQj2dA;;;;;EAKE,kBAAA;ARo2dF;;AQj2dA;EACE,qCAAA;ARo2dF;;AQj2dA;EACE,uCAAA;ARo2dF;;AQj2dA;EACE;IACE,uBAAA;ERo2dF;EQj2dA;IACE,wBAAA;ERm2dF;AACF;AQh2dA;EACE,sEAAA;EACA,wBAAA;ARk2dF;;AQ/1dA;EACE,sEAAA;EACA,yBAAA;ARk2dF;;AQ/1dA;EACE,sEAAA;EACA,yBAAA;ARk2dF;;AQ/1dA;EACE,gFAAA;EACA,qBAAA;ARk2dF;;AQ/1dA;EACE,qBAAA;ARk2dF;;AQ/1dA;;EAEE,gFAAA;ARk2dF;;AQ/1dA;EACE,oBAAA;ARk2dF;;AQ91dE;;;;;EAKE,YAAA;ARi2dJ;;AQ71dA;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;ARg2dF;;AQ71dA;;EAEE,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;ARg2dF;;AQ71dA;EACE,oBAAA;ARg2dF;;AQ71dA;EACE,cAAA;ARg2dF;;AQ71dA;EACE,WAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,gBAAA;ARg2dF;;AQ71dA;EACE,SAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;ARg2dF;;AQ51dE;EAEE,UAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AR81dJ;;AQ11dA;EACE,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,6CAAA;EACA,iTAAA;AR61dF;AQx1dA;EACE,oCAAA;AR01dF;;AQv1dA;EACE,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;EACA,iTAAA;AR01dF;AQr1dA;EACE,gBAAA;ARu1dF;;AQp1dA;EACE,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;EACA,iTAAA;ARu1dF;AQl1dA;;;EAGE,kCAAA;ARo1dF;;AQj1dA;;EAEE,gBAAA;ARo1dF;;ASnzoBA;;;KAAA;AAKA;EACE,uBAAA;EACA,6CAAA;EACA,iTAAA;EAGA,mBAAA;EACA,kBAAA;ATmzoBF;AShzoBA;EACE;IACE,uBAAA;IACA,2DAAA;ETkzoBF;AACF;AShzoBA;EACE,qBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,wBAAA;EACA,kCAAA;EACA,oBAAA;EACA,kCAAA;EACA,mCAAA;EACA,2BAAA;ATkzoBF;;AS/yoBA;EACE,gBAAA;ATkzoBF;;AShzoBA;EACE,gBAAA;ATmzoBF;;ASjzoBA;EACE,gBAAA;ATozoBF;;ASlzoBA;EACE,gBAAA;ATqzoBF;;ASnzoBA;EACE,gBAAA;ATszoBF;;ASpzoBA;EACE,gBAAA;ATuzoBF;;ASrzoBA;EACE,gBAAA;ATwzoBF;;AStzoBA;EACE,gBAAA;ATyzoBF;;ASvzoBA;EACE,gBAAA;AT0zoBF;;ASxzoBA;EACE,gBAAA;AT2zoBF;;ASzzoBA;EACE,gBAAA;AT4zoBF;;AS1zoBA;EACE,gBAAA;AT6zoBF;;AS3zoBA;EACE,gBAAA;AT8zoBF;;AS5zoBA;EACE,gBAAA;AT+zoBF;;AS7zoBA;EACE,gBAAA;ATg0oBF;;AS9zoBA;EACE,gBAAA;ATi0oBF;;AS/zoBA;EACE,gBAAA;ATk0oBF;;ASh0oBA;EACE,gBAAA;ATm0oBF;;ASj0oBA;EACE,gBAAA;ATo0oBF;;ASl0oBA;EACE,gBAAA;ATq0oBF;;ASn0oBA;EACE,gBAAA;ATs0oBF;;ASp0oBA;EACE,gBAAA;ATu0oBF;;ASr0oBA;EACE,gBAAA;ATw0oBF;;ASt0oBA;EACE,gBAAA;ATy0oBF;;ASv0oBA;EACE,gBAAA;AT00oBF;;ASx0oBA;EACE,gBAAA;AT20oBF;;ASz0oBA;EACE,gBAAA;AT40oBF;;AS10oBA;EACE,gBAAA;AT60oBF;;AS30oBA;EACE,gBAAA;AT80oBF;;AS50oBA;EACE,gBAAA;AT+0oBF;;AS70oBA;EACE,gBAAA;ATg1oBF;;AS90oBA;EACE,gBAAA;ATi1oBF;;AS/0oBA;EACE,gBAAA;ATk1oBF;;ASh1oBA;EACE,gBAAA;ATm1oBF;;ASj1oBA;EACE,gBAAA;ATo1oBF;;ASl1oBA;EACE,gBAAA;ATq1oBF;;ASn1oBA;EACE,gBAAA;ATs1oBF;;ASp1oBA;EACE,gBAAA;ATu1oBF;;ASr1oBA;EACE,gBAAA;ATw1oBF;;ASt1oBA;EACE,gBAAA;ATy1oBF;;ASv1oBA;EACE,gBAAA;AT01oBF;;ASx1oBA;EACE,gBAAA;AT21oBF;;ASz1oBA;EACE,gBAAA;AT41oBF;;AS11oBA;EACE,gBAAA;AT61oBF;;AS31oBA;EACE,gBAAA;AT81oBF;;AS51oBA;EACE,gBAAA;AT+1oBF;;AU3gpBA;EACE,0BAAA;EACA,mLAAA;AV8gpBF;AU1gpBA,iBAAA;AACA;EACE,0BAAA;EACA,mCAAA;EACA,kCAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,2FAAA;EACA,qBAAA;EACA,oBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,gBAAA;AV4gpBF;;AUzgpBA;EACE,cAAA;AV4gpBF;;AU1gpBA;EACE,cAAA;AV6gpBF;;AU3gpBA;EACE,cAAA;AV8gpBF;;AU5gpBA;EACE,cAAA;AV+gpBF;;AU7gpBA;EACE,WAAA;AVghpBF;;AU9gpBA;EACE,cAAA;AVihpBF;;AU/gpBA;EACE,cAAA;AVkhpBF;;AUhhpBA;EACE,cAAA;AVmhpBF;;AUjhpBA;EACE,cAAA;AVohpBF;;AUlhpBA;EACE,cAAA;AVqhpBF;;AUnhpBA;EACE,cAAA;AVshpBF;;AUphpBA;EACE,cAAA;AVuhpBF;;AUrhpBA;EACE,cAAA;AVwhpBF;;AUthpBA;EACE,cAAA;AVyhpBF;;AUvhpBA;EACE,cAAA;AV0hpBF;;AUxhpBA;EACE,cAAA;AV2hpBF;;AUzhpBA;EACE,cAAA;AV4hpBF;;AU1hpBA;EACE,cAAA;AV6hpBF;;AU3hpBA;EACE,cAAA;AV8hpBF;;AU5hpBA;EACE,cAAA;AV+hpBF;;AU7hpBA;EACE,cAAA;AVgipBF;;AU9hpBA;EACE,cAAA;AViipBF;;AU/hpBA;EACE,cAAA;AVkipBF;;AUhipBA;;EAEE,cAAA;AVmipBF;;AUjipBA;EACE,cAAA;AVoipBF;;AUlipBA;EACE,cAAA;AVqipBF;;AUnipBA;EACE,cAAA;AVsipBF;;AUpipBA;EACE,cAAA;AVuipBF;;AUripBA;EACE,cAAA;AVwipBF;;AUtipBA;EACE,cAAA;AVyipBF;;AUvipBA;EACE,cAAA;AV0ipBF;;AUxipBA;EACE,cAAA;AV2ipBF;;AUzipBA;EACE,cAAA;AV4ipBF;;AU1ipBA;EACE,cAAA;AV6ipBF;;AU3ipBA;EACE,cAAA;AV8ipBF;;AU5ipBA;EACE,cAAA;AV+ipBF;;AU7ipBA;EACE,cAAA;AVgjpBF;;AU9ipBA;EACE,cAAA;AVijpBF;;AU/ipBA;;EAEE,cAAA;AVkjpBF;;AUhjpBA;EACE,cAAA;AVmjpBF;;AUjjpBA;EACE,cAAA;AVojpBF;;AUljpBA;EACE,cAAA;AVqjpBF;;AUnjpBA;EACE,cAAA;AVsjpBF;;AUpjpBA;EACE,cAAA;AVujpBF;;AUrjpBA;EACE,cAAA;AVwjpBF;;AUtjpBA;EACE,cAAA;AVyjpBF;;AUvjpBA;EACE,cAAA;AV0jpBF;;AUxjpBA;EACE,cAAA;AV2jpBF;;AUzjpBA;EACE,cAAA;AV4jpBF;;AU1jpBA;EACE,cAAA;AV6jpBF;;AU3jpBA;EACE,cAAA;AV8jpBF;;AU5jpBA;EACE,cAAA;AV+jpBF;;AU7jpBA;EACE,cAAA;AVgkpBF;;AU9jpBA;EACE,cAAA;AVikpBF;;AU/jpBA;EACE,cAAA;AVkkpBF;;AUhkpBA;EACE,cAAA;AVmkpBF;;AUjkpBA;EACE,cAAA;AVokpBF;;AUlkpBA;EACE,cAAA;AVqkpBF;;AUnkpBA;EACE,cAAA;AVskpBF;;AUpkpBA;EACE,cAAA;AVukpBF;;AUrkpBA;EACE,cAAA;AVwkpBF;;AUtkpBA;EACE,cAAA;AVykpBF;;AUvkpBA;EACE,cAAA;AV0kpBF;;AUxkpBA;EACE,cAAA;AV2kpBF;;AUzkpBA;EACE,cAAA;AV4kpBF;;AU1kpBA;EACE,cAAA;AV6kpBF;;AU3kpBA;EACE,cAAA;AV8kpBF;;AU5kpBA;EACE,cAAA;AV+kpBF;;AU7kpBA;EACE,cAAA;AVglpBF;;AU9kpBA;EACE,cAAA;AVilpBF;;AU/kpBA;EACE,cAAA;AVklpBF;;AUhlpBA;EACE,cAAA;AVmlpBF;;AUjlpBA;EACE,cAAA;AVolpBF;;AUllpBA;EACE,cAAA;AVqlpBF;;AUnlpBA;EACE,cAAA;AVslpBF;;AUplpBA;EACE,cAAA;AVulpBF;;AUrlpBA;EACE,cAAA;AVwlpBF;;AUtlpBA;EACE,cAAA;AVylpBF;;AUvlpBA;EACE,cAAA;AV0lpBF;;AUxlpBA;EACE,cAAA;AV2lpBF;;AUzlpBA;EACE,cAAA;AV4lpBF;;AU1lpBA;EACE,cAAA;AV6lpBF;;AU3lpBA;EACE,cAAA;AV8lpBF;;AU5lpBA;EACE,cAAA;AV+lpBF;;AU7lpBA;EACE,cAAA;AVgmpBF;;AU9lpBA;EACE,cAAA;AVimpBF;;AU/lpBA;EACE,cAAA;AVkmpBF;;AUhmpBA;EACE,cAAA;AVmmpBF;;AUjmpBA;EACE,cAAA;AVompBF;;AUlmpBA;EACE,cAAA;AVqmpBF;;AUnmpBA;EACE,cAAA;AVsmpBF;;AUpmpBA;EACE,cAAA;AVumpBF;;AUrmpBA;EACE,cAAA;AVwmpBF;;AUtmpBA;EACE,cAAA;AVympBF;;AUvmpBA;EACE,cAAA;AV0mpBF;;AUxmpBA;EACE,cAAA;AV2mpBF;;AUzmpBA;EACE,cAAA;AV4mpBF;;AU1mpBA;EACE,cAAA;AV6mpBF;;AU3mpBA;EACE,cAAA;AV8mpBF;;AU5mpBA;EACE,cAAA;AV+mpBF;;AU7mpBA;EACE,cAAA;AVgnpBF;;AU9mpBA;EACE,cAAA;AVinpBF;;AU/mpBA;EACE,cAAA;AVknpBF;;AUhnpBA;EACE,cAAA;AVmnpBF;;AUjnpBA;EACE,cAAA;AVonpBF;;AUlnpBA;EACE,cAAA;AVqnpBF;;AUnnpBA;EACE,cAAA;AVsnpBF;;AUpnpBA;EACE,cAAA;AVunpBF;;AUrnpBA;EACE,cAAA;AVwnpBF;;AUtnpBA;EACE,cAAA;AVynpBF;;AUvnpBA;EACE,cAAA;AV0npBF;;AUxnpBA;EACE,cAAA;AV2npBF;;AUznpBA;EACE,cAAA;AV4npBF;;AU1npBA;EACE,cAAA;AV6npBF;;AU3npBA;EACE,cAAA;AV8npBF;;AU5npBA;EACE,cAAA;AV+npBF;;AU7npBA;EACE,cAAA;AVgopBF;;AU9npBA;EACE,cAAA;AViopBF;;AU/npBA;EACE,cAAA;AVkopBF;;AUhopBA;EACE,cAAA;AVmopBF;;AUjopBA;EACE,cAAA;AVoopBF;;AUlopBA;EACE,cAAA;AVqopBF;;AUnopBA;EACE,cAAA;AVsopBF;;AUpopBA;EACE,cAAA;AVuopBF;;AUropBA;EACE,cAAA;AVwopBF;;AUtopBA;EACE,cAAA;AVyopBF;;AUvopBA;EACE,cAAA;AV0opBF;;AUxopBA;EACE,cAAA;AV2opBF;;AUzopBA;EACE,cAAA;AV4opBF;;AU1opBA;EACE,cAAA;AV6opBF;;AU3opBA;EACE,cAAA;AV8opBF;;AU5opBA;EACE,cAAA;AV+opBF;;AU7opBA;EACE,cAAA;AVgppBF;;AU9opBA;EACE,cAAA;AVippBF;;AU/opBA;EACE,cAAA;AVkppBF;;AUhppBA;EACE,cAAA;AVmppBF;;AUjppBA;EACE,cAAA;AVoppBF;;AUlppBA;EACE,cAAA;AVqppBF;;AUnppBA;EACE,cAAA;AVsppBF;;AUpppBA;EACE,cAAA;AVuppBF;;AUrppBA;EACE,cAAA;AVwppBF;;AUtppBA;EACE,cAAA;AVyppBF;;AUvppBA;EACE,cAAA;AV0ppBF;;AUxppBA;EACE,cAAA;AV2ppBF;;AUzppBA;EACE,cAAA;AV4ppBF;;AU1ppBA;EACE,cAAA;AV6ppBF;;AU3ppBA;EACE,cAAA;AV8ppBF;;AU5ppBA;EACE,cAAA;AV+ppBF;;AU7ppBA;EACE,cAAA;AVgqpBF;;AU9ppBA;EACE,cAAA;AViqpBF;;AU/ppBA;EACE,cAAA;AVkqpBF;;AUhqpBA;EACE,cAAA;AVmqpBF;;AUjqpBA;EACE,cAAA;AVoqpBF;;AUlqpBA;EACE,cAAA;AVqqpBF;;AUnqpBA;EACE,cAAA;AVsqpBF;;AUpqpBA;EACE,cAAA;AVuqpBF;;AUrqpBA;EACE,cAAA;AVwqpBF;;AUtqpBA;EACE,cAAA;AVyqpBF;;AUvqpBA;EACE,cAAA;AV0qpBF;;AUxqpBA;EACE,cAAA;AV2qpBF;;AUzqpBA;EACE,cAAA;AV4qpBF;;AU1qpBA;EACE,cAAA;AV6qpBF;;AU3qpBA;EACE,cAAA;AV8qpBF;;AU5qpBA;EACE,cAAA;AV+qpBF;;AU7qpBA;EACE,cAAA;AVgrpBF;;AU9qpBA;EACE,cAAA;AVirpBF;;AU/qpBA;EACE,cAAA;AVkrpBF;;AUhrpBA;EACE,cAAA;AVmrpBF;;AUjrpBA;EACE,cAAA;AVorpBF;;AUlrpBA;EACE,cAAA;AVqrpBF;;AUnrpBA;EACE,cAAA;AVsrpBF;;AUprpBA;EACE,cAAA;AVurpBF;;AUrrpBA;EACE,cAAA;AVwrpBF;;AWtitBA,mBAAA;AAEA;EACE,aAAA;EACA,mBAAA;AXwitBF;AWtitBE;EACE,8DR4BU;EQ3BV,mBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AXwitBJ;AWtitBI;EACE,WAAA;AXwitBN;AWpitBE;EACE,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AXsitBJ;;AWjitBE;EACE,0BAAA;EACA,qBAAA;EACA,UAAA;EACA,gCAAA;AXoitBJ;AWjitBE;EACE,0BAAA;EACA,qBAAA;EACA,UAAA;EACA,gCAAA;AXmitBJ;AW/htBI;EACE,wBAAA;EACA,UAAA;AXiitBN;AW9htBI;EACE,sBAAA;EACA,wBAAA;EACA,UAAA;AXgitBN;;AW3htBA,qBAAA;AACA;EACE,aAAA;EACA,kBAAA;EACA,aAAA;EACA,gBRjCc;EQkCd,UAAA;EACA,kBAAA;EACA,MAAA;EACA,uBAAA;EACA,cRZwB;EQaxB,yBAAA;EACA,kBRvCW;EQwCX,gCAAA;AX8htBF;AW5htBE;EACE,aAAA;AX8htBJ;AW5htBI;;EAEE,aAAA;AX8htBN;AW1htBE;EACE,uBAAA;AX4htBJ;AW1htBI;EACE,eAAA;AX4htBN;AWxhtBE;EACE,uBAAA;AX0htBJ;AWvhtBE;;;EAIE,cR1CsB;AHkktB1B;AWthtBI;;;EACE,cR/DU;AHyltBhB;AWthtBE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AXwhtBJ;AWthtBI;EACE,iBRlFU;EQmFV,qBAAA;EACA,eAAA;AXwhtBN;AWthtBM;EACE,UAAA;AXwhtBR;AWrhtBM;EACE,kBAAA;AXuhtBR;AWphtBM;EACE,mBAAA;AXshtBR;AWhhtBI;EACE,kBAAA;AXkhtBN;AW9gtBE;EACE,YAAA;AXghtBJ;AW5gtBI;EACE,mBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;AX8gtBN;AW5gtBM;;EAEE,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;AX8gtBR;AW3gtBM;EACE,aAAA;AX6gtBR;AW1gtBM;EACE,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,yBAAA;EACA,gBAAA;AX4gtBR;AWzgtBM;EACE,gCAAA;EACA,QAAA;EACA,eAAA;AX2gtBR;AWtgtBQ;;;;EAGE,aAAA;EACA,gBAAA;AXygtBV;AWngtBM;EACE,gBAAA;EACA,yBAAA;EACA,kDAAA;EACA,yBAAA;AXqgtBR;AWngtBQ;EACE,aAAA;AXqgtBV;AWlgtBQ;EACE,YAAA;EACA,gBAAA;EACA,mBRhKM;EQiKN,qBRjKM;AHqqtBhB;AWlgtBU;EACE,WAAA;AXogtBZ;AWhgtBQ;EACE,gCAAA;EACA,QAAA;AXkgtBV;AW7/sBU;;;;EAGE,aAAA;EACA,gBAAA;AXggtBZ;AWx/sBI;EACE,iBRpMU;EQqMV,qBAAA;EACA,mBAAA;AX0/sBN;AWx/sBM;EAEE,uBAAA;AXy/sBR;AWt/sBM;EACE,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;AXw/sBR;AWp/sBI;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AXs/sBN;AWn/sBQ;EACE,aAAA;AXq/sBV;AWj/sBM;EACE,gBAAA;AXm/sBR;AWj/sBQ;EACE,aAAA;EACA,eAAA;AXm/sBV;AW5+sBU;EACE,WRpLO;AHkqtBnB;AWv+sBM;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;EACA,8CAAA;AXy+sBR;AWr+sBI;EACE,YAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;AXu+sBN;AWr+sBM;EACE,gCAAA;EACA,kBAAA;AXu+sBR;AWr+sBQ;EACE,0BAAA;EACA,eAAA;AXu+sBV;AWn+sBM;EACE,UAAA;AXq+sBR;AWn+sBQ;EACE,WAAA;EACA,kBAAA;AXq+sBV;AWl+sBQ;EACE,kBAAA;EACA,gCAAA;AXo+sBV;AWl+sBU;EACE,iBAAA;AXo+sBZ;AWl+sBY;EACE,kBAAA;AXo+sBd;AWh+sBU;EACE,kCAAA;AXk+sBZ;AW/9sBU;EACE,kBAAA;EACA,eAAA;AXi+sBZ;AW/9sBY;EACE,WAAA;AXi+sBd;AW79sBU;EACE,cAAA;EACA,YAAA;AX+9sBZ;AW19sBM;EACE,6BAAA;EACA,kBAAA;EACA,kBAAA;AX49sBR;AW19sBQ;EACE,0BAAA;EACA,eAAA;AX49sBV;AWx9sBM;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AX09sBR;AWx9sBQ;EACE,kBAAA;AX09sBV;AWr9sBI;EACE,UAAA;EACA,gBAAA;EACA,gBAAA;AXu9sBN;AWr9sBM;EACE,WAAA;EACA,kCAAA;EACA,aAAA;EACA,kBAAA;EACA,mBRtVQ;AH6ytBhB;AWr9sBQ;EACE,WAAA;EACA,kBAAA;AXu9sBV;AWp9sBQ;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AXs9sBV;AWl9sBM;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AXo9sBR;AWj9sBU;EACE,WR7TO;EQ8TP,eAAA;EACA,kBAAA;AXm9sBZ;AWj9sBY;EACE,kBAAA;AXm9sBd;AW/8sBU;EAIE,kCAAA;AX88sBZ;AW58sBY;EACE,uBAAA;AX88sBd;AWt8sBM;EACE,cR3YQ;AHm1tBhB;;AWl8sBA,mBAAA;AACA,+BAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YRhac;EQiad,kBAAA;EACA,QAAA;EACA,MAAA;EACA,eAAA;AXq8sBF;AWn8sBE;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,gCAAA;EACA,2BAAA;EACA,kBAAA;AXq8sBJ;AWn8sBI;EAEE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,2BAAA;EACA,kBAAA;AXo8sBN;AWj8sBI;EACE,QAAA;EACA,UAAA;AXm8sBN;AWh8sBI;EACE,SAAA;EACA,UAAA;AXk8sBN;AW77sBI;EACE,6BAAA;AX+7sBN;AW77sBM;EAEE,WAAA;EACA,WAAA;AX87sBR;AW37sBM;EACE,4CAAA;AX67sBR;AW17sBM;EACE,8CAAA;AX47sBR;;AWt7sBA;EACE,mBR/bqB;EQgcrB,kBAAA;AXy7sBF;;AWp7sBE;;EACE,WAAA;EACA,gCAAA;AXw7sBJ;AWr7sBE;EACE;;IACE,gBAAA;EXw7sBJ;AACF;;AWp7sBA;EACE,cAAA;EACA,aAAA;EACA,eAAA;EACA,gCAAA;EACA,yCAAA;EAgQA,YRnvBW;EQovBX,aAAA;EACA,MAAA;EACA,mBRztBqB;EQ0tBrB,cRztBqB;AHi5tBvB;AW17sBE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AX47sBJ;AWz7sBE;EACE,0BAAA;AX27sBJ;AWx7sBE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,WAAA;EACA,YRrgBY;EQsgBZ,kBAAA;EACA,YRtgBS;EQugBT,eAAA;EACA,kBAAA;EACA,gCAAA;AX07sBJ;AWx7sBI;EACE,aAAA;AX07sBN;AWv7sBI;EACE,0BAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;AXy7sBN;AWt7sBI;EACE,WAAA;EACA,qBAAA;AXw7sBN;AWp7sBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YRliBY;EQmiBZ,kBAAA;EACA,WAAA;EACA,MAAA;EACA,eAAA;EACA,gCAAA;AXs7sBJ;AWp7sBI;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,yBR/gBiB;EQghBjB,gCAAA;EACA,2BAAA;EACA,kBAAA;AXs7sBN;AWp7sBM;EAEE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,aAAA;EACA,yBR1hBe;EQ2hBf,oBAAA;EACA,2BAAA;EACA,kBAAA;AXq7sBR;AWl7sBM;EACE,QAAA;EACA,UAAA;AXo7sBR;AWj7sBM;EACE,SAAA;EACA,UAAA;AXm7sBR;AW96sBM;EACE,6BAAA;AXg7sBR;AW96sBQ;EAEE,WAAA;EACA,WAAA;AX+6sBV;AW56sBQ;EACE,4CAAA;AX86sBV;AW36sBQ;EACE,8CAAA;AX66sBV;AWv6sBE;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;AXy6sBJ;AWt6sBE;EACE,sBAAA;AXw6sBJ;AWp6sBQ;EACE,SAAA;AXs6sBV;AWj6sBI;EACE,kBAAA;AXm6sBN;AWj6sBM;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AXm6sBR;AWj6sBQ;EACE,kBAAA;AXm6sBV;AWh6sBQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AXk6sBV;AWh6sBU;EACE,kBAAA;EACA,SAAA;AXk6sBZ;AW35sBU;EACE,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,4BAAA;AX65sBZ;AWv5sBY;EACE,QAAA;AXy5sBd;AWl5sBY;EACE,wBAAA;AXo5sBd;AW/4sBQ;EACE,aAAA;AXi5sBV;AW74sBU;EACE,cAAA;AX+4sBZ;AW54sBU;EACE,kBAAA;AX84sBZ;AWx4sBY;EACE,gBAAA;EACA,yBAAA;EACA,SAAA;EACA,cAAA;AX04sBd;AWx4sBc;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;AX04sBhB;AWp4sBgB;EACE,yBAAA;AXs4sBlB;AWp4sBkB;EACE,UAAA;AXs4sBpB;AW73sBM;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AX+3sBR;AW33sBQ;EACE,eAAA;EACA,YAAA;AX63sBV;AWj3sBE;EACE,mBAAA;EACA,eAAA;AXm3sBJ;AWh3sBE;EACE,cRjuBmB;AHmluBvB;AW/2sBE;;EAEE,WAAA;EACA,YAAA;AXi3sBJ;AW92sBE;EACE,WRxwBmB;EQywBnB,YAAA;EACA,gCAAA;AXg3sBJ;AW92sBI;EACE,WR7wBiB;AH6nuBvB;AW92sBM;EACE,0BAAA;EACA,qBAAA;EACA,UAAA;EACA,iBAAA;AXg3sBR;AW72sBM;EACE,wBAAA;EACA,qBAAA;EACA,UAAA;EACA,2BAAA;AX+2sBR;AW52sBM;EACE,0BAAA;EACA,qBAAA;EACA,UAAA;AX82sBR;AWz2sBM;EACE,iBAAA;AX22sBR;AWv2sBI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AXy2sBN;AWv2sBM;EACE,0BAAA;EACA,qBAAA;EACA,UAAA;EACA,gCAAA;AXy2sBR;AWt2sBM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,wBAAA;EACA,WAAA;EACA,8BAAA;AXw2sBR;AWl2sBQ;EACE,aAAA;EACA,iBAAA;AXo2sBV;AWl2sBU;EACE,0BAAA;EACA,qBAAA;EACA,UAAA;EACA,gCAAA;AXo2sBZ;AW91sBY;EACE,WAAA;AXg2sBd;AWv1sBY;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,0BAAA;EACA,UAAA;EACA,yBAAA;EACA,oCAAA;AXy1sBd;AWr1sBc;EACE,kBAAA;EACA,mBAAA;AXu1sBhB;AWj1sBgB;EACE,UAAA;AXm1sBlB;AW10sBI;EACE,wBAAA;AX40sBN;AWz0sBI;;EAEE,iBRh4BiB;AH2suBvB;AWx0sBI;EACE,0BAAA;EACA,yBAAA;EACA,UAAA;EACA,iCAAA;AX00sBN;AWv0sBI;EACE,uBAAA;AXy0sBN;AWv0sBM;EACE,sBAAA;EACA,wBAAA;EACA,UAAA;AXy0sBR;AWt0sBM;EACE,YRr5BK;AH6tuBb;AWt0sBQ;EACE,wBAAA;EACA,UAAA;AXw0sBV;AWr0sBQ;EACE,0BAAA;EACA,UAAA;AXu0sBV;AWp0sBQ;EACE,aAAA;EACA,WAAA;AXs0sBV;AWj0sBQ;EACE,wBAAA;EACA,UAAA;AXm0sBV;AWh0sBQ;EACE,uBAAA;AXk0sBV;AW9zsBM;EACE,wBAAA;EACA,UAAA;AXg0sBR;AW1zsBY;EACE,wBAAA;EACA,UAAA;AX4zsBd;AW1zsBc;EACE,UAAA;EACA,mBAAA;AX4zsBhB;AWrzsBc;EACE,wBAAA;AXuzsBhB;AWjzsBgB;EACE,sCAAA;AXmzsBlB;AWzysBc;EACE,aAAA;AX2ysBhB;AWvysBgB;EACE,cAAA;AXyysBlB;AWnysBkB;EACE,UAAA;AXqysBpB;AW1xsBE;EACE,cAAA;AX4xsBJ;AWvxsBM;EAGE,cAAA;AXuxsBR;AW/wsBY;EACE,mBAAA;AXixsBd;AWvwsBQ;EACE,WAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,wBAAA;AXywsBV;AWtwsBQ;EACE,mBAAA;EACA,WAAA;AXwwsBV;AWhwsBQ;EACE,aAAA;AXkwsBV;;AWxvsBI;;;EAEE,iBR9iCiB;AH0yuBvB;AW1vsBM;;;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,UAAA;AX8vsBR;;AWxvsBA,8BAAA;AAEA,uBAAA;AACA;EACE,kBAAA;EACA,cAAA;EACA,aAAA;AX0vsBF;;AWvvsBA;EACE,kBAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,kBR9kCW;EQ+kCX,iBAAA;EACA,gCAAA;AX0vsBF;;AWvvsBA,oBAAA;AACA,iFAAA;AACA;EACE,aAAA;AX0vsBF;;AWvvsBA;EACE;IACE,mBRrkCqB;IQskCrB,WRrkCqB;EH+zuBvB;EWxvsBE;;;IAGE,cRxkCoB;EHk0uBxB;EWxvsBI;;;IACE,cR7lCQ;EHy1uBd;EWxvsBE;IACE,aAAA;IACA,gBAAA;IACA,gDAAA;EX0vsBJ;EWvvsBE;IACE,aAAA;IACA,WAAA;IACA,kBAAA;IACA,WAAA;EXyvsBJ;EWtvsBE;;;IAGE,cRlmCmB;EH01uBvB;EWrvsBE;IACE,aAAA;IACA,2BAAA;IACA,mBAAA;IACA,WAAA;IACA,YRjoCU;EHw3uBd;EWrvsBI;IACE,iBAAA;EXuvsBN;EWpvsBI;IACE,WAAA;EXsvsBN;EWlvsBE;IACE,aAAA;EXovsBJ;EW/usBM;IACE,mBAAA;EXivsBR;EW3usBA;IACE,mBAAA;IACA,eAAA;IACA,YAAA;IACA,gBAAA;EX6usBF;EW3usBE;IACE,YAAA;EX6usBJ;EW1usBE;;IAEE,cAAA;EX4usBJ;EWzusBE;IACE,WAAA;EX2usBJ;EWxusBE;IACE,aAAA;EX0usBJ;EWvusBE;IACE,cAAA;EXyusBJ;EWvusBI;;IAEE,cAAA;EXyusBN;AACF;AWpusBA;EAGM;IACE,eAAA;EXousBN;EWjusBI;IACE,mBAAA;EXmusBN;EW9tsBI;IACE,aAAA;EXgusBN;EW9tsBM;IACE,cAAA;IACA,gBAAA;EXgusBR;EW1tsBI;IACE,gBAAA;EX4tsBN;EW1tsBM;IACE,aAAA;EX4tsBR;EWztsBM;IACE,aAAA;EX2tsBR;EWvtsBI;IACE,WAAA;EXytsBN;EWttsBI;IACE,UAAA;IACA,iBAAA;IACA,kBAAA;IACA,OAAA;IACA,QAAA;EXwtsBN;EWntsBA;;IAEE,YAAA;EXqtsBF;EWltsBA;IACE,kBAAA;EXotsBF;EWjtsBA;IACE,mBAAA;EXmtsBF;AACF;AWhtsBA;EAEI;IACE,gBAAA;EXitsBJ;EW9ssBE;IACE,gBAAA;EXgtsBJ;EW7ssBM;IACE,gBAAA;EX+ssBR;EW1ssBM;IACE,gBAAA;EX4ssBR;EWrssBU;IACE,gBAAA;EXussBZ;EWjssBY;IACE,gBAAA;IACA,uBAAA;EXmssBd;EW5rsBI;IACE,gBAAA;EX8rsBN;EW1rsBM;IACE,uBAAA;EX4rsBR;AACF;AWtrsBA;EACE,mBAAA;EACA,eAAA;EACA,kBAAA;AXwrsBF;;AWrrsBA,gFAAA;AAEA;;;6CAAA;AAIA;EACE,sBR7xCsB;EQ8xCtB,cR7xCsB;EQ8xCtB,gDAAA;AXursBF;AWrrsBE;EACE,yBRpyCmB;AH29uBvB;AWrrsBI;EACE,aAAA;AXursBN;AWprsBI;EACE,cAAA;AXsrsBN;AWjrsBI;EACE,yBRhzCiB;AHm+uBvB;AWjrsBM;EAEE,yBRpzCe;AHs+uBvB;AW7qsBM;EACE,6BAAA;AX+qsBR;AW1qsBE;EACE,mBAAA;AX4qsBJ;AWzqsBE;EACE,cRl0CoB;AH6+uBxB;AWtqsBM;EACE,8BAAA;AXwqsBR;AWlqsBQ;EACE,uBAAA;AXoqsBV;AW9psBE;EACE,cRt1CoB;AHs/uBxB;AWzpsBQ;EACE,mBAAA;EACA,WAAA;AX2psBV;;AWppsBA,6CAAA;AAEA,0CAAA;AACA;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;AXspsBF;AWppsBE;EACE,yBAAA;EACA,iBAAA;AXspsBJ;;AWlpsBA,wCAAA;AAEA,yFAAA;AACA,2BAAA;AAMI;EACE,8BAAA;AX+osBN;;AWhpsBI;EACE,8BAAA;AXmpsBN;;AWppsBI;EACE,8BAAA;AXupsBN;;AWxpsBI;EACE,8BAAA;AX2psBN;;AW5psBI;EACE,8BAAA;AX+psBN;;AW1psBA;EACE;IACE,gBAAA;EX6psBF;EW1psBA;IACE,oBAAA;EX4psBF;EWzpsBA;IACE,qBAAA;EX2psBF;EWxpsBA;IACE,SAAA;EX0psBF;EWvpsBA;IACE,UAAA;EXypsBF;AACF;AWppsBA;EACE,kBAAA;AXspsBF;;AWnpsBA;;;;;;EAME,uBAAA;AXspsBF;;AWnpsBA;EACE,mBAAA;AXspsBF;;AWnpsBA;;;EAGE,mBAAA;AXspsBF;;AWnpsBA,gBAAA;AACA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AXspsBF;;AWlpsBA;EACE,WAAA;AXqpsBF;;AWjpsBA;EACE,aAAA;AXopsBF;;AYhpvBI;EACE,sBAAA;AZmpvBN;AY/ovBM;EACE,SAAA;AZipvBR;;AYvovBQ;EACE,aAAA;AZ0ovBV;AYrovBI;EACE,sBAAA;AZuovBN;AYpovBI;EACE,mBAAA;EACA,2CAAA;AZsovBN;;AY/nvBI;EACE,eAAA;EACA,gCAAA;AZkovBN;AY9nvBE;EACE,WAAA;AZgovBJ;AY7nvBE;EACE,8BAAA;AZ+nvBJ;;AYxnvBI;;EACE,sBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;AZ4nvBN;;AYvnvBA;EACE;IACE,sBAAA;IACA,kBAAA;EZ0nvBF;AACF;Aa/rvBA;;8BAAA;AAIA;;EAEE,mBVmFiB;EUlFjB,kBAAA;EACA,eAAA;EACA,YAAA;AbgsvBF;Aa9rvBE;;EACE,kBAAA;AbisvBJ;Aa9rvBE;;EACE,6BAAA;EACA,mBAAA;AbisvBJ;Aa9rvBE;;EACE,gBAAA;AbisvBJ;Aa9rvBE;;EACE,mBVgEe;AHiovBnB;Aa9rvBE;;EACE,cAAA;EACA,UAAA;AbisvBJ;Aa9rvBE;;EACE,cAAA;AbisvBJ;Aa9rvBE;;EACE,cAAA;AbisvBJ;;Aa9rvBA,sBAAA;AAEA;EACE,mBV6CiB;AHmpvBnB;Aa9rvBE;EACE,kBAAA;EACA,mBAAA;EACA,uBAAA;AbgsvBJ;Aa/rvBI;EACE,eAAA;AbisvBN;Aa7rvBE;EACE,gBAAA;Ab+rvBJ;Aa5rvBE;EACE,gBAAA;EACA,eAAA;Ab8rvBJ;;AazrvBE;EACE,2BAAA;EACA,gBAAA;Ab4rvBJ;Aa1rvBI;EACE,yBAAA;EACA,eAAA;Ab4rvBN;;AavrvBA;EACE,2BAAA;Ab0rvBF;;AaxrvBA,oBAAA;AACA,yCAAA;AACA;EACE,2BAAA;Ab2rvBF;;AazrvBA;;;;;;EAME,4BAAA;Ab4rvBF;;AaxrvBE;EACE,0BAAA;Ab2rvBJ;;AaxrvBA,gBAAA;AAEA;EACE,sBAAA;Ab0rvBF;;AaxrvBA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,2CAAA;EACA,4BAAA;EACA,eAAA;Ab2rvBF;;AazrvBA;EACE,WAAA;Ab4rvBF;;Aa1rvBA;EACE,YAAA;Ab6rvBF;Aa5rvBE;EACE,YAAA;EACA,wBAAA;Ab8rvBJ;;Aa3rvBA;;;;EAIE,gEAAA;Ab8rvBF;;Aa3rvBA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;Ab8rvBF;;Ac70vBA;;8BAAA;AAGA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;Adg1vBF;Ac90vBE;EACE,SAAA;EACA,aAAA;EACA,WAAA;Adg1vBJ;Ac90vBI;;EAEE,eAAA;Adg1vBN;Ac90vBM;;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EAEE,eAAA;EACA,sBAAA;EACA,gBAAA;EAEF,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;Ad+0vBR;Ac30vBI;EAEE,mBAAA;EACA,qBAAA;EACA,cAAA;Ad40vBN;Acz0vBI;EAIE,YAAA;Adw0vBN;Acr0vBI;EAIE,mBAAA;Ado0vBN;Ac5zvBQ;;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;Ad+zvBV;Ac5zvBQ;;EACE,UAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;Ad+zvBV;AcxzvBU;;EACE,UAAA;Ad2zvBZ;AcxzvBU;;EACE,UAAA;EACA,uBAAA;EACA,cAAA;EACA,yBAAA;Ad2zvBZ;AclzvBI;EAEE,mBAAA;EACA,qBAAA;EACA,cAAA;AdmzvBN;AchzvBI;EAEE,uBAAA;EACA,cAAA;EACA,yBAAA;AdizvBN;Ac5zvBI;EAEE,mBAAA;EACA,qBAAA;EACA,cAAA;Ad6zvBN;Ac1zvBI;EAEE,uBAAA;EACA,cAAA;EACA,yBAAA;Ad2zvBN;Act0vBI;EAEE,mBAAA;EACA,qBAAA;EACA,cAAA;Adu0vBN;Acp0vBI;EAEE,uBAAA;EACA,cAAA;EACA,yBAAA;Adq0vBN;Ach1vBI;EAEE,mBAAA;EACA,qBAAA;EACA,cAAA;Adi1vBN;Ac90vBI;EAEE,uBAAA;EACA,cAAA;EACA,yBAAA;Ad+0vBN;Ac11vBI;EAEE,mBAAA;EACA,qBAAA;EACA,cAAA;Ad21vBN;Acx1vBI;EAEE,uBAAA;EACA,cAAA;EACA,yBAAA;Ady1vBN;Acr1vBE;;EAEE,eAAA;Adu1vBJ;;Acn1vBA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;Ads1vBF;Acp1vBE;EACE,SAAA;EACA,aAAA;EACA,WAAA;Ads1vBJ;Acp1vBI;;EAEE,eAAA;Ads1vBN;Acp1vBM;;;EAEE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;Adu1vBR;Acp1vBM;;EACE,WAAA;EACA,YAAA;EACA,yBAAA;Adu1vBR;Acp1vBM;;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;Adu1vBR;Ach1vBQ;;EACE,qBAAA;Adm1vBV;Ach1vBQ;;EACE,8DXtJI;AHy+vBd;Ac70vBM;;EAEE,YAAA;EACA,mBAAA;Ad+0vBR;Ac70vBQ;;;EAEE,mBAAA;Adg1vBV;Act0vBQ;;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;Ady0vBV;Ac/zvBM;EACE,qBAAA;Adi0vBR;Ac9zvBM;EACE,mBAAA;Adg0vBR;Acr0vBM;EACE,qBAAA;Adu0vBR;Acp0vBM;EACE,mBAAA;Ads0vBR;Ac30vBM;EACE,qBAAA;Ad60vBR;Ac10vBM;EACE,mBAAA;Ad40vBR;Acj1vBM;EACE,qBAAA;Adm1vBR;Ach1vBM;EACE,mBAAA;Adk1vBR;Acv1vBM;EACE,qBAAA;Ady1vBR;Act1vBM;EACE,mBAAA;Adw1vBR;Acn1vBE;;EAEE,eAAA;Adq1vBJ;;Acl1vBA;EACE;;IAEE,SAAA;Edq1vBF;AACF;Ac70vBQ;;EACE,SAAA;Adg1vBV;;Ac10vBA,0CAAA;AAIE;;EACE,eAAA;EACA,kBAAA;Ad20vBJ;Acz0vBI;;EACE,QAAA;Ad40vBN;;AerlwBA;;8BAAA;AAIA;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AfulwBF;AenlwBI;EACE,mBAAA;EACA,cAAA;AfqlwBN;AevlwBI;EACE,mBAAA;EACA,cAAA;AfylwBN;Ae3lwBI;EACE,mBAAA;EACA,cAAA;Af6lwBN;Ae/lwBI;EACE,mBAAA;EACA,cAAA;AfimwBN;AenmwBI;EACE,mBAAA;EACA,cAAA;AfqmwBN;;AejmwBA,yCAAA;ACnBA;;8BAAA;AAGA;EACE,WAAA;AhBwnwBF;AgBvnwBE;;EAEE,6BAAA;EACA,mBAAA;EACA,wBAAA;AhBynwBJ;AgBtnwBE;EACE,gCAAA;AhBwnwBJ;AgBrnwBE;EACE,6BAAA;AhBunwBJ;AgBnnwBI;;EAEE,gBAAA;AhBqnwBN;;AgBjnwBA,oBAAA;AAEA;EACE,yBAAA;AhBmnwBF;AgBjnwBE;;EAEE,yBAAA;AhBmnwBJ;;AgBhnwBA,mBAAA;AAGE;EACE,yCAAA;AhBinwBJ;;AgB9mwBA,iBAAA;AAII;EACE,yCAAA;AhB8mwBN;;AgB1mwBA,sBAAA;AAII;EACE,WAAA;EACA,yBbbO;EacP,qBAAA;AhB0mwBN;;AgBrmwBA;EACE,WAAA;EACA,yBbrBW;AH6nwBb;AgBtmwBE;;;EAGE,qBAAA;AhBwmwBJ;AgBpmwBI;EACE,yBAAA;AhBsmwBN;AgBhmwBM;EACE,yBAAA;AhBkmwBR;;AgB7lwBA,0BAAA;AAEA;EACE;IACE,wBAAA;EhB+lwBF;AACF;AgB5lwBA;;8BAAA;AAMI;;EAEE,yBbpEU;EaqEV,qBbrEU;AHgqwBhB;AgBzlwBM;;;EAEE,yBbzEQ;Ea0ER,qBb1EQ;AHsqwBhB;AgBtlwBI;;EAEE,WAAA;AhBwlwBN;;AgBnlwBA;;EAEE,gBAAA;AhBslwBF;;AgBllwBE;EACE,gBAAA;AhBqlwBJ;AgBllwBE;EACE,iBAAA;AhBolwBJ;;AgB7kwBM;EACE,SAAA;EACA,8BAAA;AhBglwBR;AgB7kwBM;EACE,SAAA;AhB+kwBR;;AgB1kwBA,oCAAA;AACA,sCAAA;AC1JA;;8BAAA;AAGA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AjBwuwBF;AiBvuwBE;;EAEE,Wd8EkB;Ec7ElB,gBAAA;AjByuwBJ;AiBtuwBI;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AjBwuwBN;AiBtuwBM;EACE,eAAA;AjBwuwBR;AiBpuwBE;EACE,uBAAA;AjBsuwBJ;AiBpuwBE;EACE,gBAAA;AjBsuwBJ;AiBnuwBE;EACE,UAAA;AjBquwBJ;AiBluwBE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;AjBouwBJ;AiBnuwBI;EAEE,YAAA;AjBouwBN;AiBjuwBE;EAhDF;IAiDI,gBAAA;EjBouwBF;AACF;AiBnuwBE;EAEI;IACE,kBAAA;EjBouwBN;AACF;AiBhuwBE;EACE,eAAA;AjBkuwBJ;AiBjuwBI;EACE,8Dd9BQ;Ec+BR,wBAAA;EACA,6BAAA;EACA,oCAAA;AjBmuwBN;AiB/twBE;EACE,sBAAA;AjBiuwBJ;AiB/twBI;EACE,aAAA;AjBiuwBN;AiB5twBI;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AjB8twBN;AiB5twBM;EACE,WAAA;EACA,aAAA;EACA,8DdvDM;AHqxwBd;AiB3twBM;EACE,YAAA;EACA,cAAA;EACA,8Dd5DO;AHyxwBf;AiB1twBM;EACE,WAAA;EACA,YAAA;AjB4twBR;AiB3twBQ;EACE,UAAA;EACA,aAAA;EACA,mBdpEM;AHiywBhB;AiB1twBQ;EACE,YAAA;EACA,aAAA;EACA,mBdvEM;AHmywBhB;AiBxtwBM;EACE,+BAAA;AjB0twBR;AiBvtwBM;EACE,+BAAA;AjBytwBR;;AiBptwBA,wBAAA;AACA;EACE,sBAAA;EACA,4BAAA;EACA,2BAAA;AjButwBF;;AiBptwBE;EACE,cAAA;AjButwBJ;;AiBltwBE;;;;EAEE,uBAAA;AjButwBJ;;AiB7swBE;EACE,gBAAA;EACA,kBAAA;AjBgtwBJ;AiB/swBI;EACE,kBAAA;EACA,UAAA;AjBitwBN;AiB/swBI;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gBAAA;EACA,yBAAA;EACA,UAAA;EACA,YAAA;AjBitwBN;;AiB7swBA,wBAAA;AACA;EACE;IACE,qDAAA;EjBgtwBF;EiB7swBA;IACE,0DAAA;EjB+swBF;AACF;AiB7swBA,yCAAA;AClLA;;uCAAA;ACCA;;8BAAA;AAGA;;EAEE,8DhB6BY;EgB5BZ,WAAA;EACA,4CAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;AnBo4wBF;AmBl4wBE;;;;EAGE,oEhBmBU;EgBlBV,WAAA;EACA,gBAAA;AnBq4wBJ;AmBl4wBE;;EACE,iCAAA;EACA,chBqBY;EgBpBZ,yBAAA;EACA,gBAAA;AnBq4wBJ;;AmBj4wBA;EACE,iCAAA;EACA,chBac;EgBZd,yBAAA;EACA,gBAAA;AnBo4wBF;AmBl4wBE;EAGE,sBAAA;EACA,chBKY;EgBJZ,yBAAA;AnBk4wBJ;AmB/3wBE;EACE,yEAAA;EACA,WAAA;EACA,4CAAA;EACA,6BAAA;AnBi4wBJ;;AmB73wBA;EACE,8DhBhBa;EgBiBb,WAAA;EACA,4CAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;AnBg4wBF;AmB93wBE;EAGE,oEhB1BW;EgB2BX,WAAA;EACA,gBAAA;AnB83wBJ;AmB33wBE;EACE,iCAAA;EACA,chBzBY;EgB0BZ,yBAAA;EACA,gBAAA;AnB63wBJ;;AmBz3wBA;EACE,iCAAA;EACA,chBjCc;EgBkCd,yBAAA;EACA,gBAAA;AnB43wBF;AmB13wBE;EAGE,sBAAA;EACA,chBzCY;EgB0CZ,yBAAA;AnB03wBJ;AmBv3wBE;EACE,yEAAA;EACA,WAAA;EACA,4CAAA;EACA,6BAAA;AnBy3wBJ;;AmBr3wBA;EACE,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,gCAAA;AnBw3wBF;AmBt3wBE;EACE,kBAAA;AnBw3wBJ;AmBr3wBE;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;AnBs3wBJ;AmBp3wBI;EACE,eAAA;AnBs3wBN;AmBj3wBI;EACE,aAAA;AnBm3wBN;AmBh3wBI;EACE,kBAAA;AnBk3wBN;AmB92wBE;EAEE,gBAAA;AnB+2wBJ;AmB52wBE;EACE,gBAAA;AnB82wBJ;AmB32wBE;EACE,mBAAA;EACA,aAAA;AnB62wBJ;AmB12wBE;EACE,mBAAA;AnB42wBJ;;AmBv2wBE;EACE,gBAAA;EACA,eAAA;AnB02wBJ;;AmBt2wBA;;EAEE,iBAAA;EACA,eAAA;AnBy2wBF;;AmBt2wBA;;EAEE,kBAAA;EACA,eAAA;AnBy2wBF;;AmBt2wBA;EACE,gDAAA;AnBy2wBF;;AmBt2wBA;EACE,gDAAA;AnBy2wBF;;AmBt2wBA;EACE,iDAAA;AnBy2wBF;;AmBt2wBA;EACE,gDAAA;AnBy2wBF;;AmBt2wBA;EACE,iDAAA;AnBy2wBF;;AmBv2wBA,sBAAA;AAEE;EDlLA,WAAA;EACA,yBf0Fa;EezFb,qBfyFa;AHm8wBf;AkB1hxBE;EACE,WAAA;EACA,yBAXiB;EAYjB,qBAXa;AlBuixBjB;AkBrhxBE;EAEE,WAAA;EACA,yBf0EW;EezEX,qBfyEW;AH68wBf;AkBnhxBE;EAGE,WAAA;EACA,yBA5BkB;EA6BlB,qBA5Bc;AlB+ixBlB;AmB33wBE;EDlLA,WAAA;EACA,yBf0Fa;EezFb,qBfyFa;AHu9wBf;AkB9ixBE;EACE,WAAA;EACA,yBAXiB;EAYjB,qBAXa;AlB2jxBjB;AkBzixBE;EAEE,WAAA;EACA,yBf0EW;EezEX,qBfyEW;AHi+wBf;AkBvixBE;EAGE,WAAA;EACA,yBA5BkB;EA6BlB,qBA5Bc;AlBmkxBlB;AmB/4wBE;EDlLA,WAAA;EACA,yBf0Fa;EezFb,qBfyFa;AH2+wBf;AkBlkxBE;EACE,WAAA;EACA,yBAXiB;EAYjB,qBAXa;AlB+kxBjB;AkB7jxBE;EAEE,WAAA;EACA,yBf0EW;EezEX,qBfyEW;AHq/wBf;AkB3jxBE;EAGE,WAAA;EACA,yBA5BkB;EA6BlB,qBA5Bc;AlBulxBlB;AmBn6wBE;EDlLA,WAAA;EACA,yBf0Fa;EezFb,qBfyFa;AH+/wBf;AkBtlxBE;EACE,WAAA;EACA,yBAXiB;EAYjB,qBAXa;AlBmmxBjB;AkBjlxBE;EAEE,WAAA;EACA,yBf0EW;EezEX,qBfyEW;AHygxBf;AkB/kxBE;EAGE,WAAA;EACA,yBA5BkB;EA6BlB,qBA5Bc;AlB2mxBlB;AmBv7wBE;EDlLA,WAAA;EACA,yBf0Fa;EezFb,qBfyFa;AHmhxBf;AkB1mxBE;EACE,WAAA;EACA,yBAXiB;EAYjB,qBAXa;AlBunxBjB;AkBrmxBE;EAEE,WAAA;EACA,yBf0EW;EezEX,qBfyEW;AH6hxBf;AkBnmxBE;EAGE,WAAA;EACA,yBA5BkB;EA6BlB,qBA5Bc;AlB+nxBlB;AmB38wBE;EDlLA,WAAA;EACA,yBf0Fa;EezFb,qBfyFa;AHuixBf;AkB9nxBE;EACE,WAAA;EACA,yBAXiB;EAYjB,qBAXa;AlB2oxBjB;AkBznxBE;EAEE,WAAA;EACA,yBf0EW;EezEX,qBfyEW;AHijxBf;AkBvnxBE;EAGE,WAAA;EACA,yBA5BkB;EA6BlB,qBA5Bc;AlBmpxBlB;AmB/9wBE;EDlLA,cAAA;EACA,yBf0Fa;EezFb,qBfyFa;AH2jxBf;AkBlpxBE;EACE,cAAA;EACA,yBAXiB;EAYjB,qBAXa;AlB+pxBjB;AkB7oxBE;EAEE,cAAA;EACA,yBf0EW;EezEX,qBfyEW;AHqkxBf;AkB3oxBE;EAGE,cAAA;EACA,yBA5BkB;EA6BlB,qBA5Bc;AlBuqxBlB;AmBn/wBE;EDlLA,WAAA;EACA,yBf0Fa;EezFb,qBfyFa;AH+kxBf;AkBtqxBE;EACE,WAAA;EACA,yBAXiB;EAYjB,qBAXa;AlBmrxBjB;AkBjqxBE;EAEE,WAAA;EACA,yBf0EW;EezEX,qBfyEW;AHylxBf;AkB/pxBE;EAGE,WAAA;EACA,yBA5BkB;EA6BlB,qBA5Bc;AlB2rxBlB;AmBngxBA,oBAAA;AAEE;EDvJA,cf0Da;EezDb,6BAAA;EACA,sBAAA;EACA,qBfuDa;AHqmxBf;AkB1pxBE;EACE,WAAA;EACA,yBfmDW;EelDX,qBfkDW;AH0mxBf;AkBrpxBE;EAEE,cfyCW;EexCX,6BAAA;AlBspxBJ;AkBnpxBE;EAGE,WAAA;EACA,yBfiCW;EehCX,qBfgCW;AHmnxBf;AmBthxBE;EDvJA,cf0Da;EezDb,6BAAA;EACA,sBAAA;EACA,qBfuDa;AHynxBf;AkB9qxBE;EACE,WAAA;EACA,yBfmDW;EelDX,qBfkDW;AH8nxBf;AkBzqxBE;EAEE,cfyCW;EexCX,6BAAA;AlB0qxBJ;AkBvqxBE;EAGE,WAAA;EACA,yBfiCW;EehCX,qBfgCW;AHuoxBf;AmB1ixBE;EDvJA,cf0Da;EezDb,6BAAA;EACA,sBAAA;EACA,qBfuDa;AH6oxBf;AkBlsxBE;EACE,WAAA;EACA,yBfmDW;EelDX,qBfkDW;AHkpxBf;AkB7rxBE;EAEE,cfyCW;EexCX,6BAAA;AlB8rxBJ;AkB3rxBE;EAGE,WAAA;EACA,yBfiCW;EehCX,qBfgCW;AH2pxBf;AmB9jxBE;EDvJA,cf0Da;EezDb,6BAAA;EACA,sBAAA;EACA,qBfuDa;AHiqxBf;AkBttxBE;EACE,WAAA;EACA,yBfmDW;EelDX,qBfkDW;AHsqxBf;AkBjtxBE;EAEE,cfyCW;EexCX,6BAAA;AlBktxBJ;AkB/sxBE;EAGE,WAAA;EACA,yBfiCW;EehCX,qBfgCW;AH+qxBf;AmBllxBE;EDvJA,cf0Da;EezDb,6BAAA;EACA,sBAAA;EACA,qBfuDa;AHqrxBf;AkB1uxBE;EACE,WAAA;EACA,yBfmDW;EelDX,qBfkDW;AH0rxBf;AkBruxBE;EAEE,cfyCW;EexCX,6BAAA;AlBsuxBJ;AkBnuxBE;EAGE,WAAA;EACA,yBfiCW;EehCX,qBfgCW;AHmsxBf;AmBtmxBE;EDvJA,cf0Da;EezDb,6BAAA;EACA,sBAAA;EACA,qBfuDa;AHysxBf;AkB9vxBE;EACE,WAAA;EACA,yBfmDW;EelDX,qBfkDW;AH8sxBf;AkBzvxBE;EAEE,cfyCW;EexCX,6BAAA;AlB0vxBJ;AkBvvxBE;EAGE,WAAA;EACA,yBfiCW;EehCX,qBfgCW;AHutxBf;AmB1nxBE;EDvJA,cf0Da;EezDb,6BAAA;EACA,sBAAA;EACA,qBfuDa;AH6txBf;AkBlxxBE;EACE,cAAA;EACA,yBfmDW;EelDX,qBfkDW;AHkuxBf;AkB7wxBE;EAEE,cfyCW;EexCX,6BAAA;AlB8wxBJ;AkB3wxBE;EAGE,cAAA;EACA,yBfiCW;EehCX,qBfgCW;AH2uxBf;AmB9oxBE;EDvJA,cf0Da;EezDb,6BAAA;EACA,sBAAA;EACA,qBfuDa;AHivxBf;AkBtyxBE;EACE,WAAA;EACA,yBfmDW;EelDX,qBfkDW;AHsvxBf;AkBjyxBE;EAEE,cfyCW;EexCX,6BAAA;AlBkyxBJ;AkB/xxBE;EAGE,WAAA;EACA,yBfiCW;EehCX,qBfgCW;AH+vxBf;AmB9pxBA,iBAAA;AAEE;ED5HA,wFAAA;AlB4xxBF;AkB3xxBE;EACE,uFAAA;AlB6xxBJ;AkB3xxBE;EAKE,gBAAA;AlByxxBJ;;AmBtqxBE;ED5HA,4FAAA;AlBsyxBF;AkBryxBE;EACE,2FAAA;AlBuyxBJ;AkBryxBE;EAKE,gBAAA;AlBmyxBJ;;AmBhrxBE;ED5HA,0FAAA;AlBgzxBF;AkB/yxBE;EACE,yFAAA;AlBizxBJ;AkB/yxBE;EAKE,gBAAA;AlB6yxBJ;;AmB1rxBE;ED5HA,0FAAA;AlB0zxBF;AkBzzxBE;EACE,yFAAA;AlB2zxBJ;AkBzzxBE;EAKE,gBAAA;AlBuzxBJ;;AmBpsxBE;ED5HA,0FAAA;AlBo0xBF;AkBn0xBE;EACE,yFAAA;AlBq0xBJ;AkBn0xBE;EAKE,gBAAA;AlBi0xBJ;;AmB9sxBE;ED5HA,wFAAA;AlB80xBF;AkB70xBE;EACE,uFAAA;AlB+0xBJ;AkB70xBE;EAKE,gBAAA;AlB20xBJ;;AmBxtxBE;ED5HA,4FAAA;AlBw1xBF;AkBv1xBE;EACE,2FAAA;AlBy1xBJ;AkBv1xBE;EAKE,gBAAA;AlBq1xBJ;;AmBluxBE;ED5HA,sFAAA;AlBk2xBF;AkBj2xBE;EACE,qFAAA;AlBm2xBJ;AkBj2xBE;EAKE,gBAAA;AlB+1xBJ;;AmBxuxBA,iCAAA;AAGE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AnByuxBJ;AmBvuxBI;EACE,eAAA;AnByuxBN;AmBvuxBI;EACE,aAAA;AnByuxBN;AmBruxBE;EACE,kBAAA;AnBuuxBJ;AmBnuxBM;EACE,mBAAA;AnBquxBR;;AmB/txBA;EACE,eAAA;AnBkuxBF;;AoB58xBA;;8BAAA;AAGA,gBAAA;AAEA;EACE,yBjBmFiB;EiBlFjB,gBAAA;ApB88xBF;;AoB18xBE;EACE,cjByBY;AHo7xBhB;AoB18xBE;EACE,WjB2EkB;AHi4xBtB;;AoBx8xBA,eAAA;AAGE;EACE,WAAA;EACA,yBjBYY;EiBXZ,qBjBWY;AH87xBhB;;AoBt8xBA,mDAAA;AC7BA;;8BAAA;AAGA;EACE;IACE,2BAAA;ErBu+xBF;EqBp+xBA;IACE,wBAAA;ErBs+xBF;AACF;AqBn+xBA;EACE,YAAA;EACA,eAAA;EACA,yBlByEiB;EkBxEjB,gBAAA;EACA,iBAAA;ArBq+xBF;AqBn+xBE;EACE,yBlBgBY;EkBfZ,4CAAA;ArBq+xBJ;AqBh+xBM;EAEE,mBAAA;ArBi+xBR;AqBn+xBM;EAEE,mBAAA;ArBo+xBR;AqBt+xBM;EAEE,mBAAA;ArBu+xBR;AqBz+xBM;EAEE,mBAAA;ArB0+xBR;AqB5+xBM;EAEE,mBAAA;ArB6+xBR;AqBz+xBI;EACE,8DlBCQ;AH0+xBd;AqBx+xBI;EACE,8DlBFS;AH4+xBf;AqBt+xBM;EACE,oCAAA;ArBw+xBR;AqBz+xBM;EACE,oCAAA;ArB2+xBR;AqB5+xBM;EACE,oCAAA;ArB8+xBR;AqB/+xBM;EACE,oCAAA;ArBi/xBR;AqBl/xBM;EACE,oCAAA;ArBo/xBR;AqBr/xBM;EACE,oCAAA;ArBu/xBR;AqBx/xBM;EACE,oCAAA;ArB0/xBR;AqB3/xBM;EACE,oCAAA;ArB6/xBR;;AqBv/xBA,mCAAA;ACjDA;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AtB4iyBF;;AsBziyBA;EACE,cAAA;EACA,kBAAA;AtB4iyBF;AsB1iyBE;EACE,qBAAA;AtB4iyBJ;AsBziyBE;EACE,YAAA;AtB2iyBJ;;AsBviyBA,kEAAA;AAEA;EACE,mBAAA;AtByiyBF;AsBxiyBE;EACE,YAAA;EACA,WnB+De;AH2+xBnB;AsBziyBI;EACE,cnBQU;AHmiyBhB;AsBxiyBI;EACE,YAAA;AtB0iyBN;AsBtiyBE;;EAEE,YAAA;EACA,WnBmDkB;EmBlDlB,6CAAA;AtBwiyBJ;;AsBriyBA,uDAAA;AAEA;EACE,aAAA;EACA,sBAAA;EACA,4CAAA;AtBuiyBF;AsBtiyBE;EACE,kBAAA;AtBwiyBJ;AsBriyBE;;EAEE,WAAA;EACA,mBnBpBY;EmBqBZ,2CAAA;AtBuiyBJ;;AsBniyBA,+DAAA;AAGE;EACE,cAAA;EACA,kBAAA;AtBoiyBJ;;AsB/hyBE;EACE,aAAA;EACA,YAAA;EACA,kBAAA;AtBkiyBJ;;AsB/hyBA,kBAAA;AAEA,2DAAA;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,4CAAA;AtBgiyBF;AsB9hyBE;EACE,aAAA;AtBgiyBJ;AsB7hyBE;EACE,cAAA;AtB+hyBJ;;AuB3nyBA;;8BAAA;AAIA;;EAEE,YAAA;EACA,YAAA;EACA,eAAA;EACA,MAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,gCAAA;AvB6nyBF;AuB3nyBE;;EACE,2BAAA;AvB8nyBJ;AuB7nyBI;;EACE,0BAAA;AvBgoyBN;AuB5nyBE;;EACE,aAAA;EACA,gCAAA;AvB+nyBJ;AuB5nyBE;;EACE,eAAA;AvB+nyBJ;AuB5nyBE;;EACE,+CAAA;EACA,QAAA;AvB+nyBJ;;AuBznyBI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;AvB4nyBN;AuB1nyBM;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,cpBXQ;AHuoyBhB;AuBznyBM;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,+CAAA;AvB2nyBR;AuBtnyBM;EACE,6BAAA;AvBwnyBR;;AuBhnyBI;EAGE,gBAAA;EACA,aAAA;AvBinyBN;;AuB5myBA;EACE,kBAAA;AvB+myBF;AuB7myBE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AvB+myBJ;AuB7myBI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,wBAAA;EACA,WAAA;EACA,mBAAA;AvB+myBN;AuB5myBI;EACE,mBAAA;AvB8myBN;AuB3myBI;EACE,mBAAA;AvB6myBN;AuB1myBI;EACE,WAAA;EACA,qBAAA;AvB4myBN;AuBzmyBI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AvB2myBN;AuBzmyBM;EACE,eAAA;EACA,cAAA;AvB2myBR;AuBvmyBI;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,8DpB1GQ;AHmtyBd;;AuBnmyBE;EACE,kBAAA;EACA,kBAAA;AvBsmyBJ;AuBpmyBI;EACE,aAAA;AvBsmyBN;AuBnmyBI;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,eAAA;AvBqmyBN;AuBjmyBE;EACE,2BAAA;AvBmmyBJ;AuBhmyBE;EACE,YAAA;EACA,mBAAA;AvBkmyBJ;AuB/lyBE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AvBimyBJ;AuB/lyBI;EACE,gBAAA;EACA,YAAA;EACA,oBAAA;EACA,4CAAA;EACA,YAAA;EACA,+BAAA;EACA,wBAAA;AvBimyBN;AuB/lyBM;;EAEE,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;AvBimyBR;AuB5lyBQ;;;;EAGE,aAAA;EACA,gBAAA;AvB+lyBV;AuB3lyBM;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;AvB6lyBR;AuB3lyBQ;EACE,eAAA;AvB6lyBV;AuBzlyBM;EACE,6BAAA;EACA,aAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,WAAA;AvB2lyBR;AuBzlyBQ;EACE,eAAA;AvB2lyBV;AuBxlyBQ;EACE,WAAA;AvB0lyBV;AuBtlyBM;EACE,gCAAA;EACA,QAAA;AvBwlyBR;AuBrlyBM;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,6CAAA;AvBulyBR;;AuBhlyBE;EACE,+BAAA;EACA,6BAAA;EACA,8BAAA;AvBmlyBJ;AuBjlyBI;EACE,mBAAA;AvBmlyBN;AuBjlyBM;EACE,qBAAA;EACA,WAAA;EACA,kBAAA;AvBmlyBR;AuB7kyBM;;EACE,kBAAA;EACA,iBAAA;EACA,qBAAA;AvBglyBR;AuB9kyBQ;;EACE,kBAAA;AvBilyBV;AuB7kyBM;;EACE,sBAAA;AvBglyBR;AuB5kyBI;EACE,iBAAA;AvB8kyBN;AuB3kyBQ;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,4CAAA;AvB6kyBV;AuB3kyBU;EACE,2BAAA;EACA,4BAAA;AvB6kyBZ;AuB1kyBU;EACE,8BAAA;EACA,6BAAA;AvB4kyBZ;AuBxkyBQ;EACE,YAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,6CAAA;AvB0kyBV;AuBnkyBQ;EACE,8DpB5SI;EoB6SJ,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,4CAAA;AvBqkyBV;AuBnkyBU;EACE,yBAAA;EACA,6BAAA;AvBqkyBZ;AuBlkyBU;EACE,+BAAA;EACA,gCAAA;AvBokyBZ;AuBhkyBQ;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,8CAAA;AvBkkyBV;;AuB5jyBA,uBAAA;AAEA;EACE,oBAAA;AvB8jyBF;;AuB3jyBA,qBAAA;AACA,+BAAA;AAEA;EACE;IACE,cpBpUsB;EHi4yBxB;AACF;AwBz7yBA;;8BAAA;AAGA;EACE,0BAAA;AxB27yBF;;AwBx7yBA,gCAAA;ACDI;;;;;;;;;;;;;EAGE,yBAAA;EACA,UAAA;AzBu8yBN;AyBp8yBE;;;;;EACE,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;AzB08yBJ;;AyBj8yBE;;;;;EACE,UAAA;AzBw8yBJ;AyBv8yBI;;;;;;;;;EAEE,UAAA;AzBg9yBN;AyB78yBE;;;;;;;;;EAEE,YAAA;EACA,6BAAA;AzBs9yBJ;AyBn9yBI;;;;;;;;;EAEE,UAAA;AzB49yBN;;A0BrgzBA;EACE,wBAAA;A1BwgzBF;;A2BzgzBA;EACE,6BAAA;A3B4gzBF;;A4B5gzBE;EACE,YAAA;A5B+gzBJ;A4B9gzBI;EACE,oBAAA;A5BghzBN;A4B7gzBE;EACE,UAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;A5B+gzBJ;A4B9gzBI;EACE,uBAAA;A5BghzBN;A4B9gzBI;EAGE,qBAAA;A5B8gzBN;A4B1gzBI;EACE,gBAAA;A5B4gzBN;A4BxgzBE;EACE,mBAAA;A5B0gzBJ;;A6B/hzBA;EACE,cAAA;A7BkizBF;;A6B/hzBA;EACE,yBAAA;A7BkizBF;;A6B9hzBE;EACE,mBAAA;EACA,SAAA;EACA,iBAAA;A7BiizBJ;A6B9hzBE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;A7BgizBJ;;A6B5hzBA;EACE,qBAAA;A7B+hzBF;;A6B5hzBA;EACE,eAAA;A7B+hzBF;;A6B5hzBA;EACE,4BAAA;A7B+hzBF;;AAlkzBE;EACE,aAAA;AAqkzBJ;AAlkzBI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,+BAAA;AAokzBN;;AAhkzBA;EACE,WAAA;AAmkzBF;;AA/jzBE;EACE,UAAA;EACA,WAAA;EACA,YAAA;AAkkzBJ;AA/jzBE;EACE,QAAA;AAikzBJ;;AA7jzBA;EACE,kBAAA;AAgkzBF;;AA7jzBA;EAGM;;IAEE,cAAA;EA8jzBN;EA1jzBE;IACE,kBAAA;EA4jzBJ;EAxjzBA;IACE,mBAAA;EA0jzBF;AACF;AAvjzBA;EACE,qBAAA;EACA,aAAA;EACA,sBAAA;AAyjzBF;;AAvjzBA;EACE,gBAAA;AA0jzBF;;AAvjzBA;EACE,aAAA;AA0jzBF;;AAvjzBA;EACE,iBAAA;EACA,aAAA;AA0jzBF;;AAxjzBA;EACE;;IAEE,cAAA;IACA,WAAA;EA2jzBF;AACF;AAxjzBE;EACE,0BAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;AA0jzBJ;;AAtjzBA;EACE,mBGHiB;AH4jzBnB;;AAtjzBA;EACE,cGlCsB;AH2lzBxB;;AAtjzBA;;;EAGE,yBGxCsB;AHimzBxB;;AAtjzBA;EACE,6BAAA;AAyjzBF;;AAtjzBA;EACE;IACE,aAAA;EAyjzBF;EAtjzBA;IACE,mBG/DqB;EHunzBvB;EArjzBA;IACE,WGlEqB;EHynzBvB;EApjzBA;;;IAGE,sBGxEqB;EH8nzBvB;EAnjzBA;IACE,6BAAA;EAqjzBF;AACF;AAljzBA;EACE,gBAAA;AAojzBF;;AAhjzBE;EACE,uBAAA;EACA,YAAA;EACA,QAAA;EAKA,UAAA;AA+izBJ;AAnjzBI;EACE,gBAAA;EACA,kBAAA;AAqjzBN;AAjjzBE;;EAEE,mBG/GW;AHkqzBf;;AA/izBA;EACE,iBAAA;EACA,aAAA;AAkjzBF;;AAhjzBA;EACE,YAAA;EACA,qBAAA;AAmjzBF;;AAhjzBE;EACE,qBAAA;AAmjzBJ;;AAhjzBA;EACE,aAAA;AAmjzBF;;AA9izBI;EAFF;;IAGI,eAAA;IACA,kBAAA;EAmjzBJ;EAljzBI;;IACE,sBAAA;IACA,gBAAA;EAqjzBN;EApjzBM;;IACE,sCAAA;EAujzBR;EAtjzBQ;;IACE,gBAAA;EAyjzBV;EAtjzBM;;IACE,eAAA;IACA,2BAAA;IAAA,sBAAA;IACA,yBAAA;EAyjzBR;AACF;;AAnjzBA;EACE,aAAA;AAsjzBF;;AAnjzBA;EACE;;IAEE,YAAA;EAsjzBF;EArjzBE;;IACE,sCAAA;EAwjzBJ;EAtjzBE;;IACE,kBAAA;EAyjzBJ;EAtjzBI;;IACE,sBAAA;IACA,kBAAA;IACA,mBAAA;EAyjzBN;AACF;AApjzBE;EACE,eAAA;AAsjzBJ;;AAljzBE;EACE;IACE,wBAAA;EAqjzBJ;EAnjzBE;IACE,kBAAA;IACA,MAAA;IACA,OAAA;EAqjzBJ;AACF;;AAljzBA;;EAEE,sBAAA;AAqjzBF;;AAnjzBA;EACE,gBAAA;EACA,UAAA;AAsjzBF;;AApjzBA;EACE,kBAAA;EACA,UAAA;AAujzBF;;AArjzBA;EACE;IACE,iBAAA;EAwjzBF;AACF;AApjzBE;EACE,gBAAA;EACA,sBAAA;AAsjzBJ;;AAnjzBA;EACE;IACE,0BAAA;EAsjzBF;AACF;AApjzBA;EACE,gBAAA;AAsjzBF;;AAjjzBI;EACE,gBAAA;AAojzBN;;AA/izBE;EADF;IAEI,aAAA;EAmjzBF;AACF;;AAhjzBA;EACE,sBAAA;AAmjzBF","sourcesContent":["@import 'assets/scss/style.scss';\n\n.nav-outside.mob-backdrop {\n  &.mob-fixed .pcoded-navbar {\n    z-index: 1032;\n  }\n  ~ .pcoded-outside {\n    &:before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      z-index: 1031;\n      background: rgba(0, 0, 0, 0.25);\n    }\n  }\n}\n.pcoded-header .dropdown .notification .noti-body li {\n  width: 100%;\n}\n\n.header-chat .h-list-footer .input-group {\n  .btn-attach {\n    padding: 0;\n    width: 35px;\n    height: 35px;\n  }\n\n  .btn-send {\n    top: 7px;\n  }\n}\n\n.main-search {\n  padding: 16px 12px;\n}\n\n@media only screen and (max-width: 991px) {\n  .nav-outside {\n    ~ {\n      .pcoded-header,\n      .pcoded-main-container {\n        margin-left: 0;\n      }\n    }\n\n    &.mob-fixed ~ .pcoded-main-container {\n      padding-top: 142px;\n    }\n  }\n\n  .pcoded-header .navbar-nav > li:last-child {\n    padding-right: 35px;\n  }\n}\n\n.box {\n  display: inline-block;\n  padding: 10px;\n  box-sizing: border-box;\n}\n.img-preview {\n  overflow: hidden;\n}\n\n.img-preview-section-container {\n  display: none;\n}\n\n.carousel-inner {\n  overflow: visible;\n  z-index: 1050;\n}\n@media only screen and (max-width: 991px) {\n  .pcoded-header,\n  .pcoded-main-container {\n    margin-left: 0;\n    width: 100%;\n  }\n}\n.card-header .card-header-right {\n  .dropdown-menu.show {\n    transform: none !important;\n    right: 0 !important;\n    top: 100% !important;\n    left: auto !important;\n  }\n}\n\nheader.navbar.pcoded-header.navbar-expand-lg.header-default.headerpos-fixed {\n  background: $theme-background;\n}\n\nheader.navbar.pcoded-header.navbar-expand-lg.header-default.headerpos-fixed .b-brand .b-title {\n  color: $menu-light-text-color;\n}\n\nheader.navbar.pcoded-header.navbar-expand-lg.header-default.headerpos-fixed .mobile-menu span,\nheader.navbar.pcoded-header.navbar-expand-lg.header-default.headerpos-fixed .mobile-menu span:after,\nheader.navbar.pcoded-header.navbar-expand-lg.header-default.headerpos-fixed .mobile-menu span:before {\n  background-color: $menu-light-text-color;\n}\n\nheader.navbar.pcoded-header.navbar-expand-lg.header-default .mobile-menu.on span {\n  background-color: transparent;\n}\n\n@media only screen and (max-width: 991px) {\n  .pcoded-navbar {\n    z-index: 1072;\n  }\n\n  header.navbar.pcoded-header.navbar-expand-lg.header-default.headerpos-fixed {\n    background: $header-dark-background;\n  }\n\n  header.navbar.pcoded-header.navbar-expand-lg.header-default.headerpos-fixed .b-brand .b-title {\n    color: $header-dark-text-color;\n  }\n\n  header.navbar.pcoded-header.navbar-expand-lg.header-default.headerpos-fixed .mobile-menu span,\n  header.navbar.pcoded-header.navbar-expand-lg.header-default.headerpos-fixed .mobile-menu span:after,\n  header.navbar.pcoded-header.navbar-expand-lg.header-default.headerpos-fixed .mobile-menu span:before {\n    background-color: $header-dark-text-color;\n  }\n\n  header.navbar.pcoded-header.navbar-expand-lg.header-default .mobile-menu.on span {\n    background-color: transparent;\n  }\n}\n\n.user-activity .tab-content {\n  padding-top: 5px;\n}\n\n.rodal {\n  .rodal-dialog {\n    height: auto !important;\n    bottom: auto;\n    top: 25%;\n    .card {\n      box-shadow: none;\n      margin-bottom: 0px;\n    }\n    padding: 0;\n  }\n  .rodal-close:hover:before,\n  .rodal-close:hover:after {\n    background: $danger-color;\n  }\n}\n\n.carousel-inner {\n  overflow: visible;\n  z-index: 1050;\n}\n.form-control[type='file'] {\n  height: auto;\n  padding-left: 0.45rem;\n}\n.table {\n  .badge {\n    margin-right: 0.25rem;\n  }\n}\n.rdrInputRanges{\n  display: none;\n}\n.mb-3.row {\n  > .col,\n  .col.d-flex {\n    @media (max-width: 768px) {\n      margin-top: 5px;\n      margin-bottom: 5px;\n      &:nth-child(2) {\n        flex-direction: column;\n        text-align: left;\n        > span {\n          justify-content: flex-start !important;\n          .form-control {\n            max-width: 150px;\n          }\n        }\n        .btn {\n          margin-top: 8px;\n          max-width: fit-content;\n          margin-left: 0 !important;\n        }\n      }\n    }\n  }\n}\n\n.row.justify-content-between > .col > .d-flex.align-items-center strong {\n  margin: 0 5px;\n}\n\n@media (max-width: 575px) {\n  .row.justify-content-between > *[class*='col-'],\n  .row.justify-content-between > .col {\n    flex: 100%;\n    .pagination {\n      justify-content: flex-start !important;\n    }\n    &:first-child {\n      margin-bottom: 8px;\n    }\n    > .d-flex.align-items-center {\n      input {\n        width: 40px !important;\n        padding-left: 10px;\n        padding-right: 10px;\n      }\n    }\n  }\n}\ntd {\n  img.wid-40 {\n    max-width: 40px;\n  }\n}\n.new-cust-card {\n  @media (max-width: 1024px) {\n    .d-inline-block {\n      width: calc(100% - 55px);\n    }\n    .align-middle .status {\n      position: relative;\n      top: 0;\n      left: 0;\n    }\n  }\n}\n.table th,\n.table td {\n  vertical-align: middle;\n}\n.cover-img-block {\n  overflow: hidden;\n  z-index: 1;\n}\n.user-about-block {\n  position: relative;\n  z-index: 5;\n}\n@media only screen and (max-width: 1200px) {\n  .user-card .user-about-block {\n    margin-top: -10px;\n  }\n}\n\n.alert {\n  .float-right {\n    margin-left: 8px;\n    float: none !important;\n  }\n}\n@media (max-width: 768px) {\n  .modal-open .modal {\n    padding-left: 0 !important;\n  }\n}\n.carousel.slide {\n  overflow: hidden;\n}\n\n.table.table-bordered.table-hover {\n  th {\n    select.form-control {\n      min-width: 140px;\n    }\n  }\n}\n.photoshop-picker {\n  @media only screen and (max-width: 575px) {\n    display: none;\n  }\n}\n\n.css-1v494f5-Wrapper {\n  z-index: 20 !important;\n}\n","/**======================================================================\n=========================================================================\nTemplate Name: Datta Able Admin Template\nAuthor: Codedthemes\nsupports: https://codedthemes.support-hub.io/\nFile: style.css\n=========================================================================\n=========================================================================\n  == Table of Contents==\n\t- Generic classes\n\t\t-\tMargin, Padding, Font class, text align, position, floating, overflow, background class, text color, display class, boarder class\n\t- Theme Elements\n\t\t-\tAccordion, Button, tabs, typography, buttons, box shadow, Lable & Badges, Alert, Pagination, Breadcumb, Cards, Collapse,\n        -   Carousel, Grid, Progress, Model, tooltip, popover, Datepicker, Gridstack, lightbox, notification, Nestable, rating,\n        -   Rangeslider, Slider, Syntax Highlighter, Tour, Treeview, Toolbar, Session Timeout, Session idle Timeout, offline, Animation\n    - Forms\n        -   Forms Elements, Advance Form Control, Validation, Masking, Wizard, Picker, Select\n\t- Pages\n\t\t-   Chat, authentication, Maintenance, Maps, Landingpage messages, task, Todo, Notes, Charts, Icons, Gallery, Editors,\n        -   Invoice, Full Calender, File Upload,\n=================================================================================\n=================================================================================== */\n@import '~bootstrap/dist/css/bootstrap';\n// General theme contents\n@import 'partials/variables';\n@import 'partials/general';\n@import 'partials/generic';\n@import 'partials/mixins/function';\n\n// icon\n@import 'partials/font/next-icon';\n@import 'partials/font/feather';\n@import 'partials/font/fontawesome';\n@import 'partials/font/flaticon';\n@import 'partials/font/cryptofont';\n\n// important Element\n@import 'partials/menu/menu-lite';\n@import 'partials/widget/widget';\n\n// Theme Element\n@import 'partials/theme-elements/form';\n@import 'partials/theme-elements/radiobox-checkbox';\n@import 'partials/theme-elements/labels-badges';\n@import 'partials/theme-elements/data-tables';\n@import 'partials/theme-elements/authentication';\n@import 'partials/theme-elements/button';\n@import 'partials/theme-elements/breadcrumb-pagination';\n@import 'partials/theme-elements/progress';\n@import 'partials/theme-elements/nav';\n\n// Other\n@import 'partials/other/chat';\n@import 'partials/other/chart';\n\n@import 'partials/third-party/third-party';\n","@charset \"UTF-8\";\n/*!\n * Bootstrap  v5.3.3 (https://getbootstrap.com/)\n * Copyright 2011-2024 The Bootstrap Authors\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n:root,\n[data-bs-theme=light] {\n  --bs-blue: #0d6efd;\n  --bs-indigo: #6610f2;\n  --bs-purple: #6f42c1;\n  --bs-pink: #d63384;\n  --bs-red: #dc3545;\n  --bs-orange: #fd7e14;\n  --bs-yellow: #ffc107;\n  --bs-green: #198754;\n  --bs-teal: #20c997;\n  --bs-cyan: #0dcaf0;\n  --bs-black: #000;\n  --bs-white: #fff;\n  --bs-gray: #6c757d;\n  --bs-gray-dark: #343a40;\n  --bs-gray-100: #f8f9fa;\n  --bs-gray-200: #e9ecef;\n  --bs-gray-300: #dee2e6;\n  --bs-gray-400: #ced4da;\n  --bs-gray-500: #adb5bd;\n  --bs-gray-600: #6c757d;\n  --bs-gray-700: #495057;\n  --bs-gray-800: #343a40;\n  --bs-gray-900: #212529;\n  --bs-primary: #0d6efd;\n  --bs-secondary: #6c757d;\n  --bs-success: #198754;\n  --bs-info: #0dcaf0;\n  --bs-warning: #ffc107;\n  --bs-danger: #dc3545;\n  --bs-light: #f8f9fa;\n  --bs-dark: #212529;\n  --bs-primary-rgb: 13, 110, 253;\n  --bs-secondary-rgb: 108, 117, 125;\n  --bs-success-rgb: 25, 135, 84;\n  --bs-info-rgb: 13, 202, 240;\n  --bs-warning-rgb: 255, 193, 7;\n  --bs-danger-rgb: 220, 53, 69;\n  --bs-light-rgb: 248, 249, 250;\n  --bs-dark-rgb: 33, 37, 41;\n  --bs-primary-text-emphasis: #052c65;\n  --bs-secondary-text-emphasis: #2b2f32;\n  --bs-success-text-emphasis: #0a3622;\n  --bs-info-text-emphasis: #055160;\n  --bs-warning-text-emphasis: #664d03;\n  --bs-danger-text-emphasis: #58151c;\n  --bs-light-text-emphasis: #495057;\n  --bs-dark-text-emphasis: #495057;\n  --bs-primary-bg-subtle: #cfe2ff;\n  --bs-secondary-bg-subtle: #e2e3e5;\n  --bs-success-bg-subtle: #d1e7dd;\n  --bs-info-bg-subtle: #cff4fc;\n  --bs-warning-bg-subtle: #fff3cd;\n  --bs-danger-bg-subtle: #f8d7da;\n  --bs-light-bg-subtle: #fcfcfd;\n  --bs-dark-bg-subtle: #ced4da;\n  --bs-primary-border-subtle: #9ec5fe;\n  --bs-secondary-border-subtle: #c4c8cb;\n  --bs-success-border-subtle: #a3cfbb;\n  --bs-info-border-subtle: #9eeaf9;\n  --bs-warning-border-subtle: #ffe69c;\n  --bs-danger-border-subtle: #f1aeb5;\n  --bs-light-border-subtle: #e9ecef;\n  --bs-dark-border-subtle: #adb5bd;\n  --bs-white-rgb: 255, 255, 255;\n  --bs-black-rgb: 0, 0, 0;\n  --bs-font-sans-serif: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));\n  --bs-body-font-family: var(--bs-font-sans-serif);\n  --bs-body-font-size: 1rem;\n  --bs-body-font-weight: 400;\n  --bs-body-line-height: 1.5;\n  --bs-body-color: #212529;\n  --bs-body-color-rgb: 33, 37, 41;\n  --bs-body-bg: #fff;\n  --bs-body-bg-rgb: 255, 255, 255;\n  --bs-emphasis-color: #000;\n  --bs-emphasis-color-rgb: 0, 0, 0;\n  --bs-secondary-color: rgba(33, 37, 41, 0.75);\n  --bs-secondary-color-rgb: 33, 37, 41;\n  --bs-secondary-bg: #e9ecef;\n  --bs-secondary-bg-rgb: 233, 236, 239;\n  --bs-tertiary-color: rgba(33, 37, 41, 0.5);\n  --bs-tertiary-color-rgb: 33, 37, 41;\n  --bs-tertiary-bg: #f8f9fa;\n  --bs-tertiary-bg-rgb: 248, 249, 250;\n  --bs-heading-color: inherit;\n  --bs-link-color: #0d6efd;\n  --bs-link-color-rgb: 13, 110, 253;\n  --bs-link-decoration: underline;\n  --bs-link-hover-color: #0a58ca;\n  --bs-link-hover-color-rgb: 10, 88, 202;\n  --bs-code-color: #d63384;\n  --bs-highlight-color: #212529;\n  --bs-highlight-bg: #fff3cd;\n  --bs-border-width: 1px;\n  --bs-border-style: solid;\n  --bs-border-color: #dee2e6;\n  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);\n  --bs-border-radius: 0.375rem;\n  --bs-border-radius-sm: 0.25rem;\n  --bs-border-radius-lg: 0.5rem;\n  --bs-border-radius-xl: 1rem;\n  --bs-border-radius-xxl: 2rem;\n  --bs-border-radius-2xl: var(--bs-border-radius-xxl);\n  --bs-border-radius-pill: 50rem;\n  --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);\n  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);\n  --bs-focus-ring-width: 0.25rem;\n  --bs-focus-ring-opacity: 0.25;\n  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);\n  --bs-form-valid-color: #198754;\n  --bs-form-valid-border-color: #198754;\n  --bs-form-invalid-color: #dc3545;\n  --bs-form-invalid-border-color: #dc3545;\n}\n\n[data-bs-theme=dark] {\n  color-scheme: dark;\n  --bs-body-color: #dee2e6;\n  --bs-body-color-rgb: 222, 226, 230;\n  --bs-body-bg: #212529;\n  --bs-body-bg-rgb: 33, 37, 41;\n  --bs-emphasis-color: #fff;\n  --bs-emphasis-color-rgb: 255, 255, 255;\n  --bs-secondary-color: rgba(222, 226, 230, 0.75);\n  --bs-secondary-color-rgb: 222, 226, 230;\n  --bs-secondary-bg: #343a40;\n  --bs-secondary-bg-rgb: 52, 58, 64;\n  --bs-tertiary-color: rgba(222, 226, 230, 0.5);\n  --bs-tertiary-color-rgb: 222, 226, 230;\n  --bs-tertiary-bg: #2b3035;\n  --bs-tertiary-bg-rgb: 43, 48, 53;\n  --bs-primary-text-emphasis: #6ea8fe;\n  --bs-secondary-text-emphasis: #a7acb1;\n  --bs-success-text-emphasis: #75b798;\n  --bs-info-text-emphasis: #6edff6;\n  --bs-warning-text-emphasis: #ffda6a;\n  --bs-danger-text-emphasis: #ea868f;\n  --bs-light-text-emphasis: #f8f9fa;\n  --bs-dark-text-emphasis: #dee2e6;\n  --bs-primary-bg-subtle: #031633;\n  --bs-secondary-bg-subtle: #161719;\n  --bs-success-bg-subtle: #051b11;\n  --bs-info-bg-subtle: #032830;\n  --bs-warning-bg-subtle: #332701;\n  --bs-danger-bg-subtle: #2c0b0e;\n  --bs-light-bg-subtle: #343a40;\n  --bs-dark-bg-subtle: #1a1d20;\n  --bs-primary-border-subtle: #084298;\n  --bs-secondary-border-subtle: #41464b;\n  --bs-success-border-subtle: #0f5132;\n  --bs-info-border-subtle: #087990;\n  --bs-warning-border-subtle: #997404;\n  --bs-danger-border-subtle: #842029;\n  --bs-light-border-subtle: #495057;\n  --bs-dark-border-subtle: #343a40;\n  --bs-heading-color: inherit;\n  --bs-link-color: #6ea8fe;\n  --bs-link-hover-color: #8bb9fe;\n  --bs-link-color-rgb: 110, 168, 254;\n  --bs-link-hover-color-rgb: 139, 185, 254;\n  --bs-code-color: #e685b5;\n  --bs-highlight-color: #dee2e6;\n  --bs-highlight-bg: #664d03;\n  --bs-border-color: #495057;\n  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);\n  --bs-form-valid-color: #75b798;\n  --bs-form-valid-border-color: #75b798;\n  --bs-form-invalid-color: #ea868f;\n  --bs-form-invalid-border-color: #ea868f;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  :root {\n    scroll-behavior: smooth;\n  }\n}\n\nbody {\n  margin: 0;\n  font-family: var(--bs-body-font-family);\n  font-size: var(--bs-body-font-size);\n  font-weight: var(--bs-body-font-weight);\n  line-height: var(--bs-body-line-height);\n  color: var(--bs-body-color);\n  text-align: var(--bs-body-text-align);\n  background-color: var(--bs-body-bg);\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nhr {\n  margin: 1rem 0;\n  color: inherit;\n  border: 0;\n  border-top: var(--bs-border-width) solid;\n  opacity: 0.25;\n}\n\nh6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  line-height: 1.2;\n  color: var(--bs-heading-color);\n}\n\nh1, .h1 {\n  font-size: calc(1.375rem + 1.5vw);\n}\n@media (min-width: 1200px) {\n  h1, .h1 {\n    font-size: 2.5rem;\n  }\n}\n\nh2, .h2 {\n  font-size: calc(1.325rem + 0.9vw);\n}\n@media (min-width: 1200px) {\n  h2, .h2 {\n    font-size: 2rem;\n  }\n}\n\nh3, .h3 {\n  font-size: calc(1.3rem + 0.6vw);\n}\n@media (min-width: 1200px) {\n  h3, .h3 {\n    font-size: 1.75rem;\n  }\n}\n\nh4, .h4 {\n  font-size: calc(1.275rem + 0.3vw);\n}\n@media (min-width: 1200px) {\n  h4, .h4 {\n    font-size: 1.5rem;\n  }\n}\n\nh5, .h5 {\n  font-size: 1.25rem;\n}\n\nh6, .h6 {\n  font-size: 1rem;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nabbr[title] {\n  -webkit-text-decoration: underline dotted;\n  text-decoration: underline dotted;\n  cursor: help;\n  -webkit-text-decoration-skip-ink: none;\n  text-decoration-skip-ink: none;\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 700;\n}\n\ndd {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\nsmall, .small {\n  font-size: 0.875em;\n}\n\nmark, .mark {\n  padding: 0.1875em;\n  color: var(--bs-highlight-color);\n  background-color: var(--bs-highlight-bg);\n}\n\nsub,\nsup {\n  position: relative;\n  font-size: 0.75em;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\na {\n  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));\n  text-decoration: underline;\n}\na:hover {\n  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);\n}\n\na:not([href]):not([class]), a:not([href]):not([class]):hover {\n  color: inherit;\n  text-decoration: none;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: var(--bs-font-monospace);\n  font-size: 1em;\n}\n\npre {\n  display: block;\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  font-size: 0.875em;\n}\npre code {\n  font-size: inherit;\n  color: inherit;\n  word-break: normal;\n}\n\ncode {\n  font-size: 0.875em;\n  color: var(--bs-code-color);\n  word-wrap: break-word;\n}\na > code {\n  color: inherit;\n}\n\nkbd {\n  padding: 0.1875rem 0.375rem;\n  font-size: 0.875em;\n  color: var(--bs-body-bg);\n  background-color: var(--bs-body-color);\n  border-radius: 0.25rem;\n}\nkbd kbd {\n  padding: 0;\n  font-size: 1em;\n}\n\nfigure {\n  margin: 0 0 1rem;\n}\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  color: var(--bs-secondary-color);\n  text-align: left;\n}\n\nth {\n  text-align: inherit;\n  text-align: -webkit-match-parent;\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\nlabel {\n  display: inline-block;\n}\n\nbutton {\n  border-radius: 0;\n}\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n[role=button] {\n  cursor: pointer;\n}\n\nselect {\n  word-wrap: normal;\n}\nselect:disabled {\n  opacity: 1;\n}\n\n[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\nbutton,\n[type=button],\n[type=reset],\n[type=submit] {\n  -webkit-appearance: button;\n}\nbutton:not(:disabled),\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled) {\n  cursor: pointer;\n}\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ntextarea {\n  resize: vertical;\n}\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  float: left;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  font-size: calc(1.275rem + 0.3vw);\n  line-height: inherit;\n}\n@media (min-width: 1200px) {\n  legend {\n    font-size: 1.5rem;\n  }\n}\nlegend + * {\n  clear: left;\n}\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n[type=search] {\n  -webkit-appearance: textfield;\n  outline-offset: -2px;\n}\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n::-webkit-file-upload-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\n::file-selector-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\noutput {\n  display: inline-block;\n}\n\niframe {\n  border: 0;\n}\n\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n.lead {\n  font-size: 1.25rem;\n  font-weight: 300;\n}\n\n.display-1 {\n  font-size: calc(1.625rem + 4.5vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-1 {\n    font-size: 5rem;\n  }\n}\n\n.display-2 {\n  font-size: calc(1.575rem + 3.9vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-2 {\n    font-size: 4.5rem;\n  }\n}\n\n.display-3 {\n  font-size: calc(1.525rem + 3.3vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-3 {\n    font-size: 4rem;\n  }\n}\n\n.display-4 {\n  font-size: calc(1.475rem + 2.7vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-4 {\n    font-size: 3.5rem;\n  }\n}\n\n.display-5 {\n  font-size: calc(1.425rem + 2.1vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-5 {\n    font-size: 3rem;\n  }\n}\n\n.display-6 {\n  font-size: calc(1.375rem + 1.5vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-6 {\n    font-size: 2.5rem;\n  }\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline-item {\n  display: inline-block;\n}\n.list-inline-item:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.initialism {\n  font-size: 0.875em;\n  text-transform: uppercase;\n}\n\n.blockquote {\n  margin-bottom: 1rem;\n  font-size: 1.25rem;\n}\n.blockquote > :last-child {\n  margin-bottom: 0;\n}\n\n.blockquote-footer {\n  margin-top: -1rem;\n  margin-bottom: 1rem;\n  font-size: 0.875em;\n  color: #6c757d;\n}\n.blockquote-footer::before {\n  content: \"— \";\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: var(--bs-body-bg);\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n  max-width: 100%;\n  height: auto;\n}\n\n.figure {\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n\n.figure-caption {\n  font-size: 0.875em;\n  color: var(--bs-secondary-color);\n}\n\n.container,\n.container-fluid,\n.container-xxl,\n.container-xl,\n.container-lg,\n.container-md,\n.container-sm {\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@media (min-width: 576px) {\n  .container-sm, .container {\n    max-width: 540px;\n  }\n}\n@media (min-width: 768px) {\n  .container-md, .container-sm, .container {\n    max-width: 720px;\n  }\n}\n@media (min-width: 992px) {\n  .container-lg, .container-md, .container-sm, .container {\n    max-width: 960px;\n  }\n}\n@media (min-width: 1200px) {\n  .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1140px;\n  }\n}\n@media (min-width: 1400px) {\n  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1320px;\n  }\n}\n:root {\n  --bs-breakpoint-xs: 0;\n  --bs-breakpoint-sm: 576px;\n  --bs-breakpoint-md: 768px;\n  --bs-breakpoint-lg: 992px;\n  --bs-breakpoint-xl: 1200px;\n  --bs-breakpoint-xxl: 1400px;\n}\n\n.row {\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: calc(-1 * var(--bs-gutter-y));\n  margin-right: calc(-0.5 * var(--bs-gutter-x));\n  margin-left: calc(-0.5 * var(--bs-gutter-x));\n}\n.row > * {\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-top: var(--bs-gutter-y);\n}\n\n.col {\n  flex: 1 0 0%;\n}\n\n.row-cols-auto > * {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.row-cols-1 > * {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.row-cols-2 > * {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.row-cols-3 > * {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.row-cols-4 > * {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.row-cols-5 > * {\n  flex: 0 0 auto;\n  width: 20%;\n}\n\n.row-cols-6 > * {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.col-1 {\n  flex: 0 0 auto;\n  width: 8.33333333%;\n}\n\n.col-2 {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-3 {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.col-4 {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.col-5 {\n  flex: 0 0 auto;\n  width: 41.66666667%;\n}\n\n.col-6 {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.col-7 {\n  flex: 0 0 auto;\n  width: 58.33333333%;\n}\n\n.col-8 {\n  flex: 0 0 auto;\n  width: 66.66666667%;\n}\n\n.col-9 {\n  flex: 0 0 auto;\n  width: 75%;\n}\n\n.col-10 {\n  flex: 0 0 auto;\n  width: 83.33333333%;\n}\n\n.col-11 {\n  flex: 0 0 auto;\n  width: 91.66666667%;\n}\n\n.col-12 {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.offset-1 {\n  margin-left: 8.33333333%;\n}\n\n.offset-2 {\n  margin-left: 16.66666667%;\n}\n\n.offset-3 {\n  margin-left: 25%;\n}\n\n.offset-4 {\n  margin-left: 33.33333333%;\n}\n\n.offset-5 {\n  margin-left: 41.66666667%;\n}\n\n.offset-6 {\n  margin-left: 50%;\n}\n\n.offset-7 {\n  margin-left: 58.33333333%;\n}\n\n.offset-8 {\n  margin-left: 66.66666667%;\n}\n\n.offset-9 {\n  margin-left: 75%;\n}\n\n.offset-10 {\n  margin-left: 83.33333333%;\n}\n\n.offset-11 {\n  margin-left: 91.66666667%;\n}\n\n.g-0,\n.gx-0 {\n  --bs-gutter-x: 0;\n}\n\n.g-0,\n.gy-0 {\n  --bs-gutter-y: 0;\n}\n\n.g-1,\n.gx-1 {\n  --bs-gutter-x: 0.25rem;\n}\n\n.g-1,\n.gy-1 {\n  --bs-gutter-y: 0.25rem;\n}\n\n.g-2,\n.gx-2 {\n  --bs-gutter-x: 0.5rem;\n}\n\n.g-2,\n.gy-2 {\n  --bs-gutter-y: 0.5rem;\n}\n\n.g-3,\n.gx-3 {\n  --bs-gutter-x: 1rem;\n}\n\n.g-3,\n.gy-3 {\n  --bs-gutter-y: 1rem;\n}\n\n.g-4,\n.gx-4 {\n  --bs-gutter-x: 1.5rem;\n}\n\n.g-4,\n.gy-4 {\n  --bs-gutter-y: 1.5rem;\n}\n\n.g-5,\n.gx-5 {\n  --bs-gutter-x: 3rem;\n}\n\n.g-5,\n.gy-5 {\n  --bs-gutter-y: 3rem;\n}\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex: 1 0 0%;\n  }\n  .row-cols-sm-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-sm-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-sm-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-sm-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-sm-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-sm-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-sm-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-sm-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-sm-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-sm-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-sm-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-sm-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-sm-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-sm-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-sm-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-sm-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-sm-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-sm-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-sm-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-sm-0 {\n    margin-left: 0;\n  }\n  .offset-sm-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-sm-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-sm-3 {\n    margin-left: 25%;\n  }\n  .offset-sm-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-sm-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-sm-6 {\n    margin-left: 50%;\n  }\n  .offset-sm-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-sm-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-sm-9 {\n    margin-left: 75%;\n  }\n  .offset-sm-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-sm-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-sm-0,\n  .gx-sm-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-sm-0,\n  .gy-sm-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-sm-1,\n  .gx-sm-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-sm-1,\n  .gy-sm-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-sm-2,\n  .gx-sm-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-sm-2,\n  .gy-sm-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-sm-3,\n  .gx-sm-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-sm-3,\n  .gy-sm-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-sm-4,\n  .gx-sm-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-sm-4,\n  .gy-sm-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-sm-5,\n  .gx-sm-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-sm-5,\n  .gy-sm-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 768px) {\n  .col-md {\n    flex: 1 0 0%;\n  }\n  .row-cols-md-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-md-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-md-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-md-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-md-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-md-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-md-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-md-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-md-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-md-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-md-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-md-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-md-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-md-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-md-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-md-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-md-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-md-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-md-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-md-0 {\n    margin-left: 0;\n  }\n  .offset-md-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-md-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-md-3 {\n    margin-left: 25%;\n  }\n  .offset-md-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-md-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-md-6 {\n    margin-left: 50%;\n  }\n  .offset-md-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-md-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-md-9 {\n    margin-left: 75%;\n  }\n  .offset-md-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-md-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-md-0,\n  .gx-md-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-md-0,\n  .gy-md-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-md-1,\n  .gx-md-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-md-1,\n  .gy-md-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-md-2,\n  .gx-md-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-md-2,\n  .gy-md-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-md-3,\n  .gx-md-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-md-3,\n  .gy-md-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-md-4,\n  .gx-md-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-md-4,\n  .gy-md-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-md-5,\n  .gx-md-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-md-5,\n  .gy-md-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 992px) {\n  .col-lg {\n    flex: 1 0 0%;\n  }\n  .row-cols-lg-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-lg-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-lg-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-lg-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-lg-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-lg-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-lg-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-lg-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-lg-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-lg-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-lg-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-lg-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-lg-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-lg-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-lg-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-lg-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-lg-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-lg-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-lg-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-lg-0 {\n    margin-left: 0;\n  }\n  .offset-lg-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-lg-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-lg-3 {\n    margin-left: 25%;\n  }\n  .offset-lg-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-lg-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-lg-6 {\n    margin-left: 50%;\n  }\n  .offset-lg-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-lg-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-lg-9 {\n    margin-left: 75%;\n  }\n  .offset-lg-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-lg-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-lg-0,\n  .gx-lg-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-lg-0,\n  .gy-lg-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-lg-1,\n  .gx-lg-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-lg-1,\n  .gy-lg-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-lg-2,\n  .gx-lg-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-lg-2,\n  .gy-lg-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-lg-3,\n  .gx-lg-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-lg-3,\n  .gy-lg-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-lg-4,\n  .gx-lg-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-lg-4,\n  .gy-lg-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-lg-5,\n  .gx-lg-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-lg-5,\n  .gy-lg-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 1200px) {\n  .col-xl {\n    flex: 1 0 0%;\n  }\n  .row-cols-xl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xl-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-xl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xl-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xl-0 {\n    margin-left: 0;\n  }\n  .offset-xl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xl-3 {\n    margin-left: 25%;\n  }\n  .offset-xl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xl-6 {\n    margin-left: 50%;\n  }\n  .offset-xl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xl-9 {\n    margin-left: 75%;\n  }\n  .offset-xl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xl-0,\n  .gx-xl-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-xl-0,\n  .gy-xl-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-xl-1,\n  .gx-xl-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-xl-1,\n  .gy-xl-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-xl-2,\n  .gx-xl-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-xl-2,\n  .gy-xl-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-xl-3,\n  .gx-xl-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-xl-3,\n  .gy-xl-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-xl-4,\n  .gx-xl-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-xl-4,\n  .gy-xl-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-xl-5,\n  .gx-xl-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-xl-5,\n  .gy-xl-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 1400px) {\n  .col-xxl {\n    flex: 1 0 0%;\n  }\n  .row-cols-xxl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xxl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xxl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xxl-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-xxl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xxl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xxl-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xxl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xxl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xxl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xxl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xxl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xxl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xxl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xxl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xxl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xxl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xxl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xxl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xxl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xxl-0 {\n    margin-left: 0;\n  }\n  .offset-xxl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xxl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xxl-3 {\n    margin-left: 25%;\n  }\n  .offset-xxl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xxl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xxl-6 {\n    margin-left: 50%;\n  }\n  .offset-xxl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xxl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xxl-9 {\n    margin-left: 75%;\n  }\n  .offset-xxl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xxl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xxl-0,\n  .gx-xxl-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-xxl-0,\n  .gy-xxl-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-xxl-1,\n  .gx-xxl-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-xxl-1,\n  .gy-xxl-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-xxl-2,\n  .gx-xxl-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-xxl-2,\n  .gy-xxl-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-xxl-3,\n  .gx-xxl-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-xxl-3,\n  .gy-xxl-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-xxl-4,\n  .gx-xxl-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-xxl-4,\n  .gy-xxl-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-xxl-5,\n  .gx-xxl-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-xxl-5,\n  .gy-xxl-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n.table {\n  --bs-table-color-type: initial;\n  --bs-table-bg-type: initial;\n  --bs-table-color-state: initial;\n  --bs-table-bg-state: initial;\n  --bs-table-color: var(--bs-emphasis-color);\n  --bs-table-bg: var(--bs-body-bg);\n  --bs-table-border-color: var(--bs-border-color);\n  --bs-table-accent-bg: transparent;\n  --bs-table-striped-color: var(--bs-emphasis-color);\n  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);\n  --bs-table-active-color: var(--bs-emphasis-color);\n  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);\n  --bs-table-hover-color: var(--bs-emphasis-color);\n  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);\n  width: 100%;\n  margin-bottom: 1rem;\n  vertical-align: top;\n  border-color: var(--bs-table-border-color);\n}\n.table > :not(caption) > * > * {\n  padding: 0.5rem 0.5rem;\n  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));\n  background-color: var(--bs-table-bg);\n  border-bottom-width: var(--bs-border-width);\n  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));\n}\n.table > tbody {\n  vertical-align: inherit;\n}\n.table > thead {\n  vertical-align: bottom;\n}\n\n.table-group-divider {\n  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;\n}\n\n.caption-top {\n  caption-side: top;\n}\n\n.table-sm > :not(caption) > * > * {\n  padding: 0.25rem 0.25rem;\n}\n\n.table-bordered > :not(caption) > * {\n  border-width: var(--bs-border-width) 0;\n}\n.table-bordered > :not(caption) > * > * {\n  border-width: 0 var(--bs-border-width);\n}\n\n.table-borderless > :not(caption) > * > * {\n  border-bottom-width: 0;\n}\n.table-borderless > :not(:first-child) {\n  border-top-width: 0;\n}\n\n.table-striped > tbody > tr:nth-of-type(odd) > * {\n  --bs-table-color-type: var(--bs-table-striped-color);\n  --bs-table-bg-type: var(--bs-table-striped-bg);\n}\n\n.table-striped-columns > :not(caption) > tr > :nth-child(even) {\n  --bs-table-color-type: var(--bs-table-striped-color);\n  --bs-table-bg-type: var(--bs-table-striped-bg);\n}\n\n.table-active {\n  --bs-table-color-state: var(--bs-table-active-color);\n  --bs-table-bg-state: var(--bs-table-active-bg);\n}\n\n.table-hover > tbody > tr:hover > * {\n  --bs-table-color-state: var(--bs-table-hover-color);\n  --bs-table-bg-state: var(--bs-table-hover-bg);\n}\n\n.table-primary {\n  --bs-table-color: #000;\n  --bs-table-bg: #cfe2ff;\n  --bs-table-border-color: #a6b5cc;\n  --bs-table-striped-bg: #c5d7f2;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #bacbe6;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #bfd1ec;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-secondary {\n  --bs-table-color: #000;\n  --bs-table-bg: #e2e3e5;\n  --bs-table-border-color: #b5b6b7;\n  --bs-table-striped-bg: #d7d8da;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #cbccce;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #d1d2d4;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-success {\n  --bs-table-color: #000;\n  --bs-table-bg: #d1e7dd;\n  --bs-table-border-color: #a7b9b1;\n  --bs-table-striped-bg: #c7dbd2;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #bcd0c7;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #c1d6cc;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-info {\n  --bs-table-color: #000;\n  --bs-table-bg: #cff4fc;\n  --bs-table-border-color: #a6c3ca;\n  --bs-table-striped-bg: #c5e8ef;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #badce3;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #bfe2e9;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-warning {\n  --bs-table-color: #000;\n  --bs-table-bg: #fff3cd;\n  --bs-table-border-color: #ccc2a4;\n  --bs-table-striped-bg: #f2e7c3;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #e6dbb9;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #ece1be;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-danger {\n  --bs-table-color: #000;\n  --bs-table-bg: #f8d7da;\n  --bs-table-border-color: #c6acae;\n  --bs-table-striped-bg: #eccccf;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #dfc2c4;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #e5c7ca;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-light {\n  --bs-table-color: #000;\n  --bs-table-bg: #f8f9fa;\n  --bs-table-border-color: #c6c7c8;\n  --bs-table-striped-bg: #ecedee;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #dfe0e1;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #e5e6e7;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-dark {\n  --bs-table-color: #fff;\n  --bs-table-bg: #212529;\n  --bs-table-border-color: #4d5154;\n  --bs-table-striped-bg: #2c3034;\n  --bs-table-striped-color: #fff;\n  --bs-table-active-bg: #373b3e;\n  --bs-table-active-color: #fff;\n  --bs-table-hover-bg: #323539;\n  --bs-table-hover-color: #fff;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-responsive {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1399.98px) {\n  .table-responsive-xxl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n.form-label {\n  margin-bottom: 0.5rem;\n}\n\n.col-form-label {\n  padding-top: calc(0.375rem + var(--bs-border-width));\n  padding-bottom: calc(0.375rem + var(--bs-border-width));\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.5;\n}\n\n.col-form-label-lg {\n  padding-top: calc(0.5rem + var(--bs-border-width));\n  padding-bottom: calc(0.5rem + var(--bs-border-width));\n  font-size: 1.25rem;\n}\n\n.col-form-label-sm {\n  padding-top: calc(0.25rem + var(--bs-border-width));\n  padding-bottom: calc(0.25rem + var(--bs-border-width));\n  font-size: 0.875rem;\n}\n\n.form-text {\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: var(--bs-secondary-color);\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-color: var(--bs-body-bg);\n  background-clip: padding-box;\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control {\n    transition: none;\n  }\n}\n.form-control[type=file] {\n  overflow: hidden;\n}\n.form-control[type=file]:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control:focus {\n  color: var(--bs-body-color);\n  background-color: var(--bs-body-bg);\n  border-color: #86b7fe;\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.form-control::-webkit-date-and-time-value {\n  min-width: 85px;\n  height: 1.5em;\n  margin: 0;\n}\n.form-control::-webkit-datetime-edit {\n  display: block;\n  padding: 0;\n}\n.form-control::-moz-placeholder {\n  color: var(--bs-secondary-color);\n  opacity: 1;\n}\n.form-control::placeholder {\n  color: var(--bs-secondary-color);\n  opacity: 1;\n}\n.form-control:disabled {\n  background-color: var(--bs-secondary-bg);\n  opacity: 1;\n}\n.form-control::-webkit-file-upload-button {\n  padding: 0.375rem 0.75rem;\n  margin: -0.375rem -0.75rem;\n  -webkit-margin-end: 0.75rem;\n  margin-inline-end: 0.75rem;\n  color: var(--bs-body-color);\n  background-color: var(--bs-tertiary-bg);\n  pointer-events: none;\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n  border-inline-end-width: var(--bs-border-width);\n  border-radius: 0;\n  -webkit-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n.form-control::file-selector-button {\n  padding: 0.375rem 0.75rem;\n  margin: -0.375rem -0.75rem;\n  -webkit-margin-end: 0.75rem;\n  margin-inline-end: 0.75rem;\n  color: var(--bs-body-color);\n  background-color: var(--bs-tertiary-bg);\n  pointer-events: none;\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n  border-inline-end-width: var(--bs-border-width);\n  border-radius: 0;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control::-webkit-file-upload-button {\n    -webkit-transition: none;\n    transition: none;\n  }\n  .form-control::file-selector-button {\n    transition: none;\n  }\n}\n.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {\n  background-color: var(--bs-secondary-bg);\n}\n.form-control:hover:not(:disabled):not([readonly])::file-selector-button {\n  background-color: var(--bs-secondary-bg);\n}\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0;\n  margin-bottom: 0;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  background-color: transparent;\n  border: solid transparent;\n  border-width: var(--bs-border-width) 0;\n}\n.form-control-plaintext:focus {\n  outline: 0;\n}\n.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.form-control-sm {\n  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  border-radius: var(--bs-border-radius-sm);\n}\n.form-control-sm::-webkit-file-upload-button {\n  padding: 0.25rem 0.5rem;\n  margin: -0.25rem -0.5rem;\n  -webkit-margin-end: 0.5rem;\n  margin-inline-end: 0.5rem;\n}\n.form-control-sm::file-selector-button {\n  padding: 0.25rem 0.5rem;\n  margin: -0.25rem -0.5rem;\n  -webkit-margin-end: 0.5rem;\n  margin-inline-end: 0.5rem;\n}\n\n.form-control-lg {\n  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));\n  padding: 0.5rem 1rem;\n  font-size: 1.25rem;\n  border-radius: var(--bs-border-radius-lg);\n}\n.form-control-lg::-webkit-file-upload-button {\n  padding: 0.5rem 1rem;\n  margin: -0.5rem -1rem;\n  -webkit-margin-end: 1rem;\n  margin-inline-end: 1rem;\n}\n.form-control-lg::file-selector-button {\n  padding: 0.5rem 1rem;\n  margin: -0.5rem -1rem;\n  -webkit-margin-end: 1rem;\n  margin-inline-end: 1rem;\n}\n\ntextarea.form-control {\n  min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));\n}\ntextarea.form-control-sm {\n  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));\n}\ntextarea.form-control-lg {\n  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));\n}\n\n.form-control-color {\n  width: 3rem;\n  height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));\n  padding: 0.375rem;\n}\n.form-control-color:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control-color::-moz-color-swatch {\n  border: 0 !important;\n  border-radius: var(--bs-border-radius);\n}\n.form-control-color::-webkit-color-swatch {\n  border: 0 !important;\n  border-radius: var(--bs-border-radius);\n}\n.form-control-color.form-control-sm {\n  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));\n}\n.form-control-color.form-control-lg {\n  height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));\n}\n\n.form-select {\n  --bs-form-select-bg-img: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n  display: block;\n  width: 100%;\n  padding: 0.375rem 2.25rem 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-color: var(--bs-body-bg);\n  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: right 0.75rem center;\n  background-size: 16px 12px;\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-select {\n    transition: none;\n  }\n}\n.form-select:focus {\n  border-color: #86b7fe;\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.form-select[multiple], .form-select[size]:not([size=\"1\"]) {\n  padding-right: 0.75rem;\n  background-image: none;\n}\n.form-select:disabled {\n  background-color: var(--bs-secondary-bg);\n}\n.form-select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 var(--bs-body-color);\n}\n\n.form-select-sm {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  font-size: 0.875rem;\n  border-radius: var(--bs-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  padding-left: 1rem;\n  font-size: 1.25rem;\n  border-radius: var(--bs-border-radius-lg);\n}\n\n[data-bs-theme=dark] .form-select {\n  --bs-form-select-bg-img: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23dee2e6' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n}\n\n.form-check {\n  display: block;\n  min-height: 1.5rem;\n  padding-left: 1.5em;\n  margin-bottom: 0.125rem;\n}\n.form-check .form-check-input {\n  float: left;\n  margin-left: -1.5em;\n}\n\n.form-check-reverse {\n  padding-right: 1.5em;\n  padding-left: 0;\n  text-align: right;\n}\n.form-check-reverse .form-check-input {\n  float: right;\n  margin-right: -1.5em;\n  margin-left: 0;\n}\n\n.form-check-input {\n  --bs-form-check-bg: var(--bs-body-bg);\n  flex-shrink: 0;\n  width: 1em;\n  height: 1em;\n  margin-top: 0.25em;\n  vertical-align: top;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-color: var(--bs-form-check-bg);\n  background-image: var(--bs-form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  -webkit-print-color-adjust: exact;\n  color-adjust: exact;\n  print-color-adjust: exact;\n}\n.form-check-input[type=checkbox] {\n  border-radius: 0.25em;\n}\n.form-check-input[type=radio] {\n  border-radius: 50%;\n}\n.form-check-input:active {\n  filter: brightness(90%);\n}\n.form-check-input:focus {\n  border-color: #86b7fe;\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.form-check-input:checked {\n  background-color: #0d6efd;\n  border-color: #0d6efd;\n}\n.form-check-input:checked[type=checkbox] {\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e\");\n}\n.form-check-input:checked[type=radio] {\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23fff'/%3e%3c/svg%3e\");\n}\n.form-check-input[type=checkbox]:indeterminate {\n  background-color: #0d6efd;\n  border-color: #0d6efd;\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\");\n}\n.form-check-input:disabled {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.5;\n}\n.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {\n  cursor: default;\n  opacity: 0.5;\n}\n\n.form-switch {\n  padding-left: 2.5em;\n}\n.form-switch .form-check-input {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\");\n  width: 2em;\n  margin-left: -2.5em;\n  background-image: var(--bs-form-switch-bg);\n  background-position: left center;\n  border-radius: 2em;\n  transition: background-position 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-switch .form-check-input {\n    transition: none;\n  }\n}\n.form-switch .form-check-input:focus {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%2386b7fe'/%3e%3c/svg%3e\");\n}\n.form-switch .form-check-input:checked {\n  background-position: right center;\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\n}\n.form-switch.form-check-reverse {\n  padding-right: 2.5em;\n  padding-left: 0;\n}\n.form-switch.form-check-reverse .form-check-input {\n  margin-right: -2.5em;\n  margin-left: 0;\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: 1rem;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n.btn-check[disabled] + .btn, .btn-check:disabled + .btn {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.65;\n}\n\n[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%28255, 255, 255, 0.25%29'/%3e%3c/svg%3e\");\n}\n\n.form-range {\n  width: 100%;\n  height: 1.5rem;\n  padding: 0;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-color: transparent;\n}\n.form-range:focus {\n  outline: 0;\n}\n.form-range:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.form-range:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.form-range::-moz-focus-outer {\n  border: 0;\n}\n.form-range::-webkit-slider-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: -0.25rem;\n  -webkit-appearance: none;\n  appearance: none;\n  background-color: #0d6efd;\n  border: 0;\n  border-radius: 1rem;\n  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-webkit-slider-thumb {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n.form-range::-webkit-slider-thumb:active {\n  background-color: #b6d4fe;\n}\n.form-range::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: var(--bs-secondary-bg);\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.form-range::-moz-range-thumb {\n  width: 1rem;\n  height: 1rem;\n  -moz-appearance: none;\n  appearance: none;\n  background-color: #0d6efd;\n  border: 0;\n  border-radius: 1rem;\n  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-moz-range-thumb {\n    -moz-transition: none;\n    transition: none;\n  }\n}\n.form-range::-moz-range-thumb:active {\n  background-color: #b6d4fe;\n}\n.form-range::-moz-range-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: var(--bs-secondary-bg);\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.form-range:disabled {\n  pointer-events: none;\n}\n.form-range:disabled::-webkit-slider-thumb {\n  background-color: var(--bs-secondary-color);\n}\n.form-range:disabled::-moz-range-thumb {\n  background-color: var(--bs-secondary-color);\n}\n\n.form-floating {\n  position: relative;\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext,\n.form-floating > .form-select {\n  height: calc(3.5rem + calc(var(--bs-border-width) * 2));\n  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));\n  line-height: 1.25;\n}\n.form-floating > label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  height: 100%;\n  padding: 1rem 0.75rem;\n  overflow: hidden;\n  text-align: start;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  pointer-events: none;\n  border: var(--bs-border-width) solid transparent;\n  transform-origin: 0 0;\n  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-floating > label {\n    transition: none;\n  }\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext {\n  padding: 1rem 0.75rem;\n}\n.form-floating > .form-control::-moz-placeholder, .form-floating > .form-control-plaintext::-moz-placeholder {\n  color: transparent;\n}\n.form-floating > .form-control::placeholder,\n.form-floating > .form-control-plaintext::placeholder {\n  color: transparent;\n}\n.form-floating > .form-control:not(:-moz-placeholder-shown), .form-floating > .form-control-plaintext:not(:-moz-placeholder-shown) {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),\n.form-floating > .form-control-plaintext:focus,\n.form-floating > .form-control-plaintext:not(:placeholder-shown) {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:-webkit-autofill,\n.form-floating > .form-control-plaintext:-webkit-autofill {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-select {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:not(:-moz-placeholder-shown) ~ label {\n  color: rgba(var(--bs-body-color-rgb), 0.65);\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control:focus ~ label,\n.form-floating > .form-control:not(:placeholder-shown) ~ label,\n.form-floating > .form-control-plaintext ~ label,\n.form-floating > .form-select ~ label {\n  color: rgba(var(--bs-body-color-rgb), 0.65);\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control:not(:-moz-placeholder-shown) ~ label::after {\n  position: absolute;\n  inset: 1rem 0.375rem;\n  z-index: -1;\n  height: 1.5em;\n  content: \"\";\n  background-color: var(--bs-body-bg);\n  border-radius: var(--bs-border-radius);\n}\n.form-floating > .form-control:focus ~ label::after,\n.form-floating > .form-control:not(:placeholder-shown) ~ label::after,\n.form-floating > .form-control-plaintext ~ label::after,\n.form-floating > .form-select ~ label::after {\n  position: absolute;\n  inset: 1rem 0.375rem;\n  z-index: -1;\n  height: 1.5em;\n  content: \"\";\n  background-color: var(--bs-body-bg);\n  border-radius: var(--bs-border-radius);\n}\n.form-floating > .form-control:-webkit-autofill ~ label {\n  color: rgba(var(--bs-body-color-rgb), 0.65);\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control-plaintext ~ label {\n  border-width: var(--bs-border-width) 0;\n}\n.form-floating > :disabled ~ label,\n.form-floating > .form-control:disabled ~ label {\n  color: #6c757d;\n}\n.form-floating > :disabled ~ label::after,\n.form-floating > .form-control:disabled ~ label::after {\n  background-color: var(--bs-secondary-bg);\n}\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%;\n}\n.input-group > .form-control,\n.input-group > .form-select,\n.input-group > .form-floating {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n  min-width: 0;\n}\n.input-group > .form-control:focus,\n.input-group > .form-select:focus,\n.input-group > .form-floating:focus-within {\n  z-index: 5;\n}\n.input-group .btn {\n  position: relative;\n  z-index: 2;\n}\n.input-group .btn:focus {\n  z-index: 5;\n}\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--bs-tertiary-bg);\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: 0.5rem 1rem;\n  font-size: 1.25rem;\n  border-radius: var(--bs-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  border-radius: var(--bs-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: 3rem;\n}\n\n.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),\n.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,\n.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),\n.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,\n.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n  margin-left: calc(var(--bs-border-width) * -1);\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group > .form-floating:not(:first-child) > .form-control,\n.input-group > .form-floating:not(:first-child) > .form-select {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: var(--bs-form-valid-color);\n}\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.875rem;\n  color: #fff;\n  background-color: var(--bs-success);\n  border-radius: var(--bs-border-radius);\n}\n\n.was-validated :valid ~ .valid-feedback,\n.was-validated :valid ~ .valid-tooltip,\n.is-valid ~ .valid-feedback,\n.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:valid, .form-control.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-control:valid:focus, .form-control.is-valid:focus {\n  border-color: var(--bs-form-valid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n\n.was-validated textarea.form-control:valid, textarea.form-control.is-valid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);\n}\n\n.was-validated .form-select:valid, .form-select.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n}\n.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size=\"1\"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size=\"1\"] {\n  --bs-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  padding-right: 4.125rem;\n  background-position: right 0.75rem center, center right 2.25rem;\n  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-select:valid:focus, .form-select.is-valid:focus {\n  border-color: var(--bs-form-valid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n\n.was-validated .form-control-color:valid, .form-control-color.is-valid {\n  width: calc(3rem + calc(1.5em + 0.75rem));\n}\n\n.was-validated .form-check-input:valid, .form-check-input.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n}\n.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {\n  background-color: var(--bs-form-valid-color);\n}\n.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {\n  color: var(--bs-form-valid-color);\n}\n\n.form-check-inline .form-check-input ~ .valid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,\n.was-validated .input-group > .form-select:not(:focus):valid,\n.input-group > .form-select:not(:focus).is-valid,\n.was-validated .input-group > .form-floating:not(:focus-within):valid,\n.input-group > .form-floating:not(:focus-within).is-valid {\n  z-index: 3;\n}\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: var(--bs-form-invalid-color);\n}\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.875rem;\n  color: #fff;\n  background-color: var(--bs-danger);\n  border-radius: var(--bs-border-radius);\n}\n\n.was-validated :invalid ~ .invalid-feedback,\n.was-validated :invalid ~ .invalid-tooltip,\n.is-invalid ~ .invalid-feedback,\n.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:invalid, .form-control.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {\n  border-color: var(--bs-form-invalid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n\n.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);\n}\n\n.was-validated .form-select:invalid, .form-select.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n}\n.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size=\"1\"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size=\"1\"] {\n  --bs-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");\n  padding-right: 4.125rem;\n  background-position: right 0.75rem center, center right 2.25rem;\n  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {\n  border-color: var(--bs-form-invalid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n\n.was-validated .form-control-color:invalid, .form-control-color.is-invalid {\n  width: calc(3rem + calc(1.5em + 0.75rem));\n}\n\n.was-validated .form-check-input:invalid, .form-check-input.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n}\n.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {\n  background-color: var(--bs-form-invalid-color);\n}\n.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {\n  color: var(--bs-form-invalid-color);\n}\n\n.form-check-inline .form-check-input ~ .invalid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,\n.was-validated .input-group > .form-select:not(:focus):invalid,\n.input-group > .form-select:not(:focus).is-invalid,\n.was-validated .input-group > .form-floating:not(:focus-within):invalid,\n.input-group > .form-floating:not(:focus-within).is-invalid {\n  z-index: 4;\n}\n\n.btn {\n  --bs-btn-padding-x: 0.75rem;\n  --bs-btn-padding-y: 0.375rem;\n  --bs-btn-font-family: ;\n  --bs-btn-font-size: 1rem;\n  --bs-btn-font-weight: 400;\n  --bs-btn-line-height: 1.5;\n  --bs-btn-color: var(--bs-body-color);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-width: var(--bs-border-width);\n  --bs-btn-border-color: transparent;\n  --bs-btn-border-radius: var(--bs-border-radius);\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);\n  --bs-btn-disabled-opacity: 0.65;\n  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);\n  display: inline-block;\n  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);\n  font-family: var(--bs-btn-font-family);\n  font-size: var(--bs-btn-font-size);\n  font-weight: var(--bs-btn-font-weight);\n  line-height: var(--bs-btn-line-height);\n  color: var(--bs-btn-color);\n  text-align: center;\n  text-decoration: none;\n  vertical-align: middle;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);\n  border-radius: var(--bs-btn-border-radius);\n  background-color: var(--bs-btn-bg);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n}\n.btn:hover {\n  color: var(--bs-btn-hover-color);\n  background-color: var(--bs-btn-hover-bg);\n  border-color: var(--bs-btn-hover-border-color);\n}\n.btn-check + .btn:hover {\n  color: var(--bs-btn-color);\n  background-color: var(--bs-btn-bg);\n  border-color: var(--bs-btn-border-color);\n}\n.btn:focus-visible {\n  color: var(--bs-btn-hover-color);\n  background-color: var(--bs-btn-hover-bg);\n  border-color: var(--bs-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn-check:focus-visible + .btn {\n  border-color: var(--bs-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {\n  color: var(--bs-btn-active-color);\n  background-color: var(--bs-btn-active-bg);\n  border-color: var(--bs-btn-active-border-color);\n}\n.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn-check:checked:focus-visible + .btn {\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn:disabled, .btn.disabled, fieldset:disabled .btn {\n  color: var(--bs-btn-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-btn-disabled-bg);\n  border-color: var(--bs-btn-disabled-border-color);\n  opacity: var(--bs-btn-disabled-opacity);\n}\n\n.btn-primary {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #0d6efd;\n  --bs-btn-border-color: #0d6efd;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #0b5ed7;\n  --bs-btn-hover-border-color: #0a58ca;\n  --bs-btn-focus-shadow-rgb: 49, 132, 253;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #0a58ca;\n  --bs-btn-active-border-color: #0a53be;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #0d6efd;\n  --bs-btn-disabled-border-color: #0d6efd;\n}\n\n.btn-secondary {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #6c757d;\n  --bs-btn-border-color: #6c757d;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #5c636a;\n  --bs-btn-hover-border-color: #565e64;\n  --bs-btn-focus-shadow-rgb: 130, 138, 145;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #565e64;\n  --bs-btn-active-border-color: #51585e;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #6c757d;\n  --bs-btn-disabled-border-color: #6c757d;\n}\n\n.btn-success {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #198754;\n  --bs-btn-border-color: #198754;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #157347;\n  --bs-btn-hover-border-color: #146c43;\n  --bs-btn-focus-shadow-rgb: 60, 153, 110;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #146c43;\n  --bs-btn-active-border-color: #13653f;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #198754;\n  --bs-btn-disabled-border-color: #198754;\n}\n\n.btn-info {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #0dcaf0;\n  --bs-btn-border-color: #0dcaf0;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #31d2f2;\n  --bs-btn-hover-border-color: #25cff2;\n  --bs-btn-focus-shadow-rgb: 11, 172, 204;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #3dd5f3;\n  --bs-btn-active-border-color: #25cff2;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #0dcaf0;\n  --bs-btn-disabled-border-color: #0dcaf0;\n}\n\n.btn-warning {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #ffc107;\n  --bs-btn-border-color: #ffc107;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #ffca2c;\n  --bs-btn-hover-border-color: #ffc720;\n  --bs-btn-focus-shadow-rgb: 217, 164, 6;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #ffcd39;\n  --bs-btn-active-border-color: #ffc720;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #ffc107;\n  --bs-btn-disabled-border-color: #ffc107;\n}\n\n.btn-danger {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #dc3545;\n  --bs-btn-border-color: #dc3545;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #bb2d3b;\n  --bs-btn-hover-border-color: #b02a37;\n  --bs-btn-focus-shadow-rgb: 225, 83, 97;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #b02a37;\n  --bs-btn-active-border-color: #a52834;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #dc3545;\n  --bs-btn-disabled-border-color: #dc3545;\n}\n\n.btn-light {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #f8f9fa;\n  --bs-btn-border-color: #f8f9fa;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #d3d4d5;\n  --bs-btn-hover-border-color: #c6c7c8;\n  --bs-btn-focus-shadow-rgb: 211, 212, 213;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #c6c7c8;\n  --bs-btn-active-border-color: #babbbc;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #f8f9fa;\n  --bs-btn-disabled-border-color: #f8f9fa;\n}\n\n.btn-dark {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #212529;\n  --bs-btn-border-color: #212529;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #424649;\n  --bs-btn-hover-border-color: #373b3e;\n  --bs-btn-focus-shadow-rgb: 66, 70, 73;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #4d5154;\n  --bs-btn-active-border-color: #373b3e;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #212529;\n  --bs-btn-disabled-border-color: #212529;\n}\n\n.btn-outline-primary {\n  --bs-btn-color: #0d6efd;\n  --bs-btn-border-color: #0d6efd;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #0d6efd;\n  --bs-btn-hover-border-color: #0d6efd;\n  --bs-btn-focus-shadow-rgb: 13, 110, 253;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #0d6efd;\n  --bs-btn-active-border-color: #0d6efd;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #0d6efd;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #0d6efd;\n  --bs-gradient: none;\n}\n\n.btn-outline-secondary {\n  --bs-btn-color: #6c757d;\n  --bs-btn-border-color: #6c757d;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #6c757d;\n  --bs-btn-hover-border-color: #6c757d;\n  --bs-btn-focus-shadow-rgb: 108, 117, 125;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #6c757d;\n  --bs-btn-active-border-color: #6c757d;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #6c757d;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #6c757d;\n  --bs-gradient: none;\n}\n\n.btn-outline-success {\n  --bs-btn-color: #198754;\n  --bs-btn-border-color: #198754;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #198754;\n  --bs-btn-hover-border-color: #198754;\n  --bs-btn-focus-shadow-rgb: 25, 135, 84;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #198754;\n  --bs-btn-active-border-color: #198754;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #198754;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #198754;\n  --bs-gradient: none;\n}\n\n.btn-outline-info {\n  --bs-btn-color: #0dcaf0;\n  --bs-btn-border-color: #0dcaf0;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #0dcaf0;\n  --bs-btn-hover-border-color: #0dcaf0;\n  --bs-btn-focus-shadow-rgb: 13, 202, 240;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #0dcaf0;\n  --bs-btn-active-border-color: #0dcaf0;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #0dcaf0;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #0dcaf0;\n  --bs-gradient: none;\n}\n\n.btn-outline-warning {\n  --bs-btn-color: #ffc107;\n  --bs-btn-border-color: #ffc107;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #ffc107;\n  --bs-btn-hover-border-color: #ffc107;\n  --bs-btn-focus-shadow-rgb: 255, 193, 7;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #ffc107;\n  --bs-btn-active-border-color: #ffc107;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffc107;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #ffc107;\n  --bs-gradient: none;\n}\n\n.btn-outline-danger {\n  --bs-btn-color: #dc3545;\n  --bs-btn-border-color: #dc3545;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #dc3545;\n  --bs-btn-hover-border-color: #dc3545;\n  --bs-btn-focus-shadow-rgb: 220, 53, 69;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #dc3545;\n  --bs-btn-active-border-color: #dc3545;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #dc3545;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #dc3545;\n  --bs-gradient: none;\n}\n\n.btn-outline-light {\n  --bs-btn-color: #f8f9fa;\n  --bs-btn-border-color: #f8f9fa;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #f8f9fa;\n  --bs-btn-hover-border-color: #f8f9fa;\n  --bs-btn-focus-shadow-rgb: 248, 249, 250;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #f8f9fa;\n  --bs-btn-active-border-color: #f8f9fa;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #f8f9fa;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #f8f9fa;\n  --bs-gradient: none;\n}\n\n.btn-outline-dark {\n  --bs-btn-color: #212529;\n  --bs-btn-border-color: #212529;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #212529;\n  --bs-btn-hover-border-color: #212529;\n  --bs-btn-focus-shadow-rgb: 33, 37, 41;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #212529;\n  --bs-btn-active-border-color: #212529;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #212529;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #212529;\n  --bs-gradient: none;\n}\n\n.btn-link {\n  --bs-btn-font-weight: 400;\n  --bs-btn-color: var(--bs-link-color);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-color: transparent;\n  --bs-btn-hover-color: var(--bs-link-hover-color);\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-active-color: var(--bs-link-hover-color);\n  --bs-btn-active-border-color: transparent;\n  --bs-btn-disabled-color: #6c757d;\n  --bs-btn-disabled-border-color: transparent;\n  --bs-btn-box-shadow: 0 0 0 #000;\n  --bs-btn-focus-shadow-rgb: 49, 132, 253;\n  text-decoration: underline;\n}\n.btn-link:focus-visible {\n  color: var(--bs-btn-color);\n}\n.btn-link:hover {\n  color: var(--bs-btn-hover-color);\n}\n\n.btn-lg, .btn-group-lg > .btn {\n  --bs-btn-padding-y: 0.5rem;\n  --bs-btn-padding-x: 1rem;\n  --bs-btn-font-size: 1.25rem;\n  --bs-btn-border-radius: var(--bs-border-radius-lg);\n}\n\n.btn-sm, .btn-group-sm > .btn {\n  --bs-btn-padding-y: 0.25rem;\n  --bs-btn-padding-x: 0.5rem;\n  --bs-btn-font-size: 0.875rem;\n  --bs-btn-border-radius: var(--bs-border-radius-sm);\n}\n\n.fade {\n  transition: opacity 0.15s linear;\n}\n@media (prefers-reduced-motion: reduce) {\n  .fade {\n    transition: none;\n  }\n}\n.fade:not(.show) {\n  opacity: 0;\n}\n\n.collapse:not(.show) {\n  display: none;\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing {\n    transition: none;\n  }\n}\n.collapsing.collapse-horizontal {\n  width: 0;\n  height: auto;\n  transition: width 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing.collapse-horizontal {\n    transition: none;\n  }\n}\n\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n}\n.dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n}\n.dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropdown-menu {\n  --bs-dropdown-zindex: 1000;\n  --bs-dropdown-min-width: 10rem;\n  --bs-dropdown-padding-x: 0;\n  --bs-dropdown-padding-y: 0.5rem;\n  --bs-dropdown-spacer: 0.125rem;\n  --bs-dropdown-font-size: 1rem;\n  --bs-dropdown-color: var(--bs-body-color);\n  --bs-dropdown-bg: var(--bs-body-bg);\n  --bs-dropdown-border-color: var(--bs-border-color-translucent);\n  --bs-dropdown-border-radius: var(--bs-border-radius);\n  --bs-dropdown-border-width: var(--bs-border-width);\n  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));\n  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);\n  --bs-dropdown-divider-margin-y: 0.5rem;\n  --bs-dropdown-box-shadow: var(--bs-box-shadow);\n  --bs-dropdown-link-color: var(--bs-body-color);\n  --bs-dropdown-link-hover-color: var(--bs-body-color);\n  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);\n  --bs-dropdown-link-active-color: #fff;\n  --bs-dropdown-link-active-bg: #0d6efd;\n  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);\n  --bs-dropdown-item-padding-x: 1rem;\n  --bs-dropdown-item-padding-y: 0.25rem;\n  --bs-dropdown-header-color: #6c757d;\n  --bs-dropdown-header-padding-x: 1rem;\n  --bs-dropdown-header-padding-y: 0.5rem;\n  position: absolute;\n  z-index: var(--bs-dropdown-zindex);\n  display: none;\n  min-width: var(--bs-dropdown-min-width);\n  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);\n  margin: 0;\n  font-size: var(--bs-dropdown-font-size);\n  color: var(--bs-dropdown-color);\n  text-align: left;\n  list-style: none;\n  background-color: var(--bs-dropdown-bg);\n  background-clip: padding-box;\n  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);\n  border-radius: var(--bs-dropdown-border-radius);\n}\n.dropdown-menu[data-bs-popper] {\n  top: 100%;\n  left: 0;\n  margin-top: var(--bs-dropdown-spacer);\n}\n\n.dropdown-menu-start {\n  --bs-position: start;\n}\n.dropdown-menu-start[data-bs-popper] {\n  right: auto;\n  left: 0;\n}\n\n.dropdown-menu-end {\n  --bs-position: end;\n}\n.dropdown-menu-end[data-bs-popper] {\n  right: 0;\n  left: auto;\n}\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-sm-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-sm-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-sm-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 768px) {\n  .dropdown-menu-md-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-md-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-md-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-md-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 992px) {\n  .dropdown-menu-lg-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-lg-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-lg-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-lg-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1400px) {\n  .dropdown-menu-xxl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xxl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xxl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xxl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n.dropup .dropdown-menu[data-bs-popper] {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: var(--bs-dropdown-spacer);\n}\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0.3em solid;\n  border-left: 0.3em solid transparent;\n}\n.dropup .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropend .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: var(--bs-dropdown-spacer);\n}\n.dropend .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0;\n  border-bottom: 0.3em solid transparent;\n  border-left: 0.3em solid;\n}\n.dropend .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropend .dropdown-toggle::after {\n  vertical-align: 0;\n}\n\n.dropstart .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: var(--bs-dropdown-spacer);\n}\n.dropstart .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n}\n.dropstart .dropdown-toggle::after {\n  display: none;\n}\n.dropstart .dropdown-toggle::before {\n  display: inline-block;\n  margin-right: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0.3em solid;\n  border-bottom: 0.3em solid transparent;\n}\n.dropstart .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle::before {\n  vertical-align: 0;\n}\n\n.dropdown-divider {\n  height: 0;\n  margin: var(--bs-dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--bs-dropdown-divider-bg);\n  opacity: 1;\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n  clear: both;\n  font-weight: 400;\n  color: var(--bs-dropdown-link-color);\n  text-align: inherit;\n  text-decoration: none;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n  border-radius: var(--bs-dropdown-item-border-radius, 0);\n}\n.dropdown-item:hover, .dropdown-item:focus {\n  color: var(--bs-dropdown-link-hover-color);\n  background-color: var(--bs-dropdown-link-hover-bg);\n}\n.dropdown-item.active, .dropdown-item:active {\n  color: var(--bs-dropdown-link-active-color);\n  text-decoration: none;\n  background-color: var(--bs-dropdown-link-active-bg);\n}\n.dropdown-item.disabled, .dropdown-item:disabled {\n  color: var(--bs-dropdown-link-disabled-color);\n  pointer-events: none;\n  background-color: transparent;\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-header {\n  display: block;\n  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  color: var(--bs-dropdown-header-color);\n  white-space: nowrap;\n}\n\n.dropdown-item-text {\n  display: block;\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n  color: var(--bs-dropdown-link-color);\n}\n\n.dropdown-menu-dark {\n  --bs-dropdown-color: #dee2e6;\n  --bs-dropdown-bg: #343a40;\n  --bs-dropdown-border-color: var(--bs-border-color-translucent);\n  --bs-dropdown-box-shadow: ;\n  --bs-dropdown-link-color: #dee2e6;\n  --bs-dropdown-link-hover-color: #fff;\n  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);\n  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);\n  --bs-dropdown-link-active-color: #fff;\n  --bs-dropdown-link-active-bg: #0d6efd;\n  --bs-dropdown-link-disabled-color: #adb5bd;\n  --bs-dropdown-header-color: #adb5bd;\n}\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n  position: relative;\n  flex: 1 1 auto;\n}\n.btn-group > .btn-check:checked + .btn,\n.btn-group > .btn-check:focus + .btn,\n.btn-group > .btn:hover,\n.btn-group > .btn:focus,\n.btn-group > .btn:active,\n.btn-group > .btn.active,\n.btn-group-vertical > .btn-check:checked + .btn,\n.btn-group-vertical > .btn-check:focus + .btn,\n.btn-group-vertical > .btn:hover,\n.btn-group-vertical > .btn:focus,\n.btn-group-vertical > .btn:active,\n.btn-group-vertical > .btn.active {\n  z-index: 1;\n}\n\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n.btn-toolbar .input-group {\n  width: auto;\n}\n\n.btn-group {\n  border-radius: var(--bs-border-radius);\n}\n.btn-group > :not(.btn-check:first-child) + .btn,\n.btn-group > .btn-group:not(:first-child) {\n  margin-left: calc(var(--bs-border-width) * -1);\n}\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group > .btn.dropdown-toggle-split:first-child,\n.btn-group > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group > .btn:nth-child(n+3),\n.btn-group > :not(.btn-check) + .btn,\n.btn-group > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n  padding-right: 0.5625rem;\n  padding-left: 0.5625rem;\n}\n.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle-split::before {\n  margin-right: 0;\n}\n\n.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 0.375rem;\n  padding-left: 0.375rem;\n}\n\n.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 0.75rem;\n  padding-left: 0.75rem;\n}\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group {\n  width: 100%;\n}\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) {\n  margin-top: calc(var(--bs-border-width) * -1);\n}\n.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical > .btn-group:not(:last-child) > .btn {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn ~ .btn,\n.btn-group-vertical > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav {\n  --bs-nav-link-padding-x: 1rem;\n  --bs-nav-link-padding-y: 0.5rem;\n  --bs-nav-link-font-weight: ;\n  --bs-nav-link-color: var(--bs-link-color);\n  --bs-nav-link-hover-color: var(--bs-link-hover-color);\n  --bs-nav-link-disabled-color: var(--bs-secondary-color);\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);\n  font-size: var(--bs-nav-link-font-size);\n  font-weight: var(--bs-nav-link-font-weight);\n  color: var(--bs-nav-link-color);\n  text-decoration: none;\n  background: none;\n  border: 0;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .nav-link {\n    transition: none;\n  }\n}\n.nav-link:hover, .nav-link:focus {\n  color: var(--bs-nav-link-hover-color);\n}\n.nav-link:focus-visible {\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.nav-link.disabled, .nav-link:disabled {\n  color: var(--bs-nav-link-disabled-color);\n  pointer-events: none;\n  cursor: default;\n}\n\n.nav-tabs {\n  --bs-nav-tabs-border-width: var(--bs-border-width);\n  --bs-nav-tabs-border-color: var(--bs-border-color);\n  --bs-nav-tabs-border-radius: var(--bs-border-radius);\n  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);\n  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);\n  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);\n  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);\n  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);\n}\n.nav-tabs .nav-link {\n  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));\n  border: var(--bs-nav-tabs-border-width) solid transparent;\n  border-top-left-radius: var(--bs-nav-tabs-border-radius);\n  border-top-right-radius: var(--bs-nav-tabs-border-radius);\n}\n.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {\n  isolation: isolate;\n  border-color: var(--bs-nav-tabs-link-hover-border-color);\n}\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: var(--bs-nav-tabs-link-active-color);\n  background-color: var(--bs-nav-tabs-link-active-bg);\n  border-color: var(--bs-nav-tabs-link-active-border-color);\n}\n.nav-tabs .dropdown-menu {\n  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav-pills {\n  --bs-nav-pills-border-radius: var(--bs-border-radius);\n  --bs-nav-pills-link-active-color: #fff;\n  --bs-nav-pills-link-active-bg: #0d6efd;\n}\n.nav-pills .nav-link {\n  border-radius: var(--bs-nav-pills-border-radius);\n}\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: var(--bs-nav-pills-link-active-color);\n  background-color: var(--bs-nav-pills-link-active-bg);\n}\n\n.nav-underline {\n  --bs-nav-underline-gap: 1rem;\n  --bs-nav-underline-border-width: 0.125rem;\n  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);\n  gap: var(--bs-nav-underline-gap);\n}\n.nav-underline .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n  border-bottom: var(--bs-nav-underline-border-width) solid transparent;\n}\n.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {\n  border-bottom-color: currentcolor;\n}\n.nav-underline .nav-link.active,\n.nav-underline .show > .nav-link {\n  font-weight: 700;\n  color: var(--bs-nav-underline-link-active-color);\n  border-bottom-color: currentcolor;\n}\n\n.nav-fill > .nav-link,\n.nav-fill .nav-item {\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.nav-justified > .nav-link,\n.nav-justified .nav-item {\n  flex-basis: 0;\n  flex-grow: 1;\n  text-align: center;\n}\n\n.nav-fill .nav-item .nav-link,\n.nav-justified .nav-item .nav-link {\n  width: 100%;\n}\n\n.tab-content > .tab-pane {\n  display: none;\n}\n.tab-content > .active {\n  display: block;\n}\n\n.navbar {\n  --bs-navbar-padding-x: 0;\n  --bs-navbar-padding-y: 0.5rem;\n  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);\n  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);\n  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);\n  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);\n  --bs-navbar-brand-padding-y: 0.3125rem;\n  --bs-navbar-brand-margin-end: 1rem;\n  --bs-navbar-brand-font-size: 1.25rem;\n  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);\n  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);\n  --bs-navbar-nav-link-padding-x: 0.5rem;\n  --bs-navbar-toggler-padding-y: 0.25rem;\n  --bs-navbar-toggler-padding-x: 0.75rem;\n  --bs-navbar-toggler-font-size: 1.25rem;\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%2833, 37, 41, 0.75%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);\n  --bs-navbar-toggler-border-radius: var(--bs-border-radius);\n  --bs-navbar-toggler-focus-width: 0.25rem;\n  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);\n}\n.navbar > .container,\n.navbar > .container-fluid,\n.navbar > .container-sm,\n.navbar > .container-md,\n.navbar > .container-lg,\n.navbar > .container-xl,\n.navbar > .container-xxl {\n  display: flex;\n  flex-wrap: inherit;\n  align-items: center;\n  justify-content: space-between;\n}\n.navbar-brand {\n  padding-top: var(--bs-navbar-brand-padding-y);\n  padding-bottom: var(--bs-navbar-brand-padding-y);\n  margin-right: var(--bs-navbar-brand-margin-end);\n  font-size: var(--bs-navbar-brand-font-size);\n  color: var(--bs-navbar-brand-color);\n  text-decoration: none;\n  white-space: nowrap;\n}\n.navbar-brand:hover, .navbar-brand:focus {\n  color: var(--bs-navbar-brand-hover-color);\n}\n\n.navbar-nav {\n  --bs-nav-link-padding-x: 0;\n  --bs-nav-link-padding-y: 0.5rem;\n  --bs-nav-link-font-weight: ;\n  --bs-nav-link-color: var(--bs-navbar-color);\n  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);\n  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {\n  color: var(--bs-navbar-active-color);\n}\n.navbar-nav .dropdown-menu {\n  position: static;\n}\n\n.navbar-text {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  color: var(--bs-navbar-color);\n}\n.navbar-text a,\n.navbar-text a:hover,\n.navbar-text a:focus {\n  color: var(--bs-navbar-active-color);\n}\n\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  align-items: center;\n}\n\n.navbar-toggler {\n  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);\n  font-size: var(--bs-navbar-toggler-font-size);\n  line-height: 1;\n  color: var(--bs-navbar-color);\n  background-color: transparent;\n  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);\n  border-radius: var(--bs-navbar-toggler-border-radius);\n  transition: var(--bs-navbar-toggler-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .navbar-toggler {\n    transition: none;\n  }\n}\n.navbar-toggler:hover {\n  text-decoration: none;\n}\n.navbar-toggler:focus {\n  text-decoration: none;\n  outline: 0;\n  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);\n}\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--bs-navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--bs-scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-sm .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-sm .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-sm .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-sm .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-sm .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-sm .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-sm .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-sm .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-md .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-md .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-md .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-md .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-md .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-md .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-md .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-md .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-lg .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-lg .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-lg .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-lg .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-lg .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-lg .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-lg .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-xl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-xl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1400px) {\n  .navbar-expand-xxl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xxl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xxl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xxl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-xxl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xxl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xxl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xxl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-xxl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xxl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n.navbar-expand {\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n}\n.navbar-expand .navbar-nav {\n  flex-direction: row;\n}\n.navbar-expand .navbar-nav .dropdown-menu {\n  position: absolute;\n}\n.navbar-expand .navbar-nav .nav-link {\n  padding-right: var(--bs-navbar-nav-link-padding-x);\n  padding-left: var(--bs-navbar-nav-link-padding-x);\n}\n.navbar-expand .navbar-nav-scroll {\n  overflow: visible;\n}\n.navbar-expand .navbar-collapse {\n  display: flex !important;\n  flex-basis: auto;\n}\n.navbar-expand .navbar-toggler {\n  display: none;\n}\n.navbar-expand .offcanvas {\n  position: static;\n  z-index: auto;\n  flex-grow: 1;\n  width: auto !important;\n  height: auto !important;\n  visibility: visible !important;\n  background-color: transparent !important;\n  border: 0 !important;\n  transform: none !important;\n  transition: none;\n}\n.navbar-expand .offcanvas .offcanvas-header {\n  display: none;\n}\n.navbar-expand .offcanvas .offcanvas-body {\n  display: flex;\n  flex-grow: 0;\n  padding: 0;\n  overflow-y: visible;\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=dark] {\n  --bs-navbar-color: rgba(255, 255, 255, 0.55);\n  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);\n  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);\n  --bs-navbar-active-color: #fff;\n  --bs-navbar-brand-color: #fff;\n  --bs-navbar-brand-hover-color: #fff;\n  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n[data-bs-theme=dark] .navbar-toggler-icon {\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n.card {\n  --bs-card-spacer-y: 1rem;\n  --bs-card-spacer-x: 1rem;\n  --bs-card-title-spacer-y: 0.5rem;\n  --bs-card-title-color: ;\n  --bs-card-subtitle-color: ;\n  --bs-card-border-width: var(--bs-border-width);\n  --bs-card-border-color: var(--bs-border-color-translucent);\n  --bs-card-border-radius: var(--bs-border-radius);\n  --bs-card-box-shadow: ;\n  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));\n  --bs-card-cap-padding-y: 0.5rem;\n  --bs-card-cap-padding-x: 1rem;\n  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);\n  --bs-card-cap-color: ;\n  --bs-card-height: ;\n  --bs-card-color: ;\n  --bs-card-bg: var(--bs-body-bg);\n  --bs-card-img-overlay-padding: 1rem;\n  --bs-card-group-margin: 0.75rem;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  height: var(--bs-card-height);\n  color: var(--bs-body-color);\n  word-wrap: break-word;\n  background-color: var(--bs-card-bg);\n  background-clip: border-box;\n  border: var(--bs-card-border-width) solid var(--bs-card-border-color);\n  border-radius: var(--bs-card-border-radius);\n}\n.card > hr {\n  margin-right: 0;\n  margin-left: 0;\n}\n.card > .list-group {\n  border-top: inherit;\n  border-bottom: inherit;\n}\n.card > .list-group:first-child {\n  border-top-width: 0;\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n.card > .list-group:last-child {\n  border-bottom-width: 0;\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n.card > .card-header + .list-group,\n.card > .list-group + .card-footer {\n  border-top: 0;\n}\n\n.card-body {\n  flex: 1 1 auto;\n  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);\n  color: var(--bs-card-color);\n}\n\n.card-title {\n  margin-bottom: var(--bs-card-title-spacer-y);\n  color: var(--bs-card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));\n  margin-bottom: 0;\n  color: var(--bs-card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link + .card-link {\n  margin-left: var(--bs-card-spacer-x);\n}\n\n.card-header {\n  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n  margin-bottom: 0;\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n.card-header:first-child {\n  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;\n}\n\n.card-footer {\n  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n.card-footer:last-child {\n  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);\n}\n\n.card-header-tabs {\n  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));\n  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n  border-bottom: 0;\n}\n.card-header-tabs .nav-link.active {\n  background-color: var(--bs-card-bg);\n  border-bottom-color: var(--bs-card-bg);\n}\n\n.card-header-pills {\n  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n}\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--bs-card-img-overlay-padding);\n  border-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%;\n}\n\n.card-img,\n.card-img-top {\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-group > .card {\n  margin-bottom: var(--bs-card-group-margin);\n}\n@media (min-width: 576px) {\n  .card-group {\n    display: flex;\n    flex-flow: row wrap;\n  }\n  .card-group > .card {\n    flex: 1 0 0%;\n    margin-bottom: 0;\n  }\n  .card-group > .card + .card {\n    margin-left: 0;\n    border-left: 0;\n  }\n  .card-group > .card:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-top,\n  .card-group > .card:not(:last-child) .card-header {\n    border-top-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-bottom,\n  .card-group > .card:not(:last-child) .card-footer {\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-top,\n  .card-group > .card:not(:first-child) .card-header {\n    border-top-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-bottom,\n  .card-group > .card:not(:first-child) .card-footer {\n    border-bottom-left-radius: 0;\n  }\n}\n\n.accordion {\n  --bs-accordion-color: var(--bs-body-color);\n  --bs-accordion-bg: var(--bs-body-bg);\n  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;\n  --bs-accordion-border-color: var(--bs-border-color);\n  --bs-accordion-border-width: var(--bs-border-width);\n  --bs-accordion-border-radius: var(--bs-border-radius);\n  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));\n  --bs-accordion-btn-padding-x: 1.25rem;\n  --bs-accordion-btn-padding-y: 1rem;\n  --bs-accordion-btn-color: var(--bs-body-color);\n  --bs-accordion-btn-bg: var(--bs-accordion-bg);\n  --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='%23212529' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M2 5L8 11L14 5'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-icon-width: 1.25rem;\n  --bs-accordion-btn-icon-transform: rotate(-180deg);\n  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;\n  --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='%23052c65' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M2 5L8 11L14 5'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n  --bs-accordion-body-padding-x: 1.25rem;\n  --bs-accordion-body-padding-y: 1rem;\n  --bs-accordion-active-color: var(--bs-primary-text-emphasis);\n  --bs-accordion-active-bg: var(--bs-primary-bg-subtle);\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);\n  font-size: 1rem;\n  color: var(--bs-accordion-btn-color);\n  text-align: left;\n  background-color: var(--bs-accordion-btn-bg);\n  border: 0;\n  border-radius: 0;\n  overflow-anchor: none;\n  transition: var(--bs-accordion-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button {\n    transition: none;\n  }\n}\n.accordion-button:not(.collapsed) {\n  color: var(--bs-accordion-active-color);\n  background-color: var(--bs-accordion-active-bg);\n  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);\n}\n.accordion-button:not(.collapsed)::after {\n  background-image: var(--bs-accordion-btn-active-icon);\n  transform: var(--bs-accordion-btn-icon-transform);\n}\n.accordion-button::after {\n  flex-shrink: 0;\n  width: var(--bs-accordion-btn-icon-width);\n  height: var(--bs-accordion-btn-icon-width);\n  margin-left: auto;\n  content: \"\";\n  background-image: var(--bs-accordion-btn-icon);\n  background-repeat: no-repeat;\n  background-size: var(--bs-accordion-btn-icon-width);\n  transition: var(--bs-accordion-btn-icon-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button::after {\n    transition: none;\n  }\n}\n.accordion-button:hover {\n  z-index: 2;\n}\n.accordion-button:focus {\n  z-index: 3;\n  outline: 0;\n  box-shadow: var(--bs-accordion-btn-focus-box-shadow);\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--bs-accordion-color);\n  background-color: var(--bs-accordion-bg);\n  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);\n}\n.accordion-item:first-of-type {\n  border-top-left-radius: var(--bs-accordion-border-radius);\n  border-top-right-radius: var(--bs-accordion-border-radius);\n}\n.accordion-item:first-of-type > .accordion-header .accordion-button {\n  border-top-left-radius: var(--bs-accordion-inner-border-radius);\n  border-top-right-radius: var(--bs-accordion-inner-border-radius);\n}\n.accordion-item:not(:first-of-type) {\n  border-top: 0;\n}\n.accordion-item:last-of-type {\n  border-bottom-right-radius: var(--bs-accordion-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {\n  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);\n}\n.accordion-item:last-of-type > .accordion-collapse {\n  border-bottom-right-radius: var(--bs-accordion-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n\n.accordion-body {\n  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);\n}\n\n.accordion-flush > .accordion-item {\n  border-right: 0;\n  border-left: 0;\n  border-radius: 0;\n}\n.accordion-flush > .accordion-item:first-child {\n  border-top: 0;\n}\n.accordion-flush > .accordion-item:last-child {\n  border-bottom: 0;\n}\n.accordion-flush > .accordion-item > .accordion-header .accordion-button, .accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {\n  border-radius: 0;\n}\n.accordion-flush > .accordion-item > .accordion-collapse {\n  border-radius: 0;\n}\n\n[data-bs-theme=dark] .accordion-button::after {\n  --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%236ea8fe'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%236ea8fe'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n\n.breadcrumb {\n  --bs-breadcrumb-padding-x: 0;\n  --bs-breadcrumb-padding-y: 0;\n  --bs-breadcrumb-margin-bottom: 1rem;\n  --bs-breadcrumb-bg: ;\n  --bs-breadcrumb-border-radius: ;\n  --bs-breadcrumb-divider-color: var(--bs-secondary-color);\n  --bs-breadcrumb-item-padding-x: 0.5rem;\n  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);\n  margin-bottom: var(--bs-breadcrumb-margin-bottom);\n  font-size: var(--bs-breadcrumb-font-size);\n  list-style: none;\n  background-color: var(--bs-breadcrumb-bg);\n  border-radius: var(--bs-breadcrumb-border-radius);\n}\n\n.breadcrumb-item + .breadcrumb-item {\n  padding-left: var(--bs-breadcrumb-item-padding-x);\n}\n.breadcrumb-item + .breadcrumb-item::before {\n  float: left;\n  padding-right: var(--bs-breadcrumb-item-padding-x);\n  color: var(--bs-breadcrumb-divider-color);\n  content: var(--bs-breadcrumb-divider, \"/\") /* rtl: var(--bs-breadcrumb-divider, \"/\") */;\n}\n.breadcrumb-item.active {\n  color: var(--bs-breadcrumb-item-active-color);\n}\n\n.pagination {\n  --bs-pagination-padding-x: 0.75rem;\n  --bs-pagination-padding-y: 0.375rem;\n  --bs-pagination-font-size: 1rem;\n  --bs-pagination-color: var(--bs-link-color);\n  --bs-pagination-bg: var(--bs-body-bg);\n  --bs-pagination-border-width: var(--bs-border-width);\n  --bs-pagination-border-color: var(--bs-border-color);\n  --bs-pagination-border-radius: var(--bs-border-radius);\n  --bs-pagination-hover-color: var(--bs-link-hover-color);\n  --bs-pagination-hover-bg: var(--bs-tertiary-bg);\n  --bs-pagination-hover-border-color: var(--bs-border-color);\n  --bs-pagination-focus-color: var(--bs-link-hover-color);\n  --bs-pagination-focus-bg: var(--bs-secondary-bg);\n  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n  --bs-pagination-active-color: #fff;\n  --bs-pagination-active-bg: #0d6efd;\n  --bs-pagination-active-border-color: #0d6efd;\n  --bs-pagination-disabled-color: var(--bs-secondary-color);\n  --bs-pagination-disabled-bg: var(--bs-secondary-bg);\n  --bs-pagination-disabled-border-color: var(--bs-border-color);\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);\n  font-size: var(--bs-pagination-font-size);\n  color: var(--bs-pagination-color);\n  text-decoration: none;\n  background-color: var(--bs-pagination-bg);\n  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .page-link {\n    transition: none;\n  }\n}\n.page-link:hover {\n  z-index: 2;\n  color: var(--bs-pagination-hover-color);\n  background-color: var(--bs-pagination-hover-bg);\n  border-color: var(--bs-pagination-hover-border-color);\n}\n.page-link:focus {\n  z-index: 3;\n  color: var(--bs-pagination-focus-color);\n  background-color: var(--bs-pagination-focus-bg);\n  outline: 0;\n  box-shadow: var(--bs-pagination-focus-box-shadow);\n}\n.page-link.active, .active > .page-link {\n  z-index: 3;\n  color: var(--bs-pagination-active-color);\n  background-color: var(--bs-pagination-active-bg);\n  border-color: var(--bs-pagination-active-border-color);\n}\n.page-link.disabled, .disabled > .page-link {\n  color: var(--bs-pagination-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-pagination-disabled-bg);\n  border-color: var(--bs-pagination-disabled-border-color);\n}\n\n.page-item:not(:first-child) .page-link {\n  margin-left: calc(var(--bs-border-width) * -1);\n}\n.page-item:first-child .page-link {\n  border-top-left-radius: var(--bs-pagination-border-radius);\n  border-bottom-left-radius: var(--bs-pagination-border-radius);\n}\n.page-item:last-child .page-link {\n  border-top-right-radius: var(--bs-pagination-border-radius);\n  border-bottom-right-radius: var(--bs-pagination-border-radius);\n}\n\n.pagination-lg {\n  --bs-pagination-padding-x: 1.5rem;\n  --bs-pagination-padding-y: 0.75rem;\n  --bs-pagination-font-size: 1.25rem;\n  --bs-pagination-border-radius: var(--bs-border-radius-lg);\n}\n\n.pagination-sm {\n  --bs-pagination-padding-x: 0.5rem;\n  --bs-pagination-padding-y: 0.25rem;\n  --bs-pagination-font-size: 0.875rem;\n  --bs-pagination-border-radius: var(--bs-border-radius-sm);\n}\n\n.badge {\n  --bs-badge-padding-x: 0.65em;\n  --bs-badge-padding-y: 0.35em;\n  --bs-badge-font-size: 0.75em;\n  --bs-badge-font-weight: 700;\n  --bs-badge-color: #fff;\n  --bs-badge-border-radius: var(--bs-border-radius);\n  display: inline-block;\n  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);\n  font-size: var(--bs-badge-font-size);\n  font-weight: var(--bs-badge-font-weight);\n  line-height: 1;\n  color: var(--bs-badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: var(--bs-badge-border-radius);\n}\n.badge:empty {\n  display: none;\n}\n\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n.alert {\n  --bs-alert-bg: transparent;\n  --bs-alert-padding-x: 1rem;\n  --bs-alert-padding-y: 1rem;\n  --bs-alert-margin-bottom: 1rem;\n  --bs-alert-color: inherit;\n  --bs-alert-border-color: transparent;\n  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);\n  --bs-alert-border-radius: var(--bs-border-radius);\n  --bs-alert-link-color: inherit;\n  position: relative;\n  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);\n  margin-bottom: var(--bs-alert-margin-bottom);\n  color: var(--bs-alert-color);\n  background-color: var(--bs-alert-bg);\n  border: var(--bs-alert-border);\n  border-radius: var(--bs-alert-border-radius);\n}\n\n.alert-heading {\n  color: inherit;\n}\n\n.alert-link {\n  font-weight: 700;\n  color: var(--bs-alert-link-color);\n}\n\n.alert-dismissible {\n  padding-right: 3rem;\n}\n.alert-dismissible .btn-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  padding: 1.25rem 1rem;\n}\n\n.alert-primary {\n  --bs-alert-color: var(--bs-primary-text-emphasis);\n  --bs-alert-bg: var(--bs-primary-bg-subtle);\n  --bs-alert-border-color: var(--bs-primary-border-subtle);\n  --bs-alert-link-color: var(--bs-primary-text-emphasis);\n}\n\n.alert-secondary {\n  --bs-alert-color: var(--bs-secondary-text-emphasis);\n  --bs-alert-bg: var(--bs-secondary-bg-subtle);\n  --bs-alert-border-color: var(--bs-secondary-border-subtle);\n  --bs-alert-link-color: var(--bs-secondary-text-emphasis);\n}\n\n.alert-success {\n  --bs-alert-color: var(--bs-success-text-emphasis);\n  --bs-alert-bg: var(--bs-success-bg-subtle);\n  --bs-alert-border-color: var(--bs-success-border-subtle);\n  --bs-alert-link-color: var(--bs-success-text-emphasis);\n}\n\n.alert-info {\n  --bs-alert-color: var(--bs-info-text-emphasis);\n  --bs-alert-bg: var(--bs-info-bg-subtle);\n  --bs-alert-border-color: var(--bs-info-border-subtle);\n  --bs-alert-link-color: var(--bs-info-text-emphasis);\n}\n\n.alert-warning {\n  --bs-alert-color: var(--bs-warning-text-emphasis);\n  --bs-alert-bg: var(--bs-warning-bg-subtle);\n  --bs-alert-border-color: var(--bs-warning-border-subtle);\n  --bs-alert-link-color: var(--bs-warning-text-emphasis);\n}\n\n.alert-danger {\n  --bs-alert-color: var(--bs-danger-text-emphasis);\n  --bs-alert-bg: var(--bs-danger-bg-subtle);\n  --bs-alert-border-color: var(--bs-danger-border-subtle);\n  --bs-alert-link-color: var(--bs-danger-text-emphasis);\n}\n\n.alert-light {\n  --bs-alert-color: var(--bs-light-text-emphasis);\n  --bs-alert-bg: var(--bs-light-bg-subtle);\n  --bs-alert-border-color: var(--bs-light-border-subtle);\n  --bs-alert-link-color: var(--bs-light-text-emphasis);\n}\n\n.alert-dark {\n  --bs-alert-color: var(--bs-dark-text-emphasis);\n  --bs-alert-bg: var(--bs-dark-bg-subtle);\n  --bs-alert-border-color: var(--bs-dark-border-subtle);\n  --bs-alert-link-color: var(--bs-dark-text-emphasis);\n}\n\n@keyframes progress-bar-stripes {\n  0% {\n    background-position-x: 1rem;\n  }\n}\n.progress,\n.progress-stacked {\n  --bs-progress-height: 1rem;\n  --bs-progress-font-size: 0.75rem;\n  --bs-progress-bg: var(--bs-secondary-bg);\n  --bs-progress-border-radius: var(--bs-border-radius);\n  --bs-progress-box-shadow: var(--bs-box-shadow-inset);\n  --bs-progress-bar-color: #fff;\n  --bs-progress-bar-bg: #0d6efd;\n  --bs-progress-bar-transition: width 0.6s ease;\n  display: flex;\n  height: var(--bs-progress-height);\n  overflow: hidden;\n  font-size: var(--bs-progress-font-size);\n  background-color: var(--bs-progress-bg);\n  border-radius: var(--bs-progress-border-radius);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--bs-progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--bs-progress-bar-bg);\n  transition: var(--bs-progress-bar-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar {\n    transition: none;\n  }\n}\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: var(--bs-progress-height) var(--bs-progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n.progress-bar-animated {\n  animation: 1s linear infinite progress-bar-stripes;\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar-animated {\n    animation: none;\n  }\n}\n\n.list-group {\n  --bs-list-group-color: var(--bs-body-color);\n  --bs-list-group-bg: var(--bs-body-bg);\n  --bs-list-group-border-color: var(--bs-border-color);\n  --bs-list-group-border-width: var(--bs-border-width);\n  --bs-list-group-border-radius: var(--bs-border-radius);\n  --bs-list-group-item-padding-x: 1rem;\n  --bs-list-group-item-padding-y: 0.5rem;\n  --bs-list-group-action-color: var(--bs-secondary-color);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);\n  --bs-list-group-action-active-color: var(--bs-body-color);\n  --bs-list-group-action-active-bg: var(--bs-secondary-bg);\n  --bs-list-group-disabled-color: var(--bs-secondary-color);\n  --bs-list-group-disabled-bg: var(--bs-body-bg);\n  --bs-list-group-active-color: #fff;\n  --bs-list-group-active-bg: #0d6efd;\n  --bs-list-group-active-border-color: #0d6efd;\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  border-radius: var(--bs-list-group-border-radius);\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n}\n.list-group-numbered > .list-group-item::before {\n  content: counters(section, \".\") \". \";\n  counter-increment: section;\n}\n\n.list-group-item-action {\n  width: 100%;\n  color: var(--bs-list-group-action-color);\n  text-align: inherit;\n}\n.list-group-item-action:hover, .list-group-item-action:focus {\n  z-index: 1;\n  color: var(--bs-list-group-action-hover-color);\n  text-decoration: none;\n  background-color: var(--bs-list-group-action-hover-bg);\n}\n.list-group-item-action:active {\n  color: var(--bs-list-group-action-active-color);\n  background-color: var(--bs-list-group-action-active-bg);\n}\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);\n  color: var(--bs-list-group-color);\n  text-decoration: none;\n  background-color: var(--bs-list-group-bg);\n  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);\n}\n.list-group-item:first-child {\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n}\n.list-group-item:last-child {\n  border-bottom-right-radius: inherit;\n  border-bottom-left-radius: inherit;\n}\n.list-group-item.disabled, .list-group-item:disabled {\n  color: var(--bs-list-group-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-list-group-disabled-bg);\n}\n.list-group-item.active {\n  z-index: 2;\n  color: var(--bs-list-group-active-color);\n  background-color: var(--bs-list-group-active-bg);\n  border-color: var(--bs-list-group-active-border-color);\n}\n.list-group-item + .list-group-item {\n  border-top-width: 0;\n}\n.list-group-item + .list-group-item.active {\n  margin-top: calc(-1 * var(--bs-list-group-border-width));\n  border-top-width: var(--bs-list-group-border-width);\n}\n\n.list-group-horizontal {\n  flex-direction: row;\n}\n.list-group-horizontal > .list-group-item:first-child:not(:last-child) {\n  border-bottom-left-radius: var(--bs-list-group-border-radius);\n  border-top-right-radius: 0;\n}\n.list-group-horizontal > .list-group-item:last-child:not(:first-child) {\n  border-top-right-radius: var(--bs-list-group-border-radius);\n  border-bottom-left-radius: 0;\n}\n.list-group-horizontal > .list-group-item.active {\n  margin-top: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item {\n  border-top-width: var(--bs-list-group-border-width);\n  border-left-width: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item.active {\n  margin-left: calc(-1 * var(--bs-list-group-border-width));\n  border-left-width: var(--bs-list-group-border-width);\n}\n\n@media (min-width: 576px) {\n  .list-group-horizontal-sm {\n    flex-direction: row;\n  }\n  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 768px) {\n  .list-group-horizontal-md {\n    flex-direction: row;\n  }\n  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 992px) {\n  .list-group-horizontal-lg {\n    flex-direction: row;\n  }\n  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 1200px) {\n  .list-group-horizontal-xl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 1400px) {\n  .list-group-horizontal-xxl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n.list-group-flush {\n  border-radius: 0;\n}\n.list-group-flush > .list-group-item {\n  border-width: 0 0 var(--bs-list-group-border-width);\n}\n.list-group-flush > .list-group-item:last-child {\n  border-bottom-width: 0;\n}\n\n.list-group-item-primary {\n  --bs-list-group-color: var(--bs-primary-text-emphasis);\n  --bs-list-group-bg: var(--bs-primary-bg-subtle);\n  --bs-list-group-border-color: var(--bs-primary-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);\n  --bs-list-group-active-color: var(--bs-primary-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);\n}\n\n.list-group-item-secondary {\n  --bs-list-group-color: var(--bs-secondary-text-emphasis);\n  --bs-list-group-bg: var(--bs-secondary-bg-subtle);\n  --bs-list-group-border-color: var(--bs-secondary-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);\n  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);\n}\n\n.list-group-item-success {\n  --bs-list-group-color: var(--bs-success-text-emphasis);\n  --bs-list-group-bg: var(--bs-success-bg-subtle);\n  --bs-list-group-border-color: var(--bs-success-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);\n  --bs-list-group-active-color: var(--bs-success-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-success-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);\n}\n\n.list-group-item-info {\n  --bs-list-group-color: var(--bs-info-text-emphasis);\n  --bs-list-group-bg: var(--bs-info-bg-subtle);\n  --bs-list-group-border-color: var(--bs-info-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);\n  --bs-list-group-active-color: var(--bs-info-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-info-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);\n}\n\n.list-group-item-warning {\n  --bs-list-group-color: var(--bs-warning-text-emphasis);\n  --bs-list-group-bg: var(--bs-warning-bg-subtle);\n  --bs-list-group-border-color: var(--bs-warning-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);\n  --bs-list-group-active-color: var(--bs-warning-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);\n}\n\n.list-group-item-danger {\n  --bs-list-group-color: var(--bs-danger-text-emphasis);\n  --bs-list-group-bg: var(--bs-danger-bg-subtle);\n  --bs-list-group-border-color: var(--bs-danger-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);\n  --bs-list-group-active-color: var(--bs-danger-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);\n}\n\n.list-group-item-light {\n  --bs-list-group-color: var(--bs-light-text-emphasis);\n  --bs-list-group-bg: var(--bs-light-bg-subtle);\n  --bs-list-group-border-color: var(--bs-light-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);\n  --bs-list-group-active-color: var(--bs-light-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-light-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);\n}\n\n.list-group-item-dark {\n  --bs-list-group-color: var(--bs-dark-text-emphasis);\n  --bs-list-group-bg: var(--bs-dark-bg-subtle);\n  --bs-list-group-border-color: var(--bs-dark-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);\n  --bs-list-group-active-color: var(--bs-dark-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);\n}\n\n.btn-close {\n  --bs-btn-close-color: #000;\n  --bs-btn-close-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e\");\n  --bs-btn-close-opacity: 0.5;\n  --bs-btn-close-hover-opacity: 0.75;\n  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n  --bs-btn-close-focus-opacity: 1;\n  --bs-btn-close-disabled-opacity: 0.25;\n  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);\n  box-sizing: content-box;\n  width: 1em;\n  height: 1em;\n  padding: 0.25em 0.25em;\n  color: var(--bs-btn-close-color);\n  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;\n  border: 0;\n  border-radius: 0.375rem;\n  opacity: var(--bs-btn-close-opacity);\n}\n.btn-close:hover {\n  color: var(--bs-btn-close-color);\n  text-decoration: none;\n  opacity: var(--bs-btn-close-hover-opacity);\n}\n.btn-close:focus {\n  outline: 0;\n  box-shadow: var(--bs-btn-close-focus-shadow);\n  opacity: var(--bs-btn-close-focus-opacity);\n}\n.btn-close:disabled, .btn-close.disabled {\n  pointer-events: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  opacity: var(--bs-btn-close-disabled-opacity);\n}\n\n.btn-close-white {\n  filter: var(--bs-btn-close-white-filter);\n}\n\n[data-bs-theme=dark] .btn-close {\n  filter: var(--bs-btn-close-white-filter);\n}\n\n.toast {\n  --bs-toast-zindex: 1090;\n  --bs-toast-padding-x: 0.75rem;\n  --bs-toast-padding-y: 0.5rem;\n  --bs-toast-spacing: 1.5rem;\n  --bs-toast-max-width: 350px;\n  --bs-toast-font-size: 0.875rem;\n  --bs-toast-color: ;\n  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);\n  --bs-toast-border-width: var(--bs-border-width);\n  --bs-toast-border-color: var(--bs-border-color-translucent);\n  --bs-toast-border-radius: var(--bs-border-radius);\n  --bs-toast-box-shadow: var(--bs-box-shadow);\n  --bs-toast-header-color: var(--bs-secondary-color);\n  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);\n  --bs-toast-header-border-color: var(--bs-border-color-translucent);\n  width: var(--bs-toast-max-width);\n  max-width: 100%;\n  font-size: var(--bs-toast-font-size);\n  color: var(--bs-toast-color);\n  pointer-events: auto;\n  background-color: var(--bs-toast-bg);\n  background-clip: padding-box;\n  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);\n  box-shadow: var(--bs-toast-box-shadow);\n  border-radius: var(--bs-toast-border-radius);\n}\n.toast.showing {\n  opacity: 0;\n}\n.toast:not(.show) {\n  display: none;\n}\n\n.toast-container {\n  --bs-toast-zindex: 1090;\n  position: absolute;\n  z-index: var(--bs-toast-zindex);\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n}\n.toast-container > :not(:last-child) {\n  margin-bottom: var(--bs-toast-spacing);\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);\n  color: var(--bs-toast-header-color);\n  background-color: var(--bs-toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);\n  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n}\n.toast-header .btn-close {\n  margin-right: calc(-0.5 * var(--bs-toast-padding-x));\n  margin-left: var(--bs-toast-padding-x);\n}\n\n.toast-body {\n  padding: var(--bs-toast-padding-x);\n  word-wrap: break-word;\n}\n\n.modal {\n  --bs-modal-zindex: 1055;\n  --bs-modal-width: 500px;\n  --bs-modal-padding: 1rem;\n  --bs-modal-margin: 0.5rem;\n  --bs-modal-color: ;\n  --bs-modal-bg: var(--bs-body-bg);\n  --bs-modal-border-color: var(--bs-border-color-translucent);\n  --bs-modal-border-width: var(--bs-border-width);\n  --bs-modal-border-radius: var(--bs-border-radius-lg);\n  --bs-modal-box-shadow: var(--bs-box-shadow-sm);\n  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));\n  --bs-modal-header-padding-x: 1rem;\n  --bs-modal-header-padding-y: 1rem;\n  --bs-modal-header-padding: 1rem 1rem;\n  --bs-modal-header-border-color: var(--bs-border-color);\n  --bs-modal-header-border-width: var(--bs-border-width);\n  --bs-modal-title-line-height: 1.5;\n  --bs-modal-footer-gap: 0.5rem;\n  --bs-modal-footer-bg: ;\n  --bs-modal-footer-border-color: var(--bs-border-color);\n  --bs-modal-footer-border-width: var(--bs-border-width);\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  outline: 0;\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--bs-modal-margin);\n  pointer-events: none;\n}\n.modal.fade .modal-dialog {\n  transition: transform 0.3s ease-out;\n  transform: translate(0, -50px);\n}\n@media (prefers-reduced-motion: reduce) {\n  .modal.fade .modal-dialog {\n    transition: none;\n  }\n}\n.modal.show .modal-dialog {\n  transform: none;\n}\n.modal.modal-static .modal-dialog {\n  transform: scale(1.02);\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--bs-modal-margin) * 2);\n}\n.modal-dialog-scrollable .modal-content {\n  max-height: 100%;\n  overflow: hidden;\n}\n.modal-dialog-scrollable .modal-body {\n  overflow-y: auto;\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--bs-modal-margin) * 2);\n}\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  color: var(--bs-modal-color);\n  pointer-events: auto;\n  background-color: var(--bs-modal-bg);\n  background-clip: padding-box;\n  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);\n  border-radius: var(--bs-modal-border-radius);\n  outline: 0;\n}\n\n.modal-backdrop {\n  --bs-backdrop-zindex: 1050;\n  --bs-backdrop-bg: #000;\n  --bs-backdrop-opacity: 0.5;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-backdrop-zindex);\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--bs-backdrop-bg);\n}\n.modal-backdrop.fade {\n  opacity: 0;\n}\n.modal-backdrop.show {\n  opacity: var(--bs-backdrop-opacity);\n}\n\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--bs-modal-header-padding);\n  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);\n  border-top-left-radius: var(--bs-modal-inner-border-radius);\n  border-top-right-radius: var(--bs-modal-inner-border-radius);\n}\n.modal-header .btn-close {\n  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);\n  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--bs-modal-title-line-height);\n}\n\n.modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: var(--bs-modal-padding);\n}\n\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);\n  background-color: var(--bs-modal-footer-bg);\n  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);\n  border-bottom-right-radius: var(--bs-modal-inner-border-radius);\n  border-bottom-left-radius: var(--bs-modal-inner-border-radius);\n}\n.modal-footer > * {\n  margin: calc(var(--bs-modal-footer-gap) * 0.5);\n}\n\n@media (min-width: 576px) {\n  .modal {\n    --bs-modal-margin: 1.75rem;\n    --bs-modal-box-shadow: var(--bs-box-shadow);\n  }\n  .modal-dialog {\n    max-width: var(--bs-modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n  .modal-sm {\n    --bs-modal-width: 300px;\n  }\n}\n@media (min-width: 992px) {\n  .modal-lg,\n  .modal-xl {\n    --bs-modal-width: 800px;\n  }\n}\n@media (min-width: 1200px) {\n  .modal-xl {\n    --bs-modal-width: 1140px;\n  }\n}\n.modal-fullscreen {\n  width: 100vw;\n  max-width: none;\n  height: 100%;\n  margin: 0;\n}\n.modal-fullscreen .modal-content {\n  height: 100%;\n  border: 0;\n  border-radius: 0;\n}\n.modal-fullscreen .modal-header,\n.modal-fullscreen .modal-footer {\n  border-radius: 0;\n}\n.modal-fullscreen .modal-body {\n  overflow-y: auto;\n}\n\n@media (max-width: 575.98px) {\n  .modal-fullscreen-sm-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-sm-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-header,\n  .modal-fullscreen-sm-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 767.98px) {\n  .modal-fullscreen-md-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-md-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-header,\n  .modal-fullscreen-md-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 991.98px) {\n  .modal-fullscreen-lg-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-lg-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-header,\n  .modal-fullscreen-lg-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1199.98px) {\n  .modal-fullscreen-xl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-header,\n  .modal-fullscreen-xl-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1399.98px) {\n  .modal-fullscreen-xxl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-header,\n  .modal-fullscreen-xxl-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n.tooltip {\n  --bs-tooltip-zindex: 1080;\n  --bs-tooltip-max-width: 200px;\n  --bs-tooltip-padding-x: 0.5rem;\n  --bs-tooltip-padding-y: 0.25rem;\n  --bs-tooltip-margin: ;\n  --bs-tooltip-font-size: 0.875rem;\n  --bs-tooltip-color: var(--bs-body-bg);\n  --bs-tooltip-bg: var(--bs-emphasis-color);\n  --bs-tooltip-border-radius: var(--bs-border-radius);\n  --bs-tooltip-opacity: 0.9;\n  --bs-tooltip-arrow-width: 0.8rem;\n  --bs-tooltip-arrow-height: 0.4rem;\n  z-index: var(--bs-tooltip-zindex);\n  display: block;\n  margin: var(--bs-tooltip-margin);\n  font-family: var(--bs-font-sans-serif);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--bs-tooltip-font-size);\n  word-wrap: break-word;\n  opacity: 0;\n}\n.tooltip.show {\n  opacity: var(--bs-tooltip-opacity);\n}\n.tooltip .tooltip-arrow {\n  display: block;\n  width: var(--bs-tooltip-arrow-width);\n  height: var(--bs-tooltip-arrow-height);\n}\n.tooltip .tooltip-arrow::before {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {\n  bottom: calc(-1 * var(--bs-tooltip-arrow-height));\n}\n.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {\n  top: -1px;\n  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n  border-top-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {\n  left: calc(-1 * var(--bs-tooltip-arrow-height));\n  width: var(--bs-tooltip-arrow-height);\n  height: var(--bs-tooltip-arrow-width);\n}\n.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {\n  right: -1px;\n  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n  border-right-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {\n  top: calc(-1 * var(--bs-tooltip-arrow-height));\n}\n.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {\n  bottom: -1px;\n  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);\n  border-bottom-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {\n  right: calc(-1 * var(--bs-tooltip-arrow-height));\n  width: var(--bs-tooltip-arrow-height);\n  height: var(--bs-tooltip-arrow-width);\n}\n.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {\n  left: -1px;\n  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);\n  border-left-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.tooltip-inner {\n  max-width: var(--bs-tooltip-max-width);\n  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);\n  color: var(--bs-tooltip-color);\n  text-align: center;\n  background-color: var(--bs-tooltip-bg);\n  border-radius: var(--bs-tooltip-border-radius);\n}\n\n.popover {\n  --bs-popover-zindex: 1070;\n  --bs-popover-max-width: 276px;\n  --bs-popover-font-size: 0.875rem;\n  --bs-popover-bg: var(--bs-body-bg);\n  --bs-popover-border-width: var(--bs-border-width);\n  --bs-popover-border-color: var(--bs-border-color-translucent);\n  --bs-popover-border-radius: var(--bs-border-radius-lg);\n  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));\n  --bs-popover-box-shadow: var(--bs-box-shadow);\n  --bs-popover-header-padding-x: 1rem;\n  --bs-popover-header-padding-y: 0.5rem;\n  --bs-popover-header-font-size: 1rem;\n  --bs-popover-header-color: inherit;\n  --bs-popover-header-bg: var(--bs-secondary-bg);\n  --bs-popover-body-padding-x: 1rem;\n  --bs-popover-body-padding-y: 1rem;\n  --bs-popover-body-color: var(--bs-body-color);\n  --bs-popover-arrow-width: 1rem;\n  --bs-popover-arrow-height: 0.5rem;\n  --bs-popover-arrow-border: var(--bs-popover-border-color);\n  z-index: var(--bs-popover-zindex);\n  display: block;\n  max-width: var(--bs-popover-max-width);\n  font-family: var(--bs-font-sans-serif);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--bs-popover-font-size);\n  word-wrap: break-word;\n  background-color: var(--bs-popover-bg);\n  background-clip: padding-box;\n  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n  border-radius: var(--bs-popover-border-radius);\n}\n.popover .popover-arrow {\n  display: block;\n  width: var(--bs-popover-arrow-width);\n  height: var(--bs-popover-arrow-height);\n}\n.popover .popover-arrow::before, .popover .popover-arrow::after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n  border-width: 0;\n}\n\n.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {\n  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {\n  bottom: 0;\n  border-top-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  bottom: var(--bs-popover-border-width);\n  border-top-color: var(--bs-popover-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {\n  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n  width: var(--bs-popover-arrow-height);\n  height: var(--bs-popover-arrow-width);\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {\n  left: 0;\n  border-right-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  left: var(--bs-popover-border-width);\n  border-right-color: var(--bs-popover-bg);\n}\n\n/* rtl:end:ignore */\n.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {\n  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {\n  top: 0;\n  border-bottom-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  top: var(--bs-popover-border-width);\n  border-bottom-color: var(--bs-popover-bg);\n}\n.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: block;\n  width: var(--bs-popover-arrow-width);\n  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));\n  content: \"\";\n  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {\n  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n  width: var(--bs-popover-arrow-height);\n  height: var(--bs-popover-arrow-width);\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {\n  right: 0;\n  border-left-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  right: var(--bs-popover-border-width);\n  border-left-color: var(--bs-popover-bg);\n}\n\n/* rtl:end:ignore */\n.popover-header {\n  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);\n  margin-bottom: 0;\n  font-size: var(--bs-popover-header-font-size);\n  color: var(--bs-popover-header-color);\n  background-color: var(--bs-popover-header-bg);\n  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n  border-top-left-radius: var(--bs-popover-inner-border-radius);\n  border-top-right-radius: var(--bs-popover-inner-border-radius);\n}\n.popover-header:empty {\n  display: none;\n}\n\n.popover-body {\n  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);\n  color: var(--bs-popover-body-color);\n}\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n.carousel-inner::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  transition: transform 0.6s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-item {\n    transition: none;\n  }\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-property: opacity;\n  transform: none;\n}\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-start,\n.carousel-fade .carousel-item-prev.carousel-item-end {\n  z-index: 1;\n  opacity: 1;\n}\n.carousel-fade .active.carousel-item-start,\n.carousel-fade .active.carousel-item-end {\n  z-index: 0;\n  opacity: 0;\n  transition: opacity 0s 0.6s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-fade .active.carousel-item-start,\n  .carousel-fade .active.carousel-item-end {\n    transition: none;\n  }\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 15%;\n  padding: 0;\n  color: #fff;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: 0.5;\n  transition: opacity 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-control-prev,\n  .carousel-control-next {\n    transition: none;\n  }\n}\n.carousel-control-prev:hover, .carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n  color: #fff;\n  text-decoration: none;\n  outline: 0;\n  opacity: 0.9;\n}\n\n.carousel-control-prev {\n  left: 0;\n}\n\n.carousel-control-next {\n  right: 0;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\") /*rtl:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\")*/;\n}\n\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\") /*rtl:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\")*/;\n}\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  margin-right: 15%;\n  margin-bottom: 1rem;\n  margin-left: 15%;\n}\n.carousel-indicators [data-bs-target] {\n  box-sizing: content-box;\n  flex: 0 1 auto;\n  width: 30px;\n  height: 3px;\n  padding: 0;\n  margin-right: 3px;\n  margin-left: 3px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  opacity: 0.5;\n  transition: opacity 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-indicators [data-bs-target] {\n    transition: none;\n  }\n}\n.carousel-indicators .active {\n  opacity: 1;\n}\n\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 1.25rem;\n  left: 15%;\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n  color: #fff;\n  text-align: center;\n}\n\n.carousel-dark .carousel-control-prev-icon,\n.carousel-dark .carousel-control-next-icon {\n  filter: invert(1) grayscale(100);\n}\n.carousel-dark .carousel-indicators [data-bs-target] {\n  background-color: #000;\n}\n.carousel-dark .carousel-caption {\n  color: #000;\n}\n\n[data-bs-theme=dark] .carousel .carousel-control-prev-icon,\n[data-bs-theme=dark] .carousel .carousel-control-next-icon, [data-bs-theme=dark].carousel .carousel-control-prev-icon,\n[data-bs-theme=dark].carousel .carousel-control-next-icon {\n  filter: invert(1) grayscale(100);\n}\n[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {\n  background-color: #000;\n}\n[data-bs-theme=dark] .carousel .carousel-caption, [data-bs-theme=dark].carousel .carousel-caption {\n  color: #000;\n}\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--bs-spinner-width);\n  height: var(--bs-spinner-height);\n  vertical-align: var(--bs-spinner-vertical-align);\n  border-radius: 50%;\n  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);\n}\n\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg) /* rtl:ignore */;\n  }\n}\n.spinner-border {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.125em;\n  --bs-spinner-border-width: 0.25em;\n  --bs-spinner-animation-speed: 0.75s;\n  --bs-spinner-animation-name: spinner-border;\n  border: var(--bs-spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n  --bs-spinner-border-width: 0.2em;\n}\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n.spinner-grow {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.125em;\n  --bs-spinner-animation-speed: 0.75s;\n  --bs-spinner-animation-name: spinner-grow;\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .spinner-border,\n  .spinner-grow {\n    --bs-spinner-animation-speed: 1.5s;\n  }\n}\n.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {\n  --bs-offcanvas-zindex: 1045;\n  --bs-offcanvas-width: 400px;\n  --bs-offcanvas-height: 30vh;\n  --bs-offcanvas-padding-x: 1rem;\n  --bs-offcanvas-padding-y: 1rem;\n  --bs-offcanvas-color: var(--bs-body-color);\n  --bs-offcanvas-bg: var(--bs-body-bg);\n  --bs-offcanvas-border-width: var(--bs-border-width);\n  --bs-offcanvas-border-color: var(--bs-border-color-translucent);\n  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);\n  --bs-offcanvas-transition: transform 0.3s ease-in-out;\n  --bs-offcanvas-title-line-height: 1.5;\n}\n\n@media (max-width: 575.98px) {\n  .offcanvas-sm {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-sm {\n    transition: none;\n  }\n}\n@media (max-width: 575.98px) {\n  .offcanvas-sm.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-sm.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-sm.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-sm.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 576px) {\n  .offcanvas-sm {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-sm .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-sm .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .offcanvas-md {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-md {\n    transition: none;\n  }\n}\n@media (max-width: 767.98px) {\n  .offcanvas-md.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-md.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-md.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-md.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 768px) {\n  .offcanvas-md {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-md .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-md .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .offcanvas-lg {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-lg {\n    transition: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .offcanvas-lg.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-lg.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-lg.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-lg.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 992px) {\n  .offcanvas-lg {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-lg .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-lg .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .offcanvas-xl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-xl {\n    transition: none;\n  }\n}\n@media (max-width: 1199.98px) {\n  .offcanvas-xl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-xl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-xl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-xl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 1200px) {\n  .offcanvas-xl {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-xl .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-xl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-xxl {\n    transition: none;\n  }\n}\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-xxl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-xxl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-xxl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 1400px) {\n  .offcanvas-xxl {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-xxl .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-xxl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n.offcanvas {\n  position: fixed;\n  bottom: 0;\n  z-index: var(--bs-offcanvas-zindex);\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  color: var(--bs-offcanvas-color);\n  visibility: hidden;\n  background-color: var(--bs-offcanvas-bg);\n  background-clip: padding-box;\n  outline: 0;\n  transition: var(--bs-offcanvas-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .offcanvas {\n    transition: none;\n  }\n}\n.offcanvas.offcanvas-start {\n  top: 0;\n  left: 0;\n  width: var(--bs-offcanvas-width);\n  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateX(-100%);\n}\n.offcanvas.offcanvas-end {\n  top: 0;\n  right: 0;\n  width: var(--bs-offcanvas-width);\n  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateX(100%);\n}\n.offcanvas.offcanvas-top {\n  top: 0;\n  right: 0;\n  left: 0;\n  height: var(--bs-offcanvas-height);\n  max-height: 100%;\n  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateY(-100%);\n}\n.offcanvas.offcanvas-bottom {\n  right: 0;\n  left: 0;\n  height: var(--bs-offcanvas-height);\n  max-height: 100%;\n  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateY(100%);\n}\n.offcanvas.showing, .offcanvas.show:not(.hiding) {\n  transform: none;\n}\n.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {\n  visibility: visible;\n}\n\n.offcanvas-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000;\n}\n.offcanvas-backdrop.fade {\n  opacity: 0;\n}\n.offcanvas-backdrop.show {\n  opacity: 0.5;\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n}\n.offcanvas-header .btn-close {\n  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);\n  margin: calc(-0.5 * var(--bs-offcanvas-padding-y)) calc(-0.5 * var(--bs-offcanvas-padding-x)) calc(-0.5 * var(--bs-offcanvas-padding-y)) auto;\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--bs-offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n  overflow-y: auto;\n}\n\n.placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: 0.5;\n}\n.placeholder.btn::before {\n  display: inline-block;\n  content: \"\";\n}\n\n.placeholder-xs {\n  min-height: 0.6em;\n}\n\n.placeholder-sm {\n  min-height: 0.8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n.placeholder-glow .placeholder {\n  animation: placeholder-glow 2s ease-in-out infinite;\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: 0.2;\n  }\n}\n.placeholder-wave {\n  -webkit-mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);\n  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);\n  -webkit-mask-size: 200% 100%;\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    -webkit-mask-position: -200% 0%;\n    mask-position: -200% 0%;\n  }\n}\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.text-bg-primary {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-secondary {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-success {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-info {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-warning {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-danger {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-light {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-dark {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.link-primary {\n  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;\n  -webkit-text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-primary:hover, .link-primary:focus {\n  color: RGBA(10, 88, 202, var(--bs-link-opacity, 1)) !important;\n  -webkit-text-decoration-color: RGBA(10, 88, 202, var(--bs-link-underline-opacity, 1)) !important;\n  text-decoration-color: RGBA(10, 88, 202, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-secondary {\n  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;\n  -webkit-text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-secondary:hover, .link-secondary:focus {\n  color: RGBA(86, 94, 100, var(--bs-link-opacity, 1)) !important;\n  -webkit-text-decoration-color: RGBA(86, 94, 100, var(--bs-link-underline-opacity, 1)) !important;\n  text-decoration-color: RGBA(86, 94, 100, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-success {\n  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;\n  -webkit-text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-success:hover, .link-success:focus {\n  color: RGBA(20, 108, 67, var(--bs-link-opacity, 1)) !important;\n  -webkit-text-decoration-color: RGBA(20, 108, 67, var(--bs-link-underline-opacity, 1)) !important;\n  text-decoration-color: RGBA(20, 108, 67, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-info {\n  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;\n  -webkit-text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-info:hover, .link-info:focus {\n  color: RGBA(61, 213, 243, var(--bs-link-opacity, 1)) !important;\n  -webkit-text-decoration-color: RGBA(61, 213, 243, var(--bs-link-underline-opacity, 1)) !important;\n  text-decoration-color: RGBA(61, 213, 243, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-warning {\n  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;\n  -webkit-text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-warning:hover, .link-warning:focus {\n  color: RGBA(255, 205, 57, var(--bs-link-opacity, 1)) !important;\n  -webkit-text-decoration-color: RGBA(255, 205, 57, var(--bs-link-underline-opacity, 1)) !important;\n  text-decoration-color: RGBA(255, 205, 57, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger {\n  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;\n  -webkit-text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-danger:hover, .link-danger:focus {\n  color: RGBA(176, 42, 55, var(--bs-link-opacity, 1)) !important;\n  -webkit-text-decoration-color: RGBA(176, 42, 55, var(--bs-link-underline-opacity, 1)) !important;\n  text-decoration-color: RGBA(176, 42, 55, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-light {\n  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;\n  -webkit-text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-light:hover, .link-light:focus {\n  color: RGBA(249, 250, 251, var(--bs-link-opacity, 1)) !important;\n  -webkit-text-decoration-color: RGBA(249, 250, 251, var(--bs-link-underline-opacity, 1)) !important;\n  text-decoration-color: RGBA(249, 250, 251, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-dark {\n  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;\n  -webkit-text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-dark:hover, .link-dark:focus {\n  color: RGBA(26, 30, 33, var(--bs-link-opacity, 1)) !important;\n  -webkit-text-decoration-color: RGBA(26, 30, 33, var(--bs-link-underline-opacity, 1)) !important;\n  text-decoration-color: RGBA(26, 30, 33, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-body-emphasis {\n  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;\n  -webkit-text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-body-emphasis:hover, .link-body-emphasis:focus {\n  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;\n  -webkit-text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;\n  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;\n}\n\n.focus-ring:focus {\n  outline: 0;\n  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);\n}\n\n.icon-link {\n  display: inline-flex;\n  gap: 0.375rem;\n  align-items: center;\n  -webkit-text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));\n  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));\n  text-underline-offset: 0.25em;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n.icon-link > .bi {\n  flex-shrink: 0;\n  width: 1em;\n  height: 1em;\n  fill: currentcolor;\n  transition: 0.2s ease-in-out transform;\n}\n@media (prefers-reduced-motion: reduce) {\n  .icon-link > .bi {\n    transition: none;\n  }\n}\n\n.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {\n  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));\n}\n\n.ratio {\n  position: relative;\n  width: 100%;\n}\n.ratio::before {\n  display: block;\n  padding-top: var(--bs-aspect-ratio);\n  content: \"\";\n}\n.ratio > * {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.ratio-1x1 {\n  --bs-aspect-ratio: 100%;\n}\n\n.ratio-4x3 {\n  --bs-aspect-ratio: 75%;\n}\n\n.ratio-16x9 {\n  --bs-aspect-ratio: 56.25%;\n}\n\n.ratio-21x9 {\n  --bs-aspect-ratio: 42.8571428571%;\n}\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.sticky-top {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  z-index: 1020;\n}\n\n.sticky-bottom {\n  position: -webkit-sticky;\n  position: sticky;\n  bottom: 0;\n  z-index: 1020;\n}\n\n@media (min-width: 576px) {\n  .sticky-sm-top {\n    position: -webkit-sticky;\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-sm-bottom {\n    position: -webkit-sticky;\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 768px) {\n  .sticky-md-top {\n    position: -webkit-sticky;\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-md-bottom {\n    position: -webkit-sticky;\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 992px) {\n  .sticky-lg-top {\n    position: -webkit-sticky;\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-lg-bottom {\n    position: -webkit-sticky;\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1200px) {\n  .sticky-xl-top {\n    position: -webkit-sticky;\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-xl-bottom {\n    position: -webkit-sticky;\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1400px) {\n  .sticky-xxl-top {\n    position: -webkit-sticky;\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-xxl-bottom {\n    position: -webkit-sticky;\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n.visually-hidden:not(caption),\n.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {\n  position: absolute !important;\n}\n\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  content: \"\";\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.vr {\n  display: inline-block;\n  align-self: stretch;\n  width: var(--bs-border-width);\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: 0.25;\n}\n\n.align-baseline {\n  vertical-align: baseline !important;\n}\n\n.align-top {\n  vertical-align: top !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.align-bottom {\n  vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n  vertical-align: text-top !important;\n}\n\n.float-start {\n  float: left !important;\n}\n\n.float-end {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n.object-fit-contain {\n  -o-object-fit: contain !important;\n  object-fit: contain !important;\n}\n\n.object-fit-cover {\n  -o-object-fit: cover !important;\n  object-fit: cover !important;\n}\n\n.object-fit-fill {\n  -o-object-fit: fill !important;\n  object-fit: fill !important;\n}\n\n.object-fit-scale {\n  -o-object-fit: scale-down !important;\n  object-fit: scale-down !important;\n}\n\n.object-fit-none {\n  -o-object-fit: none !important;\n  object-fit: none !important;\n}\n\n.opacity-0 {\n  opacity: 0 !important;\n}\n\n.opacity-25 {\n  opacity: 0.25 !important;\n}\n\n.opacity-50 {\n  opacity: 0.5 !important;\n}\n\n.opacity-75 {\n  opacity: 0.75 !important;\n}\n\n.opacity-100 {\n  opacity: 1 !important;\n}\n\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.overflow-visible {\n  overflow: visible !important;\n}\n\n.overflow-scroll {\n  overflow: scroll !important;\n}\n\n.overflow-x-auto {\n  overflow-x: auto !important;\n}\n\n.overflow-x-hidden {\n  overflow-x: hidden !important;\n}\n\n.overflow-x-visible {\n  overflow-x: visible !important;\n}\n\n.overflow-x-scroll {\n  overflow-x: scroll !important;\n}\n\n.overflow-y-auto {\n  overflow-y: auto !important;\n}\n\n.overflow-y-hidden {\n  overflow-y: hidden !important;\n}\n\n.overflow-y-visible {\n  overflow-y: visible !important;\n}\n\n.overflow-y-scroll {\n  overflow-y: scroll !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-grid {\n  display: grid !important;\n}\n\n.d-inline-grid {\n  display: inline-grid !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: inline-flex !important;\n}\n\n.d-none {\n  display: none !important;\n}\n\n.shadow {\n  box-shadow: var(--bs-box-shadow) !important;\n}\n\n.shadow-sm {\n  box-shadow: var(--bs-box-shadow-sm) !important;\n}\n\n.shadow-lg {\n  box-shadow: var(--bs-box-shadow-lg) !important;\n}\n\n.shadow-none {\n  box-shadow: none !important;\n}\n\n.focus-ring-primary {\n  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-secondary {\n  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-success {\n  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-info {\n  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-warning {\n  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-danger {\n  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-light {\n  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-dark {\n  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));\n}\n\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-sticky {\n  position: -webkit-sticky !important;\n  position: sticky !important;\n}\n\n.top-0 {\n  top: 0 !important;\n}\n\n.top-50 {\n  top: 50% !important;\n}\n\n.top-100 {\n  top: 100% !important;\n}\n\n.bottom-0 {\n  bottom: 0 !important;\n}\n\n.bottom-50 {\n  bottom: 50% !important;\n}\n\n.bottom-100 {\n  bottom: 100% !important;\n}\n\n.start-0 {\n  left: 0 !important;\n}\n\n.start-50 {\n  left: 50% !important;\n}\n\n.start-100 {\n  left: 100% !important;\n}\n\n.end-0 {\n  right: 0 !important;\n}\n\n.end-50 {\n  right: 50% !important;\n}\n\n.end-100 {\n  right: 100% !important;\n}\n\n.translate-middle {\n  transform: translate(-50%, -50%) !important;\n}\n\n.translate-middle-x {\n  transform: translateX(-50%) !important;\n}\n\n.translate-middle-y {\n  transform: translateY(-50%) !important;\n}\n\n.border {\n  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-0 {\n  border: 0 !important;\n}\n\n.border-top {\n  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-top-0 {\n  border-top: 0 !important;\n}\n\n.border-end {\n  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-end-0 {\n  border-right: 0 !important;\n}\n\n.border-bottom {\n  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n\n.border-start {\n  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-start-0 {\n  border-left: 0 !important;\n}\n\n.border-primary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-secondary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-success {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-info {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-warning {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-danger {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-light {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-dark {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-black {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-white {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-primary-subtle {\n  border-color: var(--bs-primary-border-subtle) !important;\n}\n\n.border-secondary-subtle {\n  border-color: var(--bs-secondary-border-subtle) !important;\n}\n\n.border-success-subtle {\n  border-color: var(--bs-success-border-subtle) !important;\n}\n\n.border-info-subtle {\n  border-color: var(--bs-info-border-subtle) !important;\n}\n\n.border-warning-subtle {\n  border-color: var(--bs-warning-border-subtle) !important;\n}\n\n.border-danger-subtle {\n  border-color: var(--bs-danger-border-subtle) !important;\n}\n\n.border-light-subtle {\n  border-color: var(--bs-light-border-subtle) !important;\n}\n\n.border-dark-subtle {\n  border-color: var(--bs-dark-border-subtle) !important;\n}\n\n.border-1 {\n  border-width: 1px !important;\n}\n\n.border-2 {\n  border-width: 2px !important;\n}\n\n.border-3 {\n  border-width: 3px !important;\n}\n\n.border-4 {\n  border-width: 4px !important;\n}\n\n.border-5 {\n  border-width: 5px !important;\n}\n\n.border-opacity-10 {\n  --bs-border-opacity: 0.1;\n}\n\n.border-opacity-25 {\n  --bs-border-opacity: 0.25;\n}\n\n.border-opacity-50 {\n  --bs-border-opacity: 0.5;\n}\n\n.border-opacity-75 {\n  --bs-border-opacity: 0.75;\n}\n\n.border-opacity-100 {\n  --bs-border-opacity: 1;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.vw-100 {\n  width: 100vw !important;\n}\n\n.min-vw-100 {\n  min-width: 100vw !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.vh-100 {\n  height: 100vh !important;\n}\n\n.min-vh-100 {\n  min-height: 100vh !important;\n}\n\n.flex-fill {\n  flex: 1 1 auto !important;\n}\n\n.flex-row {\n  flex-direction: row !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n\n.flex-grow-0 {\n  flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-around {\n  justify-content: space-around !important;\n}\n\n.justify-content-evenly {\n  justify-content: space-evenly !important;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.align-items-end {\n  align-items: flex-end !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  align-content: center !important;\n}\n\n.align-content-between {\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  align-self: auto !important;\n}\n\n.align-self-start {\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n.order-first {\n  order: -1 !important;\n}\n\n.order-0 {\n  order: 0 !important;\n}\n\n.order-1 {\n  order: 1 !important;\n}\n\n.order-2 {\n  order: 2 !important;\n}\n\n.order-3 {\n  order: 3 !important;\n}\n\n.order-4 {\n  order: 4 !important;\n}\n\n.order-5 {\n  order: 5 !important;\n}\n\n.order-last {\n  order: 6 !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.m-1 {\n  margin: 0.25rem !important;\n}\n\n.m-2 {\n  margin: 0.5rem !important;\n}\n\n.m-3 {\n  margin: 1rem !important;\n}\n\n.m-4 {\n  margin: 1.5rem !important;\n}\n\n.m-5 {\n  margin: 3rem !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mx-0 {\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n\n.mx-1 {\n  margin-right: 0.25rem !important;\n  margin-left: 0.25rem !important;\n}\n\n.mx-2 {\n  margin-right: 0.5rem !important;\n  margin-left: 0.5rem !important;\n}\n\n.mx-3 {\n  margin-right: 1rem !important;\n  margin-left: 1rem !important;\n}\n\n.mx-4 {\n  margin-right: 1.5rem !important;\n  margin-left: 1.5rem !important;\n}\n\n.mx-5 {\n  margin-right: 3rem !important;\n  margin-left: 3rem !important;\n}\n\n.mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n.my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.my-1 {\n  margin-top: 0.25rem !important;\n  margin-bottom: 0.25rem !important;\n}\n\n.my-2 {\n  margin-top: 0.5rem !important;\n  margin-bottom: 0.5rem !important;\n}\n\n.my-3 {\n  margin-top: 1rem !important;\n  margin-bottom: 1rem !important;\n}\n\n.my-4 {\n  margin-top: 1.5rem !important;\n  margin-bottom: 1.5rem !important;\n}\n\n.my-5 {\n  margin-top: 3rem !important;\n  margin-bottom: 3rem !important;\n}\n\n.my-auto {\n  margin-top: auto !important;\n  margin-bottom: auto !important;\n}\n\n.mt-0 {\n  margin-top: 0 !important;\n}\n\n.mt-1 {\n  margin-top: 0.25rem !important;\n}\n\n.mt-2 {\n  margin-top: 0.5rem !important;\n}\n\n.mt-3 {\n  margin-top: 1rem !important;\n}\n\n.mt-4 {\n  margin-top: 1.5rem !important;\n}\n\n.mt-5 {\n  margin-top: 3rem !important;\n}\n\n.mt-auto {\n  margin-top: auto !important;\n}\n\n.me-0 {\n  margin-right: 0 !important;\n}\n\n.me-1 {\n  margin-right: 0.25rem !important;\n}\n\n.me-2 {\n  margin-right: 0.5rem !important;\n}\n\n.me-3 {\n  margin-right: 1rem !important;\n}\n\n.me-4 {\n  margin-right: 1.5rem !important;\n}\n\n.me-5 {\n  margin-right: 3rem !important;\n}\n\n.me-auto {\n  margin-right: auto !important;\n}\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n\n.mb-1 {\n  margin-bottom: 0.25rem !important;\n}\n\n.mb-2 {\n  margin-bottom: 0.5rem !important;\n}\n\n.mb-3 {\n  margin-bottom: 1rem !important;\n}\n\n.mb-4 {\n  margin-bottom: 1.5rem !important;\n}\n\n.mb-5 {\n  margin-bottom: 3rem !important;\n}\n\n.mb-auto {\n  margin-bottom: auto !important;\n}\n\n.ms-0 {\n  margin-left: 0 !important;\n}\n\n.ms-1 {\n  margin-left: 0.25rem !important;\n}\n\n.ms-2 {\n  margin-left: 0.5rem !important;\n}\n\n.ms-3 {\n  margin-left: 1rem !important;\n}\n\n.ms-4 {\n  margin-left: 1.5rem !important;\n}\n\n.ms-5 {\n  margin-left: 3rem !important;\n}\n\n.ms-auto {\n  margin-left: auto !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.p-1 {\n  padding: 0.25rem !important;\n}\n\n.p-2 {\n  padding: 0.5rem !important;\n}\n\n.p-3 {\n  padding: 1rem !important;\n}\n\n.p-4 {\n  padding: 1.5rem !important;\n}\n\n.p-5 {\n  padding: 3rem !important;\n}\n\n.px-0 {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n}\n\n.px-1 {\n  padding-right: 0.25rem !important;\n  padding-left: 0.25rem !important;\n}\n\n.px-2 {\n  padding-right: 0.5rem !important;\n  padding-left: 0.5rem !important;\n}\n\n.px-3 {\n  padding-right: 1rem !important;\n  padding-left: 1rem !important;\n}\n\n.px-4 {\n  padding-right: 1.5rem !important;\n  padding-left: 1.5rem !important;\n}\n\n.px-5 {\n  padding-right: 3rem !important;\n  padding-left: 3rem !important;\n}\n\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.py-1 {\n  padding-top: 0.25rem !important;\n  padding-bottom: 0.25rem !important;\n}\n\n.py-2 {\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n}\n\n.py-3 {\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}\n\n.py-4 {\n  padding-top: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n}\n\n.py-5 {\n  padding-top: 3rem !important;\n  padding-bottom: 3rem !important;\n}\n\n.pt-0 {\n  padding-top: 0 !important;\n}\n\n.pt-1 {\n  padding-top: 0.25rem !important;\n}\n\n.pt-2 {\n  padding-top: 0.5rem !important;\n}\n\n.pt-3 {\n  padding-top: 1rem !important;\n}\n\n.pt-4 {\n  padding-top: 1.5rem !important;\n}\n\n.pt-5 {\n  padding-top: 3rem !important;\n}\n\n.pe-0 {\n  padding-right: 0 !important;\n}\n\n.pe-1 {\n  padding-right: 0.25rem !important;\n}\n\n.pe-2 {\n  padding-right: 0.5rem !important;\n}\n\n.pe-3 {\n  padding-right: 1rem !important;\n}\n\n.pe-4 {\n  padding-right: 1.5rem !important;\n}\n\n.pe-5 {\n  padding-right: 3rem !important;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n\n.pb-1 {\n  padding-bottom: 0.25rem !important;\n}\n\n.pb-2 {\n  padding-bottom: 0.5rem !important;\n}\n\n.pb-3 {\n  padding-bottom: 1rem !important;\n}\n\n.pb-4 {\n  padding-bottom: 1.5rem !important;\n}\n\n.pb-5 {\n  padding-bottom: 3rem !important;\n}\n\n.ps-0 {\n  padding-left: 0 !important;\n}\n\n.ps-1 {\n  padding-left: 0.25rem !important;\n}\n\n.ps-2 {\n  padding-left: 0.5rem !important;\n}\n\n.ps-3 {\n  padding-left: 1rem !important;\n}\n\n.ps-4 {\n  padding-left: 1.5rem !important;\n}\n\n.ps-5 {\n  padding-left: 3rem !important;\n}\n\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-1 {\n  gap: 0.25rem !important;\n}\n\n.gap-2 {\n  gap: 0.5rem !important;\n}\n\n.gap-3 {\n  gap: 1rem !important;\n}\n\n.gap-4 {\n  gap: 1.5rem !important;\n}\n\n.gap-5 {\n  gap: 3rem !important;\n}\n\n.row-gap-0 {\n  row-gap: 0 !important;\n}\n\n.row-gap-1 {\n  row-gap: 0.25rem !important;\n}\n\n.row-gap-2 {\n  row-gap: 0.5rem !important;\n}\n\n.row-gap-3 {\n  row-gap: 1rem !important;\n}\n\n.row-gap-4 {\n  row-gap: 1.5rem !important;\n}\n\n.row-gap-5 {\n  row-gap: 3rem !important;\n}\n\n.column-gap-0 {\n  -moz-column-gap: 0 !important;\n  column-gap: 0 !important;\n}\n\n.column-gap-1 {\n  -moz-column-gap: 0.25rem !important;\n  column-gap: 0.25rem !important;\n}\n\n.column-gap-2 {\n  -moz-column-gap: 0.5rem !important;\n  column-gap: 0.5rem !important;\n}\n\n.column-gap-3 {\n  -moz-column-gap: 1rem !important;\n  column-gap: 1rem !important;\n}\n\n.column-gap-4 {\n  -moz-column-gap: 1.5rem !important;\n  column-gap: 1.5rem !important;\n}\n\n.column-gap-5 {\n  -moz-column-gap: 3rem !important;\n  column-gap: 3rem !important;\n}\n\n.font-monospace {\n  font-family: var(--bs-font-monospace) !important;\n}\n\n.fs-1 {\n  font-size: calc(1.375rem + 1.5vw) !important;\n}\n\n.fs-2 {\n  font-size: calc(1.325rem + 0.9vw) !important;\n}\n\n.fs-3 {\n  font-size: calc(1.3rem + 0.6vw) !important;\n}\n\n.fs-4 {\n  font-size: calc(1.275rem + 0.3vw) !important;\n}\n\n.fs-5 {\n  font-size: 1.25rem !important;\n}\n\n.fs-6 {\n  font-size: 1rem !important;\n}\n\n.fst-italic {\n  font-style: italic !important;\n}\n\n.fst-normal {\n  font-style: normal !important;\n}\n\n.fw-lighter {\n  font-weight: lighter !important;\n}\n\n.fw-light {\n  font-weight: 300 !important;\n}\n\n.fw-normal {\n  font-weight: 400 !important;\n}\n\n.fw-medium {\n  font-weight: 500 !important;\n}\n\n.fw-semibold {\n  font-weight: 600 !important;\n}\n\n.fw-bold {\n  font-weight: 700 !important;\n}\n\n.fw-bolder {\n  font-weight: bolder !important;\n}\n\n.lh-1 {\n  line-height: 1 !important;\n}\n\n.lh-sm {\n  line-height: 1.25 !important;\n}\n\n.lh-base {\n  line-height: 1.5 !important;\n}\n\n.lh-lg {\n  line-height: 2 !important;\n}\n\n.text-start {\n  text-align: left !important;\n}\n\n.text-end {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-decoration-underline {\n  text-decoration: underline !important;\n}\n\n.text-decoration-line-through {\n  text-decoration: line-through !important;\n}\n\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n/* rtl:begin:remove */\n.text-break {\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n}\n\n/* rtl:end:remove */\n.text-primary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-secondary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-success {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-info {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-warning {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-danger {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-light {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-dark {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-black {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-white {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-body {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-muted {\n  --bs-text-opacity: 1;\n  color: var(--bs-secondary-color) !important;\n}\n\n.text-black-50 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, 0.5) !important;\n}\n\n.text-white-50 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-body-secondary {\n  --bs-text-opacity: 1;\n  color: var(--bs-secondary-color) !important;\n}\n\n.text-body-tertiary {\n  --bs-text-opacity: 1;\n  color: var(--bs-tertiary-color) !important;\n}\n\n.text-body-emphasis {\n  --bs-text-opacity: 1;\n  color: var(--bs-emphasis-color) !important;\n}\n\n.text-reset {\n  --bs-text-opacity: 1;\n  color: inherit !important;\n}\n\n.text-opacity-25 {\n  --bs-text-opacity: 0.25;\n}\n\n.text-opacity-50 {\n  --bs-text-opacity: 0.5;\n}\n\n.text-opacity-75 {\n  --bs-text-opacity: 0.75;\n}\n\n.text-opacity-100 {\n  --bs-text-opacity: 1;\n}\n\n.text-primary-emphasis {\n  color: var(--bs-primary-text-emphasis) !important;\n}\n\n.text-secondary-emphasis {\n  color: var(--bs-secondary-text-emphasis) !important;\n}\n\n.text-success-emphasis {\n  color: var(--bs-success-text-emphasis) !important;\n}\n\n.text-info-emphasis {\n  color: var(--bs-info-text-emphasis) !important;\n}\n\n.text-warning-emphasis {\n  color: var(--bs-warning-text-emphasis) !important;\n}\n\n.text-danger-emphasis {\n  color: var(--bs-danger-text-emphasis) !important;\n}\n\n.text-light-emphasis {\n  color: var(--bs-light-text-emphasis) !important;\n}\n\n.text-dark-emphasis {\n  color: var(--bs-dark-text-emphasis) !important;\n}\n\n.link-opacity-10 {\n  --bs-link-opacity: 0.1;\n}\n\n.link-opacity-10-hover:hover {\n  --bs-link-opacity: 0.1;\n}\n\n.link-opacity-25 {\n  --bs-link-opacity: 0.25;\n}\n\n.link-opacity-25-hover:hover {\n  --bs-link-opacity: 0.25;\n}\n\n.link-opacity-50 {\n  --bs-link-opacity: 0.5;\n}\n\n.link-opacity-50-hover:hover {\n  --bs-link-opacity: 0.5;\n}\n\n.link-opacity-75 {\n  --bs-link-opacity: 0.75;\n}\n\n.link-opacity-75-hover:hover {\n  --bs-link-opacity: 0.75;\n}\n\n.link-opacity-100 {\n  --bs-link-opacity: 1;\n}\n\n.link-opacity-100-hover:hover {\n  --bs-link-opacity: 1;\n}\n\n.link-offset-1 {\n  text-underline-offset: 0.125em !important;\n}\n\n.link-offset-1-hover:hover {\n  text-underline-offset: 0.125em !important;\n}\n\n.link-offset-2 {\n  text-underline-offset: 0.25em !important;\n}\n\n.link-offset-2-hover:hover {\n  text-underline-offset: 0.25em !important;\n}\n\n.link-offset-3 {\n  text-underline-offset: 0.375em !important;\n}\n\n.link-offset-3-hover:hover {\n  text-underline-offset: 0.375em !important;\n}\n\n.link-underline-primary {\n  --bs-link-underline-opacity: 1;\n  -webkit-text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;\n  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-secondary {\n  --bs-link-underline-opacity: 1;\n  -webkit-text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;\n  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-success {\n  --bs-link-underline-opacity: 1;\n  -webkit-text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;\n  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-info {\n  --bs-link-underline-opacity: 1;\n  -webkit-text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;\n  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-warning {\n  --bs-link-underline-opacity: 1;\n  -webkit-text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;\n  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-danger {\n  --bs-link-underline-opacity: 1;\n  -webkit-text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;\n  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-light {\n  --bs-link-underline-opacity: 1;\n  -webkit-text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;\n  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-dark {\n  --bs-link-underline-opacity: 1;\n  -webkit-text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;\n  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline {\n  --bs-link-underline-opacity: 1;\n  -webkit-text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-underline-opacity-0 {\n  --bs-link-underline-opacity: 0;\n}\n\n.link-underline-opacity-0-hover:hover {\n  --bs-link-underline-opacity: 0;\n}\n\n.link-underline-opacity-10 {\n  --bs-link-underline-opacity: 0.1;\n}\n\n.link-underline-opacity-10-hover:hover {\n  --bs-link-underline-opacity: 0.1;\n}\n\n.link-underline-opacity-25 {\n  --bs-link-underline-opacity: 0.25;\n}\n\n.link-underline-opacity-25-hover:hover {\n  --bs-link-underline-opacity: 0.25;\n}\n\n.link-underline-opacity-50 {\n  --bs-link-underline-opacity: 0.5;\n}\n\n.link-underline-opacity-50-hover:hover {\n  --bs-link-underline-opacity: 0.5;\n}\n\n.link-underline-opacity-75 {\n  --bs-link-underline-opacity: 0.75;\n}\n\n.link-underline-opacity-75-hover:hover {\n  --bs-link-underline-opacity: 0.75;\n}\n\n.link-underline-opacity-100 {\n  --bs-link-underline-opacity: 1;\n}\n\n.link-underline-opacity-100-hover:hover {\n  --bs-link-underline-opacity: 1;\n}\n\n.bg-primary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-success {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-info {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-warning {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-light {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-dark {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-black {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-white {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-transparent {\n  --bs-bg-opacity: 1;\n  background-color: transparent !important;\n}\n\n.bg-body-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body-tertiary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-opacity-10 {\n  --bs-bg-opacity: 0.1;\n}\n\n.bg-opacity-25 {\n  --bs-bg-opacity: 0.25;\n}\n\n.bg-opacity-50 {\n  --bs-bg-opacity: 0.5;\n}\n\n.bg-opacity-75 {\n  --bs-bg-opacity: 0.75;\n}\n\n.bg-opacity-100 {\n  --bs-bg-opacity: 1;\n}\n\n.bg-primary-subtle {\n  background-color: var(--bs-primary-bg-subtle) !important;\n}\n\n.bg-secondary-subtle {\n  background-color: var(--bs-secondary-bg-subtle) !important;\n}\n\n.bg-success-subtle {\n  background-color: var(--bs-success-bg-subtle) !important;\n}\n\n.bg-info-subtle {\n  background-color: var(--bs-info-bg-subtle) !important;\n}\n\n.bg-warning-subtle {\n  background-color: var(--bs-warning-bg-subtle) !important;\n}\n\n.bg-danger-subtle {\n  background-color: var(--bs-danger-bg-subtle) !important;\n}\n\n.bg-light-subtle {\n  background-color: var(--bs-light-bg-subtle) !important;\n}\n\n.bg-dark-subtle {\n  background-color: var(--bs-dark-bg-subtle) !important;\n}\n\n.bg-gradient {\n  background-image: var(--bs-gradient) !important;\n}\n\n.user-select-all {\n  -webkit-user-select: all !important;\n  -moz-user-select: all !important;\n  user-select: all !important;\n}\n\n.user-select-auto {\n  -webkit-user-select: auto !important;\n  -moz-user-select: auto !important;\n  user-select: auto !important;\n}\n\n.user-select-none {\n  -webkit-user-select: none !important;\n  -moz-user-select: none !important;\n  user-select: none !important;\n}\n\n.pe-none {\n  pointer-events: none !important;\n}\n\n.pe-auto {\n  pointer-events: auto !important;\n}\n\n.rounded {\n  border-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.rounded-1 {\n  border-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-2 {\n  border-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-3 {\n  border-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-4 {\n  border-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-5 {\n  border-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-top {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-0 {\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n\n.rounded-top-1 {\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-top-2 {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-3 {\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-top-4 {\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-top-5 {\n  border-top-left-radius: var(--bs-border-radius-xxl) !important;\n  border-top-right-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-top-circle {\n  border-top-left-radius: 50% !important;\n  border-top-right-radius: 50% !important;\n}\n\n.rounded-top-pill {\n  border-top-left-radius: var(--bs-border-radius-pill) !important;\n  border-top-right-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-end {\n  border-top-right-radius: var(--bs-border-radius) !important;\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end-0 {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.rounded-end-1 {\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-end-2 {\n  border-top-right-radius: var(--bs-border-radius) !important;\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end-3 {\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-end-4 {\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-end-5 {\n  border-top-right-radius: var(--bs-border-radius-xxl) !important;\n  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-end-circle {\n  border-top-right-radius: 50% !important;\n  border-bottom-right-radius: 50% !important;\n}\n\n.rounded-end-pill {\n  border-top-right-radius: var(--bs-border-radius-pill) !important;\n  border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-0 {\n  border-bottom-right-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n\n.rounded-bottom-1 {\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-bottom-2 {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-3 {\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-bottom-4 {\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-bottom-5 {\n  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-bottom-circle {\n  border-bottom-right-radius: 50% !important;\n  border-bottom-left-radius: 50% !important;\n}\n\n.rounded-bottom-pill {\n  border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n  border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-start {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start-0 {\n  border-bottom-left-radius: 0 !important;\n  border-top-left-radius: 0 !important;\n}\n\n.rounded-start-1 {\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-start-2 {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start-3 {\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-start-4 {\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-start-5 {\n  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n  border-top-left-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-start-circle {\n  border-bottom-left-radius: 50% !important;\n  border-top-left-radius: 50% !important;\n}\n\n.rounded-start-pill {\n  border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n  border-top-left-radius: var(--bs-border-radius-pill) !important;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\n.z-n1 {\n  z-index: -1 !important;\n}\n\n.z-0 {\n  z-index: 0 !important;\n}\n\n.z-1 {\n  z-index: 1 !important;\n}\n\n.z-2 {\n  z-index: 2 !important;\n}\n\n.z-3 {\n  z-index: 3 !important;\n}\n\n@media (min-width: 576px) {\n  .float-sm-start {\n    float: left !important;\n  }\n  .float-sm-end {\n    float: right !important;\n  }\n  .float-sm-none {\n    float: none !important;\n  }\n  .object-fit-sm-contain {\n    -o-object-fit: contain !important;\n    object-fit: contain !important;\n  }\n  .object-fit-sm-cover {\n    -o-object-fit: cover !important;\n    object-fit: cover !important;\n  }\n  .object-fit-sm-fill {\n    -o-object-fit: fill !important;\n    object-fit: fill !important;\n  }\n  .object-fit-sm-scale {\n    -o-object-fit: scale-down !important;\n    object-fit: scale-down !important;\n  }\n  .object-fit-sm-none {\n    -o-object-fit: none !important;\n    object-fit: none !important;\n  }\n  .d-sm-inline {\n    display: inline !important;\n  }\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n  .d-sm-block {\n    display: block !important;\n  }\n  .d-sm-grid {\n    display: grid !important;\n  }\n  .d-sm-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-sm-table {\n    display: table !important;\n  }\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n  .d-sm-flex {\n    display: flex !important;\n  }\n  .d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-sm-none {\n    display: none !important;\n  }\n  .flex-sm-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-sm-row {\n    flex-direction: row !important;\n  }\n  .flex-sm-column {\n    flex-direction: column !important;\n  }\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-sm-center {\n    justify-content: center !important;\n  }\n  .justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-sm-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-sm-start {\n    align-items: flex-start !important;\n  }\n  .align-items-sm-end {\n    align-items: flex-end !important;\n  }\n  .align-items-sm-center {\n    align-items: center !important;\n  }\n  .align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-sm-start {\n    align-content: flex-start !important;\n  }\n  .align-content-sm-end {\n    align-content: flex-end !important;\n  }\n  .align-content-sm-center {\n    align-content: center !important;\n  }\n  .align-content-sm-between {\n    align-content: space-between !important;\n  }\n  .align-content-sm-around {\n    align-content: space-around !important;\n  }\n  .align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-sm-auto {\n    align-self: auto !important;\n  }\n  .align-self-sm-start {\n    align-self: flex-start !important;\n  }\n  .align-self-sm-end {\n    align-self: flex-end !important;\n  }\n  .align-self-sm-center {\n    align-self: center !important;\n  }\n  .align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n  .order-sm-first {\n    order: -1 !important;\n  }\n  .order-sm-0 {\n    order: 0 !important;\n  }\n  .order-sm-1 {\n    order: 1 !important;\n  }\n  .order-sm-2 {\n    order: 2 !important;\n  }\n  .order-sm-3 {\n    order: 3 !important;\n  }\n  .order-sm-4 {\n    order: 4 !important;\n  }\n  .order-sm-5 {\n    order: 5 !important;\n  }\n  .order-sm-last {\n    order: 6 !important;\n  }\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n  .m-sm-1 {\n    margin: 0.25rem !important;\n  }\n  .m-sm-2 {\n    margin: 0.5rem !important;\n  }\n  .m-sm-3 {\n    margin: 1rem !important;\n  }\n  .m-sm-4 {\n    margin: 1.5rem !important;\n  }\n  .m-sm-5 {\n    margin: 3rem !important;\n  }\n  .m-sm-auto {\n    margin: auto !important;\n  }\n  .mx-sm-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-sm-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-sm-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-sm-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-sm-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-sm-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-sm-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-sm-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-sm-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-sm-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-sm-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-sm-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-sm-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-sm-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-sm-0 {\n    margin-top: 0 !important;\n  }\n  .mt-sm-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-sm-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-sm-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-sm-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-sm-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-sm-auto {\n    margin-top: auto !important;\n  }\n  .me-sm-0 {\n    margin-right: 0 !important;\n  }\n  .me-sm-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-sm-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-sm-3 {\n    margin-right: 1rem !important;\n  }\n  .me-sm-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-sm-5 {\n    margin-right: 3rem !important;\n  }\n  .me-sm-auto {\n    margin-right: auto !important;\n  }\n  .mb-sm-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-sm-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-sm-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-sm-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-sm-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-sm-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-sm-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-sm-0 {\n    margin-left: 0 !important;\n  }\n  .ms-sm-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-sm-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-sm-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-sm-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-sm-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-sm-auto {\n    margin-left: auto !important;\n  }\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n  .p-sm-1 {\n    padding: 0.25rem !important;\n  }\n  .p-sm-2 {\n    padding: 0.5rem !important;\n  }\n  .p-sm-3 {\n    padding: 1rem !important;\n  }\n  .p-sm-4 {\n    padding: 1.5rem !important;\n  }\n  .p-sm-5 {\n    padding: 3rem !important;\n  }\n  .px-sm-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-sm-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-sm-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-sm-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-sm-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-sm-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-sm-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-sm-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-sm-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-sm-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-sm-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-sm-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-sm-0 {\n    padding-top: 0 !important;\n  }\n  .pt-sm-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-sm-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-sm-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-sm-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-sm-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-sm-0 {\n    padding-right: 0 !important;\n  }\n  .pe-sm-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-sm-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-sm-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-sm-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-sm-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-sm-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-sm-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-sm-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-sm-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-sm-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-sm-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-sm-0 {\n    padding-left: 0 !important;\n  }\n  .ps-sm-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-sm-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-sm-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-sm-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-sm-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-sm-0 {\n    gap: 0 !important;\n  }\n  .gap-sm-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-sm-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-sm-3 {\n    gap: 1rem !important;\n  }\n  .gap-sm-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-sm-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-sm-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-sm-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-sm-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-sm-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-sm-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-sm-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-sm-0 {\n    -moz-column-gap: 0 !important;\n    column-gap: 0 !important;\n  }\n  .column-gap-sm-1 {\n    -moz-column-gap: 0.25rem !important;\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-sm-2 {\n    -moz-column-gap: 0.5rem !important;\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-sm-3 {\n    -moz-column-gap: 1rem !important;\n    column-gap: 1rem !important;\n  }\n  .column-gap-sm-4 {\n    -moz-column-gap: 1.5rem !important;\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-sm-5 {\n    -moz-column-gap: 3rem !important;\n    column-gap: 3rem !important;\n  }\n  .text-sm-start {\n    text-align: left !important;\n  }\n  .text-sm-end {\n    text-align: right !important;\n  }\n  .text-sm-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 768px) {\n  .float-md-start {\n    float: left !important;\n  }\n  .float-md-end {\n    float: right !important;\n  }\n  .float-md-none {\n    float: none !important;\n  }\n  .object-fit-md-contain {\n    -o-object-fit: contain !important;\n    object-fit: contain !important;\n  }\n  .object-fit-md-cover {\n    -o-object-fit: cover !important;\n    object-fit: cover !important;\n  }\n  .object-fit-md-fill {\n    -o-object-fit: fill !important;\n    object-fit: fill !important;\n  }\n  .object-fit-md-scale {\n    -o-object-fit: scale-down !important;\n    object-fit: scale-down !important;\n  }\n  .object-fit-md-none {\n    -o-object-fit: none !important;\n    object-fit: none !important;\n  }\n  .d-md-inline {\n    display: inline !important;\n  }\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n  .d-md-block {\n    display: block !important;\n  }\n  .d-md-grid {\n    display: grid !important;\n  }\n  .d-md-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-md-table {\n    display: table !important;\n  }\n  .d-md-table-row {\n    display: table-row !important;\n  }\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n  .d-md-flex {\n    display: flex !important;\n  }\n  .d-md-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-md-none {\n    display: none !important;\n  }\n  .flex-md-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-md-row {\n    flex-direction: row !important;\n  }\n  .flex-md-column {\n    flex-direction: column !important;\n  }\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-md-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-md-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-md-center {\n    justify-content: center !important;\n  }\n  .justify-content-md-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-md-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-md-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-md-start {\n    align-items: flex-start !important;\n  }\n  .align-items-md-end {\n    align-items: flex-end !important;\n  }\n  .align-items-md-center {\n    align-items: center !important;\n  }\n  .align-items-md-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-md-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-md-start {\n    align-content: flex-start !important;\n  }\n  .align-content-md-end {\n    align-content: flex-end !important;\n  }\n  .align-content-md-center {\n    align-content: center !important;\n  }\n  .align-content-md-between {\n    align-content: space-between !important;\n  }\n  .align-content-md-around {\n    align-content: space-around !important;\n  }\n  .align-content-md-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-md-auto {\n    align-self: auto !important;\n  }\n  .align-self-md-start {\n    align-self: flex-start !important;\n  }\n  .align-self-md-end {\n    align-self: flex-end !important;\n  }\n  .align-self-md-center {\n    align-self: center !important;\n  }\n  .align-self-md-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-md-stretch {\n    align-self: stretch !important;\n  }\n  .order-md-first {\n    order: -1 !important;\n  }\n  .order-md-0 {\n    order: 0 !important;\n  }\n  .order-md-1 {\n    order: 1 !important;\n  }\n  .order-md-2 {\n    order: 2 !important;\n  }\n  .order-md-3 {\n    order: 3 !important;\n  }\n  .order-md-4 {\n    order: 4 !important;\n  }\n  .order-md-5 {\n    order: 5 !important;\n  }\n  .order-md-last {\n    order: 6 !important;\n  }\n  .m-md-0 {\n    margin: 0 !important;\n  }\n  .m-md-1 {\n    margin: 0.25rem !important;\n  }\n  .m-md-2 {\n    margin: 0.5rem !important;\n  }\n  .m-md-3 {\n    margin: 1rem !important;\n  }\n  .m-md-4 {\n    margin: 1.5rem !important;\n  }\n  .m-md-5 {\n    margin: 3rem !important;\n  }\n  .m-md-auto {\n    margin: auto !important;\n  }\n  .mx-md-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-md-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-md-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-md-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-md-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-md-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-md-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-md-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-md-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-md-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-md-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-md-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-md-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-md-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-md-0 {\n    margin-top: 0 !important;\n  }\n  .mt-md-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-md-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-md-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-md-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-md-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-md-auto {\n    margin-top: auto !important;\n  }\n  .me-md-0 {\n    margin-right: 0 !important;\n  }\n  .me-md-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-md-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-md-3 {\n    margin-right: 1rem !important;\n  }\n  .me-md-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-md-5 {\n    margin-right: 3rem !important;\n  }\n  .me-md-auto {\n    margin-right: auto !important;\n  }\n  .mb-md-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-md-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-md-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-md-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-md-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-md-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-md-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-md-0 {\n    margin-left: 0 !important;\n  }\n  .ms-md-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-md-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-md-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-md-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-md-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-md-auto {\n    margin-left: auto !important;\n  }\n  .p-md-0 {\n    padding: 0 !important;\n  }\n  .p-md-1 {\n    padding: 0.25rem !important;\n  }\n  .p-md-2 {\n    padding: 0.5rem !important;\n  }\n  .p-md-3 {\n    padding: 1rem !important;\n  }\n  .p-md-4 {\n    padding: 1.5rem !important;\n  }\n  .p-md-5 {\n    padding: 3rem !important;\n  }\n  .px-md-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-md-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-md-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-md-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-md-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-md-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-md-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-md-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-md-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-md-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-md-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-md-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-md-0 {\n    padding-top: 0 !important;\n  }\n  .pt-md-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-md-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-md-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-md-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-md-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-md-0 {\n    padding-right: 0 !important;\n  }\n  .pe-md-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-md-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-md-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-md-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-md-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-md-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-md-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-md-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-md-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-md-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-md-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-md-0 {\n    padding-left: 0 !important;\n  }\n  .ps-md-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-md-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-md-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-md-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-md-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-md-0 {\n    gap: 0 !important;\n  }\n  .gap-md-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-md-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-md-3 {\n    gap: 1rem !important;\n  }\n  .gap-md-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-md-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-md-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-md-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-md-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-md-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-md-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-md-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-md-0 {\n    -moz-column-gap: 0 !important;\n    column-gap: 0 !important;\n  }\n  .column-gap-md-1 {\n    -moz-column-gap: 0.25rem !important;\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-md-2 {\n    -moz-column-gap: 0.5rem !important;\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-md-3 {\n    -moz-column-gap: 1rem !important;\n    column-gap: 1rem !important;\n  }\n  .column-gap-md-4 {\n    -moz-column-gap: 1.5rem !important;\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-md-5 {\n    -moz-column-gap: 3rem !important;\n    column-gap: 3rem !important;\n  }\n  .text-md-start {\n    text-align: left !important;\n  }\n  .text-md-end {\n    text-align: right !important;\n  }\n  .text-md-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 992px) {\n  .float-lg-start {\n    float: left !important;\n  }\n  .float-lg-end {\n    float: right !important;\n  }\n  .float-lg-none {\n    float: none !important;\n  }\n  .object-fit-lg-contain {\n    -o-object-fit: contain !important;\n    object-fit: contain !important;\n  }\n  .object-fit-lg-cover {\n    -o-object-fit: cover !important;\n    object-fit: cover !important;\n  }\n  .object-fit-lg-fill {\n    -o-object-fit: fill !important;\n    object-fit: fill !important;\n  }\n  .object-fit-lg-scale {\n    -o-object-fit: scale-down !important;\n    object-fit: scale-down !important;\n  }\n  .object-fit-lg-none {\n    -o-object-fit: none !important;\n    object-fit: none !important;\n  }\n  .d-lg-inline {\n    display: inline !important;\n  }\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n  .d-lg-block {\n    display: block !important;\n  }\n  .d-lg-grid {\n    display: grid !important;\n  }\n  .d-lg-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-lg-table {\n    display: table !important;\n  }\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n  .d-lg-flex {\n    display: flex !important;\n  }\n  .d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-lg-none {\n    display: none !important;\n  }\n  .flex-lg-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-lg-row {\n    flex-direction: row !important;\n  }\n  .flex-lg-column {\n    flex-direction: column !important;\n  }\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-lg-center {\n    justify-content: center !important;\n  }\n  .justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-lg-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-lg-start {\n    align-items: flex-start !important;\n  }\n  .align-items-lg-end {\n    align-items: flex-end !important;\n  }\n  .align-items-lg-center {\n    align-items: center !important;\n  }\n  .align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-lg-start {\n    align-content: flex-start !important;\n  }\n  .align-content-lg-end {\n    align-content: flex-end !important;\n  }\n  .align-content-lg-center {\n    align-content: center !important;\n  }\n  .align-content-lg-between {\n    align-content: space-between !important;\n  }\n  .align-content-lg-around {\n    align-content: space-around !important;\n  }\n  .align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-lg-auto {\n    align-self: auto !important;\n  }\n  .align-self-lg-start {\n    align-self: flex-start !important;\n  }\n  .align-self-lg-end {\n    align-self: flex-end !important;\n  }\n  .align-self-lg-center {\n    align-self: center !important;\n  }\n  .align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n  .order-lg-first {\n    order: -1 !important;\n  }\n  .order-lg-0 {\n    order: 0 !important;\n  }\n  .order-lg-1 {\n    order: 1 !important;\n  }\n  .order-lg-2 {\n    order: 2 !important;\n  }\n  .order-lg-3 {\n    order: 3 !important;\n  }\n  .order-lg-4 {\n    order: 4 !important;\n  }\n  .order-lg-5 {\n    order: 5 !important;\n  }\n  .order-lg-last {\n    order: 6 !important;\n  }\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n  .m-lg-1 {\n    margin: 0.25rem !important;\n  }\n  .m-lg-2 {\n    margin: 0.5rem !important;\n  }\n  .m-lg-3 {\n    margin: 1rem !important;\n  }\n  .m-lg-4 {\n    margin: 1.5rem !important;\n  }\n  .m-lg-5 {\n    margin: 3rem !important;\n  }\n  .m-lg-auto {\n    margin: auto !important;\n  }\n  .mx-lg-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-lg-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-lg-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-lg-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-lg-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-lg-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-lg-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-lg-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-lg-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-lg-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-lg-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-lg-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-lg-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-lg-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-lg-0 {\n    margin-top: 0 !important;\n  }\n  .mt-lg-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-lg-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-lg-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-lg-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-lg-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-lg-auto {\n    margin-top: auto !important;\n  }\n  .me-lg-0 {\n    margin-right: 0 !important;\n  }\n  .me-lg-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-lg-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-lg-3 {\n    margin-right: 1rem !important;\n  }\n  .me-lg-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-lg-5 {\n    margin-right: 3rem !important;\n  }\n  .me-lg-auto {\n    margin-right: auto !important;\n  }\n  .mb-lg-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-lg-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-lg-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-lg-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-lg-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-lg-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-lg-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-lg-0 {\n    margin-left: 0 !important;\n  }\n  .ms-lg-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-lg-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-lg-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-lg-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-lg-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-lg-auto {\n    margin-left: auto !important;\n  }\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n  .p-lg-1 {\n    padding: 0.25rem !important;\n  }\n  .p-lg-2 {\n    padding: 0.5rem !important;\n  }\n  .p-lg-3 {\n    padding: 1rem !important;\n  }\n  .p-lg-4 {\n    padding: 1.5rem !important;\n  }\n  .p-lg-5 {\n    padding: 3rem !important;\n  }\n  .px-lg-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-lg-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-lg-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-lg-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-lg-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-lg-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-lg-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-lg-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-lg-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-lg-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-lg-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-lg-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-lg-0 {\n    padding-top: 0 !important;\n  }\n  .pt-lg-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-lg-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-lg-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-lg-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-lg-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-lg-0 {\n    padding-right: 0 !important;\n  }\n  .pe-lg-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-lg-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-lg-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-lg-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-lg-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-lg-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-lg-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-lg-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-lg-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-lg-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-lg-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-lg-0 {\n    padding-left: 0 !important;\n  }\n  .ps-lg-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-lg-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-lg-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-lg-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-lg-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-lg-0 {\n    gap: 0 !important;\n  }\n  .gap-lg-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-lg-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-lg-3 {\n    gap: 1rem !important;\n  }\n  .gap-lg-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-lg-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-lg-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-lg-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-lg-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-lg-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-lg-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-lg-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-lg-0 {\n    -moz-column-gap: 0 !important;\n    column-gap: 0 !important;\n  }\n  .column-gap-lg-1 {\n    -moz-column-gap: 0.25rem !important;\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-lg-2 {\n    -moz-column-gap: 0.5rem !important;\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-lg-3 {\n    -moz-column-gap: 1rem !important;\n    column-gap: 1rem !important;\n  }\n  .column-gap-lg-4 {\n    -moz-column-gap: 1.5rem !important;\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-lg-5 {\n    -moz-column-gap: 3rem !important;\n    column-gap: 3rem !important;\n  }\n  .text-lg-start {\n    text-align: left !important;\n  }\n  .text-lg-end {\n    text-align: right !important;\n  }\n  .text-lg-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .float-xl-start {\n    float: left !important;\n  }\n  .float-xl-end {\n    float: right !important;\n  }\n  .float-xl-none {\n    float: none !important;\n  }\n  .object-fit-xl-contain {\n    -o-object-fit: contain !important;\n    object-fit: contain !important;\n  }\n  .object-fit-xl-cover {\n    -o-object-fit: cover !important;\n    object-fit: cover !important;\n  }\n  .object-fit-xl-fill {\n    -o-object-fit: fill !important;\n    object-fit: fill !important;\n  }\n  .object-fit-xl-scale {\n    -o-object-fit: scale-down !important;\n    object-fit: scale-down !important;\n  }\n  .object-fit-xl-none {\n    -o-object-fit: none !important;\n    object-fit: none !important;\n  }\n  .d-xl-inline {\n    display: inline !important;\n  }\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xl-block {\n    display: block !important;\n  }\n  .d-xl-grid {\n    display: grid !important;\n  }\n  .d-xl-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-xl-table {\n    display: table !important;\n  }\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xl-flex {\n    display: flex !important;\n  }\n  .d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xl-none {\n    display: none !important;\n  }\n  .flex-xl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xl-row {\n    flex-direction: row !important;\n  }\n  .flex-xl-column {\n    flex-direction: column !important;\n  }\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xl-center {\n    align-items: center !important;\n  }\n  .align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xl-center {\n    align-content: center !important;\n  }\n  .align-content-xl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xl-center {\n    align-self: center !important;\n  }\n  .align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xl-first {\n    order: -1 !important;\n  }\n  .order-xl-0 {\n    order: 0 !important;\n  }\n  .order-xl-1 {\n    order: 1 !important;\n  }\n  .order-xl-2 {\n    order: 2 !important;\n  }\n  .order-xl-3 {\n    order: 3 !important;\n  }\n  .order-xl-4 {\n    order: 4 !important;\n  }\n  .order-xl-5 {\n    order: 5 !important;\n  }\n  .order-xl-last {\n    order: 6 !important;\n  }\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n  .m-xl-1 {\n    margin: 0.25rem !important;\n  }\n  .m-xl-2 {\n    margin: 0.5rem !important;\n  }\n  .m-xl-3 {\n    margin: 1rem !important;\n  }\n  .m-xl-4 {\n    margin: 1.5rem !important;\n  }\n  .m-xl-5 {\n    margin: 3rem !important;\n  }\n  .m-xl-auto {\n    margin: auto !important;\n  }\n  .mx-xl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-xl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-xl-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-xl-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xl-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-xl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-xl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-xl-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-xl-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xl-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-xl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-xl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-xl-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-xl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xl-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-xl-auto {\n    margin-top: auto !important;\n  }\n  .me-xl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-xl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-xl-3 {\n    margin-right: 1rem !important;\n  }\n  .me-xl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xl-5 {\n    margin-right: 3rem !important;\n  }\n  .me-xl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-xl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-xl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-xl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-xl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-xl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-xl-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-xl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xl-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-xl-auto {\n    margin-left: auto !important;\n  }\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n  .p-xl-1 {\n    padding: 0.25rem !important;\n  }\n  .p-xl-2 {\n    padding: 0.5rem !important;\n  }\n  .p-xl-3 {\n    padding: 1rem !important;\n  }\n  .p-xl-4 {\n    padding: 1.5rem !important;\n  }\n  .p-xl-5 {\n    padding: 3rem !important;\n  }\n  .px-xl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-xl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-xl-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-xl-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xl-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-xl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-xl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-xl-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-xl-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xl-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-xl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-xl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-xl-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-xl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xl-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-xl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-xl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-xl-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-xl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xl-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-xl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-xl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-xl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-xl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xl-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-xl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-xl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-xl-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-xl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xl-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-xl-0 {\n    gap: 0 !important;\n  }\n  .gap-xl-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-xl-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-xl-3 {\n    gap: 1rem !important;\n  }\n  .gap-xl-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-xl-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-xl-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-xl-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-xl-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-xl-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-xl-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-xl-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-xl-0 {\n    -moz-column-gap: 0 !important;\n    column-gap: 0 !important;\n  }\n  .column-gap-xl-1 {\n    -moz-column-gap: 0.25rem !important;\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-xl-2 {\n    -moz-column-gap: 0.5rem !important;\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-xl-3 {\n    -moz-column-gap: 1rem !important;\n    column-gap: 1rem !important;\n  }\n  .column-gap-xl-4 {\n    -moz-column-gap: 1.5rem !important;\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-xl-5 {\n    -moz-column-gap: 3rem !important;\n    column-gap: 3rem !important;\n  }\n  .text-xl-start {\n    text-align: left !important;\n  }\n  .text-xl-end {\n    text-align: right !important;\n  }\n  .text-xl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1400px) {\n  .float-xxl-start {\n    float: left !important;\n  }\n  .float-xxl-end {\n    float: right !important;\n  }\n  .float-xxl-none {\n    float: none !important;\n  }\n  .object-fit-xxl-contain {\n    -o-object-fit: contain !important;\n    object-fit: contain !important;\n  }\n  .object-fit-xxl-cover {\n    -o-object-fit: cover !important;\n    object-fit: cover !important;\n  }\n  .object-fit-xxl-fill {\n    -o-object-fit: fill !important;\n    object-fit: fill !important;\n  }\n  .object-fit-xxl-scale {\n    -o-object-fit: scale-down !important;\n    object-fit: scale-down !important;\n  }\n  .object-fit-xxl-none {\n    -o-object-fit: none !important;\n    object-fit: none !important;\n  }\n  .d-xxl-inline {\n    display: inline !important;\n  }\n  .d-xxl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xxl-block {\n    display: block !important;\n  }\n  .d-xxl-grid {\n    display: grid !important;\n  }\n  .d-xxl-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-xxl-table {\n    display: table !important;\n  }\n  .d-xxl-table-row {\n    display: table-row !important;\n  }\n  .d-xxl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xxl-flex {\n    display: flex !important;\n  }\n  .d-xxl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xxl-none {\n    display: none !important;\n  }\n  .flex-xxl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xxl-row {\n    flex-direction: row !important;\n  }\n  .flex-xxl-column {\n    flex-direction: column !important;\n  }\n  .flex-xxl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xxl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xxl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xxl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xxl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xxl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xxl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xxl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xxl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-xxl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xxl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xxl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xxl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xxl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xxl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xxl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xxl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xxl-center {\n    align-items: center !important;\n  }\n  .align-items-xxl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xxl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xxl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xxl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xxl-center {\n    align-content: center !important;\n  }\n  .align-content-xxl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xxl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xxl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xxl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xxl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xxl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xxl-center {\n    align-self: center !important;\n  }\n  .align-self-xxl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xxl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xxl-first {\n    order: -1 !important;\n  }\n  .order-xxl-0 {\n    order: 0 !important;\n  }\n  .order-xxl-1 {\n    order: 1 !important;\n  }\n  .order-xxl-2 {\n    order: 2 !important;\n  }\n  .order-xxl-3 {\n    order: 3 !important;\n  }\n  .order-xxl-4 {\n    order: 4 !important;\n  }\n  .order-xxl-5 {\n    order: 5 !important;\n  }\n  .order-xxl-last {\n    order: 6 !important;\n  }\n  .m-xxl-0 {\n    margin: 0 !important;\n  }\n  .m-xxl-1 {\n    margin: 0.25rem !important;\n  }\n  .m-xxl-2 {\n    margin: 0.5rem !important;\n  }\n  .m-xxl-3 {\n    margin: 1rem !important;\n  }\n  .m-xxl-4 {\n    margin: 1.5rem !important;\n  }\n  .m-xxl-5 {\n    margin: 3rem !important;\n  }\n  .m-xxl-auto {\n    margin: auto !important;\n  }\n  .mx-xxl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xxl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-xxl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-xxl-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-xxl-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xxl-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-xxl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xxl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xxl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-xxl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-xxl-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-xxl-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xxl-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-xxl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xxl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xxl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-xxl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-xxl-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-xxl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xxl-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-xxl-auto {\n    margin-top: auto !important;\n  }\n  .me-xxl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xxl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-xxl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-xxl-3 {\n    margin-right: 1rem !important;\n  }\n  .me-xxl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xxl-5 {\n    margin-right: 3rem !important;\n  }\n  .me-xxl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xxl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xxl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-xxl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-xxl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-xxl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xxl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-xxl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xxl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xxl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-xxl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-xxl-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-xxl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xxl-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-xxl-auto {\n    margin-left: auto !important;\n  }\n  .p-xxl-0 {\n    padding: 0 !important;\n  }\n  .p-xxl-1 {\n    padding: 0.25rem !important;\n  }\n  .p-xxl-2 {\n    padding: 0.5rem !important;\n  }\n  .p-xxl-3 {\n    padding: 1rem !important;\n  }\n  .p-xxl-4 {\n    padding: 1.5rem !important;\n  }\n  .p-xxl-5 {\n    padding: 3rem !important;\n  }\n  .px-xxl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xxl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-xxl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-xxl-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-xxl-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xxl-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-xxl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xxl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-xxl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-xxl-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-xxl-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xxl-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-xxl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xxl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-xxl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-xxl-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-xxl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xxl-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-xxl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xxl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-xxl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-xxl-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-xxl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xxl-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-xxl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xxl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-xxl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-xxl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-xxl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xxl-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-xxl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xxl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-xxl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-xxl-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-xxl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xxl-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-xxl-0 {\n    gap: 0 !important;\n  }\n  .gap-xxl-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-xxl-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-xxl-3 {\n    gap: 1rem !important;\n  }\n  .gap-xxl-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-xxl-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-xxl-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-xxl-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-xxl-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-xxl-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-xxl-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-xxl-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-xxl-0 {\n    -moz-column-gap: 0 !important;\n    column-gap: 0 !important;\n  }\n  .column-gap-xxl-1 {\n    -moz-column-gap: 0.25rem !important;\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-xxl-2 {\n    -moz-column-gap: 0.5rem !important;\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-xxl-3 {\n    -moz-column-gap: 1rem !important;\n    column-gap: 1rem !important;\n  }\n  .column-gap-xxl-4 {\n    -moz-column-gap: 1.5rem !important;\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-xxl-5 {\n    -moz-column-gap: 3rem !important;\n    column-gap: 3rem !important;\n  }\n  .text-xxl-start {\n    text-align: left !important;\n  }\n  .text-xxl-end {\n    text-align: right !important;\n  }\n  .text-xxl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .fs-1 {\n    font-size: 2.5rem !important;\n  }\n  .fs-2 {\n    font-size: 2rem !important;\n  }\n  .fs-3 {\n    font-size: 1.75rem !important;\n  }\n  .fs-4 {\n    font-size: 1.5rem !important;\n  }\n}\n@media print {\n  .d-print-inline {\n    display: inline !important;\n  }\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n  .d-print-block {\n    display: block !important;\n  }\n  .d-print-grid {\n    display: grid !important;\n  }\n  .d-print-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-print-table {\n    display: table !important;\n  }\n  .d-print-table-row {\n    display: table-row !important;\n  }\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n  .d-print-flex {\n    display: flex !important;\n  }\n  .d-print-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-print-none {\n    display: none !important;\n  }\n}\n\n/*# sourceMappingURL=bootstrap.css.map */","// =======================================\n//     List of variables for layout\n// =======================================\n/*\n    description Of variables for build for theme layouts\n        1) menu-caption-color\n            List of color for sidebar menu caption\n\n        2) brand-background\n            List of color for logo background\n\n        3) header-dark-background\n            List of color for Dark Header\n\n        4) header-light-background\n            List of color for light Header\n\n        5) menu-dark-background\n            List of color for Dark sidebar menu\n\n        6) menu-light-background\n            List of color for light sidebar menu\n\n        7) menu-active-color\n            List of color for Active item highliter\n\n        8) menu-icon-color\n            List of color for sidebar menu items icon colors\n*/\n$header-height: 70px;\n$Menu-width: 264px;\n$Menu-collapsed-width: 80px;\n\n// color list for build layouts\n// temp variables\n$theme-color: linear-gradient(-135deg, #1de9b6 0%, #1dc4e9 100%);\n$theme-color2: linear-gradient(-135deg, #899fd4 0%, #a389d4 100%);\n$primary-color: #04a9f5;\n$warning-color: #f4c22b;\n$danger-color: #f44236;\n$success-color: #1de9b6;\n$purple-color: #a389d4;\n$info-color: #17a2b8;\n$secondary-color: #748892;\n$default-color: #d6d6d6;\n$light-color: #f2f2f2;\n$dark-color: #37474f;\n$inverse-color: $dark-color;\n$theme-border: #eaeaea;\n\n// header\n$brand-background: #3f4d67;\n$header-dark-background: #3f4d67;\n$header-dark-text-color: #fff;\n$header-light-background: #fff;\n$header-light-text-color: #3f4d67;\n\n// Menu\n$menu-caption-color: #14171d;\n$menu-dark-background: #3f4d67;\n$menu-dark-text-color: #a9b7d0;\n$menu-light-background: #fff;\n$menu-light-text-color: #3f4d67;\n$menu-active-color: #04a9f5;\n\n// dark layout colors\n$dark-layout: #212224;\n$dark-layout-font: #adb7be;\n\n// Menu icon\n$menu-icon-color: $primary-color, #ff5252, #01a9ac, #9575cd, #23b7e5, $warning-color;\n// Header background\n$color-header-name: blue, red, purple, lightblue, dark;\n$color-header-color: $primary-color, #ff5252, #9575cd, #23b7e5, lighten($dark-layout, 7%);\n// Menu background\n$color-menu-name: blue, red, purple, lightblue, dark;\n$color-menu-color: $primary-color, #ff5252, #9575cd, #23b7e5, lighten($dark-layout, 7%);\n// Active background color\n$color-active-name: blue, red, purple, lightblue, dark;\n$color-active-color: $primary-color, #ff5252, #9575cd, #23b7e5, lighten($dark-layout, 7%);\n// Menu title color\n$color-title-name: blue, red, purple, lightblue, dark;\n$color-title-color: $primary-color, #ff5252, #9575cd, #23b7e5, lighten($dark-layout, 7%);\n\n// layout-6 background color\n$layout-6-bg-color: #23b7e5;\n\n$theme-font-family: 'Open Sans', sans-serif;\n$theme-font-size: 14px;\n$theme-background: #f4f7fa;\n$theme-font-color: #888;\n$theme-heading-color: #111;\n\n$color-name: c-blue, c-red, c-green, c-yellow, c-purple;\n$color-color: $primary-color, $danger-color, $success-color, $warning-color, $purple-color;\n$color-bt-name: primary, danger, success, warning, info;\n$color-bt-color: $primary-color, $danger-color, $success-color, $warning-color, $info-color;\n\n// form-control variables\n$form-bg: #f0f3f6;\n\n$theme-colors: () !default;\n$theme-colors: map-merge(\n  (\n    'primary': $primary-color,\n    'secondary': $secondary-color,\n    'success': $success-color,\n    'info': $info-color,\n    'warning': $warning-color,\n    'danger': $danger-color,\n    'light': $light-color,\n    'dark': $dark-color\n  ),\n  $theme-colors\n); // Color contrast\n$yiq-contrasted-threshold: 200 !default;\n$yiq-dark-color: #37474f;\n$yiq-light-color: #fff;\n$theme-color-interval: 8% !default;\n$alert-bg-level: -10 !default;\n$alert-border-level: -9 !default;\n$alert-color-level: 6 !default;\n\n:root {\n  --bs-body-color: #888;\n}\n\n.breadcrumb {\n  --bs-breadcrumb-padding-x: 1rem;\n  --bs-breadcrumb-padding-y: 0.75rem;\n}\n","/**  =====================\n      Custom css start\n==========================  **/\nbody {\n  font-family: $theme-font-family;\n  font-size: $theme-font-size;\n  color: $theme-font-color;\n  font-weight: 400;\n  background: $theme-background;\n  position: relative;\n}\n\n* {\n  &:focus {\n    outline: none;\n  }\n}\n\na {\n  &:hover {\n    outline: none;\n  }\n\n  text-decoration: none;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  color: $theme-heading-color;\n  font-weight: 400;\n}\n\nh1 {\n  font-size: 48px;\n}\n\nh2 {\n  font-size: 44px;\n}\n\nh3 {\n  font-size: 26px;\n}\n\nh4 {\n  font-size: 20px;\n}\n\nh5 {\n  font-size: 18px;\n}\n\nh6 {\n  font-size: 14px;\n}\n\np {\n  font-size: 14px;\n}\n\nstrong {\n  font-weight: 400;\n}\n\nlabel {\n  margin-bottom: 0.5rem;\n}\n\n.img-radius {\n  border-radius: 50%;\n}\n\n.page-header-title + .breadcrumb {\n  background: transparent;\n  padding: 0;\n\n  > .breadcrumb-item {\n    a {\n      color: #888;\n    }\n\n    &:last-child a {\n      color: #111;\n      font-weight: 600;\n    }\n  }\n}\n\n.theme-bg {\n  background: $theme-color;\n}\n\n.theme-bg2 {\n  background: $theme-color2;\n}\n\n/* ==========  card css start  =========== */\n\n.anim-rotate {\n  animation: anim-rotate 1s linear infinite;\n}\n\n@keyframes anim-rotate {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.anim-close-card {\n  animation: anim-close-card 1.4s linear;\n}\n\n@keyframes anim-close-card {\n  100% {\n    opacity: 0.3;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n}\n\np.text-muted {\n  font-size: 13px;\n}\n\n.card {\n  border-radius: 0;\n  box-shadow: 0 1px 20px 0 rgba(69, 90, 100, 0.08);\n  border: none;\n  margin-bottom: 30px;\n  transition: all 0.5s ease-in-out;\n  --bs-card-title-color: #111;\n  .card-header {\n    background-color: transparent;\n    border-bottom: 1px solid #f1f1f1;\n    padding: 20px 25px;\n    position: relative;\n\n    h5 {\n      margin-bottom: 0;\n      color: #000;\n      font-size: 17px;\n      font-weight: 400;\n      display: inline-block;\n      margin-right: 10px;\n      line-height: 1.1;\n      position: relative;\n\n      &:after {\n        content: '';\n        background-color: $primary-color;\n        position: absolute;\n        left: -25px;\n        top: 0;\n        width: 4px;\n        height: 20px;\n      }\n    }\n\n    &.borderless {\n      border-bottom: none;\n\n      h5:after {\n        display: none;\n      }\n    }\n\n    .card-header-right {\n      right: 10px;\n      top: 10px;\n      display: inline-block;\n      float: right;\n      padding: 0;\n      position: absolute;\n\n      @media only screen and (max-width: 575px) {\n        display: none;\n      }\n\n      .dropdown-menu {\n        margin-top: 0;\n\n        li {\n          a {\n            font-size: 14px;\n            text-transform: capitalize;\n          }\n        }\n      }\n\n      .btn.dropdown-toggle {\n        border: none;\n        background: transparent;\n        box-shadow: none;\n        color: #888;\n\n        i {\n          margin-right: 0;\n        }\n\n        &:after {\n          display: none;\n        }\n\n        &:focus {\n          box-shadow: none;\n          outline: none;\n        }\n      }\n    }\n  }\n\n  .card-footer {\n    border-top: 1px solid #f1f1f1;\n    background: transparent;\n    padding: 25px;\n  }\n\n  .card-block,\n  .card-body {\n    padding: 30px 25px;\n  }\n\n  &.card-load {\n    position: relative;\n    overflow: hidden;\n\n    .card-loader {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      background-color: rgba(256, 256, 256, 0.7);\n      z-index: 999;\n\n      i {\n        margin: 0 auto;\n        color: $primary-color;\n        font-size: 24px;\n        align-items: center;\n        display: flex;\n      }\n    }\n  }\n\n  &.full-card {\n    z-index: 99999;\n    border-radius: 0;\n  }\n}\n\n/* ==========  scrollbar End  =========== */\n\n.scroll-y {\n  z-index: 1027;\n}\n\n/* ==========  scrollbar End  ===========\n ==========  card css End  ===========\n ================================    Dropdown Start  ===================== */\n\n.dropdown-menu {\n  padding: 20px 0;\n  margin-top: 15px;\n  box-shadow: 0 1px 10px 0 rgba(69, 90, 100, 0.2);\n  border: none;\n\n  &.show {\n    &:before {\n      content: '\\63';\n      font-family: 'pct';\n      position: absolute;\n      left: 115px;\n      top: -5px;\n      z-index: 1001;\n      font-size: 40px;\n      line-height: 0;\n      color: #fff;\n      text-shadow: 0 -2px 2px rgba(69, 90, 100, 0.12);\n    }\n\n    &.dropdown-menu-right {\n      &:before {\n        left: auto;\n        right: 5px;\n      }\n    }\n  }\n\n  &[x-placement='top-start'] {\n    margin-bottom: 15px;\n    margin-top: 0;\n\n    &.show {\n      &:before {\n        content: '\\64';\n        bottom: -5px;\n        top: auto;\n        text-shadow: 0 2px 2px rgba(69, 90, 100, 0.12);\n      }\n    }\n  }\n\n  > li {\n    padding-left: 15px;\n    padding-right: 15px;\n\n    > a {\n      padding: 5px;\n      color: $theme-font-color;\n\n      i {\n        font-size: 15px;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        margin-right: 10px;\n      }\n    }\n\n    &.active,\n    &:active,\n    &:focus,\n    &:hover {\n      background: transparentize($primary-color, 0.9);\n\n      > a {\n        background: transparent;\n      }\n    }\n  }\n}\n\n/* ================================    Dropdown End  ===================== */\n@media (min-width: 1600px) {\n  .container {\n    max-width: 1540px;\n  }\n}\n\n@media (max-width: 992px) {\n  .container {\n    max-width: 100%;\n  }\n}\n\n/* ========================================================\n ===============     document      ======================\n ========================================================\n\n Grid examples\n*/\n\n.bd-example-row {\n  background: $theme-background;\n  padding: 15px;\n  margin-bottom: 15px;\n\n  .row {\n    > [class^='col-'],\n    > .col {\n      padding-top: 0.75rem;\n      padding-bottom: 0.75rem;\n      background-color: rgba(86, 61, 124, 0.15);\n      border: 1px solid rgba(86, 61, 124, 0.2);\n    }\n  }\n\n  .row + .row {\n    margin-top: 1rem;\n  }\n\n  .flex-items-bottom,\n  .flex-items-middle,\n  .flex-items-top {\n    min-height: 6rem;\n    background-color: rgba(255, 0, 0, 0.1);\n  }\n}\n\n.bd-example-row-flex-cols .row {\n  min-height: 10rem;\n  background-color: rgba(255, 0, 0, 0.1);\n}\n\n/* Docs examples */\n\n.bd-example {\n  position: relative;\n  padding: 1rem;\n  margin: 1rem;\n  border: solid #ddd;\n  border-width: 0.2rem 0 0;\n\n  @media only screen and (max-height: 575px) {\n    padding: 1.5rem;\n    margin-right: 0;\n    margin-left: 0;\n    border-width: 0.2rem;\n  }\n}\n\n/* Example modals */\n\n.modal {\n  z-index: 1072;\n\n  .popover,\n  .tooltip {\n    z-index: 1073;\n  }\n}\n\n.modal-backdrop {\n  z-index: 1071;\n}\n\n.bd-example-modal {\n  background-color: #fafafa;\n\n  .modal {\n    position: relative;\n    top: auto;\n    right: auto;\n    bottom: auto;\n    left: auto;\n    z-index: 1;\n    display: block;\n  }\n\n  .modal-dialog {\n    left: auto;\n    margin-right: auto;\n    margin-left: auto;\n  }\n}\n\n/* Example tabbable tabs */\n\n.bd-example-tabs .nav-tabs {\n  margin-bottom: 1rem;\n}\n\n/* Code snippets */\n\n.highlight {\n  padding: 1rem;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  background-color: #f3f2fb;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n\n  @media only screen and (max-height: 575px) {\n    padding: 1.5rem;\n  }\n}\n\n.bd-content .highlight {\n  margin-right: 15px;\n  margin-left: 15px;\n\n  @media only screen and (max-height: 575px) {\n    margin-right: 0;\n    margin-left: 0;\n  }\n}\n\n.highlight {\n  pre {\n    padding: 0;\n    margin-top: 0;\n    margin-bottom: 0;\n    background-color: transparent;\n    border: 0;\n  }\n\n  pre code {\n    font-size: inherit;\n    color: #333;\n  }\n}\n\n/* =======================================================================\n ===============     Ui kit copy model style      ====================== */\n\n/* Code examples */\n.datta-example {\n  position: relative;\n\n  .datta-example-btns {\n    position: absolute;\n    right: 30px;\n    top: -10px;\n    opacity: 0;\n    transform: rotateX(-90deg);\n    transition: all 0.3s ease-in-out;\n\n    .datta-example-btn {\n      display: inline-block;\n      line-height: 1;\n      font-weight: 600;\n      background: $primary-color;\n      color: #fff;\n      padding: 0.1875rem 0.3125rem;\n      border-radius: 2px;\n      white-space: nowrap;\n      font-size: 11px;\n      margin: 0 4px;\n\n      &.copy::before {\n        content: 'COPY';\n      }\n\n      &.copied {\n        background: $success-color !important;\n        color: #fff !important;\n\n        &::before {\n          content: 'COPIED!';\n        }\n      }\n    }\n  }\n\n  &:hover .datta-example-btns {\n    top: -21px;\n    transform: rotateX(0deg);\n    opacity: 1;\n  }\n}\n\n/* Modal */\n\n.datta-example-modal {\n  position: fixed;\n  z-index: 1099;\n  top: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  background: #282c34;\n  transform-origin: 50% 0;\n  transform: scale(0);\n  transition: all 0.3s ease-in-out;\n}\n\n.datta-example-modal-opened {\n  overflow: hidden !important;\n\n  .datta-example-modal {\n    transform: scale(1);\n  }\n}\n\n.datta-example-modal-content {\n  max-width: 100vw;\n  margin: auto;\n  padding: 50px;\n  height: 100vh;\n  overflow: auto;\n\n  > pre {\n    overflow: hidden;\n    width: fit-content;\n\n    > code {\n      padding: 0;\n      background: none;\n      font-size: 16px;\n    }\n  }\n}\n\n.md-datta-example-modal-copy {\n  display: block;\n  position: fixed;\n  top: 90px;\n  right: 30px;\n  margin-right: 8px;\n  font-size: 1.5rem;\n  border-radius: 50%;\n  padding: 10px 15px;\n  background: $primary-color;\n  color: #fff;\n  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);\n  z-index: 1;\n  white-space: nowrap;\n\n  &:hover {\n    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);\n    color: #fff;\n  }\n\n  &.copied::before {\n    content: 'Copied to Clipboard Successfully ! . . .';\n    position: absolute;\n    display: block;\n    right: 100%;\n    margin-right: 10px;\n    font-size: 14px;\n    background: $success-color;\n    line-height: 24px;\n    height: 24px;\n    border-radius: 3px;\n    padding: 0 6px;\n    top: 50%;\n    margin-top: -12px;\n  }\n}\n\n.datta-example-modal-close {\n  display: block;\n  position: fixed;\n  top: 10px;\n  right: 52px;\n  color: #fff;\n  opacity: 0.2;\n  font-size: 3rem;\n  font-weight: 100;\n  transition: all 0.3s ease-in-out;\n  z-index: 1;\n\n  &:hover {\n    color: #fff;\n    opacity: 0.9;\n  }\n}\n\n/* Code */\n.cui-bottom-spacer {\n  height: 12rem;\n}\n\n/* editor style for model */\n.hljs {\n  padding: 0.5em;\n  color: #abb2bf;\n  background: #282c34;\n}\n\n.hljs-comment,\n.hljs-quote {\n  color: #5c6370;\n  font-style: italic;\n}\n\n.hljs-doctag,\n.hljs-formula,\n.hljs-keyword {\n  color: #c678dd;\n}\n\n.hljs-deletion,\n.hljs-name,\n.hljs-section,\n.hljs-selector-tag,\n.hljs-subst {\n  color: #e06c75;\n}\n\n.hljs-literal {\n  color: #56b6c2;\n}\n\n.hljs-addition,\n.hljs-attribute,\n.hljs-meta-string,\n.hljs-regexp,\n.hljs-string {\n  color: #98c379;\n}\n\n.hljs-built_in,\n.hljs-class .hljs-title {\n  color: #e6c07b;\n}\n\n.hljs-attr,\n.hljs-number,\n.hljs-selector-attr,\n.hljs-selector-class,\n.hljs-selector-pseudo,\n.hljs-template-variable,\n.hljs-type,\n.hljs-variable {\n  color: #d19a66;\n}\n\n.hljs-bullet,\n.hljs-link,\n.hljs-meta,\n.hljs-selector-id,\n.hljs-symbol,\n.hljs-title {\n  color: #61aeee;\n}\n\n.hljs-emphasis {\n  font-style: italic;\n}\n\n.hljs-strong {\n  font-weight: bold;\n}\n\n.hljs-link {\n  text-decoration: underline;\n}\n\n/* ================================    md animated mode start   ===================== */\n\n.md-show.md-effect-12 ~ .md-overlay {\n  background: $theme-color;\n}\n\n/* ================================    md animated mode End   ===================== */\n/* ================================    range slider Start  ===================== */\n\n.tooltip {\n  &.in {\n    opacity: 0.9;\n  }\n\n  .tooltip-arrow {\n    position: absolute;\n    width: 0;\n    height: 0;\n    border-color: transparent;\n    border-style: solid;\n  }\n\n  &.top {\n    padding: 5px 0;\n    margin-top: -3px;\n\n    .tooltip-arrow {\n      bottom: 0;\n      left: 50%;\n      margin-left: -5px;\n      border-width: 5px 5px 0;\n      border-top-color: #000;\n    }\n  }\n}\n/* ================================    range slider End  ===================== */\n\n/* ================================    Bootstrap tags input Start  ===================== */\n\n.bootstrap-tagsinput {\n  padding: 10px 15px;\n  box-shadow: none;\n  border-radius: 2px;\n  background: $form-bg;\n\n  .tag {\n    padding: 5px 12px;\n    border-radius: 2px;\n    line-height: 37px;\n    margin-top: 5px;\n    margin-right: 5px;\n\n    [data-role='remove'] {\n      margin-right: -5px;\n\n      &:after {\n        content: '\\e8f6';\n        padding: 0 2px;\n        font-family: 'feather' !important;\n      }\n    }\n  }\n}\n\n/* ================================    Bootstrap tags input End  ===================== */\n/* ================================    Multi-Select Start  ===================== */\n\n.ms-container {\n  width: 100%;\n}\n\n/* ================================    Multi-Select End  ===================== */\n/* ================================    Blockquote Start  ===================== */\n\n.blockquote {\n  border-left: 0.25rem solid $theme-border;\n  padding: 0.5rem 1rem;\n\n  &.text-right {\n    border-left: none;\n    border-right: 0.25rem solid $theme-border;\n  }\n}\n\n/* ================================    Blockquote End  ===================== */\n/* ================================    animation start  ===================== */\n\n.card .animated {\n  animation-duration: 1s;\n  border: 5px solid #fff;\n  margin-bottom: 30px;\n  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);\n}\n\n/* ================================    animation End  ===================== */\n/* ================================    browser  warning  Start  ===================== */\n\n.ie-warning {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999999;\n  background: #000000;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  color: #fff;\n  font-family: 'Courier New', Courier, monospace;\n  padding: 50px 0;\n\n  p {\n    font-size: 17px;\n  }\n\n  h1 {\n    color: #fff;\n  }\n\n  .iew-container {\n    min-width: 1024px;\n    width: 100%;\n    height: 200px;\n    background: #fff;\n    margin: 50px 0;\n  }\n\n  .iew-download {\n    list-style: none;\n    padding: 30px 0;\n    margin: 0 auto;\n    width: 720px;\n\n    > li {\n      float: left;\n      vertical-align: top;\n\n      > a {\n        display: block;\n        color: #000;\n        width: 140px;\n        font-size: 15px;\n        padding: 15px 0;\n\n        > div {\n          margin-top: 10px;\n        }\n\n        &:hover {\n          background-color: #eee;\n        }\n      }\n    }\n  }\n}\n\n/* ================================    browser  warning  End  ===================== */\n/* material icon for material datetime picker */\n/* fallback */\n@font-face {\n  font-family: 'Material Icons';\n  font-style: normal;\n  font-weight: 400;\n  src: url('https://fonts.gstatic.com/s/materialicons/v41/flUhRq6tzZclQEJ-Vdg-IuiaDsNc.woff2') format('woff2');\n}\n\n.material-icons {\n  font-family: 'Material Icons';\n  font-weight: normal;\n  font-style: normal;\n  font-size: 24px;\n  line-height: 1;\n  letter-spacing: normal;\n  text-transform: none;\n  display: inline-block;\n  white-space: nowrap;\n  word-wrap: normal;\n  direction: ltr;\n  -webkit-font-feature-settings: 'liga';\n  -webkit-font-smoothing: antialiased;\n}\n\n/* material icon for material datetime picker */\n.btn-link {\n  text-decoration: none;\n}\n\n.react-datepicker-wrapper {\n  display: block !important;\n}\n\n.table-dark {\n  --bs-table-bg: #37474f;\n}\n\n.table-info,\n.table-info > td,\n.table-info > th {\n  --bs-table-bg: #bee5eb;\n  background-color: #bee5eb;\n}\n\n.table {\n  --bs-table-striped-bg: rgba(4, 169, 245, 0.05);\n}\n\n.table-hover tbody tr:hover {\n  color: #212529;\n  background: rgba(4, 169, 245, 0.05);\n\n  > * {\n    --bs-table-color-state: #212529;\n  }\n}\n\n.table-hover > tbody > tr:hover > * {\n  --bs-table-bg-state: rgba(4, 169, 245, 0.05);\n}\n\n.btn-check:checked + .btn:not([class*='btn-']),\n:not(.btn-check) + .btn:active,\n.btn:first-child:active,\n.btn.active,\n.btn.show {\n  --bs-btn-active-bg: #04a9f5;\n  --bs-btn-active-border-color: #04a9f5;\n}\n\n.invoice-table.table tr td {\n  background: transparent;\n}\n\n.recent-users {\n  tr {\n    td {\n      &:first-child {\n        width: 60px;\n        padding-left: 20px;\n        padding-right: 0;\n      }\n\n      &:last-child {\n        text-align: center;\n      }\n    }\n  }\n}\n\n.blockquote-footer {\n  margin-top: 0;\n}\n\n.adv-task-board {\n  header {\n    display: flex;\n    align-items: center;\n\n    span {\n      span {\n        margin-right: 8px;\n      }\n    }\n  }\n}\n\n.swatches-picker,\n.photoshop-picker,\n.hue-picker,\n.alpha-picker {\n  width: 100% !important;\n}\n\n.grid figure.effect-moses figcaption {\n  @media (max-width: 575px) {\n    padding: 8px !important;\n\n    h2 {\n      font-size: 20px;\n    }\n  }\n}\n\n.btn.text-secondary.btn-link {\n  &:active,\n  &.active,\n  &.show {\n    color: #fff !important;\n  }\n}\n\n.alert-inverse {\n  .btn-close {\n    color: $yiq-light-color !important;\n    filter: invert(1) grayscale(100%) brightness(200%) !important;\n  }\n}\n","/**  =====================\n      Generic-class css start\n========================== **/\n/*====== Padding , Margin css starts ======*/\n$i: 0;\n@while $i<=50 {\n  .p {\n    &-#{$i} {\n      padding: #{$i}px;\n    }\n\n    &-t-#{$i} {\n      padding-top: #{$i}px;\n    }\n\n    &-b-#{$i} {\n      padding-bottom: #{$i}px;\n    }\n\n    &-l-#{$i} {\n      padding-left: #{$i}px;\n    }\n\n    &-r-#{$i} {\n      padding-right: #{$i}px;\n    }\n  }\n  .m {\n    &-#{$i} {\n      margin: #{$i}px;\n    }\n\n    &-t-#{$i} {\n      margin-top: #{$i}px;\n    }\n\n    &-b-#{$i} {\n      margin-bottom: #{$i}px;\n    }\n\n    &-l-#{$i} {\n      margin-left: #{$i}px;\n    }\n\n    &-r-#{$i} {\n      margin-right: #{$i}px;\n    }\n  }\n  $i: $i + 5;\n}\n/*====== Padding , Margin css ends ======*/\n\n/*====== text-color, background color css starts ======*/\n@each $value in $color-name {\n  $i: index($color-name, $value);\n  .bg-#{$value} {\n    background: nth($color-color, $i);\n  }\n  .text-#{$value} {\n    color: nth($color-color, $i);\n  }\n}\n/*====== text-color css ends ======*/\n/*====== Card top border css starts ======*/\n@each $value in $color-name {\n  $i: index($color-name, $value);\n  .card-border-#{$value} {\n    border-top: 4px solid nth($color-color, $i);\n  }\n}\n/*====== Card top border ends ======*/\n/*====== Font-size css starts ======*/\n$i: 10;\n@while $i<=80 {\n  .f-#{$i} {\n    font-size: #{$i}px;\n  }\n  $i: $i + 2;\n}\n/*====== Font-size css ends ======*/\n/*====== Font-weight css starts ======*/\n$i: 100;\n@while $i<=900 {\n  .f-w-#{$i} {\n    font-weight: #{$i};\n  }\n  $i: $i + 100;\n}\n/*====== Font-weight css ends ======*/\n/*====== width, Height css starts ======*/\n$i: 20;\n@while $i<=150 {\n  .wid-#{$i} {\n    width: #{$i}px;\n  }\n  .hei-#{$i} {\n    height: #{$i}px;\n  }\n  $i: $i + 5;\n}\n/*====== width, Height css ends ======*/\n","@charset \"UTF-8\";\n\n@font-face {\n  font-family: 'pct';\n  src: url('./fonts/pct.eot');\n  src: url('./fonts/pct.eot?#iefix') format('embedded-opentype'), url('./fonts/pct.woff') format('woff'),\n    url('./fonts/pct.ttf') format('truetype'), url('./fonts/pct.svg#pct') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n\n[data-icon]:before {\n  font-family: 'pct' !important;\n  content: attr(data-icon);\n  font-style: normal !important;\n  font-weight: normal !important;\n  font-variant: normal !important;\n  text-transform: none !important;\n  speak: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n[class^='pct-']:before,\n[class*=' pct-']:before {\n  font-family: 'pct' !important;\n  font-style: normal !important;\n  font-weight: normal !important;\n  font-variant: normal !important;\n  text-transform: none !important;\n  speak: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.pct-arrow1:before {\n  content: '\\61';\n}\n\n.pct-arrow2:before {\n  content: '\\62';\n}\n\n.pct-arrow3:before {\n  content: '\\63';\n}\n\n.pct-arrow4:before {\n  content: '\\64';\n}\n\n.pct-chat1:before {\n  content: '\\65';\n}\n\n.pct-chat2:before {\n  content: '\\66';\n}\n\n.pct-chat3:before {\n  content: '\\67';\n}\n\n.pct-chat4:before {\n  content: '\\68';\n}\n\n.pct-loader1:before {\n  content: '\\69';\n}\n\n.pct-arrow-sharp1:before {\n  content: '\\6a';\n}\n\n.pct-arrow-sharp2:before {\n  content: '\\6b';\n}\n\n.pct-arrow-sharp3:before {\n  content: '\\6c';\n}\n\n.pct-arrow-sharp4:before {\n  content: '\\6d';\n}\n","@font-face {\n  font-family: 'feather';\n  src: url('./fonts/feather.eot?t=1501841394106');\n  /* IE9*/\n  src: url('./fonts/feather.eot?t=1501841394106#iefix') format('embedded-opentype'),\n    url('./fonts/feather.woff?t=1501841394106') format('woff'), url('./fonts/feather.ttf?t=1501841394106') format('truetype'),\n    url('./fonts/feather.svg?t=1501841394106#feather') format('svg');\n  /* iOS 4.1- */\n}\n\n.feather {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'feather' !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-alert-octagon:before {\n  content: '\\e81b';\n}\n\n.icon-alert-circle:before {\n  content: '\\e81c';\n}\n\n.icon-activity:before {\n  content: '\\e81d';\n}\n\n.icon-alert-triangle:before {\n  content: '\\e81e';\n}\n\n.icon-align-center:before {\n  content: '\\e81f';\n}\n\n.icon-airplay:before {\n  content: '\\e820';\n}\n\n.icon-align-justify:before {\n  content: '\\e821';\n}\n\n.icon-align-left:before {\n  content: '\\e822';\n}\n\n.icon-align-right:before {\n  content: '\\e823';\n}\n\n.icon-arrow-down-left:before {\n  content: '\\e824';\n}\n\n.icon-arrow-down-right:before {\n  content: '\\e825';\n}\n\n.icon-anchor:before {\n  content: '\\e826';\n}\n\n.icon-aperture:before {\n  content: '\\e827';\n}\n\n.icon-arrow-left:before {\n  content: '\\e828';\n}\n\n.icon-arrow-right:before {\n  content: '\\e829';\n}\n\n.icon-arrow-down:before {\n  content: '\\e82a';\n}\n\n.icon-arrow-up-left:before {\n  content: '\\e82b';\n}\n\n.icon-arrow-up-right:before {\n  content: '\\e82c';\n}\n\n.icon-arrow-up:before {\n  content: '\\e82d';\n}\n\n.icon-award:before {\n  content: '\\e82e';\n}\n\n.icon-bar-chart:before {\n  content: '\\e82f';\n}\n\n.icon-at-sign:before {\n  content: '\\e830';\n}\n\n.icon-bar-chart-2:before {\n  content: '\\e831';\n}\n\n.icon-battery-charging:before {\n  content: '\\e832';\n}\n\n.icon-bell-off:before {\n  content: '\\e833';\n}\n\n.icon-battery:before {\n  content: '\\e834';\n}\n\n.icon-bluetooth:before {\n  content: '\\e835';\n}\n\n.icon-bell:before {\n  content: '\\e836';\n}\n\n.icon-book:before {\n  content: '\\e837';\n}\n\n.icon-briefcase:before {\n  content: '\\e838';\n}\n\n.icon-camera-off:before {\n  content: '\\e839';\n}\n\n.icon-calendar:before {\n  content: '\\e83a';\n}\n\n.icon-bookmark:before {\n  content: '\\e83b';\n}\n\n.icon-box:before {\n  content: '\\e83c';\n}\n\n.icon-camera:before {\n  content: '\\e83d';\n}\n\n.icon-check-circle:before {\n  content: '\\e83e';\n}\n\n.icon-check:before {\n  content: '\\e83f';\n}\n\n.icon-check-square:before {\n  content: '\\e840';\n}\n\n.icon-cast:before {\n  content: '\\e841';\n}\n\n.icon-chevron-down:before {\n  content: '\\e842';\n}\n\n.icon-chevron-left:before {\n  content: '\\e843';\n}\n\n.icon-chevron-right:before {\n  content: '\\e844';\n}\n\n.icon-chevron-up:before {\n  content: '\\e845';\n}\n\n.icon-chevrons-down:before {\n  content: '\\e846';\n}\n\n.icon-chevrons-right:before {\n  content: '\\e847';\n}\n\n.icon-chevrons-up:before {\n  content: '\\e848';\n}\n\n.icon-chevrons-left:before {\n  content: '\\e849';\n}\n\n.icon-circle:before {\n  content: '\\e84a';\n}\n\n.icon-clipboard:before {\n  content: '\\e84b';\n}\n\n.icon-chrome:before {\n  content: '\\e84c';\n}\n\n.icon-clock:before {\n  content: '\\e84d';\n}\n\n.icon-cloud-lightning:before {\n  content: '\\e84e';\n}\n\n.icon-cloud-drizzle:before {\n  content: '\\e84f';\n}\n\n.icon-cloud-rain:before {\n  content: '\\e850';\n}\n\n.icon-cloud-off:before {\n  content: '\\e851';\n}\n\n.icon-codepen:before {\n  content: '\\e852';\n}\n\n.icon-cloud-snow:before {\n  content: '\\e853';\n}\n\n.icon-compass:before {\n  content: '\\e854';\n}\n\n.icon-copy:before {\n  content: '\\e855';\n}\n\n.icon-corner-down-right:before {\n  content: '\\e856';\n}\n\n.icon-corner-down-left:before {\n  content: '\\e857';\n}\n\n.icon-corner-left-down:before {\n  content: '\\e858';\n}\n\n.icon-corner-left-up:before {\n  content: '\\e859';\n}\n\n.icon-corner-up-left:before {\n  content: '\\e85a';\n}\n\n.icon-corner-up-right:before {\n  content: '\\e85b';\n}\n\n.icon-corner-right-down:before {\n  content: '\\e85c';\n}\n\n.icon-corner-right-up:before {\n  content: '\\e85d';\n}\n\n.icon-cpu:before {\n  content: '\\e85e';\n}\n\n.icon-credit-card:before {\n  content: '\\e85f';\n}\n\n.icon-crosshair:before {\n  content: '\\e860';\n}\n\n.icon-disc:before {\n  content: '\\e861';\n}\n\n.icon-delete:before {\n  content: '\\e862';\n}\n\n.icon-download-cloud:before {\n  content: '\\e863';\n}\n\n.icon-download:before {\n  content: '\\e864';\n}\n\n.icon-droplet:before {\n  content: '\\e865';\n}\n\n.icon-edit-2:before {\n  content: '\\e866';\n}\n\n.icon-edit:before {\n  content: '\\e867';\n}\n\n.icon-edit-1:before {\n  content: '\\e868';\n}\n\n.icon-external-link:before {\n  content: '\\e869';\n}\n\n.icon-eye:before {\n  content: '\\e86a';\n}\n\n.icon-feather:before {\n  content: '\\e86b';\n}\n\n.icon-facebook:before {\n  content: '\\e86c';\n}\n\n.icon-file-minus:before {\n  content: '\\e86d';\n}\n\n.icon-eye-off:before {\n  content: '\\e86e';\n}\n\n.icon-fast-forward:before {\n  content: '\\e86f';\n}\n\n.icon-file-text:before {\n  content: '\\e870';\n}\n\n.icon-film:before {\n  content: '\\e871';\n}\n\n.icon-file:before {\n  content: '\\e872';\n}\n\n.icon-file-plus:before {\n  content: '\\e873';\n}\n\n.icon-folder:before {\n  content: '\\e874';\n}\n\n.icon-filter:before {\n  content: '\\e875';\n}\n\n.icon-flag:before {\n  content: '\\e876';\n}\n\n.icon-globe:before {\n  content: '\\e877';\n}\n\n.icon-grid:before {\n  content: '\\e878';\n}\n\n.icon-heart:before {\n  content: '\\e879';\n}\n\n.icon-home:before {\n  content: '\\e87a';\n}\n\n.icon-github:before {\n  content: '\\e87b';\n}\n\n.icon-image:before {\n  content: '\\e87c';\n}\n\n.icon-inbox:before {\n  content: '\\e87d';\n}\n\n.icon-layers:before {\n  content: '\\e87e';\n}\n\n.icon-info:before {\n  content: '\\e87f';\n}\n\n.icon-instagram:before {\n  content: '\\e880';\n}\n\n.icon-layout:before {\n  content: '\\e881';\n}\n\n.icon-link-2:before {\n  content: '\\e882';\n}\n\n.icon-life-buoy:before {\n  content: '\\e883';\n}\n\n.icon-link:before {\n  content: '\\e884';\n}\n\n.icon-log-in:before {\n  content: '\\e885';\n}\n\n.icon-list:before {\n  content: '\\e886';\n}\n\n.icon-lock:before {\n  content: '\\e887';\n}\n\n.icon-log-out:before {\n  content: '\\e888';\n}\n\n.icon-loader:before {\n  content: '\\e889';\n}\n\n.icon-mail:before {\n  content: '\\e88a';\n}\n\n.icon-maximize-2:before {\n  content: '\\e88b';\n}\n\n.icon-map:before {\n  content: '\\e88c';\n}\n\n.icon-map-pin:before {\n  content: '\\e88e';\n}\n\n.icon-menu:before {\n  content: '\\e88f';\n}\n\n.icon-message-circle:before {\n  content: '\\e890';\n}\n\n.icon-message-square:before {\n  content: '\\e891';\n}\n\n.icon-minimize-2:before {\n  content: '\\e892';\n}\n\n.icon-mic-off:before {\n  content: '\\e893';\n}\n\n.icon-minus-circle:before {\n  content: '\\e894';\n}\n\n.icon-mic:before {\n  content: '\\e895';\n}\n\n.icon-minus-square:before {\n  content: '\\e896';\n}\n\n.icon-minus:before {\n  content: '\\e897';\n}\n\n.icon-moon:before {\n  content: '\\e898';\n}\n\n.icon-monitor:before {\n  content: '\\e899';\n}\n\n.icon-more-vertical:before {\n  content: '\\e89a';\n}\n\n.icon-more-horizontal:before {\n  content: '\\e89b';\n}\n\n.icon-move:before {\n  content: '\\e89c';\n}\n\n.icon-music:before {\n  content: '\\e89d';\n}\n\n.icon-navigation-2:before {\n  content: '\\e89e';\n}\n\n.icon-navigation:before {\n  content: '\\e89f';\n}\n\n.icon-octagon:before {\n  content: '\\e8a0';\n}\n\n.icon-package:before {\n  content: '\\e8a1';\n}\n\n.icon-pause-circle:before {\n  content: '\\e8a2';\n}\n\n.icon-pause:before {\n  content: '\\e8a3';\n}\n\n.icon-percent:before {\n  content: '\\e8a4';\n}\n\n.icon-phone-call:before {\n  content: '\\e8a5';\n}\n\n.icon-phone-forwarded:before {\n  content: '\\e8a6';\n}\n\n.icon-phone-missed:before {\n  content: '\\e8a7';\n}\n\n.icon-phone-off:before {\n  content: '\\e8a8';\n}\n\n.icon-phone-incoming:before {\n  content: '\\e8a9';\n}\n\n.icon-phone:before {\n  content: '\\e8aa';\n}\n\n.icon-phone-outgoing:before {\n  content: '\\e8ab';\n}\n\n.icon-pie-chart:before {\n  content: '\\e8ac';\n}\n\n.icon-play-circle:before {\n  content: '\\e8ad';\n}\n\n.icon-play:before {\n  content: '\\e8ae';\n}\n\n.icon-plus-square:before {\n  content: '\\e8af';\n}\n\n.icon-plus-circle:before {\n  content: '\\e8b0';\n}\n\n.icon-plus:before {\n  content: '\\e8b1';\n}\n\n.icon-pocket:before {\n  content: '\\e8b2';\n}\n\n.icon-printer:before {\n  content: '\\e8b3';\n}\n\n.icon-power:before {\n  content: '\\e8b4';\n}\n\n.icon-radio:before {\n  content: '\\e8b5';\n}\n\n.icon-repeat:before {\n  content: '\\e8b6';\n}\n\n.icon-refresh-ccw:before {\n  content: '\\e8b7';\n}\n\n.icon-rewind:before {\n  content: '\\e8b8';\n}\n\n.icon-rotate-ccw:before {\n  content: '\\e8b9';\n}\n\n.icon-refresh-cw:before {\n  content: '\\e8ba';\n}\n\n.icon-rotate-cw:before {\n  content: '\\e8bb';\n}\n\n.icon-save:before {\n  content: '\\e8bc';\n}\n\n.icon-search:before {\n  content: '\\e8bd';\n}\n\n.icon-server:before {\n  content: '\\e8be';\n}\n\n.icon-scissors:before {\n  content: '\\e8bf';\n}\n\n.icon-share-2:before {\n  content: '\\e8c0';\n}\n\n.icon-share:before {\n  content: '\\e8c1';\n}\n\n.icon-shield:before {\n  content: '\\e8c2';\n}\n\n.icon-settings:before {\n  content: '\\e8c3';\n}\n\n.icon-skip-back:before {\n  content: '\\e8c4';\n}\n\n.icon-shuffle:before {\n  content: '\\e8c5';\n}\n\n.icon-sidebar:before {\n  content: '\\e8c6';\n}\n\n.icon-skip-forward:before {\n  content: '\\e8c7';\n}\n\n.icon-slack:before {\n  content: '\\e8c8';\n}\n\n.icon-slash:before {\n  content: '\\e8c9';\n}\n\n.icon-smartphone:before {\n  content: '\\e8ca';\n}\n\n.icon-square:before {\n  content: '\\e8cb';\n}\n\n.icon-speaker:before {\n  content: '\\e8cc';\n}\n\n.icon-star:before {\n  content: '\\e8cd';\n}\n\n.icon-stop-circle:before {\n  content: '\\e8ce';\n}\n\n.icon-sun:before {\n  content: '\\e8cf';\n}\n\n.icon-sunrise:before {\n  content: '\\e8d0';\n}\n\n.icon-tablet:before {\n  content: '\\e8d1';\n}\n\n.icon-tag:before {\n  content: '\\e8d2';\n}\n\n.icon-sunset:before {\n  content: '\\e8d3';\n}\n\n.icon-target:before {\n  content: '\\e8d4';\n}\n\n.icon-thermometer:before {\n  content: '\\e8d5';\n}\n\n.icon-thumbs-up:before {\n  content: '\\e8d6';\n}\n\n.icon-thumbs-down:before {\n  content: '\\e8d7';\n}\n\n.icon-toggle-left:before {\n  content: '\\e8d8';\n}\n\n.icon-toggle-right:before {\n  content: '\\e8d9';\n}\n\n.icon-trash-2:before {\n  content: '\\e8da';\n}\n\n.icon-trash:before {\n  content: '\\e8db';\n}\n\n.icon-trending-up:before {\n  content: '\\e8dc';\n}\n\n.icon-trending-down:before {\n  content: '\\e8dd';\n}\n\n.icon-triangle:before {\n  content: '\\e8de';\n}\n\n.icon-type:before {\n  content: '\\e8df';\n}\n\n.icon-twitter:before {\n  content: '\\e8e0';\n}\n\n.icon-upload:before {\n  content: '\\e8e1';\n}\n\n.icon-umbrella:before {\n  content: '\\e8e2';\n}\n\n.icon-upload-cloud:before {\n  content: '\\e8e3';\n}\n\n.icon-unlock:before {\n  content: '\\e8e4';\n}\n\n.icon-user-check:before {\n  content: '\\e8e5';\n}\n\n.icon-user-minus:before {\n  content: '\\e8e6';\n}\n\n.icon-user-plus:before {\n  content: '\\e8e7';\n}\n\n.icon-user-x:before {\n  content: '\\e8e8';\n}\n\n.icon-user:before {\n  content: '\\e8e9';\n}\n\n.icon-users:before {\n  content: '\\e8ea';\n}\n\n.icon-video-off:before {\n  content: '\\e8eb';\n}\n\n.icon-video:before {\n  content: '\\e8ec';\n}\n\n.icon-voicemail:before {\n  content: '\\e8ed';\n}\n\n.icon-volume-x:before {\n  content: '\\e8ee';\n}\n\n.icon-volume-2:before {\n  content: '\\e8ef';\n}\n\n.icon-volume-1:before {\n  content: '\\e8f0';\n}\n\n.icon-volume:before {\n  content: '\\e8f1';\n}\n\n.icon-watch:before {\n  content: '\\e8f2';\n}\n\n.icon-wifi:before {\n  content: '\\e8f3';\n}\n\n.icon-x-square:before {\n  content: '\\e8f4';\n}\n\n.icon-wind:before {\n  content: '\\e8f5';\n}\n\n.icon-x:before {\n  content: '\\e8f6';\n}\n\n.icon-x-circle:before {\n  content: '\\e8f7';\n}\n\n.icon-zap:before {\n  content: '\\e8f8';\n}\n\n.icon-zoom-in:before {\n  content: '\\e8f9';\n}\n\n.icon-zoom-out:before {\n  content: '\\e8fa';\n}\n\n.icon-command:before {\n  content: '\\e8fb';\n}\n\n.icon-cloud:before {\n  content: '\\e8fc';\n}\n\n.icon-hash:before {\n  content: '\\e8fd';\n}\n\n.icon-headphones:before {\n  content: '\\e8fe';\n}\n\n.icon-underline:before {\n  content: '\\e8ff';\n}\n\n.icon-italic:before {\n  content: '\\e900';\n}\n\n.icon-bold:before {\n  content: '\\e901';\n}\n\n.icon-crop:before {\n  content: '\\e902';\n}\n\n.icon-help-circle:before {\n  content: '\\e903';\n}\n\n.icon-paperclip:before {\n  content: '\\e904';\n}\n\n.icon-shopping-cart:before {\n  content: '\\e905';\n}\n\n.icon-tv:before {\n  content: '\\e906';\n}\n\n.icon-wifi-off:before {\n  content: '\\e907';\n}\n\n.icon-minimize:before {\n  content: '\\e88d';\n}\n\n.icon-maximize:before {\n  content: '\\e908';\n}\n\n.icon-gitlab:before {\n  content: '\\e909';\n}\n\n.icon-sliders:before {\n  content: '\\e90a';\n}\n\n.icon-star-on:before {\n  content: '\\e90b';\n}\n\n.icon-heart-on:before {\n  content: '\\e90c';\n}\n",".fa,\n.fab,\n.fal,\n.far,\n.fas {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  display: inline-block;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n  line-height: 1;\n}\n\n.fa-lg {\n  font-size: 1.33333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n  > li {\n    position: relative;\n  }\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: 0.08em solid #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fab.fa-pull-left,\n.fal.fa-pull-left,\n.far.fa-pull-left,\n.fas.fa-pull-left {\n  margin-right: 0.3em;\n}\n\n.fa.fa-pull-right,\n.fab.fa-pull-right,\n.fal.fa-pull-right,\n.far.fa-pull-right,\n.fas.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  animation: fa-spin 1s infinite steps(8);\n}\n\n@keyframes fa-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(1turn);\n  }\n}\n\n.fa-rotate-90 {\n  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=1)';\n  transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=2)';\n  transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=3)';\n  transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)';\n  transform: scaleX(-1);\n}\n\n.fa-flip-vertical {\n  transform: scaleY(-1);\n}\n\n.fa-flip-horizontal.fa-flip-vertical,\n.fa-flip-vertical {\n  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)';\n}\n\n.fa-flip-horizontal.fa-flip-vertical {\n  transform: scale(-1);\n}\n\n:root {\n  .fa-flip-horizontal,\n  .fa-flip-vertical,\n  .fa-rotate-90,\n  .fa-rotate-180,\n  .fa-rotate-270 {\n    filter: none;\n  }\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  line-height: 2em;\n  position: relative;\n  vertical-align: middle;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  left: 0;\n  position: absolute;\n  text-align: center;\n  width: 100%;\n}\n\n.fa-stack-1x {\n  line-height: inherit;\n}\n\n.fa-stack-2x {\n  font-size: 2em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.fa-500px:before {\n  content: '\\f26e';\n}\n\n.fa-accessible-icon:before {\n  content: '\\f368';\n}\n\n.fa-accusoft:before {\n  content: '\\f369';\n}\n\n.fa-acquisitions-incorporated:before {\n  content: '\\f6af';\n}\n\n.fa-ad:before {\n  content: '\\f641';\n}\n\n.fa-address-book:before {\n  content: '\\f2b9';\n}\n\n.fa-address-card:before {\n  content: '\\f2bb';\n}\n\n.fa-adjust:before {\n  content: '\\f042';\n}\n\n.fa-adn:before {\n  content: '\\f170';\n}\n\n.fa-adobe:before {\n  content: '\\f778';\n}\n\n.fa-adversal:before {\n  content: '\\f36a';\n}\n\n.fa-affiliatetheme:before {\n  content: '\\f36b';\n}\n\n.fa-air-freshener:before {\n  content: '\\f5d0';\n}\n\n.fa-algolia:before {\n  content: '\\f36c';\n}\n\n.fa-align-center:before {\n  content: '\\f037';\n}\n\n.fa-align-justify:before {\n  content: '\\f039';\n}\n\n.fa-align-left:before {\n  content: '\\f036';\n}\n\n.fa-align-right:before {\n  content: '\\f038';\n}\n\n.fa-alipay:before {\n  content: '\\f642';\n}\n\n.fa-allergies:before {\n  content: '\\f461';\n}\n\n.fa-amazon:before {\n  content: '\\f270';\n}\n\n.fa-amazon-pay:before {\n  content: '\\f42c';\n}\n\n.fa-ambulance:before {\n  content: '\\f0f9';\n}\n\n.fa-american-sign-language-interpreting:before {\n  content: '\\f2a3';\n}\n\n.fa-amilia:before {\n  content: '\\f36d';\n}\n\n.fa-anchor:before {\n  content: '\\f13d';\n}\n\n.fa-android:before {\n  content: '\\f17b';\n}\n\n.fa-angellist:before {\n  content: '\\f209';\n}\n\n.fa-angle-double-down:before {\n  content: '\\f103';\n}\n\n.fa-angle-double-left:before {\n  content: '\\f100';\n}\n\n.fa-angle-double-right:before {\n  content: '\\f101';\n}\n\n.fa-angle-double-up:before {\n  content: '\\f102';\n}\n\n.fa-angle-down:before {\n  content: '\\f107';\n}\n\n.fa-angle-left:before {\n  content: '\\f104';\n}\n\n.fa-angle-right:before {\n  content: '\\f105';\n}\n\n.fa-angle-up:before {\n  content: '\\f106';\n}\n\n.fa-angry:before {\n  content: '\\f556';\n}\n\n.fa-angrycreative:before {\n  content: '\\f36e';\n}\n\n.fa-angular:before {\n  content: '\\f420';\n}\n\n.fa-ankh:before {\n  content: '\\f644';\n}\n\n.fa-app-store:before {\n  content: '\\f36f';\n}\n\n.fa-app-store-ios:before {\n  content: '\\f370';\n}\n\n.fa-apper:before {\n  content: '\\f371';\n}\n\n.fa-apple:before {\n  content: '\\f179';\n}\n\n.fa-apple-alt:before {\n  content: '\\f5d1';\n}\n\n.fa-apple-pay:before {\n  content: '\\f415';\n}\n\n.fa-archive:before {\n  content: '\\f187';\n}\n\n.fa-archway:before {\n  content: '\\f557';\n}\n\n.fa-arrow-alt-circle-down:before {\n  content: '\\f358';\n}\n\n.fa-arrow-alt-circle-left:before {\n  content: '\\f359';\n}\n\n.fa-arrow-alt-circle-right:before {\n  content: '\\f35a';\n}\n\n.fa-arrow-alt-circle-up:before {\n  content: '\\f35b';\n}\n\n.fa-arrow-circle-down:before {\n  content: '\\f0ab';\n}\n\n.fa-arrow-circle-left:before {\n  content: '\\f0a8';\n}\n\n.fa-arrow-circle-right:before {\n  content: '\\f0a9';\n}\n\n.fa-arrow-circle-up:before {\n  content: '\\f0aa';\n}\n\n.fa-arrow-down:before {\n  content: '\\f063';\n}\n\n.fa-arrow-left:before {\n  content: '\\f060';\n}\n\n.fa-arrow-right:before {\n  content: '\\f061';\n}\n\n.fa-arrow-up:before {\n  content: '\\f062';\n}\n\n.fa-arrows-alt:before {\n  content: '\\f0b2';\n}\n\n.fa-arrows-alt-h:before {\n  content: '\\f337';\n}\n\n.fa-arrows-alt-v:before {\n  content: '\\f338';\n}\n\n.fa-artstation:before {\n  content: '\\f77a';\n}\n\n.fa-assistive-listening-systems:before {\n  content: '\\f2a2';\n}\n\n.fa-asterisk:before {\n  content: '\\f069';\n}\n\n.fa-asymmetrik:before {\n  content: '\\f372';\n}\n\n.fa-at:before {\n  content: '\\f1fa';\n}\n\n.fa-atlas:before {\n  content: '\\f558';\n}\n\n.fa-atlassian:before {\n  content: '\\f77b';\n}\n\n.fa-atom:before {\n  content: '\\f5d2';\n}\n\n.fa-audible:before {\n  content: '\\f373';\n}\n\n.fa-audio-description:before {\n  content: '\\f29e';\n}\n\n.fa-autoprefixer:before {\n  content: '\\f41c';\n}\n\n.fa-avianex:before {\n  content: '\\f374';\n}\n\n.fa-aviato:before {\n  content: '\\f421';\n}\n\n.fa-award:before {\n  content: '\\f559';\n}\n\n.fa-aws:before {\n  content: '\\f375';\n}\n\n.fa-baby:before {\n  content: '\\f77c';\n}\n\n.fa-baby-carriage:before {\n  content: '\\f77d';\n}\n\n.fa-backspace:before {\n  content: '\\f55a';\n}\n\n.fa-backward:before {\n  content: '\\f04a';\n}\n\n.fa-balance-scale:before {\n  content: '\\f24e';\n}\n\n.fa-ban:before {\n  content: '\\f05e';\n}\n\n.fa-band-aid:before {\n  content: '\\f462';\n}\n\n.fa-bandcamp:before {\n  content: '\\f2d5';\n}\n\n.fa-barcode:before {\n  content: '\\f02a';\n}\n\n.fa-bars:before {\n  content: '\\f0c9';\n}\n\n.fa-baseball-ball:before {\n  content: '\\f433';\n}\n\n.fa-basketball-ball:before {\n  content: '\\f434';\n}\n\n.fa-bath:before {\n  content: '\\f2cd';\n}\n\n.fa-battery-empty:before {\n  content: '\\f244';\n}\n\n.fa-battery-full:before {\n  content: '\\f240';\n}\n\n.fa-battery-half:before {\n  content: '\\f242';\n}\n\n.fa-battery-quarter:before {\n  content: '\\f243';\n}\n\n.fa-battery-three-quarters:before {\n  content: '\\f241';\n}\n\n.fa-bed:before {\n  content: '\\f236';\n}\n\n.fa-beer:before {\n  content: '\\f0fc';\n}\n\n.fa-behance:before {\n  content: '\\f1b4';\n}\n\n.fa-behance-square:before {\n  content: '\\f1b5';\n}\n\n.fa-bell:before {\n  content: '\\f0f3';\n}\n\n.fa-bell-slash:before {\n  content: '\\f1f6';\n}\n\n.fa-bezier-curve:before {\n  content: '\\f55b';\n}\n\n.fa-bible:before {\n  content: '\\f647';\n}\n\n.fa-bicycle:before {\n  content: '\\f206';\n}\n\n.fa-bimobject:before {\n  content: '\\f378';\n}\n\n.fa-binoculars:before {\n  content: '\\f1e5';\n}\n\n.fa-biohazard:before {\n  content: '\\f780';\n}\n\n.fa-birthday-cake:before {\n  content: '\\f1fd';\n}\n\n.fa-bitbucket:before {\n  content: '\\f171';\n}\n\n.fa-bitcoin:before {\n  content: '\\f379';\n}\n\n.fa-bity:before {\n  content: '\\f37a';\n}\n\n.fa-black-tie:before {\n  content: '\\f27e';\n}\n\n.fa-blackberry:before {\n  content: '\\f37b';\n}\n\n.fa-blender:before {\n  content: '\\f517';\n}\n\n.fa-blender-phone:before {\n  content: '\\f6b6';\n}\n\n.fa-blind:before {\n  content: '\\f29d';\n}\n\n.fa-blog:before {\n  content: '\\f781';\n}\n\n.fa-blogger:before {\n  content: '\\f37c';\n}\n\n.fa-blogger-b:before {\n  content: '\\f37d';\n}\n\n.fa-bluetooth:before {\n  content: '\\f293';\n}\n\n.fa-bluetooth-b:before {\n  content: '\\f294';\n}\n\n.fa-bold:before {\n  content: '\\f032';\n}\n\n.fa-bolt:before {\n  content: '\\f0e7';\n}\n\n.fa-bomb:before {\n  content: '\\f1e2';\n}\n\n.fa-bone:before {\n  content: '\\f5d7';\n}\n\n.fa-bong:before {\n  content: '\\f55c';\n}\n\n.fa-book:before {\n  content: '\\f02d';\n}\n\n.fa-book-dead:before {\n  content: '\\f6b7';\n}\n\n.fa-book-open:before {\n  content: '\\f518';\n}\n\n.fa-book-reader:before {\n  content: '\\f5da';\n}\n\n.fa-bookmark:before {\n  content: '\\f02e';\n}\n\n.fa-bowling-ball:before {\n  content: '\\f436';\n}\n\n.fa-box:before {\n  content: '\\f466';\n}\n\n.fa-box-open:before {\n  content: '\\f49e';\n}\n\n.fa-boxes:before {\n  content: '\\f468';\n}\n\n.fa-braille:before {\n  content: '\\f2a1';\n}\n\n.fa-brain:before {\n  content: '\\f5dc';\n}\n\n.fa-briefcase:before {\n  content: '\\f0b1';\n}\n\n.fa-briefcase-medical:before {\n  content: '\\f469';\n}\n\n.fa-broadcast-tower:before {\n  content: '\\f519';\n}\n\n.fa-broom:before {\n  content: '\\f51a';\n}\n\n.fa-brush:before {\n  content: '\\f55d';\n}\n\n.fa-btc:before {\n  content: '\\f15a';\n}\n\n.fa-bug:before {\n  content: '\\f188';\n}\n\n.fa-building:before {\n  content: '\\f1ad';\n}\n\n.fa-bullhorn:before {\n  content: '\\f0a1';\n}\n\n.fa-bullseye:before {\n  content: '\\f140';\n}\n\n.fa-burn:before {\n  content: '\\f46a';\n}\n\n.fa-buromobelexperte:before {\n  content: '\\f37f';\n}\n\n.fa-bus:before {\n  content: '\\f207';\n}\n\n.fa-bus-alt:before {\n  content: '\\f55e';\n}\n\n.fa-business-time:before {\n  content: '\\f64a';\n}\n\n.fa-buysellads:before {\n  content: '\\f20d';\n}\n\n.fa-calculator:before {\n  content: '\\f1ec';\n}\n\n.fa-calendar:before {\n  content: '\\f133';\n}\n\n.fa-calendar-alt:before {\n  content: '\\f073';\n}\n\n.fa-calendar-check:before {\n  content: '\\f274';\n}\n\n.fa-calendar-day:before {\n  content: '\\f783';\n}\n\n.fa-calendar-minus:before {\n  content: '\\f272';\n}\n\n.fa-calendar-plus:before {\n  content: '\\f271';\n}\n\n.fa-calendar-times:before {\n  content: '\\f273';\n}\n\n.fa-calendar-week:before {\n  content: '\\f784';\n}\n\n.fa-camera:before {\n  content: '\\f030';\n}\n\n.fa-camera-retro:before {\n  content: '\\f083';\n}\n\n.fa-campground:before {\n  content: '\\f6bb';\n}\n\n.fa-canadian-maple-leaf:before {\n  content: '\\f785';\n}\n\n.fa-candy-cane:before {\n  content: '\\f786';\n}\n\n.fa-cannabis:before {\n  content: '\\f55f';\n}\n\n.fa-capsules:before {\n  content: '\\f46b';\n}\n\n.fa-car:before {\n  content: '\\f1b9';\n}\n\n.fa-car-alt:before {\n  content: '\\f5de';\n}\n\n.fa-car-battery:before {\n  content: '\\f5df';\n}\n\n.fa-car-crash:before {\n  content: '\\f5e1';\n}\n\n.fa-car-side:before {\n  content: '\\f5e4';\n}\n\n.fa-caret-down:before {\n  content: '\\f0d7';\n}\n\n.fa-caret-left:before {\n  content: '\\f0d9';\n}\n\n.fa-caret-right:before {\n  content: '\\f0da';\n}\n\n.fa-caret-square-down:before {\n  content: '\\f150';\n}\n\n.fa-caret-square-left:before {\n  content: '\\f191';\n}\n\n.fa-caret-square-right:before {\n  content: '\\f152';\n}\n\n.fa-caret-square-up:before {\n  content: '\\f151';\n}\n\n.fa-caret-up:before {\n  content: '\\f0d8';\n}\n\n.fa-carrot:before {\n  content: '\\f787';\n}\n\n.fa-cart-arrow-down:before {\n  content: '\\f218';\n}\n\n.fa-cart-plus:before {\n  content: '\\f217';\n}\n\n.fa-cash-register:before {\n  content: '\\f788';\n}\n\n.fa-cat:before {\n  content: '\\f6be';\n}\n\n.fa-cc-amazon-pay:before {\n  content: '\\f42d';\n}\n\n.fa-cc-amex:before {\n  content: '\\f1f3';\n}\n\n.fa-cc-apple-pay:before {\n  content: '\\f416';\n}\n\n.fa-cc-diners-club:before {\n  content: '\\f24c';\n}\n\n.fa-cc-discover:before {\n  content: '\\f1f2';\n}\n\n.fa-cc-jcb:before {\n  content: '\\f24b';\n}\n\n.fa-cc-mastercard:before {\n  content: '\\f1f1';\n}\n\n.fa-cc-paypal:before {\n  content: '\\f1f4';\n}\n\n.fa-cc-stripe:before {\n  content: '\\f1f5';\n}\n\n.fa-cc-visa:before {\n  content: '\\f1f0';\n}\n\n.fa-centercode:before {\n  content: '\\f380';\n}\n\n.fa-centos:before {\n  content: '\\f789';\n}\n\n.fa-certificate:before {\n  content: '\\f0a3';\n}\n\n.fa-chair:before {\n  content: '\\f6c0';\n}\n\n.fa-chalkboard:before {\n  content: '\\f51b';\n}\n\n.fa-chalkboard-teacher:before {\n  content: '\\f51c';\n}\n\n.fa-charging-station:before {\n  content: '\\f5e7';\n}\n\n.fa-chart-area:before {\n  content: '\\f1fe';\n}\n\n.fa-chart-bar:before {\n  content: '\\f080';\n}\n\n.fa-chart-line:before {\n  content: '\\f201';\n}\n\n.fa-chart-pie:before {\n  content: '\\f200';\n}\n\n.fa-check:before {\n  content: '\\f00c';\n}\n\n.fa-check-circle:before {\n  content: '\\f058';\n}\n\n.fa-check-double:before {\n  content: '\\f560';\n}\n\n.fa-check-square:before {\n  content: '\\f14a';\n}\n\n.fa-chess:before {\n  content: '\\f439';\n}\n\n.fa-chess-bishop:before {\n  content: '\\f43a';\n}\n\n.fa-chess-board:before {\n  content: '\\f43c';\n}\n\n.fa-chess-king:before {\n  content: '\\f43f';\n}\n\n.fa-chess-knight:before {\n  content: '\\f441';\n}\n\n.fa-chess-pawn:before {\n  content: '\\f443';\n}\n\n.fa-chess-queen:before {\n  content: '\\f445';\n}\n\n.fa-chess-rook:before {\n  content: '\\f447';\n}\n\n.fa-chevron-circle-down:before {\n  content: '\\f13a';\n}\n\n.fa-chevron-circle-left:before {\n  content: '\\f137';\n}\n\n.fa-chevron-circle-right:before {\n  content: '\\f138';\n}\n\n.fa-chevron-circle-up:before {\n  content: '\\f139';\n}\n\n.fa-chevron-down:before {\n  content: '\\f078';\n}\n\n.fa-chevron-left:before {\n  content: '\\f053';\n}\n\n.fa-chevron-right:before {\n  content: '\\f054';\n}\n\n.fa-chevron-up:before {\n  content: '\\f077';\n}\n\n.fa-child:before {\n  content: '\\f1ae';\n}\n\n.fa-chrome:before {\n  content: '\\f268';\n}\n\n.fa-church:before {\n  content: '\\f51d';\n}\n\n.fa-circle:before {\n  content: '\\f111';\n}\n\n.fa-circle-notch:before {\n  content: '\\f1ce';\n}\n\n.fa-city:before {\n  content: '\\f64f';\n}\n\n.fa-clipboard:before {\n  content: '\\f328';\n}\n\n.fa-clipboard-check:before {\n  content: '\\f46c';\n}\n\n.fa-clipboard-list:before {\n  content: '\\f46d';\n}\n\n.fa-clock:before {\n  content: '\\f017';\n}\n\n.fa-clone:before {\n  content: '\\f24d';\n}\n\n.fa-closed-captioning:before {\n  content: '\\f20a';\n}\n\n.fa-cloud:before {\n  content: '\\f0c2';\n}\n\n.fa-cloud-download-alt:before {\n  content: '\\f381';\n}\n\n.fa-cloud-meatball:before {\n  content: '\\f73b';\n}\n\n.fa-cloud-moon:before {\n  content: '\\f6c3';\n}\n\n.fa-cloud-moon-rain:before {\n  content: '\\f73c';\n}\n\n.fa-cloud-rain:before {\n  content: '\\f73d';\n}\n\n.fa-cloud-showers-heavy:before {\n  content: '\\f740';\n}\n\n.fa-cloud-sun:before {\n  content: '\\f6c4';\n}\n\n.fa-cloud-sun-rain:before {\n  content: '\\f743';\n}\n\n.fa-cloud-upload-alt:before {\n  content: '\\f382';\n}\n\n.fa-cloudscale:before {\n  content: '\\f383';\n}\n\n.fa-cloudsmith:before {\n  content: '\\f384';\n}\n\n.fa-cloudversify:before {\n  content: '\\f385';\n}\n\n.fa-cocktail:before {\n  content: '\\f561';\n}\n\n.fa-code:before {\n  content: '\\f121';\n}\n\n.fa-code-branch:before {\n  content: '\\f126';\n}\n\n.fa-codepen:before {\n  content: '\\f1cb';\n}\n\n.fa-codiepie:before {\n  content: '\\f284';\n}\n\n.fa-coffee:before {\n  content: '\\f0f4';\n}\n\n.fa-cog:before {\n  content: '\\f013';\n}\n\n.fa-cogs:before {\n  content: '\\f085';\n}\n\n.fa-coins:before {\n  content: '\\f51e';\n}\n\n.fa-columns:before {\n  content: '\\f0db';\n}\n\n.fa-comment:before {\n  content: '\\f075';\n}\n\n.fa-comment-alt:before {\n  content: '\\f27a';\n}\n\n.fa-comment-dollar:before {\n  content: '\\f651';\n}\n\n.fa-comment-dots:before {\n  content: '\\f4ad';\n}\n\n.fa-comment-slash:before {\n  content: '\\f4b3';\n}\n\n.fa-comments:before {\n  content: '\\f086';\n}\n\n.fa-comments-dollar:before {\n  content: '\\f653';\n}\n\n.fa-compact-disc:before {\n  content: '\\f51f';\n}\n\n.fa-compass:before {\n  content: '\\f14e';\n}\n\n.fa-compress:before {\n  content: '\\f066';\n}\n\n.fa-compress-arrows-alt:before {\n  content: '\\f78c';\n}\n\n.fa-concierge-bell:before {\n  content: '\\f562';\n}\n\n.fa-confluence:before {\n  content: '\\f78d';\n}\n\n.fa-connectdevelop:before {\n  content: '\\f20e';\n}\n\n.fa-contao:before {\n  content: '\\f26d';\n}\n\n.fa-cookie:before {\n  content: '\\f563';\n}\n\n.fa-cookie-bite:before {\n  content: '\\f564';\n}\n\n.fa-copy:before {\n  content: '\\f0c5';\n}\n\n.fa-copyright:before {\n  content: '\\f1f9';\n}\n\n.fa-couch:before {\n  content: '\\f4b8';\n}\n\n.fa-cpanel:before {\n  content: '\\f388';\n}\n\n.fa-creative-commons:before {\n  content: '\\f25e';\n}\n\n.fa-creative-commons-by:before {\n  content: '\\f4e7';\n}\n\n.fa-creative-commons-nc:before {\n  content: '\\f4e8';\n}\n\n.fa-creative-commons-nc-eu:before {\n  content: '\\f4e9';\n}\n\n.fa-creative-commons-nc-jp:before {\n  content: '\\f4ea';\n}\n\n.fa-creative-commons-nd:before {\n  content: '\\f4eb';\n}\n\n.fa-creative-commons-pd:before {\n  content: '\\f4ec';\n}\n\n.fa-creative-commons-pd-alt:before {\n  content: '\\f4ed';\n}\n\n.fa-creative-commons-remix:before {\n  content: '\\f4ee';\n}\n\n.fa-creative-commons-sa:before {\n  content: '\\f4ef';\n}\n\n.fa-creative-commons-sampling:before {\n  content: '\\f4f0';\n}\n\n.fa-creative-commons-sampling-plus:before {\n  content: '\\f4f1';\n}\n\n.fa-creative-commons-share:before {\n  content: '\\f4f2';\n}\n\n.fa-creative-commons-zero:before {\n  content: '\\f4f3';\n}\n\n.fa-credit-card:before {\n  content: '\\f09d';\n}\n\n.fa-critical-role:before {\n  content: '\\f6c9';\n}\n\n.fa-crop:before {\n  content: '\\f125';\n}\n\n.fa-crop-alt:before {\n  content: '\\f565';\n}\n\n.fa-cross:before {\n  content: '\\f654';\n}\n\n.fa-crosshairs:before {\n  content: '\\f05b';\n}\n\n.fa-crow:before {\n  content: '\\f520';\n}\n\n.fa-crown:before {\n  content: '\\f521';\n}\n\n.fa-css3:before {\n  content: '\\f13c';\n}\n\n.fa-css3-alt:before {\n  content: '\\f38b';\n}\n\n.fa-cube:before {\n  content: '\\f1b2';\n}\n\n.fa-cubes:before {\n  content: '\\f1b3';\n}\n\n.fa-cut:before {\n  content: '\\f0c4';\n}\n\n.fa-cuttlefish:before {\n  content: '\\f38c';\n}\n\n.fa-d-and-d:before {\n  content: '\\f38d';\n}\n\n.fa-d-and-d-beyond:before {\n  content: '\\f6ca';\n}\n\n.fa-dashcube:before {\n  content: '\\f210';\n}\n\n.fa-database:before {\n  content: '\\f1c0';\n}\n\n.fa-deaf:before {\n  content: '\\f2a4';\n}\n\n.fa-delicious:before {\n  content: '\\f1a5';\n}\n\n.fa-democrat:before {\n  content: '\\f747';\n}\n\n.fa-deploydog:before {\n  content: '\\f38e';\n}\n\n.fa-deskpro:before {\n  content: '\\f38f';\n}\n\n.fa-desktop:before {\n  content: '\\f108';\n}\n\n.fa-dev:before {\n  content: '\\f6cc';\n}\n\n.fa-deviantart:before {\n  content: '\\f1bd';\n}\n\n.fa-dharmachakra:before {\n  content: '\\f655';\n}\n\n.fa-dhl:before {\n  content: '\\f790';\n}\n\n.fa-diagnoses:before {\n  content: '\\f470';\n}\n\n.fa-diaspora:before {\n  content: '\\f791';\n}\n\n.fa-dice:before {\n  content: '\\f522';\n}\n\n.fa-dice-d20:before {\n  content: '\\f6cf';\n}\n\n.fa-dice-d6:before {\n  content: '\\f6d1';\n}\n\n.fa-dice-five:before {\n  content: '\\f523';\n}\n\n.fa-dice-four:before {\n  content: '\\f524';\n}\n\n.fa-dice-one:before {\n  content: '\\f525';\n}\n\n.fa-dice-six:before {\n  content: '\\f526';\n}\n\n.fa-dice-three:before {\n  content: '\\f527';\n}\n\n.fa-dice-two:before {\n  content: '\\f528';\n}\n\n.fa-digg:before {\n  content: '\\f1a6';\n}\n\n.fa-digital-ocean:before {\n  content: '\\f391';\n}\n\n.fa-digital-tachograph:before {\n  content: '\\f566';\n}\n\n.fa-directions:before {\n  content: '\\f5eb';\n}\n\n.fa-discord:before {\n  content: '\\f392';\n}\n\n.fa-discourse:before {\n  content: '\\f393';\n}\n\n.fa-divide:before {\n  content: '\\f529';\n}\n\n.fa-dizzy:before {\n  content: '\\f567';\n}\n\n.fa-dna:before {\n  content: '\\f471';\n}\n\n.fa-dochub:before {\n  content: '\\f394';\n}\n\n.fa-docker:before {\n  content: '\\f395';\n}\n\n.fa-dog:before {\n  content: '\\f6d3';\n}\n\n.fa-dollar-sign:before {\n  content: '\\f155';\n}\n\n.fa-dolly:before {\n  content: '\\f472';\n}\n\n.fa-dolly-flatbed:before {\n  content: '\\f474';\n}\n\n.fa-donate:before {\n  content: '\\f4b9';\n}\n\n.fa-door-closed:before {\n  content: '\\f52a';\n}\n\n.fa-door-open:before {\n  content: '\\f52b';\n}\n\n.fa-dot-circle:before {\n  content: '\\f192';\n}\n\n.fa-dove:before {\n  content: '\\f4ba';\n}\n\n.fa-download:before {\n  content: '\\f019';\n}\n\n.fa-draft2digital:before {\n  content: '\\f396';\n}\n\n.fa-drafting-compass:before {\n  content: '\\f568';\n}\n\n.fa-dragon:before {\n  content: '\\f6d5';\n}\n\n.fa-draw-polygon:before {\n  content: '\\f5ee';\n}\n\n.fa-dribbble:before {\n  content: '\\f17d';\n}\n\n.fa-dribbble-square:before {\n  content: '\\f397';\n}\n\n.fa-dropbox:before {\n  content: '\\f16b';\n}\n\n.fa-drum:before {\n  content: '\\f569';\n}\n\n.fa-drum-steelpan:before {\n  content: '\\f56a';\n}\n\n.fa-drumstick-bite:before {\n  content: '\\f6d7';\n}\n\n.fa-drupal:before {\n  content: '\\f1a9';\n}\n\n.fa-dumbbell:before {\n  content: '\\f44b';\n}\n\n.fa-dumpster:before {\n  content: '\\f793';\n}\n\n.fa-dumpster-fire:before {\n  content: '\\f794';\n}\n\n.fa-dungeon:before {\n  content: '\\f6d9';\n}\n\n.fa-dyalog:before {\n  content: '\\f399';\n}\n\n.fa-earlybirds:before {\n  content: '\\f39a';\n}\n\n.fa-ebay:before {\n  content: '\\f4f4';\n}\n\n.fa-edge:before {\n  content: '\\f282';\n}\n\n.fa-edit:before {\n  content: '\\f044';\n}\n\n.fa-eject:before {\n  content: '\\f052';\n}\n\n.fa-elementor:before {\n  content: '\\f430';\n}\n\n.fa-ellipsis-h:before {\n  content: '\\f141';\n}\n\n.fa-ellipsis-v:before {\n  content: '\\f142';\n}\n\n.fa-ello:before {\n  content: '\\f5f1';\n}\n\n.fa-ember:before {\n  content: '\\f423';\n}\n\n.fa-empire:before {\n  content: '\\f1d1';\n}\n\n.fa-envelope:before {\n  content: '\\f0e0';\n}\n\n.fa-envelope-open:before {\n  content: '\\f2b6';\n}\n\n.fa-envelope-open-text:before {\n  content: '\\f658';\n}\n\n.fa-envelope-square:before {\n  content: '\\f199';\n}\n\n.fa-envira:before {\n  content: '\\f299';\n}\n\n.fa-equals:before {\n  content: '\\f52c';\n}\n\n.fa-eraser:before {\n  content: '\\f12d';\n}\n\n.fa-erlang:before {\n  content: '\\f39d';\n}\n\n.fa-ethereum:before {\n  content: '\\f42e';\n}\n\n.fa-ethernet:before {\n  content: '\\f796';\n}\n\n.fa-etsy:before {\n  content: '\\f2d7';\n}\n\n.fa-euro-sign:before {\n  content: '\\f153';\n}\n\n.fa-exchange-alt:before {\n  content: '\\f362';\n}\n\n.fa-exclamation:before {\n  content: '\\f12a';\n}\n\n.fa-exclamation-circle:before {\n  content: '\\f06a';\n}\n\n.fa-exclamation-triangle:before {\n  content: '\\f071';\n}\n\n.fa-expand:before {\n  content: '\\f065';\n}\n\n.fa-expand-arrows-alt:before {\n  content: '\\f31e';\n}\n\n.fa-expeditedssl:before {\n  content: '\\f23e';\n}\n\n.fa-external-link-alt:before {\n  content: '\\f35d';\n}\n\n.fa-external-link-square-alt:before {\n  content: '\\f360';\n}\n\n.fa-eye:before {\n  content: '\\f06e';\n}\n\n.fa-eye-dropper:before {\n  content: '\\f1fb';\n}\n\n.fa-eye-slash:before {\n  content: '\\f070';\n}\n\n.fa-facebook:before {\n  content: '\\f09a';\n}\n\n.fa-facebook-f:before {\n  content: '\\f39e';\n}\n\n.fa-facebook-messenger:before {\n  content: '\\f39f';\n}\n\n.fa-facebook-square:before {\n  content: '\\f082';\n}\n\n.fa-fantasy-flight-games:before {\n  content: '\\f6dc';\n}\n\n.fa-fast-backward:before {\n  content: '\\f049';\n}\n\n.fa-fast-forward:before {\n  content: '\\f050';\n}\n\n.fa-fax:before {\n  content: '\\f1ac';\n}\n\n.fa-feather:before {\n  content: '\\f52d';\n}\n\n.fa-feather-alt:before {\n  content: '\\f56b';\n}\n\n.fa-fedex:before {\n  content: '\\f797';\n}\n\n.fa-fedora:before {\n  content: '\\f798';\n}\n\n.fa-female:before {\n  content: '\\f182';\n}\n\n.fa-fighter-jet:before {\n  content: '\\f0fb';\n}\n\n.fa-figma:before {\n  content: '\\f799';\n}\n\n.fa-file:before {\n  content: '\\f15b';\n}\n\n.fa-file-alt:before {\n  content: '\\f15c';\n}\n\n.fa-file-archive:before {\n  content: '\\f1c6';\n}\n\n.fa-file-audio:before {\n  content: '\\f1c7';\n}\n\n.fa-file-code:before {\n  content: '\\f1c9';\n}\n\n.fa-file-contract:before {\n  content: '\\f56c';\n}\n\n.fa-file-csv:before {\n  content: '\\f6dd';\n}\n\n.fa-file-download:before {\n  content: '\\f56d';\n}\n\n.fa-file-excel:before {\n  content: '\\f1c3';\n}\n\n.fa-file-export:before {\n  content: '\\f56e';\n}\n\n.fa-file-image:before {\n  content: '\\f1c5';\n}\n\n.fa-file-import:before {\n  content: '\\f56f';\n}\n\n.fa-file-invoice:before {\n  content: '\\f570';\n}\n\n.fa-file-invoice-dollar:before {\n  content: '\\f571';\n}\n\n.fa-file-medical:before {\n  content: '\\f477';\n}\n\n.fa-file-medical-alt:before {\n  content: '\\f478';\n}\n\n.fa-file-pdf:before {\n  content: '\\f1c1';\n}\n\n.fa-file-powerpoint:before {\n  content: '\\f1c4';\n}\n\n.fa-file-prescription:before {\n  content: '\\f572';\n}\n\n.fa-file-signature:before {\n  content: '\\f573';\n}\n\n.fa-file-upload:before {\n  content: '\\f574';\n}\n\n.fa-file-video:before {\n  content: '\\f1c8';\n}\n\n.fa-file-word:before {\n  content: '\\f1c2';\n}\n\n.fa-fill:before {\n  content: '\\f575';\n}\n\n.fa-fill-drip:before {\n  content: '\\f576';\n}\n\n.fa-film:before {\n  content: '\\f008';\n}\n\n.fa-filter:before {\n  content: '\\f0b0';\n}\n\n.fa-fingerprint:before {\n  content: '\\f577';\n}\n\n.fa-fire:before {\n  content: '\\f06d';\n}\n\n.fa-fire-alt:before {\n  content: '\\f7e4';\n}\n\n.fa-fire-extinguisher:before {\n  content: '\\f134';\n}\n\n.fa-firefox:before {\n  content: '\\f269';\n}\n\n.fa-first-aid:before {\n  content: '\\f479';\n}\n\n.fa-first-order:before {\n  content: '\\f2b0';\n}\n\n.fa-first-order-alt:before {\n  content: '\\f50a';\n}\n\n.fa-firstdraft:before {\n  content: '\\f3a1';\n}\n\n.fa-fish:before {\n  content: '\\f578';\n}\n\n.fa-fist-raised:before {\n  content: '\\f6de';\n}\n\n.fa-flag:before {\n  content: '\\f024';\n}\n\n.fa-flag-checkered:before {\n  content: '\\f11e';\n}\n\n.fa-flag-usa:before {\n  content: '\\f74d';\n}\n\n.fa-flask:before {\n  content: '\\f0c3';\n}\n\n.fa-flickr:before {\n  content: '\\f16e';\n}\n\n.fa-flipboard:before {\n  content: '\\f44d';\n}\n\n.fa-flushed:before {\n  content: '\\f579';\n}\n\n.fa-fly:before {\n  content: '\\f417';\n}\n\n.fa-folder:before {\n  content: '\\f07b';\n}\n\n.fa-folder-minus:before {\n  content: '\\f65d';\n}\n\n.fa-folder-open:before {\n  content: '\\f07c';\n}\n\n.fa-folder-plus:before {\n  content: '\\f65e';\n}\n\n.fa-font:before {\n  content: '\\f031';\n}\n\n.fa-font-awesome:before {\n  content: '\\f2b4';\n}\n\n.fa-font-awesome-alt:before {\n  content: '\\f35c';\n}\n\n.fa-font-awesome-flag:before {\n  content: '\\f425';\n}\n\n.fa-font-awesome-logo-full:before {\n  content: '\\f4e6';\n}\n\n.fa-fonticons:before {\n  content: '\\f280';\n}\n\n.fa-fonticons-fi:before {\n  content: '\\f3a2';\n}\n\n.fa-football-ball:before {\n  content: '\\f44e';\n}\n\n.fa-fort-awesome:before {\n  content: '\\f286';\n}\n\n.fa-fort-awesome-alt:before {\n  content: '\\f3a3';\n}\n\n.fa-forumbee:before {\n  content: '\\f211';\n}\n\n.fa-forward:before {\n  content: '\\f04e';\n}\n\n.fa-foursquare:before {\n  content: '\\f180';\n}\n\n.fa-free-code-camp:before {\n  content: '\\f2c5';\n}\n\n.fa-freebsd:before {\n  content: '\\f3a4';\n}\n\n.fa-frog:before {\n  content: '\\f52e';\n}\n\n.fa-frown:before {\n  content: '\\f119';\n}\n\n.fa-frown-open:before {\n  content: '\\f57a';\n}\n\n.fa-fulcrum:before {\n  content: '\\f50b';\n}\n\n.fa-funnel-dollar:before {\n  content: '\\f662';\n}\n\n.fa-futbol:before {\n  content: '\\f1e3';\n}\n\n.fa-galactic-republic:before {\n  content: '\\f50c';\n}\n\n.fa-galactic-senate:before {\n  content: '\\f50d';\n}\n\n.fa-gamepad:before {\n  content: '\\f11b';\n}\n\n.fa-gas-pump:before {\n  content: '\\f52f';\n}\n\n.fa-gavel:before {\n  content: '\\f0e3';\n}\n\n.fa-gem:before {\n  content: '\\f3a5';\n}\n\n.fa-genderless:before {\n  content: '\\f22d';\n}\n\n.fa-get-pocket:before {\n  content: '\\f265';\n}\n\n.fa-gg:before {\n  content: '\\f260';\n}\n\n.fa-gg-circle:before {\n  content: '\\f261';\n}\n\n.fa-ghost:before {\n  content: '\\f6e2';\n}\n\n.fa-gift:before {\n  content: '\\f06b';\n}\n\n.fa-gifts:before {\n  content: '\\f79c';\n}\n\n.fa-git:before {\n  content: '\\f1d3';\n}\n\n.fa-git-square:before {\n  content: '\\f1d2';\n}\n\n.fa-github:before {\n  content: '\\f09b';\n}\n\n.fa-github-alt:before {\n  content: '\\f113';\n}\n\n.fa-github-square:before {\n  content: '\\f092';\n}\n\n.fa-gitkraken:before {\n  content: '\\f3a6';\n}\n\n.fa-gitlab:before {\n  content: '\\f296';\n}\n\n.fa-gitter:before {\n  content: '\\f426';\n}\n\n.fa-glass-cheers:before {\n  content: '\\f79f';\n}\n\n.fa-glass-martini:before {\n  content: '\\f000';\n}\n\n.fa-glass-martini-alt:before {\n  content: '\\f57b';\n}\n\n.fa-glass-whiskey:before {\n  content: '\\f7a0';\n}\n\n.fa-glasses:before {\n  content: '\\f530';\n}\n\n.fa-glide:before {\n  content: '\\f2a5';\n}\n\n.fa-glide-g:before {\n  content: '\\f2a6';\n}\n\n.fa-globe:before {\n  content: '\\f0ac';\n}\n\n.fa-globe-africa:before {\n  content: '\\f57c';\n}\n\n.fa-globe-americas:before {\n  content: '\\f57d';\n}\n\n.fa-globe-asia:before {\n  content: '\\f57e';\n}\n\n.fa-globe-europe:before {\n  content: '\\f7a2';\n}\n\n.fa-gofore:before {\n  content: '\\f3a7';\n}\n\n.fa-golf-ball:before {\n  content: '\\f450';\n}\n\n.fa-goodreads:before {\n  content: '\\f3a8';\n}\n\n.fa-goodreads-g:before {\n  content: '\\f3a9';\n}\n\n.fa-google:before {\n  content: '\\f1a0';\n}\n\n.fa-google-drive:before {\n  content: '\\f3aa';\n}\n\n.fa-google-play:before {\n  content: '\\f3ab';\n}\n\n.fa-google-plus:before {\n  content: '\\f2b3';\n}\n\n.fa-google-plus-g:before {\n  content: '\\f0d5';\n}\n\n.fa-google-plus-square:before {\n  content: '\\f0d4';\n}\n\n.fa-google-wallet:before {\n  content: '\\f1ee';\n}\n\n.fa-gopuram:before {\n  content: '\\f664';\n}\n\n.fa-graduation-cap:before {\n  content: '\\f19d';\n}\n\n.fa-gratipay:before {\n  content: '\\f184';\n}\n\n.fa-grav:before {\n  content: '\\f2d6';\n}\n\n.fa-greater-than:before {\n  content: '\\f531';\n}\n\n.fa-greater-than-equal:before {\n  content: '\\f532';\n}\n\n.fa-grimace:before {\n  content: '\\f57f';\n}\n\n.fa-grin:before {\n  content: '\\f580';\n}\n\n.fa-grin-alt:before {\n  content: '\\f581';\n}\n\n.fa-grin-beam:before {\n  content: '\\f582';\n}\n\n.fa-grin-beam-sweat:before {\n  content: '\\f583';\n}\n\n.fa-grin-hearts:before {\n  content: '\\f584';\n}\n\n.fa-grin-squint:before {\n  content: '\\f585';\n}\n\n.fa-grin-squint-tears:before {\n  content: '\\f586';\n}\n\n.fa-grin-stars:before {\n  content: '\\f587';\n}\n\n.fa-grin-tears:before {\n  content: '\\f588';\n}\n\n.fa-grin-tongue:before {\n  content: '\\f589';\n}\n\n.fa-grin-tongue-squint:before {\n  content: '\\f58a';\n}\n\n.fa-grin-tongue-wink:before {\n  content: '\\f58b';\n}\n\n.fa-grin-wink:before {\n  content: '\\f58c';\n}\n\n.fa-grip-horizontal:before {\n  content: '\\f58d';\n}\n\n.fa-grip-lines:before {\n  content: '\\f7a4';\n}\n\n.fa-grip-lines-vertical:before {\n  content: '\\f7a5';\n}\n\n.fa-grip-vertical:before {\n  content: '\\f58e';\n}\n\n.fa-gripfire:before {\n  content: '\\f3ac';\n}\n\n.fa-grunt:before {\n  content: '\\f3ad';\n}\n\n.fa-guitar:before {\n  content: '\\f7a6';\n}\n\n.fa-gulp:before {\n  content: '\\f3ae';\n}\n\n.fa-h-square:before {\n  content: '\\f0fd';\n}\n\n.fa-hacker-news:before {\n  content: '\\f1d4';\n}\n\n.fa-hacker-news-square:before {\n  content: '\\f3af';\n}\n\n.fa-hackerrank:before {\n  content: '\\f5f7';\n}\n\n.fa-hammer:before {\n  content: '\\f6e3';\n}\n\n.fa-hamsa:before {\n  content: '\\f665';\n}\n\n.fa-hand-holding:before {\n  content: '\\f4bd';\n}\n\n.fa-hand-holding-heart:before {\n  content: '\\f4be';\n}\n\n.fa-hand-holding-usd:before {\n  content: '\\f4c0';\n}\n\n.fa-hand-lizard:before {\n  content: '\\f258';\n}\n\n.fa-hand-paper:before {\n  content: '\\f256';\n}\n\n.fa-hand-peace:before {\n  content: '\\f25b';\n}\n\n.fa-hand-point-down:before {\n  content: '\\f0a7';\n}\n\n.fa-hand-point-left:before {\n  content: '\\f0a5';\n}\n\n.fa-hand-point-right:before {\n  content: '\\f0a4';\n}\n\n.fa-hand-point-up:before {\n  content: '\\f0a6';\n}\n\n.fa-hand-pointer:before {\n  content: '\\f25a';\n}\n\n.fa-hand-rock:before {\n  content: '\\f255';\n}\n\n.fa-hand-scissors:before {\n  content: '\\f257';\n}\n\n.fa-hand-spock:before {\n  content: '\\f259';\n}\n\n.fa-hands:before {\n  content: '\\f4c2';\n}\n\n.fa-hands-helping:before {\n  content: '\\f4c4';\n}\n\n.fa-handshake:before {\n  content: '\\f2b5';\n}\n\n.fa-hanukiah:before {\n  content: '\\f6e6';\n}\n\n.fa-hashtag:before {\n  content: '\\f292';\n}\n\n.fa-hat-wizard:before {\n  content: '\\f6e8';\n}\n\n.fa-haykal:before {\n  content: '\\f666';\n}\n\n.fa-hdd:before {\n  content: '\\f0a0';\n}\n\n.fa-heading:before {\n  content: '\\f1dc';\n}\n\n.fa-headphones:before {\n  content: '\\f025';\n}\n\n.fa-headphones-alt:before {\n  content: '\\f58f';\n}\n\n.fa-headset:before {\n  content: '\\f590';\n}\n\n.fa-heart:before {\n  content: '\\f004';\n}\n\n.fa-heart-broken:before {\n  content: '\\f7a9';\n}\n\n.fa-heartbeat:before {\n  content: '\\f21e';\n}\n\n.fa-helicopter:before {\n  content: '\\f533';\n}\n\n.fa-highlighter:before {\n  content: '\\f591';\n}\n\n.fa-hiking:before {\n  content: '\\f6ec';\n}\n\n.fa-hippo:before {\n  content: '\\f6ed';\n}\n\n.fa-hips:before {\n  content: '\\f452';\n}\n\n.fa-hire-a-helper:before {\n  content: '\\f3b0';\n}\n\n.fa-history:before {\n  content: '\\f1da';\n}\n\n.fa-hockey-puck:before {\n  content: '\\f453';\n}\n\n.fa-holly-berry:before {\n  content: '\\f7aa';\n}\n\n.fa-home:before {\n  content: '\\f015';\n}\n\n.fa-hooli:before {\n  content: '\\f427';\n}\n\n.fa-hornbill:before {\n  content: '\\f592';\n}\n\n.fa-horse:before {\n  content: '\\f6f0';\n}\n\n.fa-horse-head:before {\n  content: '\\f7ab';\n}\n\n.fa-hospital:before {\n  content: '\\f0f8';\n}\n\n.fa-hospital-alt:before {\n  content: '\\f47d';\n}\n\n.fa-hospital-symbol:before {\n  content: '\\f47e';\n}\n\n.fa-hot-tub:before {\n  content: '\\f593';\n}\n\n.fa-hotel:before {\n  content: '\\f594';\n}\n\n.fa-hotjar:before {\n  content: '\\f3b1';\n}\n\n.fa-hourglass:before {\n  content: '\\f254';\n}\n\n.fa-hourglass-end:before {\n  content: '\\f253';\n}\n\n.fa-hourglass-half:before {\n  content: '\\f252';\n}\n\n.fa-hourglass-start:before {\n  content: '\\f251';\n}\n\n.fa-house-damage:before {\n  content: '\\f6f1';\n}\n\n.fa-houzz:before {\n  content: '\\f27c';\n}\n\n.fa-hryvnia:before {\n  content: '\\f6f2';\n}\n\n.fa-html5:before {\n  content: '\\f13b';\n}\n\n.fa-hubspot:before {\n  content: '\\f3b2';\n}\n\n.fa-i-cursor:before {\n  content: '\\f246';\n}\n\n.fa-icicles:before {\n  content: '\\f7ad';\n}\n\n.fa-id-badge:before {\n  content: '\\f2c1';\n}\n\n.fa-id-card:before {\n  content: '\\f2c2';\n}\n\n.fa-id-card-alt:before {\n  content: '\\f47f';\n}\n\n.fa-igloo:before {\n  content: '\\f7ae';\n}\n\n.fa-image:before {\n  content: '\\f03e';\n}\n\n.fa-images:before {\n  content: '\\f302';\n}\n\n.fa-imdb:before {\n  content: '\\f2d8';\n}\n\n.fa-inbox:before {\n  content: '\\f01c';\n}\n\n.fa-indent:before {\n  content: '\\f03c';\n}\n\n.fa-industry:before {\n  content: '\\f275';\n}\n\n.fa-infinity:before {\n  content: '\\f534';\n}\n\n.fa-info:before {\n  content: '\\f129';\n}\n\n.fa-info-circle:before {\n  content: '\\f05a';\n}\n\n.fa-instagram:before {\n  content: '\\f16d';\n}\n\n.fa-intercom:before {\n  content: '\\f7af';\n}\n\n.fa-internet-explorer:before {\n  content: '\\f26b';\n}\n\n.fa-invision:before {\n  content: '\\f7b0';\n}\n\n.fa-ioxhost:before {\n  content: '\\f208';\n}\n\n.fa-italic:before {\n  content: '\\f033';\n}\n\n.fa-itunes:before {\n  content: '\\f3b4';\n}\n\n.fa-itunes-note:before {\n  content: '\\f3b5';\n}\n\n.fa-java:before {\n  content: '\\f4e4';\n}\n\n.fa-jedi:before {\n  content: '\\f669';\n}\n\n.fa-jedi-order:before {\n  content: '\\f50e';\n}\n\n.fa-jenkins:before {\n  content: '\\f3b6';\n}\n\n.fa-jira:before {\n  content: '\\f7b1';\n}\n\n.fa-joget:before {\n  content: '\\f3b7';\n}\n\n.fa-joint:before {\n  content: '\\f595';\n}\n\n.fa-joomla:before {\n  content: '\\f1aa';\n}\n\n.fa-journal-whills:before {\n  content: '\\f66a';\n}\n\n.fa-js:before {\n  content: '\\f3b8';\n}\n\n.fa-js-square:before {\n  content: '\\f3b9';\n}\n\n.fa-jsfiddle:before {\n  content: '\\f1cc';\n}\n\n.fa-kaaba:before {\n  content: '\\f66b';\n}\n\n.fa-kaggle:before {\n  content: '\\f5fa';\n}\n\n.fa-key:before {\n  content: '\\f084';\n}\n\n.fa-keybase:before {\n  content: '\\f4f5';\n}\n\n.fa-keyboard:before {\n  content: '\\f11c';\n}\n\n.fa-keycdn:before {\n  content: '\\f3ba';\n}\n\n.fa-khanda:before {\n  content: '\\f66d';\n}\n\n.fa-kickstarter:before {\n  content: '\\f3bb';\n}\n\n.fa-kickstarter-k:before {\n  content: '\\f3bc';\n}\n\n.fa-kiss:before {\n  content: '\\f596';\n}\n\n.fa-kiss-beam:before {\n  content: '\\f597';\n}\n\n.fa-kiss-wink-heart:before {\n  content: '\\f598';\n}\n\n.fa-kiwi-bird:before {\n  content: '\\f535';\n}\n\n.fa-korvue:before {\n  content: '\\f42f';\n}\n\n.fa-landmark:before {\n  content: '\\f66f';\n}\n\n.fa-language:before {\n  content: '\\f1ab';\n}\n\n.fa-laptop:before {\n  content: '\\f109';\n}\n\n.fa-laptop-code:before {\n  content: '\\f5fc';\n}\n\n.fa-laravel:before {\n  content: '\\f3bd';\n}\n\n.fa-lastfm:before {\n  content: '\\f202';\n}\n\n.fa-lastfm-square:before {\n  content: '\\f203';\n}\n\n.fa-laugh:before {\n  content: '\\f599';\n}\n\n.fa-laugh-beam:before {\n  content: '\\f59a';\n}\n\n.fa-laugh-squint:before {\n  content: '\\f59b';\n}\n\n.fa-laugh-wink:before {\n  content: '\\f59c';\n}\n\n.fa-layer-group:before {\n  content: '\\f5fd';\n}\n\n.fa-leaf:before {\n  content: '\\f06c';\n}\n\n.fa-leanpub:before {\n  content: '\\f212';\n}\n\n.fa-lemon:before {\n  content: '\\f094';\n}\n\n.fa-less:before {\n  content: '\\f41d';\n}\n\n.fa-less-than:before {\n  content: '\\f536';\n}\n\n.fa-less-than-equal:before {\n  content: '\\f537';\n}\n\n.fa-level-down-alt:before {\n  content: '\\f3be';\n}\n\n.fa-level-up-alt:before {\n  content: '\\f3bf';\n}\n\n.fa-life-ring:before {\n  content: '\\f1cd';\n}\n\n.fa-lightbulb:before {\n  content: '\\f0eb';\n}\n\n.fa-line:before {\n  content: '\\f3c0';\n}\n\n.fa-link:before {\n  content: '\\f0c1';\n}\n\n.fa-linkedin:before {\n  content: '\\f08c';\n}\n\n.fa-linkedin-in:before {\n  content: '\\f0e1';\n}\n\n.fa-linode:before {\n  content: '\\f2b8';\n}\n\n.fa-linux:before {\n  content: '\\f17c';\n}\n\n.fa-lira-sign:before {\n  content: '\\f195';\n}\n\n.fa-list:before {\n  content: '\\f03a';\n}\n\n.fa-list-alt:before {\n  content: '\\f022';\n}\n\n.fa-list-ol:before {\n  content: '\\f0cb';\n}\n\n.fa-list-ul:before {\n  content: '\\f0ca';\n}\n\n.fa-location-arrow:before {\n  content: '\\f124';\n}\n\n.fa-lock:before {\n  content: '\\f023';\n}\n\n.fa-lock-open:before {\n  content: '\\f3c1';\n}\n\n.fa-long-arrow-alt-down:before {\n  content: '\\f309';\n}\n\n.fa-long-arrow-alt-left:before {\n  content: '\\f30a';\n}\n\n.fa-long-arrow-alt-right:before {\n  content: '\\f30b';\n}\n\n.fa-long-arrow-alt-up:before {\n  content: '\\f30c';\n}\n\n.fa-low-vision:before {\n  content: '\\f2a8';\n}\n\n.fa-luggage-cart:before {\n  content: '\\f59d';\n}\n\n.fa-lyft:before {\n  content: '\\f3c3';\n}\n\n.fa-magento:before {\n  content: '\\f3c4';\n}\n\n.fa-magic:before {\n  content: '\\f0d0';\n}\n\n.fa-magnet:before {\n  content: '\\f076';\n}\n\n.fa-mail-bulk:before {\n  content: '\\f674';\n}\n\n.fa-mailchimp:before {\n  content: '\\f59e';\n}\n\n.fa-male:before {\n  content: '\\f183';\n}\n\n.fa-mandalorian:before {\n  content: '\\f50f';\n}\n\n.fa-map:before {\n  content: '\\f279';\n}\n\n.fa-map-marked:before {\n  content: '\\f59f';\n}\n\n.fa-map-marked-alt:before {\n  content: '\\f5a0';\n}\n\n.fa-map-marker:before {\n  content: '\\f041';\n}\n\n.fa-map-marker-alt:before {\n  content: '\\f3c5';\n}\n\n.fa-map-pin:before {\n  content: '\\f276';\n}\n\n.fa-map-signs:before {\n  content: '\\f277';\n}\n\n.fa-markdown:before {\n  content: '\\f60f';\n}\n\n.fa-marker:before {\n  content: '\\f5a1';\n}\n\n.fa-mars:before {\n  content: '\\f222';\n}\n\n.fa-mars-double:before {\n  content: '\\f227';\n}\n\n.fa-mars-stroke:before {\n  content: '\\f229';\n}\n\n.fa-mars-stroke-h:before {\n  content: '\\f22b';\n}\n\n.fa-mars-stroke-v:before {\n  content: '\\f22a';\n}\n\n.fa-mask:before {\n  content: '\\f6fa';\n}\n\n.fa-mastodon:before {\n  content: '\\f4f6';\n}\n\n.fa-maxcdn:before {\n  content: '\\f136';\n}\n\n.fa-medal:before {\n  content: '\\f5a2';\n}\n\n.fa-medapps:before {\n  content: '\\f3c6';\n}\n\n.fa-medium:before {\n  content: '\\f23a';\n}\n\n.fa-medium-m:before {\n  content: '\\f3c7';\n}\n\n.fa-medkit:before {\n  content: '\\f0fa';\n}\n\n.fa-medrt:before {\n  content: '\\f3c8';\n}\n\n.fa-meetup:before {\n  content: '\\f2e0';\n}\n\n.fa-megaport:before {\n  content: '\\f5a3';\n}\n\n.fa-meh:before {\n  content: '\\f11a';\n}\n\n.fa-meh-blank:before {\n  content: '\\f5a4';\n}\n\n.fa-meh-rolling-eyes:before {\n  content: '\\f5a5';\n}\n\n.fa-memory:before {\n  content: '\\f538';\n}\n\n.fa-mendeley:before {\n  content: '\\f7b3';\n}\n\n.fa-menorah:before {\n  content: '\\f676';\n}\n\n.fa-mercury:before {\n  content: '\\f223';\n}\n\n.fa-meteor:before {\n  content: '\\f753';\n}\n\n.fa-microchip:before {\n  content: '\\f2db';\n}\n\n.fa-microphone:before {\n  content: '\\f130';\n}\n\n.fa-microphone-alt:before {\n  content: '\\f3c9';\n}\n\n.fa-microphone-alt-slash:before {\n  content: '\\f539';\n}\n\n.fa-microphone-slash:before {\n  content: '\\f131';\n}\n\n.fa-microscope:before {\n  content: '\\f610';\n}\n\n.fa-microsoft:before {\n  content: '\\f3ca';\n}\n\n.fa-minus:before {\n  content: '\\f068';\n}\n\n.fa-minus-circle:before {\n  content: '\\f056';\n}\n\n.fa-minus-square:before {\n  content: '\\f146';\n}\n\n.fa-mitten:before {\n  content: '\\f7b5';\n}\n\n.fa-mix:before {\n  content: '\\f3cb';\n}\n\n.fa-mixcloud:before {\n  content: '\\f289';\n}\n\n.fa-mizuni:before {\n  content: '\\f3cc';\n}\n\n.fa-mobile:before {\n  content: '\\f10b';\n}\n\n.fa-mobile-alt:before {\n  content: '\\f3cd';\n}\n\n.fa-modx:before {\n  content: '\\f285';\n}\n\n.fa-monero:before {\n  content: '\\f3d0';\n}\n\n.fa-money-bill:before {\n  content: '\\f0d6';\n}\n\n.fa-money-bill-alt:before {\n  content: '\\f3d1';\n}\n\n.fa-money-bill-wave:before {\n  content: '\\f53a';\n}\n\n.fa-money-bill-wave-alt:before {\n  content: '\\f53b';\n}\n\n.fa-money-check:before {\n  content: '\\f53c';\n}\n\n.fa-money-check-alt:before {\n  content: '\\f53d';\n}\n\n.fa-monument:before {\n  content: '\\f5a6';\n}\n\n.fa-moon:before {\n  content: '\\f186';\n}\n\n.fa-mortar-pestle:before {\n  content: '\\f5a7';\n}\n\n.fa-mosque:before {\n  content: '\\f678';\n}\n\n.fa-motorcycle:before {\n  content: '\\f21c';\n}\n\n.fa-mountain:before {\n  content: '\\f6fc';\n}\n\n.fa-mouse-pointer:before {\n  content: '\\f245';\n}\n\n.fa-mug-hot:before {\n  content: '\\f7b6';\n}\n\n.fa-music:before {\n  content: '\\f001';\n}\n\n.fa-napster:before {\n  content: '\\f3d2';\n}\n\n.fa-neos:before {\n  content: '\\f612';\n}\n\n.fa-network-wired:before {\n  content: '\\f6ff';\n}\n\n.fa-neuter:before {\n  content: '\\f22c';\n}\n\n.fa-newspaper:before {\n  content: '\\f1ea';\n}\n\n.fa-nimblr:before {\n  content: '\\f5a8';\n}\n\n.fa-nintendo-switch:before {\n  content: '\\f418';\n}\n\n.fa-node:before {\n  content: '\\f419';\n}\n\n.fa-node-js:before {\n  content: '\\f3d3';\n}\n\n.fa-not-equal:before {\n  content: '\\f53e';\n}\n\n.fa-notes-medical:before {\n  content: '\\f481';\n}\n\n.fa-npm:before {\n  content: '\\f3d4';\n}\n\n.fa-ns8:before {\n  content: '\\f3d5';\n}\n\n.fa-nutritionix:before {\n  content: '\\f3d6';\n}\n\n.fa-object-group:before {\n  content: '\\f247';\n}\n\n.fa-object-ungroup:before {\n  content: '\\f248';\n}\n\n.fa-odnoklassniki:before {\n  content: '\\f263';\n}\n\n.fa-odnoklassniki-square:before {\n  content: '\\f264';\n}\n\n.fa-oil-can:before {\n  content: '\\f613';\n}\n\n.fa-old-republic:before {\n  content: '\\f510';\n}\n\n.fa-om:before {\n  content: '\\f679';\n}\n\n.fa-opencart:before {\n  content: '\\f23d';\n}\n\n.fa-openid:before {\n  content: '\\f19b';\n}\n\n.fa-opera:before {\n  content: '\\f26a';\n}\n\n.fa-optin-monster:before {\n  content: '\\f23c';\n}\n\n.fa-osi:before {\n  content: '\\f41a';\n}\n\n.fa-otter:before {\n  content: '\\f700';\n}\n\n.fa-outdent:before {\n  content: '\\f03b';\n}\n\n.fa-page4:before {\n  content: '\\f3d7';\n}\n\n.fa-pagelines:before {\n  content: '\\f18c';\n}\n\n.fa-paint-brush:before {\n  content: '\\f1fc';\n}\n\n.fa-paint-roller:before {\n  content: '\\f5aa';\n}\n\n.fa-palette:before {\n  content: '\\f53f';\n}\n\n.fa-palfed:before {\n  content: '\\f3d8';\n}\n\n.fa-pallet:before {\n  content: '\\f482';\n}\n\n.fa-paper-plane:before {\n  content: '\\f1d8';\n}\n\n.fa-paperclip:before {\n  content: '\\f0c6';\n}\n\n.fa-parachute-box:before {\n  content: '\\f4cd';\n}\n\n.fa-paragraph:before {\n  content: '\\f1dd';\n}\n\n.fa-parking:before {\n  content: '\\f540';\n}\n\n.fa-passport:before {\n  content: '\\f5ab';\n}\n\n.fa-pastafarianism:before {\n  content: '\\f67b';\n}\n\n.fa-paste:before {\n  content: '\\f0ea';\n}\n\n.fa-patreon:before {\n  content: '\\f3d9';\n}\n\n.fa-pause:before {\n  content: '\\f04c';\n}\n\n.fa-pause-circle:before {\n  content: '\\f28b';\n}\n\n.fa-paw:before {\n  content: '\\f1b0';\n}\n\n.fa-paypal:before {\n  content: '\\f1ed';\n}\n\n.fa-peace:before {\n  content: '\\f67c';\n}\n\n.fa-pen:before {\n  content: '\\f304';\n}\n\n.fa-pen-alt:before {\n  content: '\\f305';\n}\n\n.fa-pen-fancy:before {\n  content: '\\f5ac';\n}\n\n.fa-pen-nib:before {\n  content: '\\f5ad';\n}\n\n.fa-pen-square:before {\n  content: '\\f14b';\n}\n\n.fa-pencil-alt:before {\n  content: '\\f303';\n}\n\n.fa-pencil-ruler:before {\n  content: '\\f5ae';\n}\n\n.fa-penny-arcade:before {\n  content: '\\f704';\n}\n\n.fa-people-carry:before {\n  content: '\\f4ce';\n}\n\n.fa-percent:before {\n  content: '\\f295';\n}\n\n.fa-percentage:before {\n  content: '\\f541';\n}\n\n.fa-periscope:before {\n  content: '\\f3da';\n}\n\n.fa-person-booth:before {\n  content: '\\f756';\n}\n\n.fa-phabricator:before {\n  content: '\\f3db';\n}\n\n.fa-phoenix-framework:before {\n  content: '\\f3dc';\n}\n\n.fa-phoenix-squadron:before {\n  content: '\\f511';\n}\n\n.fa-phone:before {\n  content: '\\f095';\n}\n\n.fa-phone-slash:before {\n  content: '\\f3dd';\n}\n\n.fa-phone-square:before {\n  content: '\\f098';\n}\n\n.fa-phone-volume:before {\n  content: '\\f2a0';\n}\n\n.fa-php:before {\n  content: '\\f457';\n}\n\n.fa-pied-piper:before {\n  content: '\\f2ae';\n}\n\n.fa-pied-piper-alt:before {\n  content: '\\f1a8';\n}\n\n.fa-pied-piper-hat:before {\n  content: '\\f4e5';\n}\n\n.fa-pied-piper-pp:before {\n  content: '\\f1a7';\n}\n\n.fa-piggy-bank:before {\n  content: '\\f4d3';\n}\n\n.fa-pills:before {\n  content: '\\f484';\n}\n\n.fa-pinterest:before {\n  content: '\\f0d2';\n}\n\n.fa-pinterest-p:before {\n  content: '\\f231';\n}\n\n.fa-pinterest-square:before {\n  content: '\\f0d3';\n}\n\n.fa-place-of-worship:before {\n  content: '\\f67f';\n}\n\n.fa-plane:before {\n  content: '\\f072';\n}\n\n.fa-plane-arrival:before {\n  content: '\\f5af';\n}\n\n.fa-plane-departure:before {\n  content: '\\f5b0';\n}\n\n.fa-play:before {\n  content: '\\f04b';\n}\n\n.fa-play-circle:before {\n  content: '\\f144';\n}\n\n.fa-playstation:before {\n  content: '\\f3df';\n}\n\n.fa-plug:before {\n  content: '\\f1e6';\n}\n\n.fa-plus:before {\n  content: '\\f067';\n}\n\n.fa-plus-circle:before {\n  content: '\\f055';\n}\n\n.fa-plus-square:before {\n  content: '\\f0fe';\n}\n\n.fa-podcast:before {\n  content: '\\f2ce';\n}\n\n.fa-poll:before {\n  content: '\\f681';\n}\n\n.fa-poll-h:before {\n  content: '\\f682';\n}\n\n.fa-poo:before {\n  content: '\\f2fe';\n}\n\n.fa-poo-storm:before {\n  content: '\\f75a';\n}\n\n.fa-poop:before {\n  content: '\\f619';\n}\n\n.fa-portrait:before {\n  content: '\\f3e0';\n}\n\n.fa-pound-sign:before {\n  content: '\\f154';\n}\n\n.fa-power-off:before {\n  content: '\\f011';\n}\n\n.fa-pray:before {\n  content: '\\f683';\n}\n\n.fa-praying-hands:before {\n  content: '\\f684';\n}\n\n.fa-prescription:before {\n  content: '\\f5b1';\n}\n\n.fa-prescription-bottle:before {\n  content: '\\f485';\n}\n\n.fa-prescription-bottle-alt:before {\n  content: '\\f486';\n}\n\n.fa-print:before {\n  content: '\\f02f';\n}\n\n.fa-procedures:before {\n  content: '\\f487';\n}\n\n.fa-product-hunt:before {\n  content: '\\f288';\n}\n\n.fa-project-diagram:before {\n  content: '\\f542';\n}\n\n.fa-pushed:before {\n  content: '\\f3e1';\n}\n\n.fa-puzzle-piece:before {\n  content: '\\f12e';\n}\n\n.fa-python:before {\n  content: '\\f3e2';\n}\n\n.fa-qq:before {\n  content: '\\f1d6';\n}\n\n.fa-qrcode:before {\n  content: '\\f029';\n}\n\n.fa-question:before {\n  content: '\\f128';\n}\n\n.fa-question-circle:before {\n  content: '\\f059';\n}\n\n.fa-quidditch:before {\n  content: '\\f458';\n}\n\n.fa-quinscape:before {\n  content: '\\f459';\n}\n\n.fa-quora:before {\n  content: '\\f2c4';\n}\n\n.fa-quote-left:before {\n  content: '\\f10d';\n}\n\n.fa-quote-right:before {\n  content: '\\f10e';\n}\n\n.fa-quran:before {\n  content: '\\f687';\n}\n\n.fa-r-project:before {\n  content: '\\f4f7';\n}\n\n.fa-radiation:before {\n  content: '\\f7b9';\n}\n\n.fa-radiation-alt:before {\n  content: '\\f7ba';\n}\n\n.fa-rainbow:before {\n  content: '\\f75b';\n}\n\n.fa-random:before {\n  content: '\\f074';\n}\n\n.fa-raspberry-pi:before {\n  content: '\\f7bb';\n}\n\n.fa-ravelry:before {\n  content: '\\f2d9';\n}\n\n.fa-react:before {\n  content: '\\f41b';\n}\n\n.fa-reacteurope:before {\n  content: '\\f75d';\n}\n\n.fa-readme:before {\n  content: '\\f4d5';\n}\n\n.fa-rebel:before {\n  content: '\\f1d0';\n}\n\n.fa-receipt:before {\n  content: '\\f543';\n}\n\n.fa-recycle:before {\n  content: '\\f1b8';\n}\n\n.fa-red-river:before {\n  content: '\\f3e3';\n}\n\n.fa-reddit:before {\n  content: '\\f1a1';\n}\n\n.fa-reddit-alien:before {\n  content: '\\f281';\n}\n\n.fa-reddit-square:before {\n  content: '\\f1a2';\n}\n\n.fa-redhat:before {\n  content: '\\f7bc';\n}\n\n.fa-redo:before {\n  content: '\\f01e';\n}\n\n.fa-redo-alt:before {\n  content: '\\f2f9';\n}\n\n.fa-registered:before {\n  content: '\\f25d';\n}\n\n.fa-renren:before {\n  content: '\\f18b';\n}\n\n.fa-reply:before {\n  content: '\\f3e5';\n}\n\n.fa-reply-all:before {\n  content: '\\f122';\n}\n\n.fa-replyd:before {\n  content: '\\f3e6';\n}\n\n.fa-republican:before {\n  content: '\\f75e';\n}\n\n.fa-researchgate:before {\n  content: '\\f4f8';\n}\n\n.fa-resolving:before {\n  content: '\\f3e7';\n}\n\n.fa-restroom:before {\n  content: '\\f7bd';\n}\n\n.fa-retweet:before {\n  content: '\\f079';\n}\n\n.fa-rev:before {\n  content: '\\f5b2';\n}\n\n.fa-ribbon:before {\n  content: '\\f4d6';\n}\n\n.fa-ring:before {\n  content: '\\f70b';\n}\n\n.fa-road:before {\n  content: '\\f018';\n}\n\n.fa-robot:before {\n  content: '\\f544';\n}\n\n.fa-rocket:before {\n  content: '\\f135';\n}\n\n.fa-rocketchat:before {\n  content: '\\f3e8';\n}\n\n.fa-rockrms:before {\n  content: '\\f3e9';\n}\n\n.fa-route:before {\n  content: '\\f4d7';\n}\n\n.fa-rss:before {\n  content: '\\f09e';\n}\n\n.fa-rss-square:before {\n  content: '\\f143';\n}\n\n.fa-ruble-sign:before {\n  content: '\\f158';\n}\n\n.fa-ruler:before {\n  content: '\\f545';\n}\n\n.fa-ruler-combined:before {\n  content: '\\f546';\n}\n\n.fa-ruler-horizontal:before {\n  content: '\\f547';\n}\n\n.fa-ruler-vertical:before {\n  content: '\\f548';\n}\n\n.fa-running:before {\n  content: '\\f70c';\n}\n\n.fa-rupee-sign:before {\n  content: '\\f156';\n}\n\n.fa-sad-cry:before {\n  content: '\\f5b3';\n}\n\n.fa-sad-tear:before {\n  content: '\\f5b4';\n}\n\n.fa-safari:before {\n  content: '\\f267';\n}\n\n.fa-sass:before {\n  content: '\\f41e';\n}\n\n.fa-satellite:before {\n  content: '\\f7bf';\n}\n\n.fa-satellite-dish:before {\n  content: '\\f7c0';\n}\n\n.fa-save:before {\n  content: '\\f0c7';\n}\n\n.fa-schlix:before {\n  content: '\\f3ea';\n}\n\n.fa-school:before {\n  content: '\\f549';\n}\n\n.fa-screwdriver:before {\n  content: '\\f54a';\n}\n\n.fa-scribd:before {\n  content: '\\f28a';\n}\n\n.fa-scroll:before {\n  content: '\\f70e';\n}\n\n.fa-sd-card:before {\n  content: '\\f7c2';\n}\n\n.fa-search:before {\n  content: '\\f002';\n}\n\n.fa-search-dollar:before {\n  content: '\\f688';\n}\n\n.fa-search-location:before {\n  content: '\\f689';\n}\n\n.fa-search-minus:before {\n  content: '\\f010';\n}\n\n.fa-search-plus:before {\n  content: '\\f00e';\n}\n\n.fa-searchengin:before {\n  content: '\\f3eb';\n}\n\n.fa-seedling:before {\n  content: '\\f4d8';\n}\n\n.fa-sellcast:before {\n  content: '\\f2da';\n}\n\n.fa-sellsy:before {\n  content: '\\f213';\n}\n\n.fa-server:before {\n  content: '\\f233';\n}\n\n.fa-servicestack:before {\n  content: '\\f3ec';\n}\n\n.fa-shapes:before {\n  content: '\\f61f';\n}\n\n.fa-share:before {\n  content: '\\f064';\n}\n\n.fa-share-alt:before {\n  content: '\\f1e0';\n}\n\n.fa-share-alt-square:before {\n  content: '\\f1e1';\n}\n\n.fa-share-square:before {\n  content: '\\f14d';\n}\n\n.fa-shekel-sign:before {\n  content: '\\f20b';\n}\n\n.fa-shield-alt:before {\n  content: '\\f3ed';\n}\n\n.fa-ship:before {\n  content: '\\f21a';\n}\n\n.fa-shipping-fast:before {\n  content: '\\f48b';\n}\n\n.fa-shirtsinbulk:before {\n  content: '\\f214';\n}\n\n.fa-shoe-prints:before {\n  content: '\\f54b';\n}\n\n.fa-shopping-bag:before {\n  content: '\\f290';\n}\n\n.fa-shopping-basket:before {\n  content: '\\f291';\n}\n\n.fa-shopping-cart:before {\n  content: '\\f07a';\n}\n\n.fa-shopware:before {\n  content: '\\f5b5';\n}\n\n.fa-shower:before {\n  content: '\\f2cc';\n}\n\n.fa-shuttle-van:before {\n  content: '\\f5b6';\n}\n\n.fa-sign:before {\n  content: '\\f4d9';\n}\n\n.fa-sign-in-alt:before {\n  content: '\\f2f6';\n}\n\n.fa-sign-language:before {\n  content: '\\f2a7';\n}\n\n.fa-sign-out-alt:before {\n  content: '\\f2f5';\n}\n\n.fa-signal:before {\n  content: '\\f012';\n}\n\n.fa-signature:before {\n  content: '\\f5b7';\n}\n\n.fa-sim-card:before {\n  content: '\\f7c4';\n}\n\n.fa-simplybuilt:before {\n  content: '\\f215';\n}\n\n.fa-sistrix:before {\n  content: '\\f3ee';\n}\n\n.fa-sitemap:before {\n  content: '\\f0e8';\n}\n\n.fa-sith:before {\n  content: '\\f512';\n}\n\n.fa-skating:before {\n  content: '\\f7c5';\n}\n\n.fa-sketch:before {\n  content: '\\f7c6';\n}\n\n.fa-skiing:before {\n  content: '\\f7c9';\n}\n\n.fa-skiing-nordic:before {\n  content: '\\f7ca';\n}\n\n.fa-skull:before {\n  content: '\\f54c';\n}\n\n.fa-skull-crossbones:before {\n  content: '\\f714';\n}\n\n.fa-skyatlas:before {\n  content: '\\f216';\n}\n\n.fa-skype:before {\n  content: '\\f17e';\n}\n\n.fa-slack:before {\n  content: '\\f198';\n}\n\n.fa-slack-hash:before {\n  content: '\\f3ef';\n}\n\n.fa-slash:before {\n  content: '\\f715';\n}\n\n.fa-sleigh:before {\n  content: '\\f7cc';\n}\n\n.fa-sliders-h:before {\n  content: '\\f1de';\n}\n\n.fa-slideshare:before {\n  content: '\\f1e7';\n}\n\n.fa-smile:before {\n  content: '\\f118';\n}\n\n.fa-smile-beam:before {\n  content: '\\f5b8';\n}\n\n.fa-smile-wink:before {\n  content: '\\f4da';\n}\n\n.fa-smog:before {\n  content: '\\f75f';\n}\n\n.fa-smoking:before {\n  content: '\\f48d';\n}\n\n.fa-smoking-ban:before {\n  content: '\\f54d';\n}\n\n.fa-sms:before {\n  content: '\\f7cd';\n}\n\n.fa-snapchat:before {\n  content: '\\f2ab';\n}\n\n.fa-snapchat-ghost:before {\n  content: '\\f2ac';\n}\n\n.fa-snapchat-square:before {\n  content: '\\f2ad';\n}\n\n.fa-snowboarding:before {\n  content: '\\f7ce';\n}\n\n.fa-snowflake:before {\n  content: '\\f2dc';\n}\n\n.fa-snowman:before {\n  content: '\\f7d0';\n}\n\n.fa-snowplow:before {\n  content: '\\f7d2';\n}\n\n.fa-socks:before {\n  content: '\\f696';\n}\n\n.fa-solar-panel:before {\n  content: '\\f5ba';\n}\n\n.fa-sort:before {\n  content: '\\f0dc';\n}\n\n.fa-sort-alpha-down:before {\n  content: '\\f15d';\n}\n\n.fa-sort-alpha-up:before {\n  content: '\\f15e';\n}\n\n.fa-sort-amount-down:before {\n  content: '\\f160';\n}\n\n.fa-sort-amount-up:before {\n  content: '\\f161';\n}\n\n.fa-sort-down:before {\n  content: '\\f0dd';\n}\n\n.fa-sort-numeric-down:before {\n  content: '\\f162';\n}\n\n.fa-sort-numeric-up:before {\n  content: '\\f163';\n}\n\n.fa-sort-up:before {\n  content: '\\f0de';\n}\n\n.fa-soundcloud:before {\n  content: '\\f1be';\n}\n\n.fa-sourcetree:before {\n  content: '\\f7d3';\n}\n\n.fa-spa:before {\n  content: '\\f5bb';\n}\n\n.fa-space-shuttle:before {\n  content: '\\f197';\n}\n\n.fa-speakap:before {\n  content: '\\f3f3';\n}\n\n.fa-spider:before {\n  content: '\\f717';\n}\n\n.fa-spinner:before {\n  content: '\\f110';\n}\n\n.fa-splotch:before {\n  content: '\\f5bc';\n}\n\n.fa-spotify:before {\n  content: '\\f1bc';\n}\n\n.fa-spray-can:before {\n  content: '\\f5bd';\n}\n\n.fa-square:before {\n  content: '\\f0c8';\n}\n\n.fa-square-full:before {\n  content: '\\f45c';\n}\n\n.fa-square-root-alt:before {\n  content: '\\f698';\n}\n\n.fa-squarespace:before {\n  content: '\\f5be';\n}\n\n.fa-stack-exchange:before {\n  content: '\\f18d';\n}\n\n.fa-stack-overflow:before {\n  content: '\\f16c';\n}\n\n.fa-stamp:before {\n  content: '\\f5bf';\n}\n\n.fa-star:before {\n  content: '\\f005';\n}\n\n.fa-star-and-crescent:before {\n  content: '\\f699';\n}\n\n.fa-star-half:before {\n  content: '\\f089';\n}\n\n.fa-star-half-alt:before {\n  content: '\\f5c0';\n}\n\n.fa-star-of-david:before {\n  content: '\\f69a';\n}\n\n.fa-star-of-life:before {\n  content: '\\f621';\n}\n\n.fa-staylinked:before {\n  content: '\\f3f5';\n}\n\n.fa-steam:before {\n  content: '\\f1b6';\n}\n\n.fa-steam-square:before {\n  content: '\\f1b7';\n}\n\n.fa-steam-symbol:before {\n  content: '\\f3f6';\n}\n\n.fa-step-backward:before {\n  content: '\\f048';\n}\n\n.fa-step-forward:before {\n  content: '\\f051';\n}\n\n.fa-stethoscope:before {\n  content: '\\f0f1';\n}\n\n.fa-sticker-mule:before {\n  content: '\\f3f7';\n}\n\n.fa-sticky-note:before {\n  content: '\\f249';\n}\n\n.fa-stop:before {\n  content: '\\f04d';\n}\n\n.fa-stop-circle:before {\n  content: '\\f28d';\n}\n\n.fa-stopwatch:before {\n  content: '\\f2f2';\n}\n\n.fa-store:before {\n  content: '\\f54e';\n}\n\n.fa-store-alt:before {\n  content: '\\f54f';\n}\n\n.fa-strava:before {\n  content: '\\f428';\n}\n\n.fa-stream:before {\n  content: '\\f550';\n}\n\n.fa-street-view:before {\n  content: '\\f21d';\n}\n\n.fa-strikethrough:before {\n  content: '\\f0cc';\n}\n\n.fa-stripe:before {\n  content: '\\f429';\n}\n\n.fa-stripe-s:before {\n  content: '\\f42a';\n}\n\n.fa-stroopwafel:before {\n  content: '\\f551';\n}\n\n.fa-studiovinari:before {\n  content: '\\f3f8';\n}\n\n.fa-stumbleupon:before {\n  content: '\\f1a4';\n}\n\n.fa-stumbleupon-circle:before {\n  content: '\\f1a3';\n}\n\n.fa-subscript:before {\n  content: '\\f12c';\n}\n\n.fa-subway:before {\n  content: '\\f239';\n}\n\n.fa-suitcase:before {\n  content: '\\f0f2';\n}\n\n.fa-suitcase-rolling:before {\n  content: '\\f5c1';\n}\n\n.fa-sun:before {\n  content: '\\f185';\n}\n\n.fa-superpowers:before {\n  content: '\\f2dd';\n}\n\n.fa-superscript:before {\n  content: '\\f12b';\n}\n\n.fa-supple:before {\n  content: '\\f3f9';\n}\n\n.fa-surprise:before {\n  content: '\\f5c2';\n}\n\n.fa-suse:before {\n  content: '\\f7d6';\n}\n\n.fa-swatchbook:before {\n  content: '\\f5c3';\n}\n\n.fa-swimmer:before {\n  content: '\\f5c4';\n}\n\n.fa-swimming-pool:before {\n  content: '\\f5c5';\n}\n\n.fa-synagogue:before {\n  content: '\\f69b';\n}\n\n.fa-sync:before {\n  content: '\\f021';\n}\n\n.fa-sync-alt:before {\n  content: '\\f2f1';\n}\n\n.fa-syringe:before {\n  content: '\\f48e';\n}\n\n.fa-table:before {\n  content: '\\f0ce';\n}\n\n.fa-table-tennis:before {\n  content: '\\f45d';\n}\n\n.fa-tablet:before {\n  content: '\\f10a';\n}\n\n.fa-tablet-alt:before {\n  content: '\\f3fa';\n}\n\n.fa-tablets:before {\n  content: '\\f490';\n}\n\n.fa-tachometer-alt:before {\n  content: '\\f3fd';\n}\n\n.fa-tag:before {\n  content: '\\f02b';\n}\n\n.fa-tags:before {\n  content: '\\f02c';\n}\n\n.fa-tape:before {\n  content: '\\f4db';\n}\n\n.fa-tasks:before {\n  content: '\\f0ae';\n}\n\n.fa-taxi:before {\n  content: '\\f1ba';\n}\n\n.fa-teamspeak:before {\n  content: '\\f4f9';\n}\n\n.fa-teeth:before {\n  content: '\\f62e';\n}\n\n.fa-teeth-open:before {\n  content: '\\f62f';\n}\n\n.fa-telegram:before {\n  content: '\\f2c6';\n}\n\n.fa-telegram-plane:before {\n  content: '\\f3fe';\n}\n\n.fa-temperature-high:before {\n  content: '\\f769';\n}\n\n.fa-temperature-low:before {\n  content: '\\f76b';\n}\n\n.fa-tencent-weibo:before {\n  content: '\\f1d5';\n}\n\n.fa-tenge:before {\n  content: '\\f7d7';\n}\n\n.fa-terminal:before {\n  content: '\\f120';\n}\n\n.fa-text-height:before {\n  content: '\\f034';\n}\n\n.fa-text-width:before {\n  content: '\\f035';\n}\n\n.fa-th:before {\n  content: '\\f00a';\n}\n\n.fa-th-large:before {\n  content: '\\f009';\n}\n\n.fa-th-list:before {\n  content: '\\f00b';\n}\n\n.fa-the-red-yeti:before {\n  content: '\\f69d';\n}\n\n.fa-theater-masks:before {\n  content: '\\f630';\n}\n\n.fa-themeco:before {\n  content: '\\f5c6';\n}\n\n.fa-themeisle:before {\n  content: '\\f2b2';\n}\n\n.fa-thermometer:before {\n  content: '\\f491';\n}\n\n.fa-thermometer-empty:before {\n  content: '\\f2cb';\n}\n\n.fa-thermometer-full:before {\n  content: '\\f2c7';\n}\n\n.fa-thermometer-half:before {\n  content: '\\f2c9';\n}\n\n.fa-thermometer-quarter:before {\n  content: '\\f2ca';\n}\n\n.fa-thermometer-three-quarters:before {\n  content: '\\f2c8';\n}\n\n.fa-think-peaks:before {\n  content: '\\f731';\n}\n\n.fa-thumbs-down:before {\n  content: '\\f165';\n}\n\n.fa-thumbs-up:before {\n  content: '\\f164';\n}\n\n.fa-thumbtack:before {\n  content: '\\f08d';\n}\n\n.fa-ticket-alt:before {\n  content: '\\f3ff';\n}\n\n.fa-times:before {\n  content: '\\f00d';\n}\n\n.fa-times-circle:before {\n  content: '\\f057';\n}\n\n.fa-tint:before {\n  content: '\\f043';\n}\n\n.fa-tint-slash:before {\n  content: '\\f5c7';\n}\n\n.fa-tired:before {\n  content: '\\f5c8';\n}\n\n.fa-toggle-off:before {\n  content: '\\f204';\n}\n\n.fa-toggle-on:before {\n  content: '\\f205';\n}\n\n.fa-toilet:before {\n  content: '\\f7d8';\n}\n\n.fa-toilet-paper:before {\n  content: '\\f71e';\n}\n\n.fa-toolbox:before {\n  content: '\\f552';\n}\n\n.fa-tools:before {\n  content: '\\f7d9';\n}\n\n.fa-tooth:before {\n  content: '\\f5c9';\n}\n\n.fa-torah:before {\n  content: '\\f6a0';\n}\n\n.fa-torii-gate:before {\n  content: '\\f6a1';\n}\n\n.fa-tractor:before {\n  content: '\\f722';\n}\n\n.fa-trade-federation:before {\n  content: '\\f513';\n}\n\n.fa-trademark:before {\n  content: '\\f25c';\n}\n\n.fa-traffic-light:before {\n  content: '\\f637';\n}\n\n.fa-train:before {\n  content: '\\f238';\n}\n\n.fa-tram:before {\n  content: '\\f7da';\n}\n\n.fa-transgender:before {\n  content: '\\f224';\n}\n\n.fa-transgender-alt:before {\n  content: '\\f225';\n}\n\n.fa-trash:before {\n  content: '\\f1f8';\n}\n\n.fa-trash-alt:before {\n  content: '\\f2ed';\n}\n\n.fa-tree:before {\n  content: '\\f1bb';\n}\n\n.fa-trello:before {\n  content: '\\f181';\n}\n\n.fa-tripadvisor:before {\n  content: '\\f262';\n}\n\n.fa-trophy:before {\n  content: '\\f091';\n}\n\n.fa-truck:before {\n  content: '\\f0d1';\n}\n\n.fa-truck-loading:before {\n  content: '\\f4de';\n}\n\n.fa-truck-monster:before {\n  content: '\\f63b';\n}\n\n.fa-truck-moving:before {\n  content: '\\f4df';\n}\n\n.fa-truck-pickup:before {\n  content: '\\f63c';\n}\n\n.fa-tshirt:before {\n  content: '\\f553';\n}\n\n.fa-tty:before {\n  content: '\\f1e4';\n}\n\n.fa-tumblr:before {\n  content: '\\f173';\n}\n\n.fa-tumblr-square:before {\n  content: '\\f174';\n}\n\n.fa-tv:before {\n  content: '\\f26c';\n}\n\n.fa-twitch:before {\n  content: '\\f1e8';\n}\n\n.fa-twitter:before {\n  content: '\\f099';\n}\n\n.fa-twitter-square:before {\n  content: '\\f081';\n}\n\n.fa-typo3:before {\n  content: '\\f42b';\n}\n\n.fa-uber:before {\n  content: '\\f402';\n}\n\n.fa-ubuntu:before {\n  content: '\\f7df';\n}\n\n.fa-uikit:before {\n  content: '\\f403';\n}\n\n.fa-umbrella:before {\n  content: '\\f0e9';\n}\n\n.fa-umbrella-beach:before {\n  content: '\\f5ca';\n}\n\n.fa-underline:before {\n  content: '\\f0cd';\n}\n\n.fa-undo:before {\n  content: '\\f0e2';\n}\n\n.fa-undo-alt:before {\n  content: '\\f2ea';\n}\n\n.fa-uniregistry:before {\n  content: '\\f404';\n}\n\n.fa-universal-access:before {\n  content: '\\f29a';\n}\n\n.fa-university:before {\n  content: '\\f19c';\n}\n\n.fa-unlink:before {\n  content: '\\f127';\n}\n\n.fa-unlock:before {\n  content: '\\f09c';\n}\n\n.fa-unlock-alt:before {\n  content: '\\f13e';\n}\n\n.fa-untappd:before {\n  content: '\\f405';\n}\n\n.fa-upload:before {\n  content: '\\f093';\n}\n\n.fa-ups:before {\n  content: '\\f7e0';\n}\n\n.fa-usb:before {\n  content: '\\f287';\n}\n\n.fa-user:before {\n  content: '\\f007';\n}\n\n.fa-user-alt:before {\n  content: '\\f406';\n}\n\n.fa-user-alt-slash:before {\n  content: '\\f4fa';\n}\n\n.fa-user-astronaut:before {\n  content: '\\f4fb';\n}\n\n.fa-user-check:before {\n  content: '\\f4fc';\n}\n\n.fa-user-circle:before {\n  content: '\\f2bd';\n}\n\n.fa-user-clock:before {\n  content: '\\f4fd';\n}\n\n.fa-user-cog:before {\n  content: '\\f4fe';\n}\n\n.fa-user-edit:before {\n  content: '\\f4ff';\n}\n\n.fa-user-friends:before {\n  content: '\\f500';\n}\n\n.fa-user-graduate:before {\n  content: '\\f501';\n}\n\n.fa-user-injured:before {\n  content: '\\f728';\n}\n\n.fa-user-lock:before {\n  content: '\\f502';\n}\n\n.fa-user-md:before {\n  content: '\\f0f0';\n}\n\n.fa-user-minus:before {\n  content: '\\f503';\n}\n\n.fa-user-ninja:before {\n  content: '\\f504';\n}\n\n.fa-user-plus:before {\n  content: '\\f234';\n}\n\n.fa-user-secret:before {\n  content: '\\f21b';\n}\n\n.fa-user-shield:before {\n  content: '\\f505';\n}\n\n.fa-user-slash:before {\n  content: '\\f506';\n}\n\n.fa-user-tag:before {\n  content: '\\f507';\n}\n\n.fa-user-tie:before {\n  content: '\\f508';\n}\n\n.fa-user-times:before {\n  content: '\\f235';\n}\n\n.fa-users:before {\n  content: '\\f0c0';\n}\n\n.fa-users-cog:before {\n  content: '\\f509';\n}\n\n.fa-usps:before {\n  content: '\\f7e1';\n}\n\n.fa-ussunnah:before {\n  content: '\\f407';\n}\n\n.fa-utensil-spoon:before {\n  content: '\\f2e5';\n}\n\n.fa-utensils:before {\n  content: '\\f2e7';\n}\n\n.fa-vaadin:before {\n  content: '\\f408';\n}\n\n.fa-vector-square:before {\n  content: '\\f5cb';\n}\n\n.fa-venus:before {\n  content: '\\f221';\n}\n\n.fa-venus-double:before {\n  content: '\\f226';\n}\n\n.fa-venus-mars:before {\n  content: '\\f228';\n}\n\n.fa-viacoin:before {\n  content: '\\f237';\n}\n\n.fa-viadeo:before {\n  content: '\\f2a9';\n}\n\n.fa-viadeo-square:before {\n  content: '\\f2aa';\n}\n\n.fa-vial:before {\n  content: '\\f492';\n}\n\n.fa-vials:before {\n  content: '\\f493';\n}\n\n.fa-viber:before {\n  content: '\\f409';\n}\n\n.fa-video:before {\n  content: '\\f03d';\n}\n\n.fa-video-slash:before {\n  content: '\\f4e2';\n}\n\n.fa-vihara:before {\n  content: '\\f6a7';\n}\n\n.fa-vimeo:before {\n  content: '\\f40a';\n}\n\n.fa-vimeo-square:before {\n  content: '\\f194';\n}\n\n.fa-vimeo-v:before {\n  content: '\\f27d';\n}\n\n.fa-vine:before {\n  content: '\\f1ca';\n}\n\n.fa-vk:before {\n  content: '\\f189';\n}\n\n.fa-vnv:before {\n  content: '\\f40b';\n}\n\n.fa-volleyball-ball:before {\n  content: '\\f45f';\n}\n\n.fa-volume-down:before {\n  content: '\\f027';\n}\n\n.fa-volume-mute:before {\n  content: '\\f6a9';\n}\n\n.fa-volume-off:before {\n  content: '\\f026';\n}\n\n.fa-volume-up:before {\n  content: '\\f028';\n}\n\n.fa-vote-yea:before {\n  content: '\\f772';\n}\n\n.fa-vr-cardboard:before {\n  content: '\\f729';\n}\n\n.fa-vuejs:before {\n  content: '\\f41f';\n}\n\n.fa-walking:before {\n  content: '\\f554';\n}\n\n.fa-wallet:before {\n  content: '\\f555';\n}\n\n.fa-warehouse:before {\n  content: '\\f494';\n}\n\n.fa-water:before {\n  content: '\\f773';\n}\n\n.fa-weebly:before {\n  content: '\\f5cc';\n}\n\n.fa-weibo:before {\n  content: '\\f18a';\n}\n\n.fa-weight:before {\n  content: '\\f496';\n}\n\n.fa-weight-hanging:before {\n  content: '\\f5cd';\n}\n\n.fa-weixin:before {\n  content: '\\f1d7';\n}\n\n.fa-whatsapp:before {\n  content: '\\f232';\n}\n\n.fa-whatsapp-square:before {\n  content: '\\f40c';\n}\n\n.fa-wheelchair:before {\n  content: '\\f193';\n}\n\n.fa-whmcs:before {\n  content: '\\f40d';\n}\n\n.fa-wifi:before {\n  content: '\\f1eb';\n}\n\n.fa-wikipedia-w:before {\n  content: '\\f266';\n}\n\n.fa-wind:before {\n  content: '\\f72e';\n}\n\n.fa-window-close:before {\n  content: '\\f410';\n}\n\n.fa-window-maximize:before {\n  content: '\\f2d0';\n}\n\n.fa-window-minimize:before {\n  content: '\\f2d1';\n}\n\n.fa-window-restore:before {\n  content: '\\f2d2';\n}\n\n.fa-windows:before {\n  content: '\\f17a';\n}\n\n.fa-wine-bottle:before {\n  content: '\\f72f';\n}\n\n.fa-wine-glass:before {\n  content: '\\f4e3';\n}\n\n.fa-wine-glass-alt:before {\n  content: '\\f5ce';\n}\n\n.fa-wix:before {\n  content: '\\f5cf';\n}\n\n.fa-wizards-of-the-coast:before {\n  content: '\\f730';\n}\n\n.fa-wolf-pack-battalion:before {\n  content: '\\f514';\n}\n\n.fa-won-sign:before {\n  content: '\\f159';\n}\n\n.fa-wordpress:before {\n  content: '\\f19a';\n}\n\n.fa-wordpress-simple:before {\n  content: '\\f411';\n}\n\n.fa-wpbeginner:before {\n  content: '\\f297';\n}\n\n.fa-wpexplorer:before {\n  content: '\\f2de';\n}\n\n.fa-wpforms:before {\n  content: '\\f298';\n}\n\n.fa-wpressr:before {\n  content: '\\f3e4';\n}\n\n.fa-wrench:before {\n  content: '\\f0ad';\n}\n\n.fa-x-ray:before {\n  content: '\\f497';\n}\n\n.fa-xbox:before {\n  content: '\\f412';\n}\n\n.fa-xing:before {\n  content: '\\f168';\n}\n\n.fa-xing-square:before {\n  content: '\\f169';\n}\n\n.fa-y-combinator:before {\n  content: '\\f23b';\n}\n\n.fa-yahoo:before {\n  content: '\\f19e';\n}\n\n.fa-yandex:before {\n  content: '\\f413';\n}\n\n.fa-yandex-international:before {\n  content: '\\f414';\n}\n\n.fa-yarn:before {\n  content: '\\f7e3';\n}\n\n.fa-yelp:before {\n  content: '\\f1e9';\n}\n\n.fa-yen-sign:before {\n  content: '\\f157';\n}\n\n.fa-yin-yang:before {\n  content: '\\f6ad';\n}\n\n.fa-yoast:before {\n  content: '\\f2b1';\n}\n\n.fa-youtube:before {\n  content: '\\f167';\n}\n\n.fa-youtube-square:before {\n  content: '\\f431';\n}\n\n.fa-zhihu:before {\n  content: '\\f63f';\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable {\n  &:active,\n  &:focus {\n    clip: auto;\n    height: auto;\n    margin: 0;\n    overflow: visible;\n    position: static;\n    width: auto;\n  }\n}\n\n@font-face {\n  font-family: 'Font Awesome 5 Brands';\n  font-style: normal;\n  font-weight: normal;\n  src: url(./fonts/fa-brands-400.eot);\n  src: url(./fonts/fa-brands-400.eot?#iefix) format('embedded-opentype'), url(./fonts/fa-brands-400.woff2) format('woff2'),\n    url(./fonts/fa-brands-400.woff) format('woff'), url(./fonts/fa-brands-400.ttf) format('truetype'),\n    url(./fonts/fa-brands-400.svg#fontawesome) format('svg');\n}\n\n.fab {\n  font-family: 'Font Awesome 5 Brands';\n}\n\n@font-face {\n  font-family: 'Font Awesome 5 Free';\n  font-style: normal;\n  font-weight: 400;\n  src: url(./fonts/fa-regular-400.eot);\n  src: url(./fonts/fa-regular-400.eot?#iefix) format('embedded-opentype'), url(./fonts/fa-regular-400.woff2) format('woff2'),\n    url(./fonts/fa-regular-400.woff) format('woff'), url(./fonts/fa-regular-400.ttf) format('truetype'),\n    url(./fonts/fa-regular-400.svg#fontawesome) format('svg');\n}\n\n.far {\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: 'Font Awesome 5 Free';\n  font-style: normal;\n  font-weight: 900;\n  src: url(./fonts/fa-solid-900.eot);\n  src: url(./fonts/fa-solid-900.eot?#iefix) format('embedded-opentype'), url(./fonts/fa-solid-900.woff2) format('woff2'),\n    url(./fonts/fa-solid-900.woff) format('woff'), url(./fonts/fa-solid-900.ttf) format('truetype'),\n    url(./fonts/fa-solid-900.svg#fontawesome) format('svg');\n}\n\n.fa,\n.far,\n.fas {\n  font-family: 'Font Awesome 5 Free';\n}\n\n.fa,\n.fas {\n  font-weight: 900;\n}\n","/*\n    Flaticon icon font: Flaticon\n    Creation date: 11/04/2019 05:01\n    */\n\n@font-face {\n  font-family: 'Flaticon';\n  src: url('./fonts/Flaticon.eot');\n  src: url('./fonts/Flaticon.eot?#iefix') format('embedded-opentype'), url('./fonts/Flaticon.woff2') format('woff2'),\n    url('./fonts/Flaticon.woff') format('woff'), url('./fonts/Flaticon.ttf') format('truetype'),\n    url('./fonts/Flaticon.svg#Flaticon') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@media screen and (-webkit-min-device-pixel-ratio: 0) {\n  @font-face {\n    font-family: 'Flaticon';\n    src: url('./fonts/Flaticon.svg#Flaticon') format('svg');\n  }\n}\n.fi:before {\n  display: inline-block;\n  font-family: 'Flaticon';\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  line-height: 1;\n  text-decoration: inherit;\n  text-rendering: optimizeLegibility;\n  text-transform: none;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n}\n\n.flaticon-shield:before {\n  content: '\\f100';\n}\n.flaticon-layout:before {\n  content: '\\f101';\n}\n.flaticon-layers:before {\n  content: '\\f102';\n}\n.flaticon-cube:before {\n  content: '\\f103';\n}\n.flaticon-compass:before {\n  content: '\\f104';\n}\n.flaticon-thunderbolt:before {\n  content: '\\f105';\n}\n.flaticon-gift:before {\n  content: '\\f106';\n}\n.flaticon-shapes-and-symbols:before {\n  content: '\\f107';\n}\n.flaticon-feather:before {\n  content: '\\f108';\n}\n.flaticon-menu:before {\n  content: '\\f109';\n}\n.flaticon-abc:before {\n  content: '\\f10a';\n}\n.flaticon-alarm:before {\n  content: '\\f10b';\n}\n.flaticon-locker:before {\n  content: '\\f10c';\n}\n.flaticon-menu-1:before {\n  content: '\\f10d';\n}\n.flaticon-crop:before {\n  content: '\\f10e';\n}\n.flaticon-mail:before {\n  content: '\\f10f';\n}\n.flaticon-diamond:before {\n  content: '\\f110';\n}\n.flaticon-edit:before {\n  content: '\\f111';\n}\n.flaticon-gear:before {\n  content: '\\f112';\n}\n.flaticon-video:before {\n  content: '\\f113';\n}\n.flaticon-clipboard:before {\n  content: '\\f114';\n}\n.flaticon-search:before {\n  content: '\\f115';\n}\n.flaticon-data-storage:before {\n  content: '\\f116';\n}\n.flaticon-table:before {\n  content: '\\f117';\n}\n.flaticon-pie-chart:before {\n  content: '\\f118';\n}\n.flaticon-map:before {\n  content: '\\f119';\n}\n.flaticon-calendar:before {\n  content: '\\f11a';\n}\n.flaticon-mixer:before {\n  content: '\\f11b';\n}\n.flaticon-chat:before {\n  content: '\\f11c';\n}\n.flaticon-lock:before {\n  content: '\\f11d';\n}\n.flaticon-photo:before {\n  content: '\\f11e';\n}\n.flaticon-start-up:before {\n  content: '\\f11f';\n}\n.flaticon-test:before {\n  content: '\\f120';\n}\n.flaticon-study:before {\n  content: '\\f121';\n}\n.flaticon-information:before {\n  content: '\\f122';\n}\n.flaticon-support:before {\n  content: '\\f123';\n}\n.flaticon-help:before {\n  content: '\\f124';\n}\n.flaticon-business-and-finance:before {\n  content: '\\f125';\n}\n.flaticon-cloud:before {\n  content: '\\f126';\n}\n.flaticon-grid:before {\n  content: '\\f127';\n}\n.flaticon-text:before {\n  content: '\\f128';\n}\n.flaticon-draft:before {\n  content: '\\f129';\n}\n.flaticon-writing:before {\n  content: '\\f12a';\n}\n.flaticon-flag:before {\n  content: '\\f12b';\n}\n.flaticon-waiting:before {\n  content: '\\f12c';\n}\n.flaticon-questions:before {\n  content: '\\f12d';\n}\n\n$font-Flaticon-shield: '\\f100';\n$font-Flaticon-layout: '\\f101';\n$font-Flaticon-layers: '\\f102';\n$font-Flaticon-cube: '\\f103';\n$font-Flaticon-compass: '\\f104';\n$font-Flaticon-thunderbolt: '\\f105';\n$font-Flaticon-gift: '\\f106';\n$font-Flaticon-shapes-and-symbols: '\\f107';\n$font-Flaticon-feather: '\\f108';\n$font-Flaticon-menu: '\\f109';\n$font-Flaticon-abc: '\\f10a';\n$font-Flaticon-alarm: '\\f10b';\n$font-Flaticon-locker: '\\f10c';\n$font-Flaticon-menu-1: '\\f10d';\n$font-Flaticon-crop: '\\f10e';\n$font-Flaticon-mail: '\\f10f';\n$font-Flaticon-diamond: '\\f110';\n$font-Flaticon-edit: '\\f111';\n$font-Flaticon-gear: '\\f112';\n$font-Flaticon-video: '\\f113';\n$font-Flaticon-clipboard: '\\f114';\n$font-Flaticon-search: '\\f115';\n$font-Flaticon-data-storage: '\\f116';\n$font-Flaticon-table: '\\f117';\n$font-Flaticon-pie-chart: '\\f118';\n$font-Flaticon-map: '\\f119';\n$font-Flaticon-calendar: '\\f11a';\n$font-Flaticon-mixer: '\\f11b';\n$font-Flaticon-chat: '\\f11c';\n$font-Flaticon-lock: '\\f11d';\n$font-Flaticon-photo: '\\f11e';\n$font-Flaticon-start-up: '\\f11f';\n$font-Flaticon-test: '\\f120';\n$font-Flaticon-study: '\\f121';\n$font-Flaticon-information: '\\f122';\n$font-Flaticon-support: '\\f123';\n$font-Flaticon-help: '\\f124';\n$font-Flaticon-business-and-finance: '\\f125';\n$font-Flaticon-cloud: '\\f126';\n$font-Flaticon-grid: '\\f127';\n$font-Flaticon-text: '\\f128';\n$font-Flaticon-draft: '\\f129';\n$font-Flaticon-writing: '\\f12a';\n$font-Flaticon-flag: '\\f12b';\n$font-Flaticon-waiting: '\\f12c';\n$font-Flaticon-questions: '\\f12d';\n","@font-face {\n  font-family: 'cryptocoins';\n  src: url('./fonts/cryptocoins.woff2') format('woff2'), url('./fonts/cryptocoins.woff') format('woff'),\n    url('./fonts/cryptocoins.ttf') format('truetype');\n}\n\n/* .cc:before { */\n.cc::before {\n  font-family: 'cryptocoins';\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-style: normal;\n  font-variant: normal;\n  font-weight: normal;\n  /* speak: none; only necessary if not using the private unicode range (firstGlyph option) */\n  text-decoration: none;\n  text-transform: none;\n}\n\n.cc.ADA-alt::before {\n  content: '\\E001';\n}\n\n.cc.ADA::before {\n  content: '\\E002';\n}\n\n.cc.ADC-alt::before {\n  content: '\\E003';\n}\n\n.cc.ADC::before {\n  content: '\\E004';\n}\n\n.cc.AEON-alt::before {\n  content: '\\E005';\n}\n\n.cc.AEON::before {\n  content: '\\E006';\n}\n\n.cc.AMP-alt::before {\n  content: '\\E007';\n}\n\n.cc.AMP::before {\n  content: '\\E008';\n}\n\n.cc.ANC-alt::before {\n  content: '\\E009';\n}\n\n.cc.ANC::before {\n  content: '\\E00A';\n}\n\n.cc.ARCH-alt::before {\n  content: '\\E00B';\n}\n\n.cc.ARCH::before {\n  content: '\\E00C';\n}\n\n.cc.ARDR-alt::before {\n  content: '\\E00D';\n}\n\n.cc.ARDR::before {\n  content: '\\E00E';\n}\n\n.cc.ARK-alt::before {\n  content: '\\E00F';\n}\n\n.cc.ARK::before {\n  content: '\\E010';\n}\n\n.cc.AST::before {\n  content: '\\E011';\n}\n\n.cc.AUR-alt::before {\n  content: '\\E012';\n}\n\n.cc.AUR::before {\n  content: '\\E013';\n}\n\n.cc.BANX-alt::before {\n  content: '\\E014';\n}\n\n.cc.BANX::before {\n  content: '\\E015';\n}\n\n.cc.BAT-alt::before {\n  content: '\\E016';\n}\n\n.cc.BAT::before {\n  content: '\\E017';\n}\n\n.cc.BAY-alt::before {\n  content: '\\E018';\n}\n\n.cc.BAY::before {\n  content: '\\E019';\n}\n\n.cc.BC-alt::before {\n  content: '\\E01A';\n}\n\n.cc.BLK-alt::before {\n  content: '\\E01A';\n}\n\n.cc.BC::before {\n  content: '\\E01B';\n}\n\n.cc.BLK::before {\n  content: '\\E01B';\n}\n\n.cc.BCH-alt::before {\n  content: '\\E01C';\n}\n\n.cc.BCC-alt::before {\n  content: '\\E01C';\n}\n\n.cc.BCH::before {\n  content: '\\E01D';\n}\n\n.cc.BCC::before {\n  content: '\\E01D';\n}\n\n.cc.BCN-alt::before {\n  content: '\\E01E';\n}\n\n.cc.BCN::before {\n  content: '\\E01F';\n}\n\n.cc.BCY::before {\n  content: '\\E020';\n}\n\n.cc.BELA::before {\n  content: '\\E021';\n}\n\n.cc.BFT-alt::before {\n  content: '\\E022';\n}\n\n.cc.BFT::before {\n  content: '\\E023';\n}\n\n.cc.BLZ::before {\n  content: '\\E024';\n}\n\n.cc.BNB::before {\n  content: '\\E025';\n}\n\n.cc.BRK-alt::before {\n  content: '\\E026';\n}\n\n.cc.BRK::before {\n  content: '\\E027';\n}\n\n.cc.BRX-alt::before {\n  content: '\\E028';\n}\n\n.cc.BRX::before {\n  content: '\\E029';\n}\n\n.cc.BSD-alt::before {\n  content: '\\E02A';\n}\n\n.cc.BSD::before {\n  content: '\\E02B';\n}\n\n.cc.BTA::before {\n  content: '\\E02C';\n}\n\n.cc.BTC-alt::before {\n  content: '\\E02D';\n}\n\n.cc.BTC::before {\n  content: '\\E02E';\n}\n\n.cc.BTCD-alt::before {\n  content: '\\E02F';\n}\n\n.cc.BTCD::before {\n  content: '\\E030';\n}\n\n.cc.BTCP-alt::before {\n  content: '\\E031';\n}\n\n.cc.BTCP::before {\n  content: '\\E032';\n}\n\n.cc.BTG::before {\n  content: '\\E033';\n}\n\n.cc.BTM-alt::before {\n  content: '\\E034';\n}\n\n.cc.BTM::before {\n  content: '\\E035';\n}\n\n.cc.BTS-alt::before {\n  content: '\\E036';\n}\n\n.cc.BTS::before {\n  content: '\\E037';\n}\n\n.cc.BURST::before {\n  content: '\\E038';\n}\n\n.cc.CLAM-alt::before {\n  content: '\\E039';\n}\n\n.cc.CLAM::before {\n  content: '\\E03A';\n}\n\n.cc.CLOAK-alt::before {\n  content: '\\E03B';\n}\n\n.cc.CLOAK::before {\n  content: '\\E03C';\n}\n\n.cc.CVC-alt::before {\n  content: '\\E03D';\n}\n\n.cc.CVC::before {\n  content: '\\E03E';\n}\n\n.cc.DAO-alt::before {\n  content: '\\E03F';\n}\n\n.cc.DAO::before {\n  content: '\\E040';\n}\n\n.cc.DASH-alt::before {\n  content: '\\E041';\n}\n\n.cc.DASH::before {\n  content: '\\E042';\n}\n\n.cc.DCR-alt::before {\n  content: '\\E043';\n}\n\n.cc.DCR::before {\n  content: '\\E044';\n}\n\n.cc.DCT-alt::before {\n  content: '\\E045';\n}\n\n.cc.DCT::before {\n  content: '\\E046';\n}\n\n.cc.DGB-alt::before {\n  content: '\\E047';\n}\n\n.cc.DGB::before {\n  content: '\\E048';\n}\n\n.cc.DGD::before {\n  content: '\\E049';\n}\n\n.cc.DGX::before {\n  content: '\\E04A';\n}\n\n.cc.DMD-alt::before {\n  content: '\\E04B';\n}\n\n.cc.DMD::before {\n  content: '\\E04C';\n}\n\n.cc.DOGE-alt::before {\n  content: '\\E04D';\n}\n\n.cc.DOGE::before {\n  content: '\\E04E';\n}\n\n.cc.EMC-alt::before {\n  content: '\\E04F';\n}\n\n.cc.EMC::before {\n  content: '\\E050';\n}\n\n.cc.EMC2-alt::before {\n  content: '\\E051';\n}\n\n.cc.EMC2::before {\n  content: '\\E052';\n}\n\n.cc.EOS-alt::before {\n  content: '\\E053';\n}\n\n.cc.EOS::before {\n  content: '\\E054';\n}\n\n.cc.ERC-alt::before {\n  content: '\\E055';\n}\n\n.cc.ERC::before {\n  content: '\\E056';\n}\n\n.cc.ETC-alt::before {\n  content: '\\E057';\n}\n\n.cc.ETC::before {\n  content: '\\E058';\n}\n\n.cc.ETH-alt::before {\n  content: '\\E059';\n}\n\n.cc.ETH::before {\n  content: '\\E05A';\n}\n\n.cc.EXP-alt::before {\n  content: '\\E05B';\n}\n\n.cc.EXP::before {\n  content: '\\E05C';\n}\n\n.cc.FC2-alt::before {\n  content: '\\E05D';\n}\n\n.cc.FC2::before {\n  content: '\\E05E';\n}\n\n.cc.FCT-alt::before {\n  content: '\\E05F';\n}\n\n.cc.FCT::before {\n  content: '\\E060';\n}\n\n.cc.FLDC-alt::before {\n  content: '\\E061';\n}\n\n.cc.FLDC::before {\n  content: '\\E062';\n}\n\n.cc.FLO-alt::before {\n  content: '\\E063';\n}\n\n.cc.FLO::before {\n  content: '\\E064';\n}\n\n.cc.FRK-alt::before {\n  content: '\\E065';\n}\n\n.cc.FRK::before {\n  content: '\\E066';\n}\n\n.cc.FTC-alt::before {\n  content: '\\E067';\n}\n\n.cc.FTC::before {\n  content: '\\E068';\n}\n\n.cc.FUN::before {\n  content: '\\E069';\n}\n\n.cc.GAME-alt::before {\n  content: '\\E06A';\n}\n\n.cc.GAME::before {\n  content: '\\E06B';\n}\n\n.cc.GBYTE-alt::before {\n  content: '\\E06C';\n}\n\n.cc.GBYTE::before {\n  content: '\\E06D';\n}\n\n.cc.GDC-alt::before {\n  content: '\\E06E';\n}\n\n.cc.GDC::before {\n  content: '\\E06F';\n}\n\n.cc.GEMZ-alt::before {\n  content: '\\E070';\n}\n\n.cc.GEMZ::before {\n  content: '\\E071';\n}\n\n.cc.GLD-alt::before {\n  content: '\\E072';\n}\n\n.cc.GLD::before {\n  content: '\\E073';\n}\n\n.cc.GNO-alt::before {\n  content: '\\E074';\n}\n\n.cc.GNO::before {\n  content: '\\E075';\n}\n\n.cc.GNT-alt::before {\n  content: '\\E076';\n}\n\n.cc.GNT::before {\n  content: '\\E077';\n}\n\n.cc.GOLOS-alt::before {\n  content: '\\E078';\n}\n\n.cc.GOLOS::before {\n  content: '\\E079';\n}\n\n.cc.GRC-alt::before {\n  content: '\\E07A';\n}\n\n.cc.GRC::before {\n  content: '\\E07B';\n}\n\n.cc.GRS::before {\n  content: '\\E07C';\n}\n\n.cc.HEAT-alt::before {\n  content: '\\E07D';\n}\n\n.cc.HEAT::before {\n  content: '\\E07E';\n}\n\n.cc.HSR::before {\n  content: '\\E07F';\n}\n\n.cc.HUC-alt::before {\n  content: '\\E080';\n}\n\n.cc.HUC::before {\n  content: '\\E081';\n}\n\n.cc.ICN-alt::before {\n  content: '\\E082';\n}\n\n.cc.ICN::before {\n  content: '\\E083';\n}\n\n.cc.ICX::before {\n  content: '\\E084';\n}\n\n.cc.IFC-alt::before {\n  content: '\\E085';\n}\n\n.cc.IFC::before {\n  content: '\\E086';\n}\n\n.cc.INCNT-alt::before {\n  content: '\\E087';\n}\n\n.cc.INCNT::before {\n  content: '\\E088';\n}\n\n.cc.IOC-alt::before {\n  content: '\\E089';\n}\n\n.cc.IOC::before {\n  content: '\\E08A';\n}\n\n.cc.IOTA-alt::before {\n  content: '\\E08B';\n}\n\n.cc.IOTA::before {\n  content: '\\E08C';\n}\n\n.cc.JBS-alt::before {\n  content: '\\E08D';\n}\n\n.cc.JBS::before {\n  content: '\\E08E';\n}\n\n.cc.KMD-alt::before {\n  content: '\\E08F';\n}\n\n.cc.KMD::before {\n  content: '\\E090';\n}\n\n.cc.KOBO::before {\n  content: '\\E091';\n}\n\n.cc.KORE-alt::before {\n  content: '\\E092';\n}\n\n.cc.KORE::before {\n  content: '\\E093';\n}\n\n.cc.LBC-alt::before {\n  content: '\\E094';\n}\n\n.cc.LBC::before {\n  content: '\\E095';\n}\n\n.cc.LDOGE-alt::before {\n  content: '\\E096';\n}\n\n.cc.LDOGE::before {\n  content: '\\E097';\n}\n\n.cc.LSK-alt::before {\n  content: '\\E098';\n}\n\n.cc.LSK::before {\n  content: '\\E099';\n}\n\n.cc.LTC-alt::before {\n  content: '\\E09A';\n}\n\n.cc.LTC::before {\n  content: '\\E09B';\n}\n\n.cc.MAID-alt::before {\n  content: '\\E09C';\n}\n\n.cc.MAID::before {\n  content: '\\E09D';\n}\n\n.cc.MARKS-alt::before {\n  content: '\\E09E';\n}\n\n.cc.MARKS::before {\n  content: '\\E09F';\n}\n\n.cc.Bitmark::before {\n  content: '\\E09F';\n}\n\n.cc.MCO-alt::before {\n  content: '\\E0A0';\n}\n\n.cc.MCO::before {\n  content: '\\E0A1';\n}\n\n.cc.MINT-alt::before {\n  content: '\\E0A2';\n}\n\n.cc.MINT::before {\n  content: '\\E0A3';\n}\n\n.cc.MONA-alt::before {\n  content: '\\E0A4';\n}\n\n.cc.MONA::before {\n  content: '\\E0A5';\n}\n\n.cc.MRC::before {\n  content: '\\E0A6';\n}\n\n.cc.MSC-alt::before {\n  content: '\\E0A7';\n}\n\n.cc.MSC::before {\n  content: '\\E0A8';\n}\n\n.cc.MTL-alt::before {\n  content: '\\E0A9';\n}\n\n.cc.MTL::before {\n  content: '\\E0AA';\n}\n\n.cc.MTR-alt::before {\n  content: '\\E0AB';\n}\n\n.cc.MTR::before {\n  content: '\\E0AC';\n}\n\n.cc.MUE-alt::before {\n  content: '\\E0AD';\n}\n\n.cc.MUE::before {\n  content: '\\E0AE';\n}\n\n.cc.MYST-alt::before {\n  content: '\\E0AF';\n}\n\n.cc.MYST::before {\n  content: '\\E0B0';\n}\n\n.cc.NAV-alt::before {\n  content: '\\E0B1';\n}\n\n.cc.NAV::before {\n  content: '\\E0B2';\n}\n\n.cc.NBT::before {\n  content: '\\E0B3';\n}\n\n.cc.USNBT::before {\n  content: '\\E0B3';\n}\n\n.cc.NEO-alt::before {\n  content: '\\E0B4';\n}\n\n.cc.NEO::before {\n  content: '\\E0B5';\n}\n\n.cc.GAS::before {\n  content: '\\E0B5';\n}\n\n.cc.NEOS-alt::before {\n  content: '\\E0B6';\n}\n\n.cc.NEOS::before {\n  content: '\\E0B7';\n}\n\n.cc.NEU-alt::before {\n  content: '\\E0B8';\n}\n\n.cc.NEU::before {\n  content: '\\E0B9';\n}\n\n.cc.NLG-alt::before {\n  content: '\\E0BA';\n}\n\n.cc.NLG::before {\n  content: '\\E0BB';\n}\n\n.cc.NMC-alt::before {\n  content: '\\E0BC';\n}\n\n.cc.NMC::before {\n  content: '\\E0BD';\n}\n\n.cc.NMR::before {\n  content: '\\E0BE';\n}\n\n.cc.NOTE-alt::before {\n  content: '\\E0BF';\n}\n\n.cc.NOTE::before {\n  content: '\\E0C0';\n}\n\n.cc.NVC-alt::before {\n  content: '\\E0C1';\n}\n\n.cc.NVC::before {\n  content: '\\E0C2';\n}\n\n.cc.NXT-alt::before {\n  content: '\\E0C3';\n}\n\n.cc.NXT::before {\n  content: '\\E0C4';\n}\n\n.cc.OK-alt::before {\n  content: '\\E0C5';\n}\n\n.cc.OK::before {\n  content: '\\E0C6';\n}\n\n.cc.OMG-alt::before {\n  content: '\\E0C7';\n}\n\n.cc.OMG::before {\n  content: '\\E0C8';\n}\n\n.cc.OMNI-alt::before {\n  content: '\\E0C9';\n}\n\n.cc.OMNI::before {\n  content: '\\E0CA';\n}\n\n.cc.OPAL-alt::before {\n  content: '\\E0CB';\n}\n\n.cc.OPAL::before {\n  content: '\\E0CC';\n}\n\n.cc.PART-alt::before {\n  content: '\\E0CD';\n}\n\n.cc.PART::before {\n  content: '\\E0CE';\n}\n\n.cc.PASC::before {\n  content: '\\E0CF';\n}\n\n.cc.PIGGY-alt::before {\n  content: '\\E0D0';\n}\n\n.cc.PIGGY::before {\n  content: '\\E0D1';\n}\n\n.cc.PINK-alt::before {\n  content: '\\E0D2';\n}\n\n.cc.PINK::before {\n  content: '\\E0D3';\n}\n\n.cc.PIVX-alt::before {\n  content: '\\E0D4';\n}\n\n.cc.PIVX::before {\n  content: '\\E0D5';\n}\n\n.cc.POT-alt::before {\n  content: '\\E0D6';\n}\n\n.cc.POT::before {\n  content: '\\E0D7';\n}\n\n.cc.PPC-alt::before {\n  content: '\\E0D8';\n}\n\n.cc.PPC::before {\n  content: '\\E0D9';\n}\n\n.cc.PPT::before {\n  content: '\\E0DA';\n}\n\n.cc.QRK-alt::before {\n  content: '\\E0DB';\n}\n\n.cc.QRK::before {\n  content: '\\E0DC';\n}\n\n.cc.QTUM-alt::before {\n  content: '\\E0DD';\n}\n\n.cc.QTUM::before {\n  content: '\\E0DE';\n}\n\n.cc.RADS-alt::before {\n  content: '\\E0DF';\n}\n\n.cc.RADS::before {\n  content: '\\E0E0';\n}\n\n.cc.RBIES-alt::before {\n  content: '\\E0E1';\n}\n\n.cc.RBIES::before {\n  content: '\\E0E2';\n}\n\n.cc.RBT-alt::before {\n  content: '\\E0E3';\n}\n\n.cc.RBT::before {\n  content: '\\E0E4';\n}\n\n.cc.RBY-alt::before {\n  content: '\\E0E5';\n}\n\n.cc.RBY::before {\n  content: '\\E0E6';\n}\n\n.cc.RDD-alt::before {\n  content: '\\E0E7';\n}\n\n.cc.RDD::before {\n  content: '\\E0E8';\n}\n\n.cc.REP-alt::before {\n  content: '\\E0E9';\n}\n\n.cc.REP::before {\n  content: '\\E0EA';\n}\n\n.cc.RHOC::before {\n  content: '\\E0EB';\n}\n\n.cc.RIC-alt::before {\n  content: '\\E0EC';\n}\n\n.cc.RIC::before {\n  content: '\\E0ED';\n}\n\n.cc.RISE-alt::before {\n  content: '\\E0EE';\n}\n\n.cc.RISE::before {\n  content: '\\E0EF';\n}\n\n.cc.SALT-alt::before {\n  content: '\\E0F0';\n}\n\n.cc.SALT::before {\n  content: '\\E0F1';\n}\n\n.cc.SAR-alt::before {\n  content: '\\E0F2';\n}\n\n.cc.SAR::before {\n  content: '\\E0F3';\n}\n\n.cc.SCOT-alt::before {\n  content: '\\E0F4';\n}\n\n.cc.SCOT::before {\n  content: '\\E0F5';\n}\n\n.cc.SDC-alt::before {\n  content: '\\E0F6';\n}\n\n.cc.SDC::before {\n  content: '\\E0F7';\n}\n\n.cc.SIA-alt::before {\n  content: '\\E0F8';\n}\n\n.cc.SIA::before {\n  content: '\\E0F9';\n}\n\n.cc.SC::before {\n  content: '\\E0F9';\n}\n\n.cc.SJCX-alt::before {\n  content: '\\E0FA';\n}\n\n.cc.SJCX::before {\n  content: '\\E0FB';\n}\n\n.cc.STORJ::before {\n  content: '\\E0FB';\n}\n\n.cc.SLG-alt::before {\n  content: '\\E0FC';\n}\n\n.cc.SLG::before {\n  content: '\\E0FD';\n}\n\n.cc.SLS-alt::before {\n  content: '\\E0FE';\n}\n\n.cc.SLS::before {\n  content: '\\E0FF';\n}\n\n.cc.SNRG-alt::before {\n  content: '\\E100';\n}\n\n.cc.SNRG::before {\n  content: '\\E101';\n}\n\n.cc.SNT::before {\n  content: '\\E102';\n}\n\n.cc.START-alt::before {\n  content: '\\E103';\n}\n\n.cc.START::before {\n  content: '\\E104';\n}\n\n.cc.STEEM-alt::before {\n  content: '\\E105';\n}\n\n.cc.STEEM::before {\n  content: '\\E106';\n}\n\n.cc.SBD::before {\n  content: '\\E106';\n}\n\n.cc.STRAT-alt::before {\n  content: '\\E107';\n}\n\n.cc.STRAT::before {\n  content: '\\E108';\n}\n\n.cc.SWIFT-alt::before {\n  content: '\\E109';\n}\n\n.cc.SWIFT::before {\n  content: '\\E10A';\n}\n\n.cc.SYNC-alt::before {\n  content: '\\E10B';\n}\n\n.cc.SYNC::before {\n  content: '\\E10C';\n}\n\n.cc.SYS-alt::before {\n  content: '\\E10D';\n}\n\n.cc.SYS::before {\n  content: '\\E10E';\n}\n\n.cc.TRIG-alt::before {\n  content: '\\E10F';\n}\n\n.cc.TRIG::before {\n  content: '\\E110';\n}\n\n.cc.TRX::before {\n  content: '\\E111';\n}\n\n.cc.TX-alt::before {\n  content: '\\E112';\n}\n\n.cc.TX::before {\n  content: '\\E113';\n}\n\n.cc.UBQ-alt::before {\n  content: '\\E114';\n}\n\n.cc.UBQ::before {\n  content: '\\E115';\n}\n\n.cc.UNITY-alt::before {\n  content: '\\E116';\n}\n\n.cc.UNITY::before {\n  content: '\\E117';\n}\n\n.cc.USDT-alt::before {\n  content: '\\E118';\n}\n\n.cc.USDT::before {\n  content: '\\E119';\n}\n\n.cc.VERI::before {\n  content: '\\E11A';\n}\n\n.cc.VET::before {\n  content: '\\E11B';\n}\n\n.cc.VIA-alt::before {\n  content: '\\E11C';\n}\n\n.cc.VIA::before {\n  content: '\\E11D';\n}\n\n.cc.VIOR-alt::before {\n  content: '\\E11E';\n}\n\n.cc.VIOR::before {\n  content: '\\E11F';\n}\n\n.cc.VNL-alt::before {\n  content: '\\E120';\n}\n\n.cc.VNL::before {\n  content: '\\E121';\n}\n\n.cc.VPN-alt::before {\n  content: '\\E122';\n}\n\n.cc.VPN::before {\n  content: '\\E123';\n}\n\n.cc.VRC-alt::before {\n  content: '\\E124';\n}\n\n.cc.VRC::before {\n  content: '\\E125';\n}\n\n.cc.VTC-alt::before {\n  content: '\\E126';\n}\n\n.cc.VTC::before {\n  content: '\\E127';\n}\n\n.cc.WAVES-alt::before {\n  content: '\\E128';\n}\n\n.cc.WAVES::before {\n  content: '\\E129';\n}\n\n.cc.XAI-alt::before {\n  content: '\\E12A';\n}\n\n.cc.XAI::before {\n  content: '\\E12B';\n}\n\n.cc.XBC::before {\n  content: '\\E12C';\n}\n\n.cc.XBS-alt::before {\n  content: '\\E12D';\n}\n\n.cc.XBS::before {\n  content: '\\E12E';\n}\n\n.cc.XCP-alt::before {\n  content: '\\E12F';\n}\n\n.cc.XCP::before {\n  content: '\\E130';\n}\n\n.cc.XEM-alt::before {\n  content: '\\E131';\n}\n\n.cc.XEM::before {\n  content: '\\E132';\n}\n\n.cc.XLM-alt::before {\n  content: '\\E133';\n}\n\n.cc.XLM::before {\n  content: '\\E134';\n}\n\n.cc.XMR::before {\n  content: '\\E135';\n}\n\n.cc.XMY::before {\n  content: '\\E136';\n}\n\n.cc.XPM-alt::before {\n  content: '\\E137';\n}\n\n.cc.XPM::before {\n  content: '\\E138';\n}\n\n.cc.XRB::before {\n  content: '\\E139';\n}\n\n.cc.XRP-alt::before {\n  content: '\\E13A';\n}\n\n.cc.XRP::before {\n  content: '\\E13B';\n}\n\n.cc.XTZ-alt::before {\n  content: '\\E13C';\n}\n\n.cc.XTZ::before {\n  content: '\\E13D';\n}\n\n.cc.XVC-alt::before {\n  content: '\\E13E';\n}\n\n.cc.XVC::before {\n  content: '\\E13F';\n}\n\n.cc.XVG-alt::before {\n  content: '\\E140';\n}\n\n.cc.XVG::before {\n  content: '\\E141';\n}\n\n.cc.XZC-alt::before {\n  content: '\\E142';\n}\n\n.cc.XZC::before {\n  content: '\\E143';\n}\n\n.cc.YBC-alt::before {\n  content: '\\E144';\n}\n\n.cc.YBC::before {\n  content: '\\E145';\n}\n\n.cc.ZEC-alt::before {\n  content: '\\E146';\n}\n\n.cc.ZEC::before {\n  content: '\\E147';\n}\n\n.cc.ZEIT-alt::before {\n  content: '\\E148';\n}\n\n.cc.ZEIT::before {\n  content: '\\E149';\n}\n\n.cc.ZRX-alt::before {\n  content: '\\E14A';\n}\n\n.cc.ZRX::before {\n  content: '\\E14B';\n}\n\n.ADA {\n  color: #3cc8c8;\n}\n.ADC {\n  color: #3cb0e5;\n}\n.AEON {\n  color: #164450;\n}\n.AMP {\n  color: #048dd2;\n}\n.ANC {\n  color: #000;\n}\n.ARCH {\n  color: #002652;\n}\n.ARDR {\n  color: #1162a1;\n}\n.ARK {\n  color: #f70000;\n}\n.AST {\n  color: #18f18f;\n}\n.AUR {\n  color: #136c5e;\n}\n.BANX {\n  color: #225ba6;\n}\n.BAT {\n  color: #9e1f63;\n}\n.BAY {\n  color: #584ba1;\n}\n.BC {\n  color: #202121;\n}\n.BCN {\n  color: #964f51;\n}\n.BCY {\n  color: #123a5a;\n}\n.BELA {\n  color: #009ef9;\n}\n.BFT {\n  color: #4fc3f7;\n}\n.BLZ {\n  color: #6be6be;\n}\n.BRK {\n  color: #194fa0;\n}\n.BRX {\n  color: #a8c300;\n}\n.BSD {\n  color: #1186e7;\n}\n.BTA {\n  color: #210094;\n}\n.BTC,\n.BCH {\n  color: #f7931a;\n}\n.BTG {\n  color: #eba809;\n}\n.BTCD {\n  color: #2a72dc;\n}\n.BTCP {\n  color: #272d63;\n}\n.BTM {\n  color: #9fa8b4;\n}\n.BTS {\n  color: #03a9e0;\n}\n.BURST {\n  color: #2d2d2d;\n}\n.CLAM {\n  color: #d6ab31;\n}\n.CLOAK {\n  color: #df3f1e;\n}\n.CVC {\n  color: #3ab03e;\n}\n.DAO {\n  color: #ff3b3b;\n}\n.DASH {\n  color: #1c75bc;\n}\n.DCR {\n  color: #3b7cfb;\n}\n.DCT {\n  color: #008770;\n}\n.DGB {\n  color: #0066cc;\n}\n.DGD,\n.DGX {\n  color: #d8a24a;\n}\n.DMD {\n  color: #5497b2;\n}\n.DOGE {\n  color: #ba9f33;\n}\n.EMC {\n  color: #674c8c;\n}\n.EMC2 {\n  color: #00ccff;\n}\n.EOS {\n  color: #19191a;\n}\n.ERC {\n  color: #101e84;\n}\n.ETC {\n  color: #669073;\n}\n.ETH {\n  color: #282828;\n}\n.EXP {\n  color: #ffaa5c;\n}\n.FC2 {\n  color: #040405;\n}\n.FCT {\n  color: #2175bb;\n}\n.FLDC {\n  color: #c40e09;\n}\n.FLO {\n  color: #1358c8;\n}\n.FRK {\n  color: #0633cd;\n}\n.FTC {\n  color: #679ef1;\n}\n.FUN {\n  color: #ef3a5c;\n}\n.GAME {\n  color: #ed1b24;\n}\n.GBYTE {\n  color: #2c3e50;\n}\n.GDC {\n  color: #e9a226;\n}\n.GEMZ {\n  color: #e86060;\n}\n.GLD {\n  color: #e8be24;\n}\n.GNO {\n  color: #00a6c4;\n}\n.GNT {\n  color: #00d6e3;\n}\n.GOLOS {\n  color: #2670b7;\n}\n.GRC {\n  color: #88a13c;\n}\n.GRS {\n  color: #648fa0;\n}\n.HEAT {\n  color: #ff5606;\n}\n.HUC {\n  color: #ffc018;\n}\n.ICN {\n  color: #4c6f8c;\n}\n.ICX {\n  color: #22c8cc;\n}\n.IFC {\n  color: #ed272d;\n}\n.INCNT {\n  color: #f2932f;\n}\n.IOC {\n  color: #2fa3de;\n}\n.IOTA {\n  color: #ffffff;\n}\n.JBS {\n  color: #1a8bcd;\n}\n.KMD {\n  color: #326464;\n}\n.KOBO {\n  color: #80c342;\n}\n.KORE {\n  color: #df4124;\n}\n.LBC {\n  color: #015c47;\n}\n.LDOGE {\n  color: #ffcc00;\n}\n.LSK {\n  color: #0d4ea0;\n}\n.LTC {\n  color: #838383;\n}\n.MAID {\n  color: #5492d6;\n}\n.MARKS {\n  color: #504c4c;\n}\n.MCO {\n  color: #0d3459;\n}\n.MINT {\n  color: #006835;\n}\n.MONA {\n  color: #a99364;\n}\n.MRC {\n  color: #4279bd;\n}\n.MSC {\n  color: #1d4983;\n}\n.MTL {\n  color: #242424;\n}\n.MTR {\n  color: #b92429;\n}\n.MUE {\n  color: #f5a10e;\n}\n.NAV {\n  color: #7d59b5;\n}\n.MYST {\n  color: #f5a10e;\n}\n.NBT {\n  color: #ffc93d;\n}\n.NEO {\n  color: #58bf00;\n}\n.NEOS {\n  color: #1d1d1b;\n}\n.NEU {\n  color: #2983c0;\n}\n.NLG {\n  color: #003e7e;\n}\n.NMC {\n  color: #6787b7;\n}\n.NMR {\n  color: #8de8de;\n}\n.NOTE {\n  color: #42daff;\n}\n.NVC {\n  color: #ecab41;\n}\n.NXT {\n  color: #008fbb;\n}\n.OK {\n  color: #0165a4;\n}\n.OMG {\n  color: #1a53f0;\n}\n.OMNI {\n  color: #18347e;\n}\n.OPAL {\n  color: #7193aa;\n}\n.PART {\n  color: #05d5a3;\n}\n.PASC {\n  color: #f7931e;\n}\n.PIGGY {\n  color: #f27a7a;\n}\n.PINK {\n  color: #ed31ca;\n}\n.PIVX {\n  color: #3b2f4d;\n}\n.POT {\n  color: #105b2f;\n}\n.PPC {\n  color: #3fa30c;\n}\n.PPT {\n  color: #5a9ef6;\n}\n.QRK {\n  color: #22aabf;\n}\n.QTUM {\n  color: #359bce;\n}\n.RADS {\n  color: #924cea;\n}\n.RBIES {\n  color: #c62436;\n}\n.RBT {\n  color: #0d4982;\n}\n.RBY {\n  color: #d31f26;\n}\n.RDD {\n  color: #ed1c24;\n}\n.REP {\n  color: #40a2cb;\n}\n.RIC {\n  color: #60e4dd;\n}\n.RHOC {\n  color: #c26c26;\n}\n.RISE {\n  color: #43cea2;\n}\n.SALT {\n  color: #373c43;\n}\n.SAR {\n  color: #1b72b8;\n}\n.SCOT {\n  color: #3498db;\n}\n.SDC {\n  color: #981d2d;\n}\n.SIA {\n  color: #00cba0;\n}\n.SJCX {\n  color: #003366;\n}\n.SLG {\n  color: #5a6875;\n}\n.SLS {\n  color: #1eb549;\n}\n.SNRG {\n  color: #160363;\n}\n.START {\n  color: #01aef0;\n}\n.STEEM {\n  color: #1a5099;\n}\n.STRAT {\n  color: #2398dd;\n}\n.SWIFT {\n  color: #428bca;\n}\n.SYNC {\n  color: #008dd2;\n}\n.SYS {\n  color: #0098da;\n}\n.TRIG {\n  color: #1fbff4;\n}\n.TRX {\n  color: #c62734;\n}\n.TX {\n  color: #1f8bcc;\n}\n.UBQ {\n  color: #00ec8d;\n}\n.UNITY {\n  color: #ed8527;\n}\n.USDT {\n  color: #2ca07a;\n}\n.VEN {\n  color: #15bdff;\n}\n.VIA {\n  color: #565656;\n}\n.VIOR {\n  color: #1f52a4;\n}\n.VNL {\n  color: #404249;\n}\n.VPN {\n  color: #589700;\n}\n.VRC {\n  color: #418bca;\n}\n.VTC {\n  color: #1b5c2e;\n}\n.WAVES {\n  color: #24aad6;\n}\n.XAI {\n  color: #2ef99f;\n}\n.XBC {\n  color: #f7931a;\n}\n.XBS {\n  color: #d3261d;\n}\n.XCP {\n  color: #ec1550;\n}\n.XEM {\n  color: #41bf76;\n}\n.XLM {\n  color: #08b5e5;\n}\n.XMR {\n  color: #ff6600;\n}\n.XMY {\n  color: #bc3182;\n}\n.XPM {\n  color: #e5b625;\n}\n.XRP {\n  color: #346aa9;\n}\n.XTZ {\n  color: #a6df00;\n}\n.XVC {\n  color: #b50126;\n}\n.XVG {\n  color: #42afb2;\n}\n.XZC {\n  color: #23b852;\n}\n.YBC {\n  color: #d6c154;\n}\n.ZEC {\n  color: #e5a93d;\n}\n.ZEIT {\n  color: #acacac;\n}\n.ZRX {\n  color: #302c2c;\n}\n","/* new logo start */\n\n.b-brand {\n  display: flex;\n  align-items: center;\n\n  .b-bg {\n    background: $theme-color;\n    border-radius: 10px;\n    width: 35px;\n    height: 35px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n\n    i {\n      color: #fff;\n    }\n  }\n\n  .b-title {\n    margin-left: 10px;\n    font-weight: 100;\n    color: #fff;\n    font-size: 18px;\n  }\n}\n\n.navbar-collapsed {\n  .b-brand .b-title {\n    transform: rotateY(-90deg);\n    transform-origin: 0 0;\n    opacity: 0;\n    transition: all 0.3s ease-in-out;\n  }\n\n  .mobile-menu {\n    transform: rotateY(-90deg);\n    transform-origin: 0 0;\n    opacity: 0;\n    transition: all 0.3s ease-in-out;\n  }\n\n  &:hover {\n    .b-brand .b-title {\n      transform: rotateY(0deg);\n      opacity: 1;\n    }\n\n    .mobile-menu {\n      transition-delay: 0.3s;\n      transform: rotateY(0deg);\n      opacity: 1;\n    }\n  }\n}\n\n/* header css start */\n.pcoded-header {\n  z-index: 1028;\n  position: relative;\n  display: flex;\n  min-height: $header-height;\n  padding: 0;\n  position: relative;\n  top: 0;\n  background: transparent;\n  color: $header-light-text-color;\n  width: calc(100% - #{$Menu-width});\n  margin-left: $Menu-width;\n  transition: all 0.3s ease-in-out;\n\n  .m-header {\n    display: none;\n\n    .logo-dark,\n    .logo-thumb {\n      display: none;\n    }\n  }\n\n  .input-group {\n    background: transparent;\n\n    .input-group-text {\n      margin-right: 0;\n    }\n  }\n\n  .input-group {\n    background: transparent;\n  }\n\n  .input-group .input-group-text,\n  a,\n  .btn,\n  &.dropdown-toggle {\n    color: $header-light-text-color;\n\n    &:hover {\n      color: $primary-color;\n    }\n  }\n\n  .navbar-nav {\n    padding-left: 0;\n    list-style: none;\n    margin-bottom: 0;\n    display: inline-block;\n\n    > li {\n      line-height: $header-height;\n      display: inline-block;\n      padding: 0 12px;\n\n      .nav-link {\n        padding: 0;\n      }\n\n      &:first-child {\n        padding-left: 25px;\n      }\n\n      &:last-child {\n        padding-right: 40px;\n      }\n    }\n  }\n\n  .mr-auto {\n    .dropdown-menu {\n      margin-left: -20px;\n    }\n  }\n\n  .ml-auto {\n    float: right;\n  }\n\n  .main-search {\n    .input-group {\n      border-radius: 20px;\n      padding: 0;\n      display: flex;\n      align-items: center;\n\n      .form-control,\n      .input-group-text {\n        background: transparent;\n        border: none;\n        border-radius: 0;\n        padding: 0;\n      }\n\n      .search-close {\n        display: none;\n      }\n\n      .search-btn {\n        border-radius: 50%;\n        padding: 0;\n        background: transparent;\n        border-color: transparent;\n        box-shadow: none;\n      }\n\n      .form-control {\n        transition: all 0.3s ease-in-out;\n        width: 0;\n        font-size: 14px;\n      }\n\n      .form-control,\n      .search-btn {\n        &:active,\n        &:focus,\n        &:hover {\n          outline: none;\n          box-shadow: none;\n        }\n      }\n    }\n\n    &.open {\n      .input-group {\n        background: #fff;\n        border: 1px solid #f1f1f1;\n        box-shadow: 0 6px 12px -5px rgba(65, 76, 78, 0.08);\n        padding: 5px 5px 5px 20px;\n\n        .search-close {\n          display: flex;\n        }\n\n        .search-btn {\n          padding: 5px;\n          margin-left: 5px;\n          background: $primary-color;\n          border-color: $primary-color;\n\n          .input-group-text {\n            color: #fff;\n          }\n        }\n\n        .form-control {\n          transition: all 0.3s ease-in-out;\n          width: 0;\n        }\n\n        .form-control,\n        .search-btn {\n          &:active,\n          &:focus,\n          &:hover {\n            outline: none;\n            box-shadow: none;\n          }\n        }\n      }\n    }\n  }\n\n  .dropdown {\n    .dropdown-toggle {\n      line-height: $header-height;\n      display: inline-block;\n      padding-right: 15px;\n\n      &.show,\n      &:active {\n        background: transparent;\n      }\n\n      &:after {\n        content: '\\e842';\n        font-family: 'feather';\n        font-size: 15px;\n        border: none;\n        position: absolute;\n        top: 0;\n        right: 0;\n      }\n    }\n\n    .dropdown-menu {\n      position: absolute;\n      border: none;\n      margin-top: -6px;\n      min-width: 290px;\n\n      &.show {\n        &:before {\n          display: none;\n        }\n      }\n\n      li {\n        line-height: 1.2;\n\n        a {\n          padding: 10px;\n          font-size: 14px;\n        }\n\n        &.active,\n        &:active,\n        &:focus,\n        &:hover {\n          a {\n            color: $theme-font-color;\n          }\n        }\n      }\n    }\n\n    &.show {\n      &:before {\n        content: '\\63';\n        font-family: 'pct';\n        position: absolute;\n        left: -9px;\n        top: $header-height - 8;\n        z-index: 1001;\n        font-size: 40px;\n        line-height: 0;\n        color: #fff;\n        text-shadow: 0 -2px 2px rgba(65, 76, 78, 0.12);\n      }\n    }\n\n    .notification {\n      width: 350px;\n      padding: 0;\n      line-height: 1.4;\n      overflow: hidden;\n\n      .noti-head {\n        border-bottom: 1px solid #f1f1f1;\n        padding: 15px 20px;\n\n        a {\n          text-decoration: underline;\n          font-size: 13px;\n        }\n      }\n\n      .noti-body {\n        padding: 0;\n\n        img {\n          width: 40px;\n          margin-right: 20px;\n        }\n\n        li {\n          padding: 15px 20px;\n          transition: all 0.3s ease-in-out;\n\n          &.n-title {\n            padding-bottom: 0;\n\n            p {\n              margin-bottom: 5px;\n            }\n          }\n\n          &.notification:hover {\n            background: transparentize($primary-color, 0.9);\n          }\n\n          p {\n            margin-bottom: 5px;\n            font-size: 13px;\n\n            strong {\n              color: #222;\n            }\n          }\n\n          .n-time {\n            font-size: 80%;\n            float: right;\n          }\n        }\n      }\n\n      .noti-footer {\n        border-top: 1px solid #f1f1f1;\n        padding: 15px 20px;\n        text-align: center;\n\n        a {\n          text-decoration: underline;\n          font-size: 13px;\n        }\n      }\n\n      ul {\n        padding-left: 0;\n        margin-bottom: 0;\n        list-style: none;\n\n        li {\n          padding: 20px 15px;\n        }\n      }\n    }\n\n    .profile-notification {\n      padding: 0;\n      line-height: 1.4;\n      overflow: hidden;\n\n      .pro-head {\n        color: #fff;\n        border-radius: 0.25rem 0.25rem 0 0;\n        padding: 15px;\n        position: relative;\n        background: $primary-color;\n\n        img {\n          width: 40px;\n          margin-right: 10px;\n        }\n\n        .dud-logout {\n          color: #fff;\n          padding-right: 0;\n          position: absolute;\n          right: 0;\n          top: 0;\n          height: 100%;\n          width: 40px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n        }\n      }\n\n      .pro-body {\n        padding: 20px 0;\n        margin-bottom: 0;\n        list-style: none;\n\n        li {\n          a {\n            color: $theme-font-color;\n            font-size: 14px;\n            padding: 10px 20px;\n\n            i {\n              margin-right: 10px;\n            }\n          }\n\n          &.active,\n          &:active,\n          &:focus,\n          &:hover {\n            background: transparentize($primary-color, 0.9);\n\n            > a {\n              background: transparent;\n            }\n          }\n        }\n      }\n    }\n\n    &.drp-user.show {\n      &:before {\n        color: $primary-color;\n      }\n    }\n  }\n}\n\n/* header css end */\n/* menu[ vertical ] css start */\n.mobile-menu {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 37px;\n  height: $header-height;\n  position: absolute;\n  right: 0;\n  top: 0;\n  padding: 0 10px;\n\n  span {\n    position: relative;\n    display: block;\n    width: 100%;\n    height: 2.8px;\n    background-color: #fff;\n    transition: all 0.3s ease-in-out;\n    backface-visibility: hidden;\n    border-radius: 2px;\n\n    &:after,\n    &:before {\n      content: '';\n      position: absolute;\n      left: 0;\n      height: 2.8px;\n      background-color: #fff;\n      transition: all 0.3s;\n      backface-visibility: hidden;\n      border-radius: 2px;\n    }\n\n    &:after {\n      top: 5px;\n      width: 70%;\n    }\n\n    &:before {\n      top: -5px;\n      width: 40%;\n    }\n  }\n\n  &.on {\n    span {\n      background-color: transparent;\n\n      &:after,\n      &:before {\n        height: 2px;\n        width: 100%;\n      }\n\n      &:before {\n        transform: rotate(45deg) translate(4px, 4px);\n      }\n\n      &:after {\n        transform: rotate(-45deg) translate(3px, -3px);\n      }\n    }\n  }\n}\n\n.navbar-brand {\n  background: $menu-dark-background;\n  font-size: 1.25rem;\n}\n\n.pcoded-header,\n.pcoded-main-container {\n  &:before {\n    content: '';\n    transition: all 0.3s ease-in-out;\n  }\n\n  @media screen and (max-width: 991px) {\n    .pcoded-content .pcoded-inner-content {\n      margin-top: 70px;\n    }\n  }\n}\n\n.pcoded-navbar {\n  display: block;\n  z-index: 1029;\n  position: fixed;\n  transition: all 0.3s ease-in-out;\n  box-shadow: 1px 0 20px 0 rgb(63, 77, 103);\n\n  ul {\n    padding-left: 0;\n    list-style: none;\n    margin-bottom: 0;\n  }\n\n  .datta-scroll.navbar-content {\n    height: calc(100vh - #{$header-height});\n  }\n\n  .header-logo {\n    position: relative;\n    align-items: center;\n    display: inline-flex;\n    float: left;\n    height: $header-height;\n    text-align: center;\n    width: $Menu-width;\n    margin-right: 0;\n    padding: 10px 20px;\n    transition: all 0.3s ease-in-out;\n\n    .logo-dark {\n      display: none;\n    }\n\n    .logo-thumb {\n      transform: rotateY(-90deg);\n      opacity: 0;\n      position: absolute;\n      transition: unset;\n    }\n\n    + .datta-scroll {\n      float: left;\n      display: inline-block;\n    }\n  }\n\n  .mobile-menu {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 37px;\n    height: $header-height;\n    position: absolute;\n    right: 10px;\n    top: 0;\n    padding: 0 10px;\n    transition: all 0.3s ease-in-out;\n\n    span {\n      position: relative;\n      display: block;\n      width: 100%;\n      height: 2.8px;\n      background-color: $menu-dark-text-color;\n      transition: all 0.3s ease-in-out;\n      backface-visibility: hidden;\n      border-radius: 2px;\n\n      &:after,\n      &:before {\n        content: '';\n        position: absolute;\n        left: 0;\n        height: 2.8px;\n        background-color: $menu-dark-text-color;\n        transition: all 0.3s;\n        backface-visibility: hidden;\n        border-radius: 2px;\n      }\n\n      &:after {\n        top: 5px;\n        width: 70%;\n      }\n\n      &:before {\n        top: -5px;\n        width: 40%;\n      }\n    }\n\n    &.on {\n      span {\n        background-color: transparent;\n\n        &:after,\n        &:before {\n          height: 2px;\n          width: 100%;\n        }\n\n        &:before {\n          transform: rotate(45deg) translate(4px, 4px);\n        }\n\n        &:after {\n          transform: rotate(-45deg) translate(3px, -3px);\n        }\n      }\n    }\n  }\n\n  .pcoded-badge {\n    color: #fff;\n    font-size: 75%;\n    position: absolute;\n    right: 30px;\n    top: 8px;\n    padding: 2px 7px;\n    border-radius: 2px;\n  }\n\n  .pcoded-inner-navbar {\n    flex-direction: column;\n\n    > li {\n      > a {\n        .pcoded-badge {\n          top: 12px;\n        }\n      }\n    }\n\n    li {\n      position: relative;\n\n      > a {\n        text-align: left;\n        padding: 7px 15px;\n        margin: 5px 0 0;\n        display: block;\n        border-radius: 0;\n        position: relative;\n\n        .pcoded-mtext {\n          position: relative;\n        }\n\n        > .pcoded-micon {\n          font-size: 1rem;\n          padding: 4px 7px;\n          margin-right: 7px;\n          border-radius: 4px;\n          width: 30px;\n          display: inline-flex;\n          align-items: center;\n          height: 30px;\n          text-align: center;\n\n          + .pcoded-mtext {\n            position: absolute;\n            top: 11px;\n          }\n        }\n      }\n\n      &.pcoded-hasmenu {\n        > a {\n          &:after {\n            content: '\\e844';\n            font-family: 'feather';\n            font-size: 15px;\n            border: none;\n            position: absolute;\n            top: 11px;\n            right: 20px;\n            transition: 0.3s ease-in-out;\n          }\n        }\n\n        .pcoded-hasmenu {\n          > a {\n            &:after {\n              top: 6px;\n            }\n          }\n        }\n\n        &.pcoded-trigger {\n          > a {\n            &:after {\n              transform: rotate(90deg);\n            }\n          }\n        }\n\n        .pcoded-submenu {\n          display: none;\n        }\n\n        &.pcoded-trigger {\n          > .pcoded-submenu {\n            display: block;\n          }\n\n          > a {\n            position: relative;\n          }\n        }\n\n        .pcoded-submenu {\n          li {\n            > a {\n              text-align: left;\n              padding: 7px 7px 7px 60px;\n              margin: 0;\n              display: block;\n\n              &:before {\n                content: '';\n                border-radius: 50%;\n                position: absolute;\n                top: 16px;\n                left: 35px;\n                width: 5px;\n                height: 5px;\n              }\n            }\n\n            .pcoded-submenu {\n              > li {\n                > a {\n                  padding: 7px 7px 7px 80px;\n\n                  &:before {\n                    left: 55px;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n\n      &.pcoded-menu-caption {\n        font-size: 10px;\n        font-weight: 600;\n        padding: 25px 20px 5px;\n        text-transform: uppercase;\n        position: relative;\n      }\n\n      &.disabled {\n        > a {\n          cursor: default;\n          opacity: 0.5;\n        }\n      }\n    }\n  }\n\n  width: $Menu-width;\n  height: 100vh;\n  top: 0;\n  background: $menu-dark-background;\n  color: $menu-dark-text-color;\n\n  .pcoded-submenu {\n    background: darken($header-dark-background, 3%);\n    padding: 15px 0;\n  }\n\n  a {\n    color: $menu-dark-text-color;\n  }\n\n  .navbar-content,\n  .navbar-wrapper {\n    width: 100%;\n    height: 100%;\n  }\n\n  &.navbar-collapsed {\n    width: $Menu-collapsed-width;\n    height: 100%;\n    transition: all 0.3s ease-in-out;\n\n    .header-logo {\n      width: $Menu-collapsed-width;\n\n      img {\n        transform: rotateY(-90deg);\n        transform-origin: 0 0;\n        opacity: 0;\n        transition: unset;\n      }\n\n      .logo-thumb {\n        transform: rotateY(0deg);\n        transform-origin: 0 0;\n        opacity: 1;\n        left: calc((#{$Menu-collapsed-width} / 2) - 20px);\n      }\n\n      .mobile-menu {\n        transform: rotateY(-90deg);\n        transform-origin: 0 0;\n        opacity: 0;\n      }\n    }\n\n    .navbar-content {\n      &.ps {\n        overflow: visible;\n      }\n    }\n\n    .pcoded-menu-caption {\n      position: relative;\n      width: 100%;\n      height: auto;\n      white-space: nowrap;\n      overflow: hidden;\n\n      > label {\n        transform: rotateY(-90deg);\n        transform-origin: 0 0;\n        opacity: 0;\n        transition: all 0.3s ease-in-out;\n      }\n\n      &:after {\n        content: '';\n        position: absolute;\n        top: 25px;\n        left: 15px;\n        width: calc(100% - 30px);\n        height: 1px;\n        background: rgba(0, 0, 0, 0.1);\n      }\n    }\n\n    .pcoded-inner-navbar {\n      > li {\n        > a {\n          z-index: 1026;\n          padding: 7px 25px;\n\n          > .pcoded-mtext {\n            transform: rotateY(-90deg);\n            transform-origin: 0 0;\n            opacity: 0;\n            transition: all 0.3s ease-in-out;\n          }\n        }\n\n        &.pcoded-hasmenu {\n          > a {\n            &:after {\n              right: 12px;\n            }\n          }\n        }\n      }\n\n      > li {\n        &.pcoded-trigger {\n          .pcoded-submenu {\n            &:after {\n              content: '';\n              position: absolute;\n              top: 49px;\n              left: calc(calc(#{$Menu-collapsed-width} / 2) - 3px);\n              width: 1px;\n              height: calc(100% - 49px);\n              background: transparentize($menu-dark-text-color, 0.8);\n            }\n\n            li {\n              a {\n                color: transparent;\n                white-space: nowrap;\n              }\n            }\n\n            .pcoded-submenu {\n              li {\n                a:before {\n                  opacity: 0;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n\n    ~ .pcoded-header {\n      width: calc(100% - #{$Menu-collapsed-width});\n    }\n\n    ~ .pcoded-header,\n    ~ .pcoded-main-container {\n      margin-left: $Menu-collapsed-width;\n    }\n\n    .pcoded-badge {\n      transform: rotateX(-90deg);\n      transform-origin: 50% 50%;\n      opacity: 0;\n      transition: all 0.15s ease-in-out;\n    }\n\n    &:hover {\n      width: $Menu-width !important;\n\n      .pcoded-badge {\n        transition-delay: 0.3s;\n        transform: rotateX(0deg);\n        opacity: 1;\n      }\n\n      .header-logo {\n        width: $Menu-width;\n\n        img {\n          transform: rotateY(0deg);\n          opacity: 1;\n        }\n\n        .logo-thumb {\n          transform: rotateY(-90deg);\n          opacity: 0;\n        }\n\n        .mobile-menu {\n          display: flex;\n          right: 10px;\n        }\n      }\n\n      .pcoded-menu-caption {\n        > label {\n          transform: rotateY(0deg);\n          opacity: 1;\n        }\n\n        &:after {\n          background: transparent;\n        }\n      }\n\n      .mobile-menu {\n        transform: rotateY(0deg);\n        opacity: 1;\n      }\n\n      .pcoded-inner-navbar {\n        > li {\n          > a {\n            > .pcoded-mtext {\n              transform: rotateY(0deg);\n              opacity: 1;\n\n              &:after {\n                opacity: 1;\n                visibility: visible;\n              }\n            }\n          }\n\n          &.pcoded-hasmenu {\n            > a {\n              &:after {\n                transform: rotateX(0deg);\n              }\n            }\n\n            &.pcoded-trigger {\n              > a {\n                &:after {\n                  transform: rotateX(0deg) rotate(90deg);\n                }\n              }\n            }\n          }\n        }\n\n        > li {\n          &.pcoded-trigger {\n            .pcoded-submenu {\n              &:after {\n                display: none;\n              }\n\n              li {\n                a {\n                  color: inherit;\n                }\n              }\n\n              .pcoded-submenu {\n                li {\n                  a:before {\n                    opacity: 1;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .pcoded-menu-caption {\n    color: #e8edf7;\n  }\n\n  .pcoded-inner-navbar {\n    li > a {\n      &.active,\n      &:focus,\n      &:hover {\n        color: #1dc4e9;\n      }\n\n      .pcoded-submenu > li {\n        &.active,\n        &:focus,\n        &:hover {\n          > a {\n            &:before {\n              background: #1dc4e9;\n            }\n          }\n        }\n      }\n    }\n\n    > li {\n      &.active,\n      &.pcoded-trigger {\n        &:after {\n          content: '';\n          background-color: #1dc4e9;\n          z-index: 1027;\n          position: absolute;\n          left: 0;\n          top: 5px;\n          width: 3px;\n          height: calc(100% - 5px);\n        }\n\n        > a {\n          background: darken($menu-dark-background, 6%);\n          color: #fff;\n        }\n      }\n    }\n\n    > .pcoded-menu-caption {\n      &.active,\n      &.pcoded-trigger {\n        &:after {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n.pcoded-navbar {\n  &.mob-open,\n  &.navbar-collapsed:hover {\n    ~ .pcoded-header,\n    ~ .pcoded-main-container {\n      margin-left: $Menu-collapsed-width;\n\n      &:before {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background-color: rgba(0, 0, 0, 0.2);\n        z-index: 1;\n      }\n    }\n  }\n}\n\n/* menu [ vertical ] css end */\n\n/* main content start */\n.pcoded-content {\n  position: relative;\n  display: block;\n  padding: 30px;\n}\n\n.pcoded-main-container {\n  position: relative;\n  margin: 0 auto;\n  display: block;\n  clear: both;\n  float: unset;\n  right: 0;\n  margin-left: $Menu-width;\n  min-height: 100vh;\n  transition: all 0.3s ease-in-out;\n}\n\n/* main content end*/\n/* ==========================    Rsponsive Menu  start   ====================== */\n.mob-toggler {\n  display: none;\n}\n\n@media only screen and (max-width: 991px) {\n  .pcoded-header {\n    background: $header-dark-background;\n    color: $header-dark-text-color;\n\n    .input-group-text,\n    a,\n    dropdown-toggle {\n      color: $header-light-text-color;\n\n      &:hover {\n        color: $primary-color;\n      }\n    }\n\n    > .collapse.show {\n      display: flex;\n      background: #fff;\n      box-shadow: 0 1px 20px 0 rgba(69, 90, 100, 0.08);\n    }\n\n    .mob-toggler {\n      display: flex;\n      color: #fff;\n      position: absolute;\n      right: 60px;\n    }\n\n    .dropdown-menu,\n    .dropdown-menu a,\n    .search-close .input-group-text {\n      color: $header-dark-background;\n    }\n\n    .m-header {\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n      width: 100%;\n      height: $header-height;\n\n      .b-brand {\n        margin-left: 20px;\n      }\n\n      .mobile-menu {\n        right: 20px;\n      }\n    }\n\n    .full-screen {\n      display: none;\n    }\n\n    .navbar-nav {\n      > li {\n        &:last-child {\n          padding-right: 60px;\n        }\n      }\n    }\n  }\n\n  .pcoded-navbar {\n    margin-left: -#{$Menu-width};\n    position: fixed;\n    height: 100%;\n    box-shadow: none;\n\n    .datta-scroll.navbar-content {\n      height: 100%;\n    }\n\n    ~ .pcoded-header,\n    ~ .pcoded-main-container {\n      margin-left: 0;\n    }\n\n    ~ .pcoded-header {\n      width: 100%;\n    }\n\n    .navbar-brand {\n      display: none;\n    }\n\n    &.mob-open {\n      margin-left: 0;\n\n      ~ .pcoded-header,\n      ~ .pcoded-main-container {\n        margin-left: 0;\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .pcoded-header {\n    .navbar-nav {\n      > li:first-child {\n        padding-left: 0;\n      }\n\n      > li:last-child {\n        padding-right: 20px;\n      }\n    }\n\n    .navbar-nav.mr-auto {\n      li {\n        display: none;\n\n        &.nav-item:not(.dropdown) {\n          display: block;\n          padding-right: 0;\n        }\n      }\n    }\n\n    .dropdown {\n      &.show {\n        position: static;\n\n        a:after {\n          display: none;\n        }\n\n        &:before {\n          display: none;\n        }\n      }\n\n      .notification {\n        width: 100%;\n      }\n\n      .dropdown-menu {\n        width: 95%;\n        margin-left: auto;\n        margin-right: auto;\n        left: 0;\n        right: 0;\n      }\n    }\n  }\n\n  .header-chat.open,\n  .header-user-list.open {\n    width: 280px;\n  }\n\n  .pcoded-content {\n    padding: 30px 15px;\n  }\n\n  .card {\n    margin-bottom: 15px;\n  }\n}\n\n@media only screen and (max-width: 1200px) and (min-width: 768px) {\n  .pcoded-navbar {\n    .header-logo {\n      transition: none;\n    }\n\n    &.navbar-collapsed {\n      transition: none;\n\n      .header-logo {\n        img {\n          transition: none;\n        }\n      }\n\n      .pcoded-menu-caption {\n        > label {\n          transition: none;\n        }\n      }\n\n      .pcoded-inner-navbar {\n        > li {\n          > a {\n            > .pcoded-mtext {\n              transition: none;\n            }\n          }\n\n          &.pcoded-hasmenu {\n            > a {\n              &:after {\n                transition: none;\n                transition-delay: unset;\n              }\n            }\n          }\n        }\n      }\n\n      .pcoded-badge {\n        transition: none;\n      }\n\n      &:hover {\n        .pcoded-badge {\n          transition-delay: unset;\n        }\n      }\n    }\n  }\n}\n\n.pro-card {\n  background: #5c6a83;\n  border: #465673;\n  border-radius: 8px;\n}\n\n/* ==========================    Responsive Menu  end   ====================== */\n\n/* ===================================================================================\n ==========================    Different Layout Styles Start     ====================\n ===================================================================================\n ====== [ light menu style start ] ======== */\n.pcoded-navbar.menu-light {\n  background-color: $menu-light-background;\n  color: $menu-light-text-color;\n  box-shadow: 7px 0 15px 0 rgba(69, 90, 100, 0.09);\n\n  .header-logo {\n    background-color: $menu-dark-background;\n\n    .logo-dark {\n      display: none;\n    }\n\n    .logo-main {\n      display: block;\n    }\n  }\n\n  .mobile-menu {\n    span {\n      background-color: $menu-dark-text-color;\n\n      &:after,\n      &:before {\n        background-color: $menu-dark-text-color;\n      }\n    }\n\n    &.on {\n      span {\n        background-color: transparent;\n      }\n    }\n  }\n\n  .pcoded-submenu {\n    background: darken($menu-light-background, 1.5%);\n  }\n\n  a {\n    color: $menu-light-text-color;\n  }\n\n  &.navbar-collapsed {\n    .pcoded-menu-caption {\n      &:after {\n        background: rgba(0, 0, 0, 0.1);\n      }\n    }\n\n    &:hover {\n      .pcoded-menu-caption {\n        &:after {\n          background: transparent;\n        }\n      }\n    }\n  }\n\n  .pcoded-menu-caption {\n    color: $menu-light-text-color;\n  }\n\n  .pcoded-inner-navbar {\n    > li {\n      &.active,\n      &.pcoded-trigger {\n        > a {\n          background: #f1f1f1;\n          color: #111;\n        }\n      }\n    }\n  }\n}\n\n/* ====== [ light menu style end ] ======== */\n\n/* ====== [ menu static start ] ======== */\n.pcoded-navbar.menupos-static {\n  position: absolute;\n  height: 100%;\n  min-height: 100%;\n\n  .datta-scroll.navbar-content {\n    height: calc(100% - #{$header-height});\n    min-height: 100vh;\n  }\n}\n\n/* ====== [ menu static end ] ======== */\n\n/* ==========================    Different Layout Styles end     ====================== */\n/* temp SCSS for document */\n\n@each $value in $color-menu-name {\n  $i: index($color-menu-name, $value);\n\n  .nav-link {\n    &.active.h-#{'' + $value} {\n      background: nth($color-menu-color, $i) !important;\n    }\n  }\n}\n\n@media all and (-ms-high-contrast: none) {\n  .pcoded-header .dropdown.show::before {\n    line-height: 0.1;\n  }\n\n  .pcoded-header .navbar-nav > li {\n    display: inline-flex;\n  }\n\n  .pcoded-header .navbar-nav > li.dropdown {\n    display: inline-block;\n  }\n\n  .dropdown-menu.show::before {\n    top: -2px;\n  }\n\n  .pcoded-navbar.navbar-collapsed .pcoded-inner-navbar > li.pcoded-trigger .pcoded-submenu::after {\n    left: 40px;\n  }\n}\n\n// ===  scroll bar  =====\n\n.navbar-content {\n  position: relative;\n}\n\n.ps .ps__rail-x.ps--clicking,\n.ps .ps__rail-x:focus,\n.ps .ps__rail-x:hover,\n.ps .ps__rail-y.ps--clicking,\n.ps .ps__rail-y:focus,\n.ps .ps__rail-y:hover {\n  background: transparent;\n}\n\n.ps__thumb-y {\n  background: #2a3446;\n}\n\n.ps__rail-y.ps--clicking .ps__thumb-y,\n.ps__rail-y:focus > .ps__thumb-y,\n.ps__rail-y:hover > .ps__thumb-y {\n  background: #222a38;\n}\n\n/* nav-outside */\n.nav-outside {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n\n// carousel-card\n.carousel {\n  z-index: -1;\n}\n\n// landing page nav\n.landing-nav {\n  z-index: 1201;\n}\n",".user-list {\n  .table {\n    td {\n      vertical-align: middle;\n    }\n\n    thead {\n      th {\n        border: 0;\n      }\n    }\n  }\n}\n\n.Recent-Users {\n  .table {\n    tr {\n      &:first-child {\n        td {\n          border-top: 0;\n        }\n      }\n    }\n\n    td {\n      vertical-align: middle;\n    }\n\n    .label {\n      border-radius: 15px;\n      box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.2);\n    }\n  }\n}\n\n.card-social {\n  &:hover {\n    i {\n      font-size: 40px;\n      transition: all 0.3s ease-in-out;\n    }\n  }\n\n  .progress {\n    height: 6px;\n  }\n\n  .card-active > div + div {\n    border-left: 1px solid $theme-border;\n  }\n}\n\n.card {\n  .card-block,\n  .card-body {\n    code {\n      background-color: #eee;\n      margin: 5px;\n      display: inline-block;\n      border-radius: 3px;\n      padding: 0 3px;\n    }\n  }\n}\n\n@media screen and (max-width: 767px) {\n  div.dataTables_wrapper div.dataTables_filter label {\n    float: none !important;\n    text-align: center;\n  }\n}\n","/**  =====================\n      Form Componant css start\n==========================  **/\n\n.custom-select,\n.form-control {\n  background: $theme-background;\n  padding: 10px 20px;\n  font-size: 14px;\n  height: auto;\n\n  &.form-control-lg {\n    font-size: 1.25rem;\n  }\n\n  &.form-control-sm {\n    height: calc(1.8125rem + 2px);\n    font-size: 0.875rem;\n  }\n\n  &.form-control-range {\n    box-shadow: none;\n  }\n\n  &:focus {\n    background: $theme-background;\n  }\n\n  &::-moz-placeholder {\n    color: #aaaeb3;\n    opacity: 1;\n  }\n\n  &:-ms-input-placeholder {\n    color: #aaaeb3;\n  }\n\n  &::-webkit-input-placeholder {\n    color: #aaaeb3;\n  }\n}\n/* input group start */\n\n.input-group {\n  background: $theme-background;\n\n  .input-group-text {\n    padding-left: 15px;\n    padding-right: 15px;\n    background: transparent;\n    i {\n      font-size: 20px;\n    }\n  }\n\n  .custom-file-label {\n    margin-bottom: 0;\n  }\n\n  .btn {\n    margin-bottom: 0;\n    margin-right: 0;\n  }\n}\n\n.cust-file-button {\n  .custom-file-label {\n    height: calc(2.25rem + 8px);\n    line-height: 2.5;\n\n    &::after {\n      padding: 0.775rem 0.75rem;\n      height: 2.65rem;\n    }\n  }\n}\n\n.custom-select {\n  height: calc(2.25rem + 9px);\n}\n/* input group End */\n/**====== Form Componant css end ======**/\nselect.form-control:not([size]):not([multiple]) {\n  height: calc(2.55rem + 2px);\n}\n.input-group-lg > .input-group-append > select.btn:not([size]):not([multiple]),\n.input-group-lg > .input-group-append > select.input-group-text:not([size]):not([multiple]),\n.input-group-lg > .input-group-prepend > select.btn:not([size]):not([multiple]),\n.input-group-lg > .input-group-prepend > select.input-group-text:not([size]):not([multiple]),\n.input-group-lg > select.form-control:not([size]):not([multiple]),\nselect.form-control-lg:not([size]):not([multiple]) {\n  height: calc(3.375rem + 2px);\n}\n\n.minicolors {\n  .form-control {\n    padding: 6px 12px 5px 44px;\n  }\n}\n/* form-select */\n\n.select2-container {\n  width: 100% !important;\n}\n.tt-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 160px;\n  padding: 5px 0;\n  margin: 2px 0 0;\n  list-style: none;\n  font-size: 14px;\n  background-color: #ffffff;\n  border: 1px solid #cccccc;\n  border-radius: 4px;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  background-clip: padding-box;\n  cursor: pointer;\n}\n.bootstrap-tagsinput {\n  width: 100%;\n}\n.custom-file-label {\n  height: auto;\n  &:after {\n    height: auto;\n    padding: 0.55rem 0.75rem;\n  }\n}\n.form-control.is-invalid,\n.was-validated .form-control:invalid,\n.was-validated .form-control:valid,\n.form-control.is-valid {\n  background-position: calc(100% - 10px) calc(0.375em + 0.4875rem);\n}\n\n.was-validated .form-control:invalid ~ .invalid-feedback {\n  background: #fff;\n  margin-top: 0;\n  padding-top: 0.25em;\n}\n","/**  =====================\n      Radio & Checked css start\n==========================  **/\n.checkbox {\n  padding: 10px 0;\n  min-height: auto;\n  position: relative;\n  margin-right: 5px;\n\n  input[type='checkbox'] {\n    margin: 0;\n    display: none;\n    width: 22px;\n\n    + .form-check-label,\n    + .cr {\n      padding-left: 0;\n\n      &:before {\n        content: '\\e83f';\n        width: 22px;\n        height: 22px;\n        display: inline-block;\n        margin-right: 10px;\n        border: 2px solid #e9eaec;\n        border-radius: 3px;\n        font: {\n          size: 15px;\n          family: 'feather';\n          weight: 400;\n        }\n        line-height: 19px;\n        vertical-align: bottom;\n        text-align: center;\n        background: #ffffff;\n        color: transparent;\n        cursor: pointer;\n        transition: all 0.2s ease-in-out;\n      }\n    }\n\n    &:checked + .form-check-label:before,\n    &:checked + .cr:before {\n      background: #1dd5d2;\n      border-color: #1dd5d2;\n      color: #ffffff;\n    }\n\n    &.disabled + .form-check-label,\n    &:disabled + .form-check-label,\n    &.disabled + .cr,\n    &:disabled + .cr {\n      opacity: 0.5;\n    }\n\n    &.disabled + .form-check-label:before,\n    &:disabled + .form-check-label:before,\n    &.disabled + .cr:before,\n    &:disabled + .cr:before {\n      cursor: not-allowed;\n    }\n  }\n\n  &.checkbox-fill {\n    input[type='checkbox'] {\n      + .form-check-label,\n      + .cr {\n        &:after {\n          content: '';\n          width: 22.5px;\n          height: 22.5px;\n          display: inline-block;\n          margin-right: 10px;\n          border: 2px solid #e9eaec;\n          border-radius: 2px;\n          vertical-align: bottom;\n          text-align: center;\n          background: transparent;\n          cursor: pointer;\n          transition: all 0.2s ease-in-out;\n          position: absolute;\n          top: 8.5px;\n          left: 3px;\n        }\n\n        &:before {\n          opacity: 0;\n          content: '\\e840';\n          font-size: 27px;\n          background: transparent;\n        }\n      }\n\n      &:checked {\n        + .form-check-label,\n        + .cr {\n          &:after {\n            opacity: 0;\n          }\n\n          &:before {\n            opacity: 1;\n            background: transparent;\n            color: #1dd5d2;\n            border-color: transparent;\n          }\n        }\n      }\n    }\n  }\n  @each $value in $color-bt-name {\n    $i: index($color-bt-name, $value);\n\n    &.checkbox-#{$value} input[type='checkbox']:checked + .form-check-label:before,\n    &.checkbox-#{$value} input[type='checkbox']:checked + .cr:before {\n      background: nth($color-bt-color, $i);\n      border-color: nth($color-bt-color, $i);\n      color: #ffffff;\n    }\n\n    &.checkbox-fill.checkbox-#{$value} input[type='checkbox']:checked + .form-check-label:before,\n    &.checkbox-fill.checkbox-#{$value} input[type='checkbox']:checked + .cr:before {\n      background: transparent;\n      color: nth($color-bt-color, $i);\n      border-color: transparent;\n    }\n  }\n\n  .form-check-label,\n  .cr {\n    cursor: pointer;\n  }\n}\n\n.radio {\n  padding: 10px 0;\n  min-height: auto;\n  position: relative;\n  margin-right: 5px;\n\n  input[type='radio'] {\n    margin: 0;\n    display: none;\n    width: 22px;\n\n    + .form-check-label,\n    + .cr {\n      padding-left: 0;\n\n      &:after,\n      &:before {\n        content: '';\n        display: inline-block;\n        margin-right: 10px;\n        border-radius: 50%;\n        vertical-align: bottom;\n        background: #fff;\n        color: transparent;\n        cursor: pointer;\n        transition: all 0.2s ease-in-out;\n      }\n\n      &:before {\n        width: 22px;\n        height: 22px;\n        border: 2px solid #e9eaec;\n      }\n\n      &:after {\n        width: 12px;\n        height: 12px;\n        position: absolute;\n        top: 13px;\n        left: 5px;\n      }\n    }\n\n    &:checked {\n      + .form-check-label,\n      + .cr {\n        &:before {\n          border-color: #1dd5d2;\n        }\n\n        &:after {\n          background: $theme-color;\n        }\n      }\n    }\n\n    &:disabled {\n      + .form-check-label,\n      + .cr {\n        opacity: 0.5;\n        cursor: not-allowed;\n\n        &:after,\n        &:before {\n          cursor: not-allowed;\n        }\n      }\n    }\n  }\n\n  &.radio-fill {\n    input[type='radio'] {\n      + .form-check-label,\n      + .cr {\n        &:after {\n          width: 18px;\n          height: 18px;\n          top: 10px;\n          left: 2px;\n        }\n      }\n    }\n  }\n  @each $value in $color-bt-name {\n    $i: index($color-bt-name, $value);\n\n    &.radio-#{$value} input[type='radio']:checked + .form-check-label,\n    &.radio-#{$value} input[type='radio']:checked + .cr {\n      &:before {\n        border-color: nth($color-bt-color, $i);\n      }\n\n      &:after {\n        background: nth($color-bt-color, $i);\n      }\n    }\n  }\n\n  .form-check-label,\n  .cr {\n    cursor: pointer;\n  }\n}\n@-moz-document url-prefix() {\n  .radio input[type='radio'] + .form-check-label::after,\n  .radio input[type='radio'] + .cr::after {\n    top: 14px;\n  }\n}\n\n.custom-controls-stacked {\n  .radio {\n    input[type='radio'] {\n      + .form-check-label,\n      + .cr {\n        &:after {\n          top: 15px;\n        }\n      }\n    }\n  }\n}\n/**====== Radio & Checked css end ======**/\n\n.radio,\n.checkbox {\n  .form-check {\n    padding-left: 0;\n    margin-bottom: 6px;\n\n    input[type='radio'] + .form-check-label:after {\n      top: 5px;\n    }\n  }\n}\n","/**  =====================\n      Label & Badges css start\n==========================  **/\n\n.label {\n  padding: 4px 10px;\n  min-height: auto;\n  position: relative;\n  margin-right: 5px;\n  margin-bottom: 5px;\n  @each $value in $color-bt-name {\n    $i: index($color-bt-name, $value);\n\n    &.label-#{$value} {\n      background: nth($color-bt-color, $i);\n      color: #ffffff;\n    }\n  }\n}\n/**====== Label & Badges css end ======**/\n","/**  =====================\n      Data Tables css start\n==========================  **/\n.table {\n  color: #888;\n  td,\n  th {\n    border-top: 1px solid $theme-border;\n    white-space: nowrap;\n    padding: 1.05rem 0.75rem;\n  }\n\n  thead th {\n    border-bottom: 1px solid $theme-border;\n  }\n\n  tbody + tbody {\n    border-top: 2px solid $theme-border;\n  }\n\n  &.table-sm {\n    th,\n    td {\n      padding: 0.35rem;\n    }\n  }\n}\n/* Border versions */\n\n.table-bordered {\n  border: 1px solid $theme-border;\n\n  td,\n  th {\n    border: 1px solid $theme-border;\n  }\n}\n/* Zebra-striping */\n\n.table-striped {\n  tbody tr:nth-of-type(2n + 1) {\n    background-color: transparentize($primary-color, 0.95);\n  }\n}\n/* Hover effect */\n\n.table-hover {\n  tbody tr {\n    &:hover {\n      background-color: transparentize($primary-color, 0.95);\n    }\n  }\n}\n/* Table backgrounds */\n\n.table {\n  .thead-dark {\n    th {\n      color: #fff;\n      background-color: $dark-color;\n      border-color: darken($dark-color, 10%);\n    }\n  }\n}\n\n.table-dark {\n  color: #fff;\n  background-color: $dark-color;\n\n  td,\n  th,\n  thead th {\n    border-color: darken($dark-color, 10%);\n  }\n\n  &.table-striped {\n    tbody tr:nth-of-type(odd) {\n      background-color: darken($dark-color, 2%);\n    }\n  }\n\n  &.table-hover {\n    tbody tr {\n      &:hover {\n        background-color: darken($dark-color, 5%);\n      }\n    }\n  }\n}\n/* fixed header position */\n\n@media screen and (max-width: 992px) {\n  .fixedHeader-locked {\n    display: none !important;\n  }\n}\n\n/**  =====================\n      Foo-table css start\n==========================  **/\n\n.footable .pagination > {\n  .active > {\n    a,\n    span {\n      background-color: $primary-color;\n      border-color: $primary-color;\n\n      &:focus,\n      &:hover {\n        background-color: $primary-color;\n        border-color: $primary-color;\n      }\n    }\n  }\n\n  li > {\n    a,\n    span {\n      color: #222;\n    }\n  }\n}\n\n.footable-details.table,\n.footable.table {\n  margin-bottom: 0;\n}\n\ntable {\n  &.footable > tfoot > tr.footable-paging > td > span.label {\n    margin-bottom: 0;\n  }\n\n  &.footable-paging-center > tfoot > tr.footable-paging > td {\n    padding-bottom: 0;\n  }\n}\n\n.table-columned > {\n  tbody > {\n    tr > {\n      td {\n        border: 0;\n        border-left: 1px solid $theme-border;\n      }\n\n      th {\n        border: 0;\n      }\n    }\n  }\n}\n/**====== Foo-table css end ======**/\n/**====== Data Tables css end ======**/\n","/**  =====================\n      Authentication css start\n==========================  **/\n.auth-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  min-width: 100%;\n  min-height: 100vh;\n  a,\n  p > a {\n    color: $theme-heading-color;\n    font-weight: 600;\n  }\n  .btn-auth-gen {\n    .btn-icon {\n      width: 140px;\n      height: 140px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-size: 45px;\n\n      small {\n        font-size: 15px;\n      }\n    }\n  }\n  .input-group {\n    background: transparent;\n  }\n  .card {\n    margin-bottom: 0;\n  }\n\n  > div {\n    z-index: 5;\n  }\n\n  .auth-content {\n    position: relative;\n    width: 390px;\n    padding: 15px;\n    z-index: 5;\n    &.multyform,\n    &.subscribe {\n      width: 750px;\n    }\n  }\n  @media only screen and (max-width: 768px) {\n    max-width: 360px;\n  }\n  @media only screen and (max-width: 575px) {\n    .card {\n      .card-body {\n        padding: 30px 15px;\n      }\n    }\n  }\n\n  .auth-icon {\n    font-size: 30px;\n    &:before {\n      background: $theme-color;\n      background-clip: inherit;\n      -webkit-background-clip: text;\n      -webkit-text-fill-color: transparent;\n    }\n  }\n\n  &.offline {\n    background-image: none;\n\n    &:before {\n      display: none;\n    }\n  }\n\n  .auth-bg {\n    .r {\n      position: absolute;\n      width: 300px;\n      height: 300px;\n      border-radius: 50%;\n\n      &:first-child {\n        top: -100px;\n        right: -100px;\n        background: $theme-color;\n      }\n\n      &:last-child {\n        left: -100px;\n        bottom: -100px;\n        background: $theme-color2;\n      }\n\n      &.s {\n        width: 20px;\n        height: 20px;\n        &:nth-child(2) {\n          top: 150px;\n          right: -150px;\n          background: $primary-color;\n        }\n\n        &:nth-child(3) {\n          left: -150px;\n          bottom: 150px;\n          background: $success-color;\n        }\n      }\n\n      &:nth-child(odd) {\n        animation: floating 7s infinite;\n      }\n\n      &:nth-child(even) {\n        animation: floating 9s infinite;\n      }\n    }\n  }\n}\n/* image variant start */\n.aut-bg-img {\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n.aut-bg-img-side {\n  p {\n    line-height: 2;\n  }\n}\n.aut-bg-img,\n.aut-bg-img-side {\n  .custom-select,\n  .form-control {\n    background: transparent;\n  }\n}\n.auth-tabs {\n  .card {\n    // border-right: 10px;\n  }\n  .nav-pills {\n    // margin-top: -80px;\n  }\n  .tab-content {\n    overflow: hidden;\n    position: relative;\n    .tab-pane > * {\n      position: relative;\n      z-index: 5;\n    }\n    .auth-icon {\n      position: absolute;\n      bottom: 0;\n      right: 0;\n      font-size: 180px;\n      transform: rotate(-30deg);\n      z-index: 1;\n      opacity: 0.2;\n    }\n  }\n}\n/* image varient start */\n@keyframes floating {\n  from {\n    transform: rotate(0deg) translate(-10px) rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg) translate(-10px) rotate(-360deg);\n  }\n}\n/**====== Authentication css end ======**/\n","/* Button variants\n Easily pump out default styles, as well as :hover, :focus, :active,\n and disabled options for all buttons */\n@mixin button-variant-pc(\n  $background,\n  $border,\n  $hover-background: darken($background, 7.5%),\n  $hover-border: darken($border, 10%),\n  $active-background: darken($background, 10%),\n  $active-border: darken($border, 12.5%)\n) {\n  color: color-yiq($background);\n  background-color: $border;\n  border-color: $border;\n\n  &:hover {\n    color: color-yiq($hover-background);\n    background-color: $hover-background;\n    border-color: $hover-border;\n  }\n\n  &.focus,\n  &:focus {\n  }\n\n  &.disabled,\n  &:disabled {\n    color: color-yiq($background);\n    background-color: $background;\n    border-color: $border;\n  }\n\n  &:not(:disabled):not(.disabled).active,\n  &:not(:disabled):not(.disabled):active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    border-color: $active-border;\n\n    &:focus {\n    }\n  }\n}\n@mixin button-outline-variant-pc($color, $color-hover: color-yiq($color), $active-background: $color, $active-border: $color) {\n  color: $color;\n  background-color: transparent;\n  background-image: none;\n  border-color: $color;\n\n  &:hover {\n    color: color-yiq($color);\n    background-color: $active-background;\n    border-color: $active-border;\n  }\n\n  &.focus,\n  &:focus {\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $color;\n    background-color: transparent;\n  }\n\n  &:not(:disabled):not(.disabled).active,\n  &:not(:disabled):not(.disabled):active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    border-color: $active-border;\n\n    &:focus {\n    }\n  }\n}\n@mixin button-glow-variant-pc($color, $color-hover: color-yiq($color), $active-background: $color, $active-border: $color) {\n  box-shadow: 0 1px 6px 2px transparentize($color, 0.44), 0 6px 11px 2px transparentize($color, 0.8);\n  &:hover {\n    box-shadow: 0 1px 4px 2px transparentize($color, 0.44), 0 4px 9px 2px transparentize($color, 0.9);\n  }\n  &:not(:disabled):not(.disabled).active,\n  &:not(:disabled):not(.disabled):active:focus,\n  .show > &.dropdown-toggle,\n  &.active,\n  &:focus {\n    box-shadow: none;\n  }\n}\n","@import '../mixins/buttons';\n/**  =====================\n      Button css start\n==========================  **/\n.btn-theme,\na.btn-theme {\n  background: $theme-color;\n  color: #fff;\n  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);\n  border-color: #1de1c2;\n  border-radius: 0.25rem;\n  padding: 11px 25px;\n\n  &:active,\n  &:focus,\n  &:not(:disabled):not(.disabled):active {\n    background-image: $theme-color;\n    color: #fff;\n    box-shadow: none;\n  }\n\n  &.active {\n    background-image: #fff !important;\n    color: $default-color;\n    border: 1px solid $theme-border;\n    box-shadow: none;\n  }\n}\n\n.btn-outline-theme {\n  background-image: #fff !important;\n  color: $default-color;\n  border: 1px solid $theme-border;\n  box-shadow: none;\n\n  &:active,\n  &:focus,\n  &:not(:disabled):not(.disabled):active {\n    background-image: #fff;\n    color: $default-color;\n    border: 1px solid $theme-border;\n  }\n\n  &.active {\n    background: $theme-color !important;\n    color: #fff;\n    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);\n    border: 1px solid transparent;\n  }\n}\n\n.btn-theme2 {\n  background: $theme-color2;\n  color: #fff;\n  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);\n  border: 1px solid transparent;\n  border-radius: 10px;\n  padding: 14px 25px;\n\n  &:active,\n  &:focus,\n  &:not(:disabled):not(.disabled):active {\n    background-image: $theme-color2;\n    color: #fff;\n    box-shadow: none;\n  }\n\n  &.active {\n    background-image: #fff !important;\n    color: $default-color;\n    border: 1px solid $theme-border;\n    box-shadow: none;\n  }\n}\n\n.btn-outline-theme2 {\n  background-image: #fff !important;\n  color: $default-color;\n  border: 1px solid $theme-border;\n  box-shadow: none;\n\n  &:active,\n  &:focus,\n  &:not(:disabled):not(.disabled):active {\n    background-image: #fff;\n    color: $default-color;\n    border: 1px solid $theme-border;\n  }\n\n  &.active {\n    background: $theme-color2 !important;\n    color: #fff;\n    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);\n    border: 1px solid transparent;\n  }\n}\n\n.btn {\n  padding: 10px 20px;\n  border-radius: 0.25rem;\n  font-size: 14px;\n  margin-bottom: 5px;\n  margin-right: 10px;\n  transition: all 0.3s ease-in-out;\n\n  > i {\n    margin-right: 12px;\n  }\n\n  &.btn-icon,\n  &.drp-icon {\n    width: 45px;\n    height: 45px;\n    padding: 10px 12px;\n\n    > i {\n      margin-right: 0;\n    }\n  }\n\n  &.drp-icon {\n    &.dropdown-toggle:after {\n      display: none;\n    }\n\n    + .dropdown-menu {\n      margin-left: -10px;\n    }\n  }\n\n  &:active,\n  &:focus {\n    box-shadow: none;\n  }\n\n  &-square {\n    border-radius: 0;\n  }\n\n  &.disabled {\n    cursor: not-allowed;\n    opacity: 0.55;\n  }\n\n  &-rounded {\n    border-radius: 30px;\n  }\n}\n\n.btn-group {\n  .btn {\n    margin-bottom: 0;\n    margin-right: 0;\n  }\n}\n\n.btn-group-sm > .btn,\n.btn-sm {\n  padding: 6px 14px;\n  font-size: 13px;\n}\n\n.btn-group-lg > .btn,\n.btn-lg {\n  padding: 13px 23px;\n  font-size: 16px;\n}\n\n.shadow-1 {\n  box-shadow: 0 7px 12px 0 rgba(62, 57, 107, 0.16);\n}\n\n.shadow-2 {\n  box-shadow: 0 10px 18px 0 rgba(62, 57, 107, 0.2);\n}\n\n.shadow-3 {\n  box-shadow: 0 14px 24px 0 rgba(62, 57, 107, 0.26);\n}\n\n.shadow-4 {\n  box-shadow: 0 16px 28px 0 rgba(62, 57, 107, 0.3);\n}\n\n.shadow-5 {\n  box-shadow: 0 20px 24px 0 rgba(62, 57, 107, 0.36);\n}\n/* Alternate buttons */\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @include button-variant-pc($value, $value);\n  }\n}\n/* outline buttons */\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant-pc($value);\n  }\n}\n/* glow buttons */\n@each $color, $value in $theme-colors {\n  .btn-glow-#{$color} {\n    @include button-glow-variant-pc($value);\n  }\n}\n/**====== Button css end ======**/\n\n.drp-icon {\n  .btn {\n    width: 45px;\n    height: 45px;\n    padding: 10px 12px;\n\n    > i {\n      margin-right: 0;\n    }\n    &.dropdown-toggle:after {\n      display: none;\n    }\n  }\n\n  + .dropdown-menu {\n    margin-left: -10px;\n  }\n  &.btn-rounded {\n    .btn {\n      &.dropdown-toggle {\n        border-radius: 30px;\n      }\n    }\n  }\n}\n\n.btn:not(:disabled):not(.disabled) {\n  cursor: pointer;\n}\n","/**  =====================\n      Breadcrumbs & Pagination css start\n==========================  **/\n/* Breadcrumbs */\n\n.breadcrumb {\n  background-color: $theme-background;\n  border-radius: 0;\n}\n\n.breadcrumb-item {\n  + .breadcrumb-item {\n    color: $primary-color;\n  }\n\n  &.active {\n    color: $theme-heading-color;\n  }\n}\n\n/* pagination */\n\n.page-item {\n  &.active .page-link {\n    color: #fff;\n    background-color: $primary-color;\n    border-color: $primary-color;\n  }\n}\n/**====== Breadcrumbs & Pagination css end ======**/\n","/**  =====================\n      Progress css start\n==========================  **/\n@keyframes progress-bar-stripes {\n  from {\n    background-position: 16px 0;\n  }\n\n  to {\n    background-position: 0 0;\n  }\n}\n\n.progress {\n  height: 12px;\n  font-size: 10px;\n  background-color: $theme-background;\n  border-radius: 0;\n  overflow: visible;\n\n  .progress-bar {\n    background-color: $primary-color;\n    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.3);\n\n    @each $value in $color-name {\n      $i: index($color-name, $value);\n\n      &.progress-#{$value},\n      &.bg-#{$value} {\n        background: nth($color-color, $i);\n      }\n    }\n\n    &.progress-c-theme {\n      background: $theme-color;\n    }\n\n    &.progress-c-theme2 {\n      background: $theme-color2;\n    }\n\n    @each $color, $value in $theme-colors {\n      &.bg-#{$color} {\n        background-color: $value !important;\n      }\n    }\n  }\n}\n\n/**====== Progress css end ======**/\n",".nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: 10px 24px;\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &.disabled {\n    opacity: 0.7;\n  }\n}\n\n/* ======================== Tabs =============================== */\n\n.nav-tabs {\n  border-bottom: none;\n  .nav-link {\n    border: none;\n    color: $theme-font-color;\n    &:hover {\n      color: $primary-color;\n    }\n\n    &.disabled {\n      opacity: 0.7;\n    }\n  }\n\n  .nav-item.show .nav-link,\n  .nav-link.active {\n    border: none;\n    color: $theme-heading-color;\n    box-shadow: 0 -5px 10px 0 rgba(0, 0, 0, 0.05);\n  }\n}\n/* =======================   Pills ================== */\n\n.nav-pills {\n  padding: 15px;\n  background-color: #fff;\n  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.05);\n  .nav-link {\n    border-radius: 5px;\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: #fff;\n    background: $primary-color;\n    box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.2);\n  }\n}\n\n/* ==================== Justified variants ===================*/\n\n.nav-fill {\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n/* Tabbable tabs */\n\n/* Hide tabbable panes to start, show them when `.active` */\n\n.tab-content {\n  padding: 35px 30px;\n  background: #fff;\n  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.05);\n\n  > .tab-pane {\n    display: none;\n  }\n\n  > .active {\n    display: block;\n  }\n}\n","/**  =====================\n      Chatting css start\n==========================  **/\n\n.header-chat,\n.header-user-list {\n  height: 100%;\n  width: 350px;\n  position: fixed;\n  top: 0;\n  right: -350px;\n  border-radius: 0;\n  z-index: 1030;\n  background-color: #fff;\n  transition: all 0.3s ease-in-out;\n\n  .main-friend-cont {\n    height: calc(100vh - 166px);\n    .main-friend-list {\n      height: calc(100vh - 85px);\n    }\n  }\n\n  .h-list-header {\n    padding: 15px;\n    border-bottom: 1px solid #f1f1f1;\n  }\n\n  .h-list-body {\n    padding: 20px 0;\n  }\n\n  &.open {\n    box-shadow: 0 1px 10px 0 rgba(69, 90, 100, 0.2);\n    right: 0;\n  }\n}\n\n.header-user-list {\n  &.open {\n    .h-close-text {\n      position: absolute;\n      top: 111px;\n      left: -99px;\n\n      i {\n        position: absolute;\n        top: 23px;\n        left: 73px;\n        font-size: 25px;\n        z-index: 1003;\n        color: $success-color;\n      }\n\n      &:after {\n        content: '\\61';\n        font-family: 'pct';\n        z-index: 1001;\n        font-size: 150px;\n        line-height: 0;\n        color: #fff;\n        position: absolute;\n        top: 35px;\n        left: 6px;\n        text-shadow: -4px 0 7px rgba(69, 90, 100, 0.12);\n      }\n    }\n\n    &.msg-open {\n      &:after {\n        color: transparentize($primary-color, 0.9);\n      }\n    }\n  }\n}\n\n.h-list-header {\n  .form-control {\n    &:active,\n    &:focus,\n    &:hover {\n      box-shadow: none;\n      outline: none;\n    }\n  }\n}\n\n.h-list-body {\n  position: relative;\n\n  .userlist-box {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    padding: 15px 20px;\n    position: relative;\n\n    &:after {\n      content: '';\n      position: absolute;\n      bottom: 0;\n      left: 20px;\n      width: calc(100% - 40px);\n      height: 1px;\n      background: #f3f4f9;\n    }\n\n    &.active {\n      background: lighten($primary-color, 45%);\n    }\n\n    .media-left {\n      padding-right: 10px;\n    }\n\n    .media-object {\n      width: 50px;\n      display: inline-block;\n    }\n\n    .chat-header {\n      font-size: 14px;\n      font-weight: 600;\n      margin-bottom: 0;\n\n      small {\n        margin-top: 5px;\n        font-size: 90%;\n      }\n    }\n\n    .live-status {\n      height: 25px;\n      width: 25px;\n      position: absolute;\n      top: 28px;\n      right: 20px;\n      border-radius: 100%;\n      color: #fff;\n      padding: 2px 0;\n      text-align: center;\n      background: $theme-color;\n    }\n  }\n}\n\n.header-chat {\n  .h-list-header {\n    text-align: center;\n    position: relative;\n\n    h6 {\n      margin: 5px 0;\n    }\n\n    .h-back-user-list {\n      position: absolute;\n      left: 0;\n      top: 0;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      width: 40px;\n      justify-content: center;\n      font-size: 20px;\n    }\n  }\n\n  .main-chat-cont {\n    height: calc(100vh - 166px);\n  }\n\n  .h-list-body {\n    height: 100%;\n    background: lighten($primary-color, 45%);\n  }\n\n  .h-list-footer {\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    right: 0;\n    padding: 20px 15px;\n    z-index: 10;\n    background: lighten($primary-color, 45%);\n\n    .input-group {\n      background: #fff;\n      border: none;\n      display: inline-flex;\n      box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);\n      padding: 7px;\n      border-radius: 20px 0 10px 20px;\n      width: calc(100% - 40px);\n\n      .form-control,\n      .input-group-text {\n        background: transparent;\n        border: none;\n        border-radius: 0;\n        padding: 0;\n      }\n\n      .btn-send,\n      .form-control {\n        &:active,\n        &:focus,\n        &:hover {\n          outline: none;\n          box-shadow: none;\n        }\n      }\n\n      .btn-attach {\n        border-radius: 50% !important;\n        padding: 5px;\n        margin-right: 5px;\n\n        > i {\n          margin-right: 0;\n        }\n      }\n\n      .btn-send {\n        border-radius: 50% !important;\n        padding: 10px;\n        margin-left: 5px !important;\n        position: absolute;\n        right: -45px;\n        top: 2px;\n        z-index: 99;\n\n        i {\n          margin-right: 0;\n        }\n\n        .input-group-text {\n          color: #fff;\n        }\n      }\n\n      .form-control {\n        transition: all 0.3s ease-in-out;\n        width: 0;\n      }\n\n      &:after {\n        content: '\\67';\n        font-family: 'pct';\n        z-index: 1001;\n        font-size: 35px;\n        line-height: 0;\n        color: #fff;\n        position: absolute;\n        top: 18px;\n        right: -23px;\n        text-shadow: 4px 10px 20px rgba(0, 0, 0, 0.1);\n      }\n    }\n  }\n}\n\n.h-list-body {\n  .chat-messages {\n    padding-bottom: 20px !important;\n    padding-left: 15px !important;\n    padding-right: 15px !important;\n\n    .photo-table {\n      padding-right: 15px;\n\n      img {\n        display: inline-block;\n        width: 50px;\n        margin-bottom: 5px;\n      }\n    }\n\n    .chat-menu-content,\n    .chat-menu-reply {\n      > div {\n        position: relative;\n        overflow: visible;\n        display: inline-block;\n\n        .chat-cont {\n          padding: 15px 20px;\n        }\n      }\n\n      .chat-time {\n        margin: 9px 8px 0 10px;\n      }\n    }\n\n    .chat-menu-reply {\n      text-align: right;\n\n      > div {\n        p {\n          background: #fff;\n          border-radius: 4px;\n          margin-bottom: 4px;\n          margin-right: 25px;\n          box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);\n\n          &:first-child {\n            border-top-left-radius: 8px;\n            border-top-right-radius: 8px;\n          }\n\n          &:last-child {\n            border-bottom-left-radius: 8px;\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:before {\n          content: '\\66';\n          font-family: 'pct';\n          z-index: 5;\n          font-size: 30px;\n          line-height: 0;\n          color: #fff;\n          position: absolute;\n          bottom: 19px;\n          right: 5px;\n          text-shadow: 7px 10px 20px rgba(0, 0, 0, 0.1);\n        }\n      }\n    }\n\n    .chat-menu-content {\n      > div {\n        p {\n          background: $theme-color;\n          color: #fff;\n          border-radius: 4px;\n          margin-bottom: 4px;\n          box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);\n\n          &:first-child {\n            border-top-left-radius: 0;\n            border-top-right-radius: 10px;\n          }\n\n          &:last-child {\n            border-bottom-left-radius: 10px;\n            border-bottom-right-radius: 10px;\n          }\n        }\n\n        &:before {\n          content: '\\68';\n          font-family: 'pct';\n          z-index: 1001;\n          font-size: 30px;\n          line-height: 0;\n          color: #1ec9de;\n          position: absolute;\n          top: 15px;\n          left: -20px;\n          text-shadow: -4px 4px 10px rgba(0, 0, 0, 0.15);\n        }\n      }\n    }\n  }\n}\n/* massage page start */\n\n.main-friend-chat {\n  padding-bottom: 15px;\n}\n\n/* massage page end */\n/**====== Chat css end ======**/\n\n@media only screen and (max-width: 991px) {\n  .pcoded-header {\n    color: $header-light-text-color;\n  }\n}\n","/**  =====================\n      Chart css start\n==========================  **/\n.nvtooltip {\n  position: fixed !important;\n}\n\n/**====== Chart css end ======**/\n",".datta-scroll,\n.scroll-widget,\n.main-chat-cont,\n.config-scroll,\n.main-friend-list {\n  .ps__rail-y {\n    &:hover > .ps__thumb-y,\n    &:focus > .ps__thumb-y,\n    &.ps--clicking .ps__thumb-y {\n      background-color: #a7a7a7;\n      width: 5px;\n    }\n  }\n  .ps__thumb-y {\n    background-color: #aaa;\n    border-radius: 6px;\n    width: 5px;\n    right: 0;\n  }\n}\n\nperfect-scrollbar.datta-scroll > .ps,\nperfect-scrollbar.scroll-widget > .ps,\nperfect-scrollbar.main-chat-cont > .ps,\nperfect-scrollbar.config-scroll > .ps,\nperfect-scrollbar.main-friend-list > .ps {\n  &.ps--active-y > .ps__rail-y {\n    width: 5px;\n    &:hover,\n    &.ps--clicking {\n      width: 5px;\n    }\n  }\n  &.ps--scrolling-y > .ps__rail-y,\n  &.ps--scrolling-x > .ps__rail-x {\n    opacity: 0.4;\n    background-color: transparent;\n  }\n  &.ps--active-y > .ps__rail-y {\n    &:hover,\n    &.ps--clicking {\n      width: 5px;\n    }\n  }\n}\n",".table > :not(caption) > * > * {\n  border-bottom-width: 0px;\n}\n",".map {\n  position: relative !important;\n}\n",".pcoded-header {\n  .dropdown {\n    height: 70px;\n    .dropdown-toggle {\n      margin: -2px 0 0 4px;\n    }\n  }\n  .btn {\n    padding: 0;\n    margin-bottom: 0;\n    margin-right: 0;\n    border: none;\n    &:after {\n      right: -12px !important;\n    }\n    &:focus,\n    &:active,\n    &:hover {\n      text-decoration: none;\n    }\n  }\n  .main-search {\n    .input-group-text {\n      line-height: 1.5;\n    }\n  }\n\n  .btn > i {\n    margin-right: -12px;\n  }\n}\n","@import '~react-perfect-scrollbar/dist/css/styles.css';\n@import '~nvd3/build/nv.d3.css';\n@import 'ngx-perfect-scrollbar';\n@import 'datatables';\n@import 'google-map';\n@import 'react-bootstrap/react-bootstrap';\n\n.pcoded-header .main-search .input-group-text {\n  line-height: 1;\n}\n\n.text-muted {\n  color: #6c757d !important;\n}\n\n.card-event {\n  .label {\n    border-radius: 15px;\n    margin: 0;\n    padding: 5px 16px;\n  }\n\n  i {\n    position: absolute;\n    bottom: 36px;\n    right: 27px;\n  }\n}\n\n.carousel {\n  z-index: 1 !important;\n}\n\n.rodal .rodal-dialog {\n  max-width: 100%;\n}\n\n.page-link {\n  font-size: 0.9rem !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
